(function() {
    'use strict';

    var app = angular
        .module('app.sites', ['app.doclibraryForms', 'textAngular'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdThemingProvider, $controllerProvider, $compileProvider, $filterProvider, $provide) {
        app.controller = $controllerProvider.register;
        app.directive = $compileProvider.directive;
        app.filter = $filterProvider.register;
        app.factory = $provide.factory;
        app.service = $provide.service;
        app.constant = $provide.constant;
        app.value = $provide.value;
        
        // State
        $stateProvider
            .state('app.sites', {
                url: '/sites',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/sites/sites.html',
                        controller: 'SitesController as siteCtrl'
                    }
                },
                resolve: {
                    Icons: function(msApi) {
                        return msApi.resolve('icons@get');
                    },
                    RestAPIService: 'RestAPIService',
                    Sites: function(RestAPIService) {
                        return RestAPIService.getSites();
                    }
                }
            })
            .state('app.sites.site', {
                url: '/:siteId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/sites/site/site.html',
                        controller: 'SitesController as siteCtrl'
                    },
                    'sitehome@app.sites.site':{
                    	 templateUrl: 'app/main/sites/site/home/site.home.html',
                         controller: 'SitesHomeController as siteHomeCtrl'                    	
                    },                    
                    'dashboard@app.sites.site': {
                        templateUrl: 'app/main/sites/site/dashboard/site.dashboard.html',
                        controller: 'SitesDashboardController as siteDashCtrl'
                    },
                    'doclibrary@app.sites.site': {
                        templateUrl: 'app/main/sites/site/doclibrary/site.doclibrary.html',
                        controller: 'SitesDocLibraryController as siteDocLibCtrl'
                    },
                    'members@app.sites.site': {
                        templateUrl: 'app/main/sites/site/members/site.members.html',
                        controller: 'SitesMembersController as siteMembersCtrl'
                    },
                    'wiki@app.sites.site': {
                        templateUrl: 'app/main/sites/site/wiki/site.wiki.html',
                        controller: 'SitesWikiController as siteWikiCtrl'
                    },
                   /* 'todolist@app.sites.site': {
                        templateUrl: 'app/main/sites/site/todolist/site.todolist.html',
                        controller: 'SitesTodoController as siteTodoCtrl'
                    },*/
                    'sitesettings@app.sites.site': {
                        templateUrl: 'app/main/sites/site/sitesettings/sitesettings.html',
                        controller: 'SiteSettingsController as sitesettingCtrl'
                    }
                   /* 'discussionforum@app.sites.site': {
                        templateUrl: 'app/main/sites/site/discussionforum/site.forum.html',
                        controller: 'SitesForumController as siteForumCtrl'
                    }*/
                },
                resolve: {
                    RestAPIService: 'RestAPIService',
                    Members: function(RestAPIService, $stateParams) {
                        return RestAPIService.getMembers("site-8");
                    },
                    SiteDashboard: function(RestAPIService,$stateParams){
                    	return RestAPIService.getSiteHome("site-8");                    	
                    }
                }
            });

        // Api
        msApiProvider.register('icons', ['assets/icons/selection.json']);

        // Navigation
    /* msNavigationServiceProvider.saveItem('sites', {
            title: 'Home',
            icon: 'icon-home',
            state: 'app.sites.site',
            weight: 1
        });*/
    }
})();;
(function ()
{
    'use strict';

    angular
        .module('app.sites')
        .controller('msNoteItemController', msNoteItemController)
        .directive('msNoteItem', msNoteItemDirective);

    /** @ngInject */
    function msNoteItemController($document)
    {
        var vm = this;
        vm.element = [];
               }

    /** @ngInject */
    function msNoteItemDirective()
    {
        return {
            restrict        : 'A',
            controller      : 'msNoteItemController as MsNoteItem',
            templateUrl     : 'app/main/sites/site/todolist/directives/ms-note-item/ms-note-item.html',
            require         : ['msNoteItem', '^msMasonry'],
            bindToController: {
                msNoteItem: '='
            },
            link            : function (scope, element, attributes, controllers)
            {

                var MsNoteItem = controllers[0];
                var msMasonry = controllers[1];

                MsNoteItem.element = element;
                MsNoteItem.note = MsNoteItem.msNoteItem;


                scope.$watch('MsNoteItem.msNoteItem', function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        MsNoteItem.note = newVal;
                    }
                });

                scope.$on('msMasonryItem:startReLayout', function ()
                {
                    if (  MsNoteItem.columnWidth === msMasonry.columnWidth )
                    {
                        return;
                    }

                    MsNoteItem.columnWidth = msMasonry.columnWidth;

                    });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.sites')
        .controller('msNoteFormController', msNoteFormController)
        .directive('msNoteForm', msNoteFormDirective);

        /** @ngInject */
        function msNoteFormController($state, $scope,  msUtils, $mdDialog, $rootScope, $timeout, $http, RestAPIService,$q, $stateParams)
                {
            var MsNoteForm = this;
            var siteId = $stateParams.siteId;
            var notes=[];            
            RestAPIService.getToDoList(siteId).then(
                function(success){                 
                   notes  = success.data;
                   init();                 
                },
                function(error){
                RestAPIService.showErrorDialog(error);
                }
            );     

            var config = {
                headers : {                     
                     'Authorization':'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhZG1pbiIsImF1dGgiOiJST0xFX0FETUlOLFJPTEVfVVNFUiIsImV4cCI6MTQ5MDE4NTcyMX0.1aXGwOdifQjxLTYQXnf8BPE0qRwDh70NE8flGvHx8mHR0fjLhEjQKyjlyOa6Okkv5Uab_9WNU3Kv_a3aaECx8A'
                    }
                }       
        //Data
        MsNoteForm.type = '';
        MsNoteForm.defaultNote = {
            'todolistId'  :'',
            'name'        : '',
            'description' : '',
            'actions'  : []
            };
        MsNoteForm.noteId = '';
        MsNoteForm.editNode = {};
        MsNoteForm.newCheckListItem = '';
        MsNoteForm.checkListForm = false;
        MsNoteForm.ngFlowOptions = {
            singleFile: true
            };
        MsNoteForm.ngFlow = {
            // ng-flow will be injected into here through its directive
            flow: {}
            };
        //Methods
        MsNoteForm.init = init;
        MsNoteForm.submit = submit;
        MsNoteForm.isNotValid = isNotValid;
        MsNoteForm.deleteNote = deleteNote;
        MsNoteForm.addChecklistItem = addChecklistItem;
        MsNoteForm.checklistFormToggle = checklistFormToggle;
        MsNoteForm.deleteCheckItem = deleteCheckItem;
        MsNoteForm.toggleArchive = toggleArchive;
        MsNoteForm.toggleInArray = msUtils.toggleInArray;
        MsNoteForm.exists = msUtils.exists;
         /**
         * Initialize
         */
        function init()
            {
            // If form type edit
            if ( MsNoteForm.type === 'edit' )
                {
                MsNoteForm.editNode = notes.getById(MsNoteForm.noteId);
                MsNoteForm.note = angular.copy(MsNoteForm.editNode);
                
            }        
            // If form type new
            else
                {
                resetForm();
            }
        }
        /**
         * Watch New Note Form, reset form if it is closed
         */
        $scope.$on('MsNewNote:closed', function ()
            {
            resetForm();
        });
        /**
         * Reset Form
         */
        function resetForm()
        {
            $scope.$evalAsync(function ()
            {
               MsNoteForm.note = angular.copy(MsNoteForm.defaultNote);
               MsNoteForm.checkListForm = false;
            });
        }
        /**
         * Submit Form
         */
        function submit()
            {
            if ( MsNoteForm.type === 'new' )
                {
                add();
                }
            else if ( MsNoteForm.type === 'edit' )
                {
                save();
                }
            }
        /**
         * Add new note
         */
        function add()
            {
            if ( isNotValid() )
                {
                return;
                }
        //MsNoteForm.todolistId = msUtils.guidGenerator();
         MsNoteForm.note.todolistId = 'Todo-124';
         RestAPIService.addToDoList(MsNoteForm.note, siteId).then(
             function(success){
                MsNoteForm.addToDo=success.data;
                // add is success.Need to refresh the page
                $state.reload();
                },
             function(error){
                RestAPIService.showErrorDialog(error);
                    });
         MsNoteForm.note = angular.copy(MsNoteForm.defaultNote);
         $scope.$emit('MsNewNote:close');

         $mdDialog.cancel();
        }
        /**
         * Save Note
         */
        function save()
            {
        if ( isNotValid() )
            {
            return;
            }

        RestAPIService.updateTodo(MsNoteForm.note, siteId).then(
            function(success){
            // alert(JSON.stringify(success.data));
            // Update is success.Need to refresh  the page
            $state.reload();
            },
            function(error){
                RestAPIService.showErrorDialog(error);
            });
            $mdDialog.hide();
        }
        function toggleArchive()
        {
            if ( MsNoteForm.type === 'new' )
            {
                MsNoteForm.note.archive = true;
                submit();
            }
            else if ( MsNoteForm.type === 'edit' )
            {
                MsNoteForm.note.archive = !MsNoteForm.note.archive;
                save();
            }
        }
          /**
         * One of the title, description, checklist inputs are should be exist.
         * @returns {boolean}
         */
        function isNotValid()
        {
        // return  MsNoteForm.note.todolistId === '' && MsNoteForm.note.description === '' && MsNoteForm.note.actions.length === 0;
        }
        /**
         * Delete Note
         * @param ev
         */
        function deleteNote(ev)
        {
                var confirm = $mdDialog.confirm()
                .title('Remove')
                .htmlContent('the note will be deleted permanently for this site?')
                .ariaLabel('delete note')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

        $mdDialog.show(confirm).then(function ()
            {               
            RestAPIService.deleteTodo(MsNoteForm.noteId).then(
                function(success){
                    // delete is success.Need to refresh the page
                    $state.reload();
                    },
                    function(error){
                        RestAPIService.showErrorDialog(error);
                });
          });
        }
        /**
         * Add Checklist Item
         */
        function addChecklistItem()
        {
            if ( MsNoteForm.newCheckListItem === '' )
            {
                return;
            }
            MsNoteForm.note.actions.push({
                completed: false,
                description   : MsNoteForm.newCheckListItem
            });
            MsNoteForm.newCheckListItem = '';
            focusChecklistInput();
            }
        /**
         * Checklist form toggle
         */
        function checklistFormToggle()
        {
            $scope.$evalAsync(function ()
            {
                MsNoteForm.checkListForm = !MsNoteForm.checkListForm;

                $timeout(function ()
                {
                    focusChecklistInput();

                });
            });
        }
        /**
         * Delete check item
         * @param item
         */
        function deleteCheckItem(item)
        {
            MsNoteForm.note.actions.splice(MsNoteForm.note.actions.indexOf(item), 1);
            focusChecklistInput();
        }
        /**
         * Focus checklist input
         */
        function focusChecklistInput()
        {
            angular.element('#new-checklist-item-input').focus();
        }

        function getById(value)
        {
            console.log('getById',value)
         return notes.filter(function (x)
            {
                if(x.todolistId === value){
                    return x;
                }
            });

        };

    }
    /** @ngInject */
    function msNoteFormDirective()
    {
        return {
            restrict    : 'EA',
            controller  : 'msNoteFormController',
            controllerAs: 'MsNoteForm',
            scope       : {
                noteType: '=',
                noteId  : '='
            },
            templateUrl : 'app/main/sites/site/todolist/directives/ms-note-form/ms-note-form.html',
            link        : function (scope, element, attributes, MsNoteForm)
            {
                // Type
                MsNoteForm.type = scope.noteType;
                // Note id
                if ( angular.isDefined(scope.noteId) )
                {
                    MsNoteForm.noteId = scope.noteId;
                 }

             // MsNoteForm.init();

            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.sites')
        .controller('msNewNoteController', msNewNoteController)
        .directive('msNewNoteButton', msNewNoteButtonDirective)
        .directive('msNewNote', msNewNoteDirective);

    /** @ngInject */
    function msNewNoteController($scope, $document)
    {
        var MsNewNote = this;

        //Data
        MsNewNote.form = {
            name      : '',
            description: ''
        };

        //Methods
        MsNewNote.open = open;
        MsNewNote.close = close;
        MsNewNote.element = [];
        /**
         * Close Trigger
         */
        $scope.$on('MsNewNote:close', function ()
        {
            close();
        });

        /**
         * Open new note form
         */
        function open()
        {
            MsNewNote.element.find('textarea');
            $document.on('click', outSideClick);
        }

        /**
         * Close new note form
         */
        function close()
        {
           $scope.$broadcast('MsNewNote:closed');

            $document.off('click', outSideClick);
        }

        /**
         * Click Outside Event Handler
         * @param event
         */
        function outSideClick(event)
        {
            var isChild = MsNewNote.element.has(event.target).length > 0;
            var isSelf = MsNewNote.element[0] === event.target;
            var isMenu = angular.element(event.target).closest('md-menu-content').length > 0;
           

            var isInside = isChild || isSelf || isMenu;

            if ( !isInside )
            {
                close();
            }
        }
    }

    /** @ngInject */
    function msNewNoteDirective()
    {
        return {
            restrict    : 'E',
            controller  : 'msNewNoteController',
            controllerAs: 'MsNewNote',
            templateUrl : 'app/main/sites/site/todolist/directives/ms-new-note/ms-new-note.html',
            link        : function (scope, element, attributes, MsNewNote)
            {
                MsNewNote.element = element;
            }
        };
    }

    /** @ngInject */
    function msNewNoteButtonDirective()
    {
        return {
            restrict: 'EA',
            require : '^msNewNote',
            link    : function (scope, element, attributes, msNewNote)
            {
                element.on('click', function ()
                {
                    msNewNote.open();

                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.sites')
        .controller('SitesWikiController', SitesWikiController);

    /** @ngInject */
    function SitesWikiController()
    {
        var siteWikiCtrl = this;


        siteWikiCtrl.test = 'Wiki HTML content should be in here';
        
    }
})();


(function() {
    'use strict';

    angular
        .module('app.sites')
        .controller('SitesTodoController', SitesTodoController);

    /** @ngInject */
    function SitesTodoController($document, $scope, $timeout, $mdDialog, $http, RestAPIService, CurrentSiteId, CurrentSiteName, CurrentSiteUrl) {
        var siteTodoCtrl = this;
        siteTodoCtrl.value = CurrentSiteName.value;

        siteTodoCtrl.getAnotherColor = function(index) {
            siteTodoCtrl.colors = ['red', 'pink', 'purple', 'deep-purple', 'indigo', 'blue', 'light-blue', 'cyan', 'teal', 'green',
                'light-green', 'lime', 'yellow', 'amber', 'deep-orange', 'brown', 'grey', 'blue-grey'
            ];
            var totalNoOfColors = siteTodoCtrl.colors.length;
            return 'md-' + siteTodoCtrl.colors[index % totalNoOfColors] + '-50-bg';
        }
        
        siteTodoCtrl.filters = {
            archive: false
        };
        siteTodoCtrl.noteListType = 'notes';
        // Methods
        siteTodoCtrl.editNote = editNote;

        /**
         * Edit Note
         * @param ev
         * @param noteId
         */
        function editNote(ev, noteId) {
            $mdDialog.show({
                template: '<md-dialog ms-scroll><ms-note-form note-type="\'edit\'" note-id="\'' + noteId + '\'"></ms-note-form></md-dialog>',
                parent: $document.find('#notes'),
                targetEvent: ev,
                clickOutsideToClose: true,
                escapeToClose: true,
            });
        }

        siteTodoCtrl.showConfirm = function(ev) {
            $mdDialog.show({
                template: '<md-dialog ms-scroll><ms-note-form note-type="\'new\' "></ms-note-form></md-dialog>',
                parent: $document.find('#notes'),
                targetEvent: ev,
                clickOutsideToClose: true,
                escapeToClose: true
            });
        }


        /**
         * Escape key event
         */
        function escKeyEvent(e) {
            if (e.keyCode === 27) {
                editNote(ev);
            }
        }
        
        $scope.goSites = function(hash) {
            $scope.$parent.todolistview = false;
        }

        Array.prototype.getById = function(value) {
            return this.filter(function(x) {
                return x.todolistId === value;
            })[0];
        };

    }
})();
(function() {
    'use strict';

    angular
        .module('app.sites')
        .controller('SiteSettingsController', SiteSettingsController);

    /** @ngInject */
    function SiteSettingsController($state, $scope, RestAPIService, $stateParams, $mdDialog) {
        var sitesettingCtrl = this;
        var siteId = $stateParams.siteId;
        $scope.siteSettingsLabels = {};
        $scope.Edit = true;
        $scope.setting = {};
        $scope.siteSettingsValue = {};
        sitesettingCtrl.editMode = function() {
            $scope.Edit = !$scope.Edit;
            $scope.editButton = true;
        };
        $scope.getSite =function(){
        	RestAPIService.getSiteDetails(siteId).then(
        			function(success){
        				$scope.site =success.data;
        				
        			},
        			function(error){
        				
        			});
        }
        sitesettingCtrl.smartstoreSave = function(siteId, setting) {
            // alert(JSON.stringify(siteSettingName));
            $scope.setting['siteSettingsName'] = "smartstore";
            $scope.setting['siteSettingsValue'] = $scope.siteSettingsValue;
            RestAPIService.siteSettings(siteId, $scope.setting).then(
                function(success) {
                    RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                    $scope.siteSettingsValue = success.data.settings['smartstore'];
                    sitesettingCtrl.Cancel();
                },
                function(error) {

                    RestAPIService.showErrorDialog(error);
                }
            );

        };
        $scope.Updatesite =function(site){        	
        	site['siteId'] =siteId;
        	RestAPIService.updateSite(site).then(
        			function(success){
        				 RestAPIService.successTostDialog('Site Updated Successfully');        				
        			},
        			function(error){
        				
        			});

        }
        $scope.save = function(siteId, setting) {
            $scope.setting['siteSettingsName'] = "ganeralsettings";
            $scope.setting['siteSettingsValue'] = $scope.home;
            RestAPIService.siteSettings(siteId, $scope.setting).then(
                function(success) {
                    RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                    $scope.siteSettingsValue = success.data.settings['general'];
                    $state.reload();
                },
                function(error) {

                    RestAPIService.showErrorDialog(error);
                }
            );
        };
        $scope.clear = function() {
            $scope.home = null;
        }
        sitesettingCtrl.Cancel = function() {
            $scope.editButton = false;
            $scope.Edit = !$scope.Edit;
        };
        sitesettingCtrl.solrSave = function(siteId, setting) {
            $scope.setting['siteSettingsName'] = "solr";
            $scope.setting['siteSettingsValue'] = $scope.siteSettingsValue;
            RestAPIService.siteSettings(siteId, $scope.setting).then(
                function(success) {
                    RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                    $scope.siteSettingsValue = success.data.settings['solr'];
                    sitesettingCtrl.Cancel();
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );

        };

        $scope.addDocumentTypeDialog = function(ev) {
            $mdDialog.show({
                controller: AddDocumentDialogController,
                templateUrl: 'app/main/sites/site/sitesettings/site.addDocumentDialog.html',
                parent: angular.element(document.body),
                preserveScope: true,
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        }

        function AddDocumentDialogController($scope, $mdDialog) {
            $scope.getDocumentTypes = function() {
                RestAPIService.getDocumentTypes().then(
                    function(success) {
                        $scope.documentsList = success.data;
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
            }
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
        }
    }
})();
(function ()
{
    'use strict';
    angular
        .module('app.sites')
        .controller('SitesMembersController', SitesMembersController);
        
        /** @ngInject */
        function SitesMembersController($http, $scope, $mdDialog, LoggedInUserId, RestAPIService,Members,$stateParams)
        {
            var siteMembersCtrl = this; 
            var siteId = $stateParams.siteId;
            $scope.roles = ["Administrators","Members"];
            siteMembersCtrl.members = Members.data;
            
            siteMembersCtrl.getMembers = function(){ 
                RestAPIService.getMembers(siteId).then(
                    function(success){
                        siteMembersCtrl.members = success.data;
                    },
                    function(error){
                        RestAPIService.showErrorDialog(error);
                    }
                );  
            }      

            siteMembersCtrl.deleteMember = function( ev, member, memberData){               
                var confirm = $mdDialog.confirm() 
                .title('Remove')               
                .textContent(member +' privilege of '+ memberData.firstName+" "+memberData.lastName + ' will be removed for this site , continue ?')            
                .targetEvent(ev)
                .ok('Ok')
                .cancel('Cancel');
                
                $mdDialog.show(confirm).then(function() {
                        //Deleting the member
                        RestAPIService.deleteMember(siteId,memberData.login).then(
                            function(success){
                            	//alert(JSON.stringify(siteId));
                                //Member Successfully deleted. Need to refresh through GET call  
                                siteMembersCtrl.getMembers(siteId); 
                            },
                            function(error){
                               RestAPIService.showErrorDialog(error);
                            }
                        );    
                }, function() {
                   //User clicked Cancel. Close the popup
                });
            };


            siteMembersCtrl.addMemberDialog = addMemberDialog;
            siteMembersCtrl.memberRole='';

            function addMemberDialog(ev,roleId){  
                siteMembersCtrl.memberRole = roleId; 
                
                $mdDialog.show({
                    controller: AddMemberDialogController ,
                    templateUrl: 'app/main/sites/site/members/site.addMemberDialog.html',
                    parent: angular.element(document.body),
                    preserveScope: true,
                    targetEvent: ev,
                    clickOutsideToClose:true,
                    fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })  
            }    

            function AddMemberDialogController($scope, $mdDialog){
                $scope.memberRole = siteMembersCtrl.memberRole;
                $scope.tableVisibility=false;
                $scope.searchedMembers=[];
                $scope.width=25; 
                
                $scope.addMember = function(memberData){
                    var member ={};
                    member.email = memberData.email;
                    member.firstName = memberData.firstName;
                    member.lastName = memberData.lastName;
                    member.login = memberData.login;
                    member.roleId = siteMembersCtrl.memberRole;
                    //alert(JSON.stringify(member));
                    
                    RestAPIService.addMember(siteId,member).then(
                        function(success){
                          	 	 	
                        	//alert(JSON.stringify(siteId));
                            //Member Successfully added. Need to refresh through GET call  
                            siteMembersCtrl.getMembers(siteId); 
                        },
                        function(error){
                            RestAPIService.showErrorDialog(error);
                        }
                    );               
                }  

                $scope.close=function(){
                    $mdDialog.cancel();
                }      

                $scope.cancel= function(memberData){
                    $scope.member = {};
                    $scope.tableVisibility=false;        
                    $scope.searchedMembers=[];
                    $scope.width=25;
                    $scope.msgVisibility=false;                    
                    $mdDialog.cancel();
                }       
                $scope.searchMember = function(memberdata){ 
                     var q = "";
                    if(memberdata == undefined || angular.equals(memberdata, {}) ){
                        $scope.msgVisibility=true;
                        $scope.tableVisibility=false;
                        $scope.member = {}; 
                    }else{ 
                        if((memberdata.name !=""&&memberdata.name !=undefined) && (memberdata.email !="" && memberdata.email !=undefined)){
                          q = memberdata.name;
                        }else if((memberdata.name ==""|| memberdata.name==undefined) && (memberdata.email !="" && memberdata.email != undefined)){
                            q = memberdata.email;
                        }else if(memberdata.name !="" && (memberdata.email ==""||memberdata.email==undefined)){
                            q = memberdata.name;
                        }
                        $scope.searchedMembers= [];                     
                        RestAPIService.searchMember(siteId,q).then(
                        function(success){
                            $scope.searchedMembers = success.data;
                            $scope.msgVisibility=false;
                            $scope.tableVisibility=true;
                            $scope.member = {};                        
                        },function(error){
                            RestAPIService.showErrorDialog(error);
                        }
                        );
                    }                       
                }
                // $scope.addMemberInHardCodedStag = function(memberData){
                //     siteMembersCtrl.hardcodedMembers.push(memberData);
                // }       
                $scope.ok= function(){
                    $mdDialog.cancel();
                } 
            }               
        }
    }
)();
(function ()
{
    'use strict';

    angular
        .module('app.sites')
        .controller('SitesHomeController', SitesHomeController);

    /** @ngInject */
    function SitesHomeController(CurrentSitePage,$http, $scope, RestAPIService,SiteDashboard,$mdDialog)
    {
        var siteHomeCtrl = this;
        siteHomeCtrl.currentFolderId = '';
        CurrentSitePage.value = 'Home';
        	$scope.Home = SiteDashboard.data;
        	siteHomeCtrl.getHomePage = function() {
                RestAPIService.getHomePage().then(
                    function(success) {                     
                        $scope.homepageList = success.data;
                       
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                
            }
        	
        
        	 $scope.addContractDialog = function(thing, ev) {
              	$mdDialog.show({
                     controllerAs: 'dialogCtrl',
                      clickOutsideToClose: true,
                      bindToController: true,
                      controller: addContractDialogController,
                      autoWrap: false,
                      templateUrl: 'app/main/sites/site/home/addcontract.dialog.html',
                      locals: {
                        thing: thing
                      }
                    })
              };
              
              function addContractDialogController($scope, $http, RestAPIService, $mdDialog, $state, $window, $stateParams,$localStorage) {
             	 var libCtrl = this;
             	 $scope.contract = {
          	    		"ValidTill": new Date(),
          	    		"Status": "Draft",
          	    		"BusinessPartnerType":"Vendor"
          	    };
             	 
             	 $scope.contract.OrganizationUnit = siteHomeCtrl.companyCode;
              	$scope.contract.ContractType = siteHomeCtrl.contractType;
                  var formData = new FormData();
                  $scope.setFile = function(element) {
                      $scope.$apply(function() {
                          $scope.files = [];
                          for (var i = 0; i < element.files.length; i++) {
                              formData.append('file', element.files[i]);
                              $scope.files.push(element.files[i]);
                          }
                          if($scope.files.length){                   
                          	$scope.contract.ContractName = element.files[0].name.split('.')[0];
                          	$scope.contract.Description = element.files[0].name.split('.')[0];
                          	
                          	
      					}
      					else{
      					   	return;
      					   }
                      });
                  };
                  
                  $scope.isSelectedCType = function(type) {
                  	if(siteHomeCtrl.contractType === type){
                  		if(undefined != $scope.contractForm && undefined != $scope.contractForm.$setPristine()){
                  			$scope.contractForm.$setPristine();
                  		}
                  		return true;
                  	} 
                  	return false;
                  }
                  
                  $scope.isSelectedCCode = function(code) {
                  	if(siteHomeCtrl.companyCode === code){
                  		if(undefined != $scope.contractForm && undefined != $scope.contractForm.$setPristine()){
                  			$scope.contractForm.$setPristine();
                  		}
                  		return true;
                  	} 
                  	return false;
                  }
                  
                  $scope.minDate = new Date(
                  		 $scope.contract.ValidTill.getFullYear(),
                  		 $scope.contract.ValidTill.getMonth() +12,
                  		 $scope.contract.ValidTill.getDate()
             	         );
                  $scope.maxDate = new Date(
                  		 $scope.contract.ValidTill.getFullYear(),
                  		 $scope.contract.ValidTill.getMonth() + 24,
                  		 $scope.contract.ValidTill.getDate()
             	          );
                  
                  $scope.contract.ValidTill = $scope.minDate;
                  $scope.currencys = ["USD", "GBP", "EUR","PLN","CAD","INR"];
                  $scope.businessPartnerTypes = ["Vendor", "Customer", "Employee"];
                  $scope.statusValues = ["Draft", "Active", "Pending", "Terminated", "Archived"];
                  
                  
                  $scope.hide = function() {
                      $mdDialog.hide();
                  };
                  
                  $scope.getPurchaseOrgList = function(listName) {
                      RestAPIService.getListsByname(listName).then(
                          function(success) {
                              $scope.purchaseorgList = success.data;
                          },
                          function(error) {
                              RestAPIService.showErrorDialog(error);
                          });
                  }
                  
                  $scope.getMyCompanycodes = function() {
                      RestAPIService.getCompanyCodes().then(
                          function(success) {
                              $scope.companyCodes = success.data; 
                          },
                          function(error) {
                              RestAPIService.showErrorDialog(error);
                          });
                  }
                  
                 $scope.getContractAttributes = function(){
                       RestAPIService.getContractAttributes().then(
                           function(success) {
                               $scope.attributesList = success.data;
                           },
                           function(error) {
                               RestAPIService.showErrorDialog(error);
                           });   	
                  }
               
                  $scope.getContractTypes = function(listName) {
                      RestAPIService.getListsByname(listName).then(
                          function(success) {
                              $scope.contractTypeList = success.data;
                          },
                          function(error) {
                              RestAPIService.showErrorDialog(error);
                          });
                  }
                  
                  $scope.getCategories = function(listName) {
                      RestAPIService.getListsByname(listName).then(
                          function(success) {
                              $scope.categoriesList = success.data;
                          },
                          function(error) {
                              RestAPIService.showErrorDialog(error);
                          });
                  }
                  
                  $scope.cancel = function() {
                      $mdDialog.cancel();
                  };
                  $scope.template = {};
                  
                  $scope.getDocumentTemplate = function() {
                      RestAPIService.getDocumentTemplate().then(
                          function(success) {
                              $scope.templateList = success.data;
                          },
                          function(error) {
                              RestAPIService.showErrorDialog(error);
                          });
                  }
                  $scope.cancel = function() {
                      $mdDialog.cancel();
                  };
                  
                 $scope.searchEmployee = function(ev) {
                  	libCtrl.contract =  $scope.contract;
                  	 $mdDialog.show({
                           controllerAs: 'dialogCtrl',
                           controller: searchEmployeeDialogController,
                           preserveScope: true,
                           autoWrap: true,
                           skipHide: true, 
                           clickOutsideToClose: true,
                           templateUrl: 'app/main/contractlibrary/searchEmployeeDialog.html'
                         })
                  }
                  function searchEmployeeDialogController($scope, $http, RestAPIService, $mdDialog, $state, $window, $stateParams) {
                  	var employeeCtrl = this;
                  	employeeCtrl.dtOptions = {
                      		 
                      		 dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
               	            pagingType: 'simple',
               	         //   autoWidth : false,
               	            responsive: true
                  	 }
                  	$scope.getEmployeeListByName = function(){
                  		RestAPIService.getVendorListByName("Employee").then(
                                  function(success) {
                                 	 $scope.employeeList = success.data[0];
                                 	// alert(JSON.stringify($scope.employeeList));
                                  },
                                  function(error) {
                                      RestAPIService.showErrorDialog(error);
                                  });	
                  	}
                  	$scope.selectedval = function(val){  
                  		if(val == "Name")
                  			return true; 
                      }
                  	$scope.searchEmployee = function (selectedName,enteredValue){
                  		$scope.listname = "Employee";
                  		$scope.selectedname = $scope.selectedName;
                  		$scope.enteredvalue = $scope.enteredValue;
                  		RestAPIService.getListBysearch($scope.listname,$scope.selectedname,$scope.enteredvalue).then(
                                  function(success) {	
                                 	 $scope.searchList = success.data;
                                  },
                                  function(error) {
                                  	
                                      RestAPIService.showErrorDialog(error);
                                  });		
                  	}
                  	$scope.cancel = function() {
                          $mdDialog.cancel();
                      };
                      $scope.addEmployee = function(employee) {
                  		libCtrl.contract.BusinessPartner = employee.id;
                  		$mdDialog.cancel();
                      };
                  	 function init(){
                       	$scope.getEmployeeListByName();
                       }
                       //
                       init();
                  }
                  
                  $scope.searchCustomers = function(ev) {
                  	libCtrl.contract =  $scope.contract;
                  	 $mdDialog.show({
                           controllerAs: 'dialogCtrl',
                           controller: searchCustomersDialogController,
                           preserveScope: true,
                           autoWrap: true,
                           skipHide: true, 
                           clickOutsideToClose: true,
                           templateUrl: 'app/main/contractlibrary/searchCustomersDialog.html'
                         })
                  }
                  function searchCustomersDialogController($scope, $http, RestAPIService, $mdDialog, $state, $window, $stateParams) {
                  	var customerCtrl = this;
                  	customerCtrl.dtOptions = {
                      		 
                      		 dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
               	            pagingType: 'simple',
               	         //   autoWidth : false,
               	            responsive: true
                  	 }
                  	$scope.getCustomerListByName = function(){
                  		RestAPIService.getVendorListByName("Customer").then(
                                  function(success) {
                                 	 $scope.customerList = success.data[0];
                                 	//alert(JSON.stringify($scope.customerList));
                                 	customerCtrl.vendordata = success.data[0];
                                  },
                                  function(error) {
                                      RestAPIService.showErrorDialog(error);
                                  });	
                  	}
                  	$scope.selectedval = function(val){  
                  		if(val == "Name")
                  			return true; 
                      }
                  	$scope.searchCustomer = function (selectedName,enteredValue){
                  		$scope.listname = "Customer";
                  		$scope.selectedname = $scope.selectedName;
                  		$scope.enteredvalue = $scope.enteredValue;
                  		RestAPIService.getListBysearch($scope.listname,$scope.selectedname,$scope.enteredvalue).then(
                                  function(success) {	
                                 	 $scope.searchList = success.data;
                                  },
                                  function(error) {
                                  	
                                      RestAPIService.showErrorDialog(error);
                                  });		
                  	}
                  	$scope.cancel = function() {
                          $mdDialog.cancel();
                      };
                      $scope.addCustomer = function(customer) {
                  		libCtrl.contract.BusinessPartner = customer.id;
                  		$mdDialog.cancel();
                      };
                  	 function init(){
                       	$scope.getCustomerListByName();
                       }
                       //
                       init();
                  }
                  
                 
                  $scope.searchVendors = function(ev) {
                  	libCtrl.contract =  $scope.contract;
                  	 $mdDialog.show({
                           controllerAs: 'dialogCtrl',
                           controller: SearchVendorsDialogController,
                           preserveScope: true,
                           autoWrap: true,
                           skipHide: true, 
                           clickOutsideToClose: true,
                           templateUrl: 'app/main/contractlibrary/searchVendorsDialog.html'
                         })
                  }
                  
                  function SearchVendorsDialogController($scope, $http, RestAPIService, $mdDialog, $state, $window, $stateParams) {
                  	var vendorCtrl = this;
                  	vendorCtrl.dtOptions = {
                      		 
                      		 dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
               	            pagingType: 'simple',
               	         //   autoWidth : false,
               	            responsive: true
                  	 }
                  	$scope.getVendorListByName = function(){
                  		RestAPIService.getVendorListByName("Vendor").then(
                                  function(success) {
                                 	 $scope.vendorList = success.data[0];
                                 	vendorCtrl.vendordata = success.data[0];
                                 	//siteHomeCtrl.vendor = vendorCtrl.vendordata
                                 	
                                  },
                                  function(error) {
                                      RestAPIService.showErrorDialog(error);
                                  });	
                  	}
                  	
                  	$scope.selectedval = function(val){  
                  		if(val == "Vendor name")
                  			return true; 
                      }
                  	
                  	$scope.searchVendor = function (selectedName,enteredValue){
                  		$scope.listname = "Vendor";
                  		$scope.selectedname = $scope.selectedName;
                  		$scope.enteredvalue = $scope.enteredValue;
                  		RestAPIService.getListBysearch($scope.listname,$scope.selectedname,$scope.enteredvalue).then(
                                  function(success) {	
                                 	 $scope.searchList = success.data;
                                  },
                                  function(error) {
                                  	
                                      RestAPIService.showErrorDialog(error);
                                  });		
                  	}
                  	$scope.addVendor = function(vendor) {
                  		libCtrl.contract.BusinessPartner = vendor.id;
                  		$mdDialog.cancel();
                      };
                  	
                 	 	$scope.cancel = function() {
                          $mdDialog.cancel();
                      };
                      
          			
                      $scope.ok = function() {
                          $mdDialog.cancel();
                      };
                      
                      function init(){
                      	//$scope.vendorlist(); 
                      	$scope.getVendorListByName();
                      }
                      //
                      init();
                 }
                  
                  $scope.selectParnerTypeType = function(partnerType) {
                  	$scope.partners = [];
                  	if(partnerType != "Vendor"){
                  		RestAPIService.getListsByname(partnerType).then(
                              function(success) {
                                  $scope.Partnerdata = success.data;
                                  $scope.Partnerdata.forEach(function(partner) {
                                  	var partnerval = {};
                                      if (partnerType == 'Vendor') {
                                      	partnerval['id'] = partner.id;
                                      	partnerval['value'] = partner.vendorName;
                                           $scope.partners.push(partnerval);
                                      } else if (partnerType == 'Employee' ||partnerType == 'Customer' ) {
                                      	partnerval['id'] = partner.id;
                                      	partnerval['value'] = partner.name;
                                          $scope.partners.push(partnerval);
                                      }
                                  });
                                  $scope.contract['BusinessPartner'] = partnerType;
                              },
                              function(error) {
                                  RestAPIService.showErrorDialog(error);
                              });
                  	}
                  }
                  
                  
                  $scope.addnewVendor = function(ev) { 
                      $mdDialog.show({
                          controller: AddVendorDialogController,
                          templateUrl: 'app/main/contractlibrary/addVendor.html',
                          parent: angular.element(document.body),
                          targetEvent: ev,
                          autoWrap: true,
                          skipHide: true, 
                          clickOutsideToClose: true
                      });
                  }
      			
                  
                  function AddVendorDialogController($scope, $mdDialog, $sce) {
                  	
                  	RestAPIService.getVendorListByName("Vendor").then(
                              function(success) {
                             	 $scope.vendorList = success.data[0];
                             	$scope.listdata =  $scope.vendorList;               
                             	
                              },
                              function(error) {
                                  RestAPIService.showErrorDialog(error);
                              });	
                  	
                  	$scope.listdata = siteHomeCtrl.vendor;
                  	$scope.crlist=[];
                      
                      $scope.save =function(){
                      	 var obj ={};
                      	 var ary=[];
                      	 var t=[];
                      	 t = $scope.listdata.attributes;
                      	  for(var i=0; i<t.length; i++){
                        		  obj[t[i].fieldname] = $scope.crlist[i].list;
                        		}
                      	  
                        	  ary.push({"productMap":obj});
                               $scope.arr1 = ary[0];
                               $scope.arr1.name = $scope.listdata.name;
                              RestAPIService.createdetail($scope.arr1).then(
                                      function(success) {
                                      	$scope.NewVendor =success.data.slice(-1);
                                      	 $mdDialog.hide();
                                      },
                                      function(error) {
                                          RestAPIService.showErrorDialog(error);
                                      }
                                  );
                      }
                  	$scope.cancel = function() {
                          $mdDialog.cancel();
                      };
                      
                      $scope.ok = function() {
                          $mdDialog.cancel();
                      };
                  } 
                  
                  $scope.addnewEmployee = function(ev) { 
                      $mdDialog.show({
                          controller: AddEmployeeDialogController,
                          templateUrl: 'app/main/contractlibrary/addEmployee.html',
                          parent: angular.element(document.body),
                          targetEvent: ev,
                          autoWrap: true,
                          skipHide: true, 
                          clickOutsideToClose: true
                      });
                  }
      	 function AddEmployeeDialogController($scope, $mdDialog, $sce) {
                  	
                  	RestAPIService.getVendorListByName("Employee").then(
                              function(success) {
                             	 $scope.employeeList = success.data[0];
                             	$scope.listdata =  $scope.employeeList;               
                             	
                              },
                              function(error) {
                                  RestAPIService.showErrorDialog(error);
                              });	
                  	
                  	$scope.listdata = siteHomeCtrl.vendor;
                  	$scope.crlist=[];
                      
                      $scope.save =function(){
                      	 var obj ={};
                      	 var ary=[];
                      	 var t=[];
                      	 t = $scope.listdata.attributes;
                      	  for(var i=0; i<t.length; i++){
                        		  obj[t[i].fieldname] = $scope.crlist[i].list;
                        		}
                      	  
                        	  ary.push({"productMap":obj});
                               $scope.arr1 = ary[0];
                               $scope.arr1.name = $scope.listdata.name;
                              RestAPIService.createdetail($scope.arr1).then(
                                      function(success) {
                                      	$scope.NewEmployee =success.data.slice(-1);
                                      	 $mdDialog.hide();
                                      },
                                      function(error) {
                                          RestAPIService.showErrorDialog(error);
                                      }
                                  );
                      }
                  	$scope.cancel = function() {
                          $mdDialog.cancel();
                      };
                      
                      $scope.ok = function() {
                          $mdDialog.cancel();
                      };
                  } 
                  	//customer

      $scope.addnewCustomer = function(ev) { 
                      $mdDialog.show({
                          controller: AddCustomerDialogController,
                          templateUrl: 'app/main/contractlibrary/addCustomer.html',
                          parent: angular.element(document.body),
                          targetEvent: ev,
                          autoWrap: true,
                          skipHide: true, 
                          clickOutsideToClose: true
                      });
                  }
      	 function AddCustomerDialogController($scope, $mdDialog, $sce) {
                  	
                  	RestAPIService.getVendorListByName("Customer").then(
                              function(success) {
                             	 $scope.customerList = success.data[0];
                             	$scope.listdata =  $scope.customerList;               
                             	
                              },
                              function(error) {
                                  RestAPIService.showErrorDialog(error);
                              });	
                  	
                  	$scope.listdata = siteHomeCtrl.vendor;
                  	$scope.crlist=[];
                      
                      $scope.save =function(){
                      	 var obj ={};
                      	 var ary=[];
                      	 var t=[];
                      	 t = $scope.listdata.attributes;
                      	  for(var i=0; i<t.length; i++){
                        		  obj[t[i].fieldname] = $scope.crlist[i].list;
                        		}
                      	  
                        	  ary.push({"productMap":obj});
                               $scope.arr1 = ary[0];
                               $scope.arr1.name = $scope.listdata.name;
                              RestAPIService.createdetail($scope.arr1).then(
                                      function(success) {
                                      	$scope.NewCustomer =success.data.slice(-1);
                                      	 $mdDialog.hide();
                                      },
                                      function(error) {
                                          RestAPIService.showErrorDialog(error);
                                      }
                                  );
                      }
                  	$scope.cancel = function() {
                          $mdDialog.cancel();
                      };
                      
                      $scope.ok = function() {
                          $mdDialog.cancel();
                      };
                  } 	
                  
                  
                   
                  var siteId = "site-9";
                  $scope.documentTypeJson = {};
                  
                  $scope.uploadFile = function(ev, description, documentTypeJson, templateName, name) {
                  	$scope.templatename = $scope.templateName;
                  	$scope.Name = $scope.name;
                      $scope.documentType = "Contract";
                      $scope.documentTypeJson['documentType'] = $scope.documentType;
                      $scope.documentTypeJson['attributes'] = $scope.contract;
                      var files = $scope.files;
                      if (files == undefined && $scope.templateName == undefined) {
                          $scope.ErrorMsg = "Please upload a file or select Template";
                      }
                     
                          
                          RestAPIService.uploadFile(siteId, $scope.files[0], siteHomeCtrl.currentFolderId, $scope.documentTypeJson).then(
                              function(success) {
                                  RestAPIService.successTostDialog("File uploaded successfully ");
                                  $mdDialog.cancel();
                              },
                              function(error) {
                                  RestAPIService.showErrorDialog(error);
                              }
                          );
                          $mdDialog.hide(ev);
                  
                      if ($scope.templateName != undefined) {
                      	RestAPIService.createTemplateFile(siteId, siteHomeCtrl.currentFolderId, $scope.documentTypeJson, $scope.templatename, $scope.Name).then(
                              function(success) {
                                  RestAPIService.successTostDialog("Created successfully ");
                                  $mdDialog.cancel();
                              },
                              function(error) {
                                  RestAPIService.showErrorDialog(error);
                              }
                          );
                          $mdDialog.hide(ev);
                      }

                  }
                  
                  $scope.getUserDetails = function(){
                  	RestAPIService.UserDetails($localStorage.currentUser.username).then(
                          function(success) {
                          	$scope.uploadDateFormat = success.data.dateFormat;
                              },
                          function(error) {
                              RestAPIService.showErrorDialog(error);
                          });	
                  }
                  
                  function init(){
                  	$scope.getUserDetails();
                  	$scope.getContractAttributes();
                  	$scope.getCategories("Categories");
                  	$scope.getContractTypes("ContractTypes");
                  	$scope.getMyCompanycodes();
                  	$scope.getPurchaseOrgList("PurchaseOrg");
                  	$scope.getDocumentTemplate();
                  }
                  //
                  init();
                  
              }
             
        
        
    }
})();


(function() {
    'use strict';

    var app = angular
        .module('app.doclibraryForms', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $controllerProvider, $compileProvider, $filterProvider, $provide) {
        app.controller = $controllerProvider.register;
        app.directive = $compileProvider.directive;
        app.filter = $filterProvider.register;
        app.factory = $provide.factory;
        app.service = $provide.service;
        
        $stateProvider
            .state('app.doclibraryForm', {
                url: '/smartportal/docLibraryForm/:siteId/:fileId/:businessObject',
                params: {
                    'siteId': null,
                    'fileId': null,
                    'businessObject': null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/sites/site/doclibraryForm/doclibraryForm.html',
                        controller: 'DoclibraryFormController as docLibraryFormCtrl'
                    }
                },
                resolve: {
                    deps: ['$ocLazyLoad', function($ocLazyLoad) {
                        return $ocLazyLoad.load(['app/main/sites/site/doclibraryForm/doclibraryForm.controller.js']);
                    }]
                }
            });

    }
})();
(function() {
    'use strict';

    angular
        .module('app.doclibraryForms')
        .controller('DoclibraryFormController', DoclibraryFormController);

    /** @ngInject */
    function DoclibraryFormController($state, $scope, $stateParams, $window, RestAPIService, $sce) {
        var docLibraryFormCtrl = this;
        $scope.isReadOnlyHeaderCurrency = true;        
        $scope.header = {};
        $scope.lineItems = [{
    		temp : null    		 
        }]; 
        docLibraryFormCtrl.gotoBack = function() {
            $window.history.back();
        }

        function viewForm(data){
            $scope.currentFormName = data.name;
            $scope.currentFormHeader = $sce.trustAsHtml(data.content.replace(/&quot;/g,'"'));
            $scope.currentFormLineitem = $sce.trustAsHtml(data.lineItemContent.replace(/&quot;/g,'"'));
        }

        
        // Initial load
        init();

        function init() {
            if ($stateParams.fileId != undefined && $stateParams.siteId != undefined) {
                RestAPIService.buildForm($stateParams.siteId, $stateParams.fileId).then(
                    function(success) {
                        $scope.header = success.data.header;
                        $scope.lineItems = success.data.lineItems;
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    });
            }
            if($stateParams.businessObject != undefined){
            	RestAPIService.findBusinessObjectAttributes($stateParams.businessObject).then(
                        function(success) {
                        	if(success.data != undefined){
                        		if(undefined != success.data.formId){
                        			RestAPIService.getRequestFormById(success.data.formId).then(
                                            function(response) {
                                            	console.log("response :: ",response)
                                                viewForm(response.data);
                                            },
                                            function(error) {
                                                RestAPIService.showErrorDialog(error);
                                        });
                        		}
                        	}
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                    });
            	
            }
            
            
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.sites')
        .controller('SitesDocLibraryController', SitesDocLibraryController);


    /** @ngInject */
    function SitesDocLibraryController($scope, $mdDialog, $state, RestAPIService,CommonUtil,FileIdForLegacyForm, $stateParams) {
        var siteDocLibCtrl = this;
        siteDocLibCtrl.currentFolderId = '';
        $scope.detailsVisibility = false;
        $scope.versionsVisibility = false;
        $scope.buttonVisibility = false;
        $scope.filebuttonVisibility = false;

        $scope.filePath = [{"id": "","name":"Home"}];
        $scope.filePathVisibility = false;
        $stateParams.siteId ="site-8";
        var siteId = $stateParams.siteId;
        
        $scope.orderByField = 'name';
        $scope.reverseSort = false;
       
       
        siteDocLibCtrl.pageNumber = 0;
        siteDocLibCtrl.pageSize = 10;
        siteDocLibCtrl.next = function(){
            siteDocLibCtrl.pageNumber = siteDocLibCtrl.pageNumber + 1;            
            siteDocLibCtrl.getFiles();            
        }
        siteDocLibCtrl.previous = function(){
            siteDocLibCtrl.pageNumber = siteDocLibCtrl.pageNumber - 1;           
            siteDocLibCtrl.getFiles();
        }
        $scope.sendPageNumber = function(pageNumber){
            siteDocLibCtrl.pageNumber = pageNumber;
            siteDocLibCtrl.getFiles();
        }
        
        siteDocLibCtrl.getFiles = function() {
            RestAPIService.getFiles(siteDocLibCtrl.currentFolderId, siteId,siteDocLibCtrl.pageNumber, siteDocLibCtrl.pageSize).then(
                function(success) {
                    siteDocLibCtrl.files = success.data;   
                    //alert(success.headers('x-total-count'));
                    siteDocLibCtrl.numberOfElements = success.headers('x-total-count');
                    /*console.log(siteDocLibCtrl.pageNumber,siteDocLibCtrl.pageSize);*/
                   
                    // Make page numbers to be populated in dropdown, to select page numbers directly.
                  $scope.noOfPages = siteDocLibCtrl.numberOfElements/siteDocLibCtrl.pageSize ;
                    $scope.pageNumbers = [];
                    if($scope.noOfPages > 0){
                      for(var i=0; i<$scope.noOfPages; i++){
                          $scope.pageNumbers.push(i);
                       }                        
                    } 
                    //console.log($scope.fileResults.number);
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                });
        };
        
        
        $scope.renewalFile = function(file){
         RestAPIService.renewalFile(siteId,file).then(
                     function(success) {
                         //Update successful. Need to refresh
                         //$state.reload();
                         //Reload is bad UI experience, hence executing GET again
                         RestAPIService.successTostDialog("File renamed successfully ");
                         siteDocLibCtrl.getFiles();
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                     }
                 );s
        }
        siteDocLibCtrl.getAttributes = function(fileId) {
            RestAPIService.getAttributes(siteId, fileId).then(
                function(response) {
                    $scope.file = response.data;
                    siteDocLibCtrl.selectedFile = response.data;
                   
                    siteDocLibCtrl.fileAttributes = [];
                    for(var attributeName in response.data.attributes){
                        var attribute = {
                            name: attributeName,
                            value: response.data.attributes[attributeName]
                        }
                        siteDocLibCtrl.fileAttributes.push(attribute);
                    }

                    siteDocLibCtrl.allSharedUsers = response.data.users;
                    //alert(JSON.stringify(siteDocLibCtrl.fileAttributes));
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );
        };


        $scope.editorEnabled = false;
        $scope.enableEditor = function() {
            $scope.editorEnabled = true;
        };
        $scope.disableEditor = function() {
            $scope.editorEnabled = false;
        };
        
        $scope.saveAllAttributes = function() {
            $scope.disableEditor();
            //building the PUT object manually,i.e.JSON structure
            //because only share and attributes are editable 
            $scope.fileAttributesObject = {};
            $scope.fileAttributesObject.id = siteDocLibCtrl.selectedFile.id;
            
            //Appending dynamic file attributes
            
            var attributes = {};
            for(var i=0;i<siteDocLibCtrl.fileAttributes.length;i++){
                //alert(siteDocLibCtrl.fileAttributes[i].name+'***'+siteDocLibCtrl.fileAttributes[i].value);
                attributes[siteDocLibCtrl.fileAttributes[i].name] = siteDocLibCtrl.fileAttributes[i].value;
            }
            //alert(JSON.stringify(attributes));
            
            $scope.fileAttributesObject.attributes = attributes; 
            //Appending the versions and activities AS IT IS-without any change
            $scope.fileAttributesObject.versions = siteDocLibCtrl.selectedFile.versions;
            $scope.fileAttributesObject.activities = siteDocLibCtrl.selectedFile.activities;
            $scope.fileAttributesObject.users = siteDocLibCtrl.selectedFile.users;

            //alert(JSON.stringify($scope.fileAttributesObject));
            RestAPIService.updateFileAttrAndSharing(siteId,$scope.fileAttributesObject).then(
                function(response){
                   //$state.reload();
                   //reloading is a bad UI experience.Hence calling GET again
                   siteDocLibCtrl.getAttributes(siteDocLibCtrl.selectedFile.id);
                   $mdDialog.hide();
                },
                function(error){
                    RestAPIService.showErrorDialog(error);
                }
            );
        };
        


        siteDocLibCtrl.fileIcon = function(file){
            return CommonUtil.getIconForFile(file);
        }
        siteDocLibCtrl.selectFile = function(fileItem, i) {
        	if(fileItem.status == 'CheckedOut'){
        	$scope.checkout = true;  
        	  	}
        	else{
        		$scope.checkout =false;
        	}
            $scope.selectedRow = i; 
            siteDocLibCtrl.receivedFile = fileItem;
            $scope.iconsVisibility = i;
            $scope.detailsVisibility = true;

            if (fileItem.type === "folder") {
                $scope.versionsVisibility = false;
            } else{
                $scope.versionsVisibility = true;
            }
            
            if (fileItem.mimeType == "") {
            	$scope.buttonVisibility = false;
             	$scope.filebuttonVisibility = false;
            } else if (fileItem.mimeType === "application/pdf" || fileItem.mimeType === "text/plain" || fileItem.mimeType === "multipart/form-data" || fileItem.mimeType === "application/octet-stream" || "application/jpg" || "application/PNG") {
            	$scope.buttonVisibility = false;
            	$scope.filebuttonVisibility = true;
            } else {
        		$scope.buttonVisibility = true;
             	$scope.filebuttonVisibility = false;
            }
          
            siteDocLibCtrl.selectedFileName = fileItem.name;
            $scope.selectedFileIcon = CommonUtil.getIconForFile(fileItem);
            $scope.businessObjectName = fileItem.businessObjectName;
            // Call API service to get attributes, versions and activities of this file.
            var fileId = fileItem.id;
            siteDocLibCtrl.getAttributes(fileId);
            
        }
        
        
        
        $scope.previewFile = function(ev) {
    	   $mdDialog.show({
    	      controller: DialogController,
    	      templateUrl: 'app/main/sites/site/doclibrary/previewFiles.html',
    	      parent: angular.element(document.body),
    	      targetEvent: ev,
    	      clickOutsideToClose:true
    	    });
        }
        
        function DialogController($scope, $mdDialog, $sce, $sessionStorage) {
        	var selectedFile = siteDocLibCtrl.receivedFile;
        	var jwtToken = $sessionStorage.currentUser.token.trim();
        	if(jwtToken != undefined && selectedFile != undefined) {
        		var encodedURI = encodeURIComponent(baseUrl+'/api/sites/'+$stateParams.siteId+'/files/file?fileId='+selectedFile.id+'&checkingOut=false&attachment=false&jwtToken='+jwtToken);
        		
        			$scope.fileURL = $sce.trustAsResourceUrl('https://docs.google.com/gview?url='+encodedURI+'&embedded=true');
        		
        	}
        }
        
        
        
        
        $scope.FileDeatilsDialog = function(ev,file) {
        	siteDocLibCtrl.currentFile = angular.copy(file);
             $mdDialog.show({
     	      controller: FileDetailsDialogController,
     	      templateUrl: 'app/main/sites/site/doclibrary/fileDetails.html',
     	      parent: angular.element(document.body),
     	      targetEvent: ev,
     	      clickOutsideToClose:true
     	    });
         }
         
         function FileDetailsDialogController($scope, $mdDialog, $sce, $sessionStorage) {
        	 //$scope.selectedFile = siteDocLibCtrl.receivedFile;
        	 $scope.currentFile = siteDocLibCtrl.currentFile;        	 
        	 		     	 
        	
             $scope.hide = function() {
                 $mdDialog.hide();
             };
             $scope.cancel = function() {
                 $mdDialog.cancel();
             };
        	 
         }
        
        
        
        $scope.noOfNewAttributes = 0;
        $scope.addNewAttribute = function() {
            var newAttribute = {
                name: 'Enter name',
                value:'Enter value'
            }
            //Replacing all spaces with underscore in "label" and use it as "name"
            //newAttribute.name = newAttribute.label.replace(/ /g,"_");
            //siteDocLibCtrl.fileAttributes[newAttribute.key] = newAttribute.value;
            siteDocLibCtrl.fileAttributes.push(newAttribute);
            $scope.noOfNewAttributes ++;
        };

        siteDocLibCtrl.allSharedUsers = [];

        siteDocLibCtrl.sharedUsersDialog = function(ev){
            $mdDialog.show({
                controller: sharedUsersDialogController,
                templateUrl: 'app/main/sites/site/doclibrary/sharedUsersDialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })

        }
        function sharedUsersDialogController($scope){
        	
        	$scope.getPermission = function(){
              	  RestAPIService.getPermission(siteDocLibCtrl.selectedFile.id).then(
                             function(response){
                            	 $scope.allSharedUsers =response.data;
                      
                                    },
                             function(error){
                                 RestAPIService.showErrorDialog(error);
                             }
                         );
              	   
                 }
           //$scope.allSharedUsers = siteDocLibCtrl.allSharedUsers;
           $scope.selectedFileName = siteDocLibCtrl.selectedFileName;
          
           $scope.myDate = new Date('9999-12-31T03:24:00');
           $scope.isOpen = false;       
                 
           $scope.searchElements = {
        		type: 'user'
		   };
           
           $scope.searchUsers = function(elements){
        	   $scope.searchedUsers = {};
               RestAPIService.searchUsers(elements).then(
                    function(response){
                    	if(response.data[0].length > 0){
                    		$scope.searchedUsers.data = response.data[0];
                    		$scope.searchedUsers.type = elements.type;
                    	} 
                    },
                    function(error){
                        RestAPIService.showErrorDialog(error);
                    });
           }
           siteDocLibCtrl.permission = {};
           
           $scope.shareFile = function(memberData, status, myDate, type){ 
        	  var keys = Object.keys(status);
        	  var filtered = keys.filter(function(key) {
        		    return status[key]
        		});        	   
        	   siteDocLibCtrl.permission.fileId =siteDocLibCtrl.selectedFile.id;
        	   if(type == 'user'){
        		   siteDocLibCtrl.permission.userId =memberData.login;
        	   } else {
        		   siteDocLibCtrl.permission.userId =memberData.id;
        	   }
        	  
        	   siteDocLibCtrl.permission.permissions = filtered;
        	   siteDocLibCtrl.permission.expirydate = myDate;
        	   
        	   RestAPIService.Filepermission(siteDocLibCtrl.permission).then(
                       function(response){ 
                    	   $scope.getPermission();
                       },
                       function(error){
                           RestAPIService.showErrorDialog(error);
                       });     	   
         		
                $scope.allSharedUsers.push(memberData);
           }

           $scope.removeSharing = function(userId){
        	  	
               RestAPIService.Removepermission(userId).then(
                 function(response){ 
                	$scope.getPermission();
                 },
                 function(error){
                     RestAPIService.showErrorDialog(error);
                 }
             );  
           }

           $scope.cancel = function() {               
                $mdDialog.cancel();
            }
           $scope.updateFileSharing = function(){
        	   $mdDialog.cancel();
           }
            $scope.fileAttributes = siteDocLibCtrl.fileAttributes;
            $scope.selectedFileName = siteDocLibCtrl.selectedFileName;
           /* $scope.updateFileSharing = function(){
                //building the PUT object manually,i.e.JSON structure
                //because only share and attributes are editable 
                $scope.fileSharingObject = {};
                $scope.fileSharingObject.id = siteDocLibCtrl.selectedFile.id;
                //Appending dynamic file attributes
                $scope.fileSharingObject.attributes = $scope.fileAttributes;

                //Appending the versions and activities AS IT IS-without any change
                $scope.fileSharingObject.versions = siteDocLibCtrl.selectedFile.versions;
                $scope.fileSharingObject.activities = siteDocLibCtrl.selectedFile.activities;
                //Updating the shared user object
                $scope.fileSharingObject.users = $scope.allSharedUsers; 

                //alert(JSON.stringify($scope.fileAttributesObject));
                RestAPIService.updateFileAttrAndSharing(siteId,$scope.fileSharingObject).then(
                    function(response){
                       //$state.reload();
                       //reloading is a bad UI experience.Hence calling GET again
                       RestAPIService.successTostDialog("Fie shared successfully ");
                       siteDocLibCtrl.getAttributes(siteDocLibCtrl.selectedFile.id);
                       $mdDialog.hide();
                    },
                    function(error){
                        RestAPIService.showErrorDialog(error);
                    });

            }*/
        }

        
       
        siteDocLibCtrl.doubleClick = function(file) {
            if (file.type == 'file') return;
            siteDocLibCtrl.pageNumber = 0;
            siteDocLibCtrl.currentFolderId = file.id;
            $scope.filePath.push(file);
            siteDocLibCtrl.getFiles();
            if($scope.filePath.length>1){
                $scope.filePathVisibility = true;
            }

        };
        siteDocLibCtrl.gotoFolder = function(folder){
            //Get the content of that specific folderz
            siteDocLibCtrl.doubleClick(folder);

            //Delete the intermediate folder links that come after selected folder
            var currentPath = $scope.filePath;
            var i;
            for(i=0;i<currentPath.length;i++){
                if(currentPath[i].id == folder.id){
                    $scope.filePath.splice(i+1,(currentPath.length-i+1));
                    break;
                }      
            }
            if($scope.filePath.length == 1){
                $scope.filePathVisibility = false;
            }
        }

        siteDocLibCtrl.currentFile = {};
        $scope.UpdateFile = function(ev) {
            siteDocLibCtrl.currentFile = angular.copy(siteDocLibCtrl.receivedFile);
            siteDocLibCtrl.name = siteDocLibCtrl.currentFile.name;
            siteDocLibCtrl.id = siteDocLibCtrl.currentFile.id;
            $mdDialog.show({
                controller: UpdateFileDialogController,
                templateUrl: 'app/main/sites/site/doclibrary/editFiledialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen,

            })
            

        };

        function UpdateFileDialogController($scope, $mdDialog) {

            $scope.currentFile = siteDocLibCtrl.currentFile;

            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.updateFile = function(file) {
                RestAPIService.updateFile(siteId,file).then(
                    function(success) {
                        //Update successful. Need to refresh
                        //$state.reload();
                        //Reload is bad UI experience, hence executing GET again
                        RestAPIService.successTostDialog("File renamed successfully ");
                        siteDocLibCtrl.getFiles();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide(file);
            };
        }
        	
       

        siteDocLibCtrl.VersionFile = {};
        $scope.VersionFileDialog = function(ev, file) {
            siteDocLibCtrl.VersionFile = angular.copy(file);
            $mdDialog.show({
                controller: VersionFileDialogController,
                templateUrl: 'app/main/sites/site/doclibrary/VersionFiledialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen,

            })

        };
        function VersionFileDialogController($scope, $mdDialog) {           
            $scope.VersionFile = siteDocLibCtrl.VersionFile;
            $scope.selectedFileName = siteDocLibCtrl.selectedFileName;
            var formData = new FormData();
            $scope.setFile = function(element) {
                $scope.$apply(function() {
                    $scope.files = [];
                    for (var i = 0; i < element.files.length; i++) {
                        formData.append('file', element.files[i]);
                        $scope.files.push(element.files[i]);
                    }
                });
            };
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.NewVersionFile = function() {
                //alert(JSON.stringify(checkInfile));
                RestAPIService.NewVersionFile(siteId,$scope.files[0], siteDocLibCtrl.VersionFile).then(
                    function(success) {
                        //        //Update successful. Need to refresh
                        //$state.reload();
                        //Update the file attribute section. Calling get again
                        //reloading is a bad UI experience.Hence calling GET again
                        RestAPIService.successTostDialog("New version added successfully");
                       siteDocLibCtrl.getAttributes(siteDocLibCtrl.selectedFile.id);
                    },
                    function(error) {
                        // RestAPIService.showErrorDialog(error);
                         $mdDialog.show(
                            $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('Error')
                            .textContent(error.data.description)
                            .ok('Ok')
                        );
                    }
                );
                $mdDialog.hide();
            };
        }
         siteDocLibCtrl.checkInFile = {};
        $scope.checkInFileDialog = function(ev) {
            siteDocLibCtrl.checkInFile = angular.copy(siteDocLibCtrl.receivedFile);
            $mdDialog.show({
                controller: CheckInFileDialogController,
                templateUrl: 'app/main/sites/site/doclibrary/checkInFiledialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen,
            })
        };
        function CheckInFileDialogController($scope, $mdDialog) {           
            $scope.checkInFile = siteDocLibCtrl.checkInFile;
            var formData = new FormData();
            $scope.setFile = function(element) {
                $scope.$apply(function() {
                    $scope.files = [];
                    for (var i = 0; i < element.files.length; i++) {
                        formData.append('file', element.files[i]);
                        $scope.files.push(element.files[i]);
                    }
                });
            };
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.checkIn = function() {
                //alert(JSON.stringify(checkInfile));
                RestAPIService.checkIn(siteId,$scope.files[0], siteDocLibCtrl.checkInFile, siteDocLibCtrl.currentFolderId).then(
                    function(success) {
                        alert("checkIn Success");
                        siteDocLibCtrl.getFiles();
                        //$state.reload();
                        RestAPIService.successTostDialog("File checked in successfully ");
                        // $mdDialog.show(
                        //         $mdDialog.alert()
                        //         .clickOutsideToClose(true)
                        //         .title('Success!')
                        //         .textContent('File checked in successfully')
                        //         .ok('Ok')
                        //     );
                    },
                    function(error) {
                        $mdDialog.show(
                            $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('Error')
                            .textContent(error.data.description)
                            .ok('Ok')
                        );
                   }
                );
                $mdDialog.hide();
            };
        }
        siteDocLibCtrl.deleteFile = function(ev, file) {
            var fileId = siteDocLibCtrl.receivedFile.id;
            var confirm = $mdDialog.confirm()
                .title('Remove')
                .textContent('File ' + siteDocLibCtrl.receivedFile.name + ' will be permanently deleted. Continue ?')
                .targetEvent(ev)
                .ok('Ok')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                RestAPIService.deleteFile(siteId,fileId).then(
                    function(success) {
                        //delete successful. Need to refresh
                        RestAPIService.successTostDialog("File deleted successfully");
                        // Making the Attributes, versions, activities and shared users as  empty when a file was deleted.
                        $scope.file = {};
                        siteDocLibCtrl.fileAttributes = {};
                        siteDocLibCtrl.allSharedUsers = {};
                        // Show the <div> consisting of " Select a file or folder to view its details."
                        $scope.detailsVisibility = false;
                        //$state.reload();
                        //Reload is bad UI experience, hence executing GET again
                        siteDocLibCtrl.getFiles();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
            }, function() {
                $mdDialog.cancel();
            });
        }

        $scope.buildForm = function(fileId) {
        	
        	console.log("$scope.businessObjectName : ",$scope.businessObjectName)
        	
             $state.go('app.doclibraryForm', {'siteId': siteId, 'fileId': fileId, 'businessObject': $scope.businessObjectName});
        };

        $scope.downloadFile = function() {
            var fileId = siteDocLibCtrl.receivedFile.id;
            RestAPIService.downloadFile(siteId,fileId).then(
                function(success) { 
                        var headers = success.headers();
                        //alert(JSON.stringify(headers));
                        var data = success.data;
                        //alert(data);
                        //var filename = headers['x-filename'];
                        var filename = siteDocLibCtrl.selectedFileName;
                        var contentType = headers['content-type'];
                        var linkElement = document.createElement('a');
                        try {
                            var blob = new Blob([data], { type: contentType });
                            var url = window.URL.createObjectURL(blob);
                            linkElement.setAttribute('href', url);
                            linkElement.setAttribute("download", filename);
                            var clickEvent = new MouseEvent("click", {
                                "view": window,
                                "bubbles": true,
                                "cancelable": false
                            });
                            linkElement.dispatchEvent(clickEvent);
                        } catch (ex) {
                            console.log(ex);
                        }
                },
                function(error) {
                    console.log('ERROR Downloading the file ********');
                    RestAPIService.showErrorDialog(error);
                }
            );
        }
        $scope.downloadVersionedFile = function(fileId,versionNo){
            RestAPIService.downloadVersionedFile(siteId,fileId,versionNo).then(
                function(success) { 
                        var headers = success.headers();
                        var data = success.data;
                        var filename = siteDocLibCtrl.selectedFileName;
                        var contentType = headers['content-type'];
                        var linkElement = document.createElement('a');
                        try {
                            var blob = new Blob([data], { type: contentType });
                            var url = window.URL.createObjectURL(blob);
                            linkElement.setAttribute('href', url);
                            linkElement.setAttribute("download", filename);
                            var clickEvent = new MouseEvent("click", {
                                "view": window,
                                "bubbles": true,
                                "cancelable": false
                            });
                            linkElement.dispatchEvent(clickEvent);
                        } catch (ex) {
                            console.log(ex);
                        }
                },
                function(error) {
                    console.log('ERROR Downloading the file ********');
                    RestAPIService.showErrorDialog(error);  
                }
            );
        }
        $scope.fileCheckout = function(){
            var fileId = siteDocLibCtrl.receivedFile.id;
            RestAPIService.fileCheckout(siteId,fileId).then(
                function(success) { 
                	console.log(success);
                	//alert("checkout");
                	
                        var headers = success.headers();
                        var data = success.data;
                        var filename = siteDocLibCtrl.selectedFileName;
                        var contentType = headers['content-type'];
                        var linkElement = document.createElement('a');
                        try {
                            var blob = new Blob([data], { type: contentType });
                            var url = window.URL.createObjectURL(blob);
                            linkElement.setAttribute('href', url);
                            linkElement.setAttribute("download", filename);
                            var clickEvent = new MouseEvent("click", {
                                "view": window,
                                "bubbles": true,
                                "cancelable": false
                            });
                            linkElement.dispatchEvent(clickEvent);
                        } catch (ex) {
                            console.log(ex);
                        }
                        RestAPIService.successTostDialog("File checked out successfully ");
                },
                function(error) {
                	console.log('ERROR Downloading the file ********');
                    //RestAPIService.showErrorDialog(error);  
                           $mdDialog.show(
                            $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('Error')
                            .textContent('The file has been already checked out')
                            .ok('Ok')
                        );
                
                }
            );
        }
        $scope.createFile = function(ev) {
            $mdDialog.show({
                controller: CreateFileDialogController,
                templateUrl: 'app/main/sites/site/doclibrary/upload.doclibrary.dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        };
        
        function CreateFileDialogController($scope, $http, RestAPIService, $mdDialog, $state, $window) {
            var formData = new FormData();
            $scope.setFile = function(element) {
                $scope.$apply(function() {
                    $scope.files = [];
                    for (var i = 0; i < element.files.length; i++) {
                        formData.append('file', element.files[i]);
                        $scope.files.push(element.files[i]);
                    }
                });
            };
            
            $scope.hide = function() {
                $mdDialog.hide();
            };
            
            $scope.template = {};
            $scope.create = {};
            $scope.create['documentType'] = ""
            $scope.createFiledocTypeJson = {};
            $scope.documentType = {};
            $scope.documentTypeName ="";
            $scope.documentTypeCreate = {};
            $scope.attributeObjects = [];
            $scope.selectDocumentType = function(documentType) {
                RestAPIService.getDocumentTypeAttributes(documentType.id).then(function(responce) {
                        $scope.attributeObjects = responce.data.attributes;
                        $scope.documentTypeName =documentType.name;
                        if(responce.data.attributes == null){
                        	alert("No Attributes for selected DocumentType");
                        }
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    })
            }

            $scope.selectDocumentTemplate = function(documentTemplate) {
                $scope.createDocumenttype = "";
                $scope.templateList.forEach(function(template) {
                    if (template.name == documentTemplate) {
                        $scope.createDocumenttype = template.documentType;
                        $scope.create.documentType = template.documentType;
                    }
                });

                $scope.documentsList.forEach(function(documentType) {
                    if (documentType.name == $scope.createDocumenttype) {
                        $scope.DocTypeattributeObjects = documentType.attributes;
                    }
                })
            }
            
            $scope.getDocumentTypes = function() {
                RestAPIService.getDocumentTypes().then(
                    function(success) {
                        $scope.documentsList = success.data;
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
            }
            
            $scope.getDocumentTemplate = function() {
                RestAPIService.getDocumentTemplate().then(
                    function(success) {
                        $scope.templateList = success.data;
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
            }
            
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            
            $scope.attributeObject = {};
            
            $scope.documentTypeJson ={};

            $scope.uploadFile = function(ev, folderName, description, documentTypeName, documentTypeJson) {
            	 $scope.documentTypeJson['documentType']=documentTypeName;
            	 $scope.documentTypeJson['attributes'] ={};
                $scope.attributeObjects.forEach(function(attribute) {
                    $scope.documentTypeJson.attributes[attribute.name] = attribute.Value;
                });
                var files = $scope.files;
                if (files == undefined && folderName == undefined) {
                    $scope.ErrorMsg = "Please upload a file or create new folder"
                }
                if (undefined != files) {
                    var file = files[Object.keys(files)[0]];
                    if (file.size > 1024 * 1024) {
                        alert("Too large File. Only File smaller than 1MB can be uploaded.");
                        return false;
                    }
                    RestAPIService.uploadFile(siteId, $scope.files[0], siteDocLibCtrl.currentFolderId, $scope.documentTypeJson).then(
                        function(success) {
                            RestAPIService.successTostDialog("File uploaded successfully ");
                            siteDocLibCtrl.getFiles();
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        }
                    );
                    $mdDialog.hide(ev);
                }
                if (undefined != folderName) {
                    RestAPIService.createFolder(siteId, folderName, siteDocLibCtrl.currentFolderId).then(
                        function(success) {
                            RestAPIService.successTostDialog("Folder created successfully ");
                            siteDocLibCtrl.getFiles();
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        }
                    );
                    $mdDialog.hide(ev);
                }
            }

            $scope.createTemplateFile = function(ev, name, description, documentType, template) {
                $scope.templateName = template;
                $scope.createFiledocTypeJson['documentType'] = documentType;
                $scope.createFiledocTypeJson['attributes'] = {};
                $scope.DocTypeattributeObjects.forEach(function(attribute) {
                    $scope.createFiledocTypeJson.attributes[attribute.name] = attribute.Value;
                });
                RestAPIService.createTemplateFile(siteId, siteDocLibCtrl.currentFolderId, $scope.createFiledocTypeJson, $scope.templateName, name).then(
                    function(success) {
                        RestAPIService.successTostDialog("Created successfully ");
                        siteDocLibCtrl.getFiles();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide(ev);
            }
        }
    }
})();
(function ()
{
    'use strict';
    angular
        .module('app.sites')
        .controller('SitesForumController', SitesForumController);
          function SitesForumController( $http, $scope,$mdDialog)
    {
      var siteForumCtrl =this;
      var imagePath = 'img/list/60.jpeg';
      $scope.openthread = function(threadData){
        $scope.selectedThread = threadData;
        $scope.commentsVisibility = true;
      }
      $scope.userComment = 'Enter comment here ...';
      $scope.opencategory = function(searchCategory){
        $scope.searchCategory = searchCategory;
        $scope.commentsVisibility = false;
      }
      $scope.createThreadDialog = function(ev) {
              $mdDialog.show({
                  controller: CreateThreadDialogController,
                  templateUrl: 'app/main/sites/site/discussionforum/create.thread.html',
                  parent: angular.element(document.body),
                  targetEvent: ev,
                  clickOutsideToClose:true,
                  fullscreen: $scope.customFullscreen 
              })

              $scope.cancel = function(){    
              };   
        };
        function CreateThreadDialogController($scope, $mdDialog) {
           
            $scope.hide = function() {
              $mdDialog.hide();
            };
            $scope.cancel = function() {     
              $mdDialog.cancel();
            };
          };

      siteForumCtrl.getAnotherColor =  function(index){
          siteForumCtrl.colors = ['red','pink','purple','deep-purple','indigo','blue', 'light-blue','cyan', 'teal','green',
                      'light-green','lime','yellow','amber','deep-orange','brown','grey','blue-grey'];
          var totalNoOfColors = siteForumCtrl.colors.length;                        
          return siteForumCtrl.colors[index%totalNoOfColors];
      }

  
       $scope.Searchcategory={};
       $scope.Threads = [
          {
            face:imagePath,
            Threadid : "1",
            Threadname : "Need to add user in the threaddd with namee",
            Creator : "James",
            Category: "Music",
            Comments :[
            {
              Commenter:"james",
              Commentedon:"April 2017",
              Comment:"dhhhasjkjjjjhkhabbvbcvjhdghbbbbbbbbbbbgdhfkgkggjggghhhhhhhhjgehduwjiejfeifhuefhoehfuehfue",
            },
            {
              Commenter:"john",
              Commentedon:"April 2017",
              Comment:"dhhhasjfffffffffffsddsssssskjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"john",
              Commentedon:"March 2017",
              Comment:"dhhhasjfffffffffffsddsssssskjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"smit",
              Commentedon:"March 2017",
              Comment:"dhhhasjkjjjjhkhabbvfdddddddddddbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            }],
          },
          {
           Threadid: "2",
           Threadname : "Need to change user need to chnage",
           Creator : "John",
           Category: "web design",
           Comments :[
            {
              Commenter:"james",
              Commentedon:"April 2017",
              Comment:"dhhhasjkjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"john",
              Commentedon:"April 2017",
              Comment:"dhhhasjfffffffffffsddsssssskjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"john",
              Commentedon:"April 2017",
              Comment:"dhhhasjfffffffffffsddsssssskjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"johnhh",
              Commentedon:"April 2017",
              Comment:"dhhhasjfffffffffffsddsssssskjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"smit",
              Commentedon:"April 2017",
              Comment:"dhhhasjkjjjjhkhabbvfdddddddddddbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            }],
          },
          {
           Threadid: "3",
           Threadname : "security changes security changes  security",
           Creator : "smit",
           Category: "Great designs",
           Comments :[
            {
              Commenter:"james",
              Commentedon:"March 2017",
              Comment:"dhhhasjkjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"john",
              Commentedon:"March 2017",
              Comment:"dhhhasjfffffffffffsddsssssskjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"john",
              Commentedon:"March 2017",
              Comment:"dhhhasjfffffffffffsddsssssskjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"smit",
              Commentedon:"March 2017",
              Comment:"dhhhasjkjjjjhkhabbvfdddddddddddbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            }],
          },
          {
           Threadid: "4",
           Threadname : "security vendors new security  addddding",
           Creator : "sss",
           Category: "General Discussions",
           Comments :[
            {
              Commenter:"james",
              Commentedon:"March 2017",
              Comment:"dhhhasjkjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"john",
              Commentedon:"March 2017",
              Comment:"dhhhasjfffffffffffsddsssssskjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"john",
              Commentedon:"March 2017",
              Comment:"dhhhasjfffffffffffsddsssssskjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"smit",
              Commentedon:"March 2017",
              Comment:"dhhhasjkjjjjhkhabbvfdddddddddddbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            }],
          },
          {
           Threadid: "5",
           Threadname : "security vendors ddddd security vendors new security vendors",
           Creator : "new user",
           Category: "Graphic design",
           Comments :[
            {
              Commenter:"james",
              Commentedon:"April 2017",
              Comment:"dhhhasjkjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"john",
              Commentedon:"April 2017",
              Comment:"dhhhasjfffffffffffsddsssssskjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"john",
              Commentedon:"April 2017",
              Comment:"dhhhasjfffffffffffsddsssssskjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"smit",
              Commentedon:"April 2017",
              Comment:"dhhhasjkjjjjhkhabbvfdddddddddddbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            }], 
          },
          {
           Threadid: "6",
           Threadname : "security vendors ddddd security vendors new security",
           Creator : "gggg",
           Category: "General forum designs",
           Comments :[
            {
              Commenter:"james",
              Commentedon:"April 2017",
              Comment:"dhhhasjkjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"john",
              Commentedon:"April 2017",
              Comment:"dhhhasjfffffffffffsddsssssskjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"john",
              Commentedon:"April 2017",
              Comment:"dhhhasjfffffffffffsddsssssskjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"smit",
              Commentedon:"April 2017",
              Comment:"dhhhasjkjjjjhkhabbvfdddddddddddbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            }],
          },
          {
           Threadid: "7",
           Threadname : "securicty vendors ddddd security",
           Creator : "gggcg",
           Category: "Event designs",
           Comments :[
            {
              Commenter:"james",
              Commentedon:"April 2017",
              Comment:"dhhhasjkjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"john",
              Commentedon:"April 2017",
              Comment:"dhhhasjfffffffffffsddsssssskjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"john",
              Commentedon:"April 2017",
              Comment:"dhhhasjfffffffffffsddsssssskjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"smit",
              Commentedon:"April 2017",
              Comment:"dhhhasjkjjjjhkhabbvfdddddddddddbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            }],
          },
          {
           Threadid: "8",
           Threadname : "securicty vendors security",
           Creator : "gdg",
           Category: "Tech designs",
           Comments :[
            {
              Commenter:"james",
              Commentedon:"April 2017",
              Comment:"dhhhasjkjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"john",
              Commentedon:"April 2017",
              Comment:"dhhhasjfffffffffffsddsssssskjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"john",
              Commentedon:"April 2017",
              Comment:"dhhhasjfffffffffffsddsssssskjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"johnb",
              Commentedon:"April 2017",
              Comment:"dhhhasjfffffffffffsddsssssskjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"smit",
              Commentedon:"April 2017",
              Comment:"dhhhasjkjjjjhkhabbvfdddddddddddbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            }],
          }
        ];
    }         
})();



      
        

    
 
(function ()
{
    'use strict';

    angular
        .module('app.sites')
        .controller('SitesDashboardController', SitesDashboardController);

    /** @ngInject */
    function SitesDashboardController($scope, Members,Sites,CurrentSiteId, $stateParams, CurrentSiteName, CurrentSitePage)
    {
        var siteDashCtrl = this;
        var siteId = "site-8";
        siteDashCtrl.sites = Sites.data;

        Sites.data.forEach(function(attribute){
            if(attribute.id == siteId){
                siteDashCtrl.siteHomeText = attribute.siteHomeText;
                siteDashCtrl.title = attribute.title;
                CurrentSiteName.value = attribute.name;
            }
        });

        $scope.allMembers = Members.data;
        var imagePath = 'img/list/60.jpeg';

        siteDashCtrl.test = 'Dshboard HTML content should be in here';
        $scope.messages = [{
          face : imagePath,
          what: 'Admin',
          who: 'Min Li Chan',
          when: '3:08PM',
          notes: "Last seen 30 mins ago"
        }, {
          face : imagePath,
          what: 'Admin',
          who: 'Min Li Chan',
          when: '3:08PM',
          notes: "Last seen 30 mins ago"
        }, {
          face : imagePath,
          what: 'Admin',
          who: 'Min Li Chan',
          when: '3:08PM',
          notes: "Last seen 30 mins ago"
        }, {
          face : imagePath,
          what: 'Admin',
          who: 'Min Li Chan',
          when: '3:08PM',
          notes: "Last seen 30 mins ago"
        }, {
          face : imagePath,
          what: 'Admin',
          who: 'Min Li Chan',
          when: '3:08PM',
          notes: "Last seen 30 mins ago"
        }, {
          face : imagePath,
          what: 'Admin',
          who: 'Min Li Chan',
          when: '3:08PM',
          notes: "Last seen 30 mins ago"
        }, {
          face : imagePath,
          what: 'Admin',
          who: 'Min Li Chan',
          when: '3:08PM',
          notes: "Last seen 30 mins ago"
        }, {
          face : imagePath,
          what: 'Admin',
          who: 'Min Li Chan',
          when: '3:08PM',
          notes: "Last seen 30 mins ago"
        }, {
          face : imagePath,
          what: 'Admin',
          who: 'Min Li Chan',
          when: '3:08PM',
          notes: "Last seen 30 mins ago"
        }];

        siteDashCtrl.tiles = buildGridModel(
          [{
            icon : "icon-calendar-today",
            title: "Updated today: 15 files ",
            background: ""
          },
          {
            icon : "icon-file-word-box",
            title: "DOC: 12 files",
            background: ""
          },
          {
            icon : "icon-file-excel",
            title: "Excel: 3 files",
            background: ""
          },
          {
            icon : "icon-account",
            title: "Knuth kyle: 3 files",
            
            background: ""
          },
          {
            icon : "icon-file-pdf",
            title: "PDF: 7 files",
            background: ""
          },
          {
            icon : "icon-account",
            title: "Morris Johnson: 4 files",
            
            background: ""
          },
          {
            icon : "icon-account",
            title: "Admin: 2 files",
            background: ""
          },
          {
            
            icon : "icon-calendar-clock",
            title: "Yesterday: 10 files",
            background: ""
          },
          {
            icon : "icon-timer-sand",
            title: "Last week: 23 files ",
            
            background: ""
          },
          {
            icon : "icon-account",
            title: "Prat Deushe: 5 files ",
            background: ""
          },
          {
            icon : "icon-account",
            title: "Laplace singh: 2 files",
            background: ""
          }
      ]);

    


        
    }

    function buildGridModel(tileTmpl){
      var it, results = [ ];

      for (var j=0; j<tileTmpl.length; j++) {

        it = tileTmpl[j];
        //it = angular.extend({},tileTmpl);
        //it.icon  = it.icon + (j+1);
        //it.title = it.title + (j+1);
        it.span  = { row : 1, col : 1 };

        switch(j+1) {
          case 1:
            it.background = "#ff8a80"; 
            it.span.row = it.span.col = 2;
            break;

          case 2: it.background = "#b9f6ca";         break; 
          case 3: it.background = "#80d8ff";      break;
          case 4:
            it.background = "#84ffff";
            it.span.col = 2;
            break;

          case 5:
            it.background = "#ffff8d";
            it.span.row = it.span.col = 2;
            break;

          case 6: it.background = "#ff80ab";          break;
          case 7: it.background = "#80d8ff";      break;
          case 8: it.background = "#b388ff";        break;
          case 9: it.background = "#448aff";      break;
          case 10: it.background = "#8c9eff";  break;
          case 11: it.background = "#ffff8d";       break;
        }

        results.push(it);
      }
      return results;
    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.pages.error-500', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-500', {
            url      : '/pages/errors/error-500',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-500': {
                    templateUrl: 'app/main/pages/errors/500/error-500.html',
                    controller : 'Error500Controller as vm'
                }
            },
            bodyClass: 'error-500'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/errors/500');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.errors.error-500', {
            title : '500',
            state : 'app.pages_errors_error-500',
            weight: 2
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-500')
        .controller('Error500Controller', Error500Controller);

    /** @ngInject */
    function Error500Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-404', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-404', {
            url      : '/pages/errors/error-404',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-404': {
                    templateUrl: 'app/main/pages/errors/404/error-404.html',
                    controller : 'Error404Controller as vm'
                }
            },
            bodyClass: 'error-404'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/errors/404');

        // Navigation
        // msNavigationServiceProvider.saveItem('pages.errors', {
        //     title : 'Errors',
        //     icon  : 'icon-alert',
        //     weight: 3
        // });

        // msNavigationServiceProvider.saveItem('pages.errors.error-404', {
        //     title : '404',
        //     state : 'app.pages_errors_error-404',
        //     weight: 1
        // });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-404')
        .controller('Error404Controller', Error404Controller);

    /** @ngInject */
    function Error404Controller($scope,$location)
    {
        $scope.goHome = function (hash) { 
            console.log('going home');
            $location.path('/');
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.overview', [
            'app.core',
            'app.pages.error-404',
            'ngMaterial', 'ngMessages','ngStorage',
            'app.createform','login',
            'app.user-management', 'app.sites','app.settings','app.requests','app.mycontent','app.reports','app.toolbarsearch','app.profile'
            
        ])
        .config(config)
        

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            
            .state('app.overview', {
                url: '/overview',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/overview.html',
                        controller: 'OverviewController as overCtrl'
                    }
                },
                 resolve  : {
                    Icons: function (msApi)
                    {
                        return msApi.resolve('icons@get');
                    }/*,
                    
                   RestAPIService: 'RestAPIService',
                    Homepage: function(RestAPIService) {
                        return RestAPIService.getHomePage();
                    }*/
                }


            });
          
      

        msNavigationServiceProvider.saveItem('smartportal', {
            title: 'Dashboard',
            icon: 'icon-tile-four',
            state: 'app.overview',
            
            translate: 'Home',
            weight:1
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.overview')
        .controller('CustomCreateformController', ['$scope','$http','RestAPIService','SubmitURLService','$mdDialog','$state',function($scope,$http,RestAPIService,SubmitURLService,$mdDialog,$state){
        	var customCtrl = this;
			var formData = new FormData();

        	customCtrl.custom = {
			  formName : '',
			  formDesc : '',
			  formUrl:''
			}

			customCtrl.submitUrl = function(ev){
				var inputUrl = customCtrl.custom.formUrl;
				SubmitURLService.submitFormUrl(inputUrl).then(
					function(success){
						//alert('***'+success.data.length);
					   $scope.openPreviewDialog(success.data,ev);
					},
					function(error){
						var errorStatus = error.status;
				    	var errorStatusText = error.statusText;
				    	if(errorStatus == -1){
				    		errorStatusText = 'The server application is not running';
				    	}
				    	$mdDialog.show(
					      $mdDialog.alert()
					        .clickOutsideToClose(true)
					        .title('Server error occurred while processing')
					        .htmlContent('<hr><br><strong>Error code : </strong>'+errorStatus+
					        	'<br><strong>Error message : </strong>'+errorStatusText)
					        .ariaLabel('Alert Dialog Demo')
					        .ok('Ok')
					    );
					}
				);
	    	}

	    	customCtrl.uploadFile = function(ev){
				var noOfFiles = $scope.files.length;
				// for (var i = 0; i < noOfFiles; i++) {
			 //        var file = $scope.files[i];
				// 	var uploadUrl = 'http://localhost:8085/createform/custom/fileupload';
				// 	//fileUpload.uploadFileToUrl($scope.files[0],uploadUrl);
			 //   	}


			    RestAPIService.uploadFileToUrl($scope.files[0]).then(
				    function(success){
				       //$state.go('app.createform.custom.preview');
				      $scope.openPreviewDialog(success.data,ev);
				   		// $mdDialog.show(
					    //   $mdDialog.alert()
					    //     .clickOutsideToClose(true)
					    //     .title('Length of result')
					    //     .htmlContent('<hr><br><strong>length : </strong>'+success.data.length)
					    //     .ariaLabel('Alert Dialog Demo')
					    //     .ok('Ok')
					    // );

				    },
				    function(error){
				    	var errorStatus = error.status;
				    	var errorStatusText = error.statusText;
				    	if(errorStatus == -1){
				    		errorStatusText = 'The server application is not running';
				    	}
				    	$mdDialog.show(
					      $mdDialog.alert()
					        .clickOutsideToClose(true)
					        .title('Server error occurred while processing')
					        .htmlContent('<hr><br><strong>Error code : </strong>'+errorStatus+
					        	'<br><strong>Error message : </strong>'+errorStatusText)
					        .ariaLabel('Alert Dialog Demo')
					        .ok('Ok')
					    );
				    	
  						//alert("Server error occurred while processing");
				    }
				);
			  
			  
	    	}

	    	$scope.openPreviewDialog = function(data,ev){
	    		customCtrl.inputElemAll = data;

	    		    $mdDialog.show({
				      controller: DialogController,
				      templateUrl: 'app/main/createform/views/custom/preview.html',
				      parent: angular.element(document.body),
				      targetEvent: ev,
				      clickOutsideToClose:false,
				      escapeToClose: false
				    })
			        .then(function(answer) {
			          //$scope.status = 'You said the information was "' + answer + '".';
			        }, function() {
			          //$scope.status = 'You cancelled the dialog.';
			        });


			         function DialogController($scope, $mdDialog,$filter) {
			   			//Setting the input element lists
			   			$scope.inputElemAll = customCtrl.inputElemAll;
			   			$scope.fieldTypes = ["text","password","checkbox","url","email","date",
			   						"number","range","radio"];
			   			
						$scope.removeElem = function(index) {
					      $scope.inputElemAll.splice(index,1);
					      //Removing item from parent list
					    };

					    $scope.addElem = function(){
							//Initializing new row
					    	var newElem ={};
					    	newElem.id = $scope.inputElemAll.length +1;
					    	newElem.name = "elem-"+parseInt($scope.inputElemAll.length +1);
					    	newElem.type = "text";
					    	newElem.value = "";
					    	newElem.style = "";
					    	newElem.required = false;
							
							newElem.position={};
							newElem.position.row = $scope.inputElemAll.length +1;
							newElem.position.column = 1;
							newElem.position.parent = " ";

							//Adding new row
						    $scope.inputElemAll.push(newElem);
						  
						    
						};
						$scope.setParent = function() {
							//List of potential parent = All elements present in the form
					   		$scope.parentAll = [];
					   		$scope.parentAll.push(" "); //For root

					   		for(var i=0;i<$scope.inputElemAll.length;i++){
					   			var eachInput = $scope.inputElemAll[i];
					   			//Dont allow duplicate element names
					   			if($scope.parentAll.indexOf(eachInput.name) == -1)		$scope.parentAll.push(eachInput.name);
					   		}
					    	

					    };
   						$scope.hide = function() {
					      $mdDialog.hide();
					    };

					    
					    $scope.preview = function() {
							//PRE-Processing the data
							
							var invalidElemName = [];
							for(var i=0;i<$scope.inputElemAll.length;i++){
								// (1) Removing elements that has no name :1st part
								var elem = $scope.inputElemAll[i];
								if(elem.name.trim()==''){
									invalidElemName.push(i);
									
								}
								// (2) Assume type="text" for any unknown type
								var elemType = elem.type.trim();
								if(elemType=='' || $scope.fieldTypes.indexOf(elemType)==-1){
									$scope.inputElemAll[i].type = 'text';
								}
								// (3) Accomodate blank row at the end
								var elemRow = elem.position.row;
								if( elemRow== null || elemRow == undefined || elemRow==''){
									$scope.inputElemAll[i].position.row = $scope.inputElemAll.length+1;
								}
								// (4) Assign column=1 as default value
								var elemCol = elem.position.column;
								if( elemCol== null || elemCol == undefined || elemCol==''){
									$scope.inputElemAll[i].position.column = 1;
								}

							}
							// (1) Removing elements that has no name :2nd part
							for(var j=invalidElemName.length-1;j>=0;j--){
								$scope.removeElem(invalidElemName[j]);
							}
							
					    	//Sorting the elements based on their row number
					    	$scope.inputElemAll.sort(function(a, b){
					    		//If row is same, sort by column number
					    		if(a.position.row == b.position.row)	return a.position.column - b.position.column;
					    		else 	return a.position.row - b.position.row;

					    	});

					    	//POST-Processing the data
					    	var currRow='';
					    	var currCol ='';
							for(var i=0;i<$scope.inputElemAll.length;i++){
								/*
								 * (5) Every element should have unique row, column combination
								 *     Otherwise force the uniqueness, by incrementing column number */
								var elem = $scope.inputElemAll[i];
								if(elem.position.row == currRow){
									if(elem.position.column == currCol){
										$scope.inputElemAll[i].position.column = parseInt(currCol+(elem.id)); //Make column unique
									} 
								}
								else{
									currRow = elem.position.row;
									currCol = elem.position.column;	   
								}

							}

					    	//Counting no of columns for each row
					    	$scope.rowColMap = {};
							for(var i=0;i<$scope.inputElemAll.length;i++){
								if(!$scope.rowColMap[$scope.inputElemAll[i].position.row]){
							      $scope.rowColMap[$scope.inputElemAll[i].position.row] = {};
						      	}
						    	$scope.rowColMap[$scope.inputElemAll[i].position.row][$scope.inputElemAll[i].position.column] = $scope.inputElemAll[i];
						    }

						    


		   					//alert('***'+JSON.stringify($scope.rowColMap));
					    };

					    $scope.answer = function(answer) {
					      $mdDialog.hide(answer);
					    };

					    $scope.isNumeric = function(n){
						  return !isNaN(parseFloat(n)) && isFinite(n);
						}

						$scope.getChildren = function(elemName){
						  	var children = new Array();
						  	angular.forEach($scope.inputElemAll, function(eachInput){
						  		if(eachInput.position.parent == elemName){
						  			children.push(eachInput);
						  		}
					      	})
						  	return children;
						}
						$scope.checkParent = function(elem){
							//if(elem == undefined)	return;
							if(elem.name == elem.position.parent){
								$scope.parentError = 'No element can be it\'s own parent';
								return true;
							}
							var child = elem;
							var parent = elem.position.parent;
							
							var result = $filter('filter')($scope.inputElemAll, {name:parent})[0];
							if(result){
								//console.log('grandparent= '+result.position.parent);
								if(result.position.parent != ' '){
									$scope.parentError = 'The field \"'+result.name+'\" itself is a child of \"'+result.position.parent+
												'\". Grandchildren are not allowed.';
							  			return true;
								}

							}	
					      	return false;
						}
						$scope.getElemId= function(elemName) {
							for(var i=0;i<$scope.inputElemAll.length;i++){
								var elem = $scope.inputElemAll[i];
								if(elem.name == elemName)		return elem.id;
							}
					    };
					    $scope.dynamicElemLabel= function(elemName,isRequired) {
					    	if(isRequired)		return elemName+' (Required)';
					    	else 	return elemName;
					    };
					    

					 
				  }
	   
	    	}

    		$scope.setFile = function(element) {    			
    			$scope.$apply(function() {
		         	$scope.files = [];
			        for (var i = 0; i < element.files.length; i++) {
			          formData.append('file', element.files[i]);
			          $scope.files.push(element.files[i]);
			        }
				    //If user did not specify any form name, suggest one
				    if($scope.files.length){
					   	var formName = customCtrl.custom.formName;
					   	if(!formName){
					   		customCtrl.custom.formName = 'LogInUser 001 - '+element.files[0].name;
					   	}
					}
					else{
					   	return;
					   }

		       	});

		    };


			$scope.reset = function() {
				customCtrl.custom={};
				$scope.files={};
				$scope.customForm.$setPristine();
		        $scope.customForm.$setUntouched();
		    };



  

        }])
        .directive('httpPrefix', function() {
			    return {
			        restrict: 'A',
			        require: 'ngModel',
			        link: function(scope, element, attrs, controller) {
			            function ensureHttpPrefix(value) {
			                // Need to add prefix if we don't have http:// prefix already AND we don't have part of it
			                if(value && !/^(https?):\/\//i.test(value)
			                   && 'http://'.indexOf(value) !== 0 && 'https://'.indexOf(value) !== 0 ) {
			                    controller.$setViewValue('http://' + value);
			                    controller.$render();
			                    return 'http://' + value;
			                }
			                else
			                    return value;
			            }
			            controller.$formatters.push(ensureHttpPrefix);
			            controller.$parsers.splice(0, 0, ensureHttpPrefix);
			        }
			    };
		   })

    	//.service('RestAPIService', ['$http','$q', function ($http,$q) {

    		// var uploadUrl = 'http://localhost:8085/rest/createform/custom/file';
    		//var uploadUrl = 'http://1-dot-clock-asit.appspot.com/rest/createform/custom/file';
		  	// this.uploadFileToUrl = function(file){
		   //      var fd = new FormData();
		   //      fd.append('file', file);
		   //      return $http.post(uploadUrl, fd, {
		   //          transformRequest: angular.identity,
		   //          headers: {'Content-Type': undefined}
		   //      });
		      
		  	// };
		//}])
		.service('SubmitURLService', ['$http','$q', function ($http,$q) {
			
			//var uploadUrl = 'http://localhost:8085/rest/createform/custom/url';
			var uploadUrl = 'http://1-dot-clock-asit.appspot.com/rest/createform/custom/url';
		  	this.submitFormUrl = function(inputUrl){
		  		var data = 'formUrl='+inputUrl;
		       // return $http.post(uploadUrl, data);
		       return $http.post(uploadUrl, data, {
		            headers: {'Content-Type': 'application/x-www-form-urlencoded'}
		        });
		    };
		}]);

      
})();
(function() {
    'use strict';

    var app = angular
        .module('app.administration', ['datatables', 'ngResource','nvd3'])
        .run(run)
        .config(config);

    /** @ngInject */
    function config($stateProvider, $controllerProvider, $compileProvider,msNavigationServiceProvider, $filterProvider, $provide) {
        app.controller = $controllerProvider.register;
        app.directive = $compileProvider.directive;
        app.filter = $filterProvider.register;
        app.factory = $provide.factory;
        app.service = $provide.service;

        $stateProvider
	        .state('app.administration', {
	            url: '/um',
	            views: {
	                'content@app': {
	                	 controller: function($state){
	                		 $state.go('app.administration.users');
	                     }
	                }
	            },
	        data: {accessRole: ['admin']}
	        }).state('app.administration.users', {
                url: '/users',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/user-management/users/users.html',
                        controller: 'UMController as userCtrl'
                    }
                },
                resolve: {
                    RestAPIService: 'RestAPIService',
                    Users: function(RestAPIService) {
                        return RestAPIService.getUsers();
                    }
                },
                data: {accessRole: ['admin']}
            })
           .state('app.finishReset', {
                url: '/reset/finish?key',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/user-management/users/resetpassword.html',
                        controller: 'UMController as userCtrl'
                    }
                },
            data: {accessRole: ['Admin']}
              
            })            
            .state('app.administration.groups', {
                url: '/groups',
                views: {
                    'content@app': {
                        templateUrl: '/app/main/administration/user-management/groups/groups.html',
                        controller: 'GMController as groupsCtrl'
                    }
                },
                resolve: {
                    RestAPIService: 'RestAPIService',
                    Groups: function(RestAPIService) {
                        return RestAPIService.getAllGroups();
                    }
                },
                data: {accessRole: ['admin']}
            })
          /* .state('app.administration.userupload', {
                url: '/userupload',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/user-management/user-upload/userupload.html',
                        controller: 'UserUploadController as useruploadCtrl'
                    }
                },
                resolve: {
                    RestAPIService: 'RestAPIService',
                    Users: function(RestAPIService) {
                        return RestAPIService.getUsers();
                    }
                },
                data: {accessRole: ['admin']}
            })
            .state('app.administration.forms', {
                url: '/forms',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/forms-management/overviewPage.html',
                        controller: 'FMController as requestCtrl'
                    }
                },
               
                data: {accessRole: ['admin']}
            }).state('app.administration.forms.content', {
                url: '/:requestId',
                params: {
                    'requestId': null,
                    'currentForm': null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/forms-management/form.content.html',
                        controller: 'FMController as requestCtrl'
                    }
                },
                data: {accessRole: ['admin']}
            }).state('app.administration.createform', {
                url: '/createform',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/forms-management/createForm.html',
                        controller: 'FMController as requestCtrl'
                    }
                },
               
                data: {accessRole: ['admin']}
            })
             .state('app.administration.lists', {
                url: '/lists',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/list-management/listOverview.html',
                        controller: 'LMController as listCtrl'
                    }
                },
               
                data: {accessRole: ['admin']}
            }).state('app.administration.list-maintenance', {
                url: '/lists',
                views: {  
                    'content@app': { 
                        templateUrl: 'app/main/administration/list-management/list-maintenance/list-maintenance.html',
                        controller: 'LMAINController as listmainCtrl'
                    }
                },
               
                data: {accessRole: ['admin']}
            }).state('app.administration.workflow-management', {
                url: '/workflow-management',
                views: {
	                'content@app': {
	                	 controller: function($state){
	                		 $state.go('app.administration.workflow-management.content');
	                     }
	                }
	            },
                resolve: {
                    RestAPIService: 'RestAPIService',
                    Actvitys: function(RestAPIService) {
                        return RestAPIService.getActvitys();
                    }
                    
                },
                data: {accessRole: ['admin']}
            })
            .state('app.administration.workflow-management.defination', {
                url: '/defination',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/workflow-management/workflow.defination.html',
                        controller: 'WMController as workflowCtrl'
                    }
                },
                data: {accessRole: ['admin']}
            })
            .state('app.administration.workflow-management.content', {
                url: '/content',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/workflow-management/workflow.content.html',
                        controller: 'WMController as workflowCtrl'
                    }
                },
                data: {accessRole: ['admin']}
            })
            .state('app.administration.bussiness-object', {
                url: '/bussiness-object',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/business-object/bussiness.html',
                        controller: 'BussinessController as bsCrtl'
                    }
                },
                resolve: {
                    RestAPIService: 'RestAPIService',
                    Objects: function(RestAPIService) {
                        return RestAPIService.getObjects();
                    }
                },
                data: {accessRole: ['admin']}
            })
            .state('app.administration.requestType', {
                url: '/request-type',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/request-management/createrequestType.html',
                        controller: 'ReqtypeController as reqtypeCtrl'
                    }
                },
                resolve: {
                    RestAPIService: 'RestAPIService',
                    Requests: function(RestAPIService) {
                        return RestAPIService.getRequests();
                    }
                },
                data: {accessRole: ['admin']}
            })*/
            .state('app.administration.settings', {
                url: '/settings',
                views: {
	                'content@app': {
	                	 controller: function($state){
	                		 $state.go('app.administration.settings.account');
	                     }
	                }
	            },
                
                data: {accessRole: ['admin']}
            }).state('app.administration.settings.account', {
                url: '/account',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/settings/accountSettings.html',
                        controller: 'SettingsController as settingCtrl'
                    }
                },
                data: {accessRole: ['admin']}
            }).state('app.administration.settings.technical', {
                url: '/technical',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/settings/technicalSettings.html',
                        controller: 'SettingsController as settingCtrl'
                    }
                },
                data: {accessRole: ['admin']}
            }).state('app.administration.settings.help', {
                url: '/help',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/settings/helpSettings.html',
                        controller: 'SettingsController as settingCtrl'
                    }
                },
                data: {accessRole: ['admin']}
            })
            .state('app.administration.settings.solar', {
                url: '/solar',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/settings/solarsettings.html',
                        controller: 'SettingsController as settingCtrl'
                    }
                },
                data: {accessRole: ['admin']}
            })
            .state('app.administration.settings.smartstore', {
                url: '/smartstore',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/settings/smartstoresettings.html',
                        controller: 'SettingsController as settingCtrl'
                    }
                },
                data: {accessRole: ['admin']}
            })
            .state('app.administration.settings.brand', {
                url: '/brand',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/settings/brandsettings.html',
                        controller: 'SettingsController as settingCtrl'
                    }
                },
                data: {accessRole: ['admin']}
            })
            .state('app.administration.settings.site', {
                url: '/site',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/settings/siteSettings.html',
                        controller: 'SettingsController as settingCtrl'
                    }
                },
                data: {accessRole: ['admin']}
            }).state('app.administration.settings.menubar', {
                url: '/menubar',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/settings/menubarSettings.html',
                        controller: 'SettingsController as settingCtrl'
                    }
                },
                data: {accessRole: ['admin']}
            })
          /* .state('app.administration.binder', {
                url: '/binder',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/binder-management/binder.html',
                        controller: 'BinderController as binderCrtl'
                    }
                },
                resolve: {
                    RestAPIService: 'RestAPIService',
                    Binders: function(RestAPIService) {
                        return RestAPIService.getBinders();
                    }
                },
                data: {accessRole: ['admin']}
            })
             .state('app.administration.documentType', {
                url: '/documentType',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/document-type/documenttype.html',
                        controller: 'DocumentTypeController as doctypeCrtl'
                    }
                },
                resolve: {
                	 RestAPIService: 'RestAPIService',
                	 DocumentTypes: function(RestAPIService) {
                         return RestAPIService.getDocumentTypes();
                     }
                },
                data: {accessRole: ['admin']}
               
            })
            .state('app.administration.documentType.siteConfig', {
                url: '/documentTypeSiteConfig',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/document-type/siteConfigureDialog.html',
                        controller: 'DocumentTypeController as doctypeCrtl'
                    }
                },
                params: {
                    obj: {
                    	"docType": null
                    }
         	     },
                resolve: {
                	 RestAPIService: 'RestAPIService',
                	 DocumentTypes: function(RestAPIService) {
                         return RestAPIService.getDocumentTypes();
                     }
                },
                data: {accessRole: ['admin']}
               
            })
        .state('app.administration.template', {
            url: '/template',
            views: {
                'content@app': {
                    templateUrl: 'app/main/administration/Template/template.content.html',
                    controller: 'TemplateController as templateCtrl'
                }
            },
            resolve: {
            	 RestAPIService: 'RestAPIService',
            	 DocumentTypes: function(RestAPIService) {
                     return RestAPIService.getDocumentTypes();
                 },
                 Templates: function(RestAPIService) {
                     return RestAPIService.getTemplates();
                 }
            },
            data: {accessRole: ['admin']}
           
        })
        .state('app.administration.reports', {
            url: '/reports',
            views: {  
                'content@app': {
                    templateUrl: 'app/main/administration/reports/reportDefinition.html',
                    controller: 'Reportscontoller as repCtrl'
                }
            },
            resolve: {
          	  Icons: function(msApi) {
                  return msApi.resolve('icons@get');
              }
            },
            data: {accessRole: ['admin']}
        }).state('app.administration.reports.maintenance', {
            url: '/maintenance',
            views: {  
                'content@app': {
                    templateUrl: 'app/main/administration/reports/reportMaintenance.html',
                    controller: 'Reportscontoller as repCtrl'
                }
            },
            resolve: {
          	  Icons: function(msApi) {
                  return msApi.resolve('icons@get');
              }
            },
            data: {accessRole: ['admin']}
        })
        .state('app.administration.ilmSetup', {
            url: '/ilmSetup',
            views: {  
                'content@app': {
                    templateUrl: 'app/main/administration/ILMSetup/ilm.html',
                    controller: 'ILMSetupController as ilmStp'
                }
            },
            resolve: {
            	RestAPIService: 'RestAPIService',
            	ILMStores: function(RestAPIService) {
                    return RestAPIService.getAllILMStores();
                },
                Users: function(RestAPIService) {
                    return RestAPIService.getUsers();
                },
                Sites: function(RestAPIService) {
                    return RestAPIService.getSites();
                },
                Systems: function(RestAPIService) {
                    return RestAPIService.getAllILMSystems();
                }
            }
           
        })
        .state('app.administration.systemLandScapeDirectory', {
            url: '/systemLandScapeDir',
            views: {  
                'content@app': {
                    templateUrl: 'app/main/administration/systemLandScapeDir/landscapeDir.html',
                    controller: 'SystemLandscapeController as slCtrl'
                }
            },
            resolve: {
            	RestAPIService: 'RestAPIService',            	
                ILMSystems: function(RestAPIService) {
                    return RestAPIService.getAllILMSystems();
                }
            }
           
        });*/
        
         }   
        
    

    function run(msNavigationService, $localStorage, $rootScope, $state) {
        
    	 $rootScope.$state = $state;
        msNavigationService.saveItem('admin', {
            title: 'Admin',
            icon: 'icon-account',
            state: 'app.administration',
            weight: 6/*,
            hidden: function() {                 
                    if ($rootScope.currentLogedInUser != undefined) {
                        var roles = $rootScope.currentLogedInUser.authorities;
                        return !(roles.indexOf("ROLE_ADMIN") > -1);
                    }
                   }*/
        });
        /*msNavigationServiceProvider.saveItem('admin', {
            title : 'Admin',
            icon  : 'icon-account',
            state : 'app.administration',
            weight:6
        });*/
    }

})();
 (function() {
     'use strict';
     angular
         .module('app.administration')
         .controller('UMController', UMController);

     function UMController($state, $http, $scope,$compile, $mdDialog, RestAPIService, $filter, Users, DTOptionsBuilder, DTColumnDefBuilder) {
         var userCtrl = this;
         
         $scope.usersList = Users.data;
         $scope.count = Users.data.length;
         $("#vertical-navigation").hide();
         $("#content-container").css({ "margin-left": "0px" });
         userCtrl.user = {};
         //userCtrl.dtInstance = {};
         
         userCtrl.dtOptions = {
        		 
        		 dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
 	            pagingType: 'simple',
 	            autoWidth : false,
 	            responsive: true

//                 dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
//                     columnDefs: [
//
//                         { // Target the actions column
//                             targets: 6,
//                             responsivePriority: 1,
//                             filterable: false,
//                             sortable: false
//                         }
//                     ],
//
//                     pagingType: 'simple',
//                     lengthMenu: [10, 20, 30, 50, 100],
//                     pageLength: 20
//                         // scrollY     : 'auto',
//                         //responsive  : true
                 };       
         $scope.goToPreviousState = function() {
         	$state.go("app.overview");
          	$("#vertical-navigation").show();
          	$("#content-container").css({ "margin-left": "60px" });
         }
         userCtrl.getUsers = function() {
             RestAPIService.getUsers().then(
                 function(success) {
                     $scope.usersList = success.data;
                     $scope.count = $scope.usersList.length;
                 },
                 function(error) {
                     RestAPIService.showErrorDialog(error);
                 }
             );
             //return userCtrl.usersList;
         }


         //$scope.allUsers = Users.data; 

         $scope.createUserDialog = function(ev) {
             $mdDialog.show({
                 controller: CreateUserDialogController,
                 templateUrl: 'app/main/administration/user-management/users/create.user.dialog.html',
                 parent: angular.element(document.body),
                 targetEvent: ev,
                 clickOutsideToClose: true,
                 fullscreen: $scope.customFullscreen
             })
             $scope.cancel = function() {
                 $scope.user = {};
             };
         };


         function CreateUserDialogController($scope, $mdDialog) {
             $scope.status = ["True", "False"];
             $scope.roles = ["ROLE_USER", "ROLE_ADMIN"];
             $scope.user={};
             $scope.user.activated=false;
            // $scope.re = /^[a-z0-9._%+-]+@(yahoo\.com|gmail\.com|msn\.com|hotmail\.com|actiprocess\.com|smartdocsnow\.com|live\.com)/
             $scope.re = /^[a-z]+[a-z0-9._]+@[a-z]+\.[a-z.]{2,5}$/;
             $scope.hide = function() {
                 $mdDialog.hide();
             };
             $scope.cancel = function() {
                 $mdDialog.cancel();
             };
             $scope.passwordLength = 12;
             $scope.addUpper = true;
             $scope.addNumbers = true;
             $scope.addSymbols = true;

             function getRandomInt(min, max) {
               return Math.floor(Math.random() * (max - min + 1)) + min;
             }

             function shuffleArray(array) {
               for (var i = array.length - 1; i > 0; i--) {
                 var j = Math.floor(Math.random() * (i + 1));
                 var temp = array[i];
                 array[i] = array[j];
                 array[j] = temp;
               }
               return array;
             }
             $scope.createPassword = function() {
               var lowerCharacters = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
               var upperCharacters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
               var numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
               var symbols = ['!', '#', '$', '%', '&', '\'', '(', ')', '*', '+', ',', '-', '.', '/', ':', ';', '<', '=', '>', '?', '@', '[', '\\', ']', '^', '_', '`', '{', '|', '}', '~'];
               var noOfLowerCharacters = 0,
                 noOfUpperCharacters = 0,
                 noOfNumbers = 0,
                 noOfSymbols = 0;
               var noOfneededTypes = $scope.addUpper + $scope.addNumbers + $scope.addSymbols;
               var noOfLowerCharacters = getRandomInt(1, $scope.passwordLength - noOfneededTypes);
               var usedTypeCounter = 1;
               if ($scope.addUpper) {
                 noOfUpperCharacters = getRandomInt(1, $scope.passwordLength - noOfneededTypes + usedTypeCounter - noOfLowerCharacters);
                 usedTypeCounter++;
               }
               if ($scope.addNumbers) {
                 noOfNumbers = getRandomInt(1, $scope.passwordLength - noOfneededTypes + usedTypeCounter - noOfLowerCharacters - noOfUpperCharacters);
                 usedTypeCounter++;
               }
               if ($scope.addSymbols) {
                 noOfSymbols = $scope.passwordLength - noOfLowerCharacters - noOfUpperCharacters - noOfNumbers;
               }
               var passwordArray = [];
               for (var i = 0; i < noOfLowerCharacters; i++) {
                 passwordArray.push(lowerCharacters[getRandomInt(1, lowerCharacters.length - 1)]);
               }
               for (var i = 0; i < noOfUpperCharacters; i++) {
                 passwordArray.push(upperCharacters[getRandomInt(1, upperCharacters.length - 1)]);
               }
               for (var i = 0; i < noOfNumbers; i++) {
                 passwordArray.push(numbers[getRandomInt(1, numbers.length - 1)]);
               }
               for (var i = 0; i < noOfSymbols; i++) {
                 passwordArray.push(symbols[getRandomInt(1, symbols.length - 1)]);
               }
               passwordArray = shuffleArray(passwordArray);
               return passwordArray.join("");
             };
             $scope.password=$scope.createPassword();
             $scope.mypassword = "";
             $scope.showPassword = function(){
               $scope.mypassword = $scope.password;  
             };
             
         
             
          // Set the default value of inputType
             $scope.inputType = 'password';
             
             // Hide & show password function
             $scope.hideShowPassword = function(){
               if ($scope.inputType == 'password')
                 $scope.inputType = 'text';
               else
                 $scope.inputType = 'password';
             };
             
             $scope.save = function(user) {            	 	
            	 RestAPIService.createUser(user).then(
                     function(success) {
                    	 $mdDialog.hide();
                    	 RestAPIService.successTostDialog('User Created Successfully');
                    	$state.reload();
                     },
                     function(error) {
                    	 if(error.status == 400){
                    		 RestAPIService.successTostDialog(error.headers('X-smartportalApp-defaultMessage'));
                    		 
                        	 return false;  
                        	 
                         }                    	 
                      }
                    
                 );
            	 
                 
             };

         }
         $scope.resetPassword = function(ev) {
       	     // $scope.mailId=email;
        	// alert(email);
        	 var datares = $filter('filter')($scope.usersList, {'id': ev.id});
             RestAPIService.resetPassword(datares[0].email).then(
                 function(success) {
                	 //RestAPIService.successTostDialog("Reset link sent to emailId successfully");
                	 alert("Reset link sent to emailId successfully");
                     $state.reload();
                    
                 },
                 function(error) {
                     RestAPIService.showErrorDialog(error);
                 }
             );
             $mdDialog.hide();
        
     }
         userCtrl.currentUser = {};
         $scope.updateUserDialog = function(ev, user) {
        	 var datares = $filter('filter')($scope.usersList, {'id': ev.id});
             userCtrl.currentUser = angular.copy(datares[0]);
             $mdDialog.show({
                 controller: UpdateUserDialogController,
                 templateUrl: 'app/main/administration/user-management/users/update.user.dialog.html',
                 parent: angular.element(document.body),
                 targetEvent: ev,
                 clickOutsideToClose: true,
                 fullscreen: $scope.customFullscreen
             })
         };

         function UpdateUserDialogController($scope, $mdDialog) {
             $scope.status = ["true", "false"];
             $scope.roles = ["ROLE_USER", "ROLE_ADMIN"];
             $scope.currentUser = userCtrl.currentUser;

             $scope.hide = function() {
                 $mdDialog.hide();
             };
             $scope.cancel = function() {
                 $mdDialog.cancel();
             };
             $scope.update = function(user) {
                 RestAPIService.updateUser(user).then(
                     function(success) {
                    	 RestAPIService.successTostDialog('User Updated Successfully');
                    	 $state.reload();
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                     }
                 );
                 $mdDialog.hide(user);
             };
         }

         $scope.deleteUser = function(ev, user) {
        	 var datares = $filter('filter')($scope.usersList, {'id': ev.id});
             var confirm = $mdDialog.confirm()
                 .title('Remove')
                 .textContent('User ' + datares[0].firstName + ' ' + datares[0].lastName + ' will be permanently deleted. Continue ?')
                 .targetEvent(ev)
                 .ok('Ok')
                 .cancel('Cancel');
             $mdDialog.show(confirm).then(function() {

                 RestAPIService.deleteUser(datares[0].login).then(
                     function(success) {
                    	 RestAPIService.successTostDialog('User Deleted Successfully');
                         $state.reload();
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                     }
                 );
             }, function() {
                 $mdDialog.cancel();
             });
         }

     }
 })();
(function() {
     'use strict';
     angular
         .module('app.administration')
         .controller('UserUploadController', UserUploadController);
     
     
     function UserUploadController($scope, $http, RestAPIService, $mdDialog, $state, $window) {
    	 
    	 
    	 $scope.goToPreviousState = function() {
         	$state.go("app.overview");
          	$("#vertical-navigation").show();
          	$("#content-container").css({ "margin-left": "60px" });
          }
     
    	function validate(id)
    	 {
    	     var regex =/^[a-zA-Z ]*$/;
    	   

    	     if (regex.test(id)) {
    	         return true;
    	     }
    	     else {
    	         return false;
    	     }
    	 }
    	 
    	function ValidateEmail(mail)   
    	 {  
    	  if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail))  
    	   {  
    	     return (true)  
    	   }  
    	   
    	     return (false)  
    	 }  
        
    	 function allLetter(inputtxt)  
    	  {  
    	   var letters = /^[A-Za-z]+$/;  
    	   if(inputtxt.match(letters))  
    	     {  
    	      return true;  
    	     }  
    	   else  
    	     { 
    		   return false;  
    	     }  
    	  }  
    	
    	 $scope.csv = {
    	        	content: null,
    	        	header: true,
    	        	separator: ',',
    	        	result: null
    	 };
    	 $scope.$watch('csv.result', function () {
    	            $scope.IsVisible = false;
    	            $scope.savebuttonVisible =false;
    	        	$scope.users=$scope.csv.result;
    	            $scope.finalUsersList=[];
    	        	angular.forEach($scope.users, function(value, key){
    	        		
    	        		var email=value.email;
    	        		
    	        		/*if(email ==null &&email =="" && email == undefined){
	        				value['error']="Email is Mandatory";	
	        			}*/
    	        		
    	        		if(key == 0){
    	        			
    	        			var email=value.email;
    	        			
    	        			if(ValidateEmail(email)){
    	        				
    	        			}else{
    	        				$scope.IsVisible = true;
    	        				value['error']="email is wrong";
    	        			}
    	        		}else {
    	        			angular.forEach($scope.finalUsersList, function(value1, key1){
    	        			    if(value.login == value1.login){
    	        			    	
    	        			   /* 	alert(value.login  +";"+ value1.login);*/
    	        			    	
    	        			    	value['error']="login is same";
    	        			    	$scope.IsVisible = true;
    	        			    }//end if loop for login
    	        			    if(value.email == value1.email){
    	        			    	
    	        			    	if(value['error'] !=null || value['error'] !=undefined){
    	        			    	 value['error']= value['error']+"/"+"email is same";
    	        			    		//value['error']="email is same";
    	        			    		$scope.IsVisible = true;
    	        			    	}else{
    	        			    		value['error']="email is same";
    	        			    		$scope.IsVisible = true;
    	        			    	}
    	        			    }//end if loop for email
    	        		 });
    	        		}	
    	        		var email=value.email;
    	        		var firstName=value.firstName;
    	        		var lastName=value.lastName;	
    	        		if(ValidateEmail(email)){
	        				
	        			}else{
	        				if(value['error'] !=null || value['error'] !=undefined){
	        			    	 value['error']= value['error']+"/"+"Email is Wrong";
	        			    		//value['error']="email is same";
	        			    		$scope.IsVisible = true;
	        			    	}else{
	        			    		value['error']="Email is Wrong";
	        			    		$scope.IsVisible = true;
	        			    	}
	        			}
    	        		if(allLetter(firstName)){
    	        			
    	        		}else{
    	        			if(value['error'] !=null || value['error'] !=undefined){
	        			    	 value['error']= value['error']+"/"+"FirstName Supports Only Alphabets";
	        			    		//value['error']="email is same";
	        			    		$scope.IsVisible = true;
	        			    	}else{
	        			    		value['error']="FirstName Supports Only Alphabets";
	        			    		$scope.IsVisible = true;
	        			    	}
    	        		}
    	        		if(allLetter(lastName)){
    	        			
    	        		}else{
    	        			if(value['error'] !=null || value['error'] !=undefined){
	        			    	 value['error']= value['error'] +"/"+"LastName Supports Only Alphabets";
	        			    		//value['error']="email is same";
	        			    		$scope.IsVisible = true;
	        			    	}else{
	        			    		value['error']="LastName Supports Only Alphabets";
	        			    		$scope.IsVisible = true;
	        			    	}
    	        		}	
    	        			
    	        		$scope.finalUsersList.push(value);
    	        	});
        	        
    	        
    	        	 angular.forEach($scope.finalUsersList, function(value, key){
    	        		 if(value.error != null ||value.error != undefined ){
     	                	$scope.savebuttonVisible =true;
     	                }else{
     	                	$scope.savebuttonVisible =false;
     	                }
    	                
    	             });
    	        });
    	        		
	        	$scope.save = function(usersdata) {
    	        	$scope.usersList=usersdata;
    	        	console.log($scope.usersList);
   	        	    RestAPIService.createUploadUserList(usersdata).then(
    	                function(success) {
                    	RestAPIService.successTostDialog('Users Created Successfully');
                         $state.reload();
                             },
                             function(error) {
                            	 if(error.status == 400){
                            		 RestAPIService.successTostDialog(error.headers('X-smartportalApp-defaultMessage'));
                            		return false;  
                               }                    	 
                              }
                     );
	        	}
    	        
               $scope.cancel = function() {
    	        	$state.reload();
    	        }
    	        
    	        
    	        
    	        
    	        
    	        
    	        

    	 
         /*var formData = new FormData();
         $scope.setFile = function(element) {
        	 alert("hii");
             $scope.$apply(function() {
                 $scope.files = [];
                 for (var i = 0; i < element.files.length; i++) {
                     formData.append('file', element.files[i]);
                     $scope.files.push(element.files[i]);
                     
                 }
                 console.log($scope.files[0]);
                 
                 
                 RestAPIService.createUploadUser($scope.files[0]).then(
                 
                	   
                		 
                		 
                		 function(success) {
                			
                        	 RestAPIService.successTostDialog('Users Created Successfully');
                        	 $scope.files = [];
                        	 
                             $state.reload();
                         },
                         function(error) {
                        	 if(error.status == 400){
                        		 RestAPIService.successTostDialog(error.headers('X-smartportalApp-defaultMessage'));
                        		 $scope.files = [];
                            	 return false;  
                            	 
                             }                    	 
                          }
                 
                 );
                 
                 
                 
                 
             });
         };*/
     
     
     }
 })();
(function() {
    'use strict';

    angular
        .module('app.administration')
        .controller('GMController', GMController);

    /** @ngInject */
    var groupObj = {};
    function GMController($state, $http, $scope, RestAPIService, $mdDialog, Groups) {
        var groupsCtrl = this;
        groupsCtrl.hidden = false;
        groupsCtrl.isOpen = false;
        groupsCtrl.hover = false;
        $scope.viewGroupMember = false;
        groupsCtrl.allGroups = Groups.data;
        $scope.totalGroups = Groups.data.length;       
        $("#vertical-navigation").hide();
        $("#content-container").css({ "margin-left": "0px" });
        groupsCtrl.allGroups.forEach(function(group) {
            // Calling Service for getting every group data based on groupId.
            RestAPIService.getGroupMembers(group.id).then(
                function(responce) {
                    group['members'] = responce.data;
                }
            )
            group['hidden'] = false;
            group['isOpen'] = false;
            group['hover'] = false;
        })
        
        if(groupObj !={} ||groupObj != undefined){
        	$scope.groupObj = groupObj;
        } 
        
    
        $scope.getAnotherColor = function(index) {
            /*$scope.colors = ['green-bg white-fg', 'orange-bg white-fg', 'pink-bg white-fg', 'blue-grey-bg white-fg', 'back-bg white-fg'];*/
        	$scope.colors = ['#4CAF50 !important','#FF9800 !important','#E91E63 !important','#607D8B !important','#FFFFFF !important']
            var totalNoOfColors = $scope.colors.length;
            return $scope.colors[index % totalNoOfColors];
        }
        $scope.goToPreviousState = function() {
        	$state.go("app.overview");
         	$("#vertical-navigation").show();
         	$("#content-container").css({ "margin-left": "60px" });
         }
        $scope.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            columnDefs: [{ // Target the actions column
                targets: 3,
                responsivePriority: 1,
                filterable: false,
                sortable: false
            }],
            pagingType: 'simple',
            lengthMenu: [10, 20, 30, 50, 100],
            pageLength: 20
        };
        	
        
     
         
        groupsCtrl.getAllGroups = function() {
            RestAPIService.getAllGroups().then(
                function(responce) {
                    groupsCtrl.allGroups = responce.data;
                    $scope.totalGroups = responce.data.length;
                    groupsCtrl.allGroups.forEach(function(group) {
                        // Calling Service for getting every group data based on groupId.
                        RestAPIService.getGroupMembers(group.id).then(
                            function(responce) {
                                group['members'] = responce.data;
                            }
                        )
                        group['hidden'] = false;
                        group['isOpen'] = false;
                        group['hover'] = false;
                    })
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );
        }

        groupsCtrl.selectGroup = function(eachGroup) {
            $scope.viewGroupMember = true;
            $scope.groupObj = eachGroup;
        }

        $scope.goBackToGroup = function() {
            $scope.viewGroupMember = false;
        }


        $scope.$watch('eachGroup.isOpen', function(isOpen) {
            if (isOpen) {
                $timeout(function() {
                    $scope.tooltipVisible = isOpen;
                }, 600);
            } else {
                $scope.tooltipVisible = isOpen;
            }
        });

        groupsCtrl.getAnotherColor = function(index) {
            // md-hue's are written for lighten the colors.
            groupsCtrl.colors = ['md-blue-grey-bg', 'md-warn md-hue-3', 'md-accent md-hue-3', 'md-primary md-hue-3', 'md-light-green-bg'];
            var totalNoOfColors = groupsCtrl.colors.length;
            return groupsCtrl.colors[index % totalNoOfColors];
        }

        groupsCtrl.deleteGroupMember = function(groupData, i) {
            var groupData = groupData;
            var groupId = groupData.id;
            var login = groupData.members[i].login;
            var name = groupData.members[i].firstName + " " + groupData.members[i].lastName;
            var groupName = groupData.name;
            var confirm = $mdDialog.confirm()
                .title('Remove')
                .textContent(name + ' will be removed from ' + groupName + ' , continue ?')
                //.targetEvent(ev)
                .ok('Ok')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                RestAPIService.deleteGroupMember(groupId, login).then(
                    function(responce) {
                        // Refresh the data after deleting.                        
                        //$state.reload();
                    	 RestAPIService.successTostDialog('Member Deleted Successfully');
                        RestAPIService.getGroupMembers(groupId).then(
                            function(responce) {
                                groupData['members'] = responce.data;
                            }
                        )
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
            }, function() {
                //User clicked Cancel. Close the popup
            });
        }

        groupsCtrl.deleteGroup = function(groupData) {
            var groupId = groupData.id;
            var confirm = $mdDialog.confirm()
                .title('Remove')
                .textContent(groupData.name + ' group will be removed, continue ?')
                //.targetEvent(ev)
                .ok('Ok')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                //Deleting the group
                RestAPIService.deleteGroup(groupId).then(
                    function(success) {
                        //Group Successfully deleted. Need to refresh through GET call                           
                        //$state.reload();
                    	RestAPIService.successTostDialog('Group Deleted Successfully');
                        groupsCtrl.getAllGroups();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
            }, function() {
                //User clicked Cancel. Close the popup
            });
        }

        groupsCtrl.createGroupDialog = function(ev) {
            $mdDialog.show({
                    controller: CreateGroupDialogController,
                    templateUrl: 'app/main/administration/user-management/groups/createGroupDialog.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })
                .then(function(answer) {

                }, function() {

                });
        }

        function CreateGroupDialogController($scope, $mdDialog) {
            $scope.close = function() {
                $mdDialog.cancel();
            }

            $scope.cancel = function() {
                $scope.group = {};
                $mdDialog.cancel();
            }

            $scope.createGroup = function(groupData) {
                RestAPIService.createGroup(groupData).then(
                    function(success) {
                        $mdDialog.show(
                            $mdDialog.alert()
                            .parent(angular.element(document.querySelector('#popupContainer')))
                            .clickOutsideToClose(true)
                            .textContent('You have successfully created a ' + groupData.name + ' Group .')
                            .ok('Ok')
                        );

                        //                        $state.reload();
                        groupsCtrl.getAllGroups();
                    },
                    function(error) {
                    	$mdDialog.show(
                                $mdDialog.alert()
                                .clickOutsideToClose(true)
                                .title('Error')
                                .textContent(error.data.description)
                                .ok('Ok')
                            );
                       /* RestAPIService.showErrorDialog(error);*/
                    }
                );
                $mdDialog.hide(groupData);
            };
        }
        
        groupsCtrl.currentGroup = {};
        groupsCtrl.editGroup = function(ev, group) {
            groupsCtrl.currentGroup = angular.copy(group);
            $mdDialog.show({
                controller: EditGroupDialogController,
                templateUrl: 'app/main/administration/user-management/groups/editGroupDialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        };

        function EditGroupDialogController($scope, $mdDialog) {
        	 $scope.close = function() {
                 $mdDialog.cancel();
             }
        
            $scope.currentGroup = groupsCtrl.currentGroup;

            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.EditGroup = function(group) {
            RestAPIService.editGroup(group).then(
                    function(success) {
                   	 RestAPIService.successTostDialog("Group Updated Successfully");
                        $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide(group);
            };
        }

        groupsCtrl.addMemberDialog = function(ev, groupData) {
            groupsCtrl.groupId = groupData.id;
            //alert(groupsCtrl.groupId);
            $mdDialog.show({
                    controller: addGroupMemberController,
                    templateUrl: 'app/main/administration/user-management/groups/addGroupMemberDialog.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })
                .then(function(answer) {

                }, function() {

                });
        }

        function addGroupMemberController($scope, $mdDialog,$location,$window) {
        	
            $scope.searchMember = function(memberdata) {
                var q = "";
                var type="user"
                if (memberdata == undefined || angular.equals(memberdata, {})) {
                    $scope.msgVisibility = true;
                    $scope.tableVisibility = false;
                    $scope.member = {};
                } else {
                    if ((memberdata.name != "" && memberdata.name != undefined) && (memberdata.email != "" && memberdata.email != undefined)) {
                        q = memberdata.name;
                    } else if ((memberdata.name == "" || memberdata.name == undefined) && (memberdata.email != "" && memberdata.email != undefined)) {
                        q = memberdata.email;
                    } else if (memberdata.name != "" && (memberdata.email == "" || memberdata.email == undefined)) {
                        q = memberdata.name;
                    }
                    $scope.searchedMembers = [];
                    RestAPIService.searchMemberForGroups(q,type).then(
                        function(success) {
                        	$scope.searchedMembers = success.data;
                            
                            $scope.msgVisibility = false;
                            $scope.tableVisibility = true;
                            $scope.member = {};
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        }
                    );
                }
            }

            $scope.addGroupMember = function(memberdata) {
                var groupId = groupsCtrl.groupId;
                RestAPIService.addGroupMember(memberdata, groupId).then(
                    function(responce) {
                    	 RestAPIService.successTostDialog('User'+' '+ memberdata.login +' '+'added Successfully');
                                RestAPIService.getGroupMembers(groupId).then(
                                        function(responce) {
                                        	groupObj.members =responce.data;
                                        	
                                        },
                                        function(error) {
                                            RestAPIService.showErrorDialog(error);
                                        }
                                    );
                    	 
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
            }

            $scope.cancel = function(memberdata) {
                $scope.member = {};
                $scope.tableVisibility = false;
                $scope.searchedMembers = [];
                //$scope.width=25;
                $scope.msgVisibility = false;
                $mdDialog.cancel();
            }
            $scope.ok = function() {           
                $mdDialog.cancel();
                $state.reload();               
                
            }

        }

    }


})();
(function ()
{
    'use strict';

    angular
        .module('app.administration')
        .controller('LMAINController', LMAINController);

    /** @ngInject */
    function LMAINController($state, $scope,$mdDialog,RestAPIService,$stateParams)
    {
        var listmainCtrl = this;
        listmainCtrl.pageNumber = 0;
        listmainCtrl.pageSize = 10;
        $scope.showrowdata = true;
        $scope.attributes ={};
        $scope.dataflag = true;
        $("#vertical-navigation").hide();
        $("#content-container").css({ "margin-left": "0px" });

        $scope.goToPreviousState = function() {
        	$state.go("app.overview");
         	$("#vertical-navigation").show();
         	$("#content-container").css({ "margin-left": "0px" });
         }
        
        listmainCtrl.next = function() {
        	listmainCtrl.pageNumber = listmainCtrl.pageNumber + 1;
        	$scope.getlistdata();
        }
        listmainCtrl.previous = function() {
        	listmainCtrl.pageNumber = listmainCtrl.pageNumber - 1;
        	$scope.getlistdata();
        }
        $scope.sendPageNumber = function(pageNumber) {
        	listmainCtrl.pageNumber = pageNumber;
        	$scope.getlistdata();
        }
        
        $scope.goback = function(){
        	$state.transitionTo($state.current, $stateParams, {
        	    reload: true,
        	    inherit: false,
        	    notify: true
        	});
        }
        
       /* listmainCtrl.dtOptions = {
                dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                autoWidth: false,
                responsive: true,
            };*/
        

        
            RestAPIService.getlistdata().then(
                function(success) {
                    $scope.listdata = success.data;

                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );
          
           $scope.getlistdata = function(){
        	   RestAPIService.getdetaildata($scope.listname).then(
                       function(success) {
                     	  if((success.data !=null || success.data !=undefined) && success.data.length > 0)
                     		  {
                     		  $scope.tdata = success.data;
                     		  for(var obj in success.data){
                     			    if(success.data.hasOwnProperty(obj)){
                     			    for(var prop in success.data[obj]){
                     			        if(success.data[obj].hasOwnProperty(prop)){
                     			         if ($.inArray(prop, $scope.dynamicdata1) === -1) {
                     			        	 $scope.dynamicdata1.push(prop);
                     			         }
                     			        } 
                     			    }
                     			}
                     			}
                     		 listmainCtrl.numberOfElements = success.headers('x-total-count');
                                $scope.noOfPages = listmainCtrl.numberOfElements / listmainCtrl.pageSize;
                                $scope.pageNumbers = [];
                                if ($scope.noOfPages > 0) {
                                    for (var i = 0; i < $scope.noOfPages; i++) {
                                        $scope.pageNumbers.push(i);
                                    }
                                }
                     		  }else
                     			  {
                     			  $scope.dynamicdata1 = undefined;
                     			  }

                       },
                       function(error) {
                           RestAPIService.showErrorDialog(error);
                       }
                   );
           }
           
           
            $scope.showdetail = function(list){
            	$scope.listdatause = list;
            	$scope.dynamicdata1 = [];
            	 $scope.showrowdata = false;
                
               $scope.listname = list.name;
               $scope.getlistdata();
               $scope.formatHeaders = function(headers) {
                    for(var i=0,len=headers.length,formattedHeaders=[]; i<len; i++){
                        formattedHeaders.push({ "title" : headers[i] });
                    };
                    return formattedHeaders;
                };
                
                $scope.dtoption2 = {
              		  dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                        pagingType: 'simple',
                        lengthChange: false,
                        autoWidth: false,
                        responsive: false,
              }
                
            }
            
            $scope.createlistmaintenanace = function(ev,list) {
            	listmainCtrl.listdatadata = $scope.listdatause;
                $mdDialog.show({
                    controller: ListMaincontroller,
                    templateUrl: 'app/main/administration/list-management/list-maintenance/createlist-maintenanace-dialog.html', 
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: $scope.customFullscreen
                })
            };
            $scope.deletedata = function(ev, data){
         	   RestAPIService.deletedata(data._id,$scope.listdatause.name).then(
                        function(success) {
                            RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                            $state.reload();
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        }
                    );
         	   $mdDialog.hide(data);
           }
            $scope.updatedataDialog = function(ev, detaildata) {
            	listmainCtrl.updatedata = detaildata;
                  $mdDialog.show({
                      controller: UpdatelistMaincontroller,
                      templateUrl: 'app/main/administration/list-management/list-maintenance/updatelistmaintenance-dialog.html',
                      parent: angular.element(document.body),
                      targetEvent: ev,
                      fullscreen: $scope.customFullscreen
                  })
              };
              
              function UpdatelistMaincontroller($scope, $mdDialog){
            	  $scope.currentdata = listmainCtrl.updatedata;
            	  $scope.updateddata = [];
           	   var udata =[];
           	   var pmap = {};
                  $scope.hide = function() {
                      $mdDialog.hide();
                  };
                  $scope.cancel = function() {
                      $mdDialog.cancel();
                  };

            	   var valarr = [];
                  $scope.updatedata = function() {
                   angular.forEach($scope.currentdata, function(value, key){
          	      valarr.push(key);
          	      });
         		  for(var i=0; i<$scope.updateddata.length; i++){
          			  if(valarr[i] !="_id"){
          				pmap[valarr[i]] = $scope.updateddata[i];
          			  }
            		} 
                   udata.push({"productMap":pmap});
                   $scope.arrsend = udata[0];
                   $scope.arrsend.id = $scope.updateddata[0];
                   $scope.arrsend.name = listmainCtrl.listname;
                      RestAPIService.updatedyData($scope.arrsend).then(
                          function(success) {
                              RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                              $state.reload();
                          },
                          function(error) {
                              RestAPIService.showErrorDialog(error);
                          }
                      );
                      $mdDialog.hide(udata);
                  };
                  
              }
              
              
              
            function ListMaincontroller($scope, $mdDialog){
            	$scope.attrdata = 	listmainCtrl.listdatadata.attributes;
            	$scope.crlist=[];
                $scope.hide = function() {
                    $mdDialog.hide();
                };
                $scope.cancel = function() {
                    $mdDialog.cancel();
                };
                
                
                $scope.save =function(){
              	  var t = $scope.attrdata;
              	  var uniqueNames=[];
              	  var uniqueNames1 = [];
              	  var obj ={};
              	  var ary=[];
              	  for(var i=0; i<t.length; i++){
              		  obj[t[i].fieldname] = $scope.crlist[i].list;
              		}
                    
              	  ary.push({"productMap":obj});
              	  ary.name = $scope.attrdata.name;
                     $scope.arr1 = ary[0];
                     $scope.arr1.name = listmainCtrl.listdatadata.name;
                    RestAPIService.createdetail($scope.arr1).then(
                            function(success) {
                                $state.reload();
                            },
                            function(error) {
                                RestAPIService.showErrorDialog(error);
                            }
                        );
                        $mdDialog.hide();
                        $mdDialog.show(
                            $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('Success!')
                            .textContent('Data of ' + $scope.arr1.name + ' has been successfully updated')
                            .ok('Ok')
                        );
                        
                }
            }

        }
 })();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.user-management', ['datatables', 'ngResource','nvd3'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
       //$scope.updateUser = {};
        $stateProvider
            .state('app.user-management', {
                abstract: true
                //url     : '/user-management'
            })
            
            // .state('app.user-management.create-user',{
                
            //     url: '/create-user',
            //     views: {
            //         'content@app': {
            //             templateUrl: 'app/main/user-management/create-user/create-user.html',
            //             controller: 'UserController as createUserCtrl'
            //         }
            //     }

            // })
            // .state('app.user-management.update-user',{
                
            //     url: '/update-user:id',
            //     views: {
            //         'content@app': {
            //             templateUrl: 'app/main/user-management/update-user/update-user.html',
            //             controller: 'UpdateUserController'
            //         }
            //     }

            // })          
            
            .state('app.user-management.usersDetails',{
                
                url: '/users',
                views: {
                    'content@app': {
                        templateUrl: '/app/main/user-management/users/users.html',
                        controller: 'UserController as userCtrl'
                    }
                }

                ,
                resolve : {
                    RestAPIService: 'RestAPIService',
                    Users:  function(RestAPIService){
                        return RestAPIService.getUsers();
                    }
                }
                


            }) 
            .state('app.user-management.groups',{
                
                url: '/groups',
                views: {
                    'content@app': {
                        templateUrl: '/app/main/user-management/groups/groups.html',
                        controller: 'GroupsController as groupsCtrl'
                    }
                },
                resolve : {
                    RestAPIService : 'RestAPIService',
                    Groups: function(RestAPIService){
                        return RestAPIService.getAllGroups();
                    }
                }
                

            }) 
             /*.state('app.lists-management',{
                
                url: '/lists-management',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pages/errors/404/error-404.html',
                        controller: 'Error404Controller as cf'
                    }
                }
                 }); */
          
          
      /*  msNavigationServiceProvider.saveItem('admin.user-management', {
            title : 'User Management',
            icon  : 'icon-account-circle',
            weight: 1
        });   
        
        msNavigationServiceProvider.saveItem('admin.user-management.usersDetails', {
            title: 'Users',
            state: 'app.user-management.usersDetails'
        });
        msNavigationServiceProvider.saveItem('admin.user-management.groups', {
            title: 'Groups',
            state: 'app.user-management.groups'
        });*/
       /* msNavigationServiceProvider.saveItem('admin.lists-management', {
            title: 'Lists-management',
            icon:'icon-view-list'
            state: 'app.lists-management',
            weight: 3
            });*/


    }
})();
 (function() {
     'use strict';
     angular
         .module('app.user-management')
         .controller('UserController', UserController);

     function UserController($state, $http, $scope, $mdDialog, RestAPIService, Users) {
         var userCtrl = this;

         $scope.usersList = Users.data;
         $scope.count = Users.data.length;
          userCtrl.goToAdmin = function(){
            $state.go('app.admin');
        }
        userCtrl.goToAdminuser = function(){
            $state.go('app.adminuser');
        }


         userCtrl.user = {};
         //userCtrl.dtInstance = {};
         userCtrl.dtOptions = {

             dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
             columnDefs: [

                 { // Target the actions column
                     targets: 6,
                     responsivePriority: 1,
                     filterable: false,
                     sortable: false
                 }
             ],

             pagingType: 'simple',
             lengthMenu: [10, 20, 30, 50, 100],
             pageLength: 20
                 // scrollY     : 'auto',
                 //responsive  : true
         };

         userCtrl.getUsers = function() {
             RestAPIService.getUsers().then(
                 function(success) {                     
                     $scope.usersList = success.data;
                     $scope.count = $scope.usersList.length;
                 },
                 function(error) {
                     RestAPIService.showErrorDialog(error);
                 }
             );
             //return userCtrl.usersList;
         }


         //$scope.allUsers = Users.data; 

         $scope.createUserDialog = function(ev) {
             $mdDialog.show({
                 controller: CreateUserDialogController,
                 templateUrl: 'app/main/user-management/users/create.user.dialog.html',
                 parent: angular.element(document.body),
                 targetEvent: ev,
                 clickOutsideToClose: true,
                 fullscreen: $scope.customFullscreen
             })
             $scope.cancel = function() {
                 $scope.user = {};
             };
         };


         function CreateUserDialogController($scope, $mdDialog) {
             $scope.status = ["True", "False"];
             $scope.roles = ["ROLE_USER", "ROLE_ADMIN"];

             $scope.hide = function() {
                 $mdDialog.hide();
             };
             $scope.cancel = function() {
                 $mdDialog.cancel();
             };

             $scope.save = function(user) {
                 RestAPIService.createUser(user).then(
                     function(success) {
                         //Create successful. Need to refresh
                         $state.reload();
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                     }
                 );
                 $mdDialog.hide(user);
             };

         }

         userCtrl.currentUser = {};
         $scope.updateUserDialog = function(ev, user) {
             userCtrl.currentUser = angular.copy(user);
             $mdDialog.show({
                 controller: UpdateUserDialogController,
                 templateUrl: 'app/main/user-management/users/update.user.dialog.html',
                 parent: angular.element(document.body),
                 targetEvent: ev,
                 clickOutsideToClose: true,
                 fullscreen: $scope.customFullscreen
             })
         };

         function UpdateUserDialogController($scope, $mdDialog) {
             $scope.status = ["true", "false"];
             $scope.roles = ["ROLE_USER", "ROLE_ADMIN"];
             $scope.currentUser = userCtrl.currentUser;

             $scope.hide = function() {
                 $mdDialog.hide();
             };
             $scope.cancel = function() {
                 $mdDialog.cancel();
             };
             $scope.update = function(user) {
                 RestAPIService.updateUser(user).then(
                     function(success) {
                         //Update successful. Need to refresh
                         $state.reload();
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                     }
                 );
                 $mdDialog.hide(user);
             };
         }

         userCtrl.deleteUser = function(ev, user) {
             var confirm = $mdDialog.confirm()
                 .title('Remove')
                 .textContent('User ' + user.firstName + ' ' + user.lastName + ' will be permanently deleted. Continue ?')
                 .targetEvent(ev)
                 .ok('Ok')
                 .cancel('Cancel');
             $mdDialog.show(confirm).then(function() {

                 RestAPIService.deleteUser(user.login).then(
                     function(success) {
                         //delete successful. Need to refresh
                         $state.reload();
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                     }
                 );
             }, function() {
                 $mdDialog.cancel();
             });
         }

     }
 })();
(function() {
    'use strict';

    angular
        .module('app.user-management')
        .controller('GroupsController', GroupsController);

    /** @ngInject */
    function GroupsController($state, $http, $scope, RestAPIService, $mdDialog, Groups) {
        var groupsCtrl = this;
        groupsCtrl.hidden = false;
        groupsCtrl.isOpen = false;
        groupsCtrl.hover = false;

        groupsCtrl.allGroups = Groups.data;
        $scope.totalGroups = Groups.data.length;

        groupsCtrl.allGroups.forEach(function(group) {
            // Calling Service for getting every group data based on groupId.
            RestAPIService.getGroupMembers(group.id).then(
                function(responce) {
                    group['members'] = responce.data;
                }
            )
            group['hidden'] = false;
            group['isOpen'] = false;
            group['hover'] = false;
        })

        groupsCtrl.goToAdmin = function(){
            $state.go('app.admin');
        }
        groupsCtrl.goToAdminuser = function(){
            $state.go('app.adminuser');
        }

        groupsCtrl.getAllGroups = function() {
            RestAPIService.getAllGroups().then(
                function(responce) {
                    groupsCtrl.allGroups = responce.data;
                    $scope.totalGroups = responce.data.length;
                    groupsCtrl.allGroups.forEach(function(group) {
                        // Calling Service for getting every group data based on groupId.
                        RestAPIService.getGroupMembers(group.id).then(
                            function(responce) {
                                group['members'] = responce.data;
                            }
                        )
                        group['hidden'] = false;
                        group['isOpen'] = false;
                        group['hover'] = false;
                    })
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );
        }

        

        $scope.$watch('eachGroup.isOpen', function(isOpen) {
            if (isOpen) {
                $timeout(function() {
                    $scope.tooltipVisible = isOpen;
                }, 600);
            } else {
                $scope.tooltipVisible = isOpen;
            }
        });

        groupsCtrl.getAnotherColor = function(index) {
            // md-hue's are written for lighten the colors.
            groupsCtrl.colors = ['md-blue-grey-bg', 'md-warn md-hue-3', 'md-accent md-hue-3', 'md-primary md-hue-3', 'md-light-green-bg'];
            var totalNoOfColors = groupsCtrl.colors.length;
            return groupsCtrl.colors[index % totalNoOfColors];
        }

        groupsCtrl.deleteGroupMember = function(groupData, i) {
            var groupData = groupData;
            var groupId = groupData.id;
            var login = groupData.members[i].login;
            var name = groupData.members[i].firstName + " " + groupData.members[i].lastName;
            var groupName = groupData.name;
            var confirm = $mdDialog.confirm()
                .title('Remove')
                .textContent(name + ' will be removed from '+groupName+' , continue ?')
                //.targetEvent(ev)
                .ok('Ok')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                RestAPIService.deleteGroupMember(groupId, login).then(
                    function(responce) {
                        // Refresh the data after deleting.                        
                        //$state.reload();
                        RestAPIService.getGroupMembers(groupId).then(
                            function(responce) {                               
                                groupData['members'] = responce.data;
                            }
                        )
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
            }, function() {
                //User clicked Cancel. Close the popup
            });
        }

        groupsCtrl.deleteGroup = function(groupData) {
            var groupId = groupData.id;
            var confirm = $mdDialog.confirm()
                .title('Remove')
                .textContent(groupData.name + ' group will be removed, continue ?')
                //.targetEvent(ev)
                .ok('Ok')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                //Deleting the group
                RestAPIService.deleteGroup(groupId).then(
                    function(success) {
                        //Group Successfully deleted. Need to refresh through GET call                           
                        //$state.reload();
                        groupsCtrl.getAllGroups();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
            }, function() {
                //User clicked Cancel. Close the popup
            });
        }

        groupsCtrl.createGroupDialog = function(ev) {
            $mdDialog.show({
                    controller: CreateGroupDialogController,
                    templateUrl: 'app/main/user-management/groups/createGroupDialog.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })
                .then(function(answer) {
                    
                }, function() {
                    
                });
        }

        function CreateGroupDialogController($scope, $mdDialog) {
            $scope.close = function() {
                $mdDialog.cancel();
            }

            $scope.cancel = function() {
                $scope.group = {};
                $mdDialog.cancel();
            }

            $scope.createGroup = function(groupData) {
                RestAPIService.createGroup(groupData).then(
                    function(success) {
                        $mdDialog.show(
                            $mdDialog.alert()
                            .parent(angular.element(document.querySelector('#popupContainer')))
                            .clickOutsideToClose(true)
                            .textContent('You have successfully created a ' + groupData.name + ' Group .')
                            .ok('Ok')
                        );
                        
                        //$state.reload();
                        groupsCtrl.getAllGroups();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide(groupData);
            };
        }

        groupsCtrl.addMemberDialog = function(ev, groupData) {
            groupsCtrl.groupId = groupData.id;
            //alert(groupsCtrl.groupId);
            $mdDialog.show({
                    controller: addGroupMemberController,
                    templateUrl: 'app/main/user-management/groups/addGroupMemberDialog.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })
                .then(function(answer) {
                    
                }, function() {
                   
                });
        }

        function addGroupMemberController($scope, $mdDialog) {
            $scope.searchMember = function(memberdata) {
                var q = "";
                if (memberdata == undefined || angular.equals(memberdata, {})) {
                    $scope.msgVisibility = true;
                    $scope.tableVisibility = false;
                    $scope.member = {};
                } else {
                    if ((memberdata.name != "" && memberdata.name != undefined) && (memberdata.email != "" && memberdata.email != undefined)) {
                        q = memberdata.name;
                    } else if ((memberdata.name == "" || memberdata.name == undefined) && (memberdata.email != "" && memberdata.email != undefined)) {
                        q = memberdata.email;
                    } else if (memberdata.name != "" && (memberdata.email == "" || memberdata.email == undefined)) {
                        q = memberdata.name;
                    }
                    $scope.searchedMembers = [];
                    RestAPIService.searchMemberForGroups(q).then(
                        function(success) {
                            $scope.searchedMembers = success.data;
                            $scope.msgVisibility = false;
                            $scope.tableVisibility = true;
                            $scope.member = {};
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        }
                    );
                }
            }

            $scope.addGroupMember = function(memberdata) {
                var groupId = groupsCtrl.groupId;                
                RestAPIService.addGroupMember(memberdata, groupId).then(
                    function(responce) {                        
                        //$state.reload();
                        groupsCtrl.getAllGroups();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
            }

            $scope.cancel = function(memberdata) {
                $scope.member = {};
                $scope.tableVisibility = false;
                $scope.searchedMembers = [];
                //$scope.width=25;
                $scope.msgVisibility = false;
                $mdDialog.cancel();
            }

            $scope.ok = function() {
                
                $mdDialog.cancel();
            }

        }



        groupsCtrl.groupStatGraphData = {
        "title": "Group Statistics",
        "ranges": {
            "TW": "This Week",
            "LW": "Last Week",
            "2W": "2 Weeks Ago"
        },
        "mainChart": [
            {
                "key": "Portal Admin",
                "values": {
                    "2W": [
                        {"x": "Group1", "y": 9},
                        {"x": "Group2", "y": 12},
                        {"x": "Group3", "y": 9},
                        {"x": "Group4", "y": 12},
                        {"x": "Group5", "y": 7},
                        {"x": "Group6", "y": 8},
                        {"x": "Group7", "y": 16}
                    ],
                    "LW": [
                        {"x": "Group1", "y": 12},
                        {"x": "Group2", "y": 8},
                        {"x": "Group3", "y": 7},
                        {"x": "Group4", "y": 13},
                        {"x": "Group5", "y": 7},
                        {"x": "Group6", "y": 6},
                        {"x": "Group7", "y": 10}
                    ],
                    "TW": [
                        {"x": "Group1", "y": 11},
                        {"x": "Group2", "y": 10},
                        {"x": "Group3", "y": 8},
                        {"x": "Group4", "y": 11},
                        {"x": "Group5", "y": 8},
                        {"x": "Group6", "y": 10},
                        {"x": "Group7", "y": 17}
                    ]
                }
            },
            {
                "key": "Portal User",
                "values": {
                    "2W": [
                        {"x": "Group1", "y": 37},
                        {"x": "Group2", "y": 32},
                        {"x": "Group3", "y": 39},
                        {"x": "Group4", "y": 27},
                        {"x": "Group5", "y": 18},
                        {"x": "Group6", "y": 24},
                        {"x": "Group7", "y": 20}
                    ],
                    "LW": [
                        {"x": "Group1", "y": 37},
                        {"x": "Group2", "y": 24},
                        {"x": "Group3", "y": 51},
                        {"x": "Group4", "y": 31},
                        {"x": "Group5", "y": 29},
                        {"x": "Group6", "y": 17},
                        {"x": "Group7", "y": 31}
                    ],
                    "TW": [
                        {"x": "Group1", "y": 42},
                        {"x": "Group2", "y": 28},
                        {"x": "Group3", "y": 43},
                        {"x": "Group4", "y": 34},
                        {"x": "Group5", "y": 20},
                        {"x": "Group6", "y": 25},
                        {"x": "Group7", "y": 22}
                    ]
                }
            }
        ]
    };



       
        groupsCtrl.groupStatGraph = {
            title       : groupsCtrl.groupStatGraphData.title,
            mainChart   : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type        : 'multiBarChart',
                        //color       : ['#03a9f4', '#b3e5fc'],
                        color       : ['#78909c', '#cfd8dc'],
                        
                        height      : 320,
                        margin      : {
                            top   : 8,
                            right : 16,
                            bottom: 32,
                            left  : 32
                        },
                        clipEdge    : true,
                        groupSpacing: 0.3,
                        reduceXTicks: false,
                        stacked     : false,
                        duration    : 250,
                        x           : function (d)
                        {
                            return d.x;
                        },
                        y           : function (d)
                        {
                            return d.y;
                        },
                        yAxis       : {
                            tickFormat: function (d)
                            {
                                return d;
                            }
                        },
                        legend      : {
                            margin: {
                                top   : 8,
                                bottom: 32
                            }
                        },
                        controls    : {
                            margin: {
                                top   : 8,
                                bottom: 32
                            }
                        },
                        tooltip     : {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data   : []
            },
            ranges      : groupsCtrl.groupStatGraphData.ranges,
            currentRange: '',

            days        : ['Group1', 'Group2', 'Group3', 'Group4', 'Group5', 'Group6', 'Group7'],
            changeRange : function (range)
            {
                
                 /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                angular.forEach(groupsCtrl.groupStatGraphData.mainChart, function (chartData, index)
                {
                    groupsCtrl.groupStatGraph.mainChart.data[index] = {
                        key   : chartData.key,
                        values: chartData.values[range]
                    };
                });

                //alert(groupsCtrl.groupStatGraph.mainChart.data.length);
                
            },
            init        : function ()
            {
                
                groupsCtrl.groupStatGraph.changeRange('TW');
            }
        };

        groupsCtrl.groupStatGraph.init();
    }


})();
(function() {
    'use strict';

    var app = angular
        .module('app.smartstore-admin', [])
        .run(run)
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider, $controllerProvider, $compileProvider, $filterProvider, $provide) {
        app.controller = $controllerProvider.register;
        app.directive = $compileProvider.directive;
        app.filter = $filterProvider.register;
        app.factory = $provide.factory;
        app.service = $provide.service;

        $stateProvider
            .state('app.smartstore-admin', {
                url: '/smartportal/smartstore',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/smartstore-admin/smartstore-admin.html',
                        controller: 'SmartstoreController as smartstoreCtrl'
                    }
                }
            })
             .state('app.smartstore-admin.companies', {
                url: '/companies',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/smartstore-admin/companies/companies.html',
                        controller: 'CompanyController as companyCtrl'
                    }
                },
                resolve: {
                   RestAPIService: 'RestAPIService',
                    Companies: function(RestAPIService) {
                        return RestAPIService.getCompanies();
                    }
                }
            })
             .state('app.smartstore-admin.mimetype', {
                url: '/mimetype',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/smartstore-admin/mimetype/mimetype.html',
                        controller: 'MimeTypeController as mimetypeCtrl'
                    }
                },
                resolve: {
                    RestAPIService: 'RestAPIService',
                    MimeTypes: function(RestAPIService) {
                        return RestAPIService.getMimeTypes();
                    }
                }
            })
             .state('app.smartstore-admin.systems', {
                url: '/systems',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/smartstore-admin/systems/systems.html',
                        controller: 'SystemController as systemCtrl'
                    }
                },
                resolve: {
                	RestAPIService: 'RestAPIService',
                    Systems: function(RestAPIService) {
                        return RestAPIService.getSystems();
                    },
                   
                    Repositories: function(RestAPIService) {
                        return RestAPIService.getRepositories();
                    },
                   
                    Companies: function(RestAPIService) {
                        return RestAPIService.getCompanies();
                    }
                }
            })
            .state('app.smartstore-admin.repository', {
                url: '/repositories',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/smartstore-admin/Repositories/preview.repository.html',
                        controller: 'RepositoryController as repCtrl'
                    }
                },
                resolve: {
                    RestAPIService: 'RestAPIService',
                    Repositories: function(RestAPIService) {
                        return RestAPIService.getRepositories();
                    }
                }
            })

          

      
    }
    
    function run(msNavigationService, $localStorage, $rootScope, $state) {
        // Navigation
    	 $rootScope.$state = $state;
         msNavigationService.saveItem('SmartStore', {
             title: 'SAdmin',
             icon: 'icon-account-network',
             state: 'app.smartstore-admin',
             weight: 10
            /* hidden: function() {                 
            	 if ($localStorage.menubarsetting != undefined) {
                     var show = $localStorage.menubarsetting.reports;
                     return !(show);
                 }
                }*/
         });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.smartstore-admin')
        .controller('SystemController', SystemController);

    
    function SystemController($state,$scope,$filter,$mdDialog,Systems,RestAPIService,Repositories,Companies, $rootScope)
    {
    	var systemCtrl =this;
        $scope.showRepos = false;
    	$scope.SmartstoreSystems =Systems.data;
    	systemCtrl.dtOptions = { 
         		 dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
	            pagingType: 'simple',
	            autoWidth : false,
	            responsive: true
        };
    	
        systemCtrl.goToMain =function(){
            $state.go('app.smartstore-admin');
        }
        $scope.gotoSystems = function(){
            $scope.showRepos = !$scope.showRepos;
        }
        $scope.selectSystem = function(systemData){
            $scope.showRepos = true;
            $rootScope.systemId = systemData.id;
            RestAPIService.getsystemRepos(systemData.id).then(
                function(success) {
                    $scope.repositoriesList = success.data;                               
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );
           
        }
        

         $scope.DisplaySystemDialog = function(ev,system) {
             systemCtrl.currentSystem = angular.copy(system);
            $mdDialog.show({
                controller: DisplaySystemDialogController,
                templateUrl: 'app/main/smartstore-admin/systems/display.system.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
            $scope.cancel = function() {

            };
        }
        
        function DisplaySystemDialogController($scope, $mdDialog, RestAPIService) {
            $scope.currentSystem = systemCtrl.currentSystem;  
             $scope.currentSystem.expiration = new Date($scope.currentSystem.expiration);
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };   
            
        }
    	 $scope.createSystemDialog = function(ev) {
             $mdDialog.show({
                 controller: createSystemDialogController,
                 templateUrl: 'app/main/smartstore-admin/systems/create.system.html',  
                 parent: angular.element(document.body),
                 targetEvent: ev,
                 clickOutsideToClose: true,
                 fullscreen: $scope.customFullscreen
             })
             $scope.cancel = function() {

             };
         }
         
       
         function createSystemDialogController($scope, $mdDialog, RestAPIService)
         {   
        	 $scope.types=["R5-based","SAP","Others"];
        	 $scope.SystemRepositories =Repositories.data;
        	 $scope.Systemcompanies=Companies.data;
         	
        	 $scope.cancel = function() {
                 $mdDialog.cancel();
             };
             $scope.save = function(system) {   
            	 // delete system.repository['$$hashKey'];
                 RestAPIService.createSystem(system).then(
                             function(success) {
                                RestAPIService.successTostDialog("System Created successfully ");
                               $state.reload();
                             },
                             function(error) {
                            	 RestAPIService.showErrorDialog(error);
                             }
                         );
                         $mdDialog.hide(system);
                               
                 };            
         }
         
         
         $scope.updateSystemDialog = function(ev, system) {
        	 systemCtrl.currentSystem = angular.copy(system);
             $mdDialog.show({
                 controller: updateSystemDialogController,
                 templateUrl: 'app/main/smartstore-admin/systems/update.system.html',
                 parent: angular.element(document.body),
                 targetEvent: ev,
                 clickOutsideToClose: true,
                 fullscreen: $scope.customFullscreen
             })
         };
         
         
         function updateSystemDialogController($scope, $mdDialog, RestAPIService)
         {
        	 $scope.currentSystem =systemCtrl.currentSystem;
             $scope.currentSystem.expiration = new Date($scope.currentSystem.expiration);
        	 $scope.types=["R5-based","SAP","Others"];
        	 $scope.SystemRepositories =Repositories.data;
        	 $scope.Systemcompanies=Companies.data;
        	 
        	 $scope.update = function(system) {
        		 // delete system.repository['$$hashKey'];
           	  RestAPIService.updateSystem(system).then(
                         function(success) {
                            RestAPIService.successTostDialog("System Updated successfully ");
                           $state.reload();
                         },
                         function(error) {
                       	  RestAPIService.showErrorDialog(error);                        
                         }
                     );
                     $mdDialog.hide(system);
           
           };
        	 
             $scope.hide = function() {
                 $mdDialog.hide();
             };
             $scope.cancel = function() {
                 $mdDialog.cancel();
             };
         }
         
         $scope.SystemDelete = function(ev,system) {
             var confirm = $mdDialog.confirm()
                 .title('Remove')
                 .textContent('System'+ ' ' + system.systemName + ' ' + ' will be permanently deleted. Continue ?')
                 .targetEvent(ev)
                 .ok('Ok')
                 .cancel('Cancel');
             $mdDialog.show(confirm).then(function() {	
             	RestAPIService.deleteSystem(system.id).then(
                     function(success) {
                         RestAPIService.successTostDialog("System Deleted successfully ");
                        $state.reload();
                      },
                      function(error) {
                          RestAPIService.showErrorDialog(error);
                      }
                  );
                  $mdDialog.hide();},
                 function() {
                     $mdDialog.cancel();
                 });
         }
        
        $scope.ValidateDialog = function(ev, system) {
             systemCtrl.currentSystem = angular.copy(system);
             $mdDialog.show({
                 controller: ValidateDialogController,
                 templateUrl: 'app/main/smartstore-admin/systems/validate.system.html',
                 parent: angular.element(document.body),
                 targetEvent: ev,
                 clickOutsideToClose: true,
                 fullscreen: $scope.customFullscreen
             })
         };

          function ValidateDialogController($scope, $mdDialog, RestAPIService)
         {
           $scope.currentSystem = systemCtrl.currentSystem;    
             $scope.hide = function() {
                 $mdDialog.hide();
             };
             $scope.cancel = function() {
                 $mdDialog.cancel();
             };

            RestAPIService.getSystemCertificate($scope.currentSystem.systemId).then(
                function(success){
                  $scope.certificate = success.data;
                },
                function(error){
                   RestAPIService.showErrorDialog(error);
                }
            );
      $scope.save = function(statusvalue){
      /*  if(statusvalue = 'true'){
            $scope.status = "Accept";

        }else{
             $scope.status = "Reject";
        }*/
             RestAPIService.SystemCertificateVerify($scope.currentSystem.authId,statusvalue).then(
                function(success){
                 RestAPIService.successTostDialog("Certificate Status Updated");
                   $mdDialog.cancel();
                   $state.reload();
                },
                function(error){
                   RestAPIService.showErrorDialog(error);
                }
                  );
                }
     
           }


           // Functions regarding Repositories.
            $scope.createRepDialog = function(ev) {
            $mdDialog.show({
                controller: createRepDialogController,
                templateUrl: 'app/main/smartstore-admin/systems/repos/create.repository.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
            $scope.cancel = function() {

            };
        }


        function createRepDialogController($scope, $mdDialog, RestAPIService, $window) {
            $scope.expiration = ["Active","In-Active"];
            $scope.repository = {};

            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.storageTypes = ["GoogleDrive", "OneDrive", "FileSystem","amazonS3","azurestorage"];
            $scope.save = function(repository) {
                repository['systemId'] = $rootScope.systemId;
              //  alert(JSON.stringify(repository));
                RestAPIService.createRepository(repository).then(
                    function(success) {
                        $mdDialog.hide();
                        RestAPIService.successTostDialog('Repository Created Successfully');
                        if(success.data.rootPath.indexOf('http')>=0){
                            window.open(success.data.rootPath);
                        }
                        $state.reload();
                    },
                    function(error) {
                        if (error.status == 400) {
                            RestAPIService.successTostDialog(error.headers('X-smartportalApp-defaultMessage'));

                            return false;

                        }
                    }

                );

            };
        }

        $scope.DisplayRepDialog = function(ev,repository) {
             systemCtrl.currentrepository = angular.copy(repository);
            $mdDialog.show({
                controller: DisplayRepDialogController,
                templateUrl: 'app/main/smartstore-admin/systems/repos/display.repository.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
            $scope.cancel = function() {

            };
        }
        
        function DisplayRepDialogController($scope, $mdDialog, RestAPIService) {
          //  $scope.storageTypes = ["GoogleDrive", "OneDrive", "FileSystem"];
            $scope.currentrepository = systemCtrl.currentrepository;  
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };   
            
        }

        $scope.updateRepDialog = function(ev, repository) {
            systemCtrl.currentrepository = angular.copy(repository);
            $mdDialog.show({
                controller: updateRepDialogController,
                templateUrl: 'app/main/smartstore-admin/systems/repos/update.repository.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        };


        function updateRepDialogController($scope, $mdDialog, RestAPIService) {
            $scope.storageTypes = ["GoogleDrive", "OneDrive", "FileSystem","amazonS3","azurestorage"];
            $scope.currentrepository = systemCtrl.currentrepository;  
            $scope.updateRepository = function(repository) {
                RestAPIService.updateRepository(repository).then(
                    function(success) {
                        RestAPIService.successTostDialog('Repository Updated Successfully');
                        $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide(repository);
            };
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            
            
        }

        $scope.deleteRepository = function(ev, repository) {
            var confirm = $mdDialog.confirm()
                .title('Remove')
                .textContent('Repository' + ' ' + repository.name + ' ' + ' will be permanently deleted. Continue ?')
                .targetEvent(ev)
                .ok('Ok')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                    RestAPIService.deleteRepository(repository.id).then(
                        function(success) {
                            RestAPIService.successTostDialog("Repository Deleted successfully ");
                            $state.reload();
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        }
                    );
                    $mdDialog.hide();
                },
                function() {
                    $mdDialog.cancel();
                });
        }

    	
    }         
})();
(function ()
{
    'use strict';

    angular
        .module('app.smartstore-admin')
        .controller('MimeTypeController', MimeTypeController);

    
    function MimeTypeController($state,$scope,$filter,$mdDialog,RestAPIService,MimeTypes)
    {
    	var mimetypeCtrl =this;
    	$scope.SmartstoreMimeTypes =MimeTypes.data;
    	
    	mimetypeCtrl.dtOptions = { 
         		 dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
	            pagingType: 'simple',
	            autoWidth : false,
	            responsive: true
        };
    	
        mimetypeCtrl.goToMain =function(){
            $state.go('app.smartstore-admin');
        }

         $scope.DisplayMimeTypeDialog = function(ev,mimetype) {
             mimetypeCtrl.currentMimetype = angular.copy(mimetype);
            $mdDialog.show({
                controller: DisplayMimeTypeDialogController,
                templateUrl: 'app/main/smartstore-admin/mimetype/display.mimetype.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
            $scope.cancel = function() {

            };
        }
        
        function DisplayMimeTypeDialogController($scope, $mdDialog, RestAPIService) {
            $scope.currentMimetype = mimetypeCtrl.currentMimetype;  
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };   
            
        }

    	 $scope.createMimeTypeDialog = function(ev) {
             $mdDialog.show({
                 controller: createMimeTypeDialogController,
                 templateUrl: 'app/main/smartstore-admin/mimetype/create.mimetype.html',  
                 parent: angular.element(document.body),
                 targetEvent: ev,
                 clickOutsideToClose: true,
                 fullscreen: $scope.customFullscreen
             })
             $scope.cancel = function() {

             };
         }
         
       
         function createMimeTypeDialogController($scope, $mdDialog, RestAPIService)
         {        	 
        	 $scope.save= function(mimetype){
        		 RestAPIService.createMimeType(mimetype).then(
                         function(success) {
                             RestAPIService.successTostDialog("MimeType Created successfully ");
                            $state.reload();
                          },
                          function(error) {
                              RestAPIService.showErrorDialog(error);
                          }
                      );
        		    $mdDialog.hide(mimetype);
        	 }
        	 
        	 
        	 $scope.hide = function() {
                 $mdDialog.hide();
             };
        	 $scope.cancel = function() {
                 $mdDialog.cancel();
             };
         	
            
         }
         
         
         $scope.updateMimeTypeDialog = function(ev, mimetype) {
        	 mimetypeCtrl.currentMimetype = angular.copy(mimetype);
             $mdDialog.show({
                 controller: updateMimeTypeDialogController,
                 templateUrl: 'app/main/smartstore-admin/mimetype/update.mimetype.html',
                 parent: angular.element(document.body),
                 targetEvent: ev,
                 clickOutsideToClose: true,
                 fullscreen: $scope.customFullscreen
             })
         };
         
         
         function updateMimeTypeDialogController($scope, $mdDialog, RestAPIService)
         {
        	 $scope.currentMimetype= mimetypeCtrl.currentMimetype
        	 $scope.update= function(mimetype){
        		 RestAPIService.updateMimeType(mimetype).then(
                         function(success) {
                             RestAPIService.successTostDialog("MimeType Updated successfully ");
                            $state.reload();
                          },
                          function(error) {
                              RestAPIService.showErrorDialog(error);
                          }
                      );
        		    $mdDialog.hide(mimetype);
        	 }
        	 
        	 
             $scope.hide = function() {
                 $mdDialog.hide();
             };
             $scope.cancel = function() {
                 $mdDialog.cancel();
             };
         }
         
         $scope.MimeTypeDelete = function(ev,mimetype) {
             var confirm = $mdDialog.confirm()
                 .title('Remove')
                 .textContent('MimeType'+ ' ' + mimetype.mimeType + ' ' + ' will be permanently deleted. Continue ?')
                 .targetEvent(ev)
                 .ok('Ok')
                 .cancel('Cancel');
             $mdDialog.show(confirm).then(function() {	
             	RestAPIService.deleteMimeType(mimetype.id).then(
                     function(success) {
                         RestAPIService.successTostDialog("MimeType Deleted successfully ");
                        $state.reload();
                      },
                      function(error) {
                          RestAPIService.showErrorDialog(error);
                      }
                  );
                  $mdDialog.hide();},
                 function() {
                     $mdDialog.cancel();
                 });
         }
         
    	
    }


         
})();
(function ()
{
    'use strict';

    angular
        .module('app.smartstore-admin')
        .controller('CompanyController', CompanyController);

    
    function CompanyController($state,$scope,$filter,$mdDialog,RestAPIService,Companies)
    {
    	var companyCtrl =this;
    	$scope.SmartstoreCompanies =Companies.data;
    	
    	companyCtrl.dtOptions = { 
         		 dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
	            pagingType: 'simple',
	            autoWidth : false,
	            responsive: true
        };
    	 companyCtrl.goToMain =function(){
            $state.go('app.smartstore-admin');
        }

         $scope.DisplayCompanyDialog = function(ev,company) {
             companyCtrl.currentCompany = angular.copy(company);
            $mdDialog.show({
                controller: DisplayCompanyDialogController,
                templateUrl: 'app/main/smartstore-admin/companies/display.company.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
            $scope.cancel = function() {

            };
        }
        
        function DisplayCompanyDialogController($scope, $mdDialog, RestAPIService) {
            $scope.storageTypes = ["GoogleDrive", "OneDrive", "FileSystem"];
            $scope.currentCompany = companyCtrl.currentCompany;  
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };   
            
        }

    	 $scope.createCompanyDialog = function(ev) {
             $mdDialog.show({
                 controller: createCompanyDialogController,
                 templateUrl: 'app/main/smartstore-admin/companies/create.companies.html',  
                 parent: angular.element(document.body),
                 targetEvent: ev,
                 clickOutsideToClose: true,
                 fullscreen: $scope.customFullscreen
             })
             $scope.cancel = function() {

             };
         }
         
       
         function createCompanyDialogController($scope, $mdDialog, RestAPIService)
         {     	
        	 $scope.cancel = function() {
                 $mdDialog.cancel();
             };       
             
             $scope.save = function(company) {            	
                 RestAPIService.createCompany(company).then(
                             function(success) {
                                RestAPIService.successTostDialog("Company Created successfully ");
                               $state.reload();
                             },
                             function(error) {
                            	 RestAPIService.showErrorDialog(error);
                             }
                         );
                         $mdDialog.hide(company);
                  
                
                 };
            
         }         
         $scope.updateCompanyDialog = function(ev, company) {
        	 companyCtrl.currentCompany = angular.copy(company);
             $mdDialog.show({
                 controller: updateCompanyDialogController,
                 templateUrl: 'app/main/smartstore-admin/companies/update.companies.html',
                 parent: angular.element(document.body),
                 targetEvent: ev,
                 clickOutsideToClose: true,
                 fullscreen: $scope.customFullscreen
             })
         };        
         
         function updateCompanyDialogController($scope, $mdDialog, RestAPIService)
         {
        	 $scope.currentCompany =companyCtrl.currentCompany;
             $scope.hide = function() {
                 $mdDialog.hide();
             };
             $scope.cancel = function() {
                 $mdDialog.cancel();
             };
             
             $scope.update = function(company) {
           	  RestAPIService.updateCompany(company).then(
                         function(success) {
                            RestAPIService.successTostDialog("Company Updated successfully ");
                           $state.reload();
                         },
                         function(error) {
                       	  RestAPIService.showErrorDialog(error);                        
                         }
                     );
                     $mdDialog.hide(company);
           
           };
         }
         
         $scope.CompanyDelete = function(ev,company) {
             var confirm = $mdDialog.confirm()
                 .title('Remove')
                 .textContent('Company'+ ' ' + company.name + ' ' + ' will be permanently deleted. Continue ?')
                 .targetEvent(ev)
                 .ok('Ok')
                 .cancel('Cancel');
             $mdDialog.show(confirm).then(function() {	
            	 RestAPIService.deleteCompany(company.id).then(
                     function(success) {
                         RestAPIService.successTostDialog("Company Deleted successfully ");
                        $state.reload();
                      },
                      function(error) {
                          RestAPIService.showErrorDialog(error);
                      }
                  );	
                  $mdDialog.hide();
                  },
                 function() {
                     $mdDialog.cancel();
                 });
         }
         
    	
    }


         
})();
(function() {
    'use strict';

    angular
        .module('app.smartstore-admin')
        .controller('RepositoryController', RepositoryController);


    function RepositoryController($state, $scope, $filter, $mdDialog, RestAPIService,Repositories) {
        var repCtrl = this;
        $scope.repositoriesList = Repositories.data;
        repCtrl.repository = {};

        repCtrl.dtOptions = {
            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth: false,
            responsive: true
        };
        
        repCtrl.goToMain =function(){
        	$state.go('app.smartstore-admin');
        }

       repCtrl.getRepositories = function() {
            RestAPIService.getRepositories().then(
                function(success) {
                    $scope.repositoriesList = success.data;
                    $scope.count = $scope.repositoriesList.length;
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );
        }


        $scope.createRepDialog = function(ev) {
            $mdDialog.show({
                controller: createRepDialogController,
                templateUrl: 'app/main/smartstore-admin/Repositories/create.repository.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
            $scope.cancel = function() {

            };
        }


        function createRepDialogController($scope, $mdDialog, RestAPIService) {
            $scope.expiration = ["Active","In-Active"];
            $scope.repository = {};

            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.storageTypes = ["GoogleDrive", "OneDrive", "FileSystem"];
            $scope.save = function(repository) {
              //  alert(JSON.stringify(repository));
                RestAPIService.createRepository(repository).then(
                    function(success) {
                        $mdDialog.hide();
                        RestAPIService.successTostDialog('Repository Created Successfully');
                        $state.reload();
                    },
                    function(error) {
                        if (error.status == 400) {
                            RestAPIService.successTostDialog(error.headers('X-smartportalApp-defaultMessage'));

                            return false;

                        }
                    }

                );

            };
        }

        $scope.DisplayRepDialog = function(ev,repository) {
        	 repCtrl.currentrepository = angular.copy(repository);
            $mdDialog.show({
                controller: DisplayRepDialogController,
                templateUrl: 'app/main/smartstore-admin/Repositories/display.repository.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
            $scope.cancel = function() {

            };
        }
        
        function DisplayRepDialogController($scope, $mdDialog, RestAPIService) {
          //  $scope.storageTypes = ["GoogleDrive", "OneDrive", "FileSystem"];
            $scope.currentrepository = repCtrl.currentrepository;  
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };   
            
        }

        $scope.updateRepDialog = function(ev, repository) {
            repCtrl.currentrepository = angular.copy(repository);
            $mdDialog.show({
                controller: updateRepDialogController,
                templateUrl: 'app/main/smartstore-admin/Repositories/update.repository.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        };


        function updateRepDialogController($scope, $mdDialog, RestAPIService) {
            $scope.storageTypes = ["GoogleDrive", "OneDrive", "FileSystem"];
            $scope.currentrepository = repCtrl.currentrepository;  
            $scope.updateRepository = function(repository) {
                RestAPIService.updateRepository(repository).then(
                    function(success) {
                        RestAPIService.successTostDialog('Repository Updated Successfully');
                        $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide(repository);
            };
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            
            
        }

        $scope.deleteRepository = function(ev, repository) {
            var confirm = $mdDialog.confirm()
                .title('Remove')
                .textContent('Repository' + ' ' + repository.name + ' ' + ' will be permanently deleted. Continue ?')
                .targetEvent(ev)
                .ok('Ok')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                    RestAPIService.deleteRepository(repository.id).then(
                        function(success) {
                            RestAPIService.successTostDialog("Repository Deleted successfully ");
                            $state.reload();
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        }
                    );
                    $mdDialog.hide();
                },
                function() {
                    $mdDialog.cancel();
                });
        }


    }



})();
(function() {
	'use strict';

	angular.module('app.reset.password', []).config(config);

	function config($stateProvider) {
		$stateProvider.state('app.reset_password', {
			url : '/smartportal/reset/finish/:key',
			params: {
				key: null
            },
			views : {
				'main@' : {
					templateUrl : 'app/core/layouts/content-only.html',
					controller : 'MainController as vm'
				},
				'content@app.reset_password' : {
					templateUrl : 'app/main/reset/view/reset.html',
					controller : 'RPController as vm'
				}
			},
			bodyClass : 'RS',
			data : {
				accessRole : [ 'ALL' ]
			}
		});
	}
})();
(function() {
    'use strict';

    angular
        .module('app.reset.password')
        .controller('RPController', RPController);

    function RPController($scope, $state, $location, $stateParams,RestAPIService) {
        var vm = this;
        var key = $stateParams.key;
        $scope.finishPassword = {};
        $scope.resetPasswordfinish = function(finishPassword) { 
        	 $scope.finishPassword['key'] = key;
        	 $scope.finishPassword['newPassword'] = $scope.password;
        	
             RestAPIService.resetPasswordfinish($scope.finishPassword).then(
                   function(success) {
                	   RestAPIService.successTostDialog("Successfully Updated");
                   	$location.path('/smartportal/login');
                   },
                   function(error) {
                	   alert("Invalid Key");
                       RestAPIService.showErrorDialog(error);
                   }
               );        
        }
    };

})();
(function() {
    'use strict';

    var app = angular
        .module('app.profile', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider, $controllerProvider, $compileProvider, $filterProvider, $provide) {
    	 app.controller = $controllerProvider.register;
         app.directive = $compileProvider.directive;
         app.filter = $filterProvider.register;
         app.factory = $provide.factory;
         app.service = $provide.service;
       

        $stateProvider
            .state('app.profile', {
                url: '/profile',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/profile/myprofile.html',
                        controller: 'ProfileController as profileCtrl'
                    },
                    'about@app.profile': {
                        templateUrl: 'app/main/profile/about/about.html',
                        controller : 'AboutController as abtCtrl'
                    },
                    'substitution@app.profile': {
                        templateUrl: 'app/main/profile/substitution/substitution.html',
                        controller : 'SubstitutionController as substitutionCtrl'
                    }
                },
                
            });

        
       
     
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.profile')
        .controller('SubstitutionController', SubstitutionController);

    /** @ngInject */
    function SubstitutionController($scope,$location, $mdDialog, RestAPIService,$sessionStorage)
    {
        var substitutionCtrl = this;
        // substitutionCtrl.getAllSubstitutes = function(){
        // 	RestAPIService.getAllSubstitutes().then(
        //             function(success) {
        //                 $scope.allSubstitutes = success.data;                        
        //             },
        //             function(error) {
        //                 RestAPIService.showErrorDialog(error);
        //             }
        //         );        	
        // }
        $scope.createSubstitutor = function(ev){
        	$mdDialog.show({
        		templateUrl: 'app/main/profile/substitution/substitution.create.html',
                controller: CreateSubstitutorDialogController,                
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        }
        function CreateSubstitutorDialogController($scope, $mdDialog, $sessionStorage){
        	$scope.getAllUsers = function(){
            	RestAPIService.getUsers().then(
                        function(success) {
                            $scope.usersList = success.data;                       
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        }
                    );
            }
        	$scope.cancel = function() {
               $mdDialog.cancel();
        	};
        	$scope.save = function(data){
        		data['userId'] = $sessionStorage.currentUser.username;
        		data['createdBy'] = $sessionStorage.currentUser.username;
        		RestAPIService.createSubstitutor(data).then(
                        function(success) {
//                            $scope.usersList = success.data;
                        	$mdDialog.cancel();
                        	substitutionCtrl.getAllSubstitutes();
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        }
                    );
        		
        	}
        }
        
        $scope.update = function(ev,item){        	
        	substitutionCtrl.substitutionItem = angular.copy(item);
        	$mdDialog.show({
        		templateUrl: 'app/main/profile/substitution/substitution.update.html',
                controller: UpdateUserDialogController,                
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        }
        function UpdateUserDialogController($mdDialog, $scope, RestAPIService){        	
        	$scope.substitutionItem = substitutionCtrl.substitutionItem;        		
        	$scope.cancel = function() {
                $mdDialog.cancel();
         	};
         	$scope.getAllUsers = function(){
            	RestAPIService.getUsers().then(
                        function(success) {
                            $scope.usersList = success.data;                       
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        }
                    );
            }
         	$scope.update = function(ev, data){
          		RestAPIService.updateSubstitutor(data).then(
                        function(success) {
                        	$mdDialog.cancel();
                        	substitutionCtrl.getAllSubstitutes();
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        });
         	}
        }
        $scope.delete = function(ev, data){
        	var confirm = $mdDialog.confirm()
            .title('Remove')
            .textContent('Substitution will be permanently deleted. Continue ?')
            .targetEvent(ev)
            .ok('Ok')
            .cancel('Cancel');
        $mdDialog.show(confirm).then(function() {
        	RestAPIService.deleteSubstitutor(data).then(
                    function(success) {                   
                    	RestAPIService.successTostDialog("Successfully Deleted.");
                    	substitutionCtrl.getAllSubstitutes();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
            
        }, function() {
            $mdDialog.cancel();
        });
        	
        }
        
        
        
        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.profile')
        .controller('AboutController', AboutController);

    /** @ngInject */
    function AboutController($scope, $location, $mdDialog, $cookieStore)
    {
     var abtCtrl = this; 
     var json = $cookieStore.get('logedInuserdetail');
     
     $scope.currentLogedInUser = json['currentLogedInUser'];
     $scope.loggedInUserName = json['loggedInUserName'];
     var LoggedInUserName = $scope.loggedInUserName;
     abtCtrl.editprofile =function(ev,user){
    	 abtCtrl.currentUser = angular.copy(user);
//    	 abtCtrl.currentUser = angular.copy(user);
         $mdDialog.show({
             controller: UpdateUserDialogController,
             templateUrl: 'app/main/profile/edit.profile.dialog.html',
             parent: angular.element(document.body),
             targetEvent: ev,
             clickOutsideToClose: true,
             fullscreen: $scope.customFullscreen
         })
     }
     function UpdateUserDialogController($scope, RestAPIService,$mdDialog, $state){    	 
    	 $scope.currentUser = abtCtrl.currentUser;
    	 $scope.roles = ["ROLE_USER", "ROLE_ADMIN"];
    	 $scope.status = ["true", "false"];
    	 $scope.currencyFormats = ["Dot(.)" , "Comma(,)"];
         $scope.dateFormats = ["YYYY-MM-DD", "DD.MM.YYYY", "YYYYMMDD", "DD-MM-YYYY", "MM-DD-YYYY", "MM/DD/YYYY"];
         $scope.currency= ["INR", "USD", "GBP", "EUR"];
         $scope.languages= ["English", "German", "French", "Spanish", "Hindi"];
         $scope.timeZones= ["BRT(Brasilia Time)", "CST(China Standard Time)", "ART(Argentina Time)", "BTT(Bhutan Time)", "CT(China Time)","IST(Indian Standard Time)"];
         $scope.updateUserProfile = function(user) {
             RestAPIService.updateUserProfile(user).then(
                 function(success) {
                 	RestAPIService.successTostDialog("Profile updated successfully");
                 
                     $mdDialog.hide(user);
                     $state.reload();
                 },
                 function(error) {
                     RestAPIService.showErrorDialog(error);
                 });
         }
        
          $scope.hide = function() {
              $mdDialog.hide();
          };
          $scope.cancel = function() {
              $mdDialog.cancel();
          };
    	 
     }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.migrations', ['daterangepicker'] )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdThemingProvider)
    {
    	 $stateProvider
            
            .state('app.migrations', {
                url: '/migration',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/migration/migration.html',
                        controller:  'MigrationController as migratCtrl'
                    }
                }
            })
            .state('app.migrations-Configuration', {
                url: '/migration/configuration',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/migration/migrationSmartstoreConfiguration/migrationSmartstoreConfiguration.html',
                        controller: 'MigrationconfigureController as migrateconfugureCtrl'
                    }
                }
            })
            .state('app.migrations-BatchRecords', {
                url: '/migration/BatchRecords',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/migration/batchRecords/batchRecord.html',
                        controller: 'BatchRecordsController as batchCtrl'
                    }
                }
            })
            .state('app.migrations-BatchRecordsDetails', {
                url: '/migration/BatchRecords/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/migration/batchRecords/batchRecordDetail.html',
                        controller: 'BatchRecordsController as batchCtrl'
                    }
                },
                params: {
                    id: null              
                }
            })
            .state('app.migrations-Documentation', {
                url: '/migration/migrationDocumentation',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/migration/documentationMigrationStatusReports/documentationMigrationStatusReports.html',
                        controller: 'DocumentationController as DocCtrl'
                    }
                }
            });
      msNavigationServiceProvider.saveItem('migration', {
            title : 'Migration',
            icon  : 'icon-file-document',
            state : 'app.migrations',
            weight: 11
        });

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.migrations')
        .controller('MigrationconfigureController', MigrationconfigureController);

    /** @ngInject */
    function MigrationconfigureController($state, $scope, MigrationRestAPIService, $filter, $mdDialog, $sce)
    {
        var migrateconfugureCtrl = this;
       $scope.readable="true";
       $scope.visible="true";
$scope.dataid="9999"
       init();
       function init(){
        MigrationRestAPIService.getMigrationConfiguration("9999").then(
            function(success) {
                $scope.migrateDetails= success.data; 
               $scope.configure= $scope.migrateDetails;
                console.log($scope.migrateDetails)                     
            },
            function(error) {
                MigrationRestAPIService.showErrorDialog(error);
            }
        );
       }
       $scope.migrateSubmit=function(data){
           data.id="9999"
        MigrationRestAPIService.MigrationConfiguration(data).then(
            function(success) {
                $scope.migrateDetails= success.data;  
                $scope.readable="true";
                $scope.visible="true"; 
                $mdDialog.show(
                    $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#popupContainer')))
                    .clickOutsideToClose(true)
                    .title('Success.')
                    .htmlContent('Migrate Configuration Updated successfully.</h4>')
                    .ariaLabel('Alert Dialog Demo')
                    .ok('Ok')
                  );             
            },
            function(error) {
                MigrationRestAPIService.showErrorDialog(error);
            }
        );
       }
     $scope.migrateUpdate=function(data){
        $scope.readable="false"; 
        $scope.visible="false"; 
     
     } 

$scope.migratecancel=function(){
    $scope.readable="true";
       $scope.visible="true";

}
    $scope.goBack=function(){
        $state.go('app.migrations')
    }
    }


         
})();
(function ()
{
    'use strict';

    angular
        .module('app.migrations')
        .controller('DocumentationController', DocumentationController);

    /** @ngInject */
    function DocumentationController($state, $scope, MigrationRestAPIService, $filter, $mdDialog, $sce)
    {
        var DocCtrl = this;
        DocCtrl.selectItems = [];
        $scope.loadingbar =true;
       
        // $scope.sizeNumbers= [10,20,50,100,500,1000];
        $scope.pageNumber = 0;
        $scope.size= 20;
        $scope. searchdetailspageNumber = 0;
        $scope. searchdetailssize= 20;
       
        DocCtrl.Reset=function(){
            $scope.object =[]
            $scope.searchdetails=false;
            $state.reload(); 
            DocCtrl.documentationreportDetails();
        }
     $scope.sizeselect=function(size){
        $scope.size = size
        DocCtrl.documentationreportDetails();                
    }
    $scope.next = function(){	
        $scope.pageNumber = $scope.pageNumber + 1; 
        DocCtrl.documentationreportDetails();    	
      }
      $scope.previous = function(){
          $scope.pageNumber = $scope.pageNumber - 1; 
          DocCtrl.documentationreportDetails();    	
      }  	 
      $scope.sendPageNumber = function(page) {
       $scope.pageNumber = page;
       DocCtrl.documentationreportDetails();
   }
   $scope.searchdetailssizeselect=function(size){
    $scope.searchdetailssize = size
    MigrationRestAPIService.getBatchDetailspage($scope.obj,$scope.searchdetailspageNumber,$scope.searchdetailssize).then(
        function(success) {
            $scope.workItemsdata = [];
            $scope.DocumentationDetails = success.data.content;  
            $scope.loadingbar =false;
            $scope.searchdetails=true;
            $scope.workItemsdata = success.data.content
            $scope.pageNumbers = [];
            $scope.totalRecords = success.data.totalElements;
            console.log( $scope.totalRecords)
            $scope.totalPages = Math.ceil($scope.totalRecords/$scope.searchdetailssize);
           if ($scope.totalPages  > 0) {
            for (var i = 0; i < $scope.totalPages; i++) {
                $scope.pageNumbers.push(i);
                }
           }                    
        },
        function(error) {
            MigrationRestAPIService.showErrorDialog(error);
        }
    );              
}
$scope.searchdetailsnext = function(){	
    $scope.searchdetailspageNumber = $scope.searchdetailspageNumber + 1; 
    MigrationRestAPIService.getBatchDetailspage($scope.obj,$scope.searchdetailspageNumber,$scope.searchdetailssize).then(
        function(success) {
            $scope.workItemsdata = [];
            $scope.DocumentationDetails = success.data.content;  
            $scope.loadingbar =false;
            $scope.searchdetails=true;
            $scope.workItemsdata = success.data.content
            $scope.pageNumbers = [];
            $scope.totalRecords = success.data.totalElements;
            console.log( $scope.totalRecords)
            $scope.totalPages = Math.ceil($scope.totalRecords/$scope.searchdetailssize);
           if ($scope.totalPages  > 0) {
            for (var i = 0; i < $scope.totalPages; i++) {
                $scope.pageNumbers.push(i);
                }
           }                    
        },
        function(error) {
            MigrationRestAPIService.showErrorDialog(error);
        }
    );  	
  }
  $scope.searchdetailsprevious = function(){
      $scope.searchdetailspageNumber = $scope.searchdetailspageNumber - 1; 
      MigrationRestAPIService.getBatchDetailspage($scope.obj,$scope.searchdetailspageNumber,$scope.searchdetailssize).then(
        function(success) {
            $scope.workItemsdata = [];
            $scope.DocumentationDetails = success.data.content;  
            $scope.loadingbar =false;
            $scope.searchdetails=true;
            $scope.workItemsdata = success.data.content
            $scope.pageNumbers = [];
            $scope.totalRecords = success.data.totalElements;
            console.log( $scope.totalRecords)
            $scope.totalPages = Math.ceil($scope.totalRecords/$scope.searchdetailssize);
           if ($scope.totalPages  > 0) {
            for (var i = 0; i < $scope.totalPages; i++) {
                $scope.pageNumbers.push(i);
                }
           }                    
        },
        function(error) {
            MigrationRestAPIService.showErrorDialog(error);
        }
    );   	
  }  	 
  $scope.searchdetailssendPageNumber = function(page) {
   $scope.searchdetailspageNumber = page;
   MigrationRestAPIService.getBatchDetailspage($scope.obj,$scope.searchdetailspageNumber,$scope.searchdetailssize).then(
    function(success) {
        $scope.workItemsdata = [];
        $scope.DocumentationDetails = success.data.content;  
        $scope.loadingbar =false;
        $scope.searchdetails=true;
        $scope.workItemsdata = success.data.content
        $scope.pageNumbers = [];
        $scope.totalRecords = success.data.totalElements;
        console.log( $scope.totalRecords)
        $scope.totalPages = Math.ceil($scope.totalRecords/$scope.searchdetailssize);
       if ($scope.totalPages  > 0) {
        for (var i = 0; i < $scope.totalPages; i++) {
            $scope.pageNumbers.push(i);
            }
       }                    
    },
    function(error) {
        MigrationRestAPIService.showErrorDialog(error);
    }
);
}
   $scope.obj ={    			 
               			
    "batchId":null,    			
    "fromDate":null,
   "toDate":null,
   "status":null 
}

$scope.selected = [];
$scope.checkuncheckWorkitems = function (workitem, list) {
    $scope.checkeddata=true;
    var idx = list.indexOf(workitem);
    if (idx > -1) {
        list.splice(idx, 1);
    }
    else {
        list.push(workitem);
    }
    DocCtrl.selectItems = list;
};

$scope.exists = function (workitem, list) {
    return list.indexOf(workitem) > -1;
};

$scope.isIndeterminate = function () {
    return ($scope.selected.length !== 0 &&
        $scope.selected.length !== $scope.workItemsdata.length);
}


$scope.checkuncheckAllWorkitems = function () {
    if ($scope.workItemsdata == undefined) $scope.workItemsdata = [];
    return $scope.selected.length === $scope.workItemsdata.length;

};


$scope.toggleAll = function () {
    if ($scope.selected.length === $scope.workItemsdata.length) {
        $scope.selected = [];
        DocCtrl.selectItems = $scope.selected;
    } else if ($scope.selected.length === 0 || $scope.selected.length > 0) {
        $scope.selected = $scope.workItemsdata.slice(0);
        DocCtrl.selectItems = $scope.selected;
    }
}
$scope.documentSubmit =function(){
    $scope.loadingbar =true;
   var headerdata=[]
    $scope.allworkitems = DocCtrl.selectItems;
    for(var j=0;j<$scope.allworkitems.length;j++){
        $scope.docidlist=$scope.allworkitems[j].archiveDocId
        headerdata.push($scope.docidlist)
        console.log(headerdata)
    }
   
   $scope.remigrateobj={
    "archiveDocIdList": headerdata
    }
    MigrationRestAPIService.remigrate($scope.remigrateobj).then(
        function(success) {
            $scope.remigrateDetails= success.data; 
            $scope.loadingbar =false; 
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#popupContainer')))
                .clickOutsideToClose(true)
                .title('Success.')
                .htmlContent('Re-Migrated successfully.</h4>')
                .ariaLabel('Alert Dialog Demo')
                .ok('Ok')
              );  
            $state.reload(); 
            DocCtrl.documentationreportDetails();                   
        },
        function(error) {
            MigrationRestAPIService.showErrorDialog(error);
        }
    );
}
$scope.obj ={    			 
 "fromDate":null,
   "toDate": null,
   "status":null, 
}

$scope.documentSearch=function(data){
    $scope.loadingbar =true;
    $scope.searchdetails=true;
    if(data.date){
        var startDate = new Date(data.date.startDate._d);
        startDate.setDate(startDate.getDate() + 1);
        var endDate = new Date(data.date.endDate._d);
        DocCtrl.fromDate = startDate.toISOString();
        DocCtrl.toDate = endDate.toISOString();
      } else {
        if(DocCtrl.searchData){
          DocCtrl.fromDate = null;
          DocCtrl.toDate = null;
        }
      }

        // DocCtrl.searchData=data;
        if(data!=null){
          
            $scope.obj ={    			 
                "fromDate": DocCtrl.fromDate,
                  "toDate": DocCtrl.toDate ,
                  "status":data.status, 
               }
    
       
       }
     

    MigrationRestAPIService.getBatchDetailspage($scope.obj,$scope.searchdetailspageNumber,$scope.searchdetailssize).then(
        function(success) {
            $scope.workItemsdata = [];
            $scope.DocumentationDetails = success.data.content;  
            $scope.loadingbar =false;
            $scope.searchdetails=true;
            $scope.workItemsdata = success.data.content
            $scope.pageNumbers = [];
            $scope.totalRecords = success.data.totalElements;
            console.log( $scope.totalRecords)
            $scope.totalPages = Math.ceil($scope.totalRecords/$scope.searchdetailssize);
           if ($scope.totalPages  > 0) {
            for (var i = 0; i < $scope.totalPages; i++) {
                $scope.pageNumbers.push(i);
                }
           }                    
        },
        function(error) {
            MigrationRestAPIService.showErrorDialog(error);
        }
    );
}

DocCtrl.documentationreportDetails=function(){
    $scope.workItemsdata = [];
    $scope.loadingbar =true;
    MigrationRestAPIService.getDocumentationDetails($scope.pageNumber,$scope.size).then(
        function(success) {
            $scope.DocumentationDetails = success.data.content;
            $scope.workItemsdata = success.data.content
            $scope.loadingbar =false;
            $scope.searchdetails=false;
            console.log($scope.DocumentationDetails)  
            $scope.pageNumbers = [];
            $scope.totalRecords = success.data.totalElements;
            console.log( $scope.totalRecords)
            $scope.totalPages = Math.ceil($scope.totalRecords/$scope.size);
           if ($scope.totalPages  > 0) {
            for (var i = 0; i < $scope.totalPages; i++) {
                $scope.pageNumbers.push(i);
                }
           }                   
        },
        function(error) {
            MigrationRestAPIService.showErrorDialog(error);
        }
    );
}
$scope.viewdocuments=function(archiveDocId){
    MigrationRestAPIService.getDocumentById(archiveDocId).then(
        function(success) {
            $scope.DocumentViewDetails = success.data.url;
            window.open($scope.DocumentViewDetails);
            console.log($scope.DocumentViewDetails)
        })
    // if(fileData.fileType.toLowerCase() == 'pdf'){
    //     window.open(fileData.url);
    //   }

}


        init();
            function init(){
                DocCtrl.documentationreportDetails();
        
            }
      
      

            $scope.goBack=function(){
                $state.go('app.migrations')
            }
    
    }


         
})();
(function ()
{
    'use strict';

    angular
        .module('app.migrations')
        .controller('BatchRecordsController', BatchRecordsController)
        .filter("getDiff", function() {
            return function(time) {
              var startDate = new Date(batch.createdDate);
              var endDate = new Date(batch.lastModifiedDate);
              var milisecondsDiff = endDate - startDate;
             
                return Math.floor(milisecondsDiff/(1000*60*60)).toLocaleString(undefined, {minimumIntegerDigits: 2}) + ":" + (Math.floor(milisecondsDiff/(1000*60))%60).toLocaleString(undefined, {minimumIntegerDigits: 2})  + ":" + (Math.floor(milisecondsDiff/1000)%60).toLocaleString(undefined, {minimumIntegerDigits: 2}) ;
            
            }
          });

    /** @ngInject */
    function BatchRecordsController($state, $scope, MigrationRestAPIService, $filter,$stateParams, $mdDialog, $sce)
    {
        var batchCtrl = this;
        $scope.id = $stateParams.id;
        $scope.loadingbar =true;
        // $scope.batchDetailspageData=[];
        $scope.pageNumber = 0;
        $scope.size= 20;

        $scope.detailsnext = function(){	
            $scope.pageNumber = $scope.pageNumber + 1; 
            MigrationRestAPIService.getBatchDetailspage(bactrequest,$scope.pageNumber,$scope.size).then(
                function(success) {
                    $scope.batchDetailspageData= success.data.content; 
                    $scope.loadingbar =false; 
                    $scope.pageNumbers = [];
                    $scope.totalRecords = success.data.totalElements;
                    console.log( $scope.totalRecords)
                    $scope.totalPages = Math.ceil($scope.totalRecords/$scope.size);
                   if ($scope.totalPages  > 0) {
                    for (var i = 0; i < $scope.totalPages; i++) {
                        $scope.pageNumbers.push(i);
                        }
                   } 
                    console.log( $scope.batchDetailspageData)                     
                },
                function(error) {
                    MigrationRestAPIService.showErrorDialog(error);
                }
            ); 	
          }
          $scope.detailsprevious = function(){
              $scope.pageNumber = $scope.pageNumber - 1; 
              MigrationRestAPIService.getBatchDetailspage(bactrequest,$scope.pageNumber,$scope.size).then(
                function(success) {
                    $scope.batchDetailspageData= success.data.content; 
                    $scope.loadingbar =false; 
                    $scope.pageNumbers = [];
                    $scope.totalRecords = success.data.totalElements;
                    console.log( $scope.totalRecords)
                    $scope.totalPages = Math.ceil($scope.totalRecords/$scope.size);
                   if ($scope.totalPages  > 0) {
                    for (var i = 0; i < $scope.totalPages; i++) {
                        $scope.pageNumbers.push(i);
                        }
                   } 
                    console.log( $scope.batchDetailspageData)                     
                },
                function(error) {
                    MigrationRestAPIService.showErrorDialog(error);
                }
            );  	
          }  	 
          $scope.detailssendPageNumber = function(page) {
           $scope.pageNumber = page;
           MigrationRestAPIService.getBatchDetailspage(bactrequest,$scope.pageNumber,$scope.size).then(
            function(success) {
                $scope.batchDetailspageData= success.data.content; 
                $scope.loadingbar =false; 
                $scope.pageNumbers = [];
                $scope.totalRecords = success.data.totalElements;
                console.log( $scope.totalRecords)
                $scope.totalPages = Math.ceil($scope.totalRecords/$scope.size);
               if ($scope.totalPages  > 0) {
                for (var i = 0; i < $scope.totalPages; i++) {
                    $scope.pageNumbers.push(i);
                    }
               } 
                console.log( $scope.batchDetailspageData)                     
            },
            function(error) {
                MigrationRestAPIService.showErrorDialog(error);
            }
        );
       }
      $scope.goToBatchDetails=function(data){

        $state.go('app.migrations-BatchRecordsDetails', {id: data.id, })
        $scope.id=  data.id;
        $scope.loadingbar =true;
      }
   
   if($scope.id){
    var bactrequest={
        "batchId":$scope.id,
        "status": ["completed","failed"],
    }
    
    MigrationRestAPIService.getBatchDetailspage(bactrequest,$scope.pageNumber,$scope.size).then(
     function(success) {
         $scope.batchDetailspageData= success.data.content; 
         $scope.loadingbar =false; 
         $scope.pageNumbers = [];
         $scope.totalRecords = success.data.totalElements;
         console.log( $scope.totalRecords)
         $scope.totalPages = Math.ceil($scope.totalRecords/$scope.size);
        if ($scope.totalPages  > 0) {
         for (var i = 0; i < $scope.totalPages; i++) {
             $scope.pageNumbers.push(i);
             }
        } 
         console.log( $scope.batchDetailspageData)                     
     },
     function(error) {
         MigrationRestAPIService.showErrorDialog(error);
     }
 );
     
   }
   
      $scope.goBack=function(){
            $state.go('app.migrations')
        }
        $scope.goBackbatchrecords=function(){
            $state.go('app.migrations-BatchRecords')
        }
        $scope.sizeselect=function(size){
            $scope.size = size
            DocCtrl.documentationreportDetails();                
        }
     
    
        $scope.next = function(){	
            $scope.pageNumber = $scope.pageNumber + 1; 
             batchCtrl.batchlogsData();    	
          }
          $scope.previous = function(){
              $scope.pageNumber = $scope.pageNumber - 1; 
               batchCtrl.batchlogsData();    	
          }  	 
          $scope.sendPageNumber = function(page) {
           $scope.pageNumber = page;
            batchCtrl.batchlogsData();
       }
       batchCtrl.batchlogsData=function(){
        MigrationRestAPIService.getBatchDetails($scope.pageNumber,$scope.size).then(
            function(success) {
                $scope.batchDetails= success.data.content; 
                $scope.loadingbar =false;
                $scope.pageNumbers = [];
                $scope.totalRecords = success.data.totalElements;
                console.log( $scope.totalRecords)
                $scope.totalPages = Math.ceil($scope.totalRecords/$scope.size);
               if ($scope.totalPages  > 0) {
                for (var i = 0; i < $scope.totalPages; i++) {
                    $scope.pageNumbers.push(i);
                    }
               } 

                $scope.diferencehour=[]
                for(var i=0;i<$scope.batchDetails.length;i++){
                    var startDate = new Date($scope.batchDetails[i].createdDate);
                    var endDate = new Date($scope.batchDetails[i].lastModifiedDate);
                    var milisecondsDiff = endDate - startDate;
                    batchCtrl.hour=  Math.floor(milisecondsDiff/(1000*60*60)).toLocaleString(undefined, {minimumIntegerDigits: 2}) + ":" + (Math.floor(milisecondsDiff/(1000*60))%60).toLocaleString(undefined, {minimumIntegerDigits: 2})  + ":" + (Math.floor(milisecondsDiff/1000)%60).toLocaleString(undefined, {minimumIntegerDigits: 2});
                    $scope.batchDetails[i]["differencehours"]=batchCtrl.hour
                    $scope.diferencehour.push(batchCtrl.hour)  
                    
                } 
             },
            function(error) {
                MigrationRestAPIService.showErrorDialog(error);
            }
        );
       }
        init();
        function init(){
            $scope.loadingbar =true;
            if(!$scope.id){
                batchCtrl.batchlogsData();
            }
             
            
         
    
        }
        
    }


         
})();
(function ()
{
    'use strict';

    angular
        .module('app.mycontent.outbox',[])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider.state('app.mycontent_outbox', {
            url      : '/outbox',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/mycontent/Outbox/outbox.html',
                    controller : 'OutboxController as outboxCtrl'
                }
            },
            resolve: {
                RestAPIService: 'RestAPIService',
                ReqOutbox: function(RestAPIService) {
                    return RestAPIService.getRequestOutbox();
                }
                  },
            bodyClass: 'mycontent-outbox'
        })
        .state('app.mycontent_outbox.details', {
            url: '/details/:requestType',
            params: {
                requestType: null
            },
            views: {
                'content@app': {
                    templateUrl: 'app/main/mycontent/Outbox/outbox.workitems.html',
                    controller: 'OutboxController as outboxCtrl'
                }
            }
        });     
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.mycontent.outbox')
        .controller('OutboxController', OutboxController);

    /** @ngInject */
    function OutboxController($state, $stateParams, $scope, $http, RestAPIService, CommonUtil, ReqOutbox, $sce, $mdDialog)
    {
       // var outboxCtrl = this;
       
       var outboxCtrl = this;
       $scope.docTypes = [];
       $scope.docTypes = ReqOutbox.data;
       $scope.isUpdatable = true;
       
       $scope.addLineItem = function() {
           $scope.lineItems.push({
               temp : null        		 
           });
       }
       $scope.removeLineItem = function(index) {
           $scope.lineItems.splice(index, 1);
       }
       
       $scope.goToOutbox = function() {
           $state.go('app.mycontent_outbox');
       }
       
       $scope.goToWorkitems = function(requestType) {
           $state.go('app.mycontent_outbox.details', { 'requestType': requestType });
       }
       resetRequest();
       function resetRequest() {
           $scope.header = {};
           $scope.lineItems = [{
               temp : null    		 
           }]; 
           $scope.formHeader = false;
           $scope.formLineitem = false;
           outboxCtrl.inboxComment = {};
           $scope.isReadOnlyHeaderCurrency = false;
           $scope.workitemInfo = {};
       }        
       $scope.selectWorkitem = function(workitem) {
           $scope.selectedWorkitem = workitem.docId;
           RestAPIService.getOutboxWorkitemInfo($stateParams.requestType, workitem.docId).then(function(responce) {
               viewForm(responce.data);
               $scope.workitemInfo = responce.data;
               $scope.workitemInfo.logs.forEach(function(h){
                   if(h.activityText == "Approve"){
                       h['icon'] = "icon-star-outline";
                   }
                   else if(h.activityText == "Confirm"){
                       h['icon'] = "icon-check";
                   }
                   else if(h.activityText ==""){
                       h['icon'] ="icon-content-save";
                   }
                   else if(h.activityText =="CollaboratewithIndexer"){
                       h['icon'] ="icon-content-save";
                   }
                   else if(h.activityText =="Cancel"){
                       h['icon'] ="icon-cancel";
                   }
                   else if(h.activityText == "ChangeException"){
                       h['icon'] = "icon-check";
                   }                	
                  })
               $scope.header = responce.data.header;
               if($scope.header.BASE_DATE!=undefined || $scope.header.BASE_DATE!= null){
                   outboxCtrl.Date = $scope.header.BASE_DATE;
                $scope.header.BASE_DATE = outboxCtrl.Date.substring(6,8)+'-'+outboxCtrl.Date.substring(4,6)+'-'+outboxCtrl.Date.substring(0,4);
               }
               if($scope.header.BLDAT!=undefined || $scope.header.BLDAT!= null || $scope.header.BUDAT!=undefined || $scope.header.BUDAT!=null){                	
                   if($scope.header.BLDAT){
                       outboxCtrl.InvoiceDate = $scope.header.BLDAT;                  
                   $scope.header.BLDAT = outboxCtrl.InvoiceDate.substring(6,8)+'-'+outboxCtrl.InvoiceDate.substring(4,6)+'-'+outboxCtrl.InvoiceDate.substring(0,4);
                   }
                   if($scope.header.BUDAT){
                       outboxCtrl.PostingDate = $scope.header.BUDAT;                	
                       $scope.header.BUDAT = outboxCtrl.PostingDate.substring(6,8)+'-'+outboxCtrl.PostingDate.substring(4,6)+'-'+outboxCtrl.PostingDate.substring(0,4);
                   }
               }
               $scope.lineItems = responce.data.lineItems;
               $scope.formHeader = true;
               $scope.formLineitem = true;                
               if(responce.data.dataChange == 'D'){
                   $scope.isUpdatable = false;
                   $scope.isReadOnlyHeaderCurrency = true;
               }
               
           }, function(error) {
               RestAPIService.showErrorDialog(error);
           })
       };
       outboxCtrl.fileIcon = function(file) {
           return CommonUtil.getIconForFile(file);
       }

       $scope.myView = true;
       $scope.changeView = function() {
           $scope.myView = !$scope.myView;
       };

       $scope.search = function(query) {
           $scope.searchString = query;
       };
       $scope.selectedTab = 0;
       $scope.changeTab = function() {
           if ( $scope.selectedTab > 0 ) {
               $scope.selectedTab = 0;
           }
           else {
               $scope.selectedTab--;
           }            
       }
       function viewForm(data){
           $scope.currentFormHeader = $sce.trustAsHtml(data.mainLayout.replace(/&quot;/g,'"'));
           $scope.currentFormLineitem = $sce.trustAsHtml(data.detailsLayout.replace(/&quot;/g,'"'));
       }
       $scope.downloadFile =function(file,reqId){        	
                   var archiveId = file.archiveId;
                 var ReqId = reqId;
                 var archiveDocId = file.archiveDocId;
                   //console.log(file);
              RestAPIService.downloadAttachment(ReqId,archiveId,archiveDocId).then(
                 function(success) { 
                         var headers = success.headers();
                         //alert(JSON.stringify(headers));
                         var data = success.data;
                         //alert(data);
                         //var filename = headers['x-filename'];
                         var filename = file.fileName;
                         var contentType = headers['content-type'];
                         var linkElement = document.createElement('a');
                         try {
                             var blob = new Blob([data], { type: contentType });
                             var url = window.URL.createObjectURL(blob);
                             linkElement.setAttribute('href', url);
                             linkElement.setAttribute("download", filename);
                             var clickEvent = new MouseEvent("click", {
                                 "view": window,
                                 "bubbles": true,
                                 "cancelable": false
                             });
                             linkElement.dispatchEvent(clickEvent);
                         } catch (ex) {
                             console.log(ex);
                         }
                 },
                 function(error) {
                     console.log('ERROR Downloading the file ********');
                     RestAPIService.showErrorDialog(error);
                 }
             );
         }
       $scope.getAllWorkitems = function() {
           RestAPIService.getAllOutboxWorkitems($stateParams.requestType).then(
                   function(success) {
                       $scope.allWorkitems = success.data;
                   },
                   function(error) {
                       RestAPIService.showErrorDialog(error);
                   });
       };
       
       // Initial load
       init();

       function init() {
           if ($stateParams.requestType != undefined) {
               $scope.getAllWorkitems();            	
           }
       }
       $scope.fileIcon = function(fileType){
              var icon ={};
              if(fileType == "folder"){
                    icon = "icon-folder";
                }                        
                else if(fileType.indexOf("jpg")!= -1){
                    icon = "icon-file-image";
                }
                else if(fileType.indexOf("jpeg")!= -1){
                    icon = "icon-file-image";
                }
                else if(fileType.indexOf("png")!= -1){
                    icon = "icon-file-image";
                }
                else if(fileType.indexOf("pdf")!= -1){
                    icon = "icon-file-pdf-box";
                }
                else if(fileType.indexOf("txt")!= -1){
                    icon = "icon-clipboard-text";
                }
                else if(fileType.indexOf("html")!= -1){
                    icon = "icon-language-html5";
                }
                else if(fileType.indexOf("xl")!= -1){
                    icon = "icon-file-excel";
                }
                else if(fileType.indexOf("word")!= -1){
                    icon = "icon-file-word";
                }
                else if(fileType.indexOf("xml")!= -1){
                    icon = "icon-file-xml";
                }
                else if(fileType.indexOf("doc")!= -1){
                    icon = "icon-file-document";
                }  
                else if(fileType.indexOf("docx")!= -1){
                    icon = "icon-file-document";
                }
                else if(fileType.indexOf("json")!= -1){
                    icon = "icon-clipboard-text";
                }                      

                else{
                    icon = "icon-file-document";
                }
                return icon;
                console.log(icon);
          }
       $scope.preview =function(ev,file,reqId){
           outboxCtrl.file =file;
           outboxCtrl.ReqId = reqId;
           outboxCtrl.url = file.url;
           //console.log(file);
           outboxCtrl.archiveId = file.archiveId;
           outboxCtrl.archiveDocId = file.archiveDocId;
            
           $mdDialog.show({
              controller: DialogController,
              templateUrl: 'app/main/mycontent/inbox/previewFiles.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose:true
            });
       }
       function DialogController($scope, $mdDialog, $sce, $sessionStorage) {
           $scope.fileVis = false;
          $scope.imgVis= false;
          $scope.cancel = function() {
              $mdDialog.cancel();
          };
            //console.log(ReqId); 
       var jwtToken = $sessionStorage.currentUser.token.trim();
       if(jwtToken != undefined && outboxCtrl.ReqId != undefined) {
       var encodedURI = encodeURIComponent(baseUrl+'/api/requests/inbox/filedownload?archiveId='+outboxCtrl.archiveId+'&requestId='+outboxCtrl.ReqId+'&archiveDocId='+outboxCtrl.archiveDocId+'&attachment=false&jwtToken='+jwtToken);
                 

           if(outboxCtrl.file.fileType =="jpg" || outboxCtrl.file.fileType =="JPG" || outboxCtrl.file.fileType =="jpeg" || outboxCtrl.file.fileType =="JPEG" || outboxCtrl.file.fileType =="PNG" || outboxCtrl.file.fileType =="png"){
            $scope.imgVis= true;
            $scope.fileURL= encodedURI;
           }else{
            $scope.fileVis= true;
            $scope.fileURL = $sce.trustAsResourceUrl('https://docs.google.com/gview?url='+encodedURI+'&embedded=true');
           }
       }
   }
       
   
    }


         
})();
(function ()
{
    'use strict';

    angular
        .module('app.mycontent.inbox', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider.state('app.mycontent_inbox', {
            url      : '/inbox',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/mycontent/Inbox/inbox.html',
                    controller : 'InboxController as inboxCtrl'
                }
            },
            resolve: {
                RestAPIService: 'RestAPIService',
                ReqInbox: function(RestAPIService) {
                    return RestAPIService.getRequestGroupDoctypes();
                }               
            },
            bodyClass: 'mycontent-inbox'
        })
        .state('app.mycontent_inbox.details', {
            url: '/details/:requestType',
            params: {
                requestType: null,
                displayName:null
            },
            views: {
                'content@app': {
                    templateUrl: 'app/main/mycontent/Inbox/inbox.workitems.html',
                    controller: 'InboxController as inboxCtrl'
                }
            }
        });     
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.mycontent.inbox')
        .controller('InboxController', InboxController);

    /** @ngInject */
    var ReqId = ""; 
    var archiveId = ""; 
    var archiveDocId ="";
    function InboxController($state, $stateParams, $scope, $http, RestAPIService, CommonUtil, ReqInbox, $sce, $mdDialog) {        
        var inboxCtrl = this;
        $scope.docTypes = [];
        $scope.docTypes = ReqInbox.data;
       // console.log($scope.docTypes);
        $scope.isUpdatable = true;
         
        $scope.addLineItem = function() {
        	$scope.lineItems.push({
        		temp : null        		 
            });
        }
        $scope.removeLineItem = function(index) {
        	$scope.lineItems.splice(index, 1);
        }
        
        $scope.goToWorkitems = function(requestType,displayName) {
        
            $state.go('app.mycontent_inbox.details', { 'requestType': requestType ,'displayName':displayName });
            
        }
        resetRequest();
        function resetRequest() {
        	$scope.header = {};
            $scope.lineItems = [{
        		temp : null    		 
            }]; 
            $scope.formHeader = false;
            $scope.formLineitem = false;
            inboxCtrl.inboxComment = {};
            $scope.isReadOnlyHeaderCurrency = false;
            $scope.workitemInfo = {};
            $scope.attachmentfiles = [];
        }
       
        $scope.selectWorkitem = function(workitem) {
        	//console.log(workitem);
        	$scope.selectedWorkitem = workitem.docId;
            RestAPIService.getInboxWorkitemInfo($stateParams.requestType, workitem.docId).then(function(responce) {
            	resetRequest();
            	viewForm(responce.data);
            	 $scope.displayName = $stateParams.displayName;                
                $scope.workitemInfo = responce.data;
                $scope.workitemInfo.logs.forEach(function(h){
                	if(h.activityText == "Approve"){
                		h['icon'] = "icon-star-outline";
                	}
                	else if(h.activityText == "Confirm"){
                		h['icon'] = "icon-check";
                	}
                	else if(h.activityText ==""){
                		h['icon'] ="icon-content-save";
                	}
                	else if(h.activityText =="CollaborateBack"){
                		h['icon'] ="icon-content-save";
                	}
                	else if(h.activityText =="Cancel"){
                		h['icon'] ="icon-cancel";
                	}
                	else if(h.activityText == "Elimination"){
                		h['icon'] = "icon-check";
                	}
                	
   		        })
                console.log($scope.workitemInfo);
                $scope.header = responce.data.header;
              /*  var d = new Date();*/            
                if($scope.header.BASE_DATE!=undefined || $scope.header.BASE_DATE!= null){
                    inboxCtrl.Date = $scope.header.BASE_DATE;
                	/*d.setYear($scope.header.BASE_DATE.substring(0,4));
                    d.setMonth($scope.header.BASE_DATE.substring(4,6)-1);
                    d.setDate($scope.header.BASE_DATE.substring(6,8));*/
                    $scope.header.BASE_DATE = inboxCtrl.Date.substring(6,8)+'-'+inboxCtrl.Date.substring(4,6)+'-'+inboxCtrl.Date.substring(0,4);
                }
                if($scope.header.BLDAT!=undefined || $scope.header.BLDAT!= null || $scope.header.BUDAT!=undefined || $scope.header.BUDAT!=null){
	
                	if($scope.header.BLDAT){
                		inboxCtrl.InvoiceDate = $scope.header.BLDAT;                  
                    $scope.header.BLDAT = inboxCtrl.InvoiceDate.substring(6,8)+'-'+inboxCtrl.InvoiceDate.substring(4,6)+'-'+inboxCtrl.InvoiceDate.substring(0,4);
                	}
                	if($scope.header.BUDAT){
                		inboxCtrl.PostingDate = $scope.header.BUDAT;
                		$scope.header.BUDAT = inboxCtrl.PostingDate.substring(6,8)+'-'+inboxCtrl.PostingDate.substring(4,6)+'-'+inboxCtrl.PostingDate.substring(0,4);
                	}
                }
                
                $scope.lineItems = responce.data.lineItems;
                $scope.formHeader = true;
                $scope.formLineitem = true;                
                if(responce.data.dataChange == 'D'){
                	$scope.isUpdatable = false;
                	$scope.isReadOnlyHeaderCurrency = true;
                }
                
            }, function(error) {
                RestAPIService.showErrorDialog(error);
            })
        };

        $scope.updateHeader = function() {
            console.log("Update Header call ---",$scope.header)
        }
        
        $scope.updateLineItems = function() {
            console.log("Update Line Items call ---",$scope.lineItems)
        }
        $scope.selectedTab = 0;
        $scope.changeTab = function() {
            if ( $scope.selectedTab > 0 ) {
                $scope.selectedTab = 0;
            }
            else {
                $scope.selectedTab--;
            }    
        }
 $scope.fileIcon = function(fileType){ 	

           	
           	var icon ={};
               if(fileType == "folder"){
                     icon = "icon-folder";
                 }                        
                 else if(fileType.indexOf("jpg")!= -1){
                     icon = "icon-file-image";
                 }
                 else if(fileType.indexOf("jpeg")!= -1){
                     icon = "icon-file-image";
                 }
                 else if(fileType.indexOf("png")!= -1){
                     icon = "icon-file-image";
                 }
                 else if(fileType.indexOf("pdf")!= -1){
                     icon = "icon-file-pdf-box";
                 }
                 else if(fileType.indexOf("txt")!= -1){
                     icon = "icon-clipboard-text";
                 }
                 else if(fileType.indexOf("html")!= -1){
                     icon = "icon-language-html5";
                 }
                 else if(fileType.indexOf("xl")!= -1){
                     icon = "icon-file-excel";
                 }
                 else if(fileType.indexOf("word")!= -1){
                     icon = "icon-file-word";
                 }
                 else if(fileType.indexOf("xml")!= -1){
                     icon = "icon-file-xml";
                 }
                 else if(fileType.indexOf("doc")!= -1){
                     icon = "icon-file-document";
                 }  
                 else if(fileType.indexOf("docx")!= -1){
                     icon = "icon-file-document";
                 }
                 else if(fileType.indexOf("json")!= -1){
                     icon = "icon-clipboard-text";
                 }                      

                 else{
                     icon = "icon-file-document";
                 }
                 return icon;
                 console.log(icon);
           }
        
        
        
       $scope.downloadFile =function(file,reqId){
    	   archiveId = file.archiveId;
        		ReqId = reqId;
        		archiveDocId = file.archiveDocId;
        	  	//console.log(file);
        	
        	
        	 RestAPIService.downloadAttachment(ReqId,archiveId,archiveDocId).then(
                function(success) { 
                        var headers = success.headers();
                        //alert(JSON.stringify(headers));
                        var data = success.data;
                        //alert(data);
                        //var filename = headers['x-filename'];
                        var filename = file.fileName;
                        var contentType = headers['content-type'];
                        var linkElement = document.createElement('a');
                        try {
                            var blob = new Blob([data], { type: contentType });
                            var url = window.URL.createObjectURL(blob);
                            linkElement.setAttribute('href', url);
                            linkElement.setAttribute("download", filename);
                            var clickEvent = new MouseEvent("click", {
                                "view": window,
                                "bubbles": true,
                                "cancelable": false
                            });
                            linkElement.dispatchEvent(clickEvent);
                        } catch (ex) {
                            console.log(ex);
                        }
                },
                function(error) {
                    console.log('ERROR Downloading the file ********');
                    RestAPIService.showErrorDialog(error);
                }
            );
        }
       $scope.getDummyFileIcon =  function(index){
        inboxCtrl.icons = ['icon-file-pdf-box'];
           var totalNoOfIcons = inboxCtrl.icons.length;                        
           return inboxCtrl.icons[index%totalNoOfIcons];
       }
        
       inboxCtrl.fileIcon = function(file){
            return CommonUtil.getIconForFile(file);
        }
   //     ReqId = $scope.workitemInfo;
      //  console.log(ReqId);
        $scope.preview =function(ev,file,reqId){
        	inboxCtrl.file =file;
        	ReqId = reqId;
        	inboxCtrl.url = file.url;
        	//console.log(file);
        	archiveId = file.archiveId;
        	archiveDocId = file.archiveDocId;
        	 
     	   $mdDialog.show({
     	      controller: DialogController,
     	      templateUrl: 'app/main/mycontent/inbox/previewFiles.html',
     	      parent: angular.element(document.body),
     	      targetEvent: ev,
     	      clickOutsideToClose:true
     	    });
        }
        function DialogController($scope, $mdDialog, $sce, $sessionStorage) {
        	   $scope.fileVis = false;
               $scope.imgVis= false;
               $scope.cancel = function() {
                   $mdDialog.cancel();
               };
        	 	//console.log(ReqId); 
        	var jwtToken = $sessionStorage.currentUser.token.trim();
        	if(jwtToken != undefined && ReqId != undefined) {
        	/*var encodedURI = encodeURIComponent(baseUrl+'/api/requests/inbox/filedownload?archiveId='+archiveId+'&requestId='+ReqId+'&archiveDocId='+archiveDocId+'&attachment=false&jwtToken='+jwtToken);
        	$scope.fileURL = $sce.trustAsResourceUrl('https://docs.google.com/gview?url='+encodedURI+'&embedded=true');*/
        		var encodedURI = encodeURIComponent(inboxCtrl.url);
                if(inboxCtrl.file.fileType =="jpg" || inboxCtrl.file.fileType =="JPG" || inboxCtrl.file.fileType =="jpeg" || inboxCtrl.file.fileType =="JPEG" || inboxCtrl.file.fileType =="PNG" || inboxCtrl.file.fileType =="png"){
                 $scope.imgVis= true;
                 $scope.fileURL =inboxCtrl.file.url;
                }else{
                 $scope.fileVis= true;
                 $scope.fileURL = $sce.trustAsResourceUrl('https://docs.google.com/gview?url='+encodedURI+'&embedded=true');
        		
        	}
        }
        }
        $scope.addComment = function(ev) {
        	inboxCtrl.selectedWorkitemInfo = $scope.workitemInfo;
            $mdDialog.show({
                controller: AddCommentController,
                templateUrl: 'app/main/mycontent/inbox/add.comment.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            });
        }
        
        function AddCommentController($scope, $mdDialog) {
        	var workItem = inboxCtrl.selectedWorkitemInfo;
        	var requestId = workItem.requestId;
        	$scope.inboxComment = inboxCtrl.inboxComment[requestId];
        	
            $scope.hide = function() {
                $mdDialog.hide();
            };
           
            $scope.cancel = function() {
            	$mdDialog.cancel();
            };
            
            $scope.saveComment = function(ev, comment) {
            	if(undefined != requestId){
            		inboxCtrl.inboxComment[requestId] = comment;
            	} 
            	$mdDialog.cancel();
            };
        }
        
        
        $scope.collaborate = function(ev) {
        	        	
            $mdDialog.show({
                controller: CollaborateController,
                templateUrl: 'app/main/mycontent/inbox/collabrate.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            });
        }
        
        function CollaborateController($scope, $mdDialog) {
        	 $scope.tableVisibility=false;
            $scope.hide = function() {
                $mdDialog.hide();
            };
           
            $scope.cancel = function() {
            	$mdDialog.cancel();
            };
            
            $scope.searchMember = function(memberdata){ 
                var q = "";
               if(memberdata == undefined || angular.equals(memberdata, {}) ){
                   $scope.msgVisibility=true;
                   $scope.tableVisibility=false;
                   $scope.member = {}; 
               }else{ 
                   if((memberdata.name !=""&&memberdata.name !=undefined) && (memberdata.email !="" && memberdata.email !=undefined)){
                     q = memberdata.name;
                   }else if((memberdata.name ==""|| memberdata.name==undefined) && (memberdata.email !="" && memberdata.email != undefined)){
                       q = memberdata.email;
                   }else if(memberdata.name !="" && (memberdata.email ==""||memberdata.email==undefined)){
                       q = memberdata.name;
                   }
                   $scope.searchedMembers= [];  
                   var type="user"
                   RestAPIService.searchMemberForGroups(q,type).then(
                   function(success){
                       $scope.searchedMembers = success.data;
                       $scope.msgVisibility=false;
                       $scope.tableVisibility=true;
                       $scope.member = {};                        
                   },function(error){
                       RestAPIService.showErrorDialog(error);
                   }
                   );
               }                       
           }
            $scope.Users =[];
            $scope.addMember = function(member){
            	var UserObj ={};
            	UserObj.login =member.login;
            	$scope.Users.push(UserObj);
            	
            	
            	
            	
            }
            
           
        }
        
        $scope.goToInbox = function() {
            $state.go('app.mycontent_inbox');
        }
        
        $scope.setAttachmentFile = function(element) {
            var formData = new FormData();
            $scope.$apply(function() {
                for (var i = 0; i < element.files.length; i++) {
                    formData.append('file', element.files[i]);
                    $scope.attachmentfiles.push(element.files[i]);
                }
            });
            
        };
        
        
        
        inboxCtrl.fileIcon = function(file) {
       
            return CommonUtil.getIconForFile(file);
        }

        $scope.myView = true;
        $scope.changeView = function() {
            $scope.myView = !$scope.myView;
        };

        $scope.search = function(query) {
            $scope.searchString = query;
        };
        
        
        $scope.processActvity = function(actvity, ev) {
        	inboxCtrl.newAttachments = $scope.attachmentfiles;
        	inboxCtrl.activity = actvity;
        	        	
        	inboxCtrl.selectedWorkitemInfo = $scope.workitemInfo;
            $mdDialog.show({
                controller: ProcessController,
                templateUrl: 'app/main/mycontent/inbox/add.comment.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            });
         }
  function ProcessController($scope, $mdDialog) {
        	
        	$scope.activityText = inboxCtrl.activity.buttonText;
            $scope.cancel = function() {
            	$mdDialog.cancel();
            };
            
            $scope.processItem = function(ev, comment) {
            	$mdDialog.cancel();
            	delete inboxCtrl.activity.$$hashKey;
            	var json = {activities: []};
            	json.comment = comment;
            	json.activities.push(inboxCtrl.activity);
            	json.header = inboxCtrl.selectedWorkitemInfo.header;
            	if(json.header.BASE_DATE){
            		json.header.BASE_DATE =inboxCtrl.Date;
            	}
            	if(json.header.BLDAT){
            		json.header.BLDAT =inboxCtrl.InvoiceDate;
            	}
            	if(json.header.BUDAT){
            		json.header.BUDAT =inboxCtrl.PostingDate;
            	}
            	json.lineItems = inboxCtrl.selectedWorkitemInfo.lineItems;
            	if (inboxCtrl.newAttachments.length > 0) {               	 
                	  $scope.allAttachments = inboxCtrl.selectedWorkitemInfo.attachments.concat(inboxCtrl.newAttachments);                  
                  }
            	    RestAPIService.submitRequestResource(inboxCtrl.selectedWorkitemInfo.requestId, inboxCtrl.selectedWorkitemInfo.requestType, json, $scope.allAttachments).then(
            			function(success) {    			
                        if(success.status == 200){
                        	resetRequest();                        	
                        	if(inboxCtrl.activity.buttonText == "Approve"){
                        		$mdDialog.show(
                            		      $mdDialog.alert()
                            		        .parent(angular.element(document.querySelector('#popupContainer')))
                            		        .clickOutsideToClose(true)
                            		        .title('Success.')
                            		        .htmlContent("<h4><b>"+inboxCtrl.selectedWorkitemInfo.requestId+ "</b> was Approved successfully.</h4>")
                            		        .ariaLabel('Alert Dialog Demo')
                            		        .ok('Ok')
//                            		        .targetEvent(ev)
                            		    );
                        	} else {
                        		$mdDialog.show(
                            		      $mdDialog.alert()
                            		        .parent(angular.element(document.querySelector('#popupContainer')))
                            		        .clickOutsideToClose(true)
                            		        .title('Success.')
                            		        .htmlContent("<h4><b>"+inboxCtrl.selectedWorkitemInfo.requestId+ "</b> was Rejected successfully.</h4>")
                            		        .ariaLabel('Alert Dialog Demo')
                            		        .ok('Ok')
//                            		        .targetEvent(ev)
                            		    );
                        	}
                        	$state.reload();
                        }
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    });
               
           	
            	$mdDialog.cancel();
            };
        }     
        
     

       /* $scope.processActvity = function(actvity) {
        	delete actvity.$$hashKey;
        	var requestId = $scope.workitemInfo.requestId;
        	var comment = contentCtrl.inboxComment[requestId];
        	var json = {activities: []};
        	json.comment = comment;
        	json.activities.push(actvity);
        	json.header = $scope.workitemInfo.header;
        	if(json.header.BASE_DATE){
        		json.header.BASE_DATE =contentCtrl.Date;
        	}
        	if(json.header.BLDAT){
        		json.header.BLDAT =contentCtrl.InvoiceDate;
        	}
        	if(json.header.BUDAT){
        		json.header.BUDAT =contentCtrl.PostingDate;
        	}
        	json.lineItems = $scope.workitemInfo.lineItems;
        	if($scope.attachmentfiles.length > 0){
        		$scope.workitemInfo.attachments.push($scope.attachmentfiles);
        		$scope.newAttachments = $scope.workitemInfo.attachments.concat($scope.attachmentfiles);
        	}
        	
        	if(json.comment==null){
        		RestAPIService.successTostDialog("Please add Comment before Approve/Reject");
        		
        	}
        	 else if(json.comment!=null){
        		
        	    RestAPIService.submitRequestResource(requestId, $scope.workitemInfo.requestType, json, $scope.newAttachments).then(
        			function(success) {    			
                    if(success.status == 200){
                    	resetRequest();
                    	$scope.getAllWorkitems();
                    	if(actvity.buttonText == "Approve"){
                    		 RestAPIService.successTostDialog("Request Approved successfully");
                    	} else {
                    		 RestAPIService.successTostDialog("Request Rejectd successfully");
                    	}
                    }
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                });
            }
         }*/
        
        function viewForm(data){
            $scope.currentFormHeader = $sce.trustAsHtml(data.mainLayout.replace(/&quot;/g,'"'));
            $scope.currentFormLineitem = $sce.trustAsHtml(data.detailsLayout.replace(/&quot;/g,'"'));
        }
        
        $scope.getAllWorkitems = function() {
        	RestAPIService.getAllInboxWorkitems($stateParams.requestType).then(
                    function(success) {
                        $scope.allWorkitems = success.data;
                       // console.log($scope.allWorkitems);
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    });
        };
        
        // Initial load
        init();

        function init() {
            if ($stateParams.requestType != undefined) {
            	$scope.getAllWorkitems();            	
            }
        }
    




    }


         
})();
(function ()
{
    'use strict';

    angular
        .module('app.administration')
        .controller('WMController', WMController);

    /** @ngInject */
    function WMController($state,$scope, $mdDialog, RestAPIService,Actvitys,$filter)
    {
        var workflowCtrl = this;
        $("#vertical-navigation").hide();
        $("#content-container").css({ "margin-left": "0px" });
            $scope.activitys = Actvitys.data;        
         
       $scope.goToPreviousState = function() {
         	$state.go("app.mycontent");
          	$("#vertical-navigation").show();
          	$("#content-container").css({ "margin-left": "0px" });
         }
         $scope.dtOptions = 
        		 {
        	           dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
        	            pagingType: 'simple',
        	            autoWidth : false,
        	            responsive: true
        	        };
            
         $scope.createWorkflow  = function(ev) {
             $mdDialog.show({
                 controller: createWorkflowDialogController,
                 templateUrl: 'app/main/administration/workflow-management/create.workflow.dialog.html',
                 parent: angular.element(document.body),
                 targetEvent: ev,
                 clickOutsideToClose: true,
                 fullscreen: $scope.customFullscreen
             })
             $scope.cancel = function() {
                 $scope.user = {};
             };
         };


         function createWorkflowDialogController($scope, $mdDialog) {
        	 $scope.activitytypes = ["Portal", "SAP","Document"];
             $scope.user={};
             $scope.hide = function() {
             $mdDialog.hide();
             };
             $scope.cancel = function() {
                 $mdDialog.cancel();
             };

             $scope.save = function(user) {
            	 RestAPIService.createActivity(user).then(
             function(success) {
                    	 RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                         //Create successful. Need to refresh
                         $state.reload();
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                     }
                 );
                 $mdDialog.hide(user);
             };

         }
       
         workflowCtrl.currentUser = {};
         $scope.updateRequestDialog  = function(ev) {
        	 var datares = $filter('filter')($scope.activitys, {'id': ev.id});
        	 workflowCtrl.currentUser = angular.copy(datares[0]);
             $mdDialog.show({
                 controller: updateRequestDialogController,
                 templateUrl: 'app/main/administration/workflow-management/update.workflow.dialog.html',
                 parent: angular.element(document.body),
                 targetEvent: ev,
                 clickOutsideToClose: true,
                 fullscreen: $scope.customFullscreen
             })
         };

         function updateRequestDialogController($scope, $mdDialog) {
        	  $scope.activitytypes = ["Portal", "SAP","Document"];
             $scope.currentUser = workflowCtrl.currentUser;
             console.log( $scope.currentUser);

             $scope.hide = function() {
                 $mdDialog.hide();
             };
             $scope.cancel = function() {
                 $mdDialog.cancel();
             };
             $scope.update = function(user) {
            	 RestAPIService.updateActivity(user).then(
                     function(success) {                     
    	 RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                         $state.reload();
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                     }
                 );
                 $mdDialog.hide(user);
             };
         }


       $scope.deleteActivity = function(ev) {
        var datares = $filter('filter')($scope.activitys, {'id': ev.id});
                  var confirm = $mdDialog.confirm()
                 .title('Remove')
                 .textContent(' Activity ' +  datares[0].name + ' ' + ' will be permanently deleted. Continue ?')
                 .targetEvent(ev)
                 .ok('Ok')
                 .cancel('Cancel');
             $mdDialog.show(confirm).then(function() {

                 RestAPIService.deleteActivity(ev.id).then(
                     function(success) {
                    	 RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                       
                         $state.reload();
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                        }
                      );
                     },      
                     function() {
                    $mdDialog.cancel();
                   });
                   }

        }   
})();
 (function() {
     'use strict';
     angular
         .module('app.administration')
         .controller('SystemLandscapeController', SystemLandscapeController);

     function SystemLandscapeController($state, $http, $scope, $mdDialog, RestAPIService, ILMSystems) {
    	 var ilmSystems = this;
    	 $scope.ILMSystems = ILMSystems.data;   
 ilmSystems.dtOptions = {
                 
                 dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                autoWidth : false,
                responsive: true
                 }; 

    	 $scope.creatDirDialog = function(ev){    		 
    		 $mdDialog.show({
                 controller: CreateDirDialogController,
                 templateUrl: 'app/main/administration/systemLandScapeDir/createDialog.html',
                 parent: angular.element(document.body),
                 targetEvent: ev,
                 clickOutsideToClose: true,
                 fullscreen: $scope.customFullscreen
             })            
    	 }
    	 function CreateDirDialogController($scope, $mdDialog){
    		 
    		 $scope.createSystem = function(systemData){
    			 $mdDialog.cancel();
    			 $scope.ipAddresses =  systemData.ipAddress.split(';');
    			 systemData.ipAddress= $scope.ipAddresses;
            	 RestAPIService.createILMSystem(systemData).then(
                     function(success) {                    	 
                    	 $mdDialog.show(
                   		      $mdDialog.alert()
                   		        .parent(angular.element(document.querySelector('#popupContainer')))
                   		        .clickOutsideToClose(true)
                   		        .title('Success.')
//                   		        .textContent("System was created successfully.")
                   		        .htmlContent("System was created successfully.")
                   		        .ariaLabel('Alert Dialog Demo')
                   		        .ok('Ok')
//                   		        .targetEvent(ev)
                   		    );
                    	$state.reload();
                     },
                     function(error) {
                    	 RestAPIService.showErrorDialog(error);
                     }
                    
                 );
    		 }
    		 $scope.cancel = function() {
                $mdDialog.cancel();
             };
    	 }
    	 $scope.updateSystem= function(ev, system){
    		 ilmSystems.system = system;
    		 $mdDialog.show({
                 controller: UpdateStoreDialogController,
                 templateUrl: 'app/main/administration/systemLandScapeDir/updateDialog.html',
                 parent: angular.element(document.body),
                 targetEvent: ev,
                 clickOutsideToClose: true,
                 fullscreen: $scope.customFullscreen
             })
    	 }
    	 function UpdateStoreDialogController($scope, $mdDialog){
    		 $scope.system = ilmSystems.system;
    		 $scope.updateSystem = function(systemData){
    			 $mdDialog.cancel();
    			 $scope.ipAddresses =  systemData.ipAddress.split(';');
    			 systemData.ipAddress= $scope.ipAddresses;
            	 RestAPIService.updateILMSystem(systemData).then(
                     function(success) {                    	 
                    	 $mdDialog.show(
                   		      $mdDialog.alert()
                   		        .parent(angular.element(document.querySelector('#popupContainer')))
                   		        .clickOutsideToClose(true)
                   		        .title('Success.')
//                   		        .textContent("System was created successfully.")
                   		        .htmlContent("System was updated successfully.")
                   		        .ariaLabel('Alert Dialog Demo')
                   		        .ok('Ok')
//                   		        .targetEvent(ev)
                   		    );
                    	$state.reload();
                     },
                     function(error) {
                    	 RestAPIService.showErrorDialog(error);
                     }
                    
                 );
    		 }
    		 $scope.cancel = function() {
    			 $mdDialog.cancel();
             };
    	 }
    	 $scope.deleteSystem = function(data){
    		 var confirm = $mdDialog.confirm()
             .title('Remove')
             .textContent('System will be permanently deleted. Continue ?')
//             .targetEvent(ev)
             .ok('Ok')
             .cancel('Cancel');
    		 $mdDialog.show(confirm).then(function() {

                 RestAPIService.deleteSystem(data.id).then(
                     function(success) {
                    	 $mdDialog.show(
                      		      $mdDialog.alert()
                      		        .parent(angular.element(document.querySelector('#popupContainer')))
                      		        .clickOutsideToClose(true)
                      		        .title('Success.')
//                      		        .textContent("System was created successfully.")
                      		        .htmlContent("System was deleted successfully.")
                      		        .ariaLabel('Alert Dialog Demo')
                      		        .ok('Ok')
//                      		        .targetEvent(ev)
                      		    );
                         $state.reload();
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                     }
                 );
             }, function() {
                 $mdDialog.cancel();
             });
    	 }
    	
    	
    	 $scope.goToPreviousState = function() {
          	$state.go("app.overview");
           	$("#vertical-navigation").show();
           	$("#content-container").css({ "margin-left": "60px" });
          }
     }
 })();
/*(function ()
{
    'use strict';

    angular
        .module('app.administration')
        .controller('SettingsController', SettingsController);

    *//** @ngInject *//*
    function SettingsController($state,$scope)
    {
        var settingCtrl = this;
        $scope.Edit = true;
        settingCtrl.editMode =function(){
         $scope.Edit = !$scope.Edit;
         $scope.editButton=true;

        };
        settingCtrl.Save = function(){
        	$state.reload();

        };
        settingCtrl.Cancel = function(){
        	$scope.editButton =false;
        	$scope.Edit = !$scope.Edit;

        };

        $("#vertical-navigation").hide();
        $("#content-container").css({ "margin-left": "0px" });
        
        $scope.policys =["First character must be a letter, it must contain at least 4 characters and no more than 15 characters and no characters other than letters, numbers and the underscore may be used",
        "Password must be between 4 and 8 digits long and include at least one numeric digit",
        "Password must be at least 4 characters, no more than 8 characters, and must include at least one upper case letter, one lower case letter, and one numeric digit",
        "Matches any string between 4 and 8 characters in length. Limits the length of a string",
        "Requires one lower case letter, one upper case letter, one digit, 6-13 length, and no spaces"]
        
        
        $scope.goToPreviousState = function() {
        	$state.go("app.overview");
         	$("#vertical-navigation").show();
         	$("#content-container").css({ "margin-left": "55px" });
         }
        
        
        }   
})();*/


(function ()
{
    'use strict';

    angular
        .module('app.administration')
        .controller('SettingsController', SettingsController);

    /** @ngInject */
    function SettingsController($state,$scope, RestAPIService,$rootScope,$localStorage,$location,$window )
    {
        var settingCtrl = this;
        $scope.brandsettingdata ={};
    	$scope.systemDetails = {};

        $scope.selectedModel={
        		title: ""
        };
        $scope.Edit = true;
        settingCtrl.editMode =function(){
         $scope.Edit = !$scope.Edit;
         $scope.editButton=true;

        };
        settingCtrl.Save = function(){
        	$state.reload();

        };
        settingCtrl.Cancel = function(){
        	$scope.editButton =false;
        	$scope.Edit = !$scope.Edit;

        };

        $("#vertical-navigation").hide();
        $("#content-container").css({ "margin-left": "0px" });
        
        $scope.policys =["First character must be a letter, it must contain at least 4 characters and no more than 15 characters and no characters other than letters, numbers and the underscore may be used",
        "Password must be between 4 and 8 digits long and include at least one numeric digit",
        "Password must be at least 4 characters, no more than 8 characters, and must include at least one upper case letter, one lower case letter, and one numeric digit",
        "Matches any string between 4 and 8 characters in length. Limits the length of a string",
        "Requires one lower case letter, one upper case letter, one digit, 6-13 length, and no spaces"]
        
        
        $scope.goToPreviousState = function() {
        	$state.go('app.overview');
         	$("#vertical-navigation").show();
         	$("#content-container").css({ "margin-left": "60px" });
         }
        
        settingCtrl.getSystemDetails = function(){    
        	RestAPIService.getSystemDetails().then(
                     function(responce) {                  	 
                    	 if(responce.data.length>0){
                    		 $scope.systemDetails = responce.data[0];
                    	 }
                    	 console.log($scope.systemDetails);
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                     }
                 );
                
        }
        settingCtrl.savingSmartstoreDetails = function(data){
        	RestAPIService.savingSmartstoreDetails(data).then(function(responce){
        		alert("successfully updated");
        	},function(error){
        		RestAPIService.showErrorDialog(error);
        	})

        
        }
        
        settingCtrl.savingSolrDetails = function(data){
        	console.log(data);
        	RestAPIService.savingSolrDetails(data).then(function(responce){
        		alert("successfully updated");
        	},function(error){
        		RestAPIService.showErrorDialog(error);
        	})
        }
        
        settingCtrl.savesitesetting = function(){
        	RestAPIService.savingSitedata($scope.systemDetails).then(function(responce){
        		if(responce.data.site !=null && responce.data.site !=undefined){
        			delete $localStorage.sitesettingdata;
        			$localStorage.sitesettingdata = responce.data.site;
        		}else{
        			$localStorage.sitesettingdata = null;
        		}
        		if(responce.data.activeMenu !=null && responce.data.activeMenu !=undefined){
        			delete $localStorage.menubarsetting;
        			$localStorage.menubarsetting = responce.data.activeMenu;
        		}else{
        			$localStorage.menubarsetting = null;
        		}
        		alert("successfully updated");
        		$window.location.reload();
        	},function(error){
        		RestAPIService.showErrorDialog(error);
        	})
        }
        
       
      
      $scope.setLogoFile = function(element){
    	 var reader = new FileReader();
    	 reader.readAsDataURL(element.files[0]);
    	   reader.onload = function () {
    	     $('#logo').attr('src', reader.result);
    	     $rootScope.logodata = reader.result;
    	   };
    	   reader.onerror = function (error) {
    	     console.log('Error: ', error);
    	   };
      }
      
      $scope.setappbackgroundimage = function(element){
      	 var reader = new FileReader();
      	 reader.readAsDataURL(element.files[0]);
      	   reader.onload = function () {
      	     $('#appbackimage').attr('src', reader.result);
      	     $rootScope.appbackdata = reader.result;
      	   };
      	   reader.onerror = function (error) {
      	     console.log('Error: ', error);
      	   };
        }
      
      $scope.setbackgroundfile = function(element){
     	 var reader = new FileReader();
     	 reader.readAsDataURL(element.files[0]);
     	 var file = element.files[0];
     	
     	 var img = new Image();
     	 img.src = window.URL.createObjectURL( file );
     	 img.onload = function() {
             var width = img.naturalWidth,
                 height = img.naturalHeight;

             window.URL.revokeObjectURL( img.src );

             if( width >= 1920 && height >= 1080 ) {       		  
           	     $('#backimage').attr('src', reader.result);
           	     $rootScope.backdata = reader.result;
             }
             else {
               alert("Image size is too small");
             }
         };

       }
      $scope.setapplogo = function(element){
    	  var reader = new FileReader();
     	 reader.readAsDataURL(element.files[0]);
     	   reader.onload = function () {
     	     $('#applogo').attr('src', reader.result);
     	     $rootScope.applogodata = reader.result;
     	   };
     	   reader.onerror = function (error) {
     	     console.log('Error: ', error);
     	   };
      }
    

      $scope.saveData = function(event){
    	  	$scope.brandsettingdata = {};
    	  	$scope.brandsettingdata.logo = $rootScope.logodata;
    	  	$scope.brandsettingdata.backgroundimage = $rootScope.backdata;
    	  	$scope.brandsettingdata.backgroundcolor = document.getElementById("mycolor").value;
    	   	RestAPIService.savebrandsetting($scope.brandsettingdata).then(function(responce){
        		alert("successfully updated");
        	},function(error){
        		RestAPIService.showErrorDialog(error);
        	})
      }
      
      $scope.clear = function () {
    		    $('#backimage').attr('src','');
    		    document.getElementById('backroundimageUpload').value = "";
    		    $rootScope.backdata = "";
    	};
      
      $scope.updateData = function(event){
       	  if($scope.brandsettingdata == undefined){
    		  $scope.brandsettingdata ={};
    	  }
    	  	if($rootScope.logodata !=null && $rootScope.logodata  != undefined){
    	    	$scope.brandsettingdata.loginlogo = $rootScope.logodata;
     	  	}else{
     	 	if($scope.bdata != undefined){
    	  	$scope.brandsettingdata.loginlogo = $scope.bdata.loginlogo;
     	 	}
    	  	}
    	  	if($rootScope.backdata !=null && $rootScope.backdata  != undefined){
    	  	
    	  	$scope.brandsettingdata.loginbackgroundimage = $rootScope.backdata;
    	  	
    	  	}else{
    	  	if($scope.bdata  != undefined){
    	  	$scope.brandsettingdata.loginbackgroundimage = $scope.bdata.loginbackgroundimage;
    	  	}
    	  	}
    	  	if($rootScope.applogodata !=null && $rootScope.applogodata !=undefined){
    	     $scope.brandsettingdata.applogo = $rootScope.applogodata;
    	  	}else{
    	  	if($scope.bdata  != undefined){
    	  	 $scope.brandsettingdata.applogo = $scope.bdata.applogo;
    	  	}
    	  	}
      		if($rootScope.appbackdata !=null && $rootScope.appbackdata != undefined){
       	     $scope.brandsettingdata.appbackroundimage = $rootScope.appbackdata;
       	  	}else{
       	  	if( $scope.bdata != undefined){
       	  	$scope.brandsettingdata.appbackroundimage = $scope.bdata.appbackroundimage;
       	  	}
       	  	}
  	     $scope.brandsettingdata.loginbackgroundcolor = document.getElementById("mycolor").value;
  	     $scope.brandsettingdata.applabel =  $scope.selectedModel.title;
     	RestAPIService.updatebrandsetting($scope.brandsettingdata).then(function(response){
     		delete window.localStorage['branddata'];
     		window.localStorage['branddata'] = angular.toJson(response.data);
          	$state.reload();
             alert("successfully updated");
    	},function(error){
    		RestAPIService.showErrorDialog(error);
    	})
       }
      
      settingCtrl.brandsettingdata = function(){
          RestAPIService.getbrandsetting().then(
                  function(success) {
                	  if(success.data[0] !=null || success.data!= undefined){
                		  $scope.showbutton = false;
                		  $scope.bdata = success.data[0];
                		  $scope.brandsettingdata = success.data[0];
                		  if(window.localStorage['branddata'] !="null"){
                			  var loginlogodata = JSON.parse(window.localStorage['branddata']).loginlogo;
                    		  var loginbackrounddata =  JSON.parse(window.localStorage['branddata']).loginbackgroundimage;
                    		  var loginbackgroundcolor = JSON.parse(window.localStorage['branddata']).loginbackgroundcolor;
                    		  var applog = JSON.parse(window.localStorage['branddata']).applogo;
                    		  var applabel = JSON.parse(window.localStorage['branddata']).applabel; 
                    		  var appbackgoundimage = JSON.parse(window.localStorage['branddata']).appbackroundimage; 
                		  }
                		
                	       $('#logo').attr('src', loginlogodata);
                	       $('#backimage').attr('src',loginbackrounddata);
                	       $('#applogo').attr('src', applog);
                	       $('#appbackimage').attr('src', appbackgoundimage);
                	       $scope.selectedModel.title = applabel;
                	       if(document.getElementById("mycolor") != undefined || document.getElementById("mycolor") != null){
                	    	   document.getElementById("mycolor").value = loginbackgroundcolor;
                	       }
                	       
                          }else{
                        	  $scope.showbutton = true;
                          }
           
                	  },     function(error) {
                          RestAPIService.showErrorDialog(error);
                      }
             
              );
      }
      
  /*    init();
      
      function init(){

      }*/
 
        
        }   
})();
(function() {
    'use strict';

    angular
        .module('app.administration')
        .controller('ReqtypeController', ReqtypeController);

    /** @ngInject */
    function ReqtypeController($scope, $state, $location, $mdDialog, RestAPIService, Requests,$filter) {
        var reqtypeCtrl = this;
        $scope.Requests = Requests.data;
        $("#vertical-navigation").hide();
        $("#content-container").css({ "margin-left": "0px" });
        $scope.dtOptions = {
        		 dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
 	            pagingType: 'simple',
 	            autoWidth : false,
 	            responsive: true
        };
        $scope.goToPreviousState = function() {
        	$state.go("app.overview");
         	$("#vertical-navigation").show();
         	$("#content-container").css({ "margin-left": "60px" });
        }
        $scope.getRequestForms = function() {
            RestAPIService.getRequestForms().then(
                function(success) {
                	reqtypeCtrl.forms = success.data;
                	//alert(JSON.stringify(reqtypeCtrl.forms));
                   // reqtypeCtrl.ids = [];
                  /*  $scope.forms.forEach(function(h) {
                        reqtypeCtrl.ids.push(h.id);
                    });*/


                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                });
        };

        $scope.createRequestDialog = function(ev) {
            $mdDialog.show({
                controller: createRequestDialogController,
                templateUrl: 'app/main/administration/request-management/create.requestType.dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
            $scope.cancel = function() {
                // $scope.user = {};
            };
        };


        function createRequestDialogController($scope, $mdDialog) {

            //$scope.formIds =["test","test2","test_june29","test_07_07","test10_07","TEst11","Test01","test1"];
            $scope.icons = ["icon-currency-usd", "icon-file-document", "icon-timetable"];
            $scope.flowtypes = ["Portal", "SAP", "Hybrid"];
            $scope.ids = reqtypeCtrl.ids;
            $scope.forms =reqtypeCtrl.forms;
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };

            $scope.save = function(doc) {
                RestAPIService.createRequest(doc).then(
                    function(success) {
                    	RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                        //Create successful. Need to refresh
                        $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide(doc);
            };
        }

        reqtypeCtrl.recivedDoc = {};
        $scope.updateRequestDialog = function(ev) {
        	 var datares = $filter('filter')($scope.Requests, {'id': ev.id});
            reqtypeCtrl.recivedDoc = angular.copy(datares[0]);
            $mdDialog.show({
                controller: updateRequestDialogController,
                templateUrl: 'app/main/administration/request-management/update.requestType.dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        };

        function updateRequestDialogController($scope, $mdDialog) {
            $scope.icons = ["icon-currency-usd", "icon-file-document", "icon-timetable"];
            $scope.flowtypes = ["Portal", "SAP", "Hybrid"];
            $scope.formIds = reqtypeCtrl.forms;
            //$scope.forms =reqtypeCtrl.forms;
            $scope.recivedDoc = reqtypeCtrl.recivedDoc;
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.update = function(doc) {
                RestAPIService.updateRequest(doc).then(
                    function(success) {
                    	RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                        $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide(doc);
            };
        }

        $scope.deleteDoctype = function(ev) {
        	 var datares = $filter('filter')($scope.Requests, {'id': ev.id});
            var confirm = $mdDialog.confirm()
                .title('Remove')
                .textContent(' Request ' + datares[0].name + ' ' + ' will be permanently deleted. Continue ?')
                .targetEvent(ev)
                .ok('Ok')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                    RestAPIService.deleteRequest(datares[0].id).then(
                        function(success) {
                        	RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                            $state.reload();
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        }
                    );
                },
                function() {
                    $mdDialog.cancel();
                });
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.administration')
        .controller('Reportscontoller', Reportscontoller);

    /** @ngInject */
    function Reportscontoller($state, $scope, RestAPIService, Icons, $filter, $mdDialog) {
        var repCtrl = this;
        $scope.icons = Icons.icons;
        $scope.reportdata = {};
        $scope.noOfIconsForDisplay = 50;
        $scope.iconsPerColumn = 5;
        $scope.reportInfo = {
            "reportType": "TABULAR",
            "skipSelection": false
        };
        $scope.selectionfields = [];
        $scope.outputfields = [];
        $scope.filterfields = [];
        $scope.selected = [];
        $scope.selectedAttr = [];
        $scope.selectedFilter = [];
        $scope.selectedoutfield = [];
        $scope.attributeObjects = [];
        $scope.finalDocTypeFields = [];
        $scope.finalSelectionFields = [];
        $scope.finalOutData = [];
        $scope.finalFilterData = [];
        $scope.selectedOutFl = [];
        
         
        $scope.selectedFSFields = function(fields) {
        	var cField = JSON.parse(fields);
        	$scope.selectedFSField = angular.copy(cField);
        } 
         
        $scope.setDefaultValue = function(dValue, fsfields) {
        	var fsfield = JSON.parse(fsfields[0]);
        	for (var j in $scope.finalSelectionFields) {
                if ($scope.finalSelectionFields[j].fieldname == fsfield.fieldname) {
                	$scope.finalSelectionFields[j].defaultvalue = dValue;
                }
            }
        }
        $scope.setLabelValue = function(lValue, fsfields) {
        	var fsfield = JSON.parse(fsfields[0]);
        	for (var j in $scope.finalSelectionFields) {
                if ($scope.finalSelectionFields[j].label == fsfield.label) {
                	$scope.finalSelectionFields[j].label = lValue;
                }
            }
        }
       
        $scope.setRequiredFlag = function(rValue, fsfields) {
        	var fsfield = JSON.parse(fsfields[0]);
        	for (var j in $scope.finalSelectionFields) {
                if ($scope.finalSelectionFields[j].requiredflag == fsfield.label) {
                	$scope.finalSelectionFields[j].requiredflag = rValue;
                }
            }
        }
        
        $scope.setPossibleValues = function(pValue, fsfields) {
        	var pValuesArray = pValue.split(',');
        	pValuesArray = pValuesArray.filter(function(e){ return e.replace(/(\r\n|\n|\r)/gm,"")});
        	var fsfield = JSON.parse(fsfields[0]);
        	for (var j in $scope.finalSelectionFields) {
                if ($scope.finalSelectionFields[j].fieldname == fsfield.fieldname) {
                	$scope.finalSelectionFields[j].possibleValues = pValuesArray;
                }
            }
        }
        
        $scope.getReportData = function() {
            RestAPIService.getreportdata().then(function(response) {
                    $scope.allReports = [];
                    $scope.allReports = response.data;
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                });
        }

        $scope.goToPreviousState = function() {
            $state.go("app.overview");
            $("#vertical-navigation").show();
            $("#content-container").css({
                "margin-left": "60px"
            });
        }

        $scope.getAnotherColor = function(index) {
            $scope.colors = ['red', 'pink', 'purple', 'deep-purple', 'indigo', 'blue', 'light-blue', 'cyan', 'teal', 'green',
                'light-green', 'lime', 'yellow', 'amber', 'deep-orange', 'brown', 'grey', 'blue-grey'
            ];
            var totalNoOfColors = $scope.colors.length;
            return $scope.colors[index % totalNoOfColors];
        }

        $scope.addColumn = function(sfields) {
            for (var i in sfields) {
                var field = getValues(sfields[i]);
                if ($scope.finalSelectionFields.length == 0) {
                    field.sequence = ($scope.finalSelectionFields.length + 1);
                    $scope.finalSelectionFields.push(field);
                } else {
                    var unique = isUniqueSelection(sfields[i]);
                    if (unique == undefined) {
                        field.sequence = ($scope.finalSelectionFields.length + 1);
                        $scope.finalSelectionFields.push(field);
                    }
                }
            }
        }

        $scope.moveUp = function(fsfields) {
            for (var i in fsfields) {
                var field = JSON.parse(fsfields[i]);
                if ($scope.finalSelectionFields.length > 1) {
                    for (var j in $scope.finalSelectionFields) {
                        if ($scope.finalSelectionFields[j].fieldname == field.fieldname) {
                            swap($scope.finalSelectionFields, j, (j - 1))
                        }
                    }
                }
            }
        }

        $scope.moveDown = function(fsfields) {
            for (var i in fsfields) {
                var field = JSON.parse(fsfields[i]);
                if ($scope.finalSelectionFields.length > 1) {
                    for (var j in $scope.finalSelectionFields) {
                        if ($scope.finalSelectionFields[j].fieldname == field.fieldname) {
                            swap($scope.finalSelectionFields, j, (parseInt(j) + 1))
                            return;
                        }
                    }
                }
            }
        }

        $scope.delColumn = function(fsfields) {
            for (var i in fsfields) {
                for (var j in $scope.finalSelectionFields) {
                    if ($scope.finalSelectionFields[j].fieldname == JSON.parse(fsfields[i]).fieldname) {
                        $scope.finalSelectionFields.splice(j, 1);
                    }
                }
            }
        }

        function getValues(fieldname) {
            for (var i in $scope.selectionfields) {
                if ($scope.selectionfields[i].fieldname == fieldname) {
                    return $scope.selectionfields[i];
                }
            }
        }

        function isUniqueSelection(fieldname) {
            for (var i in $scope.finalSelectionFields) {
                if ($scope.finalSelectionFields[i].fieldname == fieldname) {
                    return false;
                }
            }
        }

        function swap(input, index_A, index_B) {
            if (undefined != input[index_B]) {
                var temp = input[index_A];
                var seq_A = input[index_A].sequence;
                input[index_A] = input[index_B];
                input[index_B] = temp;
                input[index_B].sequence = input[index_A].sequence;
                input[index_A].sequence = seq_A;
            }
        }

        $scope.showIconsList = function(ev) {
            $mdDialog.show({
                controller: ReportlogoDialogController,
                templateUrl: 'app/main/reports/report/report.logo.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                preserveScope: true,
                autoWrap: true,
                skipHide: true, // this line does the trick for nested dialogs
                fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
            });
        };

        function ReportlogoDialogController($scope, $mdDialog, RestAPIService) {
            $scope.icons = Icons.icons;
            $scope.noOfIconsForDisplay = 50;
            $scope.iconsPerColumn = 5;

            $scope.loadMoreIcons = function() {
                $scope.noOfIconsForDisplay += 10;
            };

            $scope.saveLogo = function(siteIcon) {
                repCtrl.icon = siteIcon;
                $mdDialog.hide();
            };
        }

        $scope.loadMoreIcons = function() {
            $scope.noOfIconsForDisplay += 10;
        };

        $scope.saveLogo = function(siteIcon) {
            $scope.currentreportvalue = siteIcon;
            $mdDialog.hide();
        };

        $scope.cancel = function() {
            $mdDialog.cancel();
        };

        $scope.toggleCheck = function(selectionfield, list, action) {
            if (action == 'DOCTYPEFIELDS') {
                var idx = list.map(function(d) {
                    return d['name'];
                }).indexOf(selectionfield.name)
                if (idx > -1) {
                    list.splice(idx, 1);
                } else {
                    list.push(selectionfield);
                }
                $scope.finalDocTypeFields = list;
            } else {
                var idx = list.map(function(d) {
                    return d['fieldname'];
                }).indexOf(selectionfield.fieldname)
                if (idx > -1) {
                    list.splice(idx, 1);
                } else {
                    list.push(selectionfield);
                }
                if (action == 'OUTPUTFIELDS') {
                    $scope.finalOutData = list;
                } else if (action == 'FILTEREDFIELDS') {
                    $scope.finalFilterData = list;
                }
            }
        };

        $scope.exist = function(selectionfields, list, action) {
            for (var i in list) {
                if (action == 'DOCTYPEFIELDS') {
                    if (list[i].name == selectionfields.name) {
                        return true;
                    }
                } else {
                    if (list[i].fieldname == selectionfields.fieldname) {
                        return true;
                    }
                }
            }
        };

        $scope.getLabelValue = function(list, action) {
            if (action == 'FILTEREDFIELDS') {
                for (var i in $scope.selectedFilter) {
                    if ($scope.selectedFilter[i].fieldname == list.fieldname) {
                        return $scope.selectedFilter[i];
                    }
                }
            } else if (action == 'DOCTYPEFIELDS') {
                for (var i in $scope.selectedAttr) {
                    if ($scope.selectedAttr[i].name == list.name) {
                        return $scope.selectedAttr[i];
                    }
                }
            } else if (action == 'OUTPUTFIELDS') {
                for (var i in $scope.selectedOutFl) {
                    if ($scope.selectedOutFl[i].fieldname == list.fieldname) {
                        return $scope.selectedOutFl[i];
                    }
                }
            }
        }

        $scope.selectedModule = function(reportModule) {
            $scope.reportInfo.reportSpecific = null;
            if (reportModule != null) {
                $scope.getReportTypeFields(reportModule);
            }
        }

        $scope.getReportTypeFields = function(reportModule) {
            RestAPIService.getreporttypefields(reportModule).then(function(response) {
                    var data = [];
                    for (var i = 0; i <= response.data.length - 1; i++) {
                        var str1 = response.data[i].split("@");
                        if (str1[1] != 'object' && str1[0] != '_class') {
                            if (str1[0] == '_id') {
                                data.push({
                                    "fieldname": "id",
                                    "type": str1[1]
                                });
                            } else {
                                data.push({
                                    "fieldname": str1[0],
                                    "type": str1[1]
                                });
                            }
                        }
                    }
                    $scope.selectionfields = angular.copy(data);
                    $scope.outputfields = angular.copy(data);
                    $scope.filterfields = angular.copy(data);
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                })
            return $scope.reportInfo.reportSpecific;
        }

        $scope.selectSpecificType = function(reportSpecific) {
            if (reportSpecific.length > 0) {
                for (var i in reportSpecific) {
                    if (reportSpecific[i] == 'docType') {
                        $scope.getDocumentTypes();
                    }
                }
            } else {
                $scope.docTypes = [];
                $scope.attributeObjects = [];
                $scope.finalDocTypeFields = [];
                $scope.reportInfo.docType = null;
            }
        };

        $scope.getDocumentTypes = function() {
            RestAPIService.getDocumentTypes().then(function(response) {
                    $scope.docTypes = [];
                    $scope.docTypes = response.data;
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                });
        }

        $scope.selectDocType = function(docType) {
            if (docType != null) {
                RestAPIService.getDocumentTypeAttributes(docType).then(function(responce) {
                        $scope.attributeObjects = [];
                        $scope.attributeObjects = responce.data.attributes;
                        if (responce.data.attributes == null) {
                            alert("No Attributes for selected DocumentType");
                        }
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    });
            }
        };

        $scope.submitReport = function(action) {
            if (!$scope.reportInfo.skipSelection) {
                for (var i in $scope.finalSelectionFields) {
                    if ($scope.finalSelectionFields[i].label == undefined) {
                        $scope.finalSelectionFields[i].label = $scope.finalSelectionFields[i].fieldname;
                    }
                    if ($scope.finalSelectionFields[i].requiredflag == undefined) {
                        $scope.finalSelectionFields[i].requiredflag = $scope.finalSelectionFields[i].requiredflag;
                    }
                }
                $scope.reportInfo.selectionfield = $scope.finalSelectionFields;
            }
            for (var i in $scope.finalOutData) {
                if ($scope.finalOutData[i].label == undefined) {
                    $scope.finalOutData[i].label = $scope.finalOutData[i].fieldname;
                }
            }
            for (var i in $scope.finalFilterData) {
                if ($scope.finalFilterData[i].label == undefined) {
                    $scope.finalFilterData[i].label = $scope.finalFilterData[i].fieldname;
                }
            }
            for (var i in $scope.finalDocTypeFields) {
                delete $scope.finalDocTypeFields[i].$$hashKey;
                if ($scope.finalDocTypeFields[i].label == undefined) {
                    $scope.finalDocTypeFields[i].label = $scope.finalDocTypeFields[i].name;
                }
            }

            $scope.reportInfo.doctypefield = $scope.finalDocTypeFields;
            $scope.reportInfo.outputfield = $scope.finalOutData;
            $scope.reportInfo.filterfield = $scope.finalFilterData;
            $scope.reportInfo.icon = repCtrl.icon;
            console.log("$scope.reportInfo : ", $scope.reportInfo)
         

            if (action == 'SAVE') {
                RestAPIService.savereportdata($scope.reportInfo).then(function(success) {
                        RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                        $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    });
            } else if (action == 'UPDATE') {
                RestAPIService.updateReportData($scope.reportInfo).then(function(success) {
                        RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                        $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    });
            }
        }

        $scope.deleteReport = function(reportname, reportid) {
            $scope.reportid = reportid;
            var confirm = $mdDialog.confirm()
                .title('Remove')
                .textContent(reportname + ' will be removed from Report' + ' , continue ?')
                .ok('Ok')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function(reportname, reportid) {
                RestAPIService.deletereport($scope.reportid).then(
                    function(responce) {
                        RestAPIService.successTostDialog('Report Deleted Successfully');
                        $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
            }, function() {});
        }

        $scope.goToUpdateReport = function(report) {
            $scope.reportView = 1;
            $scope.getDocumentTypes();
            $scope.finalOutData = [];
            $scope.reportInfo = angular.copy(report);
            if (undefined != $scope.reportInfo.reportModule) {
                $scope.getReportTypeFields($scope.reportInfo.reportModule);
            }
            if (undefined != $scope.reportInfo.docType) {
                $scope.selectDocType($scope.reportInfo.docType);
            }
            $scope.finalSelectionFields = $scope.reportInfo.selectionfield;
            $scope.selectedAttr = $scope.reportInfo.doctypefield;
            $scope.selectedOutFl = $scope.reportInfo.outputfield;
            $scope.selectedFilter = $scope.reportInfo.filterfield;
            $scope.finalDocTypeFields = $scope.reportInfo.doctypefield;
            $scope.finalOutData = $scope.reportInfo.outputfield;
            $scope.finalFilterData = $scope.reportInfo.filterfield;
        }

        $scope.goBack = function(pageNo) {
            $scope.reportView = pageNo;
        }

        // for maintenance
        if ($state.current.name == "app.administration.reports.maintenance") {
            $scope.reportView = 0;
            $scope.getReportData();
        }

    }


})();
(function ()
{
    'use strict';

    angular
        .module('app.administration')
        .controller('LMController', LMController);

    /** @ngInject */
    function LMController($state, $scope,$mdDialog,RestAPIService,$filter)
    {
        var listCtrl = this;
        $scope.onselect = true;
        
        $("#vertical-navigation").hide();
        $("#content-container").css({ "margin-left": "0px" });

        $scope.goToPreviousState = function() {
        	$state.go("app.overview");
         	$("#vertical-navigation").show();
         	$("#content-container").css({ "margin-left": "60px" });
         }
        
        listCtrl.dtOptions = {
                dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                autoWidth: false,
                responsive: true,
            };
        
            RestAPIService.getlistdata().then(
                function(success) {
                    $scope.listdata = success.data;

                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );

        
        $scope.createListDialog = function(ev) {
            $mdDialog.show({
                controller: createListDialogController,
                templateUrl: 'app/main/administration/list-management/createlist-dialog.html',  
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
            $scope.cancel = function() {

            };
        }
        
        $scope.onTabSelected = function(data){
        	console.log("onTabSelected...........")
        } 
        
        function createListDialogController($scope, $mdDialog, RestAPIService)
        {
            $scope.list = {};
            $scope.hide = function() {
                $mdDialog.hide();
            };

            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.save = function(list) {
                RestAPIService.createList(list).then(
                    function(success) {
                        RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                        //alert(success.headers('X-smartportalApp-alert'));
                        $state.reload();
                    },
                    function(error) {
                        alert(error.headers('X-smartportalApp-defaultMessage'));
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide(list);
            };
        }
        
        
        $scope.updatelistDialog = function(ev) {
        	 var datares = $filter('filter')($scope.listdata, {'id': ev.id});
        	listCtrl.currentList = angular.copy(datares[0]);
            $mdDialog.show({
                controller: updateListDialogController,
                templateUrl: 'app/main/administration/list-management/updatelist-dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        };
        
        
        function updateListDialogController($scope, $mdDialog, RestAPIService)
        {
            $scope.currentList = listCtrl.currentList;

            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.update = function(list) {
            	console.log(list);
                RestAPIService.updateList(list).then(
                    function(success) {
                        RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                        $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide(list);
            };
        }
        
        

        $scope.deletelist = function(ev) {
        	 var datares = $filter('filter')($scope.listdata, {'id': ev.id});
            var confirm = $mdDialog.confirm()
                .title('Remove')
                .textContent('list' + datares[0].name + ' ' + ' will be permanently deleted. Continue ?')
                .targetEvent(ev)
                .ok('Ok')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {

                    RestAPIService.delete(datares[0].id).then(
                        function(success) {
                            RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));

                            $state.reload();
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        }
                    );
                },
                function() {
                    $mdDialog.cancel();
                });
        }
        
        
        $scope.ListAttributesDialog = function(ev) {
        	 var datares = $filter('filter')($scope.listdata, {'id': ev.id});
        	listCtrl.currentList = datares[0];
            $mdDialog.show({
                controller: ListAttributesDialogController,
                templateUrl: 'app/main/administration/list-management/attributes.list.html', 
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
            $scope.cancel = function() {};
        };
        
      
        function ListAttributesDialogController($scope, $mdDialog) {
            $scope.dtOptions1 = {
                    dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                    paging: false,
                    searching: false,
                    lengthChange: false,
                    autoWidth: false,
                    responsive: false,
                    info: false,
                    columnDefs: [
                    { orderable: false, targets: [0,1,2,3,4,5,6,7] },
                  ]
                };
            
        	$scope.showupdate = true;
            $scope.attributes = listCtrl.currentList.attributes;
            $scope.currentList = listCtrl.currentList;
            $scope.attributeTypes = ['String', 'Number', 'Date'];
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };

            $scope.addNewAttribute = function() {
                var newAttribute = {
                    fieldname: '',
                    type: 'String',
                    length:'',
                    label:'',
                    outputfieldflag:false,
                    filterfleldflag: false

                }
                if ($scope.attributes == null) $scope.attributes = [];
                $scope.attributes.push(newAttribute);
            };
            $scope.removeAttribute = function(ev) {
                $scope.attributes.splice(ev.id, 1);
            };
            $scope.save = function() {
            	$scope.currentList.attributes = $scope.attributes;
                RestAPIService.updateList($scope.currentList).then(
                    function(success) {
                        $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide();
                $mdDialog.show(
                    $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title('Success!')
                    .textContent('Attributes of ' + listCtrl.currentList.name + ' has been successfully updated')
                    .ok('Ok')
                );
            };
            
            $scope.setunioutputflag = function(id){
            	console.log("id is............", id);
            	for(var i=0;i<=$scope.attributes.length-1;i++){
            		if($scope.attributes[i].id == id){
            			$scope.attributes[i].outputfieldflag = true;
            		}
            		else{
            			$scope.attributes[i].outputfieldflag = false;
            		}
            	}
            	for(var i=0;i<=$scope.attributes.length-1;i++){
            		if($scope.attributes[i].outputfieldflag == true){
            		  	for(var i=0;i<=$scope.attributes.length-1;i++){
                    		if($scope.attributes[i].descriptionflag == true){
                    			$scope.showupdate = false;
                    		}
                    		}
            		}
            	}
            	
            }
            $scope.setunidescflag = function(id){
               	for(var i=0;i<=$scope.attributes.length-1;i++){
            		if($scope.attributes[i].id == id){  
            			$scope.attributes[i].descriptionflag = true;
            		}
            		else{
            			$scope.attributes[i].descriptionflag = false;
            		}
            	}
            	for(var i=0;i<=$scope.attributes.length-1;i++){
            		if($scope.attributes[i].descriptionflag == true){
            		  	for(var i=0;i<=$scope.attributes.length-1;i++){
                    		if($scope.attributes[i].outputfieldflag == true){
                    			$scope.showupdate = false;
                    		}
                    		}
            		}
            	}
            }     
            function init(){
            	if($scope.attributes !=null || $scope.attributes !=undefined){
                   	for(var i=0;i<=$scope.attributes.length-1;i++){
                		if($scope.attributes[i].descriptionflag == true){
                		  	for(var i=0;i<=$scope.attributes.length-1;i++){
                        		if($scope.attributes[i].outputfieldflag == true){
                        			$scope.showupdate = false;
                        		}
                        		}
                		}
                	}
            	}

            }
            init();

        }
        
        }   
})();
(function() {
    'use strict';

    angular
        .module('app.administration')
        .controller('FMController', FMController);

    /** @ngInject */
    function FMController($state, $stateParams,$scope, $mdDialog, RestAPIService, $sce) {
        var requestCtrl = this;
        $scope.priceVars = ["INC", "DEC"];
        $scope.rows = ["1", "2", "3"];
        $scope.customerGroups = ["MISC", "AMREP"];
        $scope.CMCFDidtributionChannels = ["DI-DIRECT", "DM-DEEMED"];
        $scope.paymentTerms = ["PT01 NET DUE AFTER 30 DAYS", "PT02 NET DUE AFTER 45 DAYS"];
        $scope.salesAreas = ["South", "East"];
        $scope.salesOffices = ["KARNATAKA", "DELHI"];
        $scope.taxes = ["CST with C from 2%", "SERVICE TAX APPLICABLE / NOT APPLICABLE"];
        $scope.request = {};
        $("#vertical-navigation").hide();
        $("#content-container").css({ "margin-left": "0px" });
        $scope.lineItems = [{
    		sNo : null,
    		baseUnit : null,
    		current : null,
    		materialCode : null,
    		newPrice : null,
    		oldPrice : null,
    		pricePer : null,
    		priceVar : null,        		
    		validFrom : null,
    		validTo : null
        }];
        
        $scope.addLineItem = function() {
        	$scope.lineItems.push({
        		sNo : null,
        		baseUnit : null,
        		current : null,
        		materialCode : null,
        		newPrice : null,
        		oldPrice : null,
        		pricePer : null,
        		priceVar : null,        		
        		validFrom : null,
        		validTo : null
            });
        }
        $scope.removeLineItem = function(index) {
        	$scope.lineItems.splice(index, 1);
        }
        $scope.goToPreviousState = function() {
        	$state.go("app.overview");
         	$("#vertical-navigation").show();
         	$("#content-container").css({ "margin-left": "55px" });
         }
        $scope.selectForm = function(form) {
            var headerContent = form.content;
            var headerContentWithQuotes = headerContent.replace(/&quot;/g,'"');
            form.content = headerContentWithQuotes;

            var lineitemContent = form.lineItemContent;
            var lineitemContentWithQuotes = lineitemContent.replace(/&quot;/g,'"');
            form.lineItemContent = lineitemContentWithQuotes;

            //alert(lineitemContentWithQuotes);
            $scope.headerForm= {};
            $state.go('app.administration.forms.content',{'requestId': form.id, 'currentForm':form});
        }
      
        $scope.getAnotherColor = function(index) {
            $scope.colors = ['green-bg white-fg', 'orange-bg white-fg', 'pink-bg white-fg', 'blue-grey-bg white-fg', 'back-bg white-fg'];
            var totalNoOfColors = $scope.colors.length;
            return $scope.colors[index % totalNoOfColors];
        }
       
        $scope.getAnotherIcon = function(index) {
            $scope.icons = ['icon-account', 'icon-cash-100', 'icon-account-switch', 'icon-file-document', 'icon-cash-usd', 'icon-chart-bar'];
            var totalNoOfIcons = $scope.icons.length;
            return $scope.icons[index % totalNoOfIcons];
        }
        
        $scope.setAttachmentFile = function(element) {
            var formData = new FormData();
            $scope.$apply(function() {
                $scope.attachmentfiles = [];
                for (var i = 0; i < element.files.length; i++) {
                    formData.append('file', element.files[i]);
                    $scope.attachmentfiles.push(element.files[i]);
                }
            });
        };

        requestCtrl.getRequestForms = function() {
            RestAPIService.getRequestForms(0,100).then(
                function(success) {
                    $scope.forms = success.data;
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                });
        };

        $scope.createRequest = function(ev) {
            $mdDialog.show({
                controller: CreateRequestDialogController,
                templateUrl: 'app/main/administration/forms-management/formCreation.html', 
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        };

        function CreateRequestDialogController($scope, $http, RestAPIService, $mdDialog, $state, $window) {
        	
        	 $scope.attributes = [];
        	 $scope.Types =["String","Number","List"]
             $scope.addNewAttribute = function() {
                 var newAttribute = {
                    fieldName: '',
                    label: '',
                    type:'',
                    length:'',
                    requiredField:false,
                    possibleValues:'e.g. A,B,C',
                    barcodeEnabled:false,
                    mobileEnabled:false
                   
                    
                           }                
                 if ($scope.attributes == null) $scope.attributes = [];
                 $scope.attributes.push(newAttribute);
             };
             $scope.removeAttribute = function(index) {
                 $scope.attributes.splice(index, 1);
             };
             
            var formData = new FormData();
            $scope.setHeaderFile = function(element) {
                $scope.$apply(function() {
                    $scope.headerfiles = [];
                    for (var i = 0; i < element.files.length; i++) {
                        formData.append('file', element.files[i]);
                        $scope.headerfiles.push(element.files[i]);
                    }
                });
            };
            $scope.setLineItemFile = function(element) {
                $scope.$apply(function() {
                    $scope.lineitemfiles = [];
                    for (var i = 0; i < element.files.length; i++) {
                        formData.append('file', element.files[i]);
                        $scope.lineitemfiles.push(element.files[i]);
                    }
                });
            };

            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.uploadRequestForm = function(request) {
            	

            	var json = JSON.stringify( $scope.attributes, function( key, value ) {
            	    if( key === "$$hashKey" ) {
            	        return undefined;
            	    }

            	    return value;
            	});
           RestAPIService.uploadRequestForm($scope.headerfiles[0],$scope.lineitemfiles[0],request.name, request.description,json).then(
                    function(success) {
                        requestCtrl.getRequestForms();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.cancel();
            }

        }
        $scope.UpdateForm = function(ev,form) {
        	requestCtrl.UpdateForm =angular.copy(form)
            $mdDialog.show({
                controller: UpdateRequestDialogController,
                templateUrl: 'app/main/administration/forms-management/formUpdate.html', 
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        };
        function UpdateRequestDialogController($scope, $http, RestAPIService, $mdDialog, $state, $window) {
        	$scope.Types =["String","Number","List"];
        $scope.CurrentForm = requestCtrl.UpdateForm;       
        $scope.attributes =requestCtrl.UpdateForm.formFieldsHeader;
       
   	    $scope.addNewAttribute = function() {
            var newAttribute = {
               fieldName: '',
               label: '',
               type:'',
               length:'',
               requiredField:false,
               possibleValues:'e.g. A,B,C',
               barcodeEnabled:false,
               mobileEnabled:false
                      }                
            if ($scope.attributes == null) $scope.attributes = [];
            $scope.attributes.push(newAttribute);
        };
        $scope.removeAttribute = function(index) {
            $scope.attributes.splice(index, 1);
        };
        var formData = new FormData();
        $scope.setHeaderFile = function(element) {
            $scope.$apply(function() {
                $scope.headerfiles = [];
                for (var i = 0; i < element.files.length; i++) {
                    formData.append('file', element.files[i]);
                    $scope.headerfiles.push(element.files[i]);
                }
            });
        };
        $scope.setLineItemFile = function(element) {
            $scope.$apply(function() {
                $scope.lineitemfiles = [];
                for (var i = 0; i < element.files.length; i++) {
                    formData.append('file', element.files[i]);
                    $scope.lineitemfiles.push(element.files[i]);
                }
            });
        };       
        
        $scope.updateRequestForm = function(request) {
        	var json = JSON.stringify( $scope.attributes, function( key, value ) {
        	    if( key === "$$hashKey" ) {
        	        return undefined;
        	    }
        	    return value;
        	});
       RestAPIService.updateRequestForm($scope.headerfiles[0],$scope.lineitemfiles[0],request.name,request.id, request.description,json).then(
                function(success) {
                    requestCtrl.getRequestForms();
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );
            $mdDialog.cancel();
        }
        
        $scope.hide = function() {
            $mdDialog.hide();
        };
        $scope.cancel = function() {
            $mdDialog.cancel();
        };
        
        
        
        
        
        
        }
       
        
        
        $scope.sendFormData = function(headerForm, lineitemForm){ 
        	
        	var header = {};
        	var lineItems = {}; 
        	var json = {};
        	header.accountGroup = headerForm.accountGroup;
        	header.channel = headerForm.channel;
        	header.conditionType = headerForm.conditionType;
        	header.customerCode = headerForm.customerCode;
        	header.customerName = headerForm.customerName;
        	header.organisation = headerForm.organisation;
        	header.type = headerForm.type;
        	 	
        	for (var i in $scope.lineItems){
        		lineItems[i] = $scope.lineItems[i];
        	}
        	
        	json.docType = 'PR_PROCESS';
        	json.description = $scope.request.comment;
        	json.header = header;
        	json.lineItems = lineItems;
        	
            RestAPIService.sendFormData(json, $scope.attachmentfiles).then(
                function(success) {
                    console.log("success :: ",success)
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
            });
            
           
        }
        
        function viewForm(data){
            $scope.currentFormName = data.name;
            $scope.currentFormHeader = $sce.trustAsHtml(data.content.replace(/&quot;/g,'"'));
            $scope.currentFormLineitem = $sce.trustAsHtml(data.lineItemContent.replace(/&quot;/g,'"'));
        }
        
        // Initial load
        init();

        function init(){
            if($stateParams.currentForm == undefined && $stateParams.requestId != undefined){
                RestAPIService.getRequestFormById($stateParams.requestId).then(
                    function(success) {
                        viewForm(success.data);
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                });
            } else if($stateParams.currentForm){
                 viewForm($stateParams.currentForm);
           }
        }
        $scope.createFormDiv = true;
        var data = [];
//         jQuery(function($) {
//         	$('#previewForm').hide();
//         	$('#submitDiv').hide();
//            	var fbEditor = document.getElementById('build-wrap');
//            	/* var formBuilder = $(fbEditor).formBuilder(); */
//            	var options = {
//            	        dataType: 'json',
//            	        defaultFields: []
//            	      };
//            	  var formBuilder = $(fbEditor).formBuilder(options);
           
//            	  document.getElementById('clear-all-fields').onclick = function() {
//            	    formBuilder.actions.clearFields();
//            	    $('#submitDiv').hide();
//            	  };
//            	document.getElementById('getJSONAndSave').addEventListener('click', function() {           	   
//            	    console.log(formBuilder.actions.getData('json'));
//            	    data = formBuilder.actions.getData('json');
//            	    $('#submitDiv').show();
//            	  });
//         	document.getElementById('preview').addEventListener('click', function() {
//         		 $('.fb-render').formRender({
//         			    dataType: 'json',
//         			    formData: formBuilder.actions.getData('json')
//         			  });        		 
// //        		 formData = formBuilder.actions.getData('json');
//         		 $('#createFormDiv').hide();
//         		 $('#previewForm').show();
//            	    console.log(formBuilder.actions.getData('json'));
//            	  });
//         	document.getElementById('edit').addEventListener('click', function() {
//         		$('#createFormDiv').show();
//        		 	$('#previewForm').hide();
//            	  });
           	
//          /*  	document.getElementById('getXML').addEventListener('click', function() {
//            	    alert(formBuilder.actions.getData('xml'));
//            	});
//            	*/
//            	});
        $scope.submitJsonForm = function(formData){        	        	
        	formData['fields'] = JSON.parse(data);
        	console.log(formData);
        	RestAPIService.createJsonForm(formData).then(
                    function(success) {
                    	console.log(success.data);
                        $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
        	
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.administration')
        .controller('DocumentTypeController', DocumentTypeController);

    /** @ngInject */
    function DocumentTypeController($state, $scope, $mdDialog, RestAPIService,DocumentTypes, $filter,$stateParams,$cookieStore,$localStorage)
    {
        var doctypeCrtl = this;
        if($stateParams.obj != undefined){
        	if($stateParams.obj.docType != undefined){
        		doctypeCrtl.docType = $stateParams.obj.docType;
        		doctypeCrtl.docTypeName = $stateParams.obj.docTypeName;
        		}
        	
        }
        if(doctypeCrtl.docType !=null){
      	  var json = {
           		 "docType" : $stateParams.obj.docType,
           		"docTypeName": $stateParams.obj.docTypeName
                }
      	  $cookieStore.put('docTypeData', json)
      	
      }
        var json = $cookieStore.get('docTypeData');
        if(doctypeCrtl.docType == undefined){
        	if(json !=undefined){
        		doctypeCrtl.docType = json['docType'];
        		doctypeCrtl.docTypeName = json['docTypeName'];
        		
        	}
        }
        
        
        
        if($localStorage.sitesettingdata !=null && $localStorage.sitesettingdata !=undefined){
         	$scope.sitedisplayname = $localStorage.sitesettingdata.sitedisplayname;
         	doctypeCrtl.sitedisname = $scope.sitedisplayname;
         }else{
         	$scope.sitedisplayname = "site";
         	doctypeCrtl.sitedisname = "site";
         }
        
       $scope.documentsList = DocumentTypes.data;
        $scope.documentType = {};
        // doctypeCrtl.dtInstance = {};
        $("#vertical-navigation").hide();
        $("#content-container").css({
            "margin-left": "0px"
        });
        doctypeCrtl.dtOptions = {
            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth: false,
            responsive: true
        };
        doctypeCrtl.goTomain = function() {
            $state.go('app.administration.documentType');
        }
        $scope.goTositeConfig = function(ev) {
        	console.log("ev............",ev.id);
        	var datares = $filter('filter')($scope.documentsList, {'id': ev.id});
            $state.go('app.administration.documentType.siteConfig',
            		{
                   	 obj: {
       	                  "docType": datares[0].id,
       	               "docTypeName": datares[0].name
       	               }
                   });
        }
        
        $scope.goToPreviousState = function() {
            $state.go("app.overview");
            $("#vertical-navigation").show();
            $("#content-container").css({
                "margin-left": "60px"
            });
        }
        doctypeCrtl.getDocumentTypes = function() {
            RestAPIService.getDocumentTypes().then(
                function(success) {
                    $scope.documentsList = success.data;

                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );

        }
        $scope.getForms = function(){
        	 RestAPIService.getRequestForms().then(
                     function(success) {
                    	 doctypeCrtl.forms = success.data;
                     	//alert(JSON.stringify(doctypeCrtl.forms));
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                     });
        }
       
        
        function init(){ 
        	$scope.getForms();
        }
        //
        init();
        
        $scope.deleteDocumentType = function(ev) {
        	var datares = $filter('filter')($scope.documentsList, {'id': ev.id});
            var confirm = $mdDialog.confirm()
                .title('Remove')
                .textContent('Document Type ' + datares[0].name + ' ' + ' will be permanently deleted. Continue ?')
                .targetEvent(ev)
                .ok('Ok')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {

                    RestAPIService.deleteDocumentType(datares[0].id).then(
                        function(success) {
                            RestAPIService.successTostDialog('DocumentType Deleted Successfully');

                            $state.reload();
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        }
                    );
                },
                function() {
                    $mdDialog.cancel();
                });
        }
       
        
        $scope.createDocumentTypeDialog = function(ev) {
            $mdDialog.show({
                controller: createDocumentTypeDialogController,
                templateUrl: 'app/main/administration/document-type/createdoctype.dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
            $scope.cancel = function() {

            };
        };

        function createDocumentTypeDialogController($scope, $mdDialog, RestAPIService) {
                $scope.forms = doctypeCrtl.forms;
        	$scope.attributes = [];
            $scope.documentType = {};
            $scope.attributeTypes = ['String', 'Number', 'Date'];
            $scope.hide = function() {
                $mdDialog.hide();
            };

            $scope.cancel = function() {
                $mdDialog.cancel();
            };
           
            
            $scope.addNewAttribute = function() {
                var newAttribute = {
                    name: '',
                    type: 'String',
                    required: false
                }                
                if ($scope.attributes == null) $scope.attributes = [];
                $scope.attributes.push(newAttribute);
            };
            $scope.removeAttribute = function(index) {
                $scope.attributes.splice(index, 1);
            };
            
            $scope.save = function(document) {
            	$scope.documentType=document;
            	$scope.documentType.attributes =$scope.attributes;
             	if( $scope.attributes.length == 0){ 
               		$scope.Error ={message:'Please Enter Atleast One Attribute'};
               	 return false;  
                  }   
              RestAPIService.createDocumentType($scope.documentType).then(            		  
                 function(success) {               
                        RestAPIService.successTostDialog('DocumentType Created Successfully');                       
                        $state.reload();
                    },
                    function(error) {                     
                    	  $mdDialog.show(
                                  $mdDialog.alert()
                                  .clickOutsideToClose(true)
                                  .title('Error')
                                  .textContent(error.headers('X-smartportalApp-defaultMessage'))
                                  .ok('Ok')
                              );                       
                    }
                );
                $mdDialog.hide($scope.documentType);
            };
        }
        doctypeCrtl.currentDocType = {};
        $scope.updateDocumentTypeDialog = function(ev) {
        	 var datares = $filter('filter')($scope.documentsList, {'id': ev.id});
             doctypeCrtl.currentDocType = angular.copy(datares[0]);
            $mdDialog.show({
                controller: updateDocumentTypeDialogController,
                templateUrl: 'app/main/administration/document-type/updatedoctype.dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        };

        function updateDocumentTypeDialogController($scope, $mdDialog) {
        	$scope.forms = doctypeCrtl.forms
            $scope.currentDocType = doctypeCrtl.currentDocType;
            $scope.attributes = doctypeCrtl.currentDocType.attributes;
            $scope.attributeTypes = ['String', 'Number', 'Date'];
            
            $scope.addNewAttribute = function() {
                var newAttribute = {
                    name: '',
                    type: 'String',
                    required: false

                }                
                if ($scope.attributes == null) $scope.attributes = [];
                $scope.attributes.push(newAttribute);
            };
            $scope.removeAttribute = function(index) {
                $scope.attributes.splice(index, 1);
            };

            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.update = function(documentType) {
                RestAPIService.updateDocumentType(documentType).then(
                    function(success) {
                        RestAPIService.successTostDialog('DocumentType Updated Successfully');
                        $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide(documentType);
            };
        }
       
        doctypeCrtl.getDocumentTypeSites = function() {
        	$scope.docTypeId = $stateParams.obj.docType;
            RestAPIService.getDocumentTypeSites($scope.docTypeId).then(
                function(success) {
                    doctypeCrtl.sites = success.data;
                    var numberOfSites = doctypeCrtl.sites.length;
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );

        }
        
        doctypeCrtl.deleteSite = function( ev, site, siteData){   
        	$scope.docTypeId = $stateParams.obj.docType;
            var confirm = $mdDialog.confirm() 
            .title('Remove')               
            .textContent(site.name + ' will be removed for this Doctype, continue ?')            
            .targetEvent(ev)
            .ok('Ok')
            .cancel('Cancel');
            
            $mdDialog.show(confirm).then(function() {
                    RestAPIService.deleteDocumentTypesforSite($scope.docTypeId,site.id).then(
                        function(success){ 
                        	 RestAPIService.successTostDialog("Deleted Successfully");
                        	doctypeCrtl.getDocumentTypeSites($scope.docTypeId); 
                        },
                        function(error){
                           RestAPIService.showErrorDialog(error);
                        }
                    );    
            }, function() {
               //User clicked Cancel. Close the popup
            });
        };

        
        doctypeCrtl.currentDocType = {};
            $scope.addSiteDialog = function(ev,documentType){      
            	 doctypeCrtl.currentDocType = angular.copy(documentType);
                $mdDialog.show({
                    controller: AddSiteDialogController ,
                    templateUrl: 'app/main/administration/document-type/addSiteDialog.html',
                    parent: angular.element(document.body),
                    preserveScope: true,
                    autoWrap: true,
                    skipHide: true, 
                    targetEvent: ev,
                    clickOutsideToClose:true,
                    fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })  
            }  
            function AddSiteDialogController($scope, $mdDialog,$stateParams,$localStorage) {
            	 if($localStorage.sitesettingdata !=null && $localStorage.sitesettingdata !=undefined){
                  	$scope.sitedisplayname = $localStorage.sitesettingdata.sitedisplayname;
                  	doctypeCrtl.sitedisname = $scope.sitedisplayname;
                  }else{
                  	$scope.sitedisplayname = "site";
                  	doctypeCrtl.sitedisname = "site";
                  }
            	 $scope.tableVisibility=false;
            	 $scope.cancel = function() {
                     $mdDialog.cancel();
                 };
                 $scope.ok= function(){
                     $mdDialog.cancel();
                 }
                 $scope.searchSite = function(queryname){
                	 $scope.searchedSites= [];                     
                     RestAPIService.searchSites(queryname).then(
                     function(success){
                         $scope.searchedSites = success.data;
                       //  alert(JSON.stringify($scope.searchedSites));
                         $scope.msgVisibility=false;
                         $scope.tableVisibility=true;
                         $scope.site = {};                        
                     },function(error){
                         RestAPIService.showErrorDialog(error);
                     }
                     );
                	 
                 }
                 $scope.addSite = function(siteData,documentType){
                	 $scope.site = {};  
                	 $scope.docTypeId = $stateParams.obj.docType;
                	 var siteId = siteData.id;
                	 RestAPIService.updateDocumentTypeSites($scope.docTypeId, siteId).then(
                             function(success){
                             	 RestAPIService.successTostDialog("added Successfully");	
                             	//$mdDialog.cancel();
                             	//alert(JSON.stringify(siteId)); 
                                 doctypeCrtl.getDocumentTypeSites($scope.docTypeId); 
                             },
                             function(error){
                                 RestAPIService.showErrorDialog(error);
                             }
                         );    
                	 
                 }
                 
            }
            
        $scope.configureApprovalDialog = function(ev) {
        	var datares = $filter('filter')($scope.documentsList, {'id': ev.id});
            doctypeCrtl.currentDocType = angular.copy(datares[0]);
            $mdDialog.show({
                controller: ConfigureApprovalDialogController,
                templateUrl: 'app/main/administration/document-type/configureapproval.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
            $scope.cancel = function() {};
        };

        function ConfigureApprovalDialogController($scope, $mdDialog,$filter) {
            $scope.configureApproval = {};
            $scope.configureApproval['docuemntApprovalConfig'] = {};
            // $scope.configureApproval.docuemntApprovalConfig = doctypeCrtl.currentDocType.docuemntApprovalConfig;
            $scope.attributes = doctypeCrtl.currentDocType.attributes;
            $scope.docId = doctypeCrtl.currentDocType.id;
            $scope.data = {};
            $scope.currentDocType = doctypeCrtl.currentDocType;
            $scope.ApprovalConfig = {};
            $scope.ApprovalConfig['docuemntApprovalConfig'] = {};
            $scope.allApprovers = [];
            $scope.durations = [{
                "days": "7 Days",
                "value": 7
            }, {
                "days": "10 Days",
                "value": 10
            }, {
                "days": "15 Days",
                "value": 15
            }, {
                "days": "30 Days",
                "value": 30
            }];
            $scope.searchElements = {
                type: 'user'
            };


            if (doctypeCrtl.currentDocType.docuemntApprovalConfig != null) {

                $scope.configureApproval = {
                    "id": null,
                    "docuemntApprovalConfig": {
                        "agents": [],
                        "approvalsRequired": [],
                        "approverRespondDuration": 0,
                        "requestApproved_notifyApprover": doctypeCrtl.currentDocType.docuemntApprovalConfig.requestApproved_notifyApprover,
                        "requestApproved_notifyRequester": doctypeCrtl.currentDocType.docuemntApprovalConfig.requestApproved_notifyRequester,
                        "requestDenied_notifyApprover": doctypeCrtl.currentDocType.docuemntApprovalConfig.requestDenied_notifyApprover,
                        "requestDenied_notifyRequester": doctypeCrtl.currentDocType.docuemntApprovalConfig.requestDenied_notifyRequester,
                        "requestExpires__notifyRequester": doctypeCrtl.currentDocType.docuemntApprovalConfig.requestExpires__notifyRequester,
                        "requestExpires_notifyApprover": doctypeCrtl.currentDocType.docuemntApprovalConfig.requestExpires_notifyApprover
                    },
                };
                if (doctypeCrtl.currentDocType.docuemntApprovalConfig.approverRespondDuration != null) {
                    $scope.configureApproval.docuemntApprovalConfig.approverRespondDuration = doctypeCrtl.currentDocType.docuemntApprovalConfig.approverRespondDuration;
                }

                doctypeCrtl.currentDocType.docuemntApprovalConfig.approvalsRequired.forEach(function(h) {
                    if (h == null || h == undefined) {
                        h = "";
                    } else if (h != "") {
                        if (h.indexOf('Upload') == 0) {
                            $scope.configureApproval.docuemntApprovalConfig.approvalsRequired['Upload'] = h;
                        } else if (h.indexOf('Share') == 0) {
                            $scope.configureApproval.docuemntApprovalConfig.approvalsRequired['Share'] = h;
                        } else if (h.indexOf('Delete') == 0) {
                            $scope.configureApproval.docuemntApprovalConfig.approvalsRequired['Delete'] = h;
                        }
                        else if (h.indexOf('Edit') == 0) {
                            $scope.configureApproval.docuemntApprovalConfig.approvalsRequired['Edit'] = h;
                        }
                    }
                });
                $scope.allApprovers = doctypeCrtl.currentDocType.docuemntApprovalConfig.agents;
            } else {

                $scope.configureApproval = {
                    "id": null,
                    "docuemntApprovalConfig": {
                        "agents": [],
                        "approvalsRequired": [],
                        "approverRespondDuration": 0,
                        "requestApproved_notifyApprover": false,
                        "requestApproved_notifyRequester": false,
                        "requestDenied_notifyApprover": false,
                        "requestDenied_notifyRequester": false,
                        "requestExpires__notifyRequester": false,
                        "requestExpires_notifyApprover": false
                    },
                };
            }
            $scope.searchUsers = function(elements) {
                $scope.searchedUsers = {};
                RestAPIService.searchUsers(elements).then(
                    function(response) {
                        if (response.data[0].length > 0) {
                            $scope.searchedUsers.data = response.data[0];
                            $scope.searchedUsers.type = elements.type;
                        }
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    });
            }

           $scope.addApprover = function(approverData, type) {
                var json = {};
                if (approverData.id == undefined) {
                    json.objectId = approverData.login;
                    json.type = "user";
                } else {
                    json.objectId = approverData.id;
                    json.type = "group";
                }
                
             var result =    $filter('filter')($scope.configureApproval.docuemntApprovalConfig.agents,{objectId:"adam"}, true)[0];
                if(result==undefined){
                	
                	var term = json.objectId;
                  
                  var index = -1;

             $scope.allApprovers.some(function(obj, i) {
               return obj.objectId === term ? index = i : false;
             });
                  /*$scope.allApprovers.forEach(function(h){
                   index = h.objectId.indexOf(term);

                  });*/

                //	var index = $scope.allApprovers.findIndex(x => x.objectId==term);                	
                	if(index == -1){
                		RestAPIService.successTostDialog("User has been added successfully.");
                		$scope.allApprovers.push(json);
                		
                	}        
                }
                
            }    

            $scope.removeApprover = function(index) {
                $scope.allApprovers.splice(index, 1);
            };
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };

            $scope.submitApprovalConfig = function(data, currentDoc) {

                $scope.approval = [];
                if ($scope.configureApproval.docuemntApprovalConfig.approvalsRequired.Delete != "") {
                    $scope.approval.push($scope.configureApproval.docuemntApprovalConfig.approvalsRequired.Delete);
                }
                if ($scope.configureApproval.docuemntApprovalConfig.approvalsRequired.Share != "") {
                    $scope.approval.push($scope.configureApproval.docuemntApprovalConfig.approvalsRequired.Share);
                }
                if ($scope.configureApproval.docuemntApprovalConfig.approvalsRequired.Upload != "") {
                    $scope.approval.push($scope.configureApproval.docuemntApprovalConfig.approvalsRequired.Upload);
                }
                if ($scope.configureApproval.docuemntApprovalConfig.approvalsRequired.Edit != "") {
                    $scope.approval.push($scope.configureApproval.docuemntApprovalConfig.approvalsRequired.Edit);
                }
                $scope.configureApproval.docuemntApprovalConfig.approvalsRequired = $scope.approval;
                $scope.configureApproval.docuemntApprovalConfig.agents =   $scope.allApprovers;

                $scope.configureApproval.id = $scope.docId;
                if($scope.configureApproval.docuemntApprovalConfig.agents.length == 0){
                	alert("Please add approver");
                }
                else{
                // console.log("$scope.configureApproval : ", $scope.configureApproval)
                RestAPIService.updateApprovalConfig($scope.configureApproval).then(
                    function(success) {
                    	//alert(JSON.stringify($scope.configureApproval));
                        RestAPIService.successTostDialog('Approval Configuration Updated Successfully');
                        $state.reload();
                    },
                    function(error) {
                        alert(error.headers('X-smartportalApp-defaultMessage'));
                        RestAPIService.showErrorDialog(error);
                    }
                );
                
                $mdDialog.hide();
                }
            }
        }
    }


         
})();
(function ()
{
    'use strict';

    angular
        .module('app.administration')
        .controller('BussinessController', BussinessController);

    /** @ngInject */
    function BussinessController($state,$scope,$mdDialog,RestAPIService,Objects)
    {
        var bsCtrl = this;
        $("#vertical-navigation").hide();
        $("#content-container").css({ "margin-left": "0px" });
        $scope.getRequestForms = function() {
	       	  RestAPIService.getRequestForms().then(
	           function(success) {
	               $scope.forms = success.data;
	               bsCtrl.ids=[];
	             $scope.forms.forEach(function(h){
	           	bsCtrl.ids.push(h.id);  
	                });
	             },
	           function(error) {
	               RestAPIService.showErrorDialog(error);
	           });
	   };
        
        
	   $scope.goToPreviousState = function() {
       	$state.go("app.overview");
        	$("#vertical-navigation").show();
        	$("#content-container").css({ "margin-left": "60px" });
       }
         $scope.objectfiles=Objects.data;
         $scope.object={};
        
         $scope.dtOptions = {
        		 
        		 dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
	            pagingType: 'simple',
	            autoWidth : false,
	            responsive: true
	        };           
             
             $scope.deleteObject = function(ev,object) {
        
                  var confirm = $mdDialog.confirm()
                 .title('Remove')
                 .textContent('Object ' + object.name + ' ' + ' will be permanently deleted. Continue ?')
                 .targetEvent(ev)
                 .ok('Ok')
                 .cancel('Cancel');
             $mdDialog.show(confirm).then(function() {

                 RestAPIService.deleteObject(object.id).then(
                     function(success) {
                    	 RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                       
                         $state.reload();
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                        }
                      );
                     },      
                     function() {
                    $mdDialog.cancel();
                   });
                   }
        

             $scope.createObjectDialog = function(ev) {
                 $mdDialog.show({
                     controller: createObjectDialogController,
                     templateUrl: 'app/main/administration/business-object/create.object.dialog.html',
                     parent: angular.element(document.body),
                     targetEvent: ev,
                     clickOutsideToClose: true,
                     fullscreen: $scope.customFullscreen
                 })
                 $scope.cancel = function() {
                    
                 };
              };


            function createObjectDialogController($scope, $mdDialog,RestAPIService) {
            	$scope.ids = bsCtrl.ids;
                  $scope.hide = function() {
                     $mdDialog.hide();
                   };
                 $scope.cancel = function() {
                     $mdDialog.cancel();
                     };
                 $scope.save = function(object) {
                RestAPIService.createObject(object).then(
                     function(success) {
                    	 RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                         $state.reload();
                     },
                     function(error) {
                    	 alert(error.headers('X-smartportalApp-defaultMessage'));
                         //RestAPIService.showErrorDialog(error);
                     }
                    );
                 $mdDialog.hide(object);
                     };
                   }
                 bsCtrl.receivedObject ={};
               $scope.updateObjectDialog = function(ev,object) {
               
                 bsCtrl.receivedObject =  angular.copy(object);
                 $mdDialog.show({
                 controller: updateObjectDialogController,
                 templateUrl: 'app/main/administration/business-object/update.object.dialog.html',
                 parent: angular.element(document.body),
                 targetEvent: ev,
                 clickOutsideToClose: true,
                 fullscreen: $scope.customFullscreen
                })
              };

           function updateObjectDialogController($scope, $mdDialog) {
        	   $scope.formIds = bsCtrl.ids;
             
             $scope.currentObject = bsCtrl.receivedObject;
             console.log($scope.currentObject);

             $scope.hide = function() {
                 $mdDialog.hide();
             };
             $scope.cancel = function() {
                 $mdDialog.cancel();
             };
            $scope.update = function(object) {
                 RestAPIService.updateObject(object).then(
                     function(success) {
                    	 RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                         $state.reload();
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                     }
                 );
                 $mdDialog.hide(object);
                };
               }
           $scope.detailsObjectDialog = function(ev, object) {
                 bsCtrl.currentObject = object;
                 $mdDialog.show({
                 controller: detailsObjectDialogController,
                 templateUrl: 'app/main/administration/business-object/details.object.dialog.html',
                 parent: angular.element(document.body),
                 targetEvent: ev,
                 clickOutsideToClose: true,
                 fullscreen: $scope.customFullscreen
             })
             $scope.cancel = function() { 
                
             };
         };
         function detailsObjectDialogController($scope, $mdDialog) {
            $scope.attributes = bsCtrl.currentObject.attributes;
            $scope.currentObject = bsCtrl.currentObject;
            $scope.attributeTypes = ['String','List','Date'];
             $scope.hide = function() {
                 $mdDialog.hide();
             };
             $scope.cancel = function() {
                 $mdDialog.cancel();
             };

            $scope.addNewAttribute = function() {
                var newAttribute = {
                    label:'',
                    type:'String',
                    range:false,
                    listReference:'e.g. A,B,C'
                }
                if($scope.attributes == null)   $scope.attributes =[];
                $scope.attributes.push(newAttribute);
            };

            $scope.save = function() {
                //Getting the updated attributes list
                $scope.currentObject.attributes = $scope.attributes;
                RestAPIService.updateObject($scope.currentObject).then(
                    function(success) {
                        $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide();

                $mdDialog.show(
                    $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title('Success!')
                    .textContent('Attributes of '+$scope.currentObject.name+' has been successfully updated')
                    .ok('Ok')
                );
                
            };

         }
         
         init();
         
         function init() {
        	 $scope.getRequestForms();
         }
   
        }   
})();  
(function() {
    'use strict';

    angular
        .module('app.administration')
        .controller('BinderController', BinderController);

    /** @ngInject */
    function BinderController($state, $scope, $mdDialog, RestAPIService, Binders) {
        var binderCrtl = this;
        $scope.bindersList = Binders.data;
        $scope.binder = {};
        binderCrtl.dtInstance = {};
        $("#vertical-navigation").hide();
        $("#content-container").css({ "margin-left": "0px" });
        $scope.dtOptions = {
//            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
//            columnDefs: [
//
//                { // Target the actions column
//                    targets: 4,
//                    responsivePriority: 1,
//                    filterable: false,
//                    sortable: false
//                }
//            ],
//            pagingType: 'simple',
//            lengthMenu: [10, 20, 30, 50, 100],
//            pageLength: 20
//            // scrollY     : 'auto',
//            // responsive  : true
        		
        		 
       		 dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
	            pagingType: 'simple',
	            autoWidth : false,
	            responsive: true
        };
        $scope.goToPreviousState = function() {
        	$state.go("app.overview");
         	$("#vertical-navigation").show();
         	$("#content-container").css({ "margin-left": "60px" });
        }
        binderCrtl.selectBusinessObject = function(businessObject) {
            // Calling Rest API Service to get Attributes of this Business Object
            RestAPIService.findBusinessObjectAttributes(businessObject.id).then(function(responce) {
                    $scope.attributeObjects = responce.data.attributes;
                    // If any Attribute is having listReferrence as COMMA separated values, Split them.
                    if ($scope.attributeObjects != null) {
                        $scope.attributeObjects.forEach(function(attribute) {
                            if (attribute.type == "List") {
                                attribute['listValues'] = attribute.listReference.split(',');
                            }
                        });
                    }
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                })
        }

        binderCrtl.getBinders = function() {
            RestAPIService.getBinders().then(
                function(success) {
                    $scope.bindersList = success.data;

                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );

        }

        $scope.deleteBinder = function(ev, binder) {
            var confirm = $mdDialog.confirm()
                .title('Remove')
                .textContent('Binder ' + binder.name + ' ' + ' will be permanently deleted. Continue ?')
                .targetEvent(ev)
                .ok('Ok')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {

                    RestAPIService.deleteBinder(binder.id).then(
                        function(success) {
                            RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));

                            $state.reload();
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        }
                    );
                },
                function() {
                    $mdDialog.cancel();
                });
        }


        $scope.createBinderDialog = function(ev) {
            $mdDialog.show({
                controller: createBinderDialogController,
                templateUrl: 'app/main/administration/binder-management/create.binder.dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
            $scope.cancel = function() {

            };
        };


        function createBinderDialogController($scope, $mdDialog, RestAPIService) {
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.getAllBusinessObjects = function() {
                RestAPIService.getAllBusinessObjects().then(
                    function(responce) {
                    	
                        $scope.allBusinessObjects = responce.data;

                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    })
            }
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.save = function(binder) {
                RestAPIService.createBinder(binder).then(
                    function(success) {
                    	RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                    	//alert(success.headers('X-smartportalApp-alert'));
                        $state.reload();
                    },
                    function(error) {
                    	alert(error.headers('X-smartportalApp-defaultMessage'));
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide(binder);
            };
        }
        binderCrtl.currentBinder = {};
        $scope.updateBinderDialog = function(ev, binder) {

            binderCrtl.currentBinder = angular.copy(binder);

            $mdDialog.show({
                controller: updateBinderDialogController,
                templateUrl: 'app/main/administration/binder-management/update.binder.dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        };

        function updateBinderDialogController($scope, $mdDialog) {
            $scope.currentBinder = binderCrtl.currentBinder;

            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.update = function(binder) {
                RestAPIService.updateBinder(binder).then(
                    function(success) {
                        RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                        $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide(binder);
            };
        }
        
        $scope.binderFoldersDialog = function(ev, binder) {
            $mdDialog.show({
                controller: binderFoldersDialogController,
                templateUrl: 'app/main/administration/binder-management/folders.binder.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        };

        function binderFoldersDialogController($scope, $mdDialog) {

            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.remove = function (scope) {
                scope.remove();
              };

              $scope.toggle = function (scope) {
                scope.toggle();
              };

              $scope.moveLastToTheBeginning = function () {
                var a = $scope.data.pop();
                $scope.data.splice(0, 0, a);
              };
              $scope.collapseAll = function () {
                  $scope.$broadcast('angular-ui-tree:collapse-all');
                };

                $scope.expandAll = function () {
                  $scope.$broadcast('angular-ui-tree:expand-all');
                };    
              $scope.newSubItem = function (scope) {
                  var nodeData = scope.$modelValue;
                  nodeData.nodes.push({
                    id: nodeData.id * 10 + nodeData.nodes.length,
                    title: nodeData.title + '.' + (nodeData.nodes.length + 1),
                    nodes: []
                  });
                };
              $scope.newItem = function () {
                var nodeData = $scope.treelist[$scope.treelist.length - 1];
                $scope.treelist.push({
                  id: $scope.treelist.length + 1,
                  title: 'node ' + ($scope.treelist.length + 1)
                });
              };
        
        
        $scope.treelist =  [
        	  {
        		    "id": 1,
        		    "title": "folder1",
        		    "nodes": []   		    
       		  }
        		]
    }
        $scope.attributesBinderDialog = function(ev, binder) {
            binderCrtl.currentBinder = binder;
            $mdDialog.show({
                controller: attributesBinderDialogController,
                templateUrl: 'app/main/administration/binder-management/attributes.binder.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
            $scope.cancel = function() {

            };
        };

        function attributesBinderDialogController($scope, $mdDialog) {
            $scope.attributes = binderCrtl.currentBinder.attributes;
            $scope.currentBinder = binderCrtl.currentBinder;
            $scope.attributeTypes = ['String', 'List', 'Date'];
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };

            $scope.addNewAttribute = function() {
                var newAttribute = {
                    label: '',
                    type: 'String',
                    range: false,
                    listReference: 'e.g. A,B,C'
                }
                if ($scope.attributes == null) $scope.attributes = [];
                $scope.attributes.push(newAttribute);
            };
        }


    }
})();
(function() {
    'use strict';

    angular
        .module('app.administration')
        .controller('TemplateController', TemplateController);

    /** @ngInject */
    function TemplateController($state, $scope, $mdDialog, RestAPIService,DocumentTypes,Templates,$filter) {
        var templateCtrl = this;
       $scope.templates =Templates.data;       
        $("#vertical-navigation").hide();
        $("#content-container").css({ "margin-left": "0px" });
        templateCtrl.dtOptions = { 
       		 dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
	            pagingType: 'simple',
	            autoWidth : false,
	            responsive: true
        };
        $scope.goToPreviousState = function() {
        	$state.go("app.overview");
         	$("#vertical-navigation").show();
         	$("#content-container").css({ "margin-left": "60px" });
        }
       /* $scope.getTemplates = function() {
            RestAPIService.getTemplates().then(
                function(success) { 
                	console.log(success.data);
                     },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                });
        };*/
        
        $scope.templateDelete = function(ev){
        	 var datares = $filter('filter')($scope.templates, {'id': ev.id});
        	 var confirm = $mdDialog.confirm()
             .title('Remove')
             .textContent('DocumentType Template ' + datares[0].name + ' ' + ' will be permanently deleted. Continue ?')
             .ok('Ok')
             .cancel('Cancel');
         $mdDialog.show(confirm).then(function() {
        	RestAPIService.DeleteTemplate(datares[0].id).then(
                    function(success) {
                       RestAPIService.successTostDialog("Template Deleted successfully ");
                      $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide();
        	
         });
        
    }
        $scope.createTemplateDialog = function(ev) {
            $mdDialog.show({
                controller: createTemplateDialogController,
                templateUrl: 'app/main/administration/Template/create.template.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
            $scope.cancel = function() {

            };
        };
        function createTemplateDialogController($scope, $mdDialog, RestAPIService,$state) {
        	$scope.Documents =DocumentTypes.data;
           /* console.log($scope.Documents);*/
        	
        	  var formData = new FormData();
        	 $scope.setFile = function(element) {
                 $scope.$apply(function() {
                     $scope.files = [];
                     for (var i = 0; i < element.files.length; i++) {
                         formData.append('file', element.files[i]);
                         $scope.files.push(element.files[i]);
                         //console.log($scope.files);
                     }
                 });
             };
            $scope.hide = function() {
                $mdDialog.hide();
            };
           
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.save = function(ev,template) {            	
            	RestAPIService.CreateTemplate(template, $scope.files[0]).then(
                        function(success) {
                           RestAPIService.successTostDialog("Template uploaded successfully ");
                          $state.reload();
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        }
                    );
                    $mdDialog.hide(ev);
            	    
            };
        }
        
         templateCtrl.currentTemplate = {};
        $scope.updateTemplateDialog = function(ev) {
        	 var datares = $filter('filter')($scope.templates, {'id': ev.id});
             templateCtrl.currentTemplate = angular.copy(datares[0]);
            $mdDialog.show({
                controller: updateTemplateDialogController,
                templateUrl: 'app/main/administration/Template/update.template.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        };
        function updateTemplateDialogController($scope, $mdDialog) {
        	$scope.Documents =DocumentTypes.data;
        	  var formData = new FormData();
         	 $scope.setFile = function(element) {
                  $scope.$apply(function() {
                      $scope.files = [];
                      for (var i = 0; i < element.files.length; i++) {
                          formData.append('file', element.files[i]);
                          $scope.files.push(element.files[i]);
                          //console.log($scope.files);
                      }
                  });
              };
            $scope.currentTemplate =  templateCtrl.currentTemplate;
            //alert(JSON.stringify( $scope.currentTemplate));

            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.update = function(ev,template) {
            	//console.log(template);
            	RestAPIService.UpdateTemplate(template, $scope.files[0]).then(
                        function(success) {
                           RestAPIService.successTostDialog("Template updated successfully ");
                          $state.reload();
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        }
                    );
                    $mdDialog.hide(ev);
            	
            };
        }
       
        
        $scope.previewFile = function(ev) {
     	   $mdDialog.show({
     	      controller: DialogController,
     	      templateUrl: 'app/main/administration/Template/template.preview.html',
     	      parent: angular.element(document.body),
     	      targetEvent: ev,
     	      clickOutsideToClose:true
     	    });
         }
         
         function DialogController($scope, $mdDialog, $sce) {
         	
         }
       
     
       
    }
})();
 (function() {
     'use strict';
     angular
         .module('app.administration')
         .controller('ILMSetupController', ILMSetupController);

     function ILMSetupController($state, $http, $scope, $mdDialog, RestAPIService, Users, Sites, Systems, ILMStores) {
    	 var ilmStp = this;
    	 $scope.users = Users.data;
    	 $scope.sites = Sites.data;    	 
    	 $scope.systems = Systems.data;
    	 $scope.allStores = ILMStores.data;
    	 console.log($scope.sites);
 ilmStp.dtOptions = {
                 
                 dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                autoWidth : false,
                responsive: true

//                 dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
//                     columnDefs: [
//
//                         { // Target the actions column
//                             targets: 6,
//                             responsivePriority: 1,
//                             filterable: false,
//                             sortable: false
//                         }
//                     ],
//
//                     pagingType: 'simple',
//                     lengthMenu: [10, 20, 30, 50, 100],
//                     pageLength: 20
//                         // scrollY     : 'auto',
//                         //responsive  : true
                 };   
         
    	 $scope.createStoreDialog = function(ev){
    		 ilmStp.users = $scope.users;
    		 ilmStp.sites = $scope.sites;
    		 ilmStp.systems = $scope.systems;
    		 $mdDialog.show({
                 controller: CreateStoreDialogController,
                 templateUrl: 'app/main/administration/ILMSetup/createStorePopup.html',
                 parent: angular.element(document.body),
                 targetEvent: ev,
                 clickOutsideToClose: true,
                 fullscreen: $scope.customFullscreen
             })            
    	 }
    	 function CreateStoreDialogController($scope, $mdDialog){
    		 $scope.users = ilmStp.users;
    		 $scope.sites = ilmStp.sites;
    		 $scope.systems = ilmStp.systems;
    		 $scope.cancel = function() {
                $mdDialog.cancel();
             };
             $scope.createStore = function(data){
    			 $mdDialog.cancel();    			 
            	 RestAPIService.createILMStore(data).then(
                     function(success) {                    	 
                    	 $mdDialog.show(
                   		      $mdDialog.alert()
                   		        .parent(angular.element(document.querySelector('#popupContainer')))
                   		        .clickOutsideToClose(true)
                   		        .title('Success.')
//                   		        .textContent("System was created successfully.")
                   		        .htmlContent("Store was created successfully.")
                   		        .ariaLabel('Alert Dialog Demo')
                   		        .ok('Ok')
//                   		        .targetEvent(ev)
                   		    );
                    	$state.reload();
                     },
                     function(error) {
                    	 RestAPIService.showErrorDialog(error);
                     }
                    
                 );
    		 
             }
    	 }
    	 $scope.updateStore = function(ev, store){
    		 ilmStp.store = store;
    		 ilmStp.users = $scope.users;
    		 ilmStp.sites = $scope.sites;
    		 ilmStp.systems= $scope.systems;
    		 $mdDialog.show({
                 controller: UpdateStoreDialogController,
                 templateUrl: 'app/main/administration/ILMSetup/updateStoreDialog.html',
                 parent: angular.element(document.body),
                 targetEvent: ev,
                 clickOutsideToClose: true,
                 fullscreen: $scope.customFullscreen
             })
    	 }
    	 function UpdateStoreDialogController($scope, $mdDialog){
    		 $scope.store = ilmStp.store;
    		 $scope.users = ilmStp.users;
    		 $scope.sites = ilmStp.sites;
    		 $scope.systems = ilmStp.systems;
    		 $scope.updateStore = function(data){
    			 $mdDialog.cancel();    			 
            	 RestAPIService.updateILMStore(data).then(
                     function(success) {                    	 
                    	 $mdDialog.show(
                   		      $mdDialog.alert()
                   		        .parent(angular.element(document.querySelector('#popupContainer')))
                   		        .clickOutsideToClose(true)
                   		        .title('Success.')
//                   		        .textContent("System was created successfully.")
                   		        .htmlContent("Store was updated successfully.")
                   		        .ariaLabel('Alert Dialog Demo')
                   		        .ok('Ok')
//                   		        .targetEvent(ev)
                   		    );
                    	$state.reload();
                     },
                     function(error) {
                    	 RestAPIService.showErrorDialog(error);
                     }
                    
                 );
    		 
             
    		 }
    		 $scope.cancel = function() {
    			 $mdDialog.cancel();
             };
    	 }
    	 
    	 $scope.deleteStore = function(data){

    		 var confirm = $mdDialog.confirm()
             .title('Remove')
             .textContent('Store will be permanently deleted. Continue ?')
//             .targetEvent(ev)
             .ok('Ok')
             .cancel('Cancel');
    		 $mdDialog.show(confirm).then(function() {
                 RestAPIService.deleteStotre(data.id).then(
                     function(success) {
                    	 $mdDialog.show(
                      		      $mdDialog.alert()
                      		        .parent(angular.element(document.querySelector('#popupContainer')))
                      		        .clickOutsideToClose(true)
                      		        .title('Success.')
//                      		        .textContent("System was created successfully.")
                      		        .htmlContent("Store was deleted successfully.")
                      		        .ariaLabel('Alert Dialog Demo')
                      		        .ok('Ok')
//                      		        .targetEvent(ev)
                      		    );
                         $state.reload();
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                     }
                 );
             }, function() {
                 $mdDialog.cancel();
             });
    	 
    	 }
    	 $scope.stores = [
    		 {
    			 "storeId": 12345,
    			 "description":"Used for SAP Syatems"
    		 },
    		 {
    			 "storeId":456666,
    			 "description":"Used for Non SAP Syetems"
    		 },
    		 {
    			 "storeId": 12345,
    			 "description":"Used for SAP Syatems"
    		 },
    		 {
    			 "storeId":456666,
    			 "description":"Used for Non SAP Syetems"
    		 }
    	 ];
    	 $scope.goToPreviousState = function() {
          	$state.go("app.overview");
           	$("#vertical-navigation").show();
           	$("#content-container").css({ "margin-left": "60px" });
          }
     }
 })();
(function ()
{
    'use strict';

    angular
        .module('app.forgot-password',[])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.forgot-password', {
                url    : '/forgot-password',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/forgot-password/forgot-password.html',
                        controller : 'ForgotPasswordController as vm'
                    }
                }
               
            })
          msNavigationServiceProvider.saveItem('fuse.forgot-password', {
            title    : 'ForgotPassword',
            icon     : 'icon-account-key',
            // state    :'app.forgot-password',
            weight   : 2
        });               
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.forgot-password')
        .controller('ForgotPasswordController', ForgotPasswordController);

    /** @ngInject */
    function ForgotPasswordController($scope)
    {
        var vm=this;
        vm.reset=reset;
        function reset(userData){
              console.log(userData);
                
                
                $scope.user = {};            
                vm.forgotPasswordForm.$setPristine();
               vm.forgotPasswordForm.$setUntouched();
          
            }

        

        // Methods

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router'
                
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element   : element,
                scope     : scope,
                form      : form,
                stepNumber: scope.step || (vm.steps.length + 1),
                stepTitle : scope.stepTitle
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });
            
            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step        : '=?',
                stepTitle   : '=?',
                optionalStep: '=?',
                hideStep    : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step        : '=?',
                stepTitle   : '=?',
                optionalStep: '=?',
                hideStep    : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);
                    
                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    // {
                    //     'title'      : 'Sample',
                    //     'icon'       : 'icon-tile-four',
                    //     'state'      : 'app.sample',
                    //     'weight'     : 1,
                    //     'children'   : [],
                    //     '_id'        : 'sample',
                    //     '_path'      : 'apps.sample',
                    //     'uisref'     : 'app.sample',
                    //     'hasShortcut': true
                    // }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                      //  bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
          /*  return foldable.scope.isNavFoldedOpen();*/
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {

        // Default configuration
        var defaultConfiguration = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }
                var offset = moment(val).utcOffset();
                var date = new Date(moment(val).add(offset, 'm'));
                return date;
            }
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            return defaultConfiguration;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require: 'ngModel',
            link   : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.unshift(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.unshift(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbarsearch', [] )
        .config(config)
        .directive('toolbarSearchBar', ToolbarSearchBarDirective);
;

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdThemingProvider)
    {
    	 $stateProvider
            
            .state('app.toolbarsearch', {
                url: '/toolbarsearch',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/toolbarsearch/toolbarsearch.html',
                        controller: 'ToolbarsearchController as toolbarSearchCtrl'
                    }
                }
            })
           .state('app.resultFiles', {
                url: '/smartportal/search',
                params: {
                    param1: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/toolbarsearch/toolbarSearchResultNew.html',
                        controller: 'ToolbarsearchController as toolbarSearchCtrl'
                    }
                },
                resolve: {
                    fileResults: ['$stateParams', function($stateParams) {
                        return $stateParams.param1;
                    }]
                }
            });
    }

    /** @ngInject */
    function ToolbarSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'toolbarSearchBar',
            controller      : 'ToolbarsearchController as toolbarSearchCtrl',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/main/toolbarsearch/toolbarsearch.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('toolbar-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }

                };
            }
        };
    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.toolbarsearch')
        .controller('ToolbarsearchController', ToolbarsearcController)
        .value("AdvanceSearchObject", {value: ""})
        .value("SearchTerm", {value: ""})
        .value("SearchType", {value: ""})
        .value("FileIdForLegacyForm", {value: ""});
        

    /** @ngInject */
    function ToolbarsearcController($state,$stateParams,$scope, $element, $timeout, $mdDialog,RestAPIService, AdvanceSearchObject,SearchTerm,SearchType, FileIdForLegacyForm,CurrentSiteId, CommonUtil)
    {
        var toolbarSearchCtrl = this;
        toolbarSearchCtrl.resultfiles = $stateParams.param1;
       // alert(JSON.stringify(toolbarSearchCtrl.resultfiles));

        // Data
        toolbarSearchCtrl.collapsed = true;
        toolbarSearchCtrl.query = '';
        toolbarSearchCtrl.queryOptions = {
            debounce: toolbarSearchCtrl.debounce || 0
        };
        toolbarSearchCtrl.resultsLoading = false;
        toolbarSearchCtrl.results = null;
        toolbarSearchCtrl.selectedResultIndex = 0;
        toolbarSearchCtrl.ignoreMouseEvents = false;
       
         $scope.fileResults = {};
         



        // Methods
        toolbarSearchCtrl.populateResults = populateResults;

        toolbarSearchCtrl.expand = expand;
        toolbarSearchCtrl.collapse = collapse;

        toolbarSearchCtrl.absorbEvent = absorbEvent;
        toolbarSearchCtrl.handleKeydown = handleKeydown;
        toolbarSearchCtrl.handleMouseenter = handleMouseenter;
        toolbarSearchCtrl.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        toolbarSearchCtrl.handleResultClick = handleResultClick;
        toolbarSearchCtrl.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        toolbarSearchCtrl.advancedSearchPopup = advancedSearchPopup;
        $scope.dtOptions={
             dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
             columnDefs: [

                 { // Target the actions column
                     targets: 0,
                     responsivePriority: 1,
                     filterable: false,
                     sortable: false
                 }
             ],
             pagingType: 'simple',
             lengthMenu: [10, 20, 30, 50, 100],
             pageLength: 20
                 // scrollY     : 'auto',
                 //responsive  : true
         };  

         $scope.detailsVisibility = false;   
          
        //////////     

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('toolbarSearchCtrl.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( toolbarSearchCtrl.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(toolbarSearchCtrl.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    toolbarSearchCtrl.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    toolbarSearchCtrl.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            toolbarSearchCtrl.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            toolbarSearchCtrl.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            toolbarSearchCtrl.resultsLoading = false;
                        }
                    );
                }
            });
        }

        

        toolbarSearchCtrl.VersionFile = {};
        $scope.VersionFileDialog = function(ev, file) {
            toolbarSearchCtrl.VersionFile = angular.copy(file);
            $mdDialog.show({
                controller: VersionFileDialogController,
                templateUrl: 'app/main/toolbarsearch/versionFile.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen,

            })

        };
        function VersionFileDialogController($scope, $mdDialog) {           
            $scope.VersionFile = toolbarSearchCtrl.VersionFile;
            $scope.selectedFileName = toolbarSearchCtrl.selectedFileName;
            var formData = new FormData();
            $scope.setFile = function(element) {
                $scope.$apply(function() {
                    $scope.files = [];
                    for (var i = 0; i < element.files.length; i++) {
                        formData.append('file', element.files[i]);
                        $scope.files.push(element.files[i]);
                    }
                });
            };
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.NewVersionFile = function() {

                //alert(JSON.stringify(checkInfile));
                RestAPIService.NewVersionFile($scope.files[0], toolbarSearchCtrl.VersionFile).then(
                    function(success) {
                       toolbarSearchCtrl.getFileAttributeDetails(toolbarSearchCtrl.selectedFile.id,CurrentSiteId.value);
                    },
                    function(error) {
                        //  RestAPIService.showErrorDialog(error);
                         $mdDialog.show(
                            $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('Error')
                            .textContent(error.data.description)
                            .ok('Ok')
                        );
                    }
                );
                $mdDialog.hide();
            };
        }
         toolbarSearchCtrl.checkInFile = {};
        $scope.checkInFileDialog = function(ev) {
            toolbarSearchCtrl.checkInFile = angular.copy(toolbarSearchCtrl.receivedFile);
            $mdDialog.show({
                controller: CheckInFileDialogController,
                templateUrl: 'app/main/toolbarsearch/checkInFile.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen,
            })
        };
        function CheckInFileDialogController($scope, $mdDialog) {           
            $scope.checkInFile = toolbarSearchCtrl.checkInFile;
            var formData = new FormData();
            $scope.setFile = function(element) {
                $scope.$apply(function() {
                    $scope.files = [];
                    for (var i = 0; i < element.files.length; i++) {
                        formData.append('file', element.files[i]);
                        $scope.files.push(element.files[i]);
                    }
                });
            };
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.checkIn = function() {
                //alert(JSON.stringify(checkInfile));
                RestAPIService.checkIn($scope.files[0], toolbarSearchCtrl.checkInFile).then(
                    function(success) {
                        //alert("checkIn Success")
                        //$state.reload();
                        $mdDialog.show(
                                $mdDialog.alert()
                                .clickOutsideToClose(true)
                                .title('Success!')
                                .textContent('File checked in successfully')
                                .ok('Ok')
                            );
                    },
                    function(error) {
                        $mdDialog.show(
                            $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('Error')
                            .textContent(error.data.description)
                            .ok('Ok')
                        );
                   }
                );
                $mdDialog.hide();
            };
        }
         $scope.buildForm = function(fileId) {
           
            /*RestAPIService.buildForm(fileId).then(
                function(success){
                    $scope.FormsData =success.data;
                    alert(JSON.stringify($scope.FormsData));
                },
                 function(error){
                        RestAPIService.showErrorDialog(error);
                    }
                );   */  
            FileIdForLegacyForm.value=fileId;

             $state.go('app.doclibraryForm');


        };
    
        $scope.fileCheckout = function(){
            var fileId = toolbarSearchCtrl.receivedFile.id;
            RestAPIService.fileCheckout(fileId).then(
                function(success) { 
                        var headers = success.headers();
                        var data = success.data;
                        var filename = toolbarSearchCtrl.selectedFileName;
                        var contentType = headers['content-type'];
                        var linkElement = document.createElement('a');
                        try {
                            var blob = new Blob([data], { type: contentType });
                            var url = window.URL.createObjectURL(blob);
                            linkElement.setAttribute('href', url);
                            linkElement.setAttribute("download", filename);
                            var clickEvent = new MouseEvent("click", {
                                "view": window,
                                "bubbles": true,
                                "cancelable": false
                            });
                            linkElement.dispatchEvent(clickEvent);
                        } catch (ex) {
                            console.log(ex);
                        }
                },
                function(error) {
                    console.log('ERROR Downloading the file ********');
                    //RestAPIService.showErrorDialog(error);  
                           $mdDialog.show(
                            $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('Error')
                            .textContent(error.data.description)
                            .ok('Ok')
                        );
                
                }
            );
        }

            toolbarSearchCtrl.searchresultsDownload = function(file){
            //    alert(file.fileExtension);
            if(file.fileType == 'json' || file.fileType == 'JSON'){
                 FileIdForLegacyForm.value =file.id;
                 CurrentSiteId.value = file.siteId;
                  $state.go('app.doclibraryForm');
                }
                else{
                    RestAPIService.searchresultsDownload(file.id,file.siteId).then(
                        function(success) { 
                            var headers = success.headers();
                            //alert(JSON.stringify(headers));
                            var data = success.data;
                            //alert(data);
                            //var filename = headers['x-filename'];
                            var filename = toolbarSearchCtrl.selectedFileName;
                            var contentType = headers['content-type'];
                            var linkElement = document.createElement('a');
                            try {
                                var blob = new Blob([data], { type: contentType });
                                var url = window.URL.createObjectURL(blob);
                                linkElement.setAttribute('href', url);
                                linkElement.setAttribute("download", filename);
                                var clickEvent = new MouseEvent("click", {
                                    "view": window,
                                    "bubbles": true,
                                    "cancelable": false
                                });
                                linkElement.dispatchEvent(clickEvent);
                            } catch (ex) {
                                console.log(ex);
                            }
                            },
                        function(error) {
                            console.log('ERROR Downloading the file ********');
                            RestAPIService.showErrorDialog(error);
                        }
                            );
                                }
                                    }
        
        

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( toolbarSearchCtrl.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            toolbarSearchCtrl.selectedResultIndex = 0;

            // Populate the results
            toolbarSearchCtrl.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            toolbarSearchCtrl.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( toolbarSearchCtrl.onExpand && angular.isFunction(toolbarSearchCtrl.onExpand) )
            {
                toolbarSearchCtrl.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            toolbarSearchCtrl.query = '';

            // Empty results to hide the results view
            toolbarSearchCtrl.populateResults(null);

            // Set collapsed status
            toolbarSearchCtrl.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( toolbarSearchCtrl.onCollapse && angular.isFunction(toolbarSearchCtrl.onCollapse) )
            {
                toolbarSearchCtrl.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:               
                    //User pressed Enter                    
                    SearchTerm.value = toolbarSearchCtrl.query;                          
                    SearchType.value = 'basic';  
                     getSearchResult();
                    //$state.go('app.resultFiles');
                    // Send to the result files state.
                    // if(SearchTerm.value != ""){
                    //     $state.go('app.resultFiles');
                    // }else{                        
                    //     $mdDialog.show(
                    //       $mdDialog.alert()
                    //         .parent(angular.element(document.querySelector('#popupContainer')))
                    //         .clickOutsideToClose(true)                           
                    //         .textContent('Please specify the Search Term')                           
                    //         .ok('OK')                           
                    //     );
                    // }
                    //$mdDialog.cancel();
                    //toolbarSearchCtrl.advancedSearchPopup();
                    // Trigger result click
                    //toolbarSearchCtrl.handleResultClick(toolbarSearchCtrl.results[toolbarSearchCtrl.selectedResultIndex]);

                    break;

                // Escape
                case 27:
                    //User pressed Escape
                    // Collapse the search bar
                    toolbarSearchCtrl.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( toolbarSearchCtrl.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        toolbarSearchCtrl.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        toolbarSearchCtrl.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !toolbarSearchCtrl.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( toolbarSearchCtrl.selectedResultIndex + 1 < toolbarSearchCtrl.results.length )
                    {
                        // Increase the selected index
                        toolbarSearchCtrl.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        toolbarSearchCtrl.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( toolbarSearchCtrl.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            toolbarSearchCtrl.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            toolbarSearchCtrl.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(toolbarSearchCtrl.mouseEventIgnoreTimeout);

            // Set the timeout
            toolbarSearchCtrl.mouseEventIgnoreTimeout = $timeout(function ()
            {
                toolbarSearchCtrl.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( toolbarSearchCtrl.onResultClick )
            {
                toolbarSearchCtrl.onResultClick({item: item});
            }

            // Collapse the search bar
            toolbarSearchCtrl.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[toolbarSearchCtrl.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                toolbarSearchCtrl.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

       

        $scope.selectFile = function(fileItem, i, event) { 
            //alert(JSON.stringify(fileItem));
            
            $scope.selectedRow = i; 
            toolbarSearchCtrl.receivedFile = fileItem;
            $scope.filebuttonVisibility = false;
            $scope.iconsVisibility = i;
            $scope.detailsVisibility = true;

            if (fileItem.type === "folder") {
                $scope.versionsVisibility = false;
            }
            else{
                $scope.versionsVisibility = true;
            }

            if (fileItem.fileExtension === "pdf" || fileItem.fileExtension === "txt" || fileItem.fileExtension === "PDF" || fileItem.fileExtension === "docx" || fileItem.fileExtension === "ppt" || fileItem.fileExtension === "xls") {
                $scope.filebuttonVisibility = true;
            }
            
            $scope.fileName = fileItem.name;
            $scope.selectedFileIcon = CommonUtil.getIconForFile(fileItem);
            // Call API service to get attributes, versions and activities of this file.
            
            var fileId = fileItem.id;
            toolbarSearchCtrl.selectedFileName = fileItem.name;
            var siteId = fileItem.siteId;
            CurrentSiteId.value = siteId;
            toolbarSearchCtrl.getFileAttributeDetails(fileId, siteId);
             // toolbarSearchCtrl.getAttributes(fileId);
            toolbarSearchCtrl.edit =false;
            toolbarSearchCtrl.viewFile =false;
            RestAPIService.getMyFilePermissions(siteId,fileId).then(
                    function(response){
                     $scope.myPermissions = response.data;
                    toolbarSearchCtrl.filePermissions = $scope.myPermissions;
                   //alert(JSON.stringify($scope.myPermissions.permissions));
                                     
                    if($scope.myPermissions.permissions != undefined) {
                    var responseEdit = $scope.myPermissions.permissions.indexOf("Edit");
                    var responseView = $scope.myPermissions.permissions.indexOf("View");
                    
                        if(responseEdit >= 0) {
                            toolbarSearchCtrl.edit = true;
                        }
                    if(responseView >=0){
                        toolbarSearchCtrl.viewFile = true;
                        }
                        
                    }
                                    },
                    function(error){
                        RestAPIService.showErrorDialog(error);
                    }
                );  
        }

        toolbarSearchCtrl.getFileAttributeDetails = function(fileId, siteId) {
            RestAPIService.getFileAttributeDetails(fileId, siteId).then(
                function(response) {
                    $scope.file = response.data;
                    toolbarSearchCtrl.selectedFile = response.data;
                    $scope.allSharedUsers = response.data.users;
                    $scope.versions = response.data.versions;
                    $scope.activities = response.data.activities;                    
                    $scope.fileAttributes = [];
                    for(var attributeName in response.data.attributes){
                        var attribute = {
                            name: attributeName,
                            value: response.data.attributes[attributeName]
                        }
                        $scope.fileAttributes.push(attribute);
                    }                    
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );
        };

        function advancedSearchPopup(){
            $mdDialog.show({
                controller: advancedSearchPopupController,
                templateUrl: 'app/main/toolbarsearch/toolbarSearchPopup.html',
                parent: angular.element(document.body),
                // targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: $scope.customFullscreen 
            })
        }
        toolbarSearchCtrl.resultFiles = {};
        function advancedSearchPopupController($scope, RestAPIService,SearchType, CommonUtil, CurrentSiteId){
            $scope.fileExtensions= ["json","pdf","docx","xl","txt","jpeg","folder","jpg","png","html","xml","doc"];
            $scope.file={                
                "fileExtension":null,
                "creator":null,                                
                "fileName":null,
                "fromDate":null,
                "toDate":null,
                // "businessObject":"",
                "fullTextSearch":null                
            }
            SearchTerm.value = toolbarSearchCtrl.query; 
            $scope.hasTheWords=SearchTerm.value;
            SearchType.value =  'advance';
            $scope.noOfAttributesToDisplay = 5;

            $scope.locations = ["allSites","currentSite"];
            $scope.dateModifiedTypes = ["Any Time", "Today","Yesterday","Last 7 days","Last 30 days","last 90 days"];
            $scope.reset = function(fileData){
                $scope.file = {};
                $scope.attributeObjects = {};
            }
            $scope.cancel = function(){
                $mdDialog.cancel();
            }
            
            $scope.getAllBusinessObjects=function(){            
                RestAPIService.getAllBusinessObjects().then(
                    function(responce){
                        $scope.allBusinessObjects = responce.data;                    
                    },
                    function(error){
                        RestAPIService.showErrorDialog(error);
                    })
            }
            $scope.selectBusinessObject = function(businessObject){                                               
                // Calling Rest API Service to get Attributes of this Business Object
                RestAPIService.findBusinessObjectAttributes(businessObject.id).then(function(responce){                   
                    $scope.attributeObjects = responce.data.attributes;                    
                    // If any Attribute is having listReferrence as COMMA separated values, Split them.
                    if($scope.attributeObjects != null){
                            $scope.attributeObjects.forEach(function(attribute){                   
                            if(attribute.type == "List"){
                                attribute['listValues'] = attribute.listReference.split(',');                  
                            }
                        });  
                    }                    
                },
                function(error){
                    RestAPIService.showErrorDialog(error);
                })                                                       
            }            
            $scope.moreObjects = function(){
                // Increase +5 objects using limitTo filter.
                $scope.noOfAttributesToDisplay += 5;
            }
            $scope.searchFiles = function(hasTheWords, fileData,attributeObjects, siteLocation){
                // alert(JSON.stringify(fileData));                
                if(siteLocation == "currentSite"){
                    fileData.siteId = CurrentSiteId.value;
                }
                 // Build the Attribute Objects array & Append to fileData.So that we can send whole object to API.
                fileData.attributes=[]; 
                if(attributeObjects != undefined){
                    attributeObjects.forEach(function(h){
                        if(h.range == true){
                            if((h.fromValue != undefined && h.fromValue != "") && (h.toValue != undefined && h.toValue != "")){
                                fileData.attributes.push({'name': h.label, 'fromValue': h.fromValue, 'toValue':h.toValue});
                            }
                            else if((h.fromValue != undefined && h.fromValue != "") &&(h.toValue == undefined || h.toValue == "")){
                                fileData.attributes.push({'name': h.label, 'fromValue': h.fromValue, 'toValue':""});
                            }
                            else if((h.fromValue == undefined || h.fromValue == "") && (h.toValue != undefined || h.toValue != "")){
                                fileData.attributes.push({'name': h.label, 'fromValue': "", 'toValue':h.toValue});
                            }
                        }
                        else if(h.range == false){
                            if(h.fromValue != undefined  && h.fromValue != ""){
                               fileData.attributes.push({'name': h.label, 'fromValue': h.fromValue}); 
                            }
                        }
                    });
                }
                AdvanceSearchObject.value = fileData;
                // Override the value of "SearchTerm.value" with the "hasTheWords" for validation.
                SearchTerm.value = hasTheWords;
                // alert(JSON.stringify(AdvanceSearchObject.value));

                if((fileData.fileName != null && fileData.fileName!= undefined) || (fileData.fromDate!= null && fileData.fromDate!= undefined) || (fileData.toDate!= null && fileData.toDate!= undefined) || (fileData.businessObject!= null && fileData.businessObject!= undefined) || (fileData.fileExtension!= null && fileData.fileExtension!= undefined) ){
                    getSearchResult();
                    $mdDialog.cancel();
                }
                else if(SearchTerm.value != "" && SearchTerm.value != undefined){
                    
                        getSearchResult();
                        $mdDialog.cancel();
                    }
                else {
                        // $mdDialog.show(
                        //   $mdDialog.alert()
                        //     .parent(angular.element(document.querySelector('#popupContainer')))
                        //     .clickOutsideToClose(true)                            
                        //     .textContent('Please specify the Search Term')                            
                        //     .ok('OK')                            
                        // );
                        RestAPIService.successTostDialog("Please specify the Search term."); 
                }       
            }             
        }

       function getSearchResult(){        
            if(SearchType.value=='advance'){                    
                // alert(JSON.stringify(AdvanceSearchObject.value));
                RestAPIService.advancedSearch(AdvanceSearchObject.value,toolbarSearchCtrl.pageNumber, toolbarSearchCtrl.pageSize, toolbarSearchCtrl.dateRange  ).then(function(responce){                           
                    toolbarSearchCtrl.resultFiles =responce.data;
                     $scope.fileResults = toolbarSearchCtrl.resultFiles;
                     console.log($scope.fileResults);
                     $state.go('app.resultFiles', {param1: $scope.fileResults})
                },
                function(error){
                    RestAPIService.showErrorDialog(error);
                })            
            }
            else{            
                RestAPIService.basicSearch(SearchTerm.value ).then(function(responce){
                    toolbarSearchCtrl.resultFiles =responce.data;   
                  //  alert(JSON.stringify(responce.data));
                    $scope.fileResults = toolbarSearchCtrl.resultFiles;
                     console.log($scope.fileResults);
                     $state.go('app.resultFiles', {param1: $scope.fileResults})                   
                },
                function(error){
                    RestAPIService.showErrorDialog(error);
                })                   
            }                
        }

        $scope.getSearchResult = function(){        
            if(SearchType.value=='advance'){                    
                // alert(JSON.stringify(AdvanceSearchObject.value));
                RestAPIService.advancedSearch(AdvanceSearchObject.value,toolbarSearchCtrl.pageNumber, toolbarSearchCtrl.pageSize, toolbarSearchCtrl.dateRange  ).then(function(responce){                           
                    toolbarSearchCtrl.resultFiles =responce.data;
                     $scope.fileResults = toolbarSearchCtrl.resultFiles;
                      toolbarSearchCtrl.numberOfElements = responce.headers('x-total-count');
                   // Make page numbers to be populated in dropdown, to select page numbers directly.
                     $scope.noOfPages =toolbarSearchCtrl.numberOfElements/toolbarSearchCtrl.pageSize;
                                 
                      $scope.pageNumbers = [];
                      if($scope.noOfPages > 0){
                        for(var i=0; i<$scope.noOfPages; i++){
                            $scope.pageNumbers.push(i);
                        }                        
                      } 
                     $state.go('app.resultFiles');
                },
                function(error){
                    RestAPIService.showErrorDialog(error);
                })            
            }
            else{            
                RestAPIService.basicSearch(SearchTerm.value ).then(function(responce){
                    toolbarSearchCtrl.resultFiles =responce.data;   
                      $scope.fileResults = toolbarSearchCtrl.resultFiles;
                       toolbarSearchCtrl.numberOfElements = responce.headers('x-total-count');
                     // Make page numbers to be populated in dropdown, to select page numbers directly.
                      $scope.noOfPages =toolbarSearchCtrl.numberOfElements/toolbarSearchCtrl.pageSize;
                      $scope.pageNumbers = [];
                      if($scope.noOfPages > 0){
                        for(var i=0; i<$scope.noOfPages; i++){
                            $scope.pageNumbers.push(i);
                        }                       
                      } 
                     $state.go('app.resultFiles');                
                },
                function(error){
                    RestAPIService.showErrorDialog(error);
                })                   
            }                
        }
        toolbarSearchCtrl.pageNumber = 0;
        toolbarSearchCtrl.pageSize = 20;
        toolbarSearchCtrl.next = function(){
            toolbarSearchCtrl.pageNumber = toolbarSearchCtrl.pageNumber + 1;            
            $scope.getSearchResult();            
        }
        toolbarSearchCtrl.previous = function(){
            toolbarSearchCtrl.pageNumber = toolbarSearchCtrl.pageNumber - 1;           
            $scope.getSearchResult();
        }
        $scope.sendPageNumber = function(pageNumber){
            toolbarSearchCtrl.pageNumber = pageNumber;
            $scope.getSearchResult();
        }

    }   
})();
(function ()
{
    'use strict';

    angular
        .module('app.smartstore-admin')
        .controller('SmartstoreController', SmartstoreController);

    
    function SmartstoreController($state,$scope,$filter)
    {
    	var smartstoreCtrl =this;
    	
    	smartstoreCtrl.goToCompanies = function(){
             $state.go('app.smartstore-admin.companies');
            }
    	
    	smartstoreCtrl.gotoMimeType = function(){
            $state.go('app.smartstore-admin.mimetype');
           }
    	smartstoreCtrl.goToSystems = function(){
            $state.go('app.smartstore-admin.systems');
           }
    	smartstoreCtrl.goToRepository = function(){
    		$state.go('app.smartstore-admin.repository');
    	}
    	
    }


         
})();
(function ()
{
    'use strict';

    angular
        .module('app.sites')
        .controller('SitesController', SitesController);
       
    /** @ngInject */
    function SitesController($state, $scope, $location, $mdDialog,$document, CurrentSiteName, CurrentSiteId, CurrentSiteUrl, CurrentSitePage, RestAPIService, Icons, Sites,textAngularManager, $stateParams)
    {
        var siteCtrl = this;    
        siteCtrl.sites = Sites.data;
        //console.log(siteCtrl.sites);
        siteCtrl.totalSites = Sites.data.length;
        $scope.siteId = "site-2";
        //List of sites              
        siteCtrl.getSites = function() {  
            RestAPIService.getSites().then(
                function(success){
                  siteCtrl.sites = success.data;
                  
                  siteCtrl.totalSites = success.data.length;
                },
                function(error){
                   RestAPIService.showErrorDialog(error);
                }
            );
        }
        siteCtrl.goToSites = function(siteUrl){
            $state.go("app.sites");
        }
        siteCtrl.openSite = function(siteUrl){
            $state.go("app.sites.site");
        }
        $scope.notesData = [];
        if($scope.siteId != undefined) {
            RestAPIService.getToDoList($scope.siteId).then(
              function(success){
                  $scope.notesData = success.data;                
             },
             function(error){
                 RestAPIService.showErrorDialog(error);
             });
        }
        
        $scope.loadPage = CurrentSitePage.value;
        $scope.loadHome =function(){
        	$scope.notes = [];
        	 CurrentSitePage.value = 'Home';
        	 $scope.loadPage = 'Home';         	
        }
       /* $scope.loadDashboard = function(){
        	$scope.notes = [];
            CurrentSitePage.value = 'home';
            $scope.loadPage = 'home';
        }*/
        $scope.loadDoclibrary = function(){
        	$scope.notes = [];
            CurrentSitePage.value = 'Library';
            $scope.loadPage = 'Library';
        }
        $scope.loadMembers = function(){
        	$scope.notes = [];
            CurrentSitePage.value = 'members';
            $scope.loadPage = 'members';
        }
        $scope.loadTodoList = function(){
        	$scope.notes = [];
            CurrentSitePage.value = 'notes';
            $scope.loadPage = 'notes';
            $scope.notes = $scope.notesData;            
        }
        $scope.loadDiscussionForum = function(){
        	$scope.notes = [];
            CurrentSitePage.value = 'discussionforum';
            $scope.loadPage = 'discussionforum';
        }
        $scope.loadSiteSettings = function(){
        	$scope.notes = [];
            CurrentSitePage.value = 'sitesettings';
            $scope.loadPage = 'sitesettings';
        }

        siteCtrl.getAnotherColor =  function(index){
            siteCtrl.colors = ['red','pink','purple','deep-purple','indigo','blue', 'light-blue','cyan', 'teal','green',
                        'light-green','lime','yellow','amber','deep-orange','brown','grey','blue-grey'];
            var totalNoOfColors = siteCtrl.colors.length;                        
            return siteCtrl.colors[index%totalNoOfColors];
        }

        siteCtrl.showConfirm = function(ev){
            $mdDialog.show({
                template           : '<md-dialog ms-scroll><ms-note-form note-type="\'new\' "></ms-note-form></md-dialog>',
                parent             : $document.find('#notes'),
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true
            
            });
        }  
        siteCtrl.escKeyEvent = function escKeyEvent(e)
        {
            if ( e.keyCode === 27 )
            {
                showConfirm();
            }
        }
       
        siteCtrl.enterSite =  function(site){
            //Set the name and id of the selected site
            CurrentSiteName.value = site.name;
            CurrentSiteId.value = site.id;
            CurrentSiteUrl.value = site.url;
            CurrentSitePage.value = 'Home';
            $state.go('app.sites.site', {siteId: site.id});
        }

        siteCtrl.getCurrentSiteName =  function(){
            return CurrentSiteName.value;
        }
        siteCtrl.getCurrentSiteId =  function(){
            return CurrentSiteId.value;
        }
        siteCtrl.getCurrentSitePage =  function(){
            if(CurrentSitePage.value == 'Home'){
            	$scope.loadHome();
            }
            return CurrentSitePage.value;
        }

       
        siteCtrl.deleteSite = function(ev) {
          // Appending dialog to document.body to cover sidenav in docs app
          var confirm = $mdDialog.confirm()
                .title('Remove')
                .textContent('All members, documents and site related data will be permanently deleted. Continue ?')
                .ariaLabel('Delete Site')
                .targetEvent(ev)
                .ok('Ok')
                .cancel('Cancel');

                $mdDialog.show(confirm).then(function() {
                  //Deleting the site
                  RestAPIService.deleteSite(siteCtrl.getCurrentSiteId()).then(
                        function(success){
                          //Go back to sites page                          
                          //Delete site successful.Need to do GET again to refresh.
                          //$state.go('app.sites', null, { reload: true });
                          RestAPIService.successTostDialog("Site deleted successfully ");
                          siteCtrl.getSites();
                          $location.url('/sites');
                          
                        },
                        function(error){
                           RestAPIService.showErrorDialog(error);
                        }
                  );    
                  
                }, function() {
                  //User clicked Cancel. Close the popup.
                });
        };



        $scope.createSite = function(ev) {
             $mdDialog.show({
                  controller: CreateSiteDialogController,
                  templateUrl: 'app/main/sites/site/create.site.dialog.html',
                  parent: angular.element(document.body),
                  targetEvent: ev,
                  clickOutsideToClose:true,
                  fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })
                .then(function(answer) {
                  //$scope.status = 'You said the information was "' + answer + '".';
                }, function() {
                  //$scope.status = 'You cancelled the dialog.';
                });
          };
        

        function CreateSiteDialogController($scope, $mdDialog, RestAPIService, CurrentSiteLogo) {
           $scope.taToolbar = [
            ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote', 'bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
            ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent', 'html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount']
        ];



   $scope.ngFlowOptions = {
            // You can configure the ngFlow from here
            /*target                   : 'api/media/image',
             chunkSize                : 15 * 1024 * 1024,
             maxChunkRetries          : 1,
             simultaneousUploads      : 1,
             testChunks               : false,
             progressCallbacksInterval: 1000*/
        };
        $scope.ngFlow = {
            // ng-flow will be injected into here through its directive
            flow: {}
        };
        $scope.dropping = false;
        $scope.upload = upload;



        function upload()
        {
            // Set headers
            $scope.ngFlow.flow.opts.headers = {
                'X-Requested-With': 'XMLHttpRequest',
                //'X-XSRF-TOKEN'    : $cookies.get('XSRF-TOKEN')
            };

            $scope.ngFlow.flow.upload();
        }
            $scope.hide = function() {

              $mdDialog.hide();
            };

            $scope.cancel = function() {
                $scope.user = {};     
                $mdDialog.cancel();
            };

            $scope.save = function(userData) {
                  //Site Icon come from global variable
                   userData.icon = CurrentSiteLogo.value;

                   RestAPIService.createSite(userData).then(
                        function(success){
                           //Create site successful.Need to do GET again to refresh.
                           //$state.reload();
                           RestAPIService.successTostDialog("Site successfully created");
                           siteCtrl.getSites();
                        },
                        function(error){
                        	console.log(error);
                        	 RestAPIService.successTostDialog(error.data.description);
                        }
                    );                                 
                    $mdDialog.hide(userData);
            };

            //Setting icons in the dialog scope
            $scope.icons = Icons.icons;

            $scope.openIconList = function(ev) {
              $mdDialog.show({
                  controller: CreateSiteDialogController,
                  templateUrl: 'app/main/sites/site/dashboard/site.logo.html',
                  parent: angular.element(document.body),
                  targetEvent: ev,
                  clickOutsideToClose:true,
                  preserveScope: true,
                  autoWrap: true,
                  
                  skipHide: true, // this line does the trick for nested dialogs

                  fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })
                .then(function(answer) {
                  $scope.status = 'You said the information was "' + answer + '".';
                }, function() {
                  $scope.status = 'You cancelled the dialog.';
                });
            };
        
            $scope.noOfIconsForDisplay = 50;
            $scope.iconsPerColumn = 5;

            $scope.range = function(min, max, step){
              step = step || 1;
              var input = [];
              for (var i = min; i <= max; i += step) input.push(i);
              return input;
            };

            $scope.loadMoreIcons = function() {
                $scope.noOfIconsForDisplay += 10;
                // if($scope.noOfIconsForDisplay >= 60)      $scope.iconsPerColumn=10;
                // if($scope.noOfIconsForDisplay >= 140)      $scope.iconsPerColumn=20;
                // if($scope.noOfIconsForDisplay >= 200)      $scope.iconsPerColumn=30;
                // if($scope.noOfIconsForDisplay >= 250)      $scope.iconsPerColumn=40;
                // if($scope.noOfIconsForDisplay >= 300)      $scope.iconsPerColumn=50;
                // if($scope.noOfIconsForDisplay >= 350)      $scope.iconsPerColumn=100;
            };

             $scope.saveLogo = function(siteIcon) {
                //alert(siteIcon);
               
               //Set the name of the selected site
                CurrentSiteLogo.value = siteIcon;
                $mdDialog.hide();
            };
          }
          
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.settings', [] )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdThemingProvider)
    {
    	 $stateProvider
            
            .state('app.settings', {
                url: '/settings',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/settings/settings.html',
                        controller: 'SettingsController as setCtrl'
                    }
                }
            });
           /* .state('app.lists', {
                url: '/settings',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pages/errors/404/error-404.html',
                        controller: 'Error404Controller as cf'
                    }
                }
            })
            .state('app.workflow', {
                url: '/settings',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pages/errors/404/error-404.html',
                        controller: 'Error404Controller as cf'
                    }
                }
            });*/

       /* msNavigationServiceProvider.saveItem('admin.settings', {
            title : 'Settings',
            icon  : 'icon-cog',
            state : 'app.settings',
            weight:5
        });*/

 
              }
})();


(function ()
{
    'use strict';

    angular
        .module('app.settings')
        .controller('SettingsController', SettingsController);

    /** @ngInject */
    function SettingsController($state)
    {
        var settingCtrl = this;
        
        }   
})();
(function() {
    'use strict';

    var app = angular
        .module('app.sharedwithme', [])
       // .run(run)
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider, $controllerProvider, $compileProvider, $filterProvider, $provide) {
        app.controller = $controllerProvider.register;
        app.directive = $compileProvider.directive;
        app.filter = $filterProvider.register;
        app.factory = $provide.factory;
        app.service = $provide.service;

        $stateProvider
            .state('app.sharedwithme', {
                url: '/sharedwithme',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/sharedwithme/sharedwithme.html',
                        controller: 'SharedwithmeController as sharedCtrl'
                    }
                },
               /* resolve: {
                    deps: ['$ocLazyLoad', function($ocLazyLoad) {
                        return $ocLazyLoad.load(['app/main/sharedwithme/sharedwithme.controller.js']);
                    }]
                }*/
            });

       /* msNavigationServiceProvider.saveItem('sharedwithme', {
              title : 'Shared With Me',
              icon  : 'icon-account-plus',
              state : 'app.sharedwithme',
              weight: 5
          });*/

    }
    
   
})();
(function() {
    'use strict';

    angular
        .module('app.sharedwithme')
        .controller('SharedwithmeController', SharedwithmeController);

    /** @ngInject */
    function SharedwithmeController($state, $scope, $http, RestAPIService, CommonUtil, $stateParams, $mdDialog) {
        var sharedCtrl = this;
      //  $scope.sharedfiles = Sharedfiles.data;
        $scope.orderByField = 'name';
        $scope.reverseSort = false;
        $scope.detailsVisibility = false;
        $scope.buttonVisibility = false;
        $scope.filebuttonVisibility = false;
        sharedCtrl.pageNumber = 0;
        sharedCtrl.pageSize = 10;
        sharedCtrl.next = function(){
            sharedCtrl.pageNumber = sharedCtrl.pageNumber + 1;            
            sharedCtrl.getSharedfiles();            
        }
        sharedCtrl.previous = function(){
            sharedCtrl.pageNumber = sharedCtrl.pageNumber - 1;           
            sharedCtrl.getSharedfiles();
        }
        $scope.sendPageNumber = function(pageNumber){
            sharedCtrl.pageNumber = pageNumber;
            sharedCtrl.getSharedfiles();
        }
        
        sharedCtrl.getSharedfiles = function() {
            RestAPIService.getMySharedfiles(sharedCtrl.pageNumber,sharedCtrl.pageSize).then(
                function(success) {
                    $scope.sharedfiles = success.data;
                sharedCtrl.numberOfElements = success.headers('x-total-count');
                  $scope.noOfPages = sharedCtrl.numberOfElements/sharedCtrl.pageSize ;
                    $scope.pageNumbers = [];
                    if($scope.noOfPages > 0){
                      for(var i=0; i<$scope.noOfPages; i++){
                          $scope.pageNumbers.push(i);
                       }                        
                    } 
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );
        }
        sharedCtrl.selectFile = function(fileItem, i) {
            $scope.selectedRow = i;
            sharedCtrl.receivedFile = fileItem;
            sharedCtrl.permissions = fileItem.permissions;

            $scope.detailsVisibility = true;
            if (fileItem.mimeType == "") {
                $scope.buttonVisibility = false;
                $scope.filebuttonVisibility = false;
            } else if (fileItem.mimeType === "application/pdf" || fileItem.mimeType === "text/plain" || fileItem.mimeType === "multipart/form-data" || fileItem.mimeType === "application/octet-stream") {
                $scope.buttonVisibility = false;
                $scope.filebuttonVisibility = true;
            } else {
                $scope.buttonVisibility = true;
                $scope.filebuttonVisibility = false;
            }
            sharedCtrl.selectedFileName = fileItem.name;
            $scope.selectedFileIcon = CommonUtil.getIconForFile(fileItem);
            $scope.businessObjectName = fileItem.businessObjectName;
            var fileId = fileItem.id;
            sharedCtrl.fileattributes = fileItem.attributes;
            $scope.fileattributes = [];
            var keyset = Object.keys(sharedCtrl.fileattributes);
            keyset.forEach(function(key) {
                $scope.fileattributes.push({
                    name: key,
                    value: sharedCtrl.fileattributes[key]
                });
            });
            //alert(JSON.stringify(sharedCtrl.fileattributes));
            // alert(JSON.stringify(sharedCtrl.permissions));
        }
        $scope.previewFileDialog = function(ev) {
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/sharedwithme/previewFiles.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            });
        }

        function DialogController($scope, $mdDialog, $sce, $sessionStorage) {
            var selectedFile = sharedCtrl.receivedFile;
            var siteId = sharedCtrl.receivedFile.siteId;
            var jwtToken = $sessionStorage.currentUser.token.trim();
            if (jwtToken != undefined && selectedFile != undefined) {
                var encodedURI = encodeURIComponent(baseUrl+'/api/sites/' + siteId + '/files/file?fileId=' + selectedFile.id + '&checkingOut=false&attachment=false&jwtToken=' + jwtToken);
                if (selectedFile.mimeType === "application/octet-stream") {
                    $scope.fileURL = $sce.trustAsResourceUrl('https://view.officeapps.live.com/op/view.aspx?src=' + encodedURI + '&embedded=true');
                } else {
                    $scope.fileURL = $sce.trustAsResourceUrl('https://docs.google.com/gview?url=' + encodedURI + '&embedded=true');
                }
            }
        }
        sharedCtrl.fileIcon = function(file) {
            return CommonUtil.getIconForFile(file);
        }
        $scope.buildForm = function(fileId) {

            console.log("$scope.businessObjectName : ", $scope.businessObjectName)

            $state.go('app.doclibraryForm', {
                'siteId': siteId,
                'fileId': fileId,
                'businessObject': $scope.businessObjectName
            });
        };
        
        $scope.isViewBtn = function(permissions, type) {
        	if(undefined != permissions) {
            	var response = permissions.indexOf(type);
            	if(response >= 0) {
            		return true;
            	}
        	}
        }        
        
        $scope.downloadFile = function() {
            var fileId = sharedCtrl.receivedFile.id;
            var siteId = sharedCtrl.receivedFile.siteId;
            RestAPIService.downloadFile(siteId, fileId).then(
                function(success) {
                    var headers = success.headers();
                    var data = success.data;
                    var filename = sharedCtrl.selectedFileName;
                    var contentType = headers['content-type'];
                    var linkElement = document.createElement('a');
                    try {
                        var blob = new Blob([data], {
                            type: contentType
                        });
                        var url = window.URL.createObjectURL(blob);
                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute("download", filename);
                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    } catch (ex) {
                        console.log(ex);
                    }
                },
                function(error) {
                    console.log('ERROR Downloading the file ********');
                    RestAPIService.showErrorDialog(error);
                }
            );
        }
        sharedCtrl.allSharedUsers = [];

        sharedCtrl.sharedUsersDialog = function(ev) {
            $mdDialog.show({
                controller: sharedUsersDialogController,
                templateUrl: 'app/main/sharedwithme/sharedUsersDialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        }

        function sharedUsersDialogController($scope) {
            $scope.allSharedUsers = sharedCtrl.allSharedUsers;
            $scope.selectedFileName = sharedCtrl.selectedFileName;
            var siteId = sharedCtrl.receivedFile.siteId;
            $scope.tableVisibility = false;
            $scope.Options = ["Display", "Edit", "Share", "Delete", "Download"];
            $scope.searchUsers = function(searchKeyword) {
                RestAPIService.searchUsers(searchKeyword).then(
                    function(response) {
                        $scope.searchedUsers = response.data;
                        $scope.tableVisibility = true;
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    });
            }

            $scope.shareFile = function(memberData, status) {
                memberData.status = status;
                $scope.allSharedUsers.push(memberData);
            }

            $scope.removeSharing = function(userData, i) {
                $scope.allSharedUsers.splice(i, 1);
            }
            $scope.cancel = function() {
                $mdDialog.cancel();
            }
            $scope.fileattributes = sharedCtrl.fileattributes;
            $scope.selectedFileName = sharedCtrl.selectedFileName;
            $scope.updateFileSharing = function() {
                $scope.fileSharingObject = {};
                $scope.fileSharingObjectId = sharedCtrl.selectedFile.id;
                $scope.fileSharingObject.attributes = $scope.fileattributes;
                $scope.fileSharingObject.users = $scope.allSharedUsers;
                RestAPIService.updateFileAttrAndSharing(siteId, $scope.fileSharingObjectId).then(
                    function(response) {
                        RestAPIService.successTostDialog("Fie shared successfully ");
                        sharedCtrl.getAttributes(sharedCtrl.receivedFile.id);
                        $mdDialog.hide();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    });
            }
        }
        sharedCtrl.currentFile = {};
        $scope.UpdateFile = function(ev) {
            sharedCtrl.currentFile = angular.copy(sharedCtrl.receivedFile);
            sharedCtrl.name = sharedCtrl.currentFile.name;
            sharedCtrl.id = sharedCtrl.currentFile.id;
            $mdDialog.show({
                controller: UpdateFileDialogController,
                templateUrl: 'app/main/sharedwithme/editFiledialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen,

            })


        };

        function UpdateFileDialogController($scope, $mdDialog) {
            var siteId = sharedCtrl.receivedFile.siteId;
            $scope.currentFile = sharedCtrl.currentFile;
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.updateFile = function(file) {
                RestAPIService.updateFile(siteId, file).then(
                    function(success) {
                        RestAPIService.successTostDialog("File renamed successfully ");
                        sharedCtrl.getSharedfiles();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide(file);
            };
        }

        sharedCtrl.deleteFile = function(ev, file) {
            var fileId = sharedCtrl.receivedFile.id;
            var siteId = sharedCtrl.receivedFile.siteId;
            var confirm = $mdDialog.confirm()
                .title('Remove')
                .textContent('File ' + sharedCtrl.receivedFile.name + ' will be permanently deleted. Continue ?')
                .targetEvent(ev)
                .ok('Ok')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                RestAPIService.deleteFile(siteId, fileId).then(
                    function(success) {
                        RestAPIService.successTostDialog("File deleted successfully");
                        $scope.file = {};
                        sharedCtrl.fileAttributes = {};
                        $scope.detailsVisibility = false;
                        sharedCtrl.getSharedfiles();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
            }, function() {
                $mdDialog.cancel();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.profile')
        .controller('ProfileController', ProfileController);
        

    /** @ngInject */
    function ProfileController($scope,$state, $location,$rootScope,$localStorage,RestAPIService,$mdDialog,$cookieStore)
    {
        var profileCtrl = this;
        var json = $cookieStore.get('logedInuserdetail');
        
        $scope.currentLogedInUser = json['currentLogedInUser'];
        $scope.loggedInUserName = json['loggedInUserName'];
        var LoggedInUserName = $scope.loggedInUserName;
        
       /* $scope.UserDetails = function() {
            RestAPIService.UserDetails($localStorage.currentUser.username).then(
                function(success) {
                    $rootScope.currentLogedInUser = success.data;
                    $rootScope.loggedInUserName = success.data.firstName + ' ' + success.data.lastName;
                    LoggedInUserName = $scope.loggedInUserName;
                    console.log($rootScope.currentLogedInUser);
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                });
        }*/
//        $scope.editprofile =function(ev,user){
//        	profileCtrl.currentUser = angular.copy(user);
//            $mdDialog.show({
//                controller: UpdateUserDialogController,
//                templateUrl: 'app/main/profile/edit.profile.dialog.html',
//                parent: angular.element(document.body),
//                targetEvent: ev,
//                clickOutsideToClose: true,
//                fullscreen: $scope.customFullscreen
//            })
//        }

//        function UpdateUserDialogController($scope, $mdDialog) {
//        	 $scope.currentUser = profileCtrl.currentUser;
//        	 $scope.roles = ["ROLE_USER", "ROLE_ADMIN"];
//        	 $scope.status = ["true", "false"];
//        	 $scope.currencyFormats = ["Dot(.)" , "Comma(,)"];
//             $scope.dateFormats = ["YYYY-MM-DD", "DD.MM.YYYY", "YYYYMMDD", "DD-MM-YYYY", "MM-DD-YYYY", "MM/DD/YYYY"];
//             $scope.currency= ["INR", "USD", "GBP", "EUR"];
//             $scope.languages= ["English", "German", "French", "Spanish", "Hindi"];
//             $scope.timeZones= ["BRT(Brasilia Time)", "CST(China Standard Time)", "ART(Argentina Time)", "BTT(Bhutan Time)", "CT(China Time)","IST(Indian Standard Time)"];
//        	 
//        	 $scope.updateUserProfile = function(user) {
//               RestAPIService.updateUserProfile(user).then(
//                   function(success) {
//                   	RestAPIService.successTostDialog("Profile updated successfully");
//                   
//                       $mdDialog.hide(user);
//                       $state.reload();
//                   },
//                   function(error) {
//                       RestAPIService.showErrorDialog(error);
//                   });
//           }
//          
//            $scope.hide = function() {
//                $mdDialog.hide();
//            };
//            $scope.cancel = function() {
//                $mdDialog.cancel();
//            };
//           
//        }
        
    	
        $scope.loadPage = "about";
        $scope.loadAbout = function() {        	
            $scope.loadPage = 'about';
        }
        $scope.loadSubstitution = function() {
            $scope.loadPage = 'substitution';

        }
       
        
    }


         
})();
(function ()
{
    'use strict';

    angular
        .module('app.reports', [] )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdThemingProvider)
    {
    	 $stateProvider
            
            .state('app.reports', {
                url: '/reports',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/reports/reports.html',
                        controller:  'ReportsController as reportCtrl'
                    }
                }
            });

      msNavigationServiceProvider.saveItem('reports', {
            title : 'Reports',
            icon  : 'icon-file-document',
            state : 'app.reports',
            weight: 5
        });

    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.reports')
        .controller('ReportsController', ReportsController);

    /** @ngInject */
    function ReportsController($state, $scope, RestAPIService, $filter, $mdDialog, $sce)
    {
        var reprtCtrl = this;
        $scope.viewPage = 0;
        $scope.doctypefields = [];
        $scope.filterarr = {};
        $scope.filterout = [];
        $scope.filterdlength = 0;
        $scope.currentReport = {};
        $scope.allDocuments = [];
        reprtCtrl.currentDocument = {};

        $scope.getAnotherColor = function(index) {
            $scope.colors = ['red', 'pink', 'purple', 'deep-purple', 'indigo', 'blue', 'light-blue', 'cyan', 'teal', 'green',
                'light-green', 'lime', 'yellow', 'amber', 'deep-orange', 'brown', 'grey', 'blue-grey'
            ];
            var totalNoOfColors = $scope.colors.length;
            return $scope.colors[index % totalNoOfColors];
        }

        $scope.dtOptions = {
            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
        }

        function resetFields() {
            $scope.querylogic = {};
            $scope.outerquery = {};
            $scope.innerquery = {};
            $scope.compdate = [];
            $scope.datearr = {};
            $scope.innerdate = {};
            $scope.datearr1 = {};
            $scope.innerdate1 = {};
            $scope.todate = [];
            $scope.fromdate = [];
        }

        $scope.getValues = function(data, output) {
            var result = null;
            angular.forEach(data, function(value, key) {
                if (output == key) {
                    result = value;
                }
            });
            return result;
        }
 
        $scope.UpdateMode = function(selecteditem, filterval) {
            $scope.comfilterdata = [];
            $scope.filterarr[selecteditem] = filterval;
            $scope.comfilterdata.push($scope.filterarr);
            $scope.filterdlength = Object.keys($scope.filterarr).length;
        }
        
        
        $scope.applyfilter = function() {
        	var tempData = angular.copy($scope.tempData);
            $scope.allDocuments = [];
            angular.forEach($scope.filterarr, function(value, key) {
                var filterExpression = {};
                filterExpression[key] = value;
                $scope.result = $filter('filter')(tempData, filterExpression);
            });
            $scope.allDocuments = $scope.result;
        }

        $scope.goBack = function(pageNo) {
            resetFields();
            $scope.viewPage = pageNo;
        }

        $scope.goToPreviousState = function() {
            $state.go("app.overview");
            $("#vertical-navigation").show();
            $("#content-container").css({
                "margin-left": "0px"
            });
        }

        $scope.viewSelection = function(type, data) {
            reprtCtrl.currentDocument = data;
            if (type == 'requestId') {
                $scope.viewPage = 4;
                RestAPIService.getInboxWorkitemInfo(reprtCtrl.currentDocument.requestType, reprtCtrl.currentDocument.requestId).then(function(responce) {
                    viewForm(responce.data);
                    $scope.requestDetails = responce.data;
                    console.log("responce : ", responce)

                }, function(error) {
                    RestAPIService.showErrorDialog(error);
                });


            } else if (type == 'id') {
                $scope.viewPage = 3;
                RestAPIService.getFileById(data.siteId, data.id).then(
                    function(success) {
                        $scope.fileDetails = success.data;
                        console.log("$scope.fileDetails : ", $scope.fileDetails)
                    },
                    function(error) {});

            }
        }

        function viewForm(data) {
            $scope.currentFormHeader = $sce.trustAsHtml(data.mainLayout.replace(/&quot;/g, '"'));
            $scope.currentFormLineitem = $sce.trustAsHtml(data.detailsLayout.replace(/&quot;/g, '"'));
        }

        $scope.getDummyFileIcon = function(index) {
            reprtCtrl.icons = ['icon-file-pdf-box'];
            var totalNoOfIcons = reprtCtrl.icons.length;
            return reprtCtrl.icons[index % totalNoOfIcons];
        }

        $scope.setAttachmentFile = function(element) {
            var formData = new FormData();
            $scope.$apply(function() {
                for (var i = 0; i < element.files.length; i++) {
                    formData.append('file', element.files[i]);
                    $scope.attachmentfiles.push(element.files[i]);
                }
            });
        };

        $scope.preview = function(ev, file, reqId) {
            reprtCtrl.file = file;
            reprtCtrl.reqId = reqId;
            $mdDialog.show({
                controller: PDialogController,
                templateUrl: 'app/main/mycontent/inbox/previewFiles.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        }

        function PDialogController($scope, $mdDialog, $sce, $sessionStorage) {
            $scope.fileVis = false;
            $scope.imgVis = false;
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            var jwtToken = $sessionStorage.currentUser.token.trim();
            if (jwtToken != undefined && reprtCtrl.reqId != undefined) {
                var encodedURI = encodeURIComponent(reprtCtrl.file.url);
                if (reprtCtrl.file.fileType == "jpg" || reprtCtrl.file.fileType == "JPG" || reprtCtrl.file.fileType == "jpeg" || reprtCtrl.file.fileType == "JPEG" || reprtCtrl.file.fileType == "PNG" || reprtCtrl.file.fileType == "png") {
                    $scope.imgVis = true;
                    $scope.fileURL = reprtCtrl.file.url;
                } else {
                    $scope.fileVis = true;
                    $scope.fileURL = $sce.trustAsResourceUrl('https://docs.google.com/gview?url=' + encodedURI + '&embedded=true');
                }
            }
        }

        $scope.previewFile = function(ev) {
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/sites/site/doclibrary/previewFiles.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        }

        function DialogController($scope, $mdDialog, $sce, $sessionStorage) {
            var jwtToken = $sessionStorage.currentUser.token.trim();
            if (jwtToken != undefined && reprtCtrl.currentDocument != undefined) {
                var encodedURI = encodeURIComponent(baseUrl + '/api/sites/' + reprtCtrl.currentDocument.siteId + '/files/file?fileId=' + reprtCtrl.currentDocument.id + '&attachment=false&jwtToken=' + jwtToken);
                $scope.fileURL = $sce.trustAsResourceUrl('https://docs.google.com/gview?url=' + encodedURI + '&embedded=true');
            }
        }

        $scope.executecriteria = function(doctypedata, collectionname) {
            $scope.viewPage = 2;
            for (var i = 0; i <= $scope.currentReport.doctypefield.length - 1; i++) {
                if ($scope.currentReport.doctypefield[i].type == "String") {
                    if ($scope.currentReport.doctypefield[i].data != null && $scope.currentReport.doctypefield[i].data != undefined) {
                        var keydata = $scope.currentReport.doctypefield[i].fieldname;
                        var value = $scope.currentReport.doctypefield[i].data.value;
                        $scope.innerquery[keydata] = value;
                    }
                }
                if ($scope.currentReport.doctypefield[i].type == "Date") {
                    if ($scope.currentReport.doctypefield[i].data != null && $scope.currentReport.doctypefield[i].data != undefined) {
                        var keydata = $scope.currentReport.doctypefield[i].fieldname;
                        if ($scope.currentReport.doctypefield[i].data.fromdate != null) {
                            var d = new Date($scope.currentReport.doctypefield[i].data.fromdate);
                            var n = $filter('date')(new Date($scope.currentReport.doctypefield[i].data.fromdate), 'yyyy-MM-ddTHH:mm:ss');

                            $scope.innerdate = {
                                "$date": n + "Z"
                            };
                            $scope.datearr = {
                                "$gt": $scope.innerdate
                            }
                            // $scope.fromdate = {
                            //     [keydata]: $scope.datearr
                            // };
                        }
                        if ($scope.currentReport.doctypefield[i].data.todate != null) {
                            var d = new Date($scope.currentReport.doctypefield[i].data.todate);
                            var n = $filter('date')(new Date($scope.currentReport.doctypefield[i].data.todate), 'yyyy-MM-ddTHH:mm:ss');
                            $scope.innerdate1 = {
                                "$date": n + "Z"
                            }
                            $scope.datearr1 = {
                                "$lt": $scope.innerdate1
                            }
                            // $scope.todate = {
                            //     [keydata]: $scope.datearr1
                            // };
                        }
                        $scope.compdate.push($scope.fromdate);
                        $scope.compdate.push($scope.todate);
                        if ($scope.innerquery.length > 0) {
                            $scope.innerquery["$and"] = $scope.compdate;
                        } else {
                            $scope.innerquery = $scope.compdate;
                        }

                    }
                }
            }

            if (undefined != $scope.currentReport.selectionfield) {
                for (var i = 0; i <= $scope.currentReport.selectionfield.length - 1; i++) {
                    if ($scope.currentReport.selectionfield[i].type == "string") {
                        if ($scope.currentReport.selectionfield[i].data != null && $scope.currentReport.selectionfield[i].data != undefined) {
                            var keydata = $scope.currentReport.selectionfield[i].fieldname;
                            var value = $scope.currentReport.selectionfield[i].data.value;
                            $scope.querylogic[keydata] = value;
                        }
                    }
                    if ($scope.currentReport.selectionfield[i].type == "Date") {
                        if ($scope.currentReport.selectionfield[i].data != null && $scope.currentReport.selectionfield[i].data != undefined) {
                            var keydata = $scope.currentReport.selectionfield[i].fieldname;
                            if ($scope.currentReport.selectionfield[i].data.fromdate != null) {
                                var d = new Date($scope.currentReport.selectionfield[i].data.fromdate);
                                var n = $filter('date')(new Date($scope.currentReport.selectionfield[i].data.fromdate), 'yyyy-MM-ddTHH:mm:ss');

                                $scope.innerdate = {
                                    "$date": n + "Z"
                                };
                                $scope.datearr = {
                                    "$gt": $scope.innerdate
                                }
                                // $scope.fromdate = {
                                //     [keydata]: $scope.datearr
                                // };
                            }
                            if ($scope.currentReport.selectionfield[i].data.todate != null) {
                                var d = new Date($scope.currentReport.selectionfield[i].data.todate);
                                var n = $filter('date')(new Date($scope.currentReport.selectionfield[i].data.todate), 'yyyy-MM-ddTHH:mm:ss');
                                $scope.innerdate1 = {
                                    "$date": n + "Z"
                                }
                                $scope.datearr1 = {
                                    "$lt": $scope.innerdate1
                                }
                                // $scope.todate = {
                                //     [keydata]: $scope.datearr1
                                // };
                            }
                            $scope.compdate.push(fromdate);
                            $scope.compdate.push(todate);
                            $scope.querylogic["$and"] = compdate;
                        }
                    }
                }
            }
            if (Object.keys($scope.innerquery).length > 0 && $scope.innerquery != null && $scope.innerquery != undefined) {
                $scope.querylogic["attributes"] = $scope.innerquery;
            }
            resetFields();
            $scope.allDocuments = [];
            var myJSON = JSON.stringify($scope.querylogic);
            if (collectionname == 'documents') {
                RestAPIService.getdocumentbyquery(myJSON).then(function(response) {
                    $scope.allDocuments = response.data;
                    $scope.tempData = response.data;
                    $scope.allFilteredData = {};
                    angular.forEach($scope.currentReport.filterfield, function(value, key) {
                        var datafilter = [];
                        var j = 0;
                        for (var i = 0; i <= $scope.allDocuments.length - 1; i++) {
                            if ($.inArray(($scope.allDocuments[i][value.fieldname]), datafilter) === -1) {
                                if ($scope.allDocuments[i][value.fieldname] != null && $scope.allDocuments[i][value.fieldname] != undefined) {
                                    datafilter[j] = $scope.allDocuments[i][value.fieldname];
                                    j = j + 1;
                                    $scope.allFilteredData[value.fieldname] = datafilter;
                                }
                            }
                        }
                        $scope.allFilteredDataLength = Object.keys($scope.allFilteredData).length;
                    });
                }, function(error) {
                    RestAPIService.showErrorDialog(error);
                });
            } else if (collectionname == 'request') {
                RestAPIService.getrequestbyquery(myJSON).then(function(response) {
                    $scope.allDocuments = response.data;
                }, function(error) {
                    RestAPIService.showErrorDialog(error);
                });
            }
        }

        $scope.goToReport = function(report) {
            $scope.viewPage = 1;
            $scope.currentReport = report;
        }

        $scope.getReportData = function() {
            RestAPIService.getreportdata().then(function(response) {
                    $scope.allReports = [];
                    $scope.allReports = response.data;
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                });
        }

        // 
        /*init();

        function init() {
            resetFields();
            $scope.getReportData();
        }
*/

    
    }


         
})();
(function ()
{
    'use strict';

    angular
        .module('finishReset',[])
        .config(config);

    /** @ngInject */
    function config(){}
    
})();
(function() {
    'use strict';


    angular
        .module('finishReset')
        .controller('FinishResetController', FinishResetController);
        function FinishResetController($scope) {
            var rp = this;
           
            rp.resetPasswordfinish = function(key,password) {
                RestAPIService.resetPasswordfinish(key,password).then(
                    function(success) {
                      $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide(user);
           
        }
           

        }


})();
(function ()
{
    'use strict';

    angular
        .module('app.migrations')
        .controller('MigrationController', MigrationController);

    /** @ngInject */
    function MigrationController($state, $scope, RestAPIService, $filter, $mdDialog, $sce)
    {
        var migratCtrl = this;
        migratCtrl.goTomigrateConfiguration = function(){
            $state.go('app.migrations-Configuration');
           }
       
       migratCtrl.gotoBatchRecords = function(){
           $state.go('app.migrations-BatchRecords');
          }
       migratCtrl.goToDocumentationMigration = function(){
           $state.go('app.migrations-Documentation');
          }


      


    
    }


         
})();
(function ()
{
    'use strict';

    angular
        .module('login',[])
        .config(config);

    /** @ngInject */
    function config(){}
    
})();
 (function() {
    'use strict';


    angular
        .module('login')
        .controller('LoginController', LoginController);
        function LoginController($scope, $http, $location, $state, AuthenticationService,RestAPIService,$cookieStore,$localStorage,$sessionStorage,$cookies) {
            var vm = this;
            vm.login=login;
            $scope.visibility = true;
            $scope.forgotPassword = function(){
               $scope.forgotPasswordPage = true; 
            }

            $scope.goToLoginPage = function(){
                $scope.forgotPasswordPage = false;
            }
            

            function login(userData){
                var id=userData.userid;
                var pwd=userData.password;
               // alert("User ID :"+id +" \n Password :"+pwd);
                $scope.user = {};            
                vm.loginForm.$setPristine();
                vm.loginForm.$setUntouched();
                 delete $sessionStorage.currentUser;
                delete $localStorage.currentUser;   
                $cookies.remove('logedInuserdetail'); 
                AuthenticationService.Login(id, pwd, function (result) {
                    if (result.success === true) {
                        RestAPIService.UserDetails().then(
                            function(success) {
                  /*              $rootScope.currentLogedInUser = success.data;
                                $rootScope.loggedInUserName = success.data.firstName + ' ' + success.data.lastName;
                                LoggedInUserName.value = vm.loggedInUserName;*/
                                 var json = {
                                          "currentLogedInUser" : success.data,
                                          "loggedInUserName" : success.data.firstName + ' ' + success.data.lastName
                                      }
                                  $cookieStore.put('logedInuserdetail', json)
                            },
                            function(error) {
                                RestAPIService.showErrorDialog(error);
                            });
                        
                        $location.path('/overview');
                    } else {
                        $scope.ErrorMsg = {message: result.message, type: 'error'};
                    }
                });
            }
            init();
            function init(){
          	  RestAPIService.getbrandsetting().then(
                      function(success) {
                    	  if(success.data.length>0){
                    		  window.localStorage['branddata'] = angular.toJson(success.data[0]);
                              	if((success.data[0].loginbackgroundcolor || success.data[0].loginlogo) !=null){
                              		if(success.data[0].loginbackgroundimage !=null && success.data[0].loginbackgroundimage !=""){
                              		
                              			$("#login").css('background-image', 'url('+success.data[0].loginbackgroundimage+')');
                              		}else{
                              			$("#login").css('background-color',success.data[0].loginbackgroundcolor);
                              		}
                              		$('#logoimage').attr('src', success.data[0].loginlogo);
                              	}else{
                              		$("#login").css('background-color',"#62a8e0");
                              		$('#logoimage').attr('src', "../assets/images/logos/Logo2.jpg");
                              	}
                    	  }else{
                    		  window.localStorage['branddata'] = null;
                    		    $("#login").css('background-color',"#62a8e0");
                        		$('#logoimage').attr('src', "../assets/images/logos/Logo2.jpg");
                    	  }
                      },
                      function(error) {
                          RestAPIService.showErrorDialog(error);
                      }
                  );
            }
            $scope.resetPassword = function(email) {
                RestAPIService.resetPassword(email).then(
                    function(success) {
                  	  //RestAPIService.successTostDialog("Reset link sent to emailId successfully");
                   	 alert("Reset link sent to emailId successfully");  
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
            
           
        }



        }


})();
(function ()
{
    'use strict';

    angular
        .module('app.requests', [] )
        .config(config)
        .directive('compileTemplate', function($compile, $parse){
            return {
                link: function(scope, element, attr){
                    var parsed = $parse(attr.ngBindHtml);
                    function getStringValue() {
                        return (parsed(scope) || '').toString();
                    }

                    // Recompile if the template changes
                    scope.$watch(getStringValue, function() {
                        $compile(element, null, -9999)(scope);  // The -9999 makes it skip directives so that we do not recompile ourselves
                    });
                }
            }
        });

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdThemingProvider)
    {
    	 $stateProvider

            .state('app.requests', {
                url: '/requests',
                views: {
                    'content@app': {                        
                        templateUrl: 'app/main/Requests/requestsOverviewPage.html',
                        controller:  'RequestsController as requestCtrl'
                    }
                }
            }) 

            .state('app.requests.content', {
                url: '/requests/content',
                params: {'currentForm': null},
                views: {
                    'content@app': {                        
                        templateUrl: 'app/main/Requests/requests.content.html',
                        controller:  'RequestsController as requestCtrl'
                    }
                }
            }) ;

            // .state('app.customerMasterCreationForm', {
            //     url: '/customerMasterCreationForm',
            //     views: {
            //         'content@app': {                        
            //             templateUrl: 'app/main/Requests/customerMasterCreationForm.html',
            //             controller:  'RequestsController as requestCtrl'
            //         }
            //     }
            // })           
            
            // .state('app.customerPriceMasterForm', {
            //     url: '/customerPriceMasterForm',
            //     views: {
            //         'content@app': {                        
            //             templateUrl: 'app/main/Requests/customerPriceMasterForm.html',
            //             controller:  'RequestsController as requestCtrl'
            //         }
            //     }
            // })
            // .state('app.vendorMasterCreationForm', {
            //     url: '/vendorMasterCreationForm',
            //     views: {
            //         'content@app': {                        
            //             templateUrl: 'app/main/Requests/vendorMasterCreationForm.html',
            //             controller:  'RequestsController as requestCtrl'
            //         }
            //     }
            // })
            
            // .state('app.vendorPriceMasterForm', {
            //     url: '/vendorPriceMasterForm',
            //     views: {
            //         'content@app': {                        
            //             templateUrl: 'app/main/Requests/vendorPriceMasterForm.html',
            //             controller:  'RequestsController as requestCtrl'
            //         }
            //     }
               
            // });

        /*msNavigationServiceProvider.saveItem('requests', {
            title : 'Requests',
            icon  : 'icon-read',
            state : 'app.requests',
            weight: 3
        });*/
        

    }
})();


(function() {
    'use strict';

    angular
        .module('app.requests')
        .controller('RequestsController', RequestsController);

    /** @ngInject */
    function RequestsController($state, $stateParams,$scope, $mdDialog, RestAPIService, $sce) {
        var requestCtrl = this;
        //$scope.forms = ["CutomerForm", "Price Form", "Vendor Form", "VendorPrice Form"];
        //$scope.AccountGroups = ["DOMC-Domestic Customer", "FRNC-Export Customer"];
        //$scope.salesOrganisations = ["205001-Debtors-Demostic", "255010-Debtors-Export"];
        //$scope.types = ["New Creation", "Mark for Deletion"];
        //$scope.distributionChannels = ["TWO WHEELER", "TRACTOR"];
        //$scope.conditionTypes = ["STANDARD", "SCRAP"];
        $scope.priceVars = ["INC", "DEC"];
        $scope.rows = ["1", "2", "3"];
        $scope.customerGroups = ["MISC", "AMREP"];
        $scope.CMCFDidtributionChannels = ["DI-DIRECT", "DM-DEEMED"];
        $scope.paymentTerms = ["PT01 NET DUE AFTER 30 DAYS", "PT02 NET DUE AFTER 45 DAYS"];
        $scope.salesAreas = ["South", "East"];
        $scope.salesOffices = ["KARNATAKA", "DELHI"];
        $scope.taxes = ["CST with C from 2%", "SERVICE TAX APPLICABLE / NOT APPLICABLE"];

        requestCtrl.goToRequests = function() {
            $state.go('app.requests');
        }

        $scope.selectForm = function(form) {
            // if (formName == "CutomerForm") {
            //     //$state.go('app.customerMasterCreationForm');
            //     $state.go('app.requests.content');
            // } else if (formName == "Price Form") {
            //     $state.go('app.customerPriceMasterForm');
            // } else if (formName == "Vendor Form") {
            //     $state.go('app.vendorMasterCreationForm');
            // } else if (formName == "VendorPrice Form") {
            //     $state.go('app.vendorPriceMasterForm');
            // }
            //alert((JSON.stringify(form.content)));
            var headerContent = form.content;
            var headerContentWithQuotes = headerContent.replace(/&quot;/g,'"');
            form.content = headerContentWithQuotes;

            var lineitemContent = form.lineItemContent;
            var lineitemContentWithQuotes = lineitemContent.replace(/&quot;/g,'"');
            form.lineItemContent = lineitemContentWithQuotes;

            //alert(lineitemContentWithQuotes);
            $scope.headerForm= {};
            $state.go('app.requests.content',{'currentForm':form});
        }
        if($stateParams.currentForm){
            $scope.currentFormName = $stateParams.currentForm.name;
            $scope.currentFormHeader = $sce.trustAsHtml($stateParams.currentForm.content);
            $scope.currentFormLineitem = $sce.trustAsHtml($stateParams.currentForm.lineItemContent);
            //$scope.currentFormHeader = $sce.trustAsHtml('<div layout="row" > <div flex="20" layout="row" layout-align="end center"> <h3>Customer Code</h3> </div><span flex="5"></span> <md-input-container class="md-block" flex="20" > <input type="text" name="owner" ng-model="form.customerCode"> </md-input-container> <span flex="5"></span> <div flex="20" layout="row" layout-align="end center"> <h3>Account Group</h3> </div><span flex="5"></span> <md-input-container class="md-block" flex="20"> <md-select ng-model="form.accountGroup"> <md-option value="DOMC-Domestic Customer">DOMC-Domestic Customer</md-option> <md-option value="FRNC-Export Customer">FRNC-Export Customer</md-option> </md-select> </md-input-container> </div><div layout="row"> <div flex="20" layout="row" layout-align="end center"> <h3>Customer Name</h3> </div><span flex="5"></span> <md-input-container class="md-block" flex="70" > <input type="text" name="owner" ng-model="form.customerName"> </md-input-container> </div><div layout="row"> <div flex="20" layout="row" layout-align="end center"> <h3>Sales Organisation</h3> </div><span flex="5"></span> <md-input-container class="md-block" flex="20" > <md-select ng-model="form.organisation"> <md-option value="205001-Debtors-Demostic">205001-Debtors-Demostic</md-option> <md-option value="255010-Debtors-Export">255010-Debtors-Export</md-option> </md-select> </md-input-container> <span flex="5"></span> <div flex="20" layout="row" layout-align="end center"> <h3>Type</h3> </div><span flex="5"></span> <md-input-container class="md-block" flex="20" > <md-select ng-model="form.type"> <md-option value="New Creation">New Creation</md-option> <md-option value="Mark for Deletion">Mark for Deletion</md-option> </md-select> </md-input-container> </div><div layout="row"> <div flex="20" layout="row" layout-align="end center"> <h3>Distribution Channel</h3> </div><span flex="5"></span> <md-input-container class="md-block" flex="20" > <md-select ng-model="form.channel"> <md-option value="TWO WHEELER">TWO WHEELER</md-option> <md-option value="TRACTOR">TRACTOR</md-option> </md-select> </md-input-container> <span flex="5"></span> <div flex="20" layout="row" layout-align="end center"> <h3>Conditions Type:</h3> </div><span flex="5"></span> <md-input-container class="md-block" flex="20" > <md-select ng-model="form.conditionType"> <md-option value="STANDARD">TWO WHEELER</md-option> <md-option value="SCRAP">TRACTOR</md-option> </md-select> </md-input-container> </div>');
            console.log($stateParams.currentForm.content);
        }    

        $scope.getAnotherColor = function(index) {

            $scope.colors = ['green-bg white-fg', 'orange-bg white-fg', 'pink-bg white-fg', 'blue-grey-bg white-fg', 'back-bg white-fg'];
            var totalNoOfColors = $scope.colors.length;
            return $scope.colors[index % totalNoOfColors];
        }
        $scope.getAnotherIcon = function(index) {

            $scope.icons = ['icon-account', 'icon-cash-100', 'icon-account-switch', 'icon-file-document', 'icon-cash-usd', 'icon-chart-bar'];
            var totalNoOfIcons = $scope.icons.length;
            return $scope.icons[index % totalNoOfIcons];
        }
        $scope.setAttachmentFile = function(element) {
            var formData = new FormData();
            $scope.$apply(function() {
                $scope.attachmentfiles = [];
                for (var i = 0; i < element.files.length; i++) {
                    formData.append('file', element.files[i]);
                    $scope.attachmentfiles.push(element.files[i]);
                }
            });
        };

        requestCtrl.getRequestForms = function() {
            RestAPIService.getRequestForms().then(
                function(success) {
                    $scope.forms = success.data;
                    //alert(JSON.stringify(requestsCtrl.RequestData));

                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                });
        };

        $scope.createRequest = function(ev) {
            $mdDialog.show({
                controller: CreateRequestDialogController,
                templateUrl: 'app/main/Requests/requestUploadForm.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        };

        function CreateRequestDialogController($scope, $http, RestAPIService, $mdDialog, $state, $window) {
            var formData = new FormData();
            $scope.setHeaderFile = function(element) {
                $scope.$apply(function() {
                    $scope.headerfiles = [];
                    for (var i = 0; i < element.files.length; i++) {
                        formData.append('file', element.files[i]);
                        $scope.headerfiles.push(element.files[i]);
                    }
                });
            };
            $scope.setLineItemFile = function(element) {
                $scope.$apply(function() {
                    $scope.lineitemfiles = [];
                    for (var i = 0; i < element.files.length; i++) {
                        formData.append('file', element.files[i]);
                        $scope.lineitemfiles.push(element.files[i]);
                    }
                });
            };

            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.uploadRequestForm = function(request) {
                RestAPIService.uploadRequestForm($scope.headerfiles[0], $scope.lineitemfiles[0], request.name, request.description).then(
                    function(success) {
                        requestCtrl.getRequestForms();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.cancel();
            }

        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: 'assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: 'assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: 'assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: 'assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: 'assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: 'assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate)
    {
        return {
            restrict: 'E',
            compile : function (element, attr)
            {
                var code;
                //No attribute? code is the content
                if ( !attr.code )
                {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr)
                {

                    if ( attr.code )
                    {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code)
                    {
                        if ( code )
                        {
                            if ( shouldInterpolate )
                            {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function ()
                            {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent)
                    {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line)
                        {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line)
                        {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function() {
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController)
        .value("LoggedInUserName", { value: "" });

    /** @ngInject */
    function ToolbarController($scope, $rootScope, $q, $state, $timeout, $interval, $mdSidenav, $translate, $mdToast, $mdDialog, msNavigationService, AuthenticationService, RestAPIService, LoggedInUserId, LoggedInUserName, $localStorage, $cookieStore) {
        var vm = this;
       var interval = null;
        var json = $cookieStore.get('logedInuserdetail');
        if(json !=undefined){
        	   if(json['loggedInUserName'] !=undefined && json['currentLogedInUser'] !=undefined){
              	 $scope.loggedInUserName = json['loggedInUserName'];
                   $rootScope.currentLogedInUser  =json['currentLogedInUser'];
              }
        }else{
        	 var interval = $interval(function() {
        		 	var json = $cookieStore.get('logedInuserdetail');
              	  if(json !=undefined){
                 	   if(json['loggedInUserName'] !=undefined && json['currentLogedInUser'] !=undefined){
                       	 $scope.loggedInUserName = json['loggedInUserName'];
                            $rootScope.currentLogedInUser  =json['currentLogedInUser'];
                       }
                  $interval.cancel(interval);
              }
        	    }, 3000);
        }
        
       
        /*var json = $cookieStore.get('logedInuserdetail');
              	 $scope.loggedInUserName = json['loggedInUserName'];
                   $rootScope.currentLogedInUser  =json['currentLogedInUser'];*/

       
        // Data
        $rootScope.global = {
            search: ''
        };

        vm.goToFavorites = function() {
            $state.go('app.favorites');
        }
        
        vm.goToShared = function() {
            $state.go('app.shared');
        }

        vm.bodyEl = angular.element('body');
        vm.userStatusOptions = [{
                'title': 'Online',
                'icon': 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon': 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon': 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon': 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon': 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];
        vm.languages = {
            en: {
                'title': 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code': 'en',
                'flag': 'us'
            },
            es: {
                'title': 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code': 'es',
                'flag': 'es'
            },
            tr: {
                'title': 'Turkish',
                'translation': 'TOOLBAR.TURKISH',
                'code': 'tr',
                'flag': 'tr'
            }
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;
        //////////

        init();

        /**
         * Initialize
         */
        function init() {

            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status) {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout() {
            // Do logout here..
            AuthenticationService.Logout();
            $state.go('login');
        }

        /**
         * Change Language
         */
        function changeLanguage(lang) {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             * 
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            if (lang.code !== 'en') {
                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position: 'top right',
                    parent: '#content'
                });

                return;
            }

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu() {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded() {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query) {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for (var x = 0; x < flatNavigation.length; x++) {
                if (flatNavigation[x].uisref) {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if (query) {
                navigation = navigation.filter(function(item) {
                    if (angular.lowercase(item.title).search(angular.lowercase(query)) > -1) {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function() {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item) {
            // If item has a link
            if (item.uisref) {
                // If there are state params,
                // use them...
                if (item.stateParams) {
                    $state.go(item.state, item.stateParams);
                } else {
                    $state.go(item.state);
                }
            }
        }

 /*       vm.UserDetails = function() {
            RestAPIService.UserDetails().then(
                function(success) {
                    $rootScope.currentLogedInUser = success.data;
                    $rootScope.loggedInUserName = success.data.firstName + ' ' + success.data.lastName;
                    LoggedInUserName.value = vm.loggedInUserName;
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                });
        }*/
        
        vm.editMyProfile =function(){
        	$state.go('app.profile');
        }

//        vm.editMyProfile = editMyProfile;
//
//        function editMyProfile() {
//       $state.go('app.profiles');
//         $mdDialog.show({
//               controller: MyProfileDialogController,
//               templateUrl: 'app/main/user-management/myProfileUpdateToolbarCustomDialog.html',
//               parent: angular.element(document.body),
//               targetEvent: ev,
//                clickOutsideToClose: true,
//                fullscreen: $scope.customFullscreen
//            })
//       }

//        function MyProfileDialogController($scope, $mdDialog) {
//        	$scope.User = $rootScope.currentLogedInUser;
//            $scope.loggedInUser = LoggedInUserName.value;
//            $scope.status = ["true", "false"];
//            $scope.roles = ["ROLE_USER", "ROLE_ADMIN"];
//            $scope.currencyFormats = ["Dot(.)", "Comma(,)"];
//            $scope.dateFormats = ["YYYY-MM-DD", "DD.MM.YYYY", "YYYYMMDD", "DD-MM-YYYY", "MM-DD-YYYY", "MM/DD/YYYY"];
//            $scope.currency = ["INR", "USD", "GBP", "EUR"];
//            $scope.languages = ["English", "German", "French", "Spanish", "Hindi"];
//            $scope.timeZones = ["BRT(Brasilia Time)", "CST(China Standard Time)", "ART(Argentina Time)", "BTT(Bhutan Time)", "CT(China Time)", "IST(Indian Standard Time)"];
//
//            $scope.updateUserProfile = function(user) {
//                RestAPIService.updateUserProfile(user).then(
//                    function(success) {
//                    	RestAPIService.successTostDialog("Profile updated successfully");
//                        $mdDialog.hide(user);
//                    },
//                    function(error) {
//                        RestAPIService.showErrorDialog(error);
//                    });
//            }
//
//            $scope.cancel = function() {
//                $mdDialog.cancel();
//            }
//        }

        vm.changePassword = changePassword;

        function changePassword(ev) {
            $mdDialog.show({
                controller: ChangePasswordController,
                templateUrl: 'app/main/finishReset/finishReset.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        }

        function ChangePasswordController($scope) {
            $scope.cancel = function() {
                $mdDialog.cancel();
            }
            $scope.save = function(password) {
              	RestAPIService.ResetPassword(password).then(
              			function(success){
              			   	 RestAPIService.successTostDialog("Password Changed successfully ");              		
              				$mdDialog.hide(password);
              			},
              			 function(error) {
                        RestAPIService.showErrorDialog(error);
                        });
            	
                
            }
        }

        $scope.toolbarSearchPopup = function(ev) {
            // alert("hii");
            $mdDialog.show({
                controller: PopupController,
                templateUrl: 'app/main/toolbarsearch/toolbarSearchPopup.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })

        }
        $scope.times = ["Today", "Last Week", "This Month"];
        $scope.doctypes = ["PO", "NPO", "CHQ_REQ"];
        $scope.sites = ["HR", "Finance", "IT"];
        $scope.fileTypes = ["docx", "pdf", "txt"];
        $scope.resultFiles = {};
        $scope.resultFiles = {
            "content": [{
                    "name": "Invoice.pdf",
                    "type": "pdf",
                    "owner": "admin",
                    "size": "55kb",
                    "createdOn": "15 Apr 2010"
                },
                {
                    "name": "Purchase Order.pdf",
                    "type": "pdf",
                    "owner": "admin",
                    "size": "55kb",
                    "createdOn": "15 Apr 2010"
                },
                {
                    "name": "Non Purchase Order.pdf",
                    "type": "pdf",
                    "owner": "admin",
                    "size": "55kb",
                    "createdOn": "15 Apr 2010"
                },
                {
                    "name": "All Doctypes List.pdf",
                    "type": "pdf",
                    "owner": "admin",
                    "size": "55kb",
                    "createdOn": "15 Apr 2010"
                }

            ],
            "facetResultPages": [{
                    "content": [{
                            "valueCount": 1,
                            "value": "site-0",
                            "field": {
                                "name": "site_id"
                            },
                            "key": {
                                "name": "site_id"
                            }
                        },
                        {
                            "valueCount": 1,
                            "value": "site-1",
                            "field": {
                                "name": "site_id"
                            },
                            "key": {
                                "name": "site_id"
                            }
                        }
                    ]
                },
                {
                    "content": [{
                        "valueCount": 101,
                        "value": "pdf",
                        "field": {
                            "name": "fileExtension"
                        },
                        "key": {
                            "name": "fileExtension"
                        }
                    }]
                },
                {
                    "content": [{
                        "valueCount": 101,
                        "value": "LFA1",
                        "field": {
                            "name": "businessObjectName"
                        },
                        "key": {
                            "name": "businessObjectName"
                        }
                    }]
                }
            ],
            "facetFields": [{
                    "name": "site_id"
                },
                {
                    "name": "fileExtension"
                },
                {
                    "name": "businessObjectName"
                }
            ],
            "totalPages": 6,
            "totalElements": 101,
            "size": 20,
            "number": 0,
            "first": true,
            "sort": null,
            "last": false,
            "numberOfElements": 20
        };

        $scope.filesLength = $scope.resultFiles.content.length;


        // This popup is for when you click search icon in toolbar page for files search.
        function PopupController($scope, RestAPIService) {
            $scope.noOfAttributesToDisplay = 5;
            $scope.locations = ["Anywhere", "Current Location", "My Sites"];

            $scope.getAllBusinessObjects = function() {
                RestAPIService.getAllBusinessObjects().then(
                    function(responce) {
                        $scope.allBusinessObjects = responce.data;
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    })
            }
            $scope.cancel = function() {
                $mdDialog.cancel();
            }
            $scope.reset = function(fileData) {
                $scope.file = {};
                $scope.attributeObjects = {};
            }
            $scope.selectBusinessObject = function(businessObject) {

                // Calling Rest API Service to get Attributes of this Business Object
                RestAPIService.findBusinessObjectAttributes(businessObject.id).then(function(responce) {
                        $scope.attributeObjects = responce.data.attributes;
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    })
                // If any Attribute is having listReferrence as COMMA separated values, Split them.         
                if ($scope.attributeObjects != null && $scope.attributeObjects != undefined) {
                    $scope.attributeObjects.forEach(function(attribute) {
                        if (attribute.listReference != null && attribute.listReference != undefined) {
                            attribute['listValues'] = attribute.listReference.split(',');
                        }
                    });
                }
            }

            $scope.moreObjects = function() {
                $scope.noOfAttributesToDisplay += 5;
            }
            $scope.searchResult = [];

            $scope.searchFiles = function(fileData) {
                alert(JSON.stringify(fileData));
                // Calling Rest API Service to get Result Files
                RestAPIService.searchFiles(fileData).then(function(responce) {
                        $scope.resultFiles = responce.data;
                        alert(JSON.stringify($scope.resultFiles));
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    })
                // Send to the result files state.
                $state.go('app.resultFiles');
                $mdDialog.cancel();

            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.overview')
        .controller('OverviewController', OverviewController)
        .value("CurrentSiteName", {value: ""})
        .value("CurrentSiteLogo", {value: ""})
        .value("CurrentSiteId", {value: ""})
        .value("CurrentSiteUrl", {value: ""})
        .value("CurrentSitePage", {value: "dashboard"});

    /** @ngInject */
    function OverviewController($state,$scope,$location, $mdDialog,$document,CurrentSiteName,CommonUtil, CurrentSiteId, CurrentSiteUrl, CurrentSitePage, RestAPIService, Icons,LoggedInUserName,LoggedInUserId,$localStorage)
    {
        var overCtrl = this;
        
       /* if($localStorage.sitesettingdata !=null && $localStorage.sitesettingdata !=undefined){
          $scope.sitedisplayname = $localStorage.sitesettingdata.sitedisplayname;
        }else{
          RestAPIService.getSystemDetails().then(
                    function(response){                    
                     if(response.data.length>0){
                      var systemDetails = response.data[0];
                       if(systemDetails !=null && systemDetails !=undefined){
                        $localStorage.sitesettingdata = systemDetails.site;
                        $localStorage.menubarsetting = systemDetails.activeMenu;
                        $scope.sitedisplayname = systemDetails.site.sitedisplayname;
                       }
                     }else{
                          $rootScope.menubardata = null;
                        $localStorage.menubarsetting = null;
                        $localStorage.sitesettingdata = null;
                       }
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
        }
        */
        $scope.loggedInUserName = function(){
          RestAPIService.UserDetails(LoggedInUserId.value).then(
              function(success) {
                overCtrl.User = success.data;
                overCtrl.loggedInUserName = overCtrl.User.firstName + ' '+ overCtrl.User.lastName;
                $scope.loggedInUserName = overCtrl.loggedInUserName;
              },
              function(error) {
                  RestAPIService.showErrorDialog(error);
              });
          // alert(LoggedInUserName.value);
            
        }
        overCtrl.goToSites = function(){
            $state.go('app.sites');
        }
         
        overCtrl.goToCreateform = function(){
            $state.go('app.createform.custom');
        }
        $scope.getDummyFileIcon =  function(index){
            overCtrl.icons = ['icon-file-pdf-box','icon-file-word','icon-file-image','icon-clipboard-text','icon-file-image'];
            var totalNoOfIcons = overCtrl.icons.length;                        
            return overCtrl.icons[index%totalNoOfIcons];
        }
         $scope.getSiteIcon =  function(index){
            overCtrl.icons = ['icon-format-italic','icon-bank','icon-cog','icon-people','icon-account'];
            var totalNoOfIcons = overCtrl.icons.length;                        
            return overCtrl.icons[index%totalNoOfIcons];
        }
         overCtrl.fileIcon = function(file){
             return CommonUtil.getIconForFile(file);
         }
         //$scope.homepageList = Homepage.data;
         /*overCtrl.getHomePage = function() {
             RestAPIService.getHomePage().then(
                 function(success) {                     
                     $scope.homepageList = success.data;
                    
                 },
                 function(error) {
                     RestAPIService.showErrorDialog(error);
                 }
             );
             
         }*/
}
})();
(function ()
{
    'use strict';

    angular
        .module('app.overview')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope)
    {
        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = true;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
           // vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, $translateProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);
        
        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('smartportal', [

            // Core
            'app.core',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Quick panel
            'app.quick-panel',

            // Overview
            'app.overview',   
            
            // Create Form
	        //'app.create'
            'app.settings',
            'app.requests',
            
           'app.mycontent',
            'app.reports',
          //  'app.bussiness',
            'app.toolbarsearch',
            'app.sharedwithme',
            'app.administration',
           // 'app.stepFlow',
           // 'app.patner-admin',
           // 'app.bussiness-admin',
            'app.smartstore-admin',
            'app.reset',
            'app.migrations'

           // 'app.define'
        ]);
})();

(function ()
{
    'use strict';

    angular
        .module('smartportal')
        .factory('RestAPIService', RestAPIService);

    /** @ngInject */
    function RestAPIService($q, $log, $http, $mdDialog,$mdToast, $sessionStorage, LoggedInUserToken, CurrentSiteId)
    {

        var service = {};
       // service.baseUrl = 'http://182.156.74.203:8080/api';
         // service.baseUrl = 'http://35.188.232.28:8080/api';
         service.baseUrl = baseUrl +'/api'
        // service.token = LoggedInUserToken.value.trim();  //Get the token from AuthenticationService
        // if(!service.token){
        //   service.token = $sessionStorage.currentUser.token.trim();  //Fallback method - if token not found check session storage
        // }
        // service.config = {
        //     headers : {                    
        //          //'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhc2l0QDEyMyIsImF1dGgiOiJST0xFX0FETUlOLFJPTEVfVVNFUiIsImV4cCI6MTQ5Mjc4NTY5MH0.o-JOUwUNnOaqXc8eIzBvGBbJ7c4yfdEIWxMdiEKVn3mt6jrv1OyGSoRTwSdVuqHvpnaywHokr7bk9zkuhL_s-Q'
        //          'Authorization': 'Bearer '+service.token

        //     }
        // };
        // These methods are for getting Toast nofifications.
        var last = {
          bottom: false,
          top: true,
          left: false,
          right: true
        };
      service.toastPosition = angular.extend({},last);

      service.getToastPosition = function() {
        service.sanitizePosition();
        return Object.keys(service.toastPosition)
          .filter(function(pos) { return service.toastPosition[pos]; })
          .join(' ');                           
      };
      service.sanitizePosition = function () {
        var current = service.toastPosition;
        if ( current.bottom && last.top ) current.top = false;
        if ( current.top && last.bottom ) current.bottom = false;
        if ( current.right && last.left ) current.left = false;
        if ( current.left && last.right ) current.right = false;
        last = angular.extend({},current);
      }
         service.successTostDialog =successTostDialog;
        function successTostDialog(msg){
          // var successStatus =success.status;
          // var successStatusText = success.statusText;
          var pinTo = service.getToastPosition();
            $mdToast.show(
              $mdToast.simple()
              .textContent(msg)
              .position(pinTo )
              .hideDelay(1000)
            );                              
        } 



        service.showErrorDialog = showErrorDialog;
         function showErrorDialog(error){
            var errorStatus = error.status;
            var errorStatusText = error.statusText;
            if(errorStatus == -1){
                errorStatusText = 'The server application is not running';
            }
            $mdDialog.show(
              $mdDialog.alert()
                .clickOutsideToClose(true)
                .title('Server error occurred while processing')
                .htmlContent('<hr><br><strong>Error code : </strong>'+errorStatus+
                    '<br><strong>Error message : </strong>'+errorStatusText)
                .ariaLabel('Alert Dialog Demo')
                .ok('Ok')
            );
        }

        

        /*
         * User Management
         */
        service.getUsers = function() {
            var appUrl = '/users?page=0&size=1000';
            return call_GET(appUrl);
        }
        service.createUser = function(user){
          var appUrl = '/users';
          return call_POST(appUrl,user);
        }

        service.updateUser = function(user){
          var appUrl = '/users';
          return call_PUT(appUrl,user);
        }

        service.deleteUser = function(login){
          var appUrl = '/users/'+login;
          return call_DELETE(appUrl);
        }
        service.editGroup = function(group) {
            var appUrl = '/groups';
            return call_PUT(appUrl, group);
        }

        // service.getbrandsetting = function(){
        //     var appUrl = '/getbrandsetting';
        //     return call_GET(appUrl);
        // }
        // service.savebrandsetting = function(branddata){
        //     var appUrl = '/savebrandSetting';
        //     return call_PUT(appUrl,branddata);
        // }
        // service.updatebrandsetting = function(branddata){
        //     var appUrl = '/updatebrandsetting';
        //     return call_POST(appUrl,branddata);
        // }

        service.savingSitedata = function(data){
          var appUrl = '/systemSettings';
          return call_PUT(appUrl, data);
        } 

        service.getlistdata = function(){
          var appUrl = '/list';
           return call_GET(appUrl);
        }
        service.createList = function(list){
          var appUrl = '/createlist';
           return call_POST(appUrl,list);
        }
        service.updateList = function(list){
            var appUrl = '/updatelist';
         return call_PUT(appUrl,list);
        }
        service.delete = function(listid){
            var appUrl = '/list/'+ listid;
         return call_DELETE(appUrl);
        }

         service.createdetail = function(data){
            var appUrl = '/savedynamiccollection';
         return call_POST(appUrl,data);
        }
        
        service.getdetaildata = function(name){
            var appUrl = '/getdynamicinstace/' + name;
            return call_GET(appUrl);
        }
        service.updatedyData = function(data){
          var appUrl = '/updatedynamiccollection';
            return call_PUT(appUrl,data);
        }
        service.deletedata = function(id,name){
          var appUrl = '/deletedynamicinstace/' + name +'/'+id;
            return call_DELETE(appUrl);
        }
        

        // *
        // *Groups Management
        // *

        service.getAllGroups = function(){
          var appUrl = '/groups';
          return call_GET(appUrl);
        }
        service.getGroupMembers = function(groupId){
          var appUrl = '/groups/'+groupId+'/users';
          return call_GET(appUrl);
           
        }
        service.createGroup = function(groupData){
          var appUrl = '/groups';
          return call_POST(appUrl,groupData);
        }
        service.searchMemberForGroups = function(searchKeyword){
          var appUrl = '/users/search?q='+searchKeyword;
          return call_GET(appUrl);
        }
        service.addGroupMember = function(member, groupId){          
          var appUrl = '/groups/'+groupId+'/users';
          return call_POST(appUrl, member )
        }
        service.deleteGroup = function(groupId){
          var appUrl = '/groups/'+groupId;
          return call_DELETE(appUrl)
        }
        service.deleteGroupMember = function(groupId, login){
          var appUrl = '/groups/'+groupId+'/users/'+login;
          return call_DELETE(appUrl);
        }
/*Workflow*/
         service.getActvitys = function() {
            var appUrl = '/request-activities';
            return call_GET(appUrl);
        }
        service.createActivity = function(doc) {
            var appUrl = '/request-activities';
            return call_POST(appUrl, doc);
        }
        service.updateActivity = function(doc) {
            var appUrl = '/request-activities';
            return call_PUT(appUrl, doc);
        }
        service.deleteActivity = function(id) {
            var appUrl = '/request-activities/' + id;
            return call_DELETE(appUrl);
        }

    /*    Requests*/
        service.createRequest = function(doc) {
            var appUrl = '/request-types';
            return call_POST(appUrl, doc);
        }
        service.getRequests = function() {
            var appUrl = '/request-types';
            return call_GET(appUrl);
        }
        service.updateRequest = function(doc) {
            var appUrl = '/request-types';
            return call_PUT(appUrl, doc);
        }
        service.deleteRequest = function(id) {
            var appUrl = '/request-types/' + id;
            return call_DELETE(appUrl);
        }

       /* Binder*/
         service.getBinders = function() {
            var appUrl = '/binders';
            return call_GET(appUrl);
        }
        service.createBinder = function(binder) {
            var appUrl = '/binders';
            return call_POST(appUrl, binder);
        }
        service.updateBinder = function(binder) {
            var appUrl = '/binders';
            return call_PUT(appUrl, binder);
        }
        service.deleteBinder = function(id) {
            var appUrl = '/binders/' + id;
            return call_DELETE(appUrl);
        }

        /* Inbox and OutBox */
        service.getRequestGroupDoctypes = function() {
          var appUrl = '/requests/inbox';
          return call_GET(appUrl);
      }
      service.getAllInboxWorkitems = function(requestType) {
        var appUrl = '/requests/inbox/requestType/'+requestType+'?page=0&size=1000';
        return call_GET(appUrl);
    }
     service.getInboxWorkitemInfo = function(requestType, requestId) {
      var appUrl = '/requests/inbox/requestType/'+requestType+'/requests/' + requestId;
      return call_GET(appUrl);
    }
    service.getRequestOutbox = function() {
      var appUrl = '/requests/outbox';
      return call_GET(appUrl);
    }
    service.getAllOutboxWorkitems = function(requestType) {
      var appUrl = '/requests/outbox/requestType/' + requestType;
      return call_GET(appUrl);
    }
   service.getOutboxWorkitemInfo = function(requestType, requestId) {
      var appUrl = '/requests/outbox/requestType/' + requestType + '/requests/' + requestId;
      return call_GET(appUrl);
    }
    /* Reset Password */
    service.resetPassword = function(email) {
        var appUrl = '/account/reset_password/init';
        return call_POST(appUrl, email);
    }
    service.resetPasswordfinish = function(newPassword) {
        var appUrl = '/account/reset_password/finish';
        return call_POST(appUrl,newPassword);
    }

        /*
         * Sites and DMS
         */
        service.getSites = function(){
          var appUrl = '/mysites';
          return call_GET(appUrl);
        } 

         service.createSite = function(site) {
            var appUrl = '/sites';
            return call_POST(appUrl, site);
        }
        service.deleteSite = function(siteId) {
            var appUrl = '/sites/' + siteId;
            return call_DELETE(appUrl);
        }
        service.getSiteDetails = function(siteId) {
            var appUrl = '/sites/' + siteId;
            return call_GET(appUrl);
        }
        service.updateSite = function(site) {
            var appUrl = '/sites';
            return call_PUT(appUrl, site);
        }
        service.getMembers = function(siteId) {
            var appUrl = '/sites/' + siteId + '/members';
            return call_GET(appUrl);
        }
        service.deleteMember = function(siteId, login) {
            var appUrl = '/sites/' + siteId + '/members/' + login;
            return call_DELETE(appUrl);
        }
        service.searchMember = function(siteId, searchKeyword) {
            var appUrl = '/sites/' + siteId + '/users/search?q=' + searchKeyword;
            return call_GET(appUrl);
        }
        service.addMember = function(siteId, member) {
            var appUrl = '/sites/' + siteId + '/members';
            return call_POST(appUrl, member);
        }
        service.getToDoList = function getToDoList(siteId) {
            var appUrl = '/sites/' + siteId + '/todolists';
            return call_GET(appUrl);
        }
        service.addToDoList = function addToDoList(note, siteId) {
            var appUrl = '/sites/' + siteId + '/todolists';
            return call_POST(appUrl, note);
        }
        service.deleteTodo = function(noteId) {
            var appUrl = '/sites/todolists/' + noteId;
            return call_DELETE(appUrl);
        }
        service.updateTodo = function(data, siteId) {
            var appUrl = '/sites/' + siteId + '/todolists';
            return call_PUT(appUrl, data);
        }
        service.getSiteHome = function(siteId) {
            var appUrl = '/sites/' + siteId + '/dashbord';
            return call_GET(appUrl);
        }
        service.siteSettings = function(siteId, settings) {
            var appUrl = '/sites/' + siteId + '/settings/createSettings';
            return call_POST(appUrl, settings);
        }
        service.getFilesOnly = function(siteId) {
            var appUrl = '/sites/' + siteId + '/filesonly';
            return call_GET(appUrl);
        }
        service.getFileById = function(siteId,libraryId) {
            var appUrl = '/sites/' + siteId + '/files/'+libraryId;
            return call_GET(appUrl);
        }
        service.uploadFileToUrl = function(file) {
            var uploadUrl = 'http://1-dot-clock-asit.appspot.com/rest/createform/custom/file';
            var fd = new FormData();
            fd.append('file', file);
            return $http.post(uploadUrl, fd, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            });
        };
        service.uploadFile = function(siteId,description, file, currentFolderId, documentTypeJson) {
            var appUrl;
            if (currentFolderId == '') {
                appUrl = '/sites/' + siteId + '/files/file';
            } else {
                appUrl = '/sites/' + siteId + '/files/file?parentId=' + currentFolderId;
            }
            var form = new FormData();
            form.append('documentTypeJson', JSON.stringify(documentTypeJson));
            form.append('file', file);
            form.append('description',description);
            return $http.post(service.baseUrl + appUrl, form, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            });
        }
        service.createTemplateFile = function(siteId,currentFolderId,documentTypeJson,templatename,name) {
            var appUrl;
         if (currentFolderId == '') {
             appUrl = '/sites/' + siteId + '/files/createfile?documentTemplate='+templatename+'&name='+name +'&documentTypeJson='+encodeURI(JSON.stringify(documentTypeJson));
         } else {
             appUrl = '/sites/' + siteId + '/files/?documentTemplate='+templatename+'&name='+name +'&documentTypeJson='+encodeURI(JSON.stringify(documentTypeJson))+'&parentId=' + currentFolderId;
         }
        
         return $http.post(service.baseUrl + appUrl, {
             transformRequest: angular.identity,
             headers: {
                 'Content-Type': undefined
             }
         });
      
         
     }
        service.createFolder = function(siteId,description, folderName, currentFolderId) {
            var appUrl;
            if (currentFolderId == '')
                appUrl = '/sites/' + siteId + '/files/folder?name=' + folderName+'&description='+description;
            else
                appUrl = '/sites/' + siteId + '/files/folder?name=' + folderName + '&parentId=' + currentFolderId+'&description='+description;
            return call_POST(appUrl);
        }
        service.getFiles = function(parentId, siteId, pageNumber, pageSize) {
            var appUrl;
            if (parentId != '')
                appUrl = '/sites/' + siteId + '/files?page=' + pageNumber + '&size=' + pageSize + '&parentId=' + parentId;
            else
                appUrl = '/sites/' + siteId + '/files?page=' + pageNumber + '&size=' + pageSize;
            return call_GET(appUrl);
        }
        service.updateFile = function(siteId, file) {
            var appUrl = '/sites/' + siteId + '/files';
            return call_PUT(appUrl, file);
        }
        service.deleteFile = function(siteId, fileId) {
            var appUrl = '/sites/' + siteId + '/files/' + fileId;
            return call_DELETE(appUrl);
        }
        service.downloadFile = function(siteId, fileId) {
            var appUrl = '/sites/' + siteId + '/files/file?fileId=' + fileId;
            return $http.get(service.baseUrl + appUrl, {
                responseType: "blob",
                headers: {
                    'Accept': '*/*'
                }
            });
        }
        service.downloadVersionedFile = function(siteId, fileId, versionNo) {
            var appUrl = '/sites/' + siteId + '/files/file?fileId=' + fileId + '&versionNo=' + versionNo;
            return $http.get(service.baseUrl + appUrl, {
                responseType: "blob",
                headers: {
                    'Accept': '*/*'
                }
            });
        }
        service.fileCheckout = function(siteId, fileId) {
            var appUrl = '/sites/' + siteId + '/files/file?fileId=' + fileId + '&checkingOut=true';
            return $http.get(service.baseUrl + appUrl, {
                responseType: "blob",
                headers: {
                    'Accept': '*/*'
                }
            });
        }
        service.getAttributes = function(siteId, fileId) {
            var appUrl = '/sites/' + siteId + '/files/' + fileId;
            return call_GET(appUrl);
        }
        service.updateFileAttrAndSharing = function(siteId, fileObject) {
            var appUrl = '/sites/' + siteId + '/files/' + fileObject.id;
            return call_PUT(appUrl, fileObject);
        }
        service.searchUsers = function(elements) {
            var appUrl = '/users/search?q=' + elements.text + '&type=' + elements.type;
            return call_GET(appUrl);
        }
        service.searchSites = function(element) {
            var appUrl = '/sites/search?q=' + element;
            return call_GET(appUrl);
        }
        service.NewVersionFile = function(siteId, file, VersionFile) {
            var appUrl = '/sites/' + siteId + '/files/file?' + 'checkingIn=false&addNewVersion=true' + '&fileId=' + VersionFile.id+'&documentTypeJson='+encodeURI('documentTypeJson={}');
            var fd = new FormData();
            fd.append('file', file);
            return $http.post(service.baseUrl + appUrl, fd, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            });
        }
        service.checkIn = function(siteId, file, checkInFile) {
            var appUrl = '/sites/' + siteId + '/files/file?' + 'checkingIn=true&addNewVersion=false' + '&fileId=' + checkInFile.id+'&documentTypeJson='+encodeURI('documentTypeJson={}');
            var fd = new FormData();
            fd.append('file', file);
            return $http.post(service.baseUrl + appUrl, fd, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            });
        }


        service.buildForm=function(fileId){
          var appUrl = '/sites/'+CurrentSiteId.value+'/files/file?fileId='+fileId+'&checkingOut=false&attachment=false';
          return call_GET(appUrl);
        }

         service.getDocumentTypesforSite = function(siteId) {
            var appUrl = '/sites/'+ siteId + '/documentTypes/';
            return call_GET(appUrl);
        }

        service.getHomePage = function() {
            var appUrl = '/users/dashbord';
            return call_GET(appUrl);
        }

        /*
          Binders
        */

        service.getbinderFiles=function(parentId,binderId){
              var appUrl;
            if(parentId !='')    
                appUrl = '/binder/'+binderId+'/files?parentId='+parentId;
            else
                appUrl = '/binder/'+binderId+'/files';
            return call_GET(appUrl);

        }
        service.getbinderAttributes = function(fileId,binderId){
          var appUrl = '/binder/'+binderId+'/files/'+fileId;
          return call_GET(appUrl);
        }

        service.deletebinderFile = function(fileId,binderId){
         var appUrl = '/binder/'+binderId+'/files/'+fileId;
          return call_DELETE(appUrl);
        }
        service.uploadbinderFile = function(file,currentFolderId,binderId){
          var appUrl;
          if(currentFolderId == '')
            appUrl = '/binder/'+binderId+'/files/file';
          else
            appUrl ='/binder/'+binderId+'/files/file?parentId='+currentFolderId;
           var fd = new FormData();
          fd.append('file', file);
          return  $http.post(service.baseUrl+appUrl, fd, {
                transformRequest: angular.identity,
                headers: {'Content-Type': undefined,'Authorization': 'Bearer '+service.token}
               });
           
             }
        service.binerfilecheckIn =function(file,checkInFile,checkInFolderid,binderId){        
          var appUrl='/binder/'+binderId+'/files/file?'+'checkingIn=true&addNewVersion=false'+'&fileId='+checkInFile.id;
          var fd = new FormData();
          fd.append('file', file);
          return  $http.post(service.baseUrl+appUrl, fd, {
                transformRequest: angular.identity,
                headers: {'Content-Type': undefined,'Authorization': 'Bearer '+service.token}
               });
        }
        service.binderfileCheckout =function(fileId,binderId){
          var appUrl = '/binder/'+binderId+'/files/file?fileId='+fileId+'&checkingOut=true&attachment=true';
          //special GET request that reads binary data
          return $http.get(service.baseUrl+appUrl,{
              responseType: "blob",
              headers: {'Accept': '*/*', 'Authorization': 'Bearer '+service.token}
          });
        }
        service.updatebinderFileAttrAndSharing = function(fileObject,binderId){
          var appUrl = '/binder/'+binderId+'/files/'+fileObject.id;
          return call_PUT(appUrl, fileObject);
        }
        service.NewVersionbinderFile = function(file,VersionFile,binderId){
          var appUrl='/binder/'+binderId+'/files/file?'+'checkingIn=false&addNewVersion=true'+'&fileId='+VersionFile.id;
          var fd = new FormData();
          fd.append('file', file);
          return  $http.post(service.baseUrl+appUrl, fd, {
                transformRequest: angular.identity,
                headers: {'Content-Type': undefined,'Authorization': 'Bearer '+service.token}
               });
           }

          service.updatebinderFile = function(file,binderId){
          var appUrl = '/binder/'+binderId+'/files';
          return call_PUT(appUrl,file);
        }
        service.downloadbinderFile =function(fileId,binderId){
          var appUrl = '/binder/'+binderId+'/files/file?fileId='+fileId;
          //special GET request that reads binary data
          return $http.get(service.baseUrl+appUrl,{
              responseType: "blob",
              headers: {'Accept': '*/*', 'Authorization': 'Bearer '+service.token}
          });
        }
        service.downloadVersionedbinderFile =function(fileId,versionNo,binderId){
          var appUrl = '/binder/'+binderId+'/files/file?fileId='+fileId+'&versionNo='+versionNo;
          //special GET request that reads binary data
          return $http.get(service.baseUrl+appUrl,{
              responseType: "blob",
              headers: {'Accept': '*/*', 'Authorization': 'Bearer '+service.token}
          });
        }
        service.createbinderFolder = function(folderName,currentFolderId,binderId){
           var appUrl;
         if(currentFolderId == '')
             appUrl = '/binder/'+binderId+'/files/folder?name='+folderName;
          else
             appUrl = '/binder/'+binderId+'/files/folder?name='+folderName+'&parentId='+currentFolderId;
              return call_POST( appUrl);
              
             }
        service.getbinderAttributes = function(fileId,binderId){
          var appUrl = '/binder/'+binderId+'/files/'+fileId;
          return call_GET(appUrl);
        }
        service.attributesThroughBinderId = function(binderId){ 
          var appUrl = "/binder/"+binderId;
          return call_GET(appUrl);
        }
        service.getAllBusinessObjects = function(){
          var appUrl = '/business-objects';
          return call_GET(appUrl);
        }

        /* Reports */
        service.getreporttypefields = function(data) {
            var appUrl = '/reports/getcollectionfields/' + data;
            return call_GET(appUrl);
        }
        
        service.savereportdata = function(data) {
            var appUrl = '/reports/savereportdata';
            return call_PUT(appUrl,data);
        }
        service.updateReportData = function(data) {
            var appUrl = '/reports/updatereportdata';
            return call_POST(appUrl,data);
        }
        
        service.getreportdata = function() {
            var appUrl = '/reports/getreportdata';
            return call_GET(appUrl);
        }
        service.getdocumentbyquery = function(query){
        	var appUrl = '/getdocumentbyquery/'+ query ;
            return call_GET(appUrl);
        }
        service.getrequestbyquery = function(query){
        	var appUrl = '/getrequestbyquery/'+ query ;
            return call_GET(appUrl);
        }
        
        service.deletereport = function(id){
        	var appUrl = '/reports/'+ id ;
            return call_DELETE(appUrl);
        }

         //Bussinessobject
         service.getObjects = function(){
           var appUrl = '/business-objects';
           return call_GET(appUrl);
        }
         service.createObject = function(object){

          var appUrl = '/business-objects';
          return call_POST(appUrl,object);
        }
         service.updateObject = function(object){
          var appUrl = '/business-objects';
          return call_PUT(appUrl,object);
        }

        service.deleteObject = function(id){
          var appUrl = '/business-objects/'+id;
          return call_DELETE(appUrl);
        }
        /* 
          Users
        */
        service.getUser = function(login){
          var appUrl = '/users/'+login;
          return call_GET(appUrl);
        }
        service.updateUserProfile = function(user){
          var appUrl = '/users';
          return call_PUT(appUrl,user);
        }


        service.UserDetails = function() {
          var appUrl = '/account';
          return call_GET(appUrl);
      }
       service.getSystemDetails = function(){
          var appUrl = '/systemSettings';
          return call_GET(appUrl);
        }

        service.getDocumentTypes = function() {
            var appUrl = '/documentTypes';
            return call_GET(appUrl);
        }

         service.getMySharedfiles = function(pageNumber,pageSize) {
            var appUrl = '/users/preference/mysharedfiles?page=' + pageNumber + '&size=' + pageSize;
            return call_GET(appUrl);
        }

        service.findBusinessObjectAttributes = function(id){
          var appUrl = '/business-objects/'+id;
          return call_GET(appUrl);
        }
        service.advanceSearch = function(fileData, searchTerm){
          // alert("FileData sent to RestAPIService is "+JSON.stringify(fileData));
          // var appUrl = '/advancedSearch?term='+searchTerm;
          var appUrl = '/advancedSearch?term='+searchTerm;
          return call_POST(appUrl,fileData);
        }
service.advancedSearch = function(fileData, pageNumber, pageSize, dateRange) {           
          var appUrl = '/advancedSearch?page='+pageNumber+'&size='+pageSize;
            return call_POST(appUrl, fileData);
        }
        service.basicSearch = function(searchTerm){
          // alert(searchTerm);
          var appUrl = '/search?term='+searchTerm;
          return call_GET(appUrl);
        }


        service.getSharedfiles = function(){
           var appUrl = '/users/preference/files/sharedWithMe';
           return call_GET(appUrl);
        }
        /* Search Download*/
        service.searchresultsDownload =function(fileId,siteId){
          var appUrl = '/sites/'+siteId+'/files/file?fileId='+fileId;
          //special GET request that reads binary data
          return $http.get(service.baseUrl+appUrl,{
              responseType: "blob",
              headers: {'Accept': '*/*', 'Authorization': 'Bearer '+service.token}
          });
        }
        service.getFileAttributeDetails= function(fileId, siteId){
          var appUrl = '/sites/'+siteId+'/files/'+fileId;
          return call_GET(appUrl);
        }

        service.uploadRequestForm = function(headerfile,lineitemfile, name, description,json) {
           	var appUrl = '/forms';
            var form = new FormData();
            form.append('name',name);
            form.append('description',description);
            form.append('headerFile', headerfile);
            form.append('lineitemfile', lineitemfile);
            form.append('formFieldsHeader',json);
            return $http.post(service.baseUrl + appUrl, form, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            });
        	
        }
        
        service.updateRequestForm = function(headerfile,lineitemfile, name,id, description,json) {
         	var appUrl = '/forms';
            var form = new FormData();
            form.append('id',id);
            form.append('name',name);
            form.append('description',description);
            form.append('headerFile', headerfile);
            form.append('lineitemfile', lineitemfile);
            form.append('formFieldsHeader',json);
            return $http.put(service.baseUrl + appUrl, form, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            });
        	
        }
        service.sendFormData = function(json, attachmentfiles) {
            var appUrl = '/requests';
            var form = new FormData();
            for(var prop in  attachmentfiles){
                form.append('files', attachmentfiles[prop]);
                 }
          /*  form.append('files',attachmentfiles);*/
            return $http.post(service.baseUrl + appUrl+"?requestData="+encodeURIComponent(JSON.stringify(json)), form, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            });
        }
        service.createJsonForm = function(data){
        	var appUrl = '/createForms';
        	return call_POST(appUrl, data);
        }
        service.getRequestForms = function(pageNumber, pageSize) {
            var appUrl = '/forms?page=' + pageNumber + '&size=' + pageSize;
            return call_GET(appUrl);
        }
        service.getRequestFormById = function(id) {
            var appUrl = '/forms/' + id;
            return call_GET(appUrl);
        }

        service.Filepermission = function(permission) {
            var appUrl = '/permissions';
            return call_POST(appUrl, permission);
        }
        service.getPermission = function(fileId) {
            var appUrl = '/permissions/' + fileId;
            return call_GET(appUrl);
        }
        service.getFilePermissions = function(siteId,fileId) {
            var appUrl = '/sites/'+siteId+  '/files/'+fileId+'/permissions/';
            return call_GET(appUrl);
        }
        service.getMyFilePermissions = function(siteId,fileId) {
            var appUrl = '/sites/'+siteId+  '/files/'+fileId+'/mypermissions/';
            return call_GET(appUrl);
        }
        service.Removepermission = function(id) {
            var appUrl = '/permissions/' + id;
            return call_DELETE(appUrl);
        }
        service.setInherited = function(siteId,fileId) {
            var appUrl = '/sites/'+ siteId +'/files/' + fileId + '/setInherited/';
            return call_POST(appUrl);
        }
        
        service.updateFilePermission = function(siteId, fileId, data) {
          var appUrl = '/sites/'+siteId+ '/files/'+fileId+'/permissions/';
            return call_PUT(appUrl, data);
        }
        
        service.ResetPassword = function(password) {
            var appUrl = '/account/change_password';
            return call_POST(appUrl, password);
        }
        
        /* Profile */
        service.getUser = function(login) {
            var appUrl = '/users/' + login;
            return call_GET(appUrl);
        }
        service.updateUserProfile = function(user) {
            var appUrl = '/users';
            return call_PUT(appUrl, user);
        }
        service.UserDetails = function() {
            var appUrl = '/account';
            return call_GET(appUrl);
        }
        /* BrandSettings */
        service.getbrandsetting = function(){
            var appUrl = '/getbrandsetting';
            return call_GET(appUrl);
        }
        service.savebrandsetting = function(branddata){
            var appUrl = '/savebrandSetting';
            return call_PUT(appUrl,branddata);
        }
        service.updatebrandsetting = function(branddata){
            var appUrl = '/updatebrandsetting';
            return call_POST(appUrl,branddata);
        }

         service.deleteDocumentTypesforSite = function(documentTypeId,siteId) {
            var appUrl = '/documentTypes/deleteSites?documentTypeId='+ documentTypeId + '&siteId='+ siteId;
            return call_DELETE(appUrl,documentTypeId,siteId);
        }
        service.getDocumentTypeSites = function(id) {
            var appUrl = '/documentTypes/'+ id + '/getSites';
            return call_GET(appUrl);
        }
        service.createDocumentType = function(documentType) {
            var appUrl = '/documentTypes';
            return call_POST(appUrl, documentType);
        }
        service.updateDocumentType = function(documentType) {
            var appUrl = '/documentTypes';
            return call_PUT(appUrl, documentType);
        }
        service.updateDocumentTypeSites = function(documentTypeId,siteId) {
            var appUrl = '/documentTypes/updateSites?documentTypeId='+documentTypeId + '&siteId=' + siteId;
            return call_PUT(appUrl,documentTypeId, siteId);
        }
        service.deleteDocumentType = function(documentId) {
            var appUrl = '/documentTypes/' + documentId;
            return call_DELETE(appUrl);
        }
        service.getDocumentTypeAttributes = function(id) {
            var appUrl = '/documentTypes/' + id;
            return call_GET(appUrl);
        }
        service.getDocumentTemplate = function() {
            var appUrl = '/documentTemplate';
            return call_GET(appUrl);
        }
        service.updateApprovalConfig = function(documentType) {
            var appUrl = '/documentTypes/updateConfig';
            return call_PUT(appUrl, documentType);
        }
/*Template*/
         service.getTemplates = function() {
            var appUrl = '/documentTemplate';
            return call_GET(appUrl);
        }
        service.CreateTemplate = function(template, file) {
            var appUrl = '/documentTemplate?name=' + template.name + '&description=' + template.description + '&documentType=' + template.documentType;
            var form = new FormData();
            form.append('file', file);
            return $http.post(service.baseUrl + appUrl, form, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            });
        }
        service.DeleteTemplate = function(id) {
            var appUrl = '/documentTemplate/' + id;
            return call_DELETE(appUrl);
        }
        service.UpdateTemplate = function(template, file) {
            var appUrl = '/documentTemplate?id=' + template.id + '&description=' + template.description + '&documentType=' + template.documentType;
            var form = new FormData();
            form.append('file', file);
            return $http.put(service.baseUrl + appUrl, form, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            });
        }
       
   /* ILM Stores & systems */
       service.createILMSystem = function(data){
          var appUrl = '/systems';
          return call_POST(appUrl, data);
        }
        service.getAllILMSystems = function(){
          var appUrl = '/systems';
          return call_GET(appUrl);
        }
        service.updateILMSystem = function(data){
          var appUrl = '/systems';
          return call_PUT(appUrl, data);
        }
        service.deleteSystem = function(id){
          var appUrl = '/systems/'+id;
          return call_DELETE(appUrl);
        }

         service.createILMStore = function(data){
          var appUrl = '/ilmstore';
          return call_POST(appUrl, data);
        }
        service.getAllILMStores = function(){
          var appUrl = '/ilmstore';
          return call_GET(appUrl);
        }
        service.updateILMStore = function(data){
          var appUrl = '/ilmstore';
          return call_PUT(appUrl, data);
        }
        service.deleteStotre = function(id){
          var appUrl = '/ilmstore/'+id;
          return call_DELETE(appUrl);
        }
        
        //workflow
        service.getAllWorkflow = function() {
           var appUrl = '/wfb/getAll';
             return call_GET(appUrl);
        }
        service.getWorkflowById = function(id) {
          var appUrl = '/wfb/get/'+id;
            return call_GET(appUrl);
        }
        

        service.createWorkflow = function(json) {
            var appUrl = '/wfb/create';
            return call_POST(appUrl, json);
        }
        //manage-vendors
         service.getVendors = function() {
            var appUrl = '/vendors';
            return call_GET(appUrl);
        }
        service.createVendor = function(vendor){
          var appUrl = '/vendors';
          return call_POST(appUrl,vendor);
        }

        service.updateVendor = function(vendor){
          var appUrl = '/vendors';
          return call_PUT(appUrl,vendor);
        }

        service.deleteVendor = function(id){
          var appUrl = '/vendors/'+id;
          return call_DELETE(appUrl);
        }
//Dataobjects
        service.getDataobjects = function() {
            var appUrl = '/dataobject';
            return call_GET(appUrl);
        }
        service.createDataObject = function(dataobject){
          var appUrl = '/dataobject';
          return call_POST(appUrl,dataobject);
        }

        service.updateDataObject = function(dataobject){
          var appUrl = '/dataobject';
          return call_PUT(appUrl,dataobject);
        }

        service.deleteDataObject = function(id){
          var appUrl = '/dataobject/'+id;
          return call_DELETE(appUrl);
        }

        //Company
         service.getCompanies = function() {
            var appUrl = '/company';
            return call_GET(appUrl);
        }
        service.createCompany = function(company){
          var appUrl = '/company';
          return call_POST(appUrl,company);
        }

        service.updateCompany = function(company){
          var appUrl = '/company';
          return call_PUT(appUrl,company);
        }

        service.deleteCompany = function(id){
          var appUrl = '/company/'+id;
          return call_DELETE(appUrl);
        }
        //notifications
        service.getNotifications = function() {
            var appUrl = '/notification';
            return call_GET(appUrl);
        }
        service.createNotification = function(notification){
          var appUrl = '/notification';
          return call_POST(appUrl,notification);
        }

        service.updateNotification = function(notification){
          var appUrl = '/notification';
          return call_PUT(appUrl,notification);
        }

        service.deleteNotification = function(id){
          var appUrl = '/notification/'+id;
          return call_DELETE(appUrl);
        }

        //Companies
         service.getCompanies = function() {
            var appUrl = '/company';
            return call_GET(appUrl);
        }
        service.createCompany = function(company){
          var appUrl = '/company';
          return call_POST(appUrl,company);
        }

        service.updateCompany = function(company){
          var appUrl = '/company';
          return call_PUT(appUrl,company);
        }

        service.deleteCompany = function(id){
          var appUrl = '/company/'+id;
          return call_DELETE(appUrl);
        }

        //Systems

         service.getSystems = function() {
            var appUrl = '/systems';
            return call_GET(appUrl);
        }
        service.createSystem = function(system){
          var appUrl = '/systems';
          return call_POST(appUrl,system);
        }

        service.updateSystem = function(system){
          var appUrl = '/systems';
          return call_PUT(appUrl,system);
        }

        service.deleteSystem = function(id){
          var appUrl = '/systems/'+id;
          return call_DELETE(appUrl);
        }
        service.getSystemCertificate = function(Id) {
            // var appUrl = '/systems/authId/' + authId;
            var appUrl ='/systems/certificates/'+Id;
            return call_GET(appUrl);
        }
          service.SystemCertificateVerify = function(authId,status) {
            var appUrl = '/systems/authId/' + authId + '/status/' + status;
            return call_PUT(appUrl);
        }

        //Repositories
        service.getRepositories = function() {
            var appUrl = '/repository';
            return call_GET(appUrl);
        }
        service.createRepository = function(repository){
          var appUrl = '/repository';
          return call_POST(appUrl,repository);
        }

        service.updateRepository = function(repository){
          var appUrl = '/repository';
          return call_PUT(appUrl,repository);
        }

        service.deleteRepository = function(id){
          var appUrl = '/repository/'+id;
          return call_DELETE(appUrl);
        }

        service.getsystemRepos = function(systemId) {
            var appUrl = '/systems/'+systemId+'/repositories';
            return call_GET(appUrl);
        }
        //Mimetype settings
        service.getMimeTypes = function() {
            var appUrl = '/mimetype';
            return call_GET(appUrl);
        }
        service.createMimeType = function(mimetype){
          var appUrl = '/mimetype';
          return call_POST(appUrl,mimetype);
        }

        service.updateMimeType = function(mimetype){
          var appUrl = '/mimetype';
          return call_PUT(appUrl,mimetype);
        }

        service.deleteMimeType = function(id){
          var appUrl = '/mimetype/'+id;
          return call_DELETE(appUrl);
        }

        


        /*
         * HTTP methods
         */
        function call_GET(appUrl){
            return $http.get(service.baseUrl+appUrl,service.config);
        }
        function call_POST(appUrl,userData){
            return $http.post(service.baseUrl+appUrl,userData,service.config);

        }
        function call_DELETE(appUrl){
            return $http.delete(service.baseUrl+appUrl,service.config);
        }
        function call_PUT(appUrl,userData){
            return $http.put(service.baseUrl+appUrl,userData,service.config);
        }       
        
        return service;
    }

})();
(function ()
{
    'use strict';

    angular
        .module('smartportal')
        .factory('MigrationRestAPIService', MigrationRestAPIService);

    /** @ngInject */
    function MigrationRestAPIService($q, $log, $http, $mdDialog,$mdToast, $sessionStorage, LoggedInUserToken, CurrentSiteId)
    {

        var service = {};
        // $http.defaults.headers.common.Authorization = "";
       // service.baseUrl = 'http://182.156.74.203:8080/api';
         // service.baseUrl = 'http://35.188.232.28:8080/api';
         service.smartStoreMigrationbaseUrl = smartStoreMigrationbaseUrl +'/api'
        // service.token = LoggedInUserToken.value.trim();  //Get the token from AuthenticationService
        // if(!service.token){
        //   service.token = $sessionStorage.currentUser.token.trim();  //Fallback method - if token not found check session storage
        // }
        // service.config = {
        //     headers : {                    
        //          //'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhc2l0QDEyMyIsImF1dGgiOiJST0xFX0FETUlOLFJPTEVfVVNFUiIsImV4cCI6MTQ5Mjc4NTY5MH0.o-JOUwUNnOaqXc8eIzBvGBbJ7c4yfdEIWxMdiEKVn3mt6jrv1OyGSoRTwSdVuqHvpnaywHokr7bk9zkuhL_s-Q'
        //          'Authorization': 'Bearer '+service.token

        //     }
        // };
        // These methods are for getting Toast nofifications.
        var last = {
          bottom: false,
          top: true,
          left: false,
          right: true
        };
      service.toastPosition = angular.extend({},last);

      service.getToastPosition = function() {
        service.sanitizePosition();
        return Object.keys(service.toastPosition)
          .filter(function(pos) { return service.toastPosition[pos]; })
          .join(' ');                           
      };
      service.sanitizePosition = function () {
        var current = service.toastPosition;
        if ( current.bottom && last.top ) current.top = false;
        if ( current.top && last.bottom ) current.bottom = false;
        if ( current.right && last.left ) current.left = false;
        if ( current.left && last.right ) current.right = false;
        last = angular.extend({},current);
      }
         service.successTostDialog =successTostDialog;
        function successTostDialog(msg){
          // var successStatus =success.status;
          // var successStatusText = success.statusText;
          var pinTo = service.getToastPosition();
            $mdToast.show(
              $mdToast.simple()
              .textContent(msg)
              .position(pinTo )
              .hideDelay(1000)
            );                              
        } 



        service.showErrorDialog = showErrorDialog;
         function showErrorDialog(error){
            var errorStatus = error.status;
            var errorStatusText = error.statusText;
            if(errorStatus == -1){
                errorStatusText = 'The server application is not running';
            }
            $mdDialog.show(
              $mdDialog.alert()
                .clickOutsideToClose(true)
                .title('Server error occurred while processing')
                .htmlContent('<hr><br><strong>Error code : </strong>'+errorStatus+
                    '<br><strong>Error message : </strong>'+errorStatusText)
                .ariaLabel('Alert Dialog Demo')
                .ok('Ok')
            );
        }

        service.getBatchDetails = function(page,size) {
          var appUrl = '/batchlogs?page='+page+'&size='+size;
          return call_GET(appUrl);
      } 
      service.getBatchDetailspage = function(data,page,size) {
        var appUrl = '/searchlogs?page='+page+'&size='+size;
        return call_POST(appUrl,data);
    } 
    service.getDocumentationDetails = function(page,size) {
      var appUrl = '/logs?page='+page+'&size='+size;
      return call_GET(appUrl);
  } 
      service.getMigrationConfiguration = function(data) {
        var appUrl = '/MigrationConfiguration/'+data;
        return call_GET(appUrl,data);
    } 
    service.getDocumentById = function(data) {
      var appUrl = '/getTargetDocument?archiveDocID='+data;
      return call_GET(appUrl);
  } 
    service.MigrationConfiguration = function(data) {
      var appUrl = '/MigrationConfiguration';
      return call_POST(appUrl,data);
  } 
  service.remigrate = function(data) {
    var appUrl = '/remigrate';
    return call_POST(appUrl,data);
} 

        /*
         * HTTP methods
         */
        function call_GET(appUrl){
            return $http.get(service.smartStoreMigrationbaseUrl+appUrl,service.config);
        }
        function call_POST(appUrl,userData){
            return $http.post(service.smartStoreMigrationbaseUrl+appUrl,userData,service.config);

        }
        function call_DELETE(appUrl){
            return $http.delete(service.smartStoreMigrationbaseUrl+appUrl,service.config);
        }
        function call_PUT(appUrl,userData){
            return $http.put(service.smartStoreMigrationbaseUrl+appUrl,userData,service.config);
        }       
        
        return service;
    }

})();
(function () {
    'use strict';

    angular
        .module('smartportal')
        .factory('AuthenticationService', Service)
        .value("LoggedInUserToken", {value: ""})
        .value("LoggedInUserId", {value: ""});

    function Service($http, $localStorage, $sessionStorage, $rootScope, LoggedInUserId, LoggedInUserToken) {
        var service = {};

        
        service.Login = Login;
        service.Logout = Logout;
       // service.GetLoggedInUser = GetLoggedInUser;
      
        return service;

        function Login(username, password, callback) {
            var response;
            $http.post(baseUrl+'/api/authenticate', { 
                username: username, 
                password: password,
                rememberMe:true
             }).then(
                    function(success){
                        //login successful if there's a token in the response
                        if (success.data.id_token) {

                            LoggedInUserId.value = username;
                            LoggedInUserToken.value = success.data.id_token;
                            
                            // store username and token in local storage to keep user logged in between page refreshes
                            //$localStorage.currentUser = { username: username, token: success.data.id_token };

                           $localStorage.currentUser = { username: username, token: success.data.id_token };
                        $sessionStorage.currentUser = { username: username, token: success.data.id_token };

                            // add jwt token to auth header for all requests made by the $http service
                            $http.defaults.headers.common.Authorization = 'Bearer ' + success.data.id_token;
                        $rootScope.loggedInUser = username;
                            // execute callback with true to indicate successful login
                            response = { success: true, message: 'successful login' };
                            callback(response);
                        }                       
                    }, 
                    function(error){
                        //Unauthorized 401 error
                        response = { success: false, message: 'ERROR : Username or password do not match !' };
                        callback(response);
                    });

               
        }

       /* function Logout() {
            // remove user from local storage and clear http auth header
            delete $sessionStorage.currentUser;
            delete $localStorage.currentUser;
            $http.defaults.headers.common.Authorization = '';
               
        }*/
         function Logout() {
            // remove user from local storage and clear http auth header
            delete $sessionStorage.currentUser;
            delete $localStorage.currentUser;
            $http.defaults.headers.common.Authorization = '';
           delete window.localStorage['branddata'];
            /* $templateCache.removeAll();            
            var cookies = $cookies.getAll();
            angular.forEach(cookies, function (v, k) {
                $cookies.remove(k);
            });*/
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('smartportal')
        .run(runBlock)
        .value("CurrentBinderId", {value: ""});

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, $localStorage, $sessionStorage, $location, $http, LoggedInUserId, LoggedInUserToken, CurrentBinderId)
    {
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function ()
        {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });


 
        // keep user logged in after page refresh
        if ($localStorage.currentUser) {
            $http.defaults.headers.common.Authorization = 'Bearer ' + $localStorage.currentUser.token;
        }

       
        $rootScope.$on('$locationChangeStart', function (event, next, current) {
            
            var publicPages = ['/login'];
        
            var userId = $location.search().userId;
            var binderId = $location.search().binderId;
            //Get the login token for userId for binder URLs coming from Success Factor
            if($location.path().indexOf('binder') != -1 && userId){
                
                $http.get( baseUrl + "/api/signin?userId="+userId).then(
                    function(success) {
                        if (success.data.id_token) {
                            LoggedInUserId.value = userId;
                            LoggedInUserToken.value = success.data.id_token;
                            CurrentBinderId.value = binderId;
                            //alert(CurrentBinderId.value);
                            // store username and token in local storage to keep user logged in between page refreshes
                            $sessionStorage.currentUser = { username: userId, token: success.data.id_token };

                            // add jwt token to auth header for all requests made by the $http service
                            $http.defaults.headers.common.Authorization = 'Bearer ' + success.data.id_token;

                            $rootScope.loggedInUser = userId;

                            // Redirect to binder page after successful login
                            $location.path('/binder');
                        }
                    },
                    function(error) {
                        //alert(error.status);
                        $location.path('/login');
                    }
                );

            }

            // redirect to login page if not logged in and trying to access a restricted page
            var restrictedPage = publicPages.indexOf($location.path()) === -1;
             if (restrictedPage && !$localStorage.currentUser) {
                if($location.path().indexOf("/smartportal/reset/finish/") > -1){
                    $location.path();
                } else {
                     $location.path('/login');
                }
            }
            /*if($localStorage.currentUser != undefined && $localStorage.currentUser.token != undefined){
                if($location.path().indexOf("/login") > -1){
                    $location.path('/overview');
                }
            }*/



        });
 

    }
})();
(function ()
{
    'use strict';

    angular
        .module('smartportal')
        .config(routeConfig)
       // .run(run);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(false);

        $urlRouterProvider.otherwise('/overview');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            // verticalNavigationFullwidthToolbar  : {
            //     main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
            //     toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
            //     navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            // },
            // verticalNavigationFullwidthToolbar2  : {
            //     main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
            //     toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
            //     navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
            // },
            // horizontalNavigation: {
            //     main      : 'app/core/layouts/horizontal-navigation.html',
            //     toolbar   : 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
            //     navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            // },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                navigation: ''
            },
            contentWithToolbar  : {
                main      : 'app/core/layouts/content-with-toolbar.html',
                toolbar   : 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController as vm'
                    },
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller : 'QuickPanelController as vm'
                    }
                }
            })
             .state('login', {
                url: '/login',
                views    : {
                    'main@'                          : {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller : 'MainController as vm'
                    },
                    'content@login': {
                        templateUrl: 'app/main/login/login.html',
                        controller : 'LoginController'
                    }
                },
                bodyClass: 'login'
            });
    }


   
})();

(function ()
{
    'use strict';

    angular
        .module('smartportal')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('smartportal');
})();

(function ()
{
    'use strict';

    angular
        .module('smartportal')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider)
    {
        // Put your custom configurations here
        $mdThemingProvider.theme('red').backgroundPalette('red');
        $mdThemingProvider.theme('pink').backgroundPalette('pink');
        $mdThemingProvider.theme('purple').backgroundPalette('purple');
        $mdThemingProvider.theme('deep-purple').backgroundPalette('deep-purple');
        $mdThemingProvider.theme('indigo').backgroundPalette('indigo');
        $mdThemingProvider.theme('blue').backgroundPalette('blue');
        $mdThemingProvider.theme('light-blue').backgroundPalette('light-blue');
        $mdThemingProvider.theme('cyan').backgroundPalette('cyan');
        $mdThemingProvider.theme('teal').backgroundPalette('teal');
        $mdThemingProvider.theme('green').backgroundPalette('green');
        $mdThemingProvider.theme('light-green').backgroundPalette('light-green');
        $mdThemingProvider.theme('lime').backgroundPalette('lime');
        $mdThemingProvider.theme('yellow').backgroundPalette('yellow');
        $mdThemingProvider.theme('amber').backgroundPalette('amber');
        $mdThemingProvider.theme('orange').backgroundPalette('orange');
        $mdThemingProvider.theme('deep-orange').backgroundPalette('deep-orange');
        $mdThemingProvider.theme('brown').backgroundPalette('brown');
        $mdThemingProvider.theme('grey').backgroundPalette('grey');
        $mdThemingProvider.theme('blue-grey').backgroundPalette('blue-grey');

    }

})();
(function ()
{
    'use strict';

    angular
        .module('smartportal')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = 'app/data/';

        // api.sample = $resource(api.baseUrl + 'sample/sample.json');

        return api;
    }

})();
(function ()
{
    'use strict';

    angular
        .module('smartportal')
        .factory('CommonUtil', CommonUtil);

    /** @ngInject */
    function CommonUtil()
    {
        var service = {};

        service.getIconForFile = function(file){
          var icon ={};
          if(file.type == "folder"){
                icon = "icon-folder";
            }                        
            else if(file.name.indexOf("jpg")!= -1){
                icon = "icon-file-image";
            }
            else if(file.name.indexOf("jpeg")!= -1){
                icon = "icon-file-image";
            }
            else if(file.name.indexOf("png")!= -1){
                icon = "icon-file-image";
            }
            else if(file.name.indexOf("pdf")!= -1){
                icon = "icon-file-pdf-box";
            }
            else if(file.name.indexOf("txt")!= -1){
                icon = "icon-clipboard-text";
            }
            else if(file.name.indexOf("html")!= -1){
                icon = "icon-language-html5";
            }
            else if(file.name.indexOf("xl")!= -1){
                icon = "icon-file-excel";
            }
            else if(file.name.indexOf("word")!= -1){
                icon = "icon-file-word";
            }
            else if(file.name.indexOf("xml")!= -1){
                icon = "icon-file-xml";
            }
            else if(file.name.indexOf("doc")!= -1){
                icon = "icon-file-document";
            }  
            else if(file.name.indexOf("docx")!= -1){
                icon = "icon-file-document";
            }
            else if(file.name.indexOf("json")!= -1){
                icon = "icon-clipboard-text";
            }                      

            else{
                icon = "icon-file-document";
            }
            return icon;
        }
        


        return service;
    }

})();
(function() {
    'use strict';

	angular.module('app.reset', [ 'app.reset.password' ]).config(config);

	function config() {
	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.mycontent', [
            'app.mycontent.inbox',
            'app.mycontent.outbox',
            'angular-timeline'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {      
       /*msNavigationServiceProvider.saveItem('mycontent', {
            title : 'MyContent',
            icon  : 'icon-email',
            state : 'app.mycontent_inbox',
            weight: 2
        });*/

       
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.createform', []).config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.createform', {
               // abstract: true,
                url     : '/createform',
                 views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/errors/404/error-404.html',
                        controller : 'Error404Controller as cf'
                    }
                }
            })
            .state('app.createform.custom', {
                url      : '/custom',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/createform/views/custom/custom.html',
                        controller : 'CustomCreateformController as cf'
                    }
                }
            });
            /* .state('app.createform.standard', {
                url      : '/standard',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/errors/404/error-404.html',
                        controller : 'Error404Controller as cf'
                    }
                }
            });*/
            /*.state('app.createform.new', {
                url      : '/new',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/errors/404/error-404.html',
                        controller : 'Error404Controller as cf'
                    }
                }
            });*/
            
        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/apps/e-commerce');

      
        // Navigation
       /* msNavigationServiceProvider.saveItem('admin', {
            title : 'ADMIN',
            group : true,
            weight: 4
        });*/

      /*  msNavigationServiceProvider.saveItem('admin.createform', {
            title : 'Requests Management',
            icon  : 'icon-script',
            state:'app.createform.custom',
            weight: 2
        });
*/
        // msNavigationServiceProvider.saveItem('admin.custom', {
        //     title: 'Lists Management',
        //     icon:'icon-view-list'
        //     state: 'app.createform.custom',
        //     weight: 3
        // });
        
        // msNavigationServiceProvider.saveItem('admin.standard', {
        //     title: 'Workflow Management',
        //     icon:'icon-worker',
        //     state: 'app.createform.standard',
        //      weight: 4
        // });

       /*    msNavigationServiceProvider.saveItem('admin.new', {
            title: 'Workflow-management',
            icon:'icon-worker'
            state: 'app.createform.new',
             weight: 4
        });*/
    }
})();

angular.module("smartportal").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/overview.html","<div md-padding ng-init=\"loggedInUserName()\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"80\" flex-gt-md=\"50\"><ms-widget-front class=\"white-bg h-430\"><md-toolbar \nlayout=\"row\" class=\"white-bg md-primary-fg border-bottom\"><div class=\"md-toolbar-tools\"><span class=\"h3\">Overview\n</span></div></md-toolbar><md-content flex></md-content></ms-widget-front></ms-widget><ms-widget layout=\"column\" \nflex=\"100\" flex-gt-xs=\"80\" flex-gt-md=\"50\"><ms-widget-front class=\"white-bg h-430\"><md-toolbar layout=\"row\" \nclass=\"white-bg md-primary-fg border-bottom\"><div class=\"md-toolbar-tools\"><span class=\"h3\">Settings</span></div>\n</md-toolbar><md-content flex></md-content></ms-widget-front></ms-widget></div><div layout=\"row\"><ms-widget \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"80\" flex-gt-md=\"50\"><ms-widget-front class=\"white-bg h-430\"><md-toolbar \nlayout=\"row\" class=\"white-bg md-primary-fg border-bottom\"><div class=\"md-toolbar-tools\"><span class=\"h3\">\nLatest Activities</span></div></md-toolbar><md-content flex><md-list><md-list-item \nng-repeat=\"activity in homepageList.latestActivities\"><p ng-bind-html=\"activity.description\"></p></md-list-item>\n</md-list></md-content></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.TODAY\">TODAY</span></md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"QUICKPANEL.CHAT\">CHAT</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" \nng-controller=\"ChatTabController as vm\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</span></md-tab-label><md-tab-body><md-content class=\"activity-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/footer.html","<span class=\"pos-abs\" style=\"left: 40%\">Version 3.0.2 <span>&#9400; 2017 SmartDocs Inc. Powered by SmartDocs.</span>\n</span>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<style>.pos-abs {\r\n     position: absolute !important; }</style><div id=\"layout-vertical-navigation\" \nclass=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" class=\"md-menu-toolbar\" ui-view=\"toolbar\">\n</md-toolbar><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content>\n</div></div><script>\nif(window.localStorage[\'branddata\']!=\"null\"){\r\n	var backrounddata = JSON.parse(window.localStorage[\'branddata\']).appbackroundimage; \r\n	if(backrounddata !=null && backrounddata != \'undefined\'){	\r\n		$(\"#toolbar\").css(\'background-image\', \'url(\'+backrounddata+\')\');\r\n	}else{\r\n		$(\"#toolbar\").css(\'background-image\', \'url(\'+\"assets/images/2.jpg\"+\')\');\r\n	}\r\n}else{\r\n	$(\"#toolbar\").css(\'background-image\', \'url(\'+\"assets/images/2.jpg\"+\')\');\r\n}\n</script><fuse-footer class=\"below md-fuse-dark-800-bg\" flex layout=\"column\"><md-toolbar role=\"toolbar\"><div \nclass=\"mat-toolbar-layout pb-35\"><md-toolbar-row class=\"mat-toolbar-row\"><span class=\"footer-div pos-abs h4\">\nVersion 2.0.6<span>&#9400; 2020 SmartDocs Inc. Powered by SmartDocs.</span></span></md-toolbar-row></div></md-toolbar>\n</fuse-footer>");
$templateCache.put("app/core/theme-options/theme-options.html","<md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div class=\"ms-theme-options-list\" \nlayout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">Layout Style:</div><md-radio-group \nlayout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" ng-change=\"vm.updateLayoutStyle()\">\n<md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" ng-value=\"layoutStyle.value\"><div layout=\"column\" \nlayout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> <span class=\"text-center font-size-12 mt-8\">\n{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div><md-divider></md-divider><div \nclass=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group layout=\"row\" \nlayout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/main/Requests/customerMasterCreationForm.html","<div class=\"page-layout carded fullwidth scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\"><ms-widget-front class=\"white-bg\">\n<div flex=\"35\" class=\"md-padding\"><ul class=\"breadcrumb\"><li ng-click=\"requestCtrl.goToRequests()\">Requests</li><li>\nCustomerMasterCreationForm</li></ul></div><div layout=\"row\"><div ng-cloak flex=\"100\" class=\"scrollable\" ms-scroll>\n<md-content><md-tabs md-dynamic-height md-border-bottom><md-tab label=\"Header\"><md-content \nclass=\"md-padding scrollable\" ms-scroll><div layout=\"row\" layout-align=\"center center\"><div flex=\"70\" \nstyle=\"border: 1px solid #cccccc\"><form name=\"customerForm\" novalidate><md-toolbar class=\"orange-bg white-fg\"><div \nclass=\"md-toolbar-tools\"><h2>CUSTOMER - MASTER CREATION FORM</h2></div></md-toolbar><div layout=\"row\"><div flex=\"20\" \nlayout=\"row\" layout-align=\"end center\"><h3>Customer Code</h3></div><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"20\"><input type=\"text\" name=\"owner\" ng-model=\"form.customerCode\"></md-input-container><span \nflex=\"5\"></span><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Account Group</h3></div><span flex=\"5\">\n</span><md-input-container class=\"md-block\" flex=\"20\"><md-select ng-model=\"form.accountGroup\"><md-option \nng-repeat=\"AccountGroup in AccountGroups\" ng-value=\"AccountGroup\">{{AccountGroup}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>\nReconciliation Account</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\"><md-select \nng-model=\"form.organisation\"><md-option ng-repeat=\"salesOrganisation in salesOrganisations\" \nng-value=\"salesOrganisation\">{{salesOrganisation}}</md-option></md-select></md-input-container><span flex=\"5\"></span>\n<div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Type</h3></div><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"20\"><md-select ng-model=\"form.type\"><md-option ng-repeat=\"type in types\" ng-value=\"type\">\n{{type}}</md-option></md-select></md-input-container></div><div layout=\"row\"><div flex=\"20\" layout=\"row\" \nlayout-align=\"end center\"><h3>Industry Sector</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" \nflex=\"20\"><md-select ng-model=\"form.channel\"><md-option ng-repeat=\"distributionChannel in distributionChannels\" \nng-value=\"distributionChannel\">{{distributionChannel}}</md-option></md-select></md-input-container><span flex=\"5\">\n</span><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Customer Group</h3></div><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"20\"><md-select ng-model=\"form.conditionType\"><md-option \nng-repeat=\"customerGroup in customerGroups\" ng-value=\"customerGroup\">{{customerGroup}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"></div><span \nflex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\"><input type=\"text\" name=\"owner\" \nplaceholder=\"Name of the Firm\" ng-model=\"form.customerCo\"></md-input-container><span flex=\"5\"></span><div flex=\"20\" \nlayout=\"row\" layout-align=\"end center\"></div><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\">\n<input type=\"text\" name=\"owner\" placeholder=\"Address of the Firm\" ng-model=\"form.customerCo\"></md-input-container>\n</div><div layout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Billing Address</h3></div><span \nflex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\"><input type=\"text\" name=\"owner\" \nng-model=\"form.customerCo\"></md-input-container><span flex=\"5\"></span><div flex=\"20\" layout=\"row\" \nlayout-align=\"end center\"><h3>Delivery Address</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" \nflex=\"20\"><input type=\"text\" name=\"owner\" ng-model=\"form.customerCo\"></md-input-container></div><div layout=\"row\"><div \nflex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Post Code</h3></div><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"20\"><input type=\"text\" name=\"owner\" ng-model=\"form.customerCo\"></md-input-container><span \nflex=\"5\"></span><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Post Code</h3></div><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"20\"><input type=\"text\" name=\"owner\" ng-model=\"form.customerCo\">\n</md-input-container></div><div layout=\"row\"><span flex=\"50\"></span><div flex=\"20\" layout=\"row\" \nlayout-align=\"end center\"><h3>Distribution Channel</h3></div><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"20\"><md-select ng-model=\"form.distributionChannel\"><md-option \nng-repeat=\"CMCFDidtributionChannel in CMCFDidtributionChannels\" ng-value=\"CMCFDidtributionChannel\">\n{{CMCFDidtributionChannel}}</md-option></md-select></md-input-container></div><div layout=\"row\"><div flex=\"20\" \nlayout=\"row\" layout-align=\"end center\"><h3>Payment Terms</h3></div><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"70\"><md-select ng-model=\"form.paymentTerm\"><md-option ng-repeat=\"paymentTerm in paymentTerms\" \nng-value=\"paymentTerm\">{{paymentTerm}}</md-option></md-select></md-input-container></div><div layout=\"row\"><div \nflex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Sales Area</h3></div><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"20\"><md-select ng-model=\"form.salesArea\"><md-option ng-repeat=\"salesArea in salesAreas\" \nng-value=\"salesArea\">{{salesArea}}</md-option></md-select></md-input-container><span flex=\"5\"></span><div flex=\"20\" \nlayout=\"row\" layout-align=\"end center\"><h3>Sales Office</h3></div><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"20\"><md-select ng-model=\"form.salesOffice\"><md-option ng-repeat=\"salesOffice in salesOffices\" \nng-value=\"salesOffice\">{{salesOffice}}</md-option></md-select></md-input-container></div><div layout=\"row\"><div \nflex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Customer Status Group</h3></div><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"20\"><md-select ng-model=\"form.customerStatusGroup\"><md-option \nng-repeat=\"salesArea in salesAreas\" ng-value=\"salesArea\">{{salesArea}}</md-option></md-select></md-input-container>\n<span flex=\"5\"></span><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Order Currency</h3></div><span \nflex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\"><input type=\"text\" name=\"owner\" \nng-model=\"form.orderCurrency\"></md-input-container></div><div layout=\"row\"><div flex=\"20\" layout=\"row\" \nlayout-align=\"end center\"><h3>Taxes</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"70\">\n<md-select ng-model=\"form.tax\"><md-option ng-repeat=\"tax in taxes\" ng-value=\"tax\">{{tax}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-align=\"center center\"><h4>\nNOTE: PLEASE ATTACH COPY OF TAX EXPEMTION / CONCESSION ISSUED BY THE RELEVANT DEPARTMENT</h4></div><div layout=\"row\">\n<div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Excise Registration No</h3></div><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"70\"><input type=\"text\" name=\"owner\" ng-model=\"form.exsiseRegistrationNo\">\n</md-input-container></div><div layout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>\nExcise Range and DIvision</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"70\"><input \ntype=\"text\" name=\"owner\" ng-model=\"form.exciseRangeandDivision\"></md-input-container></div><div layout=\"row\"><div \nflex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>VAT / TIN</h3></div><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"70\"><input type=\"text\" name=\"owner\" ng-model=\"form.vatOrTin\"></md-input-container></div><div \nlayout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Service Tax</h3></div><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"70\"><input type=\"text\" name=\"owner\" ng-model=\"form.serviceTax\">\n</md-input-container></div><div layout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>PAN No</h3>\n</div><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"70\"><input type=\"text\" name=\"owner\" \nng-model=\"form.panNo\"></md-input-container></div><div layout=\"row\"><div flex=\"20\" layout=\"row\" \nlayout-align=\"end center\"><h3>SSI Registration No</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" \nflex=\"70\"><input type=\"text\" name=\"owner\" ng-model=\"form.ssiRegistrationNo\"></md-input-container></div><div \nlayout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Year of Establishment</h3></div><span flex=\"5\">\n</span><md-input-container class=\"md-block\" flex=\"20\"><input type=\"text\" name=\"owner\" \nng-model=\"form.establishmentYear\"></md-input-container><span flex=\"5\"></span><div flex=\"20\" layout=\"row\" \nlayout-align=\"end center\"><h3>Trade License No</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" \nflex=\"20\"><input type=\"text\" name=\"owner\" ng-model=\"form.tradeLicenseNo\"></md-input-container></div><md-toolbar \nclass=\"md-primary\"><div class=\"md-toolbar-tools\"><div layout=\"row\" layout-align=\"end center\" flex><div \nclass=\"md-padding\"><md-button type=\"submit\" class=\"md-warn md-raised\" ng-click=\"submitForm(form)\">Submit</md-button>\n<md-button type=\"button\" class=\"green-bg md-raised\" ng-click=\"\">Cancel</md-button></div></div></div></md-toolbar>\n</form></div></div></md-content></md-tab><md-tab label=\"Line Items\"><md-content class=\"md-padding\"><div layout=\"row\" \nlayout-align=\"center center\"><h2>Line Items data</h2></div></md-content></md-tab><md-tab label=\"Comments\"><md-content \nclass=\"md-padding\"><h1 class=\"md-display-2\">Comments Tab</h1><p>\nInteger turpis erat, porttitor vitae mi faucibus, laoreet interdum tellus. Curabitur posuere molestie dictum. Morbi eget congue risus, quis rhoncus quam. Suspendisse vitae hendrerit erat, at posuere mi. Cras eu fermentum nunc. Sed id ante eu orci commodo volutpat non ac est. Praesent ligula diam, congue eu enim scelerisque, finibus commodo lectus.\n</p></md-content></md-tab><md-tab label=\"Attachments\"><md-content class=\"md-padding\"><h1 class=\"md-display-2\">\nAttachments Tab</h1><p>\nInteger turpis erat, porttitor vitae mi faucibus, laoreet interdum tellus. Curabitur posuere molestie dictum. Morbi eget congue risus, quis rhoncus quam. Suspendisse vitae hendrerit erat, at posuere mi. Cras eu fermentum nunc. Sed id ante eu orci commodo volutpat non ac est. Praesent ligula diam, congue eu enim scelerisque, finibus commodo lectus.\n</p></md-content></md-tab></md-tabs></md-content></div></div></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/Requests/customerPriceMasterForm.html","<div class=\"page-layout carded fullwidth scrollable\" layout=\"column\" flex ms-scroll md-dynamic-height><div \nclass=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\">\n<ms-widget-front class=\"white-bg\"><div flex=\"30\" class=\"md-padding\"><ul class=\"breadcrumb\"><li \nng-click=\"requestCtrl.goToRequests()\">Requests</li><li>CustomerPriceMasterForm</li></ul></div><div layout=\"row\"><div \nng-cloak flex=\"100\" class=\"scrollable\" ms-scroll><md-content><md-tabs md-dynamic-height md-border-bottom><md-tab \nlabel=\"Header\"><md-content class=\"md-padding scrollable\" ms-scroll><div layout=\"row\" layout-align=\"center center\"><div \nflex=\"70\" style=\"border: 1px solid #cccccc\"><form name=\"customerForm\" novalidate><div layout=\"row\"><div flex=\"20\" \nlayout=\"row\" layout-align=\"end center\"><h3>Customer Code</h3></div><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"20\"><input type=\"text\" name=\"owner\" ng-model=\"form.customerCode\"></md-input-container><span \nflex=\"5\"></span><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Account Group</h3></div><span flex=\"5\">\n</span><md-input-container class=\"md-block\" flex=\"20\"><md-select ng-model=\"form.accountGroup\"><md-option \nng-repeat=\"AccountGroup in AccountGroups\" ng-value=\"AccountGroup\">{{AccountGroup}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Customer Name:\n</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"70\"><input type=\"text\" name=\"owner\" \nng-model=\"form.customerName\"></md-input-container></div><div layout=\"row\"><div flex=\"20\" layout=\"row\" \nlayout-align=\"end center\"><h3>Sales Organisation:</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" \nflex=\"20\"><md-select ng-model=\"form.organisation\"><md-option ng-repeat=\"salesOrganisation in salesOrganisations\" \nng-value=\"salesOrganisation\">{{salesOrganisation}}</md-option></md-select></md-input-container><span flex=\"5\"></span>\n<div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Type</h3></div><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"20\"><md-select ng-model=\"form.type\"><md-option ng-repeat=\"type in types\" ng-value=\"type\">\n{{type}}</md-option></md-select></md-input-container></div><div layout=\"row\"><div flex=\"20\" layout=\"row\" \nlayout-align=\"end center\"><h3>Distribution Channel:</h3></div><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"20\"><md-select ng-model=\"form.channel\"><md-option \nng-repeat=\"distributionChannel in distributionChannels\" ng-value=\"distributionChannel\">{{distributionChannel}}\n</md-option></md-select></md-input-container><span flex=\"5\"></span><div flex=\"20\" layout=\"row\" \nlayout-align=\"end center\"><h3>Conditions Type:</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" \nflex=\"20\"><md-select ng-model=\"form.conditionType\"><md-option ng-repeat=\"conditionType in conditionTypes\" \nng-value=\"conditionType\">{{conditionType}}</md-option></md-select></md-input-container></div><md-toolbar \nclass=\"md-primary\"><div class=\"md-toolbar-tools\"><div layout=\"row\" layout-align=\"end center\" flex><div \nclass=\"md-padding\"><md-button type=\"submit\" class=\"md-warn md-raised\" ng-click=\"submitForm(form)\">Submit</md-button>\n<md-button type=\"button\" class=\"green-bg md-raised\" ng-click=\"\">Cancel</md-button></div></div></div></md-toolbar>\n</form></div></div></md-content></md-tab><md-tab label=\"Line Items\"><md-content class=\"md-padding\"><div layout=\"row\" \nlayout-align=\"center center\"><div flex=\"90\" style=\"border: 1px solid #cccccc\"><md-toolbar \nstyle=\"background-color:rgb(41, 66, 112)\" class=\"white-fg\"><div class=\"md-toolbar-tools\"><div layout=\"row\" flex=\"100\" \nlayout-align=\"center center\"><div flex=\"5\"><p>S.No</p></div><div flex=\"10\"><p>Material Code</p></div><div flex=\"10\"><p>\nNew Price</p></div><div flex=\"10\"><p>Old Price</p></div><div flex=\"10\"><p>Price Var.</p></div><div flex=\"10\"><p>Current\n</p></div><div flex=\"10\"><p>Price per 1000 or EA</p></div><span flex=\"5\"></span><div flex=\"10\"><p>Base Unit of Measure\n</p></div><div flex=\"10\"><p>Valid From</p></div><div flex=\"10\"><p>Valid To</p></div></div></div></md-toolbar><form \nname=\"lineItemsForm\" novalidate><div layout=\"row\" layout-align=\"center center\" ng-repeat=\"row in rows\"><div flex=\"5\">\n<h3 class=\"md-padding\">{{row}}</h3></div><div flex=\"10\" class=\"md-block md-padding\"><md-input-container \nclass=\"md-block\"><input type=\"text\" name=\"owner\" ng-model=\"form.materialCode\"></md-input-container></div><div \nflex=\"10\"><md-input-container class=\"md-block md-padding\"><input type=\"text\" name=\"owner\" ng-model=\"form.newPrice\">\n</md-input-container></div><div flex=\"10\"><md-input-container class=\"md-block md-padding\"><input type=\"text\" \nname=\"owner\" ng-model=\"form.oldPrice\"></md-input-container></div><div flex=\"10\"><md-input-container class=\"md-block\">\n<md-select ng-model=\"form.priceVar\"><md-option ng-repeat=\"priceVar in priceVars\" ng-value=\"priceVar\">{{priceVar}}\n</md-option></md-select></md-input-container></div><div flex=\"10\"><md-input-container class=\"md-block md-padding\">\n<input type=\"text\" name=\"owner\" ng-model=\"form.current\"></md-input-container></div><div flex=\"15\"><md-input-container \nclass=\"md-block md-padding\"><input type=\"text\" name=\"owner\" ng-model=\"form.pricePer\"></md-input-container></div><div \nflex=\"10\"><md-input-container class=\"md-block md-padding\"><input type=\"text\" name=\"owner\" ng-model=\"form.baseUnit\">\n</md-input-container></div><div flex=\"10\"><md-input-container class=\"md-block md-padding\"><input type=\"text\" \nname=\"owner\" ng-model=\"form.validFrom\"></md-input-container></div><div flex=\"10\"><md-input-container \nclass=\"md-block md-padding\"><input type=\"text\" name=\"owner\" ng-model=\"form.validTo\"></md-input-container></div></div>\n<md-toolbar class=\"md-primary\"><div class=\"md-toolbar-tools\"><div layout=\"row\" layout-align=\"end center\" flex><div \nclass=\"md-padding\"><md-button type=\"submit\" class=\"md-warn md-raised\" ng-click=\"submitForm(form)\">Submit</md-button>\n<md-button type=\"button\" class=\"green-bg md-raised\" ng-click=\"\">Cancel</md-button></div></div></div></md-toolbar>\n</form></div></div></md-content></md-tab><md-tab label=\"Comments\"><md-content class=\"md-padding\"><h1 \nclass=\"md-display-2\">Comments Tab</h1><p>\nInteger turpis erat, porttitor vitae mi faucibus, laoreet interdum tellus. Curabitur posuere molestie dictum. Morbi eget congue risus, quis rhoncus quam. Suspendisse vitae hendrerit erat, at posuere mi. Cras eu fermentum nunc. Sed id ante eu orci commodo volutpat non ac est. Praesent ligula diam, congue eu enim scelerisque, finibus commodo lectus.\n</p></md-content></md-tab><md-tab label=\"Attachments\"><md-content class=\"md-padding\"><h1 class=\"md-display-2\">\nAttachments Tab</h1><p>\nInteger turpis erat, porttitor vitae mi faucibus, laoreet interdum tellus. Curabitur posuere molestie dictum. Morbi eget congue risus, quis rhoncus quam. Suspendisse vitae hendrerit erat, at posuere mi. Cras eu fermentum nunc. Sed id ante eu orci commodo volutpat non ac est. Praesent ligula diam, congue eu enim scelerisque, finibus commodo lectus.\n</p></md-content></md-tab></md-tabs></md-content></div></div></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/Requests/requestUploadForm.html","<md-dialog flex=\"40\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create Request</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><form name=\"requestform\" novalidate layout=\"column\"><div \nlayout=\"row\"><div flex=\"30\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>Name</b></span></div><span \nflex=\"10\"></span><md-input-container flex=\"45\" class=\"md-block\" layout=\"column\" layout-align=\"space-around start\" \nstyle=\"padding-bottom: 0px !important; padding-top: 0px !important\"><input type=\"text\" name=\"name\" \nng-model=\"request.name\" placeholder=\"Name\" required></md-input-container></div><div layout=\"row\"><div flex=\"30\" \nlayout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>Description</b></span></div><span flex=\"10\"></span>\n<md-input-container flex=\"45\" class=\"md-block\" layout=\"column\" layout-align=\"space-around start\" \nstyle=\"padding-bottom: 0px !important; padding-top: 0px !important\"><input type=\"text\" name=\"description\" \nng-model=\"request.description\" placeholder=\"Description\" required></md-input-container></div><div layout=\"row\"><div \nflex=\"30\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>Header File</b></span></div><span flex=\"10\">\n</span><div flex=\"45\" layout=\"column\" layout-align=\"center start\"><input class=\"ng-hide\" id=\"headerFileUpload\" \nname=\"headerFileUpload\" type=\"file\" onchange=\"angular.element(this).scope().setHeaderFile(this)\"><label \nfor=\"headerFileUpload\" class=\"md-button md-raised md-accent\">Upload</label></div></div><div \nng-repeat=\"file in headerfiles.slice(0)\" layout=\"row\" layout-align=\"center center\"><span class=\"md-warn\">\n{{file.webkitRelativePath || file.name}}</span> (<span ng-switch=\"file.size > 1024*1024\"> <span ng-switch-when=\"true\">\n{{file.size / 1024 / 1024 | number:2}} MB</span> <span ng-switch-default>{{file.size / 1024 | number:2}} kB</span> \n</span>)</div><div layout=\"row\"><div flex=\"30\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>\nLineitem File</b></span></div><span flex=\"10\"></span><div flex=\"45\" layout=\"column\" layout-align=\"center start\"><input \nclass=\"ng-hide\" id=\"LineItemFileUpload\" name=\"LineItemFileUpload\" type=\"file\" \nonchange=\"angular.element(this).scope().setLineItemFile(this)\"><label for=\"LineItemFileUpload\" \nclass=\"md-button md-raised md-accent\">Upload</label></div></div><div><div ng-repeat=\"file in lineitemfiles.slice(0)\" \nlayout=\"row\" layout-align=\"center center\"><span class=\"md-warn\">{{file.webkitRelativePath || file.name}}</span> (<span \nng-switch=\"file.size > 1024*1024\"> <span ng-switch-when=\"true\">{{file.size / 1024 / 1024 | number:2}} MB</span> <span \nng-switch-default>{{file.size / 1024 | number:2}} kB</span> </span>)</div></div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button \nng-click=\"uploadRequestForm(request)\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Requests/requests.content.html","<div class=\"page-layout carded fullwidth scrollable\" layout=\"column\" flex ms-scroll md-dynamic-height><div \nclass=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" layout=\"row\"><ms-form-wizard \nflex><md-tabs md-dynamic-height md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"headerForm.$invalid\">1\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"headerForm.$valid\"><i class=\"icon-check s16\"></i> \n</span><span class=\"ms-form-wizard-step-text\">Header</span></span></md-tab-label><md-tab-body><md-content \nclass=\"md-padding scrollable\" ms-scroll><div layout=\"row\" layout-align=\"center center\"><div flex=\"70\" \nstyle=\"border: 1px solid #cccccc\"><form name=\"headerForm\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div \nng-bind-html=\"currentFormHeader\" compile-template></div></form></div></div></md-content></md-tab-body></md-tab><md-tab \nng-disabled=\"headerForm.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"lineitemForm.$invalid\">2</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"lineitemForm.$valid\"><i class=\"icon-check s16\"></i> </span><span\n class=\"ms-form-wizard-step-text\">Lineitem</span></span></md-tab-label><md-tab-body><form name=\"lineitemForm\" \nms-form-wizard-form novalidate><div ng-bind-html=\"currentFormLineitem\" compile-template></div></form></md-tab-body>\n</md-tab><md-tab ng-disabled=\"headerForm.$invalid  || lineitemForm.$invalid\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">3\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i>\n </span><span class=\"ms-form-wizard-step-text\">Comments</span></span></md-tab-label><md-tab-body><form \nname=\"wizardStep3\" ms-form-wizard-form novalidate><md-input-container class=\"md-block\"><label>Add comment</label>\n<textarea ng-model=\"vm.formWizard.address\" columns=\"1\" md-maxlength=\"150\" rows=\"5\" required></textarea><div \nng-messages=\"wizardStep3.address.$error\" ng-show=\"wizardStep3.address.$touched\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Address field is required.</span></div><div ng-message=\"md-maxlength\"><span>\nAddress can\'t be longer than 150 characters.</span></div></div></md-input-container></form></md-tab-body></md-tab>\n<md-tab ng-disabled=\"headerForm.$invalid || lineitemForm.$invalid || wizardStep3.$invalid\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep4.$invalid\">4\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep4.$valid\"><i class=\"icon-check s16\"></i>\n </span><span class=\"ms-form-wizard-step-text\">Attachment</span></span></md-tab-label><md-tab-body><form \nname=\"wizardStep4\" ms-form-wizard-form novalidate><div layout=\"row\" layout-align=\"center center\" flex=\"100\"><div><div>\n<input class=\"ng-hide\" id=\"attachmentUpload\" name=\"attachmentUpload\" type=\"file\" \nonchange=\"angular.element(this).scope().setAttachmentFile(this)\"><label for=\"attachmentUpload\" \nclass=\"md-button md-raised\">Upload files</label></div></div><div flex=\"10\"></div><div \nng-repeat=\"file in attachmentfiles.slice(0)\" layout=\"row\" layout-align=\"center center\"><span class=\"md-warn\">\n{{file.webkitRelativePath || file.name}}</span> (<span ng-switch=\"file.size > 1024*1024\"> <span ng-switch-when=\"true\">\n{{file.size / 1024 / 1024 | number:2}} MB</span> <span ng-switch-default>{{file.size / 1024 | number:2}} kB</span> \n</span>)</div></div></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" \nng-disabled=\"msWizard.isFirstStep()\">Previous</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\">Next</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"vm.sendForm(); msWizard.resetForm();\" ng-show=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.formsIncomplete()\">Submit</md-button></div></ms-form-wizard></ms-widget></div></div>");
$templateCache.put("app/main/Requests/requestsOverviewPage.html","<div class=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap ng-init=\"requestCtrl.getRequestForms()\"><md-button \nflow-btn class=\"md-fab md-mini grey-700-bg md-fab-bottom-right\" aria-label=\"Create Request\" \nng-click=\"createRequest($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">\nCreate Request</md-tooltip></md-button><ms-widget><ms-widget-front class=\"white-bg\"><div class=\"md-title md-padding\">\nRequests</div><div layout=\"row\" layout-wrap><div ng-repeat=\"form in forms\" flex=\"100\" flex-gt-xs=\"25\" flex-gt-md=\"20\">\n<a ng-click=\"selectForm(form)\"><md-card md-theme=\"{{getAnotherColor($index)}}\" md-theme-watch><div class=\"info\" \nlayout=\"column\" layout-align=\"space-between\" flex><div class=\"white-fg md-padding\" layout=\"row\" \nlayout-align=\"center center\" ng-style=\"{\'height\':\'150px\'}\"><md-icon md-font-icon=\"{{getAnotherIcon($index)}}\" \nclass=\"s64\"></md-icon></div><div><md-divider></md-divider><div class=\"h4 p-8 white-bg black-fg\" layout=\"column\" \nlayout-align=\"center center\">{{form.name}}</div></div></div></md-card></a></div></div></ms-widget-front></ms-widget>\n</div>");
$templateCache.put("app/main/Requests/vendorMasterCreationForm.html","<div class=\"page-layout carded fullwidth scrollable\" layout=\"column\" flex ms-scroll md-dynamic-height><div \nclass=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\">\n<ms-widget-front class=\"white-bg\"><div flex=\"30\" class=\"md-padding\"><ul class=\"breadcrumb\"><li \nng-click=\"requestCtrl.goToRequests()\">Requests</li><li>VendorMasterCreationForm</li></ul></div><div layout=\"row\"><div \nng-cloak flex=\"100\" class=\"scrollable\" ms-scroll><md-content><md-tabs md-dynamic-height md-border-bottom><md-tab \nlabel=\"Header\"><md-content class=\"md-padding scrollable\" ms-scroll><div layout=\"row\" layout-align=\"center center\"><div \nflex=\"70\" style=\"border: 1px solid #cccccc\"><form name=\"customerForm\" novalidate><md-toolbar \nclass=\"orange-bg white-fg\"><div class=\"md-toolbar-tools\"><h2>VENDOR - MASTER CREATION FORM</h2></div></md-toolbar><div \nlayout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Vendor Code</h3></div><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"20\"><input type=\"text\" name=\"owner\" ng-model=\"form.customerCode\">\n</md-input-container><span flex=\"5\"></span><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Account Group</h3>\n</div><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\"><md-select ng-model=\"form.accountGroup\">\n<md-option ng-repeat=\"AccountGroup in AccountGroups\" ng-value=\"AccountGroup\">{{AccountGroup}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>\nReconciliation Account</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\"><md-select \nng-model=\"form.organisation\"><md-option ng-repeat=\"salesOrganisation in salesOrganisations\" \nng-value=\"salesOrganisation\">{{salesOrganisation}}</md-option></md-select></md-input-container><span flex=\"5\"></span>\n<div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Type</h3></div><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"20\"><md-select ng-model=\"form.type\"><md-option ng-repeat=\"type in types\" ng-value=\"type\">\n{{type}}</md-option></md-select></md-input-container></div><div layout=\"row\"><div flex=\"20\" layout=\"row\" \nlayout-align=\"end center\"><h3>Industry Sector</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" \nflex=\"20\"><md-select ng-model=\"form.channel\"><md-option ng-repeat=\"distributionChannel in distributionChannels\" \nng-value=\"distributionChannel\">{{distributionChannel}}</md-option></md-select></md-input-container><span flex=\"5\">\n</span><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Customer Group</h3></div><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"20\"><md-select ng-model=\"form.conditionType\"><md-option \nng-repeat=\"customerGroup in customerGroups\" ng-value=\"customerGroup\">{{customerGroup}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"></div><span \nflex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\"><input type=\"text\" name=\"owner\" \nplaceholder=\"Name of the Firm\" ng-model=\"form.customerCo\"></md-input-container><span flex=\"5\"></span><div flex=\"20\" \nlayout=\"row\" layout-align=\"end center\"></div><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\">\n<input type=\"text\" name=\"owner\" placeholder=\"Address of the Firm\" ng-model=\"form.customerCo\"></md-input-container>\n</div><div layout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Billing Address</h3></div><span \nflex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\"><input type=\"text\" name=\"owner\" \nng-model=\"form.customerCo\"></md-input-container><span flex=\"5\"></span><div flex=\"20\" layout=\"row\" \nlayout-align=\"end center\"><h3>Delivery Address</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" \nflex=\"20\"><input type=\"text\" name=\"owner\" ng-model=\"form.customerCo\"></md-input-container></div><div layout=\"row\"><div \nflex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>If ISO Certified</h3></div><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"70\"><input type=\"text\" name=\"owner\" ng-model=\"form.ISOCertified\">\n</md-input-container></div><div layout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Payment Terms\n</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"70\"><md-select ng-model=\"form.paymentTerm\">\n<md-option ng-repeat=\"paymentTerm in paymentTerms\" ng-value=\"paymentTerm\">{{paymentTerm}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>\nName & Address of Branch</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"70\"><input \ntype=\"text\" name=\"owner\" ng-model=\"form.branchAddress\"></md-input-container></div><div layout=\"row\"><div flex=\"20\" \nlayout=\"row\" layout-align=\"end center\"><h3>RTGS Code</h3></div><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"20\"><input type=\"text\" name=\"owner\" ng-model=\"form.RTGSCode\"></md-input-container><span \nflex=\"5\"></span><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>IFSC Code</h3></div><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"20\"><input type=\"text\" name=\"owner\" ng-model=\"form.IFSCCode\">\n</md-input-container></div><div layout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>MICR No</h3>\n</div><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\"><input type=\"text\" name=\"owner\" \nng-model=\"form.MICRNo\"></md-input-container><span flex=\"5\"></span><div flex=\"20\" layout=\"row\" \nlayout-align=\"end center\"><h3>Order Currency</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" \nflex=\"20\"><input type=\"text\" name=\"owner\" ng-model=\"form.orderCrrency\"></md-input-container></div><div layout=\"row\">\n<div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Taxes</h3></div><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"70\"><md-select ng-model=\"form.tax\"><md-option ng-repeat=\"tax in taxes\" ng-value=\"tax\">{{tax}}\n</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"center center\"><h4>\nNOTE: PLEASE ATTACH COPY OF TAX EXPEMTION / CONCESSION ISSUED BY THE RELEVANT DEPARTMENT</h4></div><div layout=\"row\">\n<div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Excise Registration No</h3></div><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"70\"><input type=\"text\" name=\"owner\" ng-model=\"form.exsiseRegistrationNo\">\n</md-input-container></div><div layout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>\nExcise Range and DIvision</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"70\"><input \ntype=\"text\" name=\"owner\" ng-model=\"form.exciseRangeandDivision\"></md-input-container></div><div layout=\"row\"><div \nflex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>VAT / TIN</h3></div><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"70\"><input type=\"text\" name=\"owner\" ng-model=\"form.vatOrTin\"></md-input-container></div><div \nlayout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Service Tax</h3></div><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"70\"><input type=\"text\" name=\"owner\" ng-model=\"form.serviceTax\">\n</md-input-container></div><div layout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>PAN No</h3>\n</div><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"70\"><input type=\"text\" name=\"owner\" \nng-model=\"form.panNo\"></md-input-container></div><div layout=\"row\"><div flex=\"20\" layout=\"row\" \nlayout-align=\"end center\"><h3>SSI Registration No</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" \nflex=\"70\"><input type=\"text\" name=\"owner\" ng-model=\"form.ssiRegistrationNo\"></md-input-container></div><div \nlayout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Year of Establishment</h3></div><span flex=\"5\">\n</span><md-input-container class=\"md-block\" flex=\"20\"><input type=\"text\" name=\"owner\" \nng-model=\"form.establishmentYear\"></md-input-container><span flex=\"5\"></span><div flex=\"20\" layout=\"row\" \nlayout-align=\"end center\"><h3>Trade License No</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" \nflex=\"20\"><input type=\"text\" name=\"owner\" ng-model=\"form.tradeLicenseNo\"></md-input-container></div><md-toolbar \nclass=\"md-primary\"><div class=\"md-toolbar-tools\"><div layout=\"row\" layout-align=\"end center\" flex><div \nclass=\"md-padding\"><md-button class=\"md-warn md-raised\" ng-click=\"\">Submit</md-button><md-button \nclass=\"green-bg md-raised\" ng-click=\"\">Cancel</md-button></div></div></div></md-toolbar></form></div></div>\n</md-content></md-tab><md-tab label=\"Line Items\"><md-content class=\"md-padding\"><div layout=\"row\" \nlayout-align=\"center center\"></div></md-content></md-tab><md-tab label=\"Comments\"><md-content class=\"md-padding\"><h1 \nclass=\"md-display-2\">Comments Tab</h1><p>\nInteger turpis erat, porttitor vitae mi faucibus, laoreet interdum tellus. Curabitur posuere molestie dictum. Morbi eget congue risus, quis rhoncus quam. Suspendisse vitae hendrerit erat, at posuere mi. Cras eu fermentum nunc. Sed id ante eu orci commodo volutpat non ac est. Praesent ligula diam, congue eu enim scelerisque, finibus commodo lectus.\n</p></md-content></md-tab><md-tab label=\"Attachments\"><md-content class=\"md-padding\"><h1 class=\"md-display-2\">\nAttachments Tab</h1><p>\nInteger turpis erat, porttitor vitae mi faucibus, laoreet interdum tellus. Curabitur posuere molestie dictum. Morbi eget congue risus, quis rhoncus quam. Suspendisse vitae hendrerit erat, at posuere mi. Cras eu fermentum nunc. Sed id ante eu orci commodo volutpat non ac est. Praesent ligula diam, congue eu enim scelerisque, finibus commodo lectus.\n</p></md-content></md-tab></md-tabs></md-content></div></div></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/Requests/vendorPriceMasterForm.html","<div class=\"page-layout carded fullwidth scrollable\" layout=\"column\" flex ms-scroll md-dynamic-height><div \nclass=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\">\n<ms-widget-front class=\"white-bg\"><div flex=\"30\" class=\"md-padding\"><ul class=\"breadcrumb\"><li \nng-click=\"requestCtrl.goToRequests()\">Requests</li><li>VendoPriceMasterForm</li></ul></div><div layout=\"row\"><div \nng-cloak flex=\"100\" class=\"scrollable\" ms-scroll><md-content><md-tabs md-dynamic-height md-border-bottom><md-tab \nlabel=\"Header\"><md-content class=\"md-padding scrollable\" ms-scroll><div layout=\"row\" layout-align=\"center center\"><div \nflex=\"70\" style=\"border: 1px solid #cccccc\"><md-toolbar class=\"orange-bg white-fg\"><div class=\"md-toolbar-tools\"><h2>\nVENDOR - PRICE MASTER FORM (Info Record)</h2></div></md-toolbar><div layout=\"row\"><div flex=\"20\" layout=\"row\" \nlayout-align=\"end center\"><h3>Vendor Code</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" \nflex=\"20\"><input type=\"text\" name=\"owner\" ng-model=\"file.creat\"></md-input-container><span flex=\"5\"></span><div \nflex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Account Group</h3></div><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"20\"><md-select ng-model=\"abc\"><md-option ng-repeat=\"AccountGroup in AccountGroups\" \nng-value=\"AccountGroup\">{{AccountGroup}}</md-option></md-select></md-input-container></div><div layout=\"row\"><div \nflex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Vendor Name:</h3></div><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"70\"><input type=\"text\" name=\"owner\" ng-model=\"file.creator\"></md-input-container></div><div \nlayout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Purchase Org:</h3></div><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"20\"><md-select ng-model=\"ab\"><md-option \nng-repeat=\"salesOrganisation in salesOrganisations\" ng-value=\"salesOrganisation\">{{salesOrganisation}}</md-option>\n</md-select></md-input-container><span flex=\"5\"></span><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Type\n</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\"><md-select ng-model=\"abf\"><md-option \nng-repeat=\"type in types\" ng-value=\"type\">{{type}}</md-option></md-select></md-input-container></div><div layout=\"row\">\n<div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Plant:</h3></div><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"20\"><md-select ng-model=\"abcd\"><md-option \nng-repeat=\"distributionChannel in distributionChannels\" ng-value=\"distributionChannel\">{{distributionChannel}}\n</md-option></md-select></md-input-container><span flex=\"5\"></span><div flex=\"20\" layout=\"row\" \nlayout-align=\"end center\"><h3>Info Category:</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" \nflex=\"20\"><md-select ng-model=\"abcd\"><md-option ng-repeat=\"conditionType in conditionTypes\" ng-value=\"conditionType\">\n{{conditionType}}</md-option></md-select></md-input-container></div><md-toolbar class=\"md-primary\"><div \nclass=\"md-toolbar-tools\"><div layout=\"row\" layout-align=\"end center\" flex><div class=\"md-padding\"><md-button \nclass=\"md-warn md-raised\" ng-click=\"\">Submit</md-button><md-button class=\"green-bg md-raised\" ng-click=\"\">Cancel\n</md-button></div></div></div></md-toolbar></div></div></md-content></md-tab><md-tab label=\"Line Items\"><md-content \nclass=\"md-padding\"><div layout=\"row\" layout-align=\"center center\"><div flex=\"90\" style=\"border: 1px solid #cccccc\">\n<md-toolbar style=\"background-color:rgb(41, 66, 112)\" class=\"white-fg\"><div class=\"md-toolbar-tools\"><div layout=\"row\" \nflex=\"100\" layout-align=\"center center\"><div flex=\"5\" class=\"md-padding\"><p>S.No</p></div><div flex=\"10\" \nclass=\"md-padding\"><p>Material Code</p></div><div flex=\"10\" class=\"md-padding\"><p>New Price</p></div><div flex=\"10\" \nclass=\"md-padding\"><p>Old Price</p></div><div flex=\"10\" class=\"md-padding\"><p>Price Var.</p></div><div flex=\"10\" \nclass=\"md-padding\"><p>Current</p></div><div flex=\"10\"><p>Price per 1000 or EA</p></div><span flex=\"5\"></span><div \nflex=\"10\"><p>Base Unit of Measure</p></div><div flex=\"10\"><p>Valid From</p></div><div flex=\"10\" class=\"md-padding\"><p>\nValid To</p></div></div></div></md-toolbar><form name=\"lineItemsForm\" novalidate><div layout=\"row\" \nlayout-align=\"center center\" ng-repeat=\"row in rows\"><div flex=\"5\"><h3 class=\"md-padding\">{{row}}</h3></div><div \nflex=\"10\" class=\"md-block md-padding\"><md-input-container class=\"md-block\" style=\"margin: 0px\"><input type=\"text\" \nname=\"owner\" ng-model=\"form.materialCode\"></md-input-container></div><div flex=\"10\"><md-input-container \nclass=\"md-block md-padding\" style=\"margin: 0px\"><input type=\"text\" name=\"owner\" ng-model=\"form.newPrice\">\n</md-input-container></div><div flex=\"10\"><md-input-container class=\"md-block md-padding\" style=\"margin: 0px\"><input \ntype=\"text\" name=\"owner\" ng-model=\"form.oldPrice\"></md-input-container></div><div flex=\"10\"><md-input-container \nclass=\"md-block\" style=\"margin: 0px\"><md-select ng-model=\"form.priceVar\"><md-option ng-repeat=\"priceVar in priceVars\" \nng-value=\"priceVar\">{{priceVar}}</md-option></md-select></md-input-container></div><div flex=\"10\"><md-input-container \nclass=\"md-block md-padding\" style=\"margin: 0px\"><input type=\"text\" name=\"owner\" ng-model=\"form.current\">\n</md-input-container></div><div flex=\"15\"><md-input-container class=\"md-block md-padding\" style=\"margin: 0px\"><input \ntype=\"text\" name=\"owner\" ng-model=\"form.pricePer\"></md-input-container></div><div flex=\"10\"><md-input-container \nclass=\"md-block md-padding\" style=\"margin: 0px\"><input type=\"text\" name=\"owner\" ng-model=\"form.baseUnit\">\n</md-input-container></div><div flex=\"10\"><md-input-container class=\"md-block md-padding\" style=\"margin: 0px\"><input \ntype=\"text\" name=\"owner\" ng-model=\"form.validFrom\"></md-input-container></div><div flex=\"10\"><md-input-container \nclass=\"md-block md-padding\" style=\"margin: 0px\"><input type=\"text\" name=\"owner\" ng-model=\"form.validTo\">\n</md-input-container></div></div><md-toolbar class=\"md-primary\"><div class=\"md-toolbar-tools\"><div layout=\"row\" \nlayout-align=\"end center\" flex><div class=\"md-padding\"><md-button type=\"submit\" class=\"md-warn md-raised\" \nng-click=\"submitForm(form)\">Submit</md-button><md-button type=\"button\" class=\"green-bg md-raised\" ng-click=\"\">Cancel\n</md-button></div></div></div></md-toolbar></form></div></div></md-content></md-tab><md-tab label=\"Comments\">\n<md-content class=\"md-padding\"><h1 class=\"md-display-2\">Comments Tab</h1><p>\nInteger turpis erat, porttitor vitae mi faucibus, laoreet interdum tellus. Curabitur posuere molestie dictum. Morbi eget congue risus, quis rhoncus quam. Suspendisse vitae hendrerit erat, at posuere mi. Cras eu fermentum nunc. Sed id ante eu orci commodo volutpat non ac est. Praesent ligula diam, congue eu enim scelerisque, finibus commodo lectus.\n</p></md-content></md-tab><md-tab label=\"Attachments\"><md-content class=\"md-padding\"><h1 class=\"md-display-2\">\nAttachments Tab</h1><p>\nInteger turpis erat, porttitor vitae mi faucibus, laoreet interdum tellus. Curabitur posuere molestie dictum. Morbi eget congue risus, quis rhoncus quam. Suspendisse vitae hendrerit erat, at posuere mi. Cras eu fermentum nunc. Sed id ante eu orci commodo volutpat non ac est. Praesent ligula diam, congue eu enim scelerisque, finibus commodo lectus.\n</p></md-content></md-tab></md-tabs></md-content></div></div></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/finishReset/finishReset.html","<md-dialog flex=\"35\"><form name=\"passwordForm\" novalidate layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Change Password</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" \nlayout-align=\"center center\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-key-variant\" \nstyle=\"color: rgb(5, 167, 253) !important\"></md-icon><input type=\"password\" name=\"password\" ng-model=\"user.password\" \nplaceholder=\"Enter Password*\" minlength=\"4\" required><div ng-messages=\"passwordForm.password.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Password field is required</span></div><div ng-message=\"minlength\"><span>\nPassword must contain at least 4 letters</span></div></div></md-input-container><md-input-container class=\"md-block\">\n<md-icon md-font-icon=\"icon-key-variant\" style=\"color: rgb(5, 167, 253) !important\"></md-icon><input type=\"password\" \nname=\"passwordConfirm\" ng-model=\"user.passwordConfirm\" placeholder=\"Re-enter Password*\" required><div \nng-messages=\"passwordForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nRe-enter Password field is required</span></div></div></md-input-container><span \nstyle=\"color: red;font-family: \'Roboto\';font-size: 12px; margin-top: -4% !important\" \nng-show=\"user.password !== user.passwordConfirm\">Passwords do not match</span></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel\n</md-button><md-button type=\"submit\" ng-disabled=\"user.password !== user.passwordConfirm\" \nng-click=\" passwordForm.$valid && save(user.password)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/login/login.html","<div id=\"login\" class=\"flex-scrollable bg\" ng-controller=\"LoginController as vm\" layout=\"column\" ms-scroll><div \nid=\"login-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\" \nng-hide=\"forgotPasswordPage\"><div layout=\"row\" layout-align=\"center center\"><span><img id=\"logoimage\"></span></div><div\n class=\"title\">Log in to your account</div><form name=\"vm.loginForm\" novalidate \nng-submit=\"vm.loginForm.$valid && vm.login(login)\"><span class=\"md-body-2\" ng-style=\"{color:\'red\'}\" layout=\"row\" \nlayout-align=\"center center\">{{ErrorMsg.message}}</span><md-input-container class=\"md-block\"><input type=\"text\" \nname=\"userid\" ng-model=\"login.userid\" placeholder=\"User Id\" required><div ng-messages=\"vm.loginForm.userid.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>UserId field is required</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><input type=\"password\" name=\"password\" \nng-model=\"login.password\" placeholder=\"Password\" required><div ng-messages=\"vm.loginForm.password.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Password field is required</span></div></div></md-input-container><div \nclass=\"remember-forgot-password\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-between center\"><md-checkbox \nclass=\"remember-me\" ng-model=\"login.remember\" aria-label=\"Remember Me\"><span>Remember Me</span></md-checkbox><a \nclass=\"forgot-password md-accent-color c-p\" ng-click=\"forgotPassword()\" style=\"color:rgb(0, 102, 255) !important\">\nForgot Password?</a></div><md-button type=\"submit\" role=\"loginForm\" class=\"md-raised md-accent submit-button\" \naria-label=\"LOG IN\">LOG IN</md-button></form></div></div><div id=\"forgotpassword\" class=\"flex-scrollable\" \nlayout=\"column\" ms-scroll style=\"background:none\" ng-show=\"forgotPasswordPage\"><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"title\">Recover your password</div><form name=\"vm.forgotPasswordForm\" novalidate><md-input-container \nclass=\"md-block\"><input type=\"email\" name=\"email\" ng-model=\"user.email\" placeholder=\"Email\" required><div \nng-messages=\"vm.forgotPasswordForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nEmail field is required</span></div><div ng-message=\"email\"><span>Email must be a valid e-mail address</span></div>\n</div></md-input-container><md-button class=\"md-raised md-accent submit-button\" ng-click=\"resetPassword(user.email)\" \naria-label=\"SEND RESET LINK\">SEND RESET LINK<div class=\"md-ripple-container\"></div></md-button></form><div \nclass=\"login\" layout=\"row\" layout-align=\"center center\"><a ng-click=\"goToLoginPage()\" \nstyle=\"color:rgb(0, 102, 255) !important\" class=\"c-p\">Go back to login</a></div></div></div></div></div>");
$templateCache.put("app/main/migration/migration.html","<div class=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget><ms-widget-front class=\"white-bg\"><div \nclass=\"widget-group c-p\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"33\" flex-gt-md=\"20\" ng-click=\" migratCtrl.goTomigrateConfiguration()\"><ms-widget-front \nclass=\"h-170 p-16 orange-500-bg white-fg\"><div class=\"white-fg\" layout=\"column\" layout-align=\"end start\" flex><div \nclass=\"md-title pb-16\">Migration Configuration</div><span class=\"h4\"></span></div><div class=\"background-image-center\">\n<md-icon md-font-icon=\"icon-bank\" class=\"s128 faint-text\"></md-icon></div></ms-widget-front></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"33\" flex-gt-md=\"20\" ng-click=\"migratCtrl.gotoBatchRecords()\">\n<ms-widget-front class=\"h-170 p-16 light-green-500-bg white-fg\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"end start\" flex><div class=\"md-title pb-16\">Batch Records</div><span class=\"h4\"></span></div><div \nclass=\"background-image-center\"><md-icon md-font-icon=\"\r\n                           icon-minus-network\" \nclass=\"s128 faint-text\"></md-icon></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"33\" flex-gt-md=\"20\" ng-click=\" migratCtrl.goToDocumentationMigration()\"><ms-widget-front \nclass=\"h-170 p-16 blue-500-bg white-fg\"><div class=\"white-fg\" layout=\"column\" layout-align=\"end start\" flex><div \nclass=\"md-title pb-16\">Documentation Migration Status Reports</div><span class=\"h4\"></span></div><div \nclass=\"background-image-center\"><md-icon md-font-icon=\"icon-bitbucket\" class=\"s128 faint-text\"></md-icon></div>\n</ms-widget-front></ms-widget></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/profile/edit.profile.dialog.html","<md-dialog aria-label=\"Update user\" flex=\"50\"><style>\n.btn-update{\r\n     min-width: 120px;\r\n    background-color: #84bf48;\r\n    box-shadow: 0 4px 0 #6a9d37;\r\n    font-size: 12px;\r\n    margin-right: 10px;\r\n    padding: 10px 15px 10px 15px;\r\n    padding:0px;\r\n    }\r\n    .btn-cancel{\r\n        min-width: 120px;\r\n    background-color: #b9bec6;\r\n    box-shadow: 0 4px 0 #9da4af;\r\n    font-size: 12px;\r\n    padding: 10px 15px 10px 15px;\r\n    padding:0px;\r\n    }\r\n    .dialog-header{\r\n      \r\n    padding-bottom: 4px;\r\n    padding-top: 0px;\r\n    margin-bottom: 8px;}\r\n    .divider-width \r\n    {    \r\n        width: 107% !important;\r\n   		 margin-left: -4% !important;\r\n    }\n</style><form name=\"userUpdateForm\" novalidate layout=\"column\"><md-dialog-content layout=\"column\"><div \nclass=\"dialog-header details\" style=\"margin-top: -20px\">Primary Details</div><md-divider class=\"divider-width\">\n</md-divider><div layout=\"row\"><md-input-container flex=\"40\"><label class=\"subtext\">First Name</label><input \ntype=\"text\" ng-model=\"currentUser.firstName\" required></md-input-container><span flex=\"20\"></span><md-input-container \nflex=\"40\"><label class=\"subtext\">Middle Name</label><input type=\"text\" ng-model=\"user\"></md-input-container></div><div \nlayout=\"row\"><md-input-container flex=\"40\"><label class=\"subtext\">Last Name</label><input type=\"text\" \nng-model=\"currentUser.lastName\" required></md-input-container><span flex=\"20\"></span><md-input-container flex=\"40\">\n<label class=\"subtext\">Authority</label><md-select ng-model=\"currentUser.authorities\" multiple=\"multiple\"><md-option \nng-value=\"authority\" disabled=\"true\" ng-repeat=\"authority in roles\">\n{{authority.replace(\"ROLE_USER\",\"User\").replace(\"ROLE_ADMIN\",\"Admin\")}}</md-option></md-select></md-input-container>\n</div><div layout=\"row\"><md-input-container flex=\"40\"><label class=\"subtext\">TimeZone</label><md-select \nng-model=\"currentUser.timeZone\"><md-option ng-value=\"timeZone\" ng-repeat=\"timeZone in timeZones\">{{timeZone}}\n</md-option></md-select></md-input-container><span flex=\"20\"></span><md-input-container flex=\"40\"><label \nclass=\"subtext\">Activate User</label><md-select ng-model=\"currentUser.activated\"><md-option ng-value=\"activated\" \ndisabled=\"true\" ng-repeat=\"activated in status\">{{activated.replace(\"true\",\"True\").replace(\"false\",\"False\")}}\n</md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container flex=\"40\"><label \nclass=\"subtext\">Currency</label><md-select ng-model=\"currentUser.currency\"><md-option ng-value=\"eachCurrency\" \nng-repeat=\"eachCurrency in currency\">{{eachCurrency}}</md-option></md-select></md-input-container><span flex=\"20\">\n</span><md-input-container flex=\"40\"><label class=\"subtext\">Decimal Seperator</label><md-select \nng-model=\"currentUser.decimalSeparator\"><md-option ng-value=\"currencyFormat\" \nng-repeat=\"currencyFormat in currencyFormats\">{{currencyFormat}}</md-option></md-select></md-input-container></div><div\n layout=\"row\"><md-input-container flex=\"40\"><label class=\"subtext\">Language</label><md-select \nng-model=\"currentUser.language\"><md-option ng-value=\"language\" ng-repeat=\"language in languages\">{{language}}\n</md-option></md-select></md-input-container><span flex=\"20\"></span><md-input-container flex=\"40\"><label \nclass=\"subtext\">Date Format</label><md-select ng-model=\"currentUser.dateFormat\"><md-option ng-value=\"dateFormat\" \nng-repeat=\"dateFormat in dateFormats\">{{dateFormat}}</md-option></md-select></md-input-container></div>\n</md-dialog-content><md-dialog-actions class=\"md-padding\" layout=\"row\" layout-align=\"end end\"><md-button \nclass=\"button btn-update\" ng-click=\"updateUserProfile(currentUser)\">Update</md-button><md-button \nclass=\"button btn-cancel\" ng-click=\"cancel()\">cancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/profile/myprofile.html","<style>.rowheight-job\r\n{\r\nmargin-top: -5%;\r\n}\r\n.icon{\r\nline-height: 1.5;\r\n\r\n}</style><div class=\"widget-group\" flex \nlayout=\"column\" layout-wrap ng-init=\"UserDetails()\"><ms-widget flippable=\"true\"><ms-widget-front class=\"white-bg\"><div \nlayout=\"row\" flex=\"100\"><div flex=\"15\" style=\"background-color: #6f8ab5\" layout=\"row\" layout-align=\"center center\"><i \nclass=\"icon icon-account s128\"></i></div><div flex=\"85\"><div layout=\"column\"><div style=\"margin-left: 17px\"><h1>\n{{currentLogedInUser.firstName}} {{currentLogedInUser.lastName}}</h1></div><div layout=\"row\" \nlayout-align=\"start start\"><div layout=\"row\" class=\"md-padding\"><md-icon class=\"icon-email icon\"></md-icon><span>\n{{currentLogedInUser.email}}</span></div></div></div><md-divider></md-divider><md-content \nstyle=\"background-color: #dee7f4\"><div layout=\"row\" layout-align=\"start center\"><md-button ng-click=\"loadAbout()\" \nstyle=\"min-width: 20px !important\"><span class=\"md-padding\">About</span></md-button><md-button \nng-click=\"loadSubstitution()\" style=\"min-width: 20px !important\"><span class=\"md-padding\">Substitution</span>\n</md-button></div></md-content></div></div></ms-widget-front></ms-widget><div><div ui-view=\"about\" \nng-show=\"loadPage==\'about\'\"></div><div ui-view=\"substitution\" ng-show=\"loadPage==\'substitution\'\"></div></div></div>");
$templateCache.put("app/main/profile/profile.html","<div class=\"md-padding\" layout-align=\"start start\"><div class=\"heading3\">Presonal Information</div><div layout=\"row\" \nflex><div class=\"md-padding\" flex=\"50\" style=\"margin-top: 0\"><ms-widget flippable=\"true\"><ms-widget-front \nclass=\"white-bg\" flex><div class=\"md-padding\" layout=\"row\" layout-align=\"space-between center\"><span class=\"details\">\nPrimary Details </span><span class=\"edit c-p\" ng-click=\"editprofile($event,currentLogedInUser)\">EDIT</span></div>\n<md-divider></md-divider><div layout=\"row\" layout-align=\"start start\"><div layout=\"column\" class=\"md-padding\"><span \nclass=\"subtext\">First Name</span> <span>{{currentLogedInUser.firstName}}</span></div><span flex=\"25\"></span><div \nlayout=\"column\" class=\"md-padding\"><span class=\"subtext\">Middle Name</span> <span>{{}}</span></div></div><div \nlayout=\"row\" layout-align=\"start start\"><div layout=\"column\" class=\"md-padding\"><span class=\"subtext\">Last Name</span> \n<span>{{currentLogedInUser.lastName}}</span></div><span flex=\"25\"></span><div layout=\"column\" class=\"md-padding\"><span \nclass=\"subtext\">Display Name</span> <span>{{currentLogedInUser.firstName}} {{currentLogedInUser.lastName}}</span></div>\n</div><div layout=\"row\" layout-align=\"start start\"><div layout=\"column\" class=\"md-padding\"><span class=\"subtext\">\nMARITAL STATUS</span> <span>Single</span></div><span flex=\"20\"></span><div layout=\"column\" class=\"md-padding\"><span \nclass=\"subtext\">BLOOD GROUP</span> <span></span></div></div><div layout=\"row\" layout-align=\"start start\"><div \nlayout=\"column\" class=\"md-padding\"><span class=\"subtext\">gender</span> <span>Male</span></div><span flex=\"30\"></span>\n<div layout=\"column\" class=\"md-padding\"><span class=\"subtext\">Dob</span> <span>DD-MM-YYYY</span></div></div>\n</ms-widget-front></ms-widget></div><div class=\"md-padding\" flex=\"50\"><ms-widget flippable=\"true\"><ms-widget-front \nclass=\"white-bg\" flex><div class=\"md-padding\" layout=\"row\" layout-align=\"space-between center\"><span class=\"details\">\nContact Details </span><span class=\"edit c-p\" ng-click=\"\">EDIT</span></div><md-divider></md-divider><div \nclass=\"md-padding\">Hi there!you have not added any Contact Details summary</div></ms-widget-front></ms-widget></div>\n</div><div layout=\"row\" layout-align=\"start start\"><div class=\"md-padding\" flex=\"50\"><ms-widget flippable=\"true\">\n<ms-widget-front class=\"white-bg\" flex><div class=\"md-padding details\">Addresses</div><md-divider></md-divider><div \nclass=\"md-padding\">No data available</div></ms-widget-front></ms-widget></div><div class=\"md-padding\" flex=\"50\">\n<ms-widget flippable=\"true\"><ms-widget-front class=\"white-bg\" flex><div class=\"md-padding details\">Relations</div>\n<md-divider></md-divider><div class=\"md-padding\">No data available.</div></ms-widget-front></ms-widget></div></div>\n</div><div class=\"md-padding heading3\">Professional Information</div><div layout=\"row\" layout-align=\"start start\"><div \nclass=\"md-padding\" flex=\"50\"><ms-widget flippable=\"true\"><ms-widget-front class=\"white-bg\" flex><div \nclass=\"md-padding details\">Addresses</div><md-divider></md-divider><div class=\"md-padding\">No data available</div>\n</ms-widget-front></ms-widget></div><div class=\"md-padding\" flex=\"50\"><ms-widget flippable=\"true\"><ms-widget-front \nclass=\"white-bg\" flex><div class=\"md-padding details\">Relations</div><md-divider></md-divider><div class=\"md-padding\">\nNo data available.</div></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/reports/reports.html","<style>\n.mh-0 {\r\n    min-height: 0px !important;\r\n}\r\n.parent-tabs > md-tabs .md-tab.md-active:after{\r\n    content: \" \";\r\n    border-left: 7px solid transparent;\r\n    border-right: 7px solid transparent;\r\n    border-bottom: 7px solid #efefef;\r\n    position: absolute;\r\n    display: block;\r\n    top: 87%;\r\n    left: 50%;\r\n   \r\n}\r\n.parent-tabs > md-tabs md-ink-bar {\r\n    background: none; \r\n}\r\n.parent-tabs > md-tabs .md-tab:hover {\r\n    color: #389cec !important;\r\n}\r\n.md-tab {\r\n  \r\n  text-transform: none;\r\n  }\n</style><div class=\"page-layout carded fullwidth scrollable\" layout=\"column\" flex ms-scroll md-dynamic-height><div \nclass=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Reports\" md-active=\"true\"></md-tab></md-tabs>\n</div></ms-widget></div></div>");
$templateCache.put("app/main/settings/settings.html","<div class=\"widget-group\" layout=\"column\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\">\n<ms-widget-front class=\"white-bg\"><div ng-cloak><md-content><md-tabs md-dynamic-height md-border-bottom><md-tab \nlabel=\"Account Settings\"><md-content class=\"md-padding\"><h1>Password Policy</h1><md-divider></md-divider><h3>\n<md-radio-group class=\"md-primary\"><md-radio-button value=\"a\">\nFirst character must be a letter, it must contain at least 4 characters and no more than 15 characters and no characters other than letters, numbers and the underscore may be used\n</md-radio-button><md-radio-button value=\"b\">\nPassword must be between 4 and 8 digits long and include at least one numeric digit.</md-radio-button><md-radio-button \nvalue=\"c\">\nPassword must be at least 4 characters, no more than 8 characters, and must include at least one upper case letter, one lower case letter, and one numeric digit.\n</md-radio-button><md-radio-button value=\"d\">\nMatches any string between 4 and 8 characters in length. Limits the length of a string.</md-radio-button>\n<md-radio-button value=\"s\">\nRequires one lower case letter, one upper case letter, one digit, 6-13 length, and no spaces.</md-radio-button>\n</md-radio-group></h3></md-content></md-tab><md-tab label=\"Technical Settings\"><md-content class=\"md-padding\">\n</md-content></md-tab><md-tab label=\"Help Settings\"><md-content class=\"md-padding\"></md-content></md-tab></md-tabs>\n</md-content></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/sites/sites.html","<div class=\"page-layout simple tabbed mh-0\" layout=\"column\"><div class=\"content parent-tabs\"><md-tabs class=\"mh-0\">\n<md-tab label=\"Home\" ui-sref=\"app.sites\" md-active=\"true\"></md-tab></md-tabs></div><div class=\"sitesearch\"><div><span \nflex=\"45\" class=\"h3\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><input \nng-model=\"searchSite\" type=\"text\" placeholder=\"Search\"></md-input-container></span></div></div></div><div id=\"sites\" \nclass=\"page-layout carded fullwidth scrollable\" layout=\"column\" flex ms-scroll md-dynamic-height><md-button flow-btn \nclass=\"md-fab md-mini grey-700-bg md-fab-bottom-right add_btn\" aria-label=\"Create User\" ng-click=\"createSite($event)\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Create site</md-tooltip></md-button><div \nclass=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\"><ms-widget-front \nclass=\"white-bg md-padding\"><div layout=\"row\" layout-wrap><div \nng-repeat=\"site in siteCtrl.sites  | filter : searchSite\" flex=\"15\"><md-card \nmd-theme=\"{{siteCtrl.getAnotherColor($index)}}\" md-theme-watch class=\"c-p\" ng-click=\"siteCtrl.enterSite(site)\">\n<md-tooltip md-direction=\"top\">{{site.title}}</md-tooltip><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" flex><div class=\"white-fg md-padding\" layout=\"row\" layout-align=\"center center\" \nng-style=\"{\'height\':\'150px\'}\"><md-icon md-font-icon=\"{{site.icon}}\" class=\"s64\"></md-icon></div><div><md-divider>\n</md-divider><div class=\"p-8 white-bg\" layout=\"column\" layout-align=\"center center\">{{site.name}}</div></div></div>\n</md-card></div></div></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/sharedwithme/editFiledialog.html","<md-dialog><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nEdit {{currentFile.type}} : {{currentFile.name}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><form name=\"doclibrary\" \nnovalidate layout=\"column\"><div layout=\"row\" layout-align=\"start center\"><div flex=\"20\" layout=\"column\" \nlayout-align=\"center end\"><span class=\"h3\"><b>Rename</b></span></div><span flex=\"10\"></span><div flex=\"60\" \nlayout=\"column\" layout-align=\"center start\"><md-input-container flex=\"45\" class=\"md-block\" layout=\"column\" \nlayout-align=\"space-around start\"><input type=\"text\" name=\"editname\" ng-model=\"currentFile.name\"></md-input-container>\n</div></div></form></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nng-click=\"cancel()\">Cancel</md-button><md-button ng-click=\"updateFile(currentFile)\">Save</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sharedwithme/previewFiles.html","<md-dialog style=\"height: 100%; width: 100%\"><md-dialog-content class=\"no-padding\"><iframe id=\"iframe\" \nsrc=\"{{fileURL}}\" name=\"contentframe\" frameborder=\"0\" \nstyle=\"width: 100%; height: 100%; position: absolute; z-index: 999\"></iframe></md-dialog-content></md-dialog>");
$templateCache.put("app/main/sharedwithme/sharedUsersDialog.html","<md-dialog ng-cloak flex=\"50\"><md-toolbar layout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\"><span>\nSharing : {{selectedFileName}}</span> <span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content layout=\"column\" layout-align=\"center center\"><div flex=\"55\" \nclass=\"md-padding\"><md-content flex ng-style=\"{\'border\': \'1px solid #cccccc\'}\" class=\"scrollable\" ms-scroll \nlayout=\"row\" layout-wrap><div ng-switch=\"(allSharedUsers).length\"><div ng-switch-when=\"0\" layout=\"row\" \nlayout-align=\"center center\"><p class=\"md-padding md-subhead md-primary-fg\">{{\'Not shared yet...\' | uppercase}}</p>\n</div><div ng-switch-default ng-style=\"{\'height\':\'190px\'}\"><table class=\"simple list-view\"><thead><tr><th>NAME</th><th>\nEMAIL</th><th>PERMISSION</th><th>ACTION</th></tr></thead><tbody><tr ng-repeat=\"user in allSharedUsers \" \nng-click=\"null\"><td>{{user.firstName}} {{user.lastName}}</td><td>{{user.email}}</td><td><li \nng-repeat=\"st in user.status\">{{st}}</li></td><td><md-button class=\"md-secondary md-icon-button\" \nng-click=\"removeSharing(user, $index)\"><md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon><i \nclass=\"icon icon-delete s30\"></i></md-icon></md-button></td></tr></tbody></table></div></div></md-content></div><div \nclass=\"scrollable md-padding\" ms-scroll><div layout=\"row\" class=\"md-padding\"><md-input-container class=\"md-block\" \nflex=\"70\"><input type=\"text\" name=\"name\" ng-model=\"searchKeyword\" placeholder=\"Search User\" required>\n</md-input-container><div layout=\"column\" layout-align=\"center center\"><md-button flow-btn class=\"md-accent md-raised\" \nng-click=\" searchUsers(searchKeyword)\">Search</md-button></div></div><div ng-show=\"tableVisibility\"><table><thead><tr>\n<th class=\"secondary-text md-padding\"><div class=\"table-header\"><span class=\"column-title\">NAME</span></div></th><th \nclass=\"secondary-text md-padding\"><div class=\"table-header\"><span class=\"column-title\">EMAIL</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"member in searchedUsers\"><td class=\"md-padding\">{{member.firstName}} {{member.lastName}}\n</td><td class=\"md-padding\">{{member.email}}</td><td layout=\"row\" layout-align=\"center center\"><md-input-container \nclass=\"md-block\"><md-select ng-model=\"status\" multiple=\"multiple\"><md-option ng-value=\"option\" \nng-repeat=\"option in Options\">{{option}}</md-option></md-select></md-input-container><md-button \nclass=\"md-accent md-raised\" ng-click=\"shareFile(member,status) \">ADD</md-button></td></tr></tbody></table></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel(member)\">Cancel\n</md-button><md-button ng-click=\"updateFileSharing()\" md-autofocus>Ok</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sharedwithme/sharedwithme.html","<style>\n.selected {\r\n        background-color: rgb(232, 233, 237) !important;\r\n    }\r\n    \r\n    .uf {\r\n        background-color: #fb8c00 !important;\r\n    }\n</style><div class=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap data-ng-init=\"sharedCtrl.getSharedfiles();\">\n<ms-widget><ms-widget-front class=\"white-bg\"><div id=\"docLibrary\" class=\"page-layout simple right-sidenav\" \nlayout=\"row\"><div flex=\"80\"><table class=\"simple\"><thead><tr><th><a href=\"#\" \nng-click=\"orderByField=\'name\'; reverseSort = !reverseSort\" style=\"color: #626262 !important\">Name<span \nng-show=\"orderByField == \'name\'\"><span ng-show=\"!reverseSort\"><md-icon md-font-icon=\"icon-keyboard-up\" class=\"icon\">\n</md-icon></span><span ng-show=\"reverseSort\"><md-icon md-font-icon=\"icon-keyboard-down\" class=\"icon\"></md-icon></span>\n</span></a></th><th hide-xs><a href=\"#\" ng-click=\"orderByField=\'createdBy\'; reverseSort = !reverseSort\" \nstyle=\"color: #626262 !important\">Owner<span ng-show=\"orderByField == \'createdBy\'\"><span ng-show=\"!reverseSort\">\n<md-icon md-font-icon=\"icon-keyboard-up\" class=\"icon\"></md-icon></span><span ng-show=\"reverseSort\"><md-icon \nmd-font-icon=\"icon-keyboard-down\" class=\"icon\"></md-icon></span></span></a></th><th hide-xs><a href=\"#\" \nng-click=\"orderByField=\'type\'; reverseSort = !reverseSort\" style=\"color: #626262 !important\">Type<span \nng-show=\"orderByField == \'type\'\"><span ng-show=\"!reverseSort\"><md-icon md-font-icon=\"icon-keyboard-up\" class=\"icon\">\n</md-icon></span><span ng-show=\"reverseSort\"><md-icon md-font-icon=\"icon-keyboard-down\" class=\"icon\"></md-icon></span>\n</span></a></th><th hide-xs><a href=\"#\" ng-click=\"orderByField=\'siteName\'; reverseSort = !reverseSort\" \nstyle=\"color: #626262 !important\">Site<span ng-show=\"orderByField == \'siteName\'\"><span ng-show=\"!reverseSort\"><md-icon \nmd-font-icon=\"icon-keyboard-up\" class=\"icon\"></md-icon></span><span ng-show=\"reverseSort\"><md-icon \nmd-font-icon=\"icon-keyboard-down\" class=\"icon\"></md-icon></span></span></a></th><th hide-xs><a href=\"#\" \nng-click=\"orderByField=\'size\'; reverseSort = !reverseSort\" style=\"color: #626262 !important\">Size<span \nng-show=\"orderByField == \'size\'\"><span ng-show=\"!reverseSort\"><md-icon md-font-icon=\"icon-keyboard-up\" class=\"icon\">\n</md-icon></span><span ng-show=\"reverseSort\"><md-icon md-font-icon=\"icon-keyboard-down\" class=\"icon\"></md-icon></span>\n</span></a></th><th hide show-gt-md><a href=\"#\" ng-click=\"orderByField=\'lastModifiedDate\'; reverseSort = !reverseSort\" \nstyle=\"color: #626262 !important\">Last Modified<span ng-show=\"orderByField == \'lastModifiedDate\'\"><span \nng-show=\"!reverseSort\"><md-icon md-font-icon=\"icon-keyboard-up\" class=\"icon\"></md-icon></span><span \nng-show=\"reverseSort\"><md-icon md-font-icon=\"icon-keyboard-down\" class=\"icon\"></md-icon></span></span></a></th></tr>\n</thead><tbody><tr class=\"c-p\" ng-repeat=\"file in sharedfiles |orderBy:orderByField:reverseSort\" \nng-click=\"sharedCtrl.selectFile(file, $index)\" ng-dblclick=\"sharedCtrl.doubleClick(file)\" \nng-class=\"{\'selected\':$index == selectedRow}\"><td><md-icon md-font-icon=\"{{sharedCtrl.fileIcon(file)}}\" class=\"icon\">\n</md-icon><span>{{file.name}}</span></td><td>{{file.createdBy}}</td><td>{{file.type}}</td><td>{{file.siteName}}</td><td\n hide-xs><span ng-show=\"file.size == \'\'\">-</span> <span ng-switch=\"file.size > 1024*1024\" \nng-hide=\"file.type ==\'folder\'\"><span ng-switch-when=\"true\">{{file.size / 1024 / 1024 | number:2}} MB</span> <span \nng-switch-default>{{file.size / 1024 | number:2}} kB</span></span></td><td>{{file.lastModifiedDate.substr(0,10)}}</td>\n</tr></tbody></table><div ng-show=\"sharedCtrl.numberOfElements == 0\" class=\"md-padding\"><span layout=\"row\" \nlayout-align=\"center center\"><h2>No files</h2></span></div><md-divider></md-divider><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"md-padding\"><h5>\nShowing {{(sharedCtrl.pageNumber*sharedCtrl.pageSize)+1}} - {{(sharedCtrl.pageNumber*sharedCtrl.pageSize)+sharedCtrl.pageSize}} of {{sharedCtrl.numberOfElements}} Results\n</h5></div><div layout=\"row\" layout-align=\"center center\">Page No<md-input-container class=\"md-block md-padding\" \nstyle=\"margin: 0px\"><md-select ng-model=\"pageNumber\"><md-option ng-repeat=\"pageNumber in pageNumbers\" \nng-value=\"pageNumber\" ng-click=\"sendPageNumber(pageNumber)\" value=\"sharedCtrl.pageNumber\" ng-selected=\"$first\">\n{{pageNumber+1}}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"center center\"><div>\n<md-button type=\"button\" ng-click=\"sharedCtrl.previous()\" ng-disabled=\"sharedCtrl.pageNumber <= 0\">Prev</md-button>\n</div><p class=\"md-padding\">{{sharedCtrl.pageNumber+1}}/{{pageNumbers.length}} &nbsp;PAGES</p><div class=\"md-padding\">\n<md-button type=\"button\" ng-click=\"sharedCtrl.next()\" \nng-disabled=\"sharedCtrl.pageNumber == pageNumbers.length-1 || sharedCtrl.numberOfElements == 0\">Next</md-button></div>\n</div></div></div><md-divider></md-divider><div flex=\"20\" ng-hide=\"detailsVisibility\" layout=\"column\"><md-tabs \nmd-dynamic-height md-center-tabs md-border-bottom md-active><md-tab label=\"Details\"><md-content class=\"md-padding\"><div\n layout=\"column\" layout-align=\"center center\"><svg width=\"107px\" height=\"82px\" viewBox=\"0 0 107 82\" focusable=\"false\">\n<path class=\"a-s-fa-Ha-pa drive\" fill=\"#B8B8B8\" \nd=\"M0,4a4,4,0,0,1,4,-4h89a4,4,0,0,1,4,4v18.5l-23.5,40.5h-69.5a4,4,0,0,1,-4,-4ZM74.5,65l23,-39.15l1,0l7,4.1l1,1l-23,39.15ZM74,65.8l9.5,5.5l-9,4ZM97,51v8a4,4,0,0,1,-4,4h-3ZM21,63v19l23,-19Z\">\n</path></svg><p class=\"md-primary md-hue-3\">Select a file to view its details.</p></div></md-content></md-tab>\n</md-tabs></div><div flex=\"20\" layout=\"column\" ng-show=\"detailsVisibility\" class=\"scrollable\" ms-scroll><div \nlayout=\"row\" layout-align=\"center center\"><span class=\"md-title md-padding\">{{sharedCtrl.selectedFileName}}</span>\n</div><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button\" ng-click=\"UpdateFile($event)\" \ndata-ng-if=\"isViewBtn(sharedCtrl.receivedFile.permissions, \'edit\')\"><md-tooltip md-direction=\"top\">Edit</md-tooltip>\n<md-icon md-font-icon=\"icon-pencil\" style=\"color:#ffc107 ! important\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"downloadFile()\" \ndata-ng-if=\"isViewBtn(sharedCtrl.receivedFile.permissions, \'download\')\"><md-tooltip md-direction=\"top\">Download\n</md-tooltip><md-icon md-font-icon=\"icon-download\" style=\"color:#2ecc71 ! important\"></md-icon></md-button></div><div>\n<md-content ng-cloak><md-tabs md-dynamic-height md-center-tabs md-border-bottom><md-tab label=\"Details\"><div \nclass=\"auto-height scrollable\" ms-scroll><md-content class=\"md-padding scrollable\" ms-scroll><table \nclass=\"detailsTable1\"><tr ng-repeat=\"fileattribute in fileattributes\"><th align=\"left\">{{fileattribute.name}}</th><td>\n{{fileattribute.value}}</td></tr></table></md-content></div><div class=\"md-padding\" layout=\"row\" \nlayout-align=\"center center\" data-ng-if=\"isViewBtn(sharedCtrl.receivedFile.permissions, \'view\')\" \ndata-ng-show=\"buttonVisibility\"><md-button class=\"md-raised\" ng-click=\"buildForm(file.id)\">DISPLAY</md-button></div>\n<div class=\"md-padding\" layout=\"row\" layout-align=\"center center\" \ndata-ng-if=\"isViewBtn(sharedCtrl.receivedFile.permissions, \'view\')\" data-ng-show=\"filebuttonVisibility\"><md-button \nclass=\"md-raised\" ng-click=\"previewFileDialog($event)\">DISPLAY</md-button></div></md-tab></md-tabs></md-content></div>\n</div></div></ms-widget-front></ms-widget></div><div ng-include=\"\'/app/core/layouts/footer.html\'\"></div>");
$templateCache.put("app/main/smartstore-admin/smartstore-admin.html","<div class=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget><ms-widget-front class=\"white-bg\"><div \nclass=\"widget-group c-p\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"33\" flex-gt-md=\"20\" ng-click=\"smartstoreCtrl.goToSystems()\"><ms-widget-front \nclass=\"h-170 p-16 light-green-500-bg white-fg\"><div class=\"white-fg\" layout=\"column\" layout-align=\"end start\" flex><div\n class=\"md-title pb-16\">Systems</div><span class=\"h4\"></span></div><div class=\"background-image-center\"><md-icon \nmd-font-icon=\"\r\n                          icon-minus-network\" class=\"s128 faint-text\"></md-icon></div>\n</ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"33\" flex-gt-md=\"20\" \nng-click=\"smartstoreCtrl.gotoMimeType()\"><ms-widget-front class=\"h-170 p-16 md-teal-500-bg white-fg\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"end start\" flex><div class=\"md-title pb-16\">MimeType Settings</div><span\n class=\"h4\"></span></div><div class=\"background-image-center\"><md-icon md-font-icon=\"icon-cog\" class=\"s128 faint-text\">\n</md-icon></div></ms-widget-front></ms-widget></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/toolbarsearch/checkInFile.html","<md-dialog><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nCheckIn {{checkInFile.type}} : {{checkInFile.name}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><form name=\"doclibrary\" \nnovalidate layout=\"column\"><div layout=\"row\"><div flex=\"45\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\">\n<b>Upload File</b></span></div><span flex=\"10\"></span><div flex=\"45\" layout=\"column\" layout-align=\"center start\"><input\n class=\"ng-hide\" id=\"formUploadFile\" name=\"formUploadFile\" type=\"file\" \nonchange=\"angular.element(this).scope().setFile(this)\"><label for=\"formUploadFile\" \nclass=\"md-button md-raised md-accent\">Upload</label></div></div><div><div ng-repeat=\"file in files.slice(0)\" \nlayout=\"row\" layout-align=\"center center\"><span class=\"md-warn\">{{file.webkitRelativePath || file.name}}</span> (<span \nng-switch=\"file.size > 1024*1024\"> <span ng-switch-when=\"true\">{{file.size / 1024 / 1024 | number:2}} MB</span> <span \nng-switch-default>{{file.size / 1024 | number:2}} kB</span> </span>)</div></div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button \nng-click=\"checkIn()\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/toolbarsearch/toolbarSearchPopup.html","<md-dialog flex=\"45\" ng-init=\"getAllBusinessObjects()\" style=\"height: 85% !important\"><form name=\"businessObjectForm\" \nnovalidate layout=\"column\"><md-dialog-content class=\"scrollable\" ms-scroll><div layout=\"row\" \nlayout-align=\"center center\"><div class=\"md-title\" layout=\"row\" layout-align=\"start center\">Search</div></div><div \nlayout=\"row\"><p flex=\"20\">File Type</p><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\" \nstyle=\"margin: 0px\"><md-select ng-model=\"file.fileExtension\"><md-option ng-repeat=\"fileExtension in fileExtensions\" \nng-value=\"fileExtension\"><md-icon ng-if=\"fileExtension == \'folder\'\" md-font-icon=\"icon-folder\" class=\"icon s16\">\n</md-icon><md-icon ng-if=\"fileExtension == \'txt\'\" md-font-icon=\"icon-clipboard-text\" class=\"icon s16\"></md-icon>\n<md-icon ng-if=\"fileExtension == \'doc\'\" md-font-icon=\"icon-file-document\" class=\"icon s16\"></md-icon><md-icon \nng-if=\"fileExtension == \'xl\'\" md-font-icon=\"icon-file-excel\" class=\"icon s16\"></md-icon><md-icon \nng-if=\"fileExtension == \'jpg\'\" md-font-icon=\"icon-file-image\" class=\"icon s16\"></md-icon><md-icon \nng-if=\"fileExtension == \'jpeg\'\" md-font-icon=\"icon-file-image\" class=\"icon s16\"></md-icon><md-icon \nng-if=\"fileExtension == \'png\'\" md-font-icon=\"icon-file-image\" class=\"icon s16\"></md-icon><md-icon \nng-if=\"fileExtension == \'pdf\'\" md-font-icon=\"icon-file-pdf-box\" class=\"icon s16\"></md-icon><md-icon \nng-if=\"fileExtension == \'html\'\" md-font-icon=\"icon-language-html5\" class=\"icon s16\"></md-icon><md-icon \nng-if=\"fileExtension == \'xml\'\" md-font-icon=\"icon-file-xml\" class=\"icon s16\"></md-icon><md-icon \nng-if=\"fileExtension == \'docx\'\" md-font-icon=\"icon-file-document\" class=\"icon s16\"></md-icon><md-icon \nng-if=\"fileExtension == \'json\'\" md-font-icon=\"icon-file-outline\" class=\"icon s16\"></md-icon>\n{{fileExtension.replace(\"folder\",\"Folder\").replace(\"jpg\",\"JPG\").replace(\"jpeg\",\"JPEG\").replace(\"png\",\"PNG Images\").replace(\"pdf\",\"PDF Files\").replace(\"txt\",\"Text Documents\").replace(\"html\",\"HTML Documents\").replace(\"xl\",\"Spreadsheets\").replace(\"xml\",\"XML Documents\").replace(\"docx\",\"Word Documents\").replace(\"json\",\"Data\")}}\n</md-option></md-select></md-input-container><span flex=\"10\"></span><p flex=\"20\">Creator</p><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"20\" style=\"margin: 0px\"><input type=\"text\" name=\"creator\" \nng-model=\"file.creator\"></md-input-container></div><div layout=\"row\"><p flex=\"20\">Site</p><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"20\" style=\"margin: 0px\"><md-select ng-model=\"siteLocation\"><md-option \nng-repeat=\"location in locations\" ng-value=\"location\">\n{{location.replace(\"allSites\",\"All Sites\").replace(\"currentSite\",\"Current Site\")}}</md-option></md-select>\n</md-input-container><span flex=\"10\"></span><p flex=\"20\">File Name</p><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"20\" style=\"margin: 0px\"><input type=\"text\" name=\"fileName\" ng-model=\"file.fileName\">\n</md-input-container></div><div layout=\"row\"><p flex=\"15\">Date</p><md-datepicker ng-model=\"file.fromDate\" \nmd-placeholder=\"From\"></md-datepicker><span flex=\"5\"></span><md-datepicker ng-model=\"file.toDate\" md-placeholder=\"To\">\n</md-datepicker></div><div layout=\"row\"><p flex=\"20\">Date Modified</p><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"20\" style=\"margin: 0px\"><md-select ng-model=\"file.dateModified\"><md-option \nng-repeat=\"dateModifiedType in dateModifiedTypes\" ng-value=\"dateModifiedType\">{{dateModifiedType}}</md-option>\n</md-select></md-input-container></div><div layout=\"row\"><p flex=\"20\">Document Type</p><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"20\" style=\"margin: 0px\"><md-select ng-model=\"file.documentType\"><md-option \nng-repeat=\"documentType in alldocumentType\" ng-value=\"documentType.name\" ng-click=\"selectBusinessObject(documentType)\">\n{{documentType.name}}</md-option></md-select></md-input-container><span flex=\"10\"></span></div><md-divider>\n</md-divider><div ng-show=\"attributeObjects\"><div ng-repeat=\"attributeObject in attributeObjects\"><div layout=\"row\"><p \nflex=\"40\">{{attributeObject.name}}</p><span flex=\"5\"></span><div layout=\"row\" flex=\"100\"><div \nng-if=\"attributeObject.type == \'String\' \" layout=\"row\" flex=\"100\"><md-input-container class=\"md-block\" flex=\"40\" \nstyle=\"margin: 0px\"><input type=\"text\" name=\"from\" ng-model=\"attributeObject.value\"></md-input-container></div><div \nng-if=\"attributeObject.type == \'Date\' \" layout=\"row\" flex=\"100\"><md-datepicker ng-model=\"attributeObject.value\">\n</md-datepicker></div></div></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nmd-autofocus class=\"md-accent\" ng-show=\"$scope.attributeObjects.length >5\" ng-click=\"moreObjects()\">More</md-button>\n<span flex></span><md-button type=\"button\" ng-click=\"reset(file)\">Reset</md-button><md-button type=\"submit\" \nclass=\"md-accent md-raised\" ng-click=\"searchFiles(hasTheWords, file, attributeObjects, siteLocation)\">Search\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/toolbarsearch/toolbarSearchResultNew.html","<style>\n.detailsTable{\r\n                padding: 0 7px;\r\n                width: 100%;\r\n                text-align: left;\r\n                tr {\r\n                    th, td {\r\n                    padding: 10px;\r\n                    }\r\n                }\r\n            }\r\n            .selected{\r\n              background-color: rgb(232, 233, 237) !important;\r\n            }\r\n            .selectedDate{\r\n              color: rgb(61, 190, 237);\r\n              font-weight: bold; \r\n            }\n</style><div class=\"page-layout carded fullwidth\" layout=\"column\" flex class=\"scrollable\" ms-scroll \nng-init=\"getSearchResult();getFilePermissions()\"><div class=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap>\n<ms-widget flippable=\"true\"><ms-widget-front class=\"white-bg\"><div layout=\"row\"><div flex=\"80\"><div \nng-show=\" !facetView\"><table class=\"dataTable row-border hover tableHighllete simple list-view\"><thead><tr><th><a \nhref=\"#\" ng-click=\"orderByField=\'name\'; reverseSort = !reverseSort\" style=\"color: #626262 !important\">Name<span \nng-show=\"orderByField == \'name\'\"><span ng-show=\"!reverseSort\"><md-icon md-font-icon=\"icon-keyboard-up\" class=\"icon\">\n</md-icon></span><span ng-show=\"reverseSort\"><md-icon md-font-icon=\"icon-keyboard-down\" class=\"icon\"></md-icon></span>\n</span></a></th><th hide-xs><a href=\"#\" ng-click=\"orderByField=\'createdBy\'; reverseSort = !reverseSort\" \nstyle=\"color: #626262 !important\">Owner<span ng-show=\"orderByField == \'createdBy\'\"><span ng-show=\"!reverseSort\">\n<md-icon md-font-icon=\"icon-keyboard-up\" class=\"icon\"></md-icon></span><span ng-show=\"reverseSort\"><md-icon \nmd-font-icon=\"icon-keyboard-down\" class=\"icon\"></md-icon></span></span></a></th><th hide-xs><a href=\"#\" \nng-click=\"orderByField=\'size\'; reverseSort = !reverseSort\" style=\"color: #626262 !important\">Size<span \nng-show=\"orderByField == \'size\'\"><span ng-show=\"!reverseSort\"><md-icon md-font-icon=\"icon-keyboard-up\" class=\"icon\">\n</md-icon></span><span ng-show=\"reverseSort\"><md-icon md-font-icon=\"icon-keyboard-down\" class=\"icon\"></md-icon></span>\n</span></a></th><th hide show-gt-md><a href=\"#\" ng-click=\"orderByField=\'lastModifiedDate\'; reverseSort = !reverseSort\" \nstyle=\"color: #626262 !important\">Last Modified<span ng-show=\"orderByField == \'lastModifiedDate\'\"><span \nng-show=\"!reverseSort\"><md-icon md-font-icon=\"icon-keyboard-up\" class=\"icon\"></md-icon></span><span \nng-show=\"reverseSort\"><md-icon md-font-icon=\"icon-keyboard-down\" class=\"icon\"></md-icon></span></span></a></th></tr>\n</thead><tbody><tr ng-if=\" toolbarSearchCtrl.numberOfElements == 0\"><td flex=\"100\" class=\"md-padding\"><div \nlayout=\"row\" layout-align=\"center center\"><b>No Results were found.</b></div></td></tr><tr class=\"c-p\" \nng-if=\"fileResults.totalElements != 0\" ng-repeat=\"file in toolbarSearchCtrl.resultFiles\" \nng-click=\"selectFile(file, $index, $event)\" ng-class=\"{\'selected\':$index == selectedRow}\"><td flex=\"100\" \nclass=\"md-padding\">{{file.name}}</td><td><span>{{file.createdBy}}</span></td><td><div><span \nng-switch=\"file.size > 1024*1024\"><span ng-switch-when=\"true\">{{file.size / 1024 / 1024 | number:2}} MB</span> <span \nng-switch-default>{{file.size / 1024 | number:2}} kB</span></span></div></td><td><div><span>\n{{file.lastModifiedDate.substr(0,10)}}</span></div></td></tr></tbody></table><md-divider></md-divider><div \nng-if=\"fileResults.totalElements != 0\" layout=\"row\" layout-align=\"space-between center\"><div class=\"md-padding\"><h5>\nShowing {{(toolbarSearchCtrl.pageNumber*toolbarSearchCtrl.pageSize)+1}} - {{(toolbarSearchCtrl.pageNumber*toolbarSearchCtrl.pageSize)+toolbarSearchCtrl.pageSize}} of {{toolbarSearchCtrl.numberOfElements}} Results\n</h5></div><div layout=\"row\" layout-align=\"center center\">Page No<md-input-container class=\"md-block md-padding\" \nstyle=\"margin: 0px\"><md-select ng-model=\"pageNumber\"><md-option ng-repeat=\"pageNumber in pageNumbers\" \nng-value=\"pageNumber\" ng-click=\"sendPageNumber(pageNumber)\" value=\"toolbarSearchCtrl.pageNumber\">{{pageNumber+1}}\n</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"center center\"><div><md-button \ntype=\"button\" ng-click=\"toolbarSearchCtrl.previous()\" ng-disabled=\"toolbarSearchCtrl.pageNumber <= 0\">Prev</md-button>\n</div><p class=\"md-padding\">{{toolbarSearchCtrl.pageNumber+1}}/{{fileResults.totalPages}} &nbsp;PAGES</p><div \nclass=\"md-padding\"><md-button type=\"button\" ng-click=\"toolbarSearchCtrl.next()\" \nng-disabled=\"toolbarSearchCtrl.pageNumber == pageNumbers.length-1\">Next</md-button></div></div></div><md-divider>\n</md-divider></div><div ng-show=\" facetView\"><table class=\"dataTable row-border hover tableHighllete\"><thead><th \nclass=\"md-padding\">Total Results : {{facetResults.totalElements}}</th></thead><tbody><tr \nng-if=\"facetResults.totalElements == 0\"><td flex=\"100\" class=\"md-padding\"><div layout=\"row\" \nlayout-align=\"center center\"><b>No Results were found.</b></div></td></tr><tr class=\"c-p\" \nng-if=\"facetResults.totalElements != 0\" ng-repeat=\"file in facetResults.content\" \nng-click=\"selectFile(file, $index, $event)\" ng-class=\"{\'selected\':$index == selectedRow}\"><td flex=\"100\" \nclass=\"md-padding\"><div layout=\"column\"><div layout=\"row\" layout-align=\"space-between center\"><span class=\"h4\" \nstyle=\"color: rgb(61, 190, 237)\"><b>Document Name: {{file.name}}</b> </span><span class=\"h4\" class=\"button\" \nstyle=\"color: rgb(61, 190, 237)\" ng-click=\"toolbarSearchCtrl.searchresultsDownload(file)\"><b>Open</b></span></div><div \nlayout=\"row\" layout-align=\"space-between center\"><div><span><b>File Type: </b>{{file.fileType}}</span></div><div><span \nng-switch=\"file.size > 1024*1024\"><span ng-switch-when=\"true\"><span><b>Size: </b></span>\n{{file.size / 1024 / 1024 | number:2}} MB</span> <span ng-switch-default><span><b>Size: </b></span>\n{{file.size / 1024 | number:2}} kB</span></span></div><div><span><b>Owner: </b>{{file.createdBy}}</span></div><div>\n<span><b>Site: </b>{{file.site}}</span></div><div><span><b>Last Modified: </b>{{file.lastModifiedDate.substr(0,10)}}\n</span></div></div></div></td></tr></tbody></table><md-divider></md-divider><div \nng-if=\"facetResults.totalElements != 0\" layout=\"row\" layout-align=\"space-between center\"><div class=\"md-padding\"><h5>\nShowing {{(facetResults.number*facetResults.size)+1}} - {{(facetResults.number*facetResults.size)+facetResults.numberOfElements}} of {{facetResults.totalElements}} Results\n</h5></div><div layout=\"row\" layout-align=\"center center\">Page No<md-input-container class=\"md-block md-padding\" \nstyle=\"margin: 0px\"><md-select ng-model=\"pageNumber\"><md-option ng-repeat=\"facetPageNumber in facetPageNumbers\" \nng-value=\"facetPageNumber\" ng-click=\"facetSendPageNumber(facetPageNumber)\">{{facetPageNumber+1}}</md-option>\n</md-select></md-input-container></div><div layout=\"row\" layout-align=\"center center\"><div><md-button type=\"button\" \nng-click=\"toolbarSearchCtrl.facetPrevious()\" ng-disabled=\"toolbarSearchCtrl.pageNumber <= 0\">Prev</md-button></div><p \nclass=\"md-padding\">{{toolbarSearchCtrl.pageNumber+1}}/{{facetResults.totalPages}} &nbsp;PAGES</p><div \nclass=\"md-padding\"><md-button type=\"button\" ng-click=\"toolbarSearchCtrl.facetNext()\" \nng-disabled=\"toolbarSearchCtrl.pageNumber == facetResults.totalPages-1\">Next</md-button></div></div></div><md-divider>\n</md-divider></div></div><md-divider></md-divider><div flex=\"25\" ng-hide=\"detailsVisibility\" layout=\"column\"><md-tabs \nmd-dynamic-height md-center-tabs md-border-bottom><md-tab label=\"Details\"><md-content class=\"md-padding\"><div \nlayout=\"column\" layout-align=\"center center\"><svg width=\"107px\" height=\"82px\" viewBox=\"0 0 107 82\" focusable=\"false\">\n<path class=\"a-s-fa-Ha-pa drive\" fill=\"#B8B8B8\" \nd=\"M0,4a4,4,0,0,1,4,-4h89a4,4,0,0,1,4,4v18.5l-23.5,40.5h-69.5a4,4,0,0,1,-4,-4ZM74.5,65l23,-39.15l1,0l7,4.1l1,1l-23,39.15ZM74,65.8l9.5,5.5l-9,4ZM97,51v8a4,4,0,0,1,-4,4h-3ZM21,63v19l23,-19Z\">\n</path></svg><p class=\"md-primary md-hue-3\">Select a file or folder to view its details.</p></div></md-content>\n</md-tab><md-tab label=\"Activity\"><md-content class=\"md-padding\"><div layout=\"column\" layout-align=\"center center\"><svg\n width=\"107px\" height=\"82px\" viewBox=\"0 0 107 82\" focusable=\"false\"><path class=\"a-s-fa-Ha-pa drive\" fill=\"#B8B8B8\" \nd=\"M0,4a4,4,0,0,1,4,-4h89a4,4,0,0,1,4,4v18.5l-23.5,40.5h-69.5a4,4,0,0,1,-4,-4ZM74.5,65l23,-39.15l1,0l7,4.1l1,1l-23,39.15ZM74,65.8l9.5,5.5l-9,4ZM97,51v8a4,4,0,0,1,-4,4h-3ZM21,63v19l23,-19Z\">\n</path></svg><p class=\"md-primary md-hue-3\">Select a file or folder to view its details.</p></div></md-content>\n</md-tab></md-tabs></div><div flex=\"25\" layout=\"column\" ng-show=\"detailsVisibility\" class=\"scrollable\" ms-scroll><div \nlayout=\"row\" layout-align=\"center center\"><h1>{{fileName}}</h1></div><div layout=\"row\" layout-align=\"center center\">\n<md-button class=\"md-icon-button\" ng-if=\"toolbarSearchCtrl.receivedFile.fileType != \'json\' \" \nng-click=\"checkInFileDialog($event)\" ng-show=\"toolbarSearchCtrl.edit\"><md-tooltip md-direction=\"top\">Check in\n</md-tooltip><md-icon md-font-icon=\"icon-login\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-if=\"toolbarSearchCtrl.receivedFile.fileType != \'json\'\" ng-click=\"fileCheckout()\" ng-show=\"toolbarSearchCtrl.edit\">\n<md-tooltip md-direction=\"top\">Check out</md-tooltip><md-icon md-font-icon=\"icon-logout\"></md-icon></md-button></div>\n<div><md-content ng-cloak><md-tabs md-dynamic-height md-center-tabs md-border-bottom><md-tab label=\"Details\"><div \nclass=\"auto-height scrollable\" ms-scroll><md-content class=\"md-padding\"><table class=\"md-padding detailsTable\"><tr \nng-repeat=\"fileAttribute in fileAttributes\"><th>\n{{fileAttribute.name.charAt(0).toUpperCase()+ fileAttribute.name.slice(1)}}</th><td>{{fileAttribute.value}}</td></tr>\n</table><div layout=\"row\" layout-align=\"center center\"><div ng-repeat=\"user in allSharedUsers\" \nstyle=\"padding-left: 2%\"><md-button flow-btn class=\"md-icon-button md-fab md-mini grey-700-bg\" ng-click=\"\">\n{{user.firstName.slice(0,1).toUpperCase()}}<md-tooltip md-direction=\"top\">{{user.firstName +\" \"+ user.lastName}}\n</md-tooltip></md-button></div></div></md-content></div><div class=\"md-padding\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised\" ng-click=\"buildForm(file.id)\" \nng-if=\"toolbarSearchCtrl.receivedFile.fileType === \'json\'\" ng-show=\"toolbarSearchCtrl.viewFile\">DISPLAY</md-button>\n</div><div class=\"md-padding\" layout=\"row\" layout-align=\"center center\" ng-show=\"filebuttonVisibility\"><md-button \nclass=\"md-raised\" ng-click=\"previewFile($event)\" ng-show=\"toolbarSearchCtrl.viewFile\">Preview</md-button></div>\n<md-divider ng-show=\"versionsVisibility\"></md-divider><div layout=\"row\" layout-align=\"center center\" \nclass=\"md-padding\" ng-show=\"versionsVisibility\"><span class=\"md-body-2\">VERSIONS</span></div><md-divider \nng-show=\"versionsVisibility\"></md-divider><div class=\"auto-height scrollable\" ms-scroll><md-content><md-list>\n<md-list-item class=\"md-2-line\" ng-repeat=\"version in versions\" ng-click=\"null\"><md-button flow-btn \nclass=\"md-icon-button\"><md-icon md-font-icon=\"{{selectedFileIcon}}\" class=\"icon\"></md-icon></md-button><span flex=\"5\">\n</span><div class=\"md-list-item-text\" layout=\"column\"><h3><strong>Version {{version.versionNo}} </strong>created by \n<strong>{{version.createdBy}}</strong></h3><p>Date : {{version.createdDate.substr(0,10)}}</p></div><md-divider \nng-if=\"!$last\"></md-divider></md-list-item></md-list></md-content></div></md-tab><md-tab label=\"ACTIVITY\"><div \nclass=\"auto-height-activity scrollable\" ms-scroll><md-content><md-list><md-list-item class=\"md-2-line\" \nng-repeat=\"activity in activities | orderBy:\'-\' \" ng-click=\"null\"><img ng-src=\"assets\\images\\avatars/Nora.jpg\" \nclass=\"md-avatar\"><div class=\"md-list-item-text\" layout=\"column\"><p ng-bind-html=\"activity.description\"></p></div>\n<md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list></md-content></div></md-tab></md-tabs></md-content>\n</div></div></div></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/toolbarsearch/toolbarsearch.html","<div flex layout=\"row\" layout-align=\"start center\"><input id=\"ms-search-bar-input\" type=\"text\" placeholder=\"Search\" \nflex ng-model=\"toolbarSearchCtrl.query\" ng-model-options=\"toolbarSearchCtrl.queryOptions\" \nng-keydown=\"toolbarSearchCtrl.handleKeydown($event)\"><md-button class=\"ms-search-bar-collapser md-icon-button\" \nng-click=\"toolbarSearchCtrl.advancedSearchPopup()\"><md-icon md-font-icon=\"icon-menu-down\" class=\"icon s48\"></md-icon>\n</md-button><md-button class=\"ms-search-bar-collapser md-icon-button\" ng-click=\"toolbarSearchCtrl.collapse()\" \naria-label=\"Collapse Search Bar\"><md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div \nclass=\"ms-search-bar-results\" ng-if=\"toolbarSearchCtrl.results\" ms-scroll><div class=\"no-results\" \nng-if=\"toolbarSearchCtrl.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in toolbarSearchCtrl.results\" ng-click=\"toolbarSearchCtrl.handleResultClick(result)\" \nng-mouseenter=\"toolbarSearchCtrl.handleMouseenter($index)\" ng-mousedown=\"toolbarSearchCtrl.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == toolbarSearchCtrl.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/main/toolbarsearch/toolbarsearchResult.html","<style>\n.detailsTable{\r\n                padding: 0 7px;\r\n                width: 100%;\r\n                text-align: left;\r\n                tr {\r\n                    th, td {\r\n                    padding: 10px;\r\n                    }\r\n                }\r\n            }\r\n            .selected{\r\n              background-color: rgb(232, 233, 237) !important;\r\n            }\n</style><div class=\"page-layout carded fullwidth\" layout=\"column\" flex class=\"scrollable\" ms-scroll \nng-init=\"getSearchResult()\"><div class=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget \nflippable=\"true\"><ms-widget-front class=\"white-bg\"><div layout=\"row\"><div flex=\"15\"><div layout=\"column\"><div \nclass=\"md-padding\" style=\"padding-bottom: 0px !important;padding-top: 0px !important\" \nng-repeat=\"facetResultPage in fileResults.facetResultPages\"><div style=\"background-color: rgb(61, 190, 237)\"><p \nclass=\"md-padding white-fg\">\n{{facetResultPage.content[0].key.name.charAt(0).toUpperCase()+ facetResultPage.content[0].key.name.slice(1);}}</p>\n</div><div class=\"md-padding\" style=\"padding-top: 0px !important; padding-bottom: 0px !important\"><div \nng-repeat=\"valueObject in facetResultPage.content\"><p ng-click=\"\">{{valueObject.value}} ({{valueObject.valueCount}} )\n</p></div></div><md-divider></md-divider></div></div></div><md-divider></md-divider><div flex=\"60\"><table \nclass=\"dataTable row-border hover tableHighllete\" datatable=\"ng\" dt-options=\"dtOptions\"><thead><th>\nTotal Results : {{fileResults.content.length}}</th></thead><tbody><tr ng-repeat=\"file in fileResults.content\" \nng-click=\"selectFile(file, $index, $event)\" ng-class=\"{\'selected\':$index == selectedRow}\"><td flex=\"100\"><div \nlayout=\"column\"><div layout=\"row\" layout-align=\"space-between center\"><span class=\"h4\" \nstyle=\"color: rgb(61, 190, 237)\"><b>Document Name: {{file.name}}</b> </span><span class=\"h4\" class=\"button\" \nstyle=\"color: rgb(61, 190, 237)\" ng-click=\"toolbarSearchCtrl.searchresultsDownload(file)\"><b>Open</b></span></div><div \nlayout=\"row\" layout-align=\"space-between center\"><div><span><b>File Type: </b>{{file.fileType}}</span></div><div><span \nng-switch=\"file.size > 1024*1024\"><span ng-switch-when=\"true\"><span><b>Size: </b></span>\n{{file.size / 1024 / 1024 | number:2}} MB</span> <span ng-switch-default><span><b>Size: </b></span>\n{{file.size / 1024 | number:2}} kB</span></span></div><div><span><b>Owner: </b>{{file.createdBy}}</span></div><div>\n<span><b>Site: </b>{{file.site}}</span></div><div><span><b>Last Modified: </b>{{file.lastModifiedDate.substr(0,10)}}\n</span></div></div><div layout=\"row\"></div></div></td></tr></tbody></table></div><md-divider></md-divider><div \nflex=\"25\" ng-hide=\"detailsVisibility\" layout=\"column\"><md-tabs md-dynamic-height md-center-tabs md-border-bottom>\n<md-tab label=\"Details\"><md-content class=\"md-padding\"><div layout=\"column\" layout-align=\"center center\"><svg \nwidth=\"107px\" height=\"82px\" viewBox=\"0 0 107 82\" focusable=\"false\"><path class=\"a-s-fa-Ha-pa drive\" fill=\"#B8B8B8\" \nd=\"M0,4a4,4,0,0,1,4,-4h89a4,4,0,0,1,4,4v18.5l-23.5,40.5h-69.5a4,4,0,0,1,-4,-4ZM74.5,65l23,-39.15l1,0l7,4.1l1,1l-23,39.15ZM74,65.8l9.5,5.5l-9,4ZM97,51v8a4,4,0,0,1,-4,4h-3ZM21,63v19l23,-19Z\">\n</path></svg><p class=\"md-primary md-hue-3\">Select a file or folder to view its details.</p></div></md-content>\n</md-tab><md-tab label=\"Activity\"><md-content class=\"md-padding\"><div layout=\"column\" layout-align=\"center center\"><svg\n width=\"107px\" height=\"82px\" viewBox=\"0 0 107 82\" focusable=\"false\"><path class=\"a-s-fa-Ha-pa drive\" fill=\"#B8B8B8\" \nd=\"M0,4a4,4,0,0,1,4,-4h89a4,4,0,0,1,4,4v18.5l-23.5,40.5h-69.5a4,4,0,0,1,-4,-4ZM74.5,65l23,-39.15l1,0l7,4.1l1,1l-23,39.15ZM74,65.8l9.5,5.5l-9,4ZM97,51v8a4,4,0,0,1,-4,4h-3ZM21,63v19l23,-19Z\">\n</path></svg><p class=\"md-primary md-hue-3\">Select a file or folder to view its details.</p></div></md-content>\n</md-tab></md-tabs></div><div flex=\"25\" layout=\"column\" ng-show=\"detailsVisibility\" class=\"scrollable\" ms-scroll><div \nlayout=\"row\" layout-align=\"center center\"><h1>{{fileName}}</h1></div><div layout=\"row\" layout-align=\"center center\">\n<md-button class=\"md-icon-button\" ng-if=\"toolbarSearchCtrl.receivedFile.fileType != \'json\' \" \nng-click=\"checkInFileDialog($event)\"><md-tooltip md-direction=\"top\">Check in</md-tooltip><md-icon \nmd-font-icon=\"icon-login\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-if=\"toolbarSearchCtrl.receivedFile.fileType != \'json\'\" ng-click=\"fileCheckout()\"><md-tooltip md-direction=\"top\">\nCheck out</md-tooltip><md-icon md-font-icon=\"icon-logout\"></md-icon></md-button></div><div><md-content ng-cloak>\n<md-tabs md-dynamic-height md-center-tabs md-border-bottom><md-tab label=\"Details\"><div class=\"auto-height scrollable\" \nms-scroll><md-content class=\"md-padding\"><table class=\"md-padding detailsTable\"><tr \nng-repeat=\"fileAttribute in fileAttributes\"><th>\n{{fileAttribute.name.charAt(0).toUpperCase()+ fileAttribute.name.slice(1)}}</th><td>{{fileAttribute.value}}</td></tr>\n</table><div layout=\"row\" layout-align=\"center center\"><div ng-repeat=\"user in allSharedUsers\" \nstyle=\"padding-left: 2%\"><md-button flow-btn class=\"md-icon-button md-fab md-mini grey-700-bg\" ng-click=\"\">\n{{user.firstName.slice(0,1).toUpperCase()}}<md-tooltip md-direction=\"top\">{{user.firstName +\" \"+ user.lastName}}\n</md-tooltip></md-button></div></div></md-content></div><div class=\"md-padding\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised\" ng-click=\"buildForm(file.id)\" \nng-if=\"toolbarSearchCtrl.receivedFile.fileType === \'json\'\">DISPLAY</md-button></div><md-divider \nng-show=\"versionsVisibility\"></md-divider><div layout=\"row\" layout-align=\"center center\" class=\"md-padding\" \nng-show=\"versionsVisibility\"><span class=\"md-body-2\">VERSIONS</span></div><md-divider ng-show=\"versionsVisibility\">\n</md-divider><div class=\"auto-height scrollable\" ms-scroll><md-content><md-list><md-list-item class=\"md-2-line\" \nng-repeat=\"version in versions\" ng-click=\"null\"><md-button flow-btn class=\"md-icon-button\"><md-icon \nmd-font-icon=\"{{selectedFileIcon}}\" class=\"icon\"></md-icon></md-button><span flex=\"5\"></span><div \nclass=\"md-list-item-text\" layout=\"column\"><h3><strong>Version {{version.versionNo}} </strong>created by <strong>\n{{version.createdBy}}</strong></h3><p>Date : {{version.createdDate.substr(0,10)}}</p></div><md-divider ng-if=\"!$last\">\n</md-divider></md-list-item></md-list></md-content></div></md-tab><md-tab label=\"ACTIVITY\"><div \nclass=\"auto-height-activity scrollable\" ms-scroll><md-content><md-list><md-list-item class=\"md-2-line\" \nng-repeat=\"activity in activities | orderBy:\'-\' \" ng-click=\"null\"><img ng-src=\"assets\\images\\avatars/Nora.jpg\" \nclass=\"md-avatar\"><div class=\"md-list-item-text\" layout=\"column\"><span><b><strong>{{activity.description}}</strong></b>\n by <strong>{{activity.userId}}</strong></span><p>Date :{{activity.postedAt.substr(0,10)}}</p></div><md-divider \nng-if=\"!$last\"></md-divider></md-list-item></md-list></md-content></div></md-tab></md-tabs></md-content></div></div>\n</div></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/toolbarsearch/versionFile.html","<md-dialog><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Add new version : {{selectedFileName}}</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><form name=\"doclibrary\" novalidate layout=\"column\"><div layout=\"row\">\n<div flex=\"45\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>Upload File</b></span></div><span \nflex=\"10\"></span><div flex=\"45\" layout=\"column\" layout-align=\"center start\"><input class=\"ng-hide\" id=\"formUploadFile\" \nname=\"formUploadFile\" type=\"file\" onchange=\"angular.element(this).scope().setFile(this)\"><label for=\"formUploadFile\" \nclass=\"md-button md-raised md-accent\">Upload</label></div></div><div><div ng-repeat=\"file in files.slice(0)\" \nlayout=\"row\" layout-align=\"center center\"><span class=\"md-warn\">{{file.webkitRelativePath || file.name}}</span> (<span \nng-switch=\"file.size > 1024*1024\"> <span ng-switch-when=\"true\">{{file.size / 1024 / 1024 | number:2}} MB</span> <span \nng-switch-default>{{file.size / 1024 | number:2}} kB</span> </span>)</div></div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button \nng-click=\"NewVersionFile()\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/user-management/changePassword.html","<md-dialog aria-label=\"Change Password\" flex=\"20\"><form name=\"passwordForm\" novalidate layout=\"column\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Change Password</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" layout-align=\"center center\"><md-input-container\n class=\"md-block\"><md-icon md-font-icon=\"icon-key-variant\" style=\"color: rgb(5, 167, 253) !important\"></md-icon><input \ntype=\"password\" name=\"password\" ng-model=\"user.password\" placeholder=\"Enter Password*\" required><div \nng-messages=\"passwordForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>Password field is required\n</span></div></div></md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-key-variant\" \nstyle=\"color: rgb(5, 167, 253) !important\"></md-icon><input type=\"password\" name=\"passwordConfirm\" \nng-model=\"user.passwordConfirm\" placeholder=\"Re-enter Password*\" required> <span \nstyle=\"color: red;font-family: \'Roboto\';font-size: 12px\" ng-show=\"user.password !== user.passwordConfirm\">\nPasswords do not match</span><div ng-messages=\"passwordForm.passwordConfirm.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Re-enter Password field is required</span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" \nng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"passwordForm.$valid && save(user)\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div layout=\"row\" layout-align=\"start center\" flex><div \nclass=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" ms-scroll \nng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/main/administration/ILMSetup/createStorePopup.html","<md-dialog aria-label=\"Create Store\" flex=\"30\"><form name=\"userForm\" novalidate ng-submit=\"userForm.$valid\" \nlayout=\"column\" flex=\"66\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create Store</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-input-container class=\"md-block\"><label>ILM Store ID</label>\n<input type=\"text\" name=\"store\" ng-model=\"store.storeId\" required></md-input-container><md-input-container \nclass=\"md-block\"><label>ILM Store Description</label><input type=\"text\" name=\"email\" ng-model=\"store.description\" \nrequired></md-input-container><md-input-container class=\"md-block\"><label>Link R5 Site</label><md-select name=\"site\" \nng-model=\"store.r5siteId\" required><md-option ng-value=\"site.id\" ng-repeat=\"site in sites\">{{site.name}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\"><label>Connected Systyems</label><md-select \nname=\"USer\" ng-model=\"store.connectedSystems\" multiple=\"multiple\" required><md-option ng-value=\"system.systemName\" \nng-repeat=\"system in systems\">{{system.systemName}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\"><label>Users</label><md-select name=\"USer\" ng-model=\"store.users\" multiple=\"multiple\" required>\n<md-option ng-value=\"user.login\" ng-repeat=\"user in users\">{{user.firstName}} {{user.lastName}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\"><md-checkbox type=\"checkbox\" ng-model=\"store.checkIPAddress\">\nCheck IP Address</md-checkbox></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"userForm.$valid && createStore(store)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/ILMSetup/ilm.html","<style>\n.mh-0 {\r\n    min-height: 0px !important;\r\n}\r\n.parent-tabs > md-tabs .md-tab.md-active:after{\r\n    content: \" \";\r\n    border-left: 7px solid transparent;\r\n    border-right: 7px solid transparent;\r\n    border-bottom: 7px solid #efefef;\r\n    position: absolute;\r\n    display: block;\r\n    top: 87%;\r\n    left: 50%;\r\n    \r\n}\r\n.parent-tabs > md-tabs md-ink-bar {\r\n    background: none; \r\n}\r\n.parent-tabs > md-tabs .md-tab:hover {\r\n    color: #389cec !important;\r\n}\r\n.md-tab {\r\n  \r\n  text-transform: none;\r\n  }\r\n  .table-border {\r\n    border: 1px solid #d3d3d3 !important;\r\n}\r\n.table-header {\r\n    background-color: #dee7f4 !important;\r\n    text-transform: uppercase;\r\n    font-size: 11px!important;\r\n}\n</style><div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"ILM Setup\" \nui-sref=\"app.administration.ilmSetup\" md-active=\"true\"></md-tab></md-tabs></div><div class=\"md-padding white-bg\"><table\n class=\"dataTable row-border hover table-border\" datatable=\"ng\" dt-options=\"ilmStp.dtOptions\"><thead><tr \nclass=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Store ID</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Description</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\" layout=\"row\" layout-align=\"center center\"><span \nclass=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr ng-repeat=\"store in allStores\"><td>\n{{store.storeId}}</td><td>{{store.description}}</td><td layout=\"row\" layout-align=\"center center\" \nstyle=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Update\" ng-click=\"updateStore($event,store)\"><md-tooltip md-direction=\"top\">Update</md-tooltip><md-icon><i \nlayout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s18 deleteme\"></i></md-icon></md-button><md-button \nclass=\"md-icon-button test-tooltip\" aria-label=\"Delete\" ng-click=\"deleteStore(store)\"><md-tooltip md-direction=\"top\">\nDelete</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s18\"></i></md-icon>\n</md-button></td></tr></tbody></table></div></ms-widget></div><md-button flow-btn \nclass=\"md-fab grey-700-bg md-mini md-fab-bottom-right\" aria-label=\"Create User\" ng-click=\"createStoreDialog($event)\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Create a Store</md-tooltip></md-button>\n</div></div>");
$templateCache.put("app/main/administration/ILMSetup/updateStoreDialog.html","<md-dialog aria-label=\"Create Store\" flex=\"30\"><form name=\"userForm\" novalidate ng-submit=\"userForm.$valid\" \nlayout=\"column\" flex=\"66\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>update Store</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-input-container class=\"md-block\"><label>ILM Store ID</label>\n<input type=\"text\" name=\"store\" ng-model=\"store.storeId\" required></md-input-container><md-input-container \nclass=\"md-block\"><label>ILM Store Description</label><input type=\"text\" name=\"email\" ng-model=\"store.description\" \nrequired></md-input-container><md-input-container class=\"md-block\"><label>Link R5 Site</label><md-select name=\"site\" \nng-model=\"store.r5siteId\" required><md-option ng-value=\"site.id\" ng-repeat=\"site in sites\">{{site.name}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\"><label>Connected Systyems</label><md-select \nname=\"USer\" ng-model=\"store.connectedSystems\" multiple=\"multiple\" required><md-option ng-value=\"system.systemName\" \nng-repeat=\"system in systems\">{{system.systemName}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\"><label>Users</label><md-select name=\"USer\" ng-model=\"store.users\" multiple=\"multiple\" required>\n<md-option ng-value=\"user.login\" ng-repeat=\"user in users\">{{user.firstName}} {{user.lastName}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\"><md-checkbox type=\"checkbox\" ng-model=\"store.checkIPAddress\">\nCheck IP Address</md-checkbox></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\" updateStore(store)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/Template/create.template.html","<md-dialog flex=\"45\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create Template</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><form name=\"template\" novalidate layout=\"column\"><div layout=\"row\">\n<div flex=\"35\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>Template Name </b></span></div><span \nflex=\"10\"></span><md-input-container flex=\"45\" class=\"md-block\" layout=\"column\" layout-align=\"space-around start\" \nstyle=\"margin-bottom: -11px\"><input type=\"text\" name=\"name\" ng-model=\"test.name\" placeholder=\"Template name\" required>\n</md-input-container></div><div layout=\"row\"><div flex=\"35\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\">\n<b>Description </b></span></div><span flex=\"10\"></span><md-input-container flex=\"45\" class=\"md-block\" layout=\"column\" \nlayout-align=\"space-around start\" style=\"padding-top: 0px !important;padding-bottom: 0px !important\"><input \ntype=\"text\" name=\"name\" ng-model=\"test.description\" placeholder=\"Description\" required></md-input-container></div><div \nlayout=\"row\"><div flex=\"35\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>DocumentType </b></span>\n</div><span flex=\"10\"></span><md-select ng-model=\"test.documentType\" placeholder=\"DocumentType\" flex=\"45\" \nstyle=\"margin-top:0px !important\"><md-option ng-value=\"doc.name\" ng-repeat=\"doc in Documents\">{{doc.name}}</md-option>\n</md-select></div><div layout=\"row\"><div flex=\"35\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>\nTemplate File</b></span></div><span flex=\"10\"></span><div flex=\"45\" layout=\"column\" layout-align=\"center start\"><input \nclass=\"ng-hide\" id=\"formUploadFile\" name=\"formUploadFile\" type=\"file\" \nonchange=\"angular.element(this).scope().setFile(this)\"><label for=\"formUploadFile\" \nclass=\"md-button md-raised md-accent\">Browse</label></div></div><div><div ng-repeat=\"file in files.slice(0)\" \nlayout=\"row\" layout-align=\"center center\"><span class=\"md-warn\">{{file.webkitRelativePath || file.name}}</span> (<span \nng-switch=\"file.size > 1024*1024\"> <span ng-switch-when=\"true\">{{file.size / 1024 / 1024 | number:2}} MB</span> <span \nng-switch-default>{{file.size / 1024 | number:2}} kB</span> </span>)</div></div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button \nng-click=\"save($event,test)\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/administration/Template/template.content.html","<style>\n.mh-0 {\r\n    min-height: 0px !important;\r\n}\r\n.parent-tabs > md-tabs .md-tab.md-active:after{\r\n    content: \" \";\r\n    border-left: 7px solid transparent;\r\n    border-right: 7px solid transparent;\r\n    border-bottom: 7px solid #efefef;\r\n    position: absolute;\r\n    display: block;\r\n    top: 87%;\r\n    left: 50%;\r\n   \r\n}\r\n.parent-tabs > md-tabs md-ink-bar {\r\n    background: none; \r\n}\r\n.parent-tabs > md-tabs .md-tab:hover {\r\n    color: #389cec !important;\r\n}\r\n.md-tab {\r\n  \r\n  text-transform: none;\r\n  }\r\n  .table-border {\r\n    border: 1px solid #d3d3d3 !important;\r\n}\r\n.table-header {\r\n    background-color: #dee7f4 !important;\r\n    text-transform: uppercase;\r\n    font-size: 11px!important;\r\n}\n</style><div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Templates\" md-active=\"true\"></md-tab></md-tabs>\n</div><div class=\"md-padding white-bg\"><table class=\"dataTable row-border hover table-border\" datatable=\"ng\" \ndt-options=\"templateCtrl.dtOptions\"><thead><tr class=\"table-header\"><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">TemplateName</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Description</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">DocumentType</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\" layout=\"row\" layout-align=\"center center\"><span class=\"column-title\">File</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"template in templates\"><td>{{template.name}}</td><td>{{template.description}}</td><td>\n{{template.documentType}}</td><td layout=\"row\" layout-align=\"center center\" \nstyle=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button id=\"{{template.id}}\" \nclass=\"md-icon-button test-tooltip\" aria-label=\"Update\" \nonclick=\"angular.element(this).scope().updateTemplateDialog(this)\"><md-tooltip md-direction=\"top\">Update</md-tooltip>\n<md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s18\"></i></md-icon></md-button><md-button\n id=\"{{template.id}}\" class=\"md-icon-button test-tooltip\" aria-label=\"Delete\" \nonclick=\"angular.element(this).scope().templateDelete(this)\"><md-tooltip md-direction=\"top\">Delete</md-tooltip>\n<md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s18\"></i></md-icon></md-button><md-button\n id=\"{{template.id}}\" class=\"md-icon-button test-tooltip\" aria-label=\"Display\" \nonclick=\"angular.element(this).scope().previewFile(this)\"><md-tooltip md-direction=\"top\">Display</md-tooltip><md-icon>\n<i layout=\"row\" layout-align=\"center center\" class=\"icon icon-login s18\"></i></md-icon></md-button></td></tr></tbody>\n</table></div></ms-widget></div><md-button flow-btn class=\"md-fab grey-700-bg md-mini md-fab-bottom-right add_btn\" \nng-click=\"createTemplateDialog(ev)\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">\nCreate Template</md-tooltip></md-button></div></div>");
$templateCache.put("app/main/administration/Template/template.preview.html","<md-dialog style=\"height: 100%; width: 100%\"><md-dialog-content class=\"no-padding\"><iframe id=\"iframe\" \nsrc=\"{{fileURL}}\" name=\"contentframe\" frameborder=\"0\" \nstyle=\"width: 100%; height: 100%; position: absolute; z-index: 999\"></iframe></md-dialog-content></md-dialog>");
$templateCache.put("app/main/administration/Template/update.template.html","<md-dialog flex=\"45\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Update Template</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><form name=\"template\" novalidate layout=\"column\"><div layout=\"row\">\n<div flex=\"35\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>Template Name </b></span></div><span \nflex=\"10\"></span><md-input-container flex=\"45\" class=\"md-block\" layout=\"column\" layout-align=\"space-around start\" \nstyle=\"margin-bottom: -11px\"><input type=\"text\" name=\"name\" ng-model=\"currentTemplate.name\" disabled=\"disabled\" \nplaceholder=\"Template name\" required></md-input-container></div><div layout=\"row\"><div flex=\"35\" layout=\"column\" \nlayout-align=\"center end\"><span class=\"h3\"><b>Description </b></span></div><span flex=\"10\"></span><md-input-container \nflex=\"45\" class=\"md-block\" layout=\"column\" layout-align=\"space-around start\" \nstyle=\"padding-top: 0px !important;padding-bottom: 0px !important\"><input type=\"text\" name=\"name\" \nng-model=\"currentTemplate.description\" placeholder=\"Description\" required></md-input-container></div><div layout=\"row\">\n<div flex=\"35\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>DocumentType </b></span></div><span \nflex=\"10\"></span><md-select ng-model=\"currentTemplate.documentType\" placeholder=\"DocumentType\" flex=\"45\" \nstyle=\"margin-top:0px !important\"><md-option ng-value=\"doc.name\" ng-repeat=\"doc in Documents\">{{doc.name}}</md-option>\n</md-select></div><div layout=\"row\"><div flex=\"35\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>\nTemplate File</b></span></div><span flex=\"10\"></span><div flex=\"45\" layout=\"column\" layout-align=\"center start\"><input \nclass=\"ng-hide\" id=\"formUploadFile\" name=\"formUploadFile\" type=\"file\" \nonchange=\"angular.element(this).scope().setFile(this)\"><label for=\"formUploadFile\" \nclass=\"md-button md-raised md-accent\">Browse</label></div></div><div><div ng-repeat=\"file in files.slice(0)\" \nlayout=\"row\" layout-align=\"center center\"><span class=\"md-warn\">{{file.webkitRelativePath || file.name}}</span> (<span \nng-switch=\"file.size > 1024*1024\"> <span ng-switch-when=\"true\">{{file.size / 1024 / 1024 | number:2}} MB</span> <span \nng-switch-default>{{file.size / 1024 | number:2}} kB</span> </span>)</div></div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button \nng-click=\"update($event,currentTemplate)\">Update</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/administration/binder-management/attributes.binder.html","<md-dialog aria-label=\"Add a new user\" flex=\"75\"><form name=\"objectForm\" novalidate \nng-submit=\"objectForm.$valid && bsCtrl.detailsObject(object)\" layout=\"column\" flex=\"66\"><md-toolbar class=\"md-accent\">\n<div class=\"md-toolbar-tools\"><h2>Attributes of Binder : {{currentBinder.name}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><div><div layout=\"row\" \nlayout-align=\"space-around center\"><div class=\"table-header\"><span class=\"column-title\">NAME</span></div><div \nclass=\"table-header\"><span class=\"column-title\">TYPE</span></div><div class=\"table-header\"><span class=\"column-title\">\nRANGE</span></div><div class=\"table-header\"><span class=\"column-title\"></span></div></div><md-content><div \nng-repeat=\"element in attributes\" layout=\"row\" layout-align=\"center center\"><md-input-container class=\"md-block\" \nflex=\"20\"><input type=\"text\" name=\"type\" ng-model=\"element.label\"></md-input-container><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"20\"><md-select ng-model=\"element.type\"><md-option \nng-repeat=\"type in attributeTypes\" value=\"{{type}}\">{{type}}</md-option></md-select></md-input-container><span \nflex=\"15\"></span><md-input-container class=\"md-block\" flex=\"10\"><md-switch ng-model=\"element.range\" \naria-label=\"Switch\"></md-switch></md-input-container><md-input-container class=\"md-block\" flex=\"20\"><input type=\"text\" \nname=\"list\" ng-model=\"element.listReference\" ng-show=\"element.type == \'List\'\"></md-input-container><span flex=\"5\">\n</span></div></md-content></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\">\n<md-button ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"save()\">Update</md-button>\n</md-dialog-actions><md-button flow-btn class=\"md-fab md-accent md-fab-bottom-right\" aria-label=\"Create User\" \nng-click=\"addNewAttribute()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">New Attribute\n</md-tooltip></md-button></form></md-dialog>");
$templateCache.put("app/main/administration/binder-management/binder.html","<style>\n.mh-0 {\r\n    min-height: 0px !important;\r\n}\r\n.parent-tabs > md-tabs .md-tab.md-active:after{\r\n    content: \" \";\r\n    border-left: 7px solid transparent;\r\n    border-right: 7px solid transparent;\r\n    border-bottom: 7px solid #efefef;\r\n    position: absolute;\r\n    display: block;\r\n    top: 87%;\r\n    left: 50%;\r\n    \r\n}\r\n.parent-tabs > md-tabs md-ink-bar {\r\n    background: none; \r\n}\r\n.parent-tabs > md-tabs .md-tab:hover {\r\n    color: #389cec !important;\r\n}\r\n.md-tab {\r\n  \r\n  text-transform: none;\r\n  }\r\n  .table-border {\r\n    border: 1px solid #d3d3d3 !important;\r\n}\r\n.table-header {\r\n    background-color: #dee7f4 !important;\r\n    text-transform: uppercase;\r\n    font-size: 11px!important;\r\n}\n</style><div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Binders\" md-active=\"true\"></md-tab></md-tabs>\n</div><div class=\"md-padding white-bg\"><table class=\"dataTable row-border hover table-border table-header\" \ndatatable=\"ng\" dt-options=\"dtOptions\"><thead><tr class=\"table-header\"><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Description</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Site Id</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Business Object</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\" layout=\"row\" layout-align=\"center center\"><span class=\"column-title\">Actions</span></div></th>\n</tr></thead><tbody><tr ng-repeat=\"binder in bindersList | filter : searchUser\"><td>{{binder.name}}</td><td>\n{{binder.description}}</td><td>{{binder.siteId}}</td><td>{{binder.businessobject}}</td><td layout=\"row\" \nlayout-align=\"center center\" style=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button \nclass=\"md-icon-button test-tooltip\" aria-label=\"Update\" ng-click=\"attributesBinderDialog($event,binder)\"><md-tooltip \nmd-direction=\"top\">Attributes</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-dots-vertical s20\"></i></md-icon></md-button><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Update\" ng-click=\"updateBinderDialog($event,binder)\"><md-tooltip md-direction=\"top\">Update</md-tooltip>\n<md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s20\"></i></md-icon></md-button><md-button\n class=\"md-icon-button test-tooltip\" aria-label=\"Delete\" ng-click=\"deleteBinder($event,binder)\"><md-tooltip \nmd-direction=\"top\">Delete</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-delete s20\"></i></md-icon></md-button><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Folders\" ng-click=\"binderFoldersDialog($event,binder)\"><md-tooltip md-direction=\"top\">Folders</md-tooltip>\n<md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-folder s20\"></i></md-icon></md-button></td></tr>\n</tbody></table></div></ms-widget></div><md-button flow-btn \nclass=\"md-fab grey-700-bg md-mini md-fab-bottom-right add_btn\" ng-click=\"createBinderDialog($event)\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Create Binder</md-tooltip></md-button></div></div>");
$templateCache.put("app/main/administration/binder-management/create.binder.dialog.html","<md-dialog aria-label=\"Add a new object\" flex=\"30\" ng-init=\"getAllBusinessObjects()\"><form name=\"binderCreateForm\" \nnovalidate ng-submit=\"binderCreateForm.$valid && binderCrtl.createBinder(binder)\" layout=\"column\" flex=\"66\"><md-toolbar\n class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create Binder</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-input-container class=\"md-block\"><input type=\"text\" name=\"name\" \nng-model=\"binder.name\" placeholder=\"Name\" required><div ng-messages=\"binderCreateForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Name is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><input type=\"text\" name=\"description\" ng-model=\"binder.description\" placeholder=\"Description\" \nrequired><div ng-messages=\"binderCreateForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDescription is required</span></div></div></md-input-container><md-input-container class=\"md-block\"><input type=\"text\" \nname=\"siteId\" ng-model=\"binder.siteId\" placeholder=\"siteId\" required><div ng-messages=\"binderCreateForm.siteId.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>SiteId is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><label>Business Object</label><md-select ng-model=\"binder.businessObject\">\n<md-option ng-repeat=\"businessObject in allBusinessObjects\" ng-value=\"businessObject.name\" \nng-click=\"binderCrtl.selectBusinessObject(businessObject)\">{{businessObject.name}}</md-option></md-select>\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button \ntype=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"binderCreateForm.$valid && save(binder) \">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/binder-management/folders.binder.html","<md-dialog aria-label=\"Add a new object\" flex=\"30\"><script type=\"text/ng-template\" id=\"nodes_renderer2.html\">\n<div class=\"tree-node\">\r\n    <div class=\"tree-node-content\">\r\n      <a class=\"btn btn-success btn-xs\" data-nodrag ng-click=\"toggle(this)\">\r\n        <span class=\"icon\" ng-style=\"{\'font-size\': \'25px\'}\" ng-class=\"{\r\n          \'icon-chevron-right\': collapsed,\r\n          \'icon-chevron-down\': !collapsed\r\n          }\">\r\n        </span>\r\n        </span>\r\n      </a>\r\n      <input type=\"text\" name=\"name\" ng-model=\"node.title\" >\r\n      <md-button class=\"md-icon-button\" data-nodrag ng-click=\"newSubItem(this)\">\r\n        <md-icon class=\"icon icon-plus\" ng-style=\"{\'font-size\': \'25px\'}\"></md-icon>\r\n      </md-button>\r\n      <md-button class=\"pull-right md-icon-button\" data-nodrag ng-click=\"remove(this)\" >\r\n        <md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" ng-style=\"{\'font-size\': \'25px\'}\" ></md-icon>\r\n      </md-button>\r\n    </div>\r\n  </div>\r\n  <ol ui-tree-nodes=\"\" ng-model=\"node.nodes\" ng-class=\"{hidden: collapsed}\">\r\n    <li ng-repeat=\"node in node.nodes\" ui-tree-node ng-include=\"\'nodes_renderer2.html\'\">\r\n    </li>\r\n  </ol>\n</script><div ui-tree id=\"tree2-root\" data-clone-enabled=\"true\"><ol ui-tree-nodes=\"\" ng-model=\"treelist\"><li \nng-repeat=\"node in treelist\" ui-tree-node ng-include=\"\'nodes_renderer2.html\'\"></li></ol></div><md-dialog-actions \nlayout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/administration/binder-management/update.binder.dialog.html","<md-dialog aria-label=\"Add a new user\" flex=\"30\" ng-init=\"getAllBusinessObjects()\"><form name=\"binderUpdateForm\" \nnovalidate ng-submit=\"binderForm.$valid && binderCrtl.updateUser(binder)\" layout=\"column\" flex=\"66\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Edit Binder : {{currentBinder.name}}</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-input-container class=\"md-block\"><input type=\"text\" name=\"name\" \nng-model=\"currentBinder.name\" placeholder=\"Name\" required></md-input-container><md-input-container class=\"md-block\">\n<input type=\"text\" name=\"description\" ng-model=\"currentBinder.description\" placeholder=\"Description\" required>\n</md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"siteId\" \nng-model=\"currentBinder.siteId\" placeholder=\"siteId\" required></md-input-container><md-input-container \nclass=\"md-block\"><label>Business Object</label><md-select ng-model=\"businessObject\"><md-option \nng-repeat=\"businessObject in allBusinessObjects\" ng-value=\"businessObject.name\" \nng-click=\"binderCrtl.selectBusinessObject(businessObject)\">{{businessObject.name}}</md-option></md-select>\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button \ntype=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"binderUpdateForm.$valid && update(currentBinder)\">Update</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/business-object/bussiness.html","<style>\n.mh-0 {\r\n    min-height: 0px !important;\r\n}\r\n.parent-tabs > md-tabs .md-tab.md-active:after{\r\n    content: \" \";\r\n    border-left: 7px solid transparent;\r\n    border-right: 7px solid transparent;\r\n    border-bottom: 7px solid #efefef;\r\n    position: absolute;\r\n    display: block;\r\n    top: 87%;\r\n    left: 50%;\r\n    \r\n}\r\n.parent-tabs > md-tabs md-ink-bar {\r\n    background: none; \r\n}\r\n.parent-tabs > md-tabs .md-tab:hover {\r\n    color: #389cec !important;\r\n}\r\n.md-tab {\r\n  \r\n  text-transform: none;\r\n  }\r\n  .table-border {\r\n    border: 1px solid #d3d3d3 !important;\r\n}\r\n.table-header {\r\n    background-color: #dee7f4 !important;\r\n    text-transform: uppercase;\r\n    font-size: 11px!important;\r\n}\n</style><div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Bussiness Object\" md-active=\"true\"></md-tab>\n</md-tabs></div><div class=\"md-padding white-bg\"><table class=\"dataTable row-border hover table-border\" datatable=\"ng\" \ndt-options=\"dtOptions\"><thead><tr class=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Id</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Description</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">FormId</span></div></th><th class=\"secondary-text\"><div class=\"table-header\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr \nng-repeat=\"object in objectfiles\"><td>{{object.id}}</td><td>{{object.name}}</td><td>{{object.description}}</td><td>\n{{object.formId}}</td><td layout=\"row\" layout-align=\"center center\" \nstyle=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Update\" ng-click=\"detailsObjectDialog($event,object)\"><md-tooltip md-direction=\"top\">Details</md-tooltip>\n<md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-dots-vertical s20\"></i></md-icon></md-button>\n<md-button class=\"md-icon-button test-tooltip\" aria-label=\"Update\" ng-click=\"updateObjectDialog($event,object)\">\n<md-tooltip md-direction=\"top\">Update</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-pencil s20\"></i></md-icon></md-button><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Delete\" ng-click=\"deleteObject($event,object)\"><md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon>\n<i layout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s20\"></i></md-icon></md-button></td></tr></tbody>\n</table></div></ms-widget></div><md-button flow-btn class=\"md-fab grey-700-bg md-mini md-fab-bottom-right add_btn\" \nng-click=\"createObjectDialog($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">\nCreate Business Object</md-tooltip></md-button></div></div>");
$templateCache.put("app/main/administration/business-object/create.object.dialog.html","<md-dialog aria-label=\"Add a new object\" flex=\"30\"><form name=\"objectCreateForm\" novalidate \nng-submit=\"objectCreateForm.$valid && bsCtrl.createObject(object)\" layout=\"column\" flex=\"66\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create Business Object</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-input-container class=\"md-block\"><input type=\"text\" name=\"name\" \nng-model=\"object.name\" placeholder=\"Name\" required><div ng-messages=\"objectCreateForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Name is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><input type=\"text\" name=\"description\" ng-model=\"object.description\" placeholder=\"Description\" \nrequired><div ng-messages=\"objectCreateForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDescription is required</span></div></div></md-input-container><md-input-container class=\"md-block\"><label>Form Id\n</label><md-select ng-model=\"object.formId\"><md-option ng-value=\"formId\" ng-repeat=\"formId in ids\">{{formId}}\n</md-option></md-select></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"objectCreateForm.$valid && save(object) \">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/business-object/details.object.dialog.html","<md-dialog aria-label=\"Add a new user\" flex=\"75\"><form name=\"objectForm\" novalidate \nng-submit=\"objectForm.$valid && bsCtrl.detailsObject(object)\" layout=\"column\" flex=\"66\"><md-toolbar class=\"md-accent\">\n<div class=\"md-toolbar-tools\"><h2>Attributes of Business Object : {{currentObject.name}}</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><div><div layout=\"row\" \nlayout-align=\"space-around center\"><div class=\"table-header\"><span class=\"column-title\">NAME</span></div><div \nclass=\"table-header\"><span class=\"column-title\">TYPE</span></div><div class=\"table-header\"><span class=\"column-title\">\nRANGE</span></div><div class=\"table-header\"><span class=\"column-title\"></span></div></div><md-content><div \nng-repeat=\"element in attributes\" layout=\"row\" layout-align=\"center center\"><md-input-container class=\"md-block\" \nflex=\"20\"><input type=\"text\" name=\"type\" ng-model=\"element.label\"></md-input-container><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"20\"><md-select ng-model=\"element.type\"><md-option \nng-repeat=\"type in attributeTypes\" value=\"{{type}}\">{{type}}</md-option></md-select></md-input-container><span \nflex=\"15\"></span><md-input-container class=\"md-block\" flex=\"10\"><md-switch ng-model=\"element.range\" \naria-label=\"Switch\"></md-switch></md-input-container><md-input-container class=\"md-block\" flex=\"20\"><input type=\"text\" \nname=\"list\" ng-model=\"element.listReference\" ng-show=\"element.type == \'List\'\"></md-input-container><span flex=\"5\">\n</span></div></md-content></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\">\n<md-button ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"save()\">Update</md-button>\n</md-dialog-actions><md-button flow-btn class=\"md-fab md-accent md-fab-bottom-right\" aria-label=\"Create User\" \nng-click=\"addNewAttribute()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">New Attribute\n</md-tooltip></md-button></form></md-dialog>");
$templateCache.put("app/main/administration/business-object/update.object.dialog.html","<md-dialog aria-label=\"Add a new user\" flex=\"30\"><form name=\"objectUpdateForm\" layout=\"column\" flex=\"66\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Edit Business Object : {{currentObject.actvity}}</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-input-container class=\"md-block\"><input type=\"text\" \ndisabled=\"true\" name=\"id\" ng-model=\"currentObject.id\" placeholder=\"Id\" required></md-input-container>\n<md-input-container class=\"md-block\"><input type=\"text\" name=\"name\" ng-model=\"currentObject.name\" placeholder=\"Name\" \nrequired></md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"description\" \nng-model=\"currentObject.description\" placeholder=\"Description\" required></md-input-container><md-input-container \nclass=\"md-block\"><label>Form Id</label><md-select ng-model=\"currentObject.formId\"><md-option ng-value=\"formId\" \nng-repeat=\"formId in formIds\">{{formId}}</md-option></md-select></md-input-container></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel\n</md-button><md-button type=\"button\" ng-click=\"update(currentObject)\">Update</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/administration/common/admin.html","<style>\n[md-theme=\"default\"] a{\r\ncolor: black !important;\r\n}\r\n\r\nms-nav ms-nav-item .ms-nav-button.active{\r\ncolor: rgb(3,155,229) !important;\r\n}\r\n.static-side {\r\n    margin-bottom: 10px;\r\n    width: 200px;\r\n    border-radius: 3px;\r\n    border: 1px solid #d3d3d3;   \r\n}\r\n.static-side li.active>a {\r\n    color: #fff !important;\r\n    background-color: #3697ef;\r\n}\r\n.static-side li:hover {\r\n    color: #fff !important;\r\n    background-color: #3697ef !important;   \r\n}\r\n.static-side li:hover>a {\r\n    color: #fff !important;\r\n    background-color: #3697ef !important;   \r\n}\r\n.nav {\r\n    margin-bottom: 0;\r\n    padding-left: 0;\r\n    margin-top: 0;\r\n    list-style: none;\r\n}  \r\n.nav>li>a {\r\n    color: #515152 !important;\r\n    font-size: 14px;\r\n    display: block;\r\n    padding: 7px 15px;\r\n} \r\n.previous-state {\r\n    color: #52b8e9;\r\n    font-size: 12px;\r\n    text-transform: uppercase;\r\n    font-weight: 500;\r\n    width: 100%;\r\n    padding: 7px 15px; \r\n}\n</style><div class=\"page-layout simple right-sidenav\" hide-xs layout=\"row\"><div layout=\"column\" layout-wrap><ms-widget \nflippable=\"true\" layout=\"column\"><div class=\"static-side white-bg\" layout=\"column\"><ul class=\"nav\"><li \nclass=\"previous-state c-p\" data-ng-click=\"goToPreviousState()\"><span><span class=\"icon-arrow-left-bold-circle-outline\">\n</span> Back</span></li><li \nng-class=\"{active: $state.includes(\'app.administration.users\') || $state.includes(\'app.administration.groups\') || $state.includes(\'app.administration.userupload\')}\">\n<a ui-sref=\"app.administration.users\">User Management <span class=\"icon-chevron-right pull-right\"></span></a></li><li \nng-class=\"{active: $state.includes(\'app.administration.settings.account\') || $state.includes(\'app.administration.settings.technical\') || $state.includes(\'app.administration.settings.help\') || $state.includes(\'app.administration.settings.solar\') || $state.includes(\'app.administration.settings.smartstore\') || $state.includes(\'app.administration.settings.brand\') || $state.includes(\'app.administration.settings.site\') || $state.includes(\'app.administration.settings.menubar\')}\">\n<a ui-sref=\"app.administration.settings.account\">Settings <span class=\"icon-chevron-right pull-right\"></span></a></li>\n</ul></div></ms-widget></div></div><ms-nav hide-gt-md style=\"margin-top: 10px\"><ms-nav-item ms-nav-toggle \ncollapsed=\"true\"><a style=\"background: #5fa648\" ms-nav-button md-ink-ripple><i class=\"icon-tile-four s16\"></i> <span \nstyle=\"color: black\" class=\"ms-nav-label\" translate=\"ADMIN.DASHBOARDS\">Dashboards</span> <i style=\"color: black\" \nclass=\"icon-chevron-down s16 arrow\"></i></a><ms-nav-toggle-items><ms-nav-item><a ms-nav-button \nui-sref=\"app.administration.users\" ui-sref-active=\"active\" md-ink-ripple><span class=\"ms-nav-label\">User Management\n</span></a></ms-nav-item><ms-nav-item><a ms-nav-button ui-sref=\"app.administration.forms\" ui-sref-active=\"active\" \nmd-ink-ripple><span class=\"ms-nav-label\">Forms Management</span></a></ms-nav-item><ms-nav-item><a ms-nav-button \nui-sref=\"app.administration.lists\" ui-sref-active=\"active\" md-ink-ripple><span class=\"ms-nav-label\">List Management\n</span></a></ms-nav-item><ms-nav-item><a ms-nav-button ui-sref=\"app.administration.workflow-management\" \nui-sref-active=\"active\" md-ink-ripple><span class=\"ms-nav-label\">Workflow Management</span></a></ms-nav-item>\n<ms-nav-item><a ms-nav-button ui-sref=\"app.administration.bussiness-object\" ui-sref-active=\"active\" md-ink-ripple><span\n class=\"ms-nav-label\">Bussiness Object</span></a></ms-nav-item><ms-nav-item><a ms-nav-button \nui-sref=\"app.administration.requestType\" ui-sref-active=\"active\" md-ink-ripple><span class=\"ms-nav-label\">\nRequests Management</span></a></ms-nav-item><ms-nav-item><a ms-nav-button ui-sref=\"app.administration.settings\" \nui-sref-active=\"active\" md-ink-ripple><span class=\"ms-nav-label\">Settings</span></a></ms-nav-item><ms-nav-item><a \nui-sref-active=\"active\" ms-nav-button ui-sref=\"app.administration.binder\" md-ink-ripple><span class=\"ms-nav-label\">\nBinder</span></a></ms-nav-item><ms-nav-item><a ui-sref-active=\"active\" ms-nav-button \nui-sref=\"app.administration.documentType\" md-ink-ripple><span class=\"ms-nav-label\">Document Types</span></a>\n</ms-nav-item><ms-nav-item><a ui-sref-active=\"active\" ms-nav-button ui-sref=\"app.administration.template\" \nmd-ink-ripple><span class=\"ms-nav-label\">Templates</span></a></ms-nav-item><ms-nav-item><a ui-sref-active=\"active\" \nms-nav-button ui-sref=\"app.administration.reports\" md-ink-ripple><span class=\"ms-nav-label\">Reports</span></a>\n</ms-nav-item></ms-nav-toggle-items></ms-nav-item></ms-nav><script>\nif (screen.width < 600) {\r\n    $(\"#vertical-navigation\").show();\r\n}else{\r\n	$(\"#vertical-navigation\").hide();\r\n}\n</script>");
$templateCache.put("app/main/administration/document-type/addSiteDialog.html","<md-dialog flex=\"50\"><form name=\"siteMembersCtrl.memberForm\" role=\"form\" novalidate ng-submit=\" \"><md-toolbar \nlayout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Add {{sitedisplayname}}</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content layout=\"column\" layout-align=\"center center\"><div layout=\"row\" class=\"md-padding\">\n<md-input-container class=\"md-block\" flex=\"50\"><input type=\"text\" name=\"name\" ng-model=\"queryname\" placeholder=\"Name\">\n</md-input-container><span flex=\"5\"></span><div class=\"md-padding\"><md-button type=\"button\" class=\"md-raised\" \nng-click=\"searchSite(queryname)\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>Search {{sitedisplayname}}</md-button>\n</div></div><div ng-show=\"tableVisibility\" class=\"md-padding scrollable\" ms-scroll><table><thead><tr><th \nclass=\"secondary-text md-padding\"><div class=\"table-header\"><span class=\"column-title\">{{sitedisplayname}} Name</span>\n</div></th><th class=\"secondary-text md-padding\"><div class=\"table-header\"><span class=\"column-title\">\n{{sitedisplayname}} Id</span></div></th></tr></thead><tbody><tr ng-repeat=\"site in searchedSites\"><td \nclass=\"md-padding\">{{site.name}}</td><td class=\"md-padding\">{{site.id}}</td><td layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-click=\"addSite(site,documentType) \">ADD\n</md-button></td></tr></tbody></table></div></md-dialog-content></form><md-dialog-actions layout=\"row\"><span flex>\n</span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button ng-click=\"ok()\" md-autofocus>Ok</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/administration/document-type/attributes.documenttype.html","<md-dialog aria-label=\"Add new Attributes\" flex=\"75\"><form name=\"DoctypeForm\" novalidate \nng-submit=\"DoctypeForm.$valid && save()\" layout=\"column\" flex=\"66\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Attributes of DocumentType:{{currentDocType.name}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><div><div layout=\"row\" \nlayout-align=\"space-around center\"><div class=\"table-header\"><span class=\"column-title\">NAME</span></div><div \nclass=\"table-header\"><span class=\"column-title\">TYPE</span></div><div class=\"table-header\"><span class=\"column-title\">\nREQUIRED</span></div><div class=\"table-header\"><span class=\"column-title\"></span></div></div><md-content><div \nng-repeat=\"element in attributes\" layout=\"row\" layout-align=\"center center\"><md-input-container class=\"md-block\" \nflex=\"20\"><input type=\"text\" name=\"name\" ng-model=\"element.name\" ng-required=\"true\"><div \nng-messages=\"DoctypeForm.name.$error\" role=\"alert\"><div ng-message=\"required\">Enter attribute name</div></div>\n</md-input-container><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\"><md-select \nng-model=\"element.type\"><md-option ng-repeat=\"type in attributeTypes\" value=\"{{type}}\">{{type}}</md-option></md-select>\n</md-input-container><span flex=\"15\"></span><md-input-container class=\"md-block\" flex=\"10\"><md-switch \nng-model=\"element.required\" aria-label=\"Switch\"></md-switch></md-input-container><span flex=\"5\"></span><md-button \nclass=\"md-icon-button md-accent\" ng-click=\"removeAttribute($index)\"><md-tooltip md-direction=\"top\">Delete</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></md-content></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button ng-click=\"cancel()\">Cancel</md-button>\n<md-button type=\"submit\">Update</md-button></md-dialog-actions><md-button flow-btn \nclass=\"md-fab md-accent md-fab-bottom-right\" aria-label=\"Create User\" ng-click=\"addNewAttribute()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">New Attribute</md-tooltip></md-button></form>\n</md-dialog>");
$templateCache.put("app/main/administration/document-type/configureapproval.html","<md-dialog flex=\"45\"><form name=\"ApprovalForm\" novalidate \nng-submit=\"ApprovalForm.$valid && submitApprovalConfig(configureApproval, currentDocType)\" layout=\"column\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Configure Approval</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><div layout=\"row\" \nlayout-align=\"start Start\" class=\"md-padding\"><div><span class=\"h3\"><b>Approval Required </b></span></div><span \nflex=\"5\"></span><md-checkbox ng-model=\"configureApproval.docuemntApprovalConfig.approvalsRequired.Upload\" \naria-label=\"Upload\" ng-true-value=\"\'Upload\'\" ng-false-value=\"\'\'\">Upload</md-checkbox><span flex=\"5\"></span><md-checkbox\n ng-model=\"configureApproval.docuemntApprovalConfig.approvalsRequired.Share\" aria-label=\"Share\" \nng-true-value=\"\'Share\'\" ng-false-value=\"\'\'\">Share</md-checkbox><span flex=\"5\"></span><md-checkbox \nng-model=\"configureApproval.docuemntApprovalConfig.approvalsRequired.Delete\" aria-label=\"Delete\" \nng-true-value=\"\'Delete\'\" ng-false-value=\"\'\'\">Delete</md-checkbox><span flex=\"5\"></span><md-checkbox \nng-model=\"configureApproval.docuemntApprovalConfig.approvalsRequired.Edit\" aria-label=\"Edit\" ng-true-value=\"\'Edit\'\" \nng-false-value=\"\'\'\">Edit</md-checkbox></div><md-divider></md-divider><div layout=\"row\" layout-align=\"start Start\" \nclass=\"md-padding\"><div><span class=\"h3\"><b style=\"padding-top:15px !important\">Approvers:</b></span></div><span \nflex=\"5\"></span><div class=\"scrollable md-padding\" ms-scroll><div layout=\"row\" class=\"md-padding pl-0\"><md-radio-group \nng-model=\"searchElements.type\" style=\"display: -webkit-inline-box\"><md-radio-button class=\"pr-15\" value=\"user\" \nng-disabled=\"!configureApproval.docuemntApprovalConfig.approvalsRequired.Upload  && !configureApproval.docuemntApprovalConfig.approvalsRequired.Share && !configureApproval.docuemntApprovalConfig.approvalsRequired.Delete && !configureApproval.docuemntApprovalConfig.approvalsRequired.Edit \">\nUsers</md-radio-button><md-radio-button value=\"group\" \nng-disabled=\"!configureApproval.docuemntApprovalConfig.approvalsRequired.Upload  && !configureApproval.docuemntApprovalConfig.approvalsRequired.Share && !configureApproval.docuemntApprovalConfig.approvalsRequired.Delete && !configureApproval.docuemntApprovalConfig.approvalsRequired.Edit\">\nUsers Group</md-radio-button></md-radio-group></div><div layout=\"row\"><md-input-container class=\"no-padding no-margin\" \nflex=\"45\"><input type=\"text\" name=\"name\" ng-model=\"searchElements.text\" \nng-disabled=\"!configureApproval.docuemntApprovalConfig.approvalsRequired.Upload  && !configureApproval.docuemntApprovalConfig.approvalsRequired.Share && !configureApproval.docuemntApprovalConfig.approvalsRequired.Delete && !configureApproval.docuemntApprovalConfig.approvalsRequired.Edit\" \nplaceholder=\"Search here\" required></md-input-container><md-button class=\"md-raised\" \nng-disabled=\"searchElements.text == undefined\" ng-click=\"searchUsers(searchElements)\" style=\"height: 35px;top: -11px\">\nSearch</md-button></div></div></div><div class=\"scrollable md-padding pt-0\" ms-scroll layout=\"column\" \nlayout-align=\"center center\"><table class=\"simple\" ng-show=\"searchedUsers.data.length > 0\"><thead><tr><th \nclass=\"secondary-text md-padding\"><span class=\"column-title\">NAME</span></th><th class=\"secondary-text md-padding\">\n<span class=\"column-title\">TYPE</span></th></tr></thead><tbody><tr \ndata-ng-repeat=\"(key,value) in searchedUsers.data track by $index\"><td class=\"no-padding\" \ndata-ng-if=\"searchedUsers.type == \'user\'\" style=\"padding-left: 10px !important;padding-right: 10px !important\">\n{{value.firstName}} {{value.lastName}}</td><td class=\"no-padding\" data-ng-if=\"searchedUsers.type == \'user\'\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important\">{{searchedUsers.type}}</td><td class=\"no-padding\" \ndata-ng-if=\"searchedUsers.type == \'group\'\" style=\"padding-left: 10px !important;padding-right: 10px !important\">\n{{value.name}}</td><td class=\"no-padding\" data-ng-if=\"searchedUsers.type == \'group\'\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important\">{{searchedUsers.type}}</td><td class=\"no-padding\">\n<md-button class=\"md-accent md-raised md-mini\" ng-click=\"addApprover(value,searchedUsers.type) \">ADD</md-button></td>\n</tr></tbody></table></div><div layout=\"column\"><div flex=\"20\" class=\"md-padding\"><div><md-toolbar><div \nclass=\"md-toolbar-tools\"><span>Approvers</span></div></md-toolbar><md-content flex \nng-style=\"{\'border\': \'1px solid #cccccc\'}\" class=\"scrollable\" ms-scroll><div ng-switch=\"(allApprovers).length\"><div \nng-switch-when=\"0\" layout=\"row\" layout-align=\"center center\"><p class=\"md-padding md-subhead md-primary-fg\">\n{{\'No Approver yet...\' | uppercase}}</p></div><div ng-switch-default ng-style=\"{\'height\':\'190px\'}\"><table \nclass=\"simple list-view\"><tbody><tr ng-repeat=\"approver in allApprovers\"><td data-ng-if=\"approver.type != \'user\'\"><i \nclass=\"fa fa-users\" aria-hidden=\"true\"></i> {{approver.objectId}}</td><td data-ng-if=\"approver.type == \'user\'\"><i \nclass=\"fa fa-user\" aria-hidden=\"true\"></i>{{approver.objectId}}</td><td class=\"no-padding\"><md-button \nclass=\"md-secondary md-icon-button\" ng-click=\"removeApprover(index)\"><md-tooltip md-direction=\"top\">Delete</md-tooltip>\n<md-icon><i class=\"icon icon-delete s30\"></i></md-icon></md-button></td></tr></tbody></table></div></div></md-content>\n</div></div></div><md-divider></md-divider><div layout=\"row\" layout-align=\"start Start\" class=\"md-padding\"><div><span \nclass=\"h3\"><b>If Request Approved </b></span></div><span flex=\"10\"></span><div layout=\"column\"><md-checkbox \nng-model=\"configureApproval.docuemntApprovalConfig.requestApproved_notifyRequester\" \naria-label=\"Send Email to Requesters\">Send Email to Requester</md-checkbox><md-checkbox \nng-model=\"configureApproval.docuemntApprovalConfig.requestApproved_notifyApprover\" aria-label=\"Send Email to Appovers\">\nSend Email to Approver</md-checkbox></div></div><md-divider></md-divider><div layout=\"row\" layout-align=\"start Start\" \nclass=\"md-padding\"><div><span class=\"h3\"><b>If Request is Denied </b></span></div><span flex=\"10\"></span><div \nlayout=\"column\"><md-checkbox ng-model=\"configureApproval.docuemntApprovalConfig.requestDenied_notifyRequester\" \naria-label=\"Send Email to Requesters\">Send Email to Requester</md-checkbox><md-checkbox \nng-model=\"configureApproval.docuemntApprovalConfig.requestDenied_notifyApprover\" aria-label=\"Send Email to Appovers\">\nSend Email to Approver</md-checkbox></div></div><md-divider></md-divider><div layout=\"row\"><div flex=\"35\" \nlayout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>End In </b></span></div><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"25\" layout=\"column\" layout-align=\"space-around start\" \nstyle=\"padding-top: 0px !important;padding-bottom: 0px !important\"><md-select \nng-model=\"configureApproval.docuemntApprovalConfig.approverRespondDuration\"><md-option \nng-repeat=\"duration in durations\" ng-value=\"duration.value\">{{duration.days}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-align=\"start Start\" class=\"md-padding\"><div><span class=\"h3\"><b>\nIf Request is Expired </b></span></div><span flex=\"10\"></span><div layout=\"column\"><md-checkbox \nng-model=\"configureApproval.docuemntApprovalConfig.requestExpires__notifyRequester\" \naria-label=\"Send Email to Requesters\">Send Email to Requester</md-checkbox><md-checkbox \nng-model=\"configureApproval.docuemntApprovalConfig.requestExpires_notifyApprover\" aria-label=\"Send Email to Appovers\">\nSend Email to Approver</md-checkbox></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span>\n<md-button ng-click=\"cancel()\">Cancel</md-button><md-button \nng-click=\"submitApprovalConfig(configureApproval, currentDocType)\">Save</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/administration/document-type/createdoctype.dialog.html","<md-dialog aria-label=\"Add Document Type\" flex=\"60\"><form name=\"documentForm\" novalidate \nng-submit=\"documentForm.$valid && doctypeCrtl.createDocumentType()\" layout=\"column\" flex><md-toolbar class=\"md-accent\">\n<div class=\"md-toolbar-tools\"><h2>Create Document Type</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\"><div flex=\"45\">\n<md-input-container class=\"md-block\"><label>Name</label><input type=\"text\" name=\"name\" ng-pattern=\"/^[a-zA-Z ]*$/\" \nng-model=\"documentType.name\" required><div ng-messages=\"documentForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Name is required</span></div><div ng-message=\"pattern\"><span>Name has invalid characters\n</span></div></div></md-input-container></div><span flex=\"10\"></span><div flex=\"45\"><md-input-container \nclass=\"md-block\"><input type=\"text\" name=\"description\" ng-pattern=\"/^[a-zA-Z ]*$/\" ng-model=\"documentType.description\" \nplaceholder=\"Desription\"><div ng-messages=\"documentForm.description.$error\" role=\"alert\"><div ng-message=\"pattern\">\n<span>Description has invalid characters</span></div></div></md-input-container></div></div><div layout=\"row\" \nlayout-align=\"center center\"><div flex=\"45\"><md-input-container class=\"md-block\"><label>Display Form</label><md-select \nng-model=\"documentType.formId\"><md-option ng-value=\"form.name\" ng-repeat=\"form in forms\">{{form.name}}</md-option>\n</md-select></md-input-container></div><div flex=\"10\"></div><div flex=\"45\">Approval Required:<md-checkbox \nng-model=\"documentType.approvalRequired\" aria-label=\"Checkbox 1\"></md-checkbox></div></div><md-dialog-content \nclass=\"scrollable\" ms-scroll><div class=\"md-body-2\" ng-style=\"{color:\'red\'}\" ng-hide=\"attributes.length != 0\" \nlayout=\"row\" layout-align=\"center center\">{{Error.message}}</div><div style=\"margin-top: -5% !important\"><h2 \nng-hide=\"attributes.length == 0\">Attributes of DocumentType</h2><div layout=\"row\" layout-align=\"space-around center\" \nng-hide=\"attributes.length == 0\"><div class=\"table-header\"><span class=\"column-title\">NAME</span></div><div \nclass=\"table-header\"><span class=\"column-title\">TYPE</span></div><div class=\"table-header\" \nstyle=\"margin-right: -12% !important\"><span class=\"column-title\">REQUIRED</span></div><div class=\"table-header\"><span \nclass=\"column-title\"></span></div></div><md-content class=\"scrollable\" ms-scroll><div \nng-repeat=\"element in attributes\" layout=\"row\" layout-align=\"center center\" style=\"margin-bottom: -5%\">\n<md-input-container class=\"md-block\" flex=\"20\"><input type=\"text\" name=\"name\" ng-model=\"element.name\" required><div \nng-messages=\"documentForm.name.$error\" role=\"alert\"><div ng-message=\"required\">Enter attribute name</div></div>\n</md-input-container><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\" \nstyle=\"margin-top: -1% !important\"><md-select ng-model=\"element.type\"><md-option ng-repeat=\"type in attributeTypes\" \nvalue=\"{{type}}\">{{type}}</md-option></md-select></md-input-container><span flex=\"15\"></span><md-input-container \nclass=\"md-block\" flex=\"10\"><md-switch ng-model=\"element.required\" aria-label=\"Switch\"></md-switch></md-input-container>\n<span flex=\"5\"></span><md-button class=\"md-icon-button md-accent\" ng-click=\"removeAttribute($index)\"><md-tooltip \nmd-direction=\"top\">Delete</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></md-content>\n</div><md-button flow-btn class=\"md-fab md-accent md-mini md-fab-bottom-right\" aria-label=\"Create User\" \nng-click=\"addNewAttribute()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">New Attribute\n</md-tooltip></md-button></md-dialog-content></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"documentForm.$valid && save(documentType)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/document-type/documenttype.html","<style>\n.mh-0 {\r\n    min-height: 0px !important;\r\n}\r\n.parent-tabs > md-tabs .md-tab.md-active:after{\r\n    content: \" \";\r\n    border-left: 7px solid transparent;\r\n    border-right: 7px solid transparent;\r\n    border-bottom: 7px solid #efefef;\r\n    position: absolute;\r\n    display: block;\r\n    top: 87%;\r\n    left: 50%;\r\n    \r\n}\r\n.parent-tabs > md-tabs md-ink-bar {\r\n    background: none; \r\n}\r\n.parent-tabs > md-tabs .md-tab:hover {\r\n    color: #389cec !important;\r\n}\r\n.md-tab {\r\n  \r\n  text-transform: none;\r\n  }\r\n  .table-border {\r\n    border: 1px solid #d3d3d3 !important;\r\n}\r\n.table-header {\r\n    background-color: #dee7f4 !important;\r\n    text-transform: uppercase;\r\n    font-size: 11px!important;\r\n}\n</style><div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Document Type\" md-active=\"true\"></md-tab>\n</md-tabs></div><div class=\"md-padding white-bg\"><table class=\"dataTable row-border hover table-border\" datatable=\"ng\" \ndt-options=\"doctypeCrtl.dtOptions\"><thead><tr class=\"table-header\"><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Description</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\" layout=\"row\" layout-align=\"center center\"><span class=\"column-title\">Actions</span></div></th><th>\n</th></tr></thead><tbody><tr ng-repeat=\"documentType in documentsList \"><td>{{documentType.name}}</td><td>\n{{documentType.description}}</td><td layout=\"row\" layout-align=\"center center\" \nstyle=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button class=\"md-icon-button test-tooltip\" \nid=\"{{documentType.id}}\" aria-label=\"Update\" onclick=\"angular.element(this).scope().updateDocumentTypeDialog(this)\">\n<md-tooltip md-direction=\"top\">Update</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-pencil s18\"></i></md-icon></md-button><md-button class=\"md-icon-button test-tooltip\" \nid=\"{{documentType.id}}\" aria-label=\"Delete\" onclick=\"angular.element(this).scope().deleteDocumentType(this)\">\n<md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-delete s18\"></i></md-icon></md-button><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"siteupdate\" id=\"{{documentType.id}}\" onclick=\"angular.element(this).scope().goTositeConfig(this)\">\n<md-tooltip md-direction=\"top\">Site Configuration</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-web s20\"></i></md-icon></md-button><md-button class=\"md-icon-button test-tooltip\" aria-label=\"Update\" \nid=\"{{documentType.id}}\" onclick=\"angular.element(this).scope().configureApprovalDialog(this)\"><md-tooltip \nmd-direction=\"top\">Configure Approval</md-tooltip><md-icon \nng-hide=\"documentType.approvalRequired == true && documentType.docuemntApprovalConfig == null || documentType.docuemntApprovalConfig.agents.length == 0\">\n<i layout=\"row\" layout-align=\"center center\" class=\"icon icon-check-circle s20\" style=\"color:green\"></i></md-icon>\n<md-icon \nng-if=\"documentType.approvalRequired == true && documentType.docuemntApprovalConfig == null || documentType.docuemntApprovalConfig.agents.length == 0  \">\n<i layout=\"row\" layout-align=\"center center\" class=\"icon icon-check-circle s20\" style=\"color:red\"></i></md-icon>\n</md-button></td><td><div \nng-if=\"documentType.docuemntApprovalConfig == null && documentType.approvalRequired == true || documentType.docuemntApprovalConfig.agents.length == 0\" \nstyle=\"color:red\">Please Create Approval Config</div></td></tr></tbody></table></div></ms-widget></div><md-button \nflow-btn class=\"md-fab grey-700-bg md-mini md-fab-bottom-right add_btn\" ng-click=\"createDocumentTypeDialog(ev)\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Create DocType</md-tooltip></md-button>\n</div></div>");
$templateCache.put("app/main/administration/document-type/siteConfigureDialog.html","<div class=\"page-layout simple right-sidenav\" layout=\"row\" ng-init=\"doctypeCrtl.getDocumentTypeSites()\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div class=\"md-padding white-bg\">\n<md-button ng-click=\"doctypeCrtl.goTomain()\"><md-icon md-font-icon=\"icon-keyboard-return\"></md-icon>Back</md-button>\n<md-toolbar layout=\"column\" class=\"md-accent\" flex=\"50\" layout-align=\"center center\"><div class=\"md-toolbar-tools\">\n<span>{{sitedisplayname}}Configuration {{doctypeCrtl.docTypeName}}</span></div><div><md-button flow-btn \nclass=\"md-fab grey-700-bg md-mini md-fab-top-right\" ng-click=\"addSiteDialog($event)\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon><md-tooltip md-direction=\"top\">Add {{sitedisplayname}}</md-tooltip></md-button></div></md-toolbar><md-content\n flex=\"50\" ng-style=\"{\'border\': \'1px solid #cccccc\'}\" class=\"scrollable\" ms-scroll><div \nng-switch=\"doctypeCrtl.sites.length\"><div ng-switch-when=\"0\" layout=\"row\" layout-align=\"center center\"><p \nclass=\"md-padding md-subhead md-primary-fg\">NO {{sitedisplayname | uppercase}} YET</p></div><div ng-switch-default \nng-style=\"{\'height\':\'280px\'}\"><md-list><md-list-item class=\"md-2-line\" ng-repeat=\"site in doctypeCrtl.sites\" \nng-click=\"null\"><div class=\"md-list-item-text\" layout=\"column\"><h3>{{ site.name }}</h3><p>{{ site.description }}</p>\n<md-button class=\"md-secondary md-icon-button\" ng-click=\"doctypeCrtl.deleteSite($event,site)\"><md-tooltip \nmd-direction=\"top\">Delete</md-tooltip><md-icon><i class=\"icon icon-delete s30\"></i></md-icon></md-button></div>\n<md-divider></md-divider></md-list-item></md-list></div></div></md-content></div></ms-widget></div></div></div>");
$templateCache.put("app/main/administration/document-type/updatedoctype.dialog.html","<md-dialog aria-label=\"Update Document Type\" flex=\"60\"><form name=\"documentUpdateForm\" novalidate \nng-submit=\"documentUpdateForm.$valid && update(currentDocType)\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Update Document Type</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\"><div flex=\"45\">\n<md-input-container class=\"md-block\"><label>Name</label><input type=\"text\" name=\"name\" ng-pattern=\"/^[a-zA-Z ]*$/\" \nng-model=\"currentDocType.name\" required><div ng-messages=\"documentForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Name is required</span></div><div ng-message=\"pattern\"><span>Name has invalid characters\n</span></div></div></md-input-container></div><span flex=\"10\"></span><div flex=\"45\"><md-input-container \nclass=\"md-block\"><input type=\"text\" name=\"description\" ng-pattern=\"/^[a-zA-Z ]*$/\" \nng-model=\"currentDocType.description\" placeholder=\"Desription\"><div ng-messages=\"documentForm.description.$error\" \nrole=\"alert\"><div ng-message=\"pattern\"><span>Description has invalid characters</span></div></div></md-input-container>\n</div></div><div layout=\"row\" layout-align=\"center center\"><div flex-gt-sm=\"40\">Approval Required:<md-checkbox \nng-model=\"currentDocType.approvalRequired\" aria-label=\"Checkbox 1\"></md-checkbox></div><div flex-gt-sm=\"40\">\n<md-input-container class=\"md-block\"><label>Display Form</label><md-select ng-model=\"doc.formId\"><md-option \nng-value=\"form.id\" ng-repeat=\"form in forms\">{{form.name}}</md-option></md-select></md-input-container></div></div>\n<md-dialog-content class=\"scrollable\" ms-scroll><div><h2>Attributes of DocumentType:{{currentDocType.name}}</h2><table \nclass=\"simple table-border\" ms-responsive-table><thead><tr class=\"table-header\"><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">NAME</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">TYPE</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">REQUIRED</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\" layout=\"row\" layout-align=\"center center\"><span class=\"column-title\">Actions</span></div></th>\n</tr></thead><tbody><tr ng-repeat=\"element in attributes\"><td><md-input-container class=\"md-block\" flex=\"20\"><input \ntype=\"text\" name=\"name\" ng-model=\"element.name\" ng-required=\"true\"><div ng-messages=\"DoctypeForm.name.$error\" \nrole=\"alert\"><div ng-message=\"required\">Enter attribute name</div></div></md-input-container></td><td>\n<md-input-container class=\"md-block\" flex=\"20\" style=\"margin-top: -1% !important\"><md-select ng-model=\"element.type\">\n<md-option ng-repeat=\"type in attributeTypes\" value=\"{{type}}\">{{type}}</md-option></md-select></md-input-container>\n</td><td><md-input-container class=\"md-block\" flex=\"10\"><md-switch ng-model=\"element.required\" aria-label=\"Switch\">\n</md-switch></md-input-container></td><td><md-input-container class=\"md-block\" flex=\"10\"><md-button \nclass=\"md-icon-button md-accent\" ng-click=\"removeAttribute($index)\"><md-tooltip md-direction=\"top\">Delete</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></md-input-container></td></tr></tbody></table></div>\n<md-button flow-btn class=\"md-fab md-mini md-accent md-fab-bottom-right\" aria-label=\"Create User\" \nng-click=\"addNewAttribute()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">New Attribute\n</md-tooltip></md-button></md-dialog-content></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"center center\"><md-button ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\">Update\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/forms-management/createForm.html","<style>\nbody {\r\n   padding: 0;\r\n   margin: 10px 0;\r\n   background: #f2f2f2 url(\'http://formbuilder.readthedocs.io/en/latest/img/noise.png\');\r\n   }\r\n  \r\n   label{\r\n		line-height: 5px;\r\n		font-weight: bold;\r\n	}\r\n	input{\r\n		border-radius: 2px !important;\r\n		padding: 10px !important;\r\n	}\r\n	li span{\r\n		font-size:14px !important;\r\n		font-family:Arial !important;\r\n	}\n</style><div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div class=\"widget-group scrollable\" flex=\"100\" \nlayout=\"column\" layout-wrap ms-scroll><ms-widget><div class=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab \nlabel=\"Forms\" ui-sref=\"app.administration.forms\"></md-tab><md-tab label=\"Create Forms\" \nui-sref=\"app.administration.createform\" md-active=\"true\"></md-tab></md-tabs></div><div class=\"md-padding\" \nng-show=\"createFormDiv\" id=\"createFormDiv\"><div id=\"build-wrap\"></div><div layout=\"row\" layout-align=\"end center\" \nclass=\"md-padding\"><button id=\"preview\" type=\"button\" \nstyle=\"background-color: #aeb6b3;padding: 0.75%;border-radius: 5px;width: 10%\">Preview</button> <span \nstyle=\"width:15px !important\"></span> <button id=\"getJSONAndSave\" type=\"button\" \nstyle=\"background-color: #aeb6b3;padding: 0.75%;border-radius: 5px;width: 10%\">Save</button> <span \nstyle=\"width:15px !important\"></span> <button id=\"clear-all-fields\" type=\"button\" \nstyle=\"background-color: #ff7e71;padding: 0.75%;border-radius: 5px;width: 10%\">Clear Fields</button></div><div \nclass=\"addFieldWrap\"></div></div><div id=\"previewForm\" class=\"md-padding\"><div layout=\"row\" \nstyle=\"background-color: #e5e5e5\" class=\"md-padding\"><div class=\"fb-render\" style=\"width: 95%;margin-top:1%\"><div \nid=\"fb-template\"></div></div></div><div layout=\"row\" layout-align=\"end center\" class=\"md-padding\"><button id=\"edit\" \ntype=\"button\" style=\"background-color: #aeb6b3;padding: 0.75%;border-radius: 5px;width: 10%\">Back to Edit</button>\n</div></div><div layout=\"row\" layout-align=\"end center\" flex=\"100\" id=\"submitDiv\"><div flex=\"70\" layout=\"row\"><div \nflex=\"25\" layout=\"row\"><h3 flex=\"45\">Name</h3><span flex=\"10\"></span><md-input-container class=\"md-block\" flex=\"45\" \nstyle=\"margin:0px\"><input type=\"text\" name=\"name\" ng-model=\"form.name\" required></md-input-container></div><span \nflex=\"5\"></span><div flex=\"25\" layout=\"row\"><h3 flex=\"45\">Description</h3><span flex=\"10\"></span><md-input-container \nclass=\"md-block\" flex=\"45\" style=\"margin:0px\"><input type=\"text\" name=\"description\" ng-model=\"form.description\" \nrequired></md-input-container></div><span flex=\"5\"></span><div><md-button class=\"md-accent\" \nng-click=\"submitJsonForm(form)\">Submit</md-button></div></div></div></ms-widget></div></div>");
$templateCache.put("app/main/administration/forms-management/form.content.html","<div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\">><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div class=\"page-layout carded fullwidth scrollable\" \nlayout=\"column\" flex ms-scroll md-dynamic-height><div class=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap>\n<ms-widget ng-init=\"isHeaderView = true;\"><div class=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab \nlabel=\"Forms\" md-active=\"true\"></md-tab></md-tabs></div><div class=\"child-tabs white-bg\"><md-tabs class=\"mh-0\"><md-tab \nlabel=\"Header\" md-active=\"isHeaderView\" md-on-select=\"isHeaderView = true;\"></md-tab><md-tab label=\"Line Items\" \nmd-active=\"!isHeaderView\" md-on-select=\"isHeaderView = false;\"></md-tab></md-tabs></div><md-divider></md-divider><div \nclass=\"white-bg md-padding\" layout=\"row\"><div flex=\"100\"><div class=\"md-padding pt-0 pl-0\" layout=\"row\"><span \nclass=\"md-active c-p\" ui-sref=\"app.administration.forms\" style=\"display: inherit\"><md-icon \nmd-font-icon=\"icon-arrow-left md-active s16\"></md-icon>Go back</span></div><div layout=\"row\" \nlayout-align=\"center center\" data-ng-show=\"isHeaderView\"><div flex=\"50\" style=\"border: 1px solid #cccccc\"><form \nname=\"headerForm\" novalidate><div ng-bind-html=\"currentFormHeader\" compile-template></div></form></div></div><div \nlayout=\"row\" layout-align=\"center center\" data-ng-show=\"!isHeaderView\"><div flex=\"100\"><form name=\"lineitemForm\" \nnovalidate style=\"overflow-y: hidden; overflow-x: scroll\"><fieldset style=\"border: 1px solid #cccccc\"><div \nng-bind-html=\"currentFormLineitem\" compile-template></div></fieldset></form></div></div></div></div></ms-widget></div>\n</div></div>");
$templateCache.put("app/main/administration/forms-management/formCreation.html","<md-dialog flex=\"70\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create Form</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><form name=\"requestform\" novalidate layout=\"column\"><md-dialog-content \nclass=\"scrollable\" ms-scroll><div layout=\"row\" layout-align=\"start start\" class=\"md-padding\"><div flex=\"30\" \nlayout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>Name</b></span></div><span flex=\"10\"></span>\n<md-input-container flex=\"45\" class=\"md-block\" layout=\"column\" layout-align=\"space-around start\" \nstyle=\"margin-top:-2% !important\"><input type=\"text\" name=\"name\" ng-model=\"request.name\" placeholder=\"Name\" required>\n</md-input-container><div flex=\"30\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>Description</b>\n</span></div><span flex=\"10\"></span><md-input-container flex=\"45\" class=\"md-block\" layout=\"column\" \nlayout-align=\"space-around start\" style=\"margin-top:-2% !important\"><input type=\"text\" name=\"description\" \nng-model=\"request.description\" placeholder=\"Description\" required></md-input-container></div><div layout=\"row\" \nlayout-align=\"start start\" class=\"md-padding\"><div flex=\"30\" layout=\"column\" layout-align=\"center end\"><span \nclass=\"h3\"><b>Main File</b></span></div><span flex=\"10\"></span><div flex=\"40\" layout=\"column\" \nlayout-align=\"center start\" style=\"margin-top:-2% !important\"><input class=\"ng-hide\" id=\"headerFileUpload\" \nname=\"headerFileUpload\" type=\"file\" onchange=\"angular.element(this).scope().setHeaderFile(this)\"><label \nfor=\"headerFileUpload\" class=\"md-button md-raised md-accent\">Upload</label></div><div \nng-repeat=\"file in headerfiles.slice(0)\" layout=\"row\" layout-align=\"start start\"><span class=\"md-warn\">\n{{file.webkitRelativePath || file.name}}</span> (<span ng-switch=\"file.size > 1024*1024\"> <span ng-switch-when=\"true\">\n{{file.size / 1024 / 1024 | number:2}} MB</span> <span ng-switch-default>{{file.size / 1024 | number:2}} kB</span> \n</span>)</div><div flex=\"30\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>Details File</b></span>\n</div><span flex=\"10\"></span><div flex=\"40\" layout=\"column\" layout-align=\"center start\" \nstyle=\"margin-top:-2% !important\"><input class=\"ng-hide\" id=\"LineItemFileUpload\" name=\"LineItemFileUpload\" type=\"file\" \nonchange=\"angular.element(this).scope().setLineItemFile(this)\"><label for=\"LineItemFileUpload\" \nclass=\"md-button md-raised md-accent\">Upload</label></div><div><div ng-repeat=\"file in lineitemfiles.slice(0)\" \nlayout=\"row\" layout-align=\"start start\"><span class=\"md-warn\">{{file.webkitRelativePath || file.name}}</span> (<span \nng-switch=\"file.size > 1024*1024\"> <span ng-switch-when=\"true\">{{file.size / 1024 / 1024 | number:2}} MB</span> <span \nng-switch-default>{{file.size / 1024 | number:2}} kB</span> </span>)</div></div></div><md-dialog-content \nclass=\"scrollable\" ms-scroll><div style=\"margin-top: -5% !important\"><h2 ng-hide=\"attributes.length == 0\">\nForm Attributes</h2><div layout=\"row\" layout-align=\"space-around center\" ng-hide=\"attributes.length == 0\"><div \nclass=\"table-header\" style=\"margin-right: 4% !important\"><span class=\"column-title\">FieldName</span></div><div \nclass=\"table-header\" style=\"margin-right: 6% !important\"><span class=\"column-title\">Label</span></div><div \nclass=\"table-header\" style=\"margin-right: 4% !important\"><span class=\"column-title\">Type</span></div><div \nclass=\"table-header\" style=\"margin-right: 4% !important\"><span class=\"column-title\">Length</span></div><div \nclass=\"table-header\" style=\"margin-right: 2% !important\"><span class=\"column-title\">RequiredField</span></div><div \nclass=\"table-header\" style=\"margin-right: 2% !important\"><span class=\"column-title\">BarcodeEnabled</span></div><div \nclass=\"table-header\" style=\"margin-right: 4% !important\"><span class=\"column-title\">MobileEnabled</span></div><div \nclass=\"table-header\"><span class=\"column-title\"></span></div><div class=\"table-header\"><span class=\"column-title\">\n</span></div></div><md-content class=\"scrollable\" ms-scroll><div ng-repeat=\"element in attributes\" layout=\"row\" \nlayout-align=\"space-around center\" style=\"margin-bottom: -3%\"><md-input-container class=\"md-block\" flex=\"20\"><input \ntype=\"text\" name=\"fieldName\" ng-model=\"element.fieldName\" required><div ng-messages=\"requestform.fieldName.$error\" \nrole=\"alert\"><div ng-message=\"required\">FieldName*</div></div></md-input-container><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"20\"><input type=\"text\" name=\"label\" ng-model=\"element.label\" required><div \nng-messages=\"requestform.label.$error\" role=\"alert\"><div ng-message=\"required\">Label*</div></div></md-input-container>\n<span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\" style=\"margin-top:0% !important\"><md-select \nng-model=\"element.type\"><md-option ng-value=\"type\" ng-repeat=\"type in Types\">{{ type }}</md-option></md-select><div \nng-messages=\"requestform.type.$error\" role=\"alert\"><div ng-message=\"required\">Type*</div></div></md-input-container>\n<span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\"><input type=\"number\" name=\"length\" \nng-model=\"element.length\" required><div ng-messages=\"requestform.length.$error\" role=\"alert\"><div \nng-message=\"required\">Length*</div></div></md-input-container><span flex=\"10\"></span><md-input-container \nclass=\"md-block\" flex=\"20\"><md-switch ng-model=\"element.requiredField\" aria-label=\"Switch\"></md-switch>\n</md-input-container><span flex=\"5\"></span> <span flex=\"10\"></span><md-input-container class=\"md-block\" flex=\"20\">\n<md-switch ng-model=\"element.barcodeEnabled\" aria-label=\"Switch\"></md-switch></md-input-container><span flex=\"10\">\n</span><md-input-container class=\"md-block\" flex=\"20\"><md-switch ng-model=\"element.mobileEnabled\" aria-label=\"Switch\">\n</md-switch></md-input-container><md-input-container class=\"md-block\" flex=\"20\"><input type=\"text\" \nname=\"possibleValues\" ng-model=\"element.possibleValues\" ng-show=\"element.type == \'List\'\"></md-input-container>\n<md-button class=\"md-icon-button md-accent\" ng-click=\"removeAttribute($index)\"><md-tooltip md-direction=\"top\">Delete\n</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></md-content></div></md-dialog-content>\n<md-button flow-btn class=\"md-fab md-accent md-mini md-fab-bottom-right\" aria-label=\"Create Form\" \nng-click=\"addNewAttribute()\" style=\"margin-bottom: 5%\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"top\">Form Attributes</md-tooltip></md-button></md-dialog-content></form><md-dialog-actions layout=\"row\">\n<span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button ng-click=\"uploadRequestForm(request)\">\nSave</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/administration/forms-management/formUpdate.html","<md-dialog flex=\"70\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Update Form:{{CurrentForm.name}}\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><form name=\"requestform\" novalidate layout=\"column\"><md-dialog-content \nclass=\"scrollable\" ms-scroll><div layout=\"row\" layout-align=\"start start\" class=\"md-padding\"><div flex=\"30\" \nlayout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>Name</b></span></div><span flex=\"10\"></span>\n<md-input-container flex=\"45\" class=\"md-block\" layout=\"column\" layout-align=\"space-around start\" \nstyle=\"margin-top:-2% !important\"><input type=\"text\" name=\"name\" ng-model=\"CurrentForm.name\" placeholder=\"Name\" \nrequired></md-input-container><div flex=\"30\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>Description\n</b></span></div><span flex=\"10\"></span><md-input-container flex=\"45\" class=\"md-block\" layout=\"column\" \nlayout-align=\"space-around start\" style=\"margin-top:-2% !important\"><input type=\"text\" name=\"description\" \nng-model=\"CurrentForm.description\" placeholder=\"Description\" required></md-input-container></div><div layout=\"row\" \nlayout-align=\"start start\" class=\"md-padding\"><div flex=\"30\" layout=\"column\" layout-align=\"center end\"><span \nclass=\"h3\"><b>Main File</b></span></div><span flex=\"10\"></span><div flex=\"40\" layout=\"column\" \nlayout-align=\"center start\" style=\"margin-top:-2% !important\"><input class=\"ng-hide\" id=\"headerFileUpload\" \nname=\"headerFileUpload\" type=\"file\" onchange=\"angular.element(this).scope().setHeaderFile(this)\"><label \nfor=\"headerFileUpload\" class=\"md-button md-raised md-accent\">Upload</label></div><div \nng-repeat=\"file in headerfiles.slice(0)\" layout=\"row\" layout-align=\"start start\"><span class=\"md-warn\">\n{{file.webkitRelativePath || file.name}}</span> (<span ng-switch=\"file.size > 1024*1024\"> <span ng-switch-when=\"true\">\n{{file.size / 1024 / 1024 | number:2}} MB</span> <span ng-switch-default>{{file.size / 1024 | number:2}} kB</span> \n</span>)</div><div flex=\"30\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>Details File</b></span>\n</div><span flex=\"10\"></span><div flex=\"40\" layout=\"column\" layout-align=\"center start\" \nstyle=\"margin-top:-2% !important\"><input class=\"ng-hide\" id=\"LineItemFileUpload\" name=\"LineItemFileUpload\" type=\"file\" \nonchange=\"angular.element(this).scope().setLineItemFile(this)\"><label for=\"LineItemFileUpload\" \nclass=\"md-button md-raised md-accent\">Upload</label></div><div><div ng-repeat=\"file in lineitemfiles.slice(0)\" \nlayout=\"row\" layout-align=\"start start\"><span class=\"md-warn\">{{file.webkitRelativePath || file.name}}</span> (<span \nng-switch=\"file.size > 1024*1024\"> <span ng-switch-when=\"true\">{{file.size / 1024 / 1024 | number:2}} MB</span> <span \nng-switch-default>{{file.size / 1024 | number:2}} kB</span> </span>)</div></div></div><md-dialog-content \nclass=\"scrollable\" ms-scroll><div style=\"margin-top: -5% !important\"><h2 ng-hide=\"attributes.length == 0\">\nForm Attributes</h2><div layout=\"row\" layout-align=\"space-around center\" ng-hide=\"attributes.length == 0\"><div \nclass=\"table-header\" style=\"margin-right: 4% !important\"><span class=\"column-title\">FieldName</span></div><div \nclass=\"table-header\" style=\"margin-right: 6% !important\"><span class=\"column-title\">Label</span></div><div \nclass=\"table-header\" style=\"margin-right: 4% !important\"><span class=\"column-title\">Type</span></div><div \nclass=\"table-header\" style=\"margin-right: 4% !important\"><span class=\"column-title\">Length</span></div><div \nclass=\"table-header\" style=\"margin-right: 2% !important\"><span class=\"column-title\">RequiredField</span></div><div \nclass=\"table-header\" style=\"margin-right: 2% !important\"><span class=\"column-title\">BarcodeEnabled</span></div><div \nclass=\"table-header\" style=\"margin-right: 4% !important\"><span class=\"column-title\">MobileEnabled</span></div><div \nclass=\"table-header\"><span class=\"column-title\"></span></div><div class=\"table-header\"><span class=\"column-title\">\n</span></div></div><md-content class=\"scrollable\" ms-scroll><div ng-repeat=\"element in attributes\" layout=\"row\" \nlayout-align=\"space-around center\" style=\"margin-bottom: -3%\"><md-input-container class=\"md-block\" flex=\"20\"><input \ntype=\"text\" name=\"fieldName\" ng-model=\"element.fieldName\" required><div ng-messages=\"requestform.fieldName.$error\" \nrole=\"alert\"><div ng-message=\"required\">FieldName*</div></div></md-input-container><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"20\"><input type=\"text\" name=\"label\" ng-model=\"element.label\" required><div \nng-messages=\"requestform.label.$error\" role=\"alert\"><div ng-message=\"required\">Label*</div></div></md-input-container>\n<span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\" style=\"margin-top:0% !important\"><md-select \nng-model=\"element.type\"><md-option ng-value=\"type\" ng-repeat=\"type in Types\">{{ type }}</md-option></md-select><div \nng-messages=\"requestform.type.$error\" role=\"alert\"><div ng-message=\"required\">Type*</div></div></md-input-container>\n<span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\"><input type=\"number\" name=\"length\" \nng-model=\"element.length\" required><div ng-messages=\"requestform.length.$error\" role=\"alert\"><div \nng-message=\"required\">Length*</div></div></md-input-container><span flex=\"10\"></span><md-input-container \nclass=\"md-block\" flex=\"20\"><md-switch ng-model=\"element.requiredField\" aria-label=\"Switch\"></md-switch>\n</md-input-container><span flex=\"5\"></span> <span flex=\"10\"></span><md-input-container class=\"md-block\" flex=\"20\">\n<md-switch ng-model=\"element.barcodeEnabled\" aria-label=\"Switch\"></md-switch></md-input-container><span flex=\"10\">\n</span><md-input-container class=\"md-block\" flex=\"20\"><md-switch ng-model=\"element.mobileEnabled\" aria-label=\"Switch\">\n</md-switch></md-input-container><md-input-container class=\"md-block\" flex=\"20\"><input type=\"text\" \nname=\"possibleValues\" ng-model=\"element.possibleValues\" ng-show=\"element.type == \'List\'\"></md-input-container>\n<md-button class=\"md-icon-button md-accent\" ng-click=\"removeAttribute($index)\"><md-tooltip md-direction=\"top\">Delete\n</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></md-content></div></md-dialog-content>\n<md-button flow-btn class=\"md-fab md-accent md-mini md-fab-bottom-right\" aria-label=\"Create Form\" \nng-click=\"addNewAttribute()\" style=\"margin-bottom: 5%\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"top\">Form Attributes</md-tooltip></md-button></md-dialog-content></form><md-dialog-actions layout=\"row\">\n<span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button \nng-click=\"updateRequestForm(CurrentForm)\">Update</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/administration/forms-management/overviewPage.html","<style>\n.fb-render {\r\n  		margin: auto;\r\n  		max-width: 1280px\r\n	}\r\n	label{\r\n		line-height: 5px;\r\n		font-weight: bold;\r\n	}\r\n	input{\r\n		border-radius: 2px !important;\r\n		padding: 10px !important;\r\n	}\n</style><div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div class=\"widget-group scrollable\" flex=\"100\" \nlayout=\"column\" layout-wrap ms-scroll ng-init=\"requestCtrl.getRequestForms()\"><md-button flow-btn \nclass=\"md-fab md-mini grey-700-bg md-fab-bottom-right add_btn\" aria-label=\"Create Request\" \nng-click=\"createRequest($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">\nCreate Request</md-tooltip></md-button><ms-widget><div class=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab\n label=\"Forms\" ui-sref=\"app.administration.forms\" md-active=\"true\"></md-tab><md-tab label=\"Create Forms\" \nui-sref=\"app.administration.createform\"></md-tab></md-tabs></div><div class=\"white-bg\" layout=\"row\" layout-wrap><div \nng-repeat=\"form in forms\" flex=\"100\" flex-gt-xs=\"20\" flex-gt-md=\"20\" class=\"md-padding\"><a ng-click=\"selectForm(form)\">\n<ms-widget flex=\"15\"><ms-widget-front class=\"h-170 p-16 c-p\"><div class=\"md-subhead font-weight-500 black-fg\">\n{{form.name}}</div><div layout=\"column\" layout-align=\"space-between\" flex><div><div class=\"h6 secondary-text\">\n{{form.description}}</div></div></div><div layout=\"row\" layout-align=\"space-between center\"><div><md-icon \nmd-font-icon=\"icon-file-document\" class=\"s50 icon\"></md-icon></div></div></ms-widget-front></ms-widget></a><div \nlayout=\"row\" layout-align=\"end end\"><md-icon md-font-icon=\"icon-pencil\" class=\"c-p\" ng-click=\"UpdateForm($event,form)\">\n</md-icon></div></div></div></ms-widget></div></div>");
$templateCache.put("app/main/administration/list-management/attributes.list.html","<md-dialog aria-label=\"Add new Attributes\" flex=\"75\"><form name=\"ListForm\" novalidate \nng-submit=\"ListForm.$valid && save()\" layout=\"column\" flex=\"66\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Attributes of List:{{currentDocType.name}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><table id=\"attrlisttable\" \nclass=\"dataTable row-border hover table-border\" datatable=\"ng\" dt-options=\"dtOptions1\"><thead><tr class=\"table-header\">\n<th ng-show=\"false\"></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Field NAME\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">TYPE</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\" layout=\"row\" layout-align=\"center center\"><span \nclass=\"column-title\">LABEL</span></div></th><th class=\"secondary-text\"><div class=\"table-header\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"column-title\">LENGTH</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\" layout=\"row\" layout-align=\"center center\"><span class=\"column-title\">OUTPUTFIELDFLAG</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\" layout=\"row\" layout-align=\"center center\"><span \nclass=\"column-title\">FILTERFIELDFLAG</span></div></th><th class=\"secondary-text\"><div class=\"table-header\" \nlayout=\"row\" layout-align=\"center center\"><span class=\"column-title\">DESCRIPTIONFLAG</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\"></span></div></th></tr></thead><tbody><tr \nng-repeat=\"element in attributes track by $index\"><td ng-show=\"false\"><md-input-container class=\"md-block\" flex=\"10\">\n<input type=\"text\" name=\"name\" ng-model=\"element.id\" ng-init=\"element.id = $index\"><div \nng-messages=\"ListForm.name.$error\" role=\"alert\"><div ng-message=\"required\">Enter id name</div></div>\n</md-input-container></td><td><md-input-container class=\"md-block\"><input type=\"text\" name=\"name\" \nng-model=\"element.fieldname\" ng-required=\"true\"><div ng-messages=\"ListForm.name.$error\" role=\"alert\"><div \nng-message=\"required\">Enter attribute name</div></div></md-input-container></td><td><md-input-container \nclass=\"md-block\"><md-select ng-model=\"element.type\"><md-option ng-repeat=\"type in attributeTypes\" value=\"{{type}}\">\n{{type}}</md-option></md-select></md-input-container></td><td><md-input-container class=\"md-block\"><input type=\"text\" \nname=\"label\" ng-model=\"element.label\"><div ng-messages=\"ListForm.label.$error\" role=\"alert\"><div ng-message=\"required\">\nEnter Label</div></div></md-input-container></td><td><md-input-container class=\"md-block\"><input type=\"text\" \nname=\"length\" ng-model=\"element.length\"><div ng-messages=\"ListForm.length.$error\" role=\"alert\"><div \nng-message=\"required\">Enter length</div></div></md-input-container></td><td><md-input-container class=\"md-block\">\n<md-switch ng-model=\"element.outputfieldflag\" aria-label=\"Switch\" ng-change=\"setunioutputflag(element.id)\"></md-switch>\n</md-input-container></td><td><md-input-container class=\"md-block\"><md-switch ng-model=\"element.filterfieldflag\" \naria-label=\"Switch\"></md-switch></md-input-container></td><td><md-input-container class=\"md-block\"><md-switch \nng-model=\"element.descriptionflag\" aria-label=\"Switch\" ng-change=\"setunidescflag(element.id)\"></md-switch>\n</md-input-container></td><td><md-button id=\"{{$index}}\" class=\"md-icon-button md-accent\" \nonclick=\"angular.element(this).scope().removeAttribute(this)\"><md-tooltip md-direction=\"top\">Delete</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody></table></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button ng-click=\"cancel()\">Cancel</md-button>\n<md-button type=\"submit\" ng-disabled=\"showupdate\">Update</md-button></md-dialog-actions><md-button flow-btn \nclass=\"md-fab md-accent md-fab-bottom-right\" aria-label=\"Create User\" ng-click=\"addNewAttribute()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">New Attribute</md-tooltip></md-button></form>\n</md-dialog>");
$templateCache.put("app/main/administration/list-management/createlist-dialog.html","<md-dialog aria-label=\"Add List\"><form name=\"listForm\" novalidate \nng-submit=\"listForm.$valid && doctypeCrtl.createDocumentType()\" layout=\"column\" flex=\"66\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create List</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container class=\"md-block\" flex=\"45\">\n<input type=\"text\" name=\"name\" ng-pattern=\"/^[a-zA-Z ]*$/\" ng-model=\"list.name\" placeholder=\"Name\" required><div \nng-messages=\"listForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Name is required</span></div><div \nng-message=\"pattern\"><span>Name has invalid characters</span></div></div></md-input-container><span flex=\"10\"></span>\n<md-input-container class=\"md-block\" flex=\"45\"><input type=\"text\" name=\"description\" ng-model=\"list.description\" \nplaceholder=\"Description\"><div ng-messages=\"listForm.description.$error\" role=\"alert\"><div ng-message=\"pattern\"><span>\nDescription has invalid characters</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"listForm.$valid && save(list)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/list-management/listOverview.html","<style>\n.mh-0 {\r\n    min-height: 0px !important;\r\n}\r\n.parent-tabs > md-tabs .md-tab.md-active:after{\r\n    content: \" \";\r\n    border-left: 7px solid transparent;\r\n    border-right: 7px solid transparent;\r\n    border-bottom: 7px solid #efefef;\r\n    position: absolute;\r\n    display: block;\r\n    top: 87%;\r\n    left: 50%;\r\n   \r\n}\r\n.parent-tabs > md-tabs md-ink-bar {\r\n    background: none; \r\n}\r\n.parent-tabs > md-tabs .md-tab:hover {\r\n    color: #389cec !important;\r\n}\r\n.md-tab {\r\n  \r\n  text-transform: none;\r\n  }\r\n  .table-border {\r\n    border: 1px solid #d3d3d3 !important;\r\n}\r\n.table-header {\r\n    background-color: #dee7f4 !important;\r\n    text-transform: uppercase;\r\n    font-size: 11px!important;\r\n}\n</style><div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"List Definition\" md-active=\"true\"></md-tab>\n<md-tab label=\"List Maintenance\" ui-sref=\"app.administration.list-maintenance\"></md-tab></md-tabs></div><div \nclass=\"md-padding white-bg\"><table id=\"listtable\" class=\"dataTable row-border hover table-border\" datatable=\"ng\" \ndt-options=\"listCtrl.dtOptions \"><thead><tr class=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Description</span></div></th><th class=\"secondary-text\"><div class=\"table-header\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr \nng-repeat=\"list in listdata \"><td>{{list.name}}</td><td>{{list.description}}</td><td layout=\"row\" \nlayout-align=\"center center\" style=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button \nid=\"{{list.id}}\" class=\"md-icon-button test-tooltip\" aria-label=\"Update\" \nonclick=\"angular.element(this).scope().updatelistDialog(this)\"><md-tooltip md-direction=\"top\">Update</md-tooltip>\n<md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s18\"></i></md-icon></md-button><md-button\n id=\"{{list.id}}\" class=\"md-icon-button test-tooltip\" aria-label=\"Delete\" \nonclick=\"angular.element(this).scope().deletelist(this)\"><md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon><i \nlayout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s18\"></i></md-icon></md-button><md-button \nid=\"{{list.id}}\" class=\"md-icon-button test-tooltip\" aria-label=\"Update\" \nonclick=\"angular.element(this).scope().ListAttributesDialog(this)\"><md-tooltip md-direction=\"top\">Attributes\n</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-dots-vertical s20\"></i></md-icon>\n</md-button></td></tr></tbody></table></div></ms-widget></div><md-button flow-btn \nclass=\"md-fab grey-700-bg md-mini md-fab-bottom-right add_btn\" ng-click=\"createListDialog(ev)\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Create DocType</md-tooltip></md-button></div></div>");
$templateCache.put("app/main/administration/list-management/updatelist-dialog.html","<md-dialog aria-label=\"Update List\" flex=\"45\"><form name=\"ListUpdateForm\" novalidate \nng-submit=\"ListUpdateForm.$valid && update(currentList)\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Update List</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content layout=\"column\"><md-input-container class=\"md-block\" flex=\"45\"><input\n type=\"text\" name=\"Name\" ng-model=\"currentList.name\" placeholder=\"name\" required><div \nng-messages=\"ListUpdateForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Name is required</span></div>\n<div ng-message=\"pattern\"><span>Name has invalid characters</span></div></div></md-input-container><span flex=\"10\">\n</span><md-input-container class=\"md-block\" flex=\"45\"><input type=\"text\" name=\"Description\" \nng-model=\"currentList.description\" placeholder=\"description\"><div ng-messages=\"ListUpdateForm.description.$error\" \nrole=\"alert\"><div ng-message=\"pattern\"><span>Description has invalid characters</span></div></div></md-input-container>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button ng-click=\"cancel()\">Cancel\n</md-button><md-button type=\"submit\" ng-click=\"listForm.$valid && update(currentList)\">Update</md-button>\n</md-dialog-actions></form></md-dialog>tml>");
$templateCache.put("app/main/administration/request-management/create.requestType.dialog.html","<md-dialog aria-label=\"Add a new doctype\" flex=\"35\"><form name=\"docType\" novalidate \nng-submit=\"doctypeCtrl.createDoctype(doc)\" layout=\"column\" flex=\"66\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Create ReqType</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll>\n<md-input-container class=\"md-block\"><input type=\"text\" name=\"name\" ng-model=\"doc.name\" placeholder=\"Name\" required>\n<div ng-messages=\"doctype.name.$error\" role=\"alert\"><div ng-message=\"required\">Name is required</div></div>\n</md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"doctype\" ng-model=\"doc.docType\" \nplaceholder=\"DiplayName\" required><div ng-messages=\"doctype.name.$error\" role=\"alert\"><div ng-message=\"required\">\nDisplayName is required</div></div></md-input-container><md-input-container class=\"md-block\"><input type=\"description\" \nname=\"description\" ng-model=\"doc.description\" placeholder=\"Description\" required><div \nng-messages=\"doctype.description.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nDescription is required</span></div></div></md-input-container><md-input-container class=\"md-block\"><input \ntype=\"prefix\" name=\"prefix\" ng-model=\"doc.prefix\" placeholder=\"Prefix\" required><div \nng-messages=\"doctype.prefix.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nPrefix is required</span></div></div></md-input-container><md-input-container class=\"md-block\"><label>Form Id</label>\n<md-select ng-model=\"doc.formId\"><md-option ng-value=\"form.id\" ng-repeat=\"form in forms\">{{form.name}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\"><input type=\"flowId\" name=\"flowId\" \nng-model=\"doc.flowId\" placeholder=\"Flow Id\" required><div ng-messages=\"doctype.flowId.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>FlowId is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><label>FlowType</label><md-select ng-model=\"doc.flowType\"><md-option \nng-value=\"flowtype\" ng-repeat=\"flowtype in flowtypes\">{{flowtype}}</md-option></md-select></md-input-container><div \nlayout=\"row\" layout-align=\"space-between center\"><md-input-container class=\"md-block\"><input type=\"text\" \nname=\"noRangeFrom\" ng-model=\"doc.noRangeFrom\" placeholder=\"From\"></md-input-container><md-input-container \nclass=\"md-block\"><input type=\"text\" name=\"noRangeTo\" ng-model=\"doc.noRangeTo\" placeholder=\"To\"></md-input-container>\n</div><md-input-container class=\"md-block\"><label>Icons</label><md-select ng-model=\"doc.icon\"><md-option \nng-value=\"icon\" ng-repeat=\"icon in icons\">{{icon}}</md-option></md-select></md-input-container></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel\n</md-button><md-button type=\"submit\" ng-click=\"save(doc)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/request-management/createrequestType.html","<style>\n.mh-0 {\r\n    min-height: 0px !important;\r\n}\r\n.parent-tabs > md-tabs .md-tab.md-active:after{\r\n    content: \" \";\r\n    border-left: 7px solid transparent;\r\n    border-right: 7px solid transparent;\r\n    border-bottom: 7px solid #efefef;\r\n    position: absolute;\r\n    display: block;\r\n    top: 87%;\r\n    left: 50%;\r\n    \r\n}\r\n.parent-tabs > md-tabs md-ink-bar {\r\n    background: none; \r\n}\r\n.parent-tabs > md-tabs .md-tab:hover {\r\n    color: #389cec !important;\r\n}\r\n.md-tab {\r\n  \r\n  text-transform: none;\r\n  }\r\n  .table-border {\r\n    border: 1px solid #d3d3d3 !important;\r\n}\r\n.table-header {\r\n    background-color: #dee7f4 !important;\r\n    text-transform: uppercase;\r\n    font-size: 11px!important;\r\n}\n</style><div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll ng-init=\"getRequestForms()\">\n<div class=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Requests\" md-active=\"true\"></md-tab></md-tabs>\n</div><div class=\"md-padding white-bg\"><table class=\"dataTable row-border hover table-border table-header\" \ndatatable=\"ng\" dt-options=\"dtOptions\"><thead><tr class=\"table-header\"><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Description</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">FormId</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">FlowId</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\" layout=\"row\" layout-align=\"center center\"><span class=\"column-title\">Actions</span></div></th>\n</tr></thead><tbody><tr ng-repeat=\"doc in Requests | filter : searchUser\"><td>{{doc.name}}</td><td>{{doc.description}}\n</td><td>{{doc.formId}}</td><td>{{doc.flowId}}</td><td layout=\"row\" layout-align=\"center center\" \nstyle=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button id=\"{{doc.id}}\" \nclass=\"md-icon-button test-tooltip\" aria-label=\"Update\" \nonclick=\"angular.element(this).scope().updateRequestDialog(this)\"><md-tooltip md-direction=\"top\">Update</md-tooltip>\n<md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s20\"></i></md-icon></md-button><md-button\n id=\"{{doc.id}}\" class=\"md-icon-button test-tooltip\" aria-label=\"Delete\" \nonclick=\"angular.element(this).scope().deleteDoctype(this)\"><md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon>\n<i layout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s20\"></i></md-icon></md-button></td></tr></tbody>\n</table></div></ms-widget></div><md-button flow-btn class=\"md-fab grey-700-bg md-mini md-fab-bottom-right add_btn\" \naria-label=\"Create Form\" ng-click=\"createRequestDialog($event)()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n<md-tooltip md-direction=\"top\">Create DocType</md-tooltip></md-button></div></div>");
$templateCache.put("app/main/administration/request-management/update.requestType.dialog.html","<md-dialog aria-label=\"Add a new doctype\" flex=\"35\"><form name=\"docType\" novalidate layout=\"column\" flex=\"66\">\n<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Edit ReqType:{{recivedDoc.name}}</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><md-input-container class=\"md-block\">\n<input type=\"text\" name=\"name\" ng-model=\"recivedDoc.name\" disabled=\"true\" placeholder=\"Name\" required><div \nng-messages=\"doctype.name.$error\" role=\"alert\"><div ng-message=\"required\">Name is required</div></div>\n</md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"doctype\" \nng-model=\"recivedDoc.docType\" placeholder=\"DiplayName\" required><div ng-messages=\"doctype.name.$error\" role=\"alert\">\n<div ng-message=\"required\">DisplayName is required</div></div></md-input-container><md-input-container \nclass=\"md-block\"><input type=\"description\" name=\"description\" ng-model=\"recivedDoc.description\" \nplaceholder=\"Description\" required><div ng-messages=\"doctype.description.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Description is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><input type=\"prefix\" name=\"prefix\" ng-model=\"recivedDoc.prefix\" placeholder=\"Prefix\" required><div \nng-messages=\"doctype.prefix.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nPrefix is required</span></div></div></md-input-container><md-input-container class=\"md-block\"><label>Form Id</label>\n<md-select ng-model=\"recivedDoc.formId\"><md-option ng-value=\"formId.id\" ng-repeat=\"formId in formIds\">{{formId.name}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><input type=\"flowId\" name=\"flowId\" \nng-model=\"recivedDoc.flowId\" placeholder=\"Flow Id\" required><div ng-messages=\"doctype.flowId.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>FlowId is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><label>FlowType</label><md-select ng-model=\"recivedDoc.flowType\"><md-option \nng-value=\"flowtype\" ng-repeat=\"flowtype in flowtypes\">{{flowtype}}</md-option></md-select></md-input-container><div \nlayout=\"row\" layout-align=\"space-between center\"><md-input-container class=\"md-block\"><input type=\"text\" \nname=\"noRangeFrom\" ng-model=\"recivedDoc.noRangeFrom\" disabled=\"true\" placeholder=\"From\"></md-input-container>\n<md-input-container class=\"md-block\"><input type=\"text\" name=\"noRangeTo\" ng-model=\"recivedDoc.noRangeTo\" \ndisabled=\"true\" placeholder=\"To\"></md-input-container></div><md-input-container class=\"md-block\"><label>Icons</label>\n<md-select ng-model=\"recivedDoc.icon\"><md-option ng-value=\"icon\" ng-repeat=\"icon in icons\">{{icon}}</md-option>\n</md-select></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\">\n<md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"update(recivedDoc)\">\nSave</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/reports/mainReport.html","<style>\n.mh-0 {\r\n    min-height: 0px !important;\r\n}\r\n.parent-tabs > md-tabs .md-tab.md-active:after{\r\n    content: \" \";\r\n    border-left: 7px solid transparent;\r\n    border-right: 7px solid transparent;\r\n    border-bottom: 7px solid #efefef;\r\n    position: absolute;\r\n    display: block;\r\n    top: 87%;\r\n    left: 50%;\r\n   \r\n}\r\n.parent-tabs > md-tabs md-ink-bar {\r\n    background: none; \r\n}\r\n.parent-tabs > md-tabs .md-tab:hover {\r\n    color: #389cec !important;\r\n}\r\n.md-tab {\r\n  \r\n  text-transform: none;\r\n  }\r\n  .table-border {\r\n    border: 1px solid #d3d3d3 !important;\r\n}\r\n.table-header {\r\n    background-color: #dee7f4 !important;\r\n    text-transform: uppercase;\r\n    font-size: 11px!important;\r\n}\r\n.reportImage-1 { \r\n    background: url(/assets/images/reportsicon.svg) no-repeat;\r\n    background-position: -1px -8px;\r\n    height: 103px;\r\n    width: 187px;\r\n    position: absolute;\r\n    top: 30px;\r\n}\r\n.reportImage-2 { \r\n    background: url(/assets/images/reportsicon.svg) no-repeat;\r\n    background-position: -1px -122px;\r\n    width: 187px;\r\n    height: 103px;\r\n    position: absolute;\r\n    top: 30px;\r\n}\r\n.reportImage-3 { \r\n    background: url(/assets/images/reportsicon.svg) no-repeat;\r\n    background-position: -1px -236px;\r\n    width: 187px;\r\n    height: 101px;\r\n    position: absolute;\r\n    top: 30px;\r\n}\n</style><div class=\"pb-15\" layout=\"row\" ng-if=\"reportView == 1\"><span class=\"md-active c-p\" data-ng-click=\"goBack(0)\" \nstyle=\"display: inherit;color: #52b8e9\" role=\"button\"><md-icon md-font-icon=\"icon-arrow-left md-active s16\" \nclass=\"md-font icon-arrow-left md-active s16 material-icons\" aria-hidden=\"true\"></md-icon>Go back</span></div><div \nclass=\"content md-padding white-bg mb-15\" flex><div layout=\"row\"><div flex=\"45\"><md-input-container \nclass=\"md-block no-margin\"><input type=\"text\" name=\"id\" ng-model=\"reportInfo.reportid\" placeholder=\"ReportId\" required>\n<div ng-messages=\"reportForm.id.$error\" role=\"alert\"><div ng-message=\"required\">Reportid is required</div></div>\n</md-input-container></div><span flex=\"10\"></span><div flex=\"45\"><md-input-container class=\"md-block no-margin\"><input \ntype=\"text\" name=\"label\" ng-model=\"reportInfo.label\" placeholder=\"Label\"></md-input-container></div></div><div \nlayout=\"row\"><md-input-container flex=\"30\"><label>Select Module</label><md-select name=\"type\" \nng-model=\"reportInfo.reportModule\" md-on-close=\"selectedModule(reportInfo.reportModule)\"><md-option value=\"documents\">\nDocument</md-option><md-option value=\"request\">Request</md-option></md-select></md-input-container><span flex=\"5\">\n</span><md-input-container flex=\"30\"><label>Specific Type</label><md-select \nng-disabled=\"reportInfo.reportModule == null && reportInfo.reportModule == undefined\" \nng-model=\"reportInfo.reportSpecific\" md-on-close=\"selectSpecificType(reportInfo.reportSpecific)\" multiple=\"multiple\">\n<md-option ng-if=\"reportInfo.reportModule == \'documents\'\" value=\"docType\">Doctype specific</md-option><md-option \nng-if=\"reportInfo.reportModule == \'request\'\" value=\"reqType\">Requesttype specific</md-option></md-select>\n</md-input-container><span flex=\"5\"></span><md-input-container flex=\"30\"><label>DocType</label><md-select name=\"type\" \nng-disabled=\"reportInfo.reportSpecific.length == 0\" ng-model=\"reportInfo.docType\" \nmd-on-close=\"selectDocType(reportInfo.docType)\"><md-option ng-repeat=\"doctype in docTypes\" ng-value=\"doctype.id\">\n{{doctype.name}}</md-option></md-select></md-input-container></div><md-divider></md-divider><div layout=\"row\" \nclass=\"pt-15 pb-15\"><div class=\"h-136\" flex=\"100\"><md-radio-group ng-model=\"reportInfo.reportType\" layout=\"row\">\n<md-radio-button value=\"TABULAR\" flex>Tabular Report<br><span class=\"reportImage-1\"></span><br></md-radio-button>\n<md-radio-button value=\"SUMMARY\" flex>Summary Report<br><span class=\"reportImage-2\"></span><br></md-radio-button>\n<md-radio-button value=\"MATRIX\" flex>Matrix Report<br><span class=\"reportImage-3\"></span><br></md-radio-button>\n</md-radio-group></div></div><md-divider></md-divider><div layout=\"row\"><div flex=\"50\" class=\"md-padding\"><md-checkbox \nng-model=\"reportInfo.skipSelection\" aria-label=\"Skip Selection\">Skip Selection</md-checkbox></div><md-divider>\n</md-divider><div flex=\"50\" class=\"md-padding\"><md-button ng-click=\"showIconsList()\" class=\"md-accent md-raised\">\nselect report logo</md-button></div></div></div><div class=\"md-padding white-bg\"><md-tabs md-dynamic-height><md-tab \ndata-ng-if=\"!reportInfo.skipSelection\" label=\"Selection Fields\"><ms-widget layout=\"column\"><ms-widget-front \nclass=\"white-bg mh-420 b-t\"><div class=\"scrollable\" ms-scroll><table border=\"0\" align=\"center\" cellpadding=\"0\" \ncellspacing=\"2\"><tbody><tr><td class=\"f14 color_4 pB10\">Available Columns:</td><td>&nbsp;</td><td \nclass=\"f14 color_4 pB10\">Selected Columns:</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr><tr>\n<td><select id=\"availList\" name=\"availList\" multiple=\"\" class=\"select\" ng-model=\"sfields\" \nstyle=\"width:200px;height:300px;max-height:300px;overflow: auto\"><option value=\"{{field.fieldname}}\" \nng-repeat=\"field in selectionfields track by $index\" style=\"padding-left: 5px\">{{ field.fieldname }}</option></select>\n</td><td><table border=\"0\" align=\"center\" cellpadding=\"0\" cellspacing=\"5\"><tbody><tr><td><div align=\"center\"><md-button\n class=\"md-accent md-raised\" type=\"submit\" ng-click=\"addColumn(sfields)\">Add</md-button></div></td></tr></tbody>\n</table></td><td><select id=\"selectedColumns\" name=\"selectedColumns\" multiple=\"\" class=\"select\" ng-model=\"fsfields\" \nng-change=\"selectedFSFields(fsfields)\" style=\"width:200px;height:300px;overflow: auto\"><option value=\"{{field}}\" \nng-repeat=\"field in finalSelectionFields track by $index\" style=\"padding-left: 5px\">{{ field.fieldname }}</option>\n</select></td><td><table border=\"0\" cellspacing=\"0\" cellpadding=\"0\"><tbody><tr><td><md-button \nclass=\"md-icon-button md-accent\" aria-label=\"Favorite\" ng-click=\"moveUp(fsfields)\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_keyboard_arrow_up_black_24px.svg\"></md-icon></md-button></td>\n</tr><tr><td><md-button class=\"md-icon-button md-accent\" aria-label=\"Favorite\" ng-click=\"moveDown(fsfields)\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_keyboard_arrow_down_black_24px.svg\"></md-icon></md-button>\n</td></tr><tr style=\"height:5px\"><td></td></tr><tr><td><md-button class=\"md-icon-button md-warn\" aria-label=\"Favorite\" \nng-click=\"delColumn(fsfields)\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\">\n</md-icon></md-button></td></tr></tbody></table></td><td style=\"vertical-align: top\" class=\"layout-row\">\n<md-input-container class=\"md-block no-margin\" ng-if=\"selectedFSField != undefined\"><input type=\"text\" \nname=\"defaultvalue\" ng-model=\"selectedFSField.defaultvalue\" \nng-blur=\"setDefaultValue(selectedFSField.defaultvalue, fsfields);\" placeholder=\"Default Value\"></md-input-container>\n<md-input-container class=\"md-block no-margin\" flex=\"100\" ng-if=\"selectedFSField != undefined\"><input type=\"text\" \nname=\"possibleValues\" ng-model=\"selectedFSField.possibleValues\" \nng-blur=\"setPossibleValues(selectedFSField.possibleValues, fsfields);\" placeholder=\"Possible Values\">\n</md-input-container><md-input-container class=\"md-block no-margin\" flex=\"100\" ng-if=\"selectedFSField != undefined\">\n<input type=\"text\" name=\"label\" ng-model=\"selectedFSField.label\" \nng-blur=\"setLabelValue(selectedFSField.label, fsfields);\" placeholder=\"Label\"></md-input-container><md-input-container \nclass=\"md-block no-margin\" flex=\"100\" ng-if=\"selectedFSField != undefined\"><label>Required</label><md-switch \nng-model=\"selectedFSField.requiredflag\" aria-label=\"required\" \nng-blur=\"setRequiredFlag(selectedFSField.requiredflag, fsfields);\"></md-switch></md-input-container></td></tr></tbody>\n</table></div></ms-widget-front></ms-widget></md-tab><md-tab label=\"DocType Fields\"><ms-widget layout=\"column\">\n<ms-widget-front class=\"white-bg mh-420 b-t\"><div class=\"scrollable\" ms-scroll><table class=\"simple list-view\"><tbody>\n<tr class=\"layout-row\" flex=\"100\" ng-repeat=\"attr in attributeObjects\"><td flex=\"20\">{{ attr.name }}</td><td flex=\"20\">\n{{ attr.type }}</td><td flex=\"30\" class=\"no-padding\"><md-input-container md-no-float class=\"no-padding no-margin\" \nstyle=\"top: 15px; height: 30px; width: 50%\"><input type=\"text\" ng-model=\"getLabelValue(attr, \'DOCTYPEFIELDS\').label\" \nplaceholder=\"Label\" style=\"float:left\"></md-input-container></td><td flex=\"30\" class=\"no-padding\"><md-input-container \nclass=\"no-padding no-margin\"><span dir=\"rtl\" style=\"display: -webkit-box; padding-top: 14px\"><md-checkbox \nng-checked=\"exist(attr, selectedAttr, \'DOCTYPEFIELDS\')\" ng-click=\"toggleCheck(attr, selectedAttr, \'DOCTYPEFIELDS\')\">\n</md-checkbox></span></md-input-container></td></tr></tbody></table></div><div class=\"md-padding white-bg\" \ndata-ng-if=\"attributeObjects.length == 0\"><div class=\"content-container text-center\"><div \nclass=\"alert alert-info mv-10 mh-10\"><p>No data available</p></div></div></div></ms-widget-front></ms-widget></md-tab>\n<md-tab label=\"Output Fields\"><ms-widget layout=\"column\"><ms-widget-front class=\"white-bg mh-420 b-t\"><div \nclass=\"scrollable\" ms-scroll><table class=\"simple list-view\"><tbody><tr class=\"layout-row\" flex=\"100\" \nng-repeat=\"field in outputfields track by $index\"><td flex=\"25\">{{ field.fieldname }}</td><td flex=\"25\" \nclass=\"no-padding\"><md-input-container md-no-float class=\"no-padding no-margin\" \nstyle=\"top: 15px; height: 30px; width: 50%\"><input type=\"text\" ng-model=\"getLabelValue(field, \'OUTPUTFIELDS\').label\" \nplaceholder=\"Label\" style=\"float:left\"></md-input-container></td><td flex=\"25\" class=\"no-padding\"><md-input-container \nmd-no-float class=\"no-padding no-margin\" style=\"top: 15px; height: 30px\"><input type=\"number\" \nng-model=\"getLabelValue(field, \'OUTPUTFIELDS\').sequence\" placeholder=\"Sequence Number\" style=\"float:left\">\n</md-input-container></td><td flex=\"25\" class=\"no-padding\"><md-input-container md-no-float \nclass=\"no-padding no-margin\" style=\"top: 15px; height: 30px\"><input type=\"number\" \nng-model=\"getLabelValue(field, \'OUTPUTFIELDS\').length\" placeholder=\"Length\" style=\"float:left\"></md-input-container>\n</td><td flex=\"25\" class=\"no-padding\"><md-input-container class=\"no-padding no-margin\"><span dir=\"rtl\" \nstyle=\"display: -webkit-box; padding-top: 14px\"><md-checkbox ng-checked=\"exist(field, selectedOutFl, \'OUTPUTFIELDS\')\" \nng-click=\"toggleCheck(field, selectedOutFl, \'OUTPUTFIELDS\')\"></md-checkbox></span></md-input-container></td></tr>\n</tbody></table></div><div class=\"md-padding white-bg\" data-ng-if=\"outputfields.length == 0\"><div \nclass=\"content-container text-center\"><div class=\"alert alert-info mv-10 mh-10\"><p>No data available</p></div></div>\n</div></ms-widget-front></ms-widget></md-tab><md-tab label=\"Filtered Fields\"><ms-widget layout=\"column\">\n<ms-widget-front class=\"white-bg mh-420 b-t\"><div class=\"scrollable\" ms-scroll><table class=\"simple list-view\"><tbody>\n<tr class=\"layout-row\" flex=\"100\" ng-repeat=\"field in filterfields track by $index\"><td flex=\"30\">{{ field.fieldname }}\n</td><td flex=\"30\" class=\"no-padding\"><md-input-container md-no-float class=\"no-padding no-margin\" \nstyle=\"top: 15px; height: 30px; width: 50%\"><input type=\"text\" ng-model=\"getLabelValue(field, \'FILTEREDFIELDS\').label\" \nplaceholder=\"Label\" style=\"float:left\"></md-input-container></td><td flex=\"40\" class=\"no-padding\"><md-input-container \nclass=\"no-padding no-margin\"><span dir=\"rtl\" style=\"display: -webkit-box; padding-top: 14px\"><md-checkbox \nng-checked=\"exist(field, selectedFilter, \'FILTEREDFIELDS\')\" \nng-click=\"toggleCheck(field, selectedFilter, \'FILTEREDFIELDS\')\"></md-checkbox></span></md-input-container></td></tr>\n</tbody></table></div><div class=\"md-padding white-bg\" data-ng-if=\"filterfields.length == 0\"><div \nclass=\"content-container text-center\"><div class=\"alert alert-info mv-10 mh-10\"><p>No data available</p></div></div>\n</div></ms-widget-front></ms-widget></md-tab></md-tabs><section layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center center\" layout-wrap><md-button ng-if=\"reportView != 1\" class=\"md-raised md-primary\" type=\"submit\" \nng-click=\"reportForm.$valid && submitReport(\'SAVE\')\">Save Report</md-button><md-button ng-if=\"reportView == 1\" \nclass=\"md-raised md-primary\" type=\"submit\" ng-click=\"reportForm.$valid && submitReport(\'UPDATE\')\">Update Report\n</md-button></section></div>");
$templateCache.put("app/main/administration/reports/reportDefinition.html","<style>\n.mh-0 {\r\n    min-height: 0px !important;\r\n}\r\n.parent-tabs > md-tabs .md-tab.md-active:after{\r\n    content: \" \";\r\n    border-left: 7px solid transparent;\r\n    border-right: 7px solid transparent;\r\n    border-bottom: 7px solid #efefef;\r\n    position: absolute;\r\n    display: block;\r\n    top: 87%;\r\n    left: 50%;\r\n   \r\n}\r\n.parent-tabs > md-tabs md-ink-bar {\r\n    background: none; \r\n}\r\n.parent-tabs > md-tabs .md-tab:hover {\r\n    color: #389cec !important;\r\n}\r\n.md-tab {\r\n  \r\n  text-transform: none;\r\n  }\r\n  .table-border {\r\n    border: 1px solid #d3d3d3 !important;\r\n}\r\n.table-header {\r\n    background-color: #dee7f4 !important;\r\n    text-transform: uppercase;\r\n    font-size: 11px!important;\r\n}\n</style><div id=\"reportform\" class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><form name=\"reportForm\" novalidate \nng-submit=\"repctrl.createreport(report)\" layout=\"column\" flex=\"100\"><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Report Definition\" \nui-sref=\"app.administration.reports\" md-active=\"true\"></md-tab><md-tab label=\"Report Maintenance\" \nui-sref=\"app.administration.reports.maintenance\"></md-tab></md-tabs></div><div \nng-include=\"\'app/main/administration/reports/mainReport.html\'\"></div></ms-widget></div></div></form></div>");
$templateCache.put("app/main/administration/reports/reportMaintenance.html","<style>\n.mh-0 {\r\n    min-height: 0px !important;\r\n}\r\n.parent-tabs > md-tabs .md-tab.md-active:after{\r\n    content: \" \";\r\n    border-left: 7px solid transparent;\r\n    border-right: 7px solid transparent;\r\n    border-bottom: 7px solid #efefef;\r\n    position: absolute;\r\n    display: block;\r\n    top: 87%;\r\n    left: 50%;\r\n   \r\n}\r\n.parent-tabs > md-tabs md-ink-bar {\r\n    background: none; \r\n}\r\n.parent-tabs > md-tabs .md-tab:hover {\r\n    color: #389cec !important;\r\n}\r\n.md-tab {\r\n  \r\n  text-transform: none;\r\n  }\r\n  .table-border {\r\n    border: 1px solid #d3d3d3 !important;\r\n}\r\n.table-header {\r\n    background-color: #dee7f4 !important;\r\n    text-transform: uppercase;\r\n    font-size: 11px!important;\r\n}\n</style><div id=\"reportform\" class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><form name=\"reportForm\" novalidate \nng-submit=\"repctrl.createreport(report)\" layout=\"column\" flex=\"100\"><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Report Definition\" \nui-sref=\"app.administration.reports\"></md-tab><md-tab label=\"Report Maintenance\" \nui-sref=\"app.administration.reports.maintenance\" md-active=\"true\"></md-tab></md-tabs></div><div layout=\"row\" \nclass=\"white-bg md-padding\" layout-wrap ng-if=\"reportView == 0\"><div \nng-repeat=\"report in allReports  | filter : searchSite\" flex=\"100\" flex-gt-xs=\"25\" flex-gt-md=\"20\"><md-card \nmd-theme=\"{{getAnotherColor($index)}}\" md-theme-watch class=\"c-p\"><md-tooltip md-direction=\"top\">{{report.label}}\n</md-tooltip><div class=\"info\" layout=\"column\" layout-align=\"space-between\" flex><div><div class=\"white-fg md-padding\" \nlayout=\"row\" layout-align=\"center center\" ng-style=\"{\'height\':\'150px\'}\"><md-icon md-font-icon=\"{{report.icon}}\" \nclass=\"s64\"></md-icon></div><div layout=\"row\" layout-align=\"end end\" style=\"color:white\">\n{{report.visibility}} &nbsp;&nbsp;</div></div><div><md-divider></md-divider><div class=\"text white-bg\" \nstyle=\"text-align: center\"><label>{{report.label}}</label><md-button class=\"md-icon-button test-tooltip\" \nng-click=\"deleteReport(report.label,report.id)\"><md-tooltip md-direction=\"top\">Delete Report</md-tooltip><md-icon><i \nlayout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s20\"></i></md-icon></md-button><md-button \nclass=\"md-icon-button test-tooltip\" aria-label=\"Update\" ng-click=\"goToUpdateReport(report)\"><md-tooltip \nmd-direction=\"top\">Update</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-pencil s18 deleteme\"></i></md-icon></md-button></div></div></div></md-card></div></div><div \nng-if=\"reportView == 1\" ng-include=\"\'app/main/administration/reports/mainReport.html\'\"></div><div \nclass=\"md-padding white-bg\" data-ng-if=\"allReports.length == 0\"><div class=\"content-container text-center\"><div \nclass=\"alert alert-info mv-10 mh-10\"><p>No data available</p></div></div></div></ms-widget></div></div></form></div>");
$templateCache.put("app/main/administration/settings/accountSettings.html","<style>\n.mh-0 {\r\n    min-height: 0px !important;\r\n}\r\n.parent-tabs > md-tabs .md-tab.md-active:after{\r\n    content: \" \";\r\n    border-left: 7px solid transparent;\r\n    border-right: 7px solid transparent;\r\n    border-bottom: 7px solid #efefef;\r\n    position: absolute;\r\n    display: block;\r\n    top: 87%;\r\n    left: 50%;\r\n   \r\n}\r\n.parent-tabs > md-tabs md-ink-bar {\r\n    background: none; \r\n}\r\n.parent-tabs > md-tabs .md-tab:hover {\r\n    color: #389cec !important;\r\n}\r\n.md-tab {\r\n  \r\n  text-transform: none;\r\n  }\n</style><div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Account\" \nui-sref=\"app.administration.settings.account\" md-active=\"true\"></md-tab><md-tab label=\"Brand\" \nui-sref=\"app.administration.settings.brand\"></md-tab></md-tabs></div><div layout=\"row\" class=\"md-padding white-bg\"><div\n class=\"md-padding\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>Password Policy</b></span></div><span\n flex=\"5\"></span><md-input-container flex class=\"md-block\" layout=\"column\" layout-align=\"space-around start\"><md-select\n ng-model=\"Policy\"><md-option ng-repeat=\"Policy in policys\">{{Policy}}</md-option></md-select></md-input-container>\n</div></ms-widget></div></div></div>");
$templateCache.put("app/main/administration/settings/brandsettings.html","<style>\n.mh-0 {\r\n    min-height: 0px !important;\r\n}\r\n.parent-tabs > md-tabs .md-tab.md-active:after{\r\n    content: \" \";\r\n    border-left: 7px solid transparent;\r\n    border-right: 7px solid transparent;\r\n    border-bottom: 7px solid #efefef;\r\n    position: absolute;\r\n    display: block;\r\n    top: 87%;\r\n    left: 50%;\r\n   \r\n}\r\n.parent-tabs > md-tabs md-ink-bar {\r\n    background: none; \r\n}\r\n.parent-tabs > md-tabs .md-tab:hover {\r\n    color: #389cec !important;\r\n}\r\n.md-tab {\r\n  \r\n  text-transform: none;\r\n  }\n</style><div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap ng-init=\"settingCtrl.brandsettingdata()\"><ms-widget flippable=\"true\" \nclass=\"no-padding\"><div class=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Account\" \nui-sref=\"app.administration.settings.account\"></md-tab><md-tab label=\"Brand\" \nui-sref=\"app.administration.settings.brand\" md-active=\"true\"></md-tab></md-tabs></div><md-content class=\"md-padding\">\n<div class=\"content\" flex><md-tabs md-dynamic-height><md-tab label=\"Login Settings\"><div layout=\"column\" layout-wrap>\n<div layout=\"row\" layout-align=\"start center\" layout-wrap><div flex=\"100\" flex-gt-xs=\"33\"><div \nclass=\"h2 m-16 pb-16 border-bottom\">Login Logo Image test</div><div class=\"p-16 pb-32\"><div class=\"pb-8\" id=\"imgid\" \nlayout=\"column\" layout-align=\"space-between start\"><img id=\"logo\"></div><input id=\"logoUpload\" name=\"logoUpload\" \ntype=\"file\" maxsize=\"500\" onchange=\"angular.element(this).scope().setLogoFile(this)\" accept=\"image/*\"></div></div><div \nflex=\"100\" flex-gt-xs=\"33\"><div class=\"h2 m-16 pb-16 border-bottom\">Login Background Image</div><div \nclass=\"p-16 pb-32\"><div class=\"pb-8\" layout=\"column\" layout-align=\"space-between start\"><div class=\"pb-8\" \nlayout=\"column\" layout-align=\"space-between start\"><img class=\"w-150 h-150\" id=\"backimage\" \nng-src=\"{{addOperator.imageUrl}}\"> <input id=\"backroundimageUpload\" name=\"backroundimageUpload\" type=\"file\" \nmaxsize=\"500\" onchange=\"angular.element(this).scope().setbackgroundfile(this)\" accept=\"image/*\"> <button \nng-click=\"clear()\">clear</button></div></div></div></div><div flex=\"100\" flex-gt-xs=\"33\"><div \nclass=\"h2 m-16 pb-16 border-bottom\">Login Background Color</div><div class=\"p-16 pb-32\"><div class=\"pb-8\" \nlayout=\"column\" layout-align=\"space-between center\"><div class=\"w-150 h-180\"><input type=\"color\" id=\"mycolor\" \nng-init=\"color = \'#f05a28\'\"></div></div></div></div></div><div layout=\"row\" class=\"margin-bottom-10\" \nlayout-align=\"center center\"><md-button ng-show=\"showbutton\" class=\"md-accent md-raised\" aria-label=\"compose\" \nng-click=\"saveData($event)\" translate=\"save\">Save</md-button><md-button ng-hide=\"showbutton\" \nclass=\"md-accent md-raised\" aria-label=\"compose\" ng-click=\"updateData($event)\" translate=\"update\">Update</md-button>\n</div></div></md-tab><md-tab label=\"Application Settings\"><div layout=\"column\" layout-wrap><div layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div flex=\"100\" flex-gt-xs=\"33\"><div class=\"h2 m-16 pb-16 border-bottom\">\nLogo Image</div><div class=\"p-16 pb-32\"><div class=\"pb-8\" id=\"imgid\" layout=\"column\" \nlayout-align=\"space-between start\"><img class=\"w-150 h-160\" id=\"applogo\"> <input id=\"logoUpload\" name=\"logoUpload\" \ntype=\"file\" maxsize=\"500\" onchange=\"angular.element(this).scope().setapplogo(this)\" accept=\"image/*\"></div></div></div>\n<div flex=\"100\" flex-gt-xs=\"33\"><div class=\"h2 m-16 pb-16 border-bottom\">Background Image</div><div class=\"p-16 pb-32\">\n<div class=\"pb-8\" layout=\"column\" layout-align=\"space-between start\"><div class=\"pb-8\" layout=\"column\" \nlayout-align=\"space-between start\"><img class=\"w-150 h-150\" id=\"appbackimage\" ng-src=\"{{addOperator.imageUrl}}\"> <input\n id=\"appbackroundimageUpload\" name=\"backroundimageUpload\" type=\"file\" maxsize=\"500\" \nonchange=\"angular.element(this).scope().setappbackgroundimage(this)\" accept=\"image/*\"></div></div></div></div><div \nflex=\"100\" flex-gt-xs=\"33\"><div class=\"h2 m-16 pb-16 border-bottom\">Label</div><div class=\"p-16 pb-32\"><div \nclass=\"pb-8\" layout=\"column\" layout-align=\"space-between center\"><div class=\"w-150 h-180\"><md-input-container><label>\nTitle</label><input ng-model=\"selectedModel.title\"></md-input-container></div></div></div></div></div><div \nlayout=\"row\" class=\"margin-bottom-10\" layout-align=\"center center\"><md-button ng-show=\"showbutton\" \nclass=\"md-accent md-raised\" aria-label=\"compose\" ng-click=\"saveData($event)\" translate=\"save\">Save</md-button>\n<md-button ng-hide=\"showbutton\" class=\"md-accent md-raised\" aria-label=\"compose\" ng-click=\"updateData($event)\" \ntranslate=\"update\">Update</md-button></div></div></md-tab></md-tabs></div></md-content></ms-widget></div></div></div>");
$templateCache.put("app/main/administration/settings/helpSettings.html","<style>\n.mh-0 {\r\n    min-height: 0px !important;\r\n}\r\n.parent-tabs > md-tabs .md-tab.md-active:after{\r\n    content: \" \";\r\n    border-left: 7px solid transparent;\r\n    border-right: 7px solid transparent;\r\n    border-bottom: 7px solid #efefef;\r\n    position: absolute;\r\n    display: block;\r\n    top: 87%;\r\n    left: 50%;\r\n   \r\n}\r\n.parent-tabs > md-tabs md-ink-bar {\r\n    background: none; \r\n}\r\n.parent-tabs > md-tabs .md-tab:hover {\r\n    color: #389cec !important;\r\n}\r\n.md-tab {\r\n  \r\n  text-transform: none;\r\n  }\n</style><div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Account\" \nui-sref=\"app.administration.settings.account\"></md-tab><md-tab label=\"Brand\" \nui-sref=\"app.administration.settings.brand\"></md-tab></md-tabs></div><div layout=\"row\" class=\"md-padding white-bg\"><div\n class=\"md-padding\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>Help </b></span></div><span flex=\"5\">\n</span></div></ms-widget></div></div></div>");
$templateCache.put("app/main/administration/settings/menubarSettings.html","<style>\n.mh-0 {\r\n    min-height: 0px !important;\r\n}\r\n.parent-tabs > md-tabs .md-tab.md-active:after{\r\n    content: \" \";\r\n    border-left: 7px solid transparent;\r\n    border-right: 7px solid transparent;\r\n    border-bottom: 7px solid #efefef;\r\n    position: absolute;\r\n    display: block;\r\n    top: 87%;\r\n    left: 50%;\r\n   \r\n}\r\n.parent-tabs > md-tabs md-ink-bar {\r\n    background: none; \r\n}\r\n.parent-tabs > md-tabs .md-tab:hover {\r\n    color: #389cec !important;\r\n}\r\n.md-tab {\r\n  \r\n  text-transform: none;\r\n  }\n</style><div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap ng-init=\"settingCtrl.getSystemDetails()\"><ms-widget flippable=\"true\" \nclass=\"no-padding\"><div class=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Account\" \nui-sref=\"app.administration.settings.account\"></md-tab><md-tab label=\"Smartstore\" \nui-sref=\"app.administration.settings.smartstore\"></md-tab><md-tab label=\"Solar\" \nui-sref=\"app.administration.settings.solar\"></md-tab><md-tab label=\"Brand\" ui-sref=\"app.administration.settings.brand\">\n</md-tab><md-tab label=\"Site\" ui-sref=\"app.administration.settings.site\"></md-tab><md-tab label=\"MenuBar\" \nui-sref=\"app.administration.settings.menubar\" md-active=\"true\"></md-tab></md-tabs></div><md-content class=\"md-padding\">\n<div class=\"content\" flex><md-tabs md-dynamic-height><md-tab label=\"Menubar Settings\"><div layout=\"column\" layout-wrap>\n<div layout=\"row\" layout-align=\"start center\" layout-wrap><div flex=\"100\" flex-gt-xs=\"15\"><div \nclass=\"h2 m-16 pb-16 border-bottom\">indox</div><div class=\"p-16 pb-32\"><div class=\"pb-8\" layout=\"column\" \nlayout-align=\"space-between center\"><div class=\"w-150 h-180\"><md-switch ng-model=\"systemDetails.activeMenu.inbox\" \naria-label=\"inbox\"></md-switch></div></div></div></div><div flex=\"100\" flex-gt-xs=\"15\"><div \nclass=\"h2 m-16 pb-16 border-bottom\">Request</div><div class=\"p-16 pb-32\"><div class=\"pb-8\" layout=\"column\" \nlayout-align=\"space-between center\"><div class=\"w-150 h-180\"><md-switch ng-model=\"systemDetails.activeMenu.request\" \naria-label=\"request\"></md-switch></div></div></div></div><div flex=\"100\" flex-gt-xs=\"15\"><div \nclass=\"h2 m-16 pb-16 border-bottom\">site</div><div class=\"p-16 pb-32\"><div class=\"pb-8\" layout=\"column\" \nlayout-align=\"space-between center\"><div class=\"w-150 h-180\"><md-switch ng-model=\"systemDetails.activeMenu.site\" \naria-label=\"site\"></md-switch></div></div></div></div><div flex=\"100\" flex-gt-xs=\"15\"><div \nclass=\"h2 m-16 pb-16 border-bottom\">shared</div><div class=\"p-16 pb-32\"><div class=\"pb-8\" layout=\"column\" \nlayout-align=\"space-between center\"><div class=\"w-150 h-180\"><md-switch ng-model=\"systemDetails.activeMenu.shared\" \naria-label=\"shared\"></md-switch></div></div></div></div><div flex=\"100\" flex-gt-xs=\"15\"><div \nclass=\"h2 m-16 pb-16 border-bottom\">Reports</div><div class=\"p-16 pb-32\"><div class=\"pb-8\" layout=\"column\" \nlayout-align=\"space-between center\"><div class=\"w-150 h-180\"><md-switch ng-model=\"systemDetails.activeMenu.reports\" \naria-label=\"reports\"></md-switch></div></div></div></div><div flex=\"100\" flex-gt-xs=\"15\"><div \nclass=\"h2 m-16 pb-16 border-bottom\">workflow</div><div class=\"p-16 pb-32\"><div class=\"pb-8\" layout=\"column\" \nlayout-align=\"space-between center\"><div class=\"w-150 h-180\"><md-switch ng-model=\"systemDetails.activeMenu.workflow\" \naria-label=\"workflow\"></md-switch></div></div></div></div></div><div layout=\"row\" class=\"margin-bottom-10\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" aria-label=\"compose\" \nng-click=\"settingCtrl.savesitesetting()\" translate=\"Save\">save</md-button></div></div></md-tab></md-tabs></div>\n</md-content></ms-widget></div></div></div>");
$templateCache.put("app/main/administration/settings/siteSettings.html","<style>\n.mh-0 {\r\n    min-height: 0px !important;\r\n}\r\n.parent-tabs > md-tabs .md-tab.md-active:after{\r\n    content: \" \";\r\n    border-left: 7px solid transparent;\r\n    border-right: 7px solid transparent;\r\n    border-bottom: 7px solid #efefef;\r\n    position: absolute;\r\n    display: block;\r\n    top: 87%;\r\n    left: 50%;\r\n   \r\n}\r\n.parent-tabs > md-tabs md-ink-bar {\r\n    background: none; \r\n}\r\n.parent-tabs > md-tabs .md-tab:hover {\r\n    color: #389cec !important;\r\n}\r\n.md-tab {\r\n  \r\n  text-transform: none;\r\n  }\n</style><div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap ng-init=\"settingCtrl.getSystemDetails()\"><ms-widget flippable=\"true\" \nclass=\"no-padding\"><div class=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Account\" \nui-sref=\"app.administration.settings.account\"></md-tab><md-tab label=\"Brand\" \nui-sref=\"app.administration.settings.brand\"></md-tab></md-tabs></div><md-content class=\"md-padding\"><div \nclass=\"content\" flex><md-tabs md-dynamic-height><md-tab label=\"Site Settings\"><div layout=\"column\" layout-wrap><div \nlayout=\"row\" layout-align=\"start center\" layout-wrap><div flex=\"100\" flex-gt-xs=\"33\"><div \nclass=\"h2 m-16 pb-16 border-bottom\">Site Display Name</div><div class=\"p-16 pb-32\"><div class=\"pb-8\" layout=\"column\" \nlayout-align=\"space-between center\"><div class=\"w-150 h-180\"><md-input-container><label>Site Name</label><input \nng-model=\"systemDetails.site.sitedisplayname\"></md-input-container></div></div></div></div><div flex=\"100\" \nflex-gt-xs=\"33\"><div class=\"h2 m-16 pb-16 border-bottom\">Maximun NO. of Sites</div><div class=\"p-16 pb-32\"><div \nclass=\"pb-8\" layout=\"column\" layout-align=\"space-between center\"><div class=\"w-150 h-180\"><md-input-container><label>\nno. of sites</label><input type=\"number\" ng-model=\"systemDetails.site.maxnosite\"></md-input-container></div></div>\n</div></div><div flex=\"100\" flex-gt-xs=\"33\"><div class=\"h2 m-16 pb-16 border-bottom\">Allow WebDAV</div><div \nclass=\"p-16 pb-32\"><div class=\"pb-8\" layout=\"column\" layout-align=\"space-between center\"><div class=\"w-150 h-180\">\n<md-input-container><md-switch class=\"md-accent\" name=\"special\" ng-model=\"systemDetails.site.isWebDav\"></md-switch>\n</md-input-container></div></div></div></div></div><div layout=\"row\" class=\"margin-bottom-10\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" aria-label=\"compose\" \nng-click=\"settingCtrl.savesitesetting()\" translate=\"Save\">save</md-button></div></div></md-tab></md-tabs></div>\n</md-content></ms-widget></div></div></div>");
$templateCache.put("app/main/administration/settings/smartstoresettings.html","<style>\n.mh-0 {\r\n    min-height: 0px !important;\r\n}\r\n.parent-tabs > md-tabs .md-tab.md-active:after{\r\n    content: \" \";\r\n    border-left: 7px solid transparent;\r\n    border-right: 7px solid transparent;\r\n    border-bottom: 7px solid #efefef;\r\n    position: absolute;\r\n    display: block;\r\n    top: 87%;\r\n    left: 50%;\r\n   \r\n}\r\n.parent-tabs > md-tabs md-ink-bar {\r\n    background: none; \r\n}\r\n.parent-tabs > md-tabs .md-tab:hover {\r\n    color: #389cec !important;\r\n}\r\n.md-tab {\r\n  \r\n  text-transform: none;\r\n  }\n</style><div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Account\" \nui-sref=\"app.administration.settings.account\"></md-tab><md-tab label=\"Smartstore\" \nui-sref=\"app.administration.settings.smartstore\" md-active=\"true\"></md-tab><md-tab label=\"Solar\" \nui-sref=\"app.administration.settings.solar\"></md-tab><md-tab label=\"Brand\" ui-sref=\"app.administration.settings.brand\">\n</md-tab><md-tab label=\"Site\" ui-sref=\"app.administration.settings.site\"></md-tab><md-tab label=\"MenuBar\" \nui-sref=\"app.administration.settings.menubar\"></md-tab></md-tabs></div><md-content class=\"md-padding\"><div \nlayout=\"row\" layout-align=\"center center\"><div flex=\"70\" style=\"border: 1px solid #cccccc\"><div layout=\"row\"><div \nflex=\"35\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>IP </b></span></div><span flex=\"10\"></span>\n<md-input-container flex=\"15\" class=\"md-block\" layout=\"column\" layout-align=\"space-around start\"><input type=\"text\" \nname=\"name\" ng-disabled=\"Edit\" ng-model=\"site.ip\" required></md-input-container></div><div layout=\"row\"><div flex=\"35\" \nlayout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>Port NO </b></span></div><span flex=\"10\"></span>\n<md-input-container flex=\"15\" class=\"md-block\" layout=\"column\" layout-align=\"space-around start\" \nstyle=\"padding-top: 0px !important;padding-bottom: 0px !important\"><input type=\"text\" name=\"name\" ng-disabled=\"Edit\" \nng-model=\"site.portNo\" required></md-input-container></div><div layout=\"row\"><div flex=\"35\" layout=\"column\" \nlayout-align=\"center end\"><span class=\"h3\"><b>System Id </b></span></div><span flex=\"10\"></span><md-input-container \nflex=\"15\" class=\"md-block\" layout=\"column\" layout-align=\"space-around start\" \nstyle=\"padding-top: 0px !important;padding-bottom: 0px !important\"><input type=\"text\" name=\"name\" ng-disabled=\"Edit\" \nng-model=\"site.systemId\" required></md-input-container></div><div layout=\"row\"><div flex=\"35\" layout=\"column\" \nlayout-align=\"center end\"><span class=\"h3\"><b>Respository </b></span></div><span flex=\"10\"></span><md-input-container \nflex=\"15\" class=\"md-block\" layout=\"column\" layout-align=\"space-around start\" \nstyle=\"padding-top: 0px !important;padding-bottom: 0px !important\"><input type=\"text\" name=\"name\" ng-disabled=\"Edit\" \nng-model=\"site.respository\" required></md-input-container></div><div layout=\"row\"><span flex></span><md-button \nng-click=\"settingCtrl.editMode()\" ng-hide=\"editButton\">Edit</md-button><md-button ng-click=\"settingCtrl.Save()\">Save\n</md-button><md-button ng-click=\"settingCtrl.Cancel()\" ng-show=\"editButton\">Cancel</md-button></div></div></div>\n</md-content></ms-widget></div></div></div>");
$templateCache.put("app/main/administration/settings/solarsettings.html","<style>\n.mh-0 {\r\n    min-height: 0px !important;\r\n}\r\n.parent-tabs > md-tabs .md-tab.md-active:after{\r\n    content: \" \";\r\n    border-left: 7px solid transparent;\r\n    border-right: 7px solid transparent;\r\n    border-bottom: 7px solid #efefef;\r\n    position: absolute;\r\n    display: block;\r\n    top: 87%;\r\n    left: 50%;\r\n   \r\n}\r\n.parent-tabs > md-tabs md-ink-bar {\r\n    background: none; \r\n}\r\n.parent-tabs > md-tabs .md-tab:hover {\r\n    color: #389cec !important;\r\n}\r\n.md-tab {\r\n  \r\n  text-transform: none;\r\n  }\n</style><div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Account\" \nui-sref=\"app.administration.settings.account\"></md-tab><md-tab label=\"Smartstore\" \nui-sref=\"app.administration.settings.smartstore\"></md-tab><md-tab label=\"Solar\" \nui-sref=\"app.administration.settings.solar\" md-active=\"true\"></md-tab><md-tab label=\"Brand\" \nui-sref=\"app.administration.settings.brand\"></md-tab><md-tab label=\"Site\" ui-sref=\"app.administration.settings.site\">\n</md-tab><md-tab label=\"MenuBar\" ui-sref=\"app.administration.settings.menubar\"></md-tab></md-tabs></div><md-content \nclass=\"md-padding\"><div layout=\"row\" layout-align=\"center center\"><div flex=\"70\" style=\"border: 1px solid #cccccc\"><div\n layout=\"row\"><div flex=\"35\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>IP </b></span></div><span \nflex=\"10\"></span><md-input-container flex=\"15\" class=\"md-block\" layout=\"column\" layout-align=\"space-around start\">\n<input type=\"text\" name=\"name\" ng-disabled=\"Edit\" ng-model=\"solr.ip\" required></md-input-container></div><div \nlayout=\"row\"><div flex=\"35\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>Port NO </b></span></div>\n<span flex=\"10\"></span><md-input-container flex=\"15\" class=\"md-block\" layout=\"column\" \nlayout-align=\"space-around start\" style=\"padding-top: 0px !important;padding-bottom: 0px !important\"><input \ntype=\"text\" name=\"name\" ng-disabled=\"Edit\" ng-model=\"solr.portNo\" required></md-input-container></div><div \nlayout=\"row\"><div flex=\"35\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>Core Name </b></span></div>\n<span flex=\"10\"></span><md-input-container flex=\"15\" class=\"md-block\" layout=\"column\" \nlayout-align=\"space-around start\" style=\"padding-top: 0px !important;padding-bottom: 0px !important\"><input \ntype=\"text\" name=\"name\" ng-disabled=\"Edit\" ng-model=\"solr.coreName\" required></md-input-container></div><div \nlayout=\"row\"><span flex></span><md-button ng-click=\"settingCtrl.editMode()\" ng-hide=\"editButton\">Edit</md-button>\n<md-button ng-click=\"settingCtrl.Save()\">Save</md-button><md-button ng-click=\"settingCtrl.Cancel()\" \nng-show=\"editButton\">Cancel</md-button></div></div></div></md-content></ms-widget></div></div></div>");
$templateCache.put("app/main/administration/settings/technicalSettings.html","<style>\n.mh-0 {\r\n    min-height: 0px !important;\r\n}\r\n.parent-tabs > md-tabs .md-tab.md-active:after{\r\n    content: \" \";\r\n    border-left: 7px solid transparent;\r\n    border-right: 7px solid transparent;\r\n    border-bottom: 7px solid #efefef;\r\n    position: absolute;\r\n    display: block;\r\n    top: 87%;\r\n    left: 50%;\r\n   \r\n}\r\n.parent-tabs > md-tabs md-ink-bar {\r\n    background: none; \r\n}\r\n.parent-tabs > md-tabs .md-tab:hover {\r\n    color: #389cec !important;\r\n}\r\n.md-tab {\r\n  \r\n  text-transform: none;\r\n  }\n</style><div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Account\" \nui-sref=\"app.administration.settings.account\"></md-tab><md-tab label=\"Smartstore\" \nui-sref=\"app.administration.settings.smartstore\"></md-tab><md-tab label=\"Solar\" \nui-sref=\"app.administration.settings.solar\"></md-tab><md-tab label=\"Brand\" ui-sref=\"app.administration.settings.brand\">\n</md-tab><md-tab label=\"Site\" ui-sref=\"app.administration.settings.site\"></md-tab><md-tab label=\"MenuBar\" \nui-sref=\"app.administration.settings.menubar\"></md-tab></md-tabs></div><div layout=\"row\" class=\"md-padding white-bg\">\n<div class=\"md-padding\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>Technical Settings</b></span>\n</div><span flex=\"5\"></span></div></ms-widget></div></div></div>");
$templateCache.put("app/main/administration/systemLandScapeDir/createDialog.html","<md-dialog aria-label=\"Create Store\" flex=\"30\"><form name=\"userForm\" novalidate ng-submit=\"userForm.$valid\" \nlayout=\"column\" flex=\"66\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create System</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-input-container class=\"md-block\"><label>System ID</label><input \ntype=\"text\" name=\"store\" ng-model=\"system.systemId\" required></md-input-container><md-input-container class=\"md-block\">\n<label>Name</label><input type=\"text\" name=\"email\" ng-model=\"system.systemName\" required></md-input-container>\n<md-input-container class=\"md-block\"><label>Description</label><input type=\"text\" name=\"email\" \nng-model=\"system.description\" required></md-input-container><md-input-container class=\"md-block\"><label>Type</label>\n<md-select ng-model=\"system.systemType\" required><md-option value=\"SAP\">SAP</md-option><md-option value=\"Synapse\">\nSynapse</md-option><md-option value=\"R5\">R5</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\"><label>IP Address</label><input type=\"text\" name=\"email\" ng-model=\"system.ipAddress\" required>\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button \ntype=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"createSystem(system)\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/systemLandScapeDir/landscapeDir.html","<style>\n.mh-0 {\r\n    min-height: 0px !important;\r\n}\r\n.parent-tabs > md-tabs .md-tab.md-active:after{\r\n    content: \" \";\r\n    border-left: 7px solid transparent;\r\n    border-right: 7px solid transparent;\r\n    border-bottom: 7px solid #efefef;\r\n    position: absolute;\r\n    display: block;\r\n    top: 87%;\r\n    left: 50%;\r\n    \r\n}\r\n.parent-tabs > md-tabs md-ink-bar {\r\n    background: none; \r\n}\r\n.parent-tabs > md-tabs .md-tab:hover {\r\n    color: #389cec !important;\r\n}\r\n.md-tab {\r\n  \r\n  text-transform: none;\r\n  }\r\n  .table-border {\r\n    border: 1px solid #d3d3d3 !important;\r\n}\r\n.table-header {\r\n    background-color: #dee7f4 !important;\r\n    text-transform: uppercase;\r\n    font-size: 11px!important;\r\n}\n</style><div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"System Landscape Directory\" \nui-sref=\"app.administration.systemLandScapeDirectory\" md-active=\"true\"></md-tab></md-tabs></div><div \nclass=\"md-padding white-bg\"><table class=\"dataTable row-border hover table-border\" datatable=\"ng\" \ndt-options=\"ilmSystems.dtOptions\"><thead><tr class=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">System ID</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Type</span></div></th><th class=\"secondary-text\"><div class=\"table-header\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr \nng-repeat=\"system in ILMSystems | filter : searchUser\"><td>{{system.systemId}}</td><td>{{system.systemName}}</td><td>\n{{system.systemType}}</td><td layout=\"row\" layout-align=\"center center\" \nstyle=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Update\" ng-click=\"updateSystem($event, system )\"><md-tooltip md-direction=\"top\">Update</md-tooltip>\n<md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s18 deleteme\"></i></md-icon></md-button>\n<md-button class=\"md-icon-button test-tooltip\" aria-label=\"Delete\" ng-click=\"deleteSystem(system)\"><md-tooltip \nmd-direction=\"top\">Delete</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-delete s18\"></i></md-icon></md-button></td></tr></tbody></table></div></ms-widget></div><md-button \nflow-btn class=\"md-fab grey-700-bg md-mini md-fab-bottom-right\" aria-label=\"Create User\" \nng-click=\"creatDirDialog($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">\nCreate Directory</md-tooltip></md-button></div></div>");
$templateCache.put("app/main/administration/systemLandScapeDir/updateDialog.html","<md-dialog aria-label=\"Create Store\" flex=\"30\"><form name=\"userForm\" novalidate ng-submit=\"userForm.$valid\" \nlayout=\"column\" flex=\"66\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Update System</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-input-container class=\"md-block\"><label>System ID</label><input \ntype=\"text\" name=\"store\" ng-model=\"system.systemId\" required></md-input-container><md-input-container class=\"md-block\">\n<label>Name</label><input type=\"text\" name=\"email\" ng-model=\"system.systemName\" required></md-input-container>\n<md-input-container class=\"md-block\"><label>Description</label><input type=\"text\" name=\"email\" \nng-model=\"system.description\" required></md-input-container><md-input-container class=\"md-block\"><label>Type</label>\n<md-select ng-model=\"system.systemType\" required><md-option value=\"SAP\">SAP</md-option><md-option value=\"Synapse\">\nSynapse</md-option><md-option value=\"R5\">R5</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\"><label>IP Address</label><input type=\"text\" name=\"email\" ng-model=\"system.ipAddress\" required>\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button \ntype=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"updateSystem(system)\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/login/forgot-password/forgot-password.html","<div id=\"forgotpassword\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><span>SP</span></div><div class=\"title\">Recover your password</div><form \nname=\"vm.forgotPasswordForm\" novalidate ng-submit=\"vm.forgotPasswordForm.$valid && vm.reset(user)\"><md-input-container \nclass=\"md-block\"><input type=\"email\" name=\"email\" ng-model=\"user.email\" placeholder=\"Email\" required><div \nng-messages=\"vm.forgotPasswordForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nEmail field is required</span></div><div ng-message=\"email\"><span>Email must be a valid e-mail address</span></div>\n</div></md-input-container><md-button \nclass=\"md-raised md-accent submit-button md-button ng-scope md-default-theme md-ink-ripple\" type=\"submit\" \naria-label=\"SEND RESET LINK\">SEND RESET LINK<div class=\"md-ripple-container\"></div></md-button></form><div \nclass=\"login\" layout=\"row\" layout-align=\"center center\"><a class=\"link\" ui-sref=\"app.sample\">Go back to login</a></div>\n</div></div></div>");
$templateCache.put("app/main/administration/workflow-management/create.workflow.dialog.html","<md-dialog aria-label=\"Add a new doctype\" flex=\"35\"><form name=\"docType\" layout=\"column\" flex=\"66\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create Activity</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><md-input-container class=\"md-block\">\n<input type=\"text\" name=\"name\" ng-model=\"doc.actvity\" placeholder=\"Actvity\" required><div \nng-messages=\"doctype.name.$error\" role=\"alert\"><div ng-message=\"required\">Actvity is required</div></div>\n</md-input-container><md-input-container class=\"md-block\"><input type=\"description\" name=\"description\" \nng-model=\"doc.description\" placeholder=\"Description\" required><div ng-messages=\"doctype.description.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Description is required</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"buttonText\" \nng-model=\"doc.buttonText\" placeholder=\"ButtonText\" required><div ng-messages=\"doctype.prefix.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>ButtonText is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><label>Type</label><md-select ng-model=\"doc.type\"><md-option ng-value=\"type\" \nng-repeat=\"type in activitytypes\">{{type}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\"><input type=\"text\" name=\"url\" ng-model=\"doc.url\" placeholder=\"Url\" required><div \nng-messages=\"doctype.flowId.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Url is required\n</span></div></div></md-input-container><md-checkbox ng-model=\"doc.commentsRequired\" style=\"margin-bottom: 0px\">\n</md-checkbox><span>Comments Required</span></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button type=\"button\" \nng-click=\"save(doc)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/workflow-management/update.workflow.dialog.html","<md-dialog aria-label=\"Add a new doctype\" flex=\"35\"><form name=\"docType\" layout=\"column\" flex=\"66\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Edit Activity:{{currentUser.actvity}}</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><md-input-container class=\"md-block\">\n<input type=\"text\" name=\"name\" ng-model=\"currentUser.actvity\" placeholder=\"Activity\" required><div \nng-messages=\"doctype.name.$error\" role=\"alert\"><div ng-message=\"required\">Name is required</div></div>\n</md-input-container><md-input-container class=\"md-block\"><input type=\"description\" name=\"description\" \nng-model=\"currentUser.description\" placeholder=\"Description\" required><div ng-messages=\"doctype.description.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Description is required</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"buttonText\" \nng-model=\"currentUser.buttonText\" placeholder=\"Button Text\" required><div ng-messages=\"doctype.prefix.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>ActivityText is required</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><label>Type</label><md-select ng-model=\"currentUser.type\">\n<md-option ng-value=\"type\" ng-repeat=\"type in activitytypes\">{{type}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\"><input type=\"text\" name=\"url\" ng-model=\"currentUser.url\" placeholder=\"Url\" \nrequired><div ng-messages=\"doctype.flowId.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nUrl is required</span></div></div></md-input-container><md-checkbox ng-model=\"currentUser.commentsRequired\" \nstyle=\"margin-bottom: 0px\"></md-checkbox><span>Comments Required</span></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button \ntype=\"button\" ng-click=\"update(currentUser)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/workflow-management/workflow.content.html","<style>\n.mh-0 {\r\n    min-height: 0px !important;\r\n}\r\n.parent-tabs > md-tabs .md-tab.md-active:after{\r\n    content: \" \";\r\n    border-left: 7px solid transparent;\r\n    border-right: 7px solid transparent;\r\n    border-bottom: 7px solid #efefef;\r\n    position: absolute;\r\n    display: block;\r\n    top: 87%;\r\n    left: 50%;\r\n    \r\n}\r\n.parent-tabs > md-tabs md-ink-bar {\r\n    background: none; \r\n}\r\n.parent-tabs > md-tabs .md-tab:hover {\r\n    color: #389cec !important;\r\n}\r\n.md-tab {\r\n  \r\n  text-transform: none;\r\n  }\r\n  .table-border {\r\n    border: 1px solid #d3d3d3 !important;\r\n}\r\n.table-header {\r\n    background-color: #dee7f4 !important;\r\n    text-transform: uppercase;\r\n    font-size: 11px!important;\r\n}\n</style><div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Activity\" \nui-sref=\"app.administration.workflow-management.content\" md-active=\"true\"></md-tab><md-tab label=\"WorkFlow\" \nui-sref=\"app.administration.workflow-management.defination\"></md-tab></md-tabs></div><div class=\"md-padding white-bg\">\n<table class=\"dataTable row-border hover table-border table-header\" datatable=\"ng\" dt-options=\"dtOptions\" \ndata-ng-if=\"activitys.length > 0\"><thead><tr class=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">Activity</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Description</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">ButtonText</span></div></th><th class=\"secondary-text\"><div class=\"table-header\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr \nng-repeat=\"doc in activitys\"><td>{{doc.actvity}}</td><td>{{doc.description}}</td><td>{{doc.buttonText}}</td><td \nlayout=\"row\" layout-align=\"center center\" style=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button \nid=\"{{doc.id}}\" class=\"md-icon-button test-tooltip\" aria-label=\"Update\" \nonclick=\"angular.element(this).scope().updateRequestDialog(this)\"><md-tooltip md-direction=\"top\">Update</md-tooltip>\n<md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s18\"></i></md-icon></md-button><md-button\n id=\"{{doc.id}}\" class=\"md-icon-button test-tooltip\" aria-label=\"Delete\" \nonclick=\"angular.element(this).scope().deleteActivity(this)\"><md-tooltip md-direction=\"top\">Delete</md-tooltip>\n<md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s18\"></i></md-icon></md-button></td></tr>\n</tbody></table></div><div class=\"md-padding white-bg\" data-ng-if=\"activitys.length == 0\"><div \nclass=\"content-container text-center\"><div class=\"alert alert-info mv-10 mh-10\"><p>No data available</p></div></div>\n</div></ms-widget></div><md-button flow-btn class=\"md-fab md-mini grey-700-bg md-fab-bottom-right add_btn\" \naria-label=\"Create Activity\" ng-click=\"createWorkflow($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"top\">Create Activity</md-tooltip></md-button></div></div>");
$templateCache.put("app/main/administration/workflow-management/workflow.defination.html","<style>\n.mh-0 {\r\n    min-height: 0px !important;\r\n}\r\n.parent-tabs > md-tabs .md-tab.md-active:after{\r\n    content: \" \";\r\n    border-left: 7px solid transparent;\r\n    border-right: 7px solid transparent;\r\n    border-bottom: 7px solid #efefef;\r\n    position: absolute;\r\n    display: block;\r\n    top: 87%;\r\n    left: 50%;\r\n    \r\n}\r\n.parent-tabs > md-tabs md-ink-bar {\r\n    background: none; \r\n}\r\n.parent-tabs > md-tabs .md-tab:hover {\r\n    color: #389cec !important;\r\n}\r\n.md-tab {\r\n  \r\n  text-transform: none;\r\n  }\r\n  .table-border {\r\n    border: 1px solid #d3d3d3 !important;\r\n}\r\n.table-header {\r\n    background-color: #dee7f4 !important;\r\n    text-transform: uppercase;\r\n    font-size: 11px!important;\r\n}\n</style><div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Activity\" \nui-sref=\"app.administration.workflow-management.content\"></md-tab><md-tab label=\"WorkFlow\" \nui-sref=\"app.administration.workflow-management.defination\" md-active=\"true\"></md-tab></md-tabs></div><div \nclass=\"md-padding white-bg\"><div class=\"content-container text-center\"><div class=\"alert alert-info mv-10 mh-10\"><p>\nNo data available</p></div></div></div></ms-widget></div></div></div><div ng-include=\"\'/app/core/layouts/footer.html\'\">\n</div>");
$templateCache.put("app/main/migration/documentationMigrationStatusReports/documentationMigrationStatusReports.html","<style>.nav-bar {\r\n        background: #fff;\r\n        border-bottom: 1px solid rgb(190, 190, 190);\r\n    }</style><div \nclass=\"nav-bar\" layout=\"row\"><div class=\"p-5\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-primary\" \nstyle=\"text-transform:capitalize; font-weight: bold; margin: 1rem 2rem 0 0\" ng-click=\"goBack()\"><i \nclass=\"icon icon-arrow-left s20\" style=\"vertical-align: sub\"></i> Back To Migration</md-button></div></div><div \nclass=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget><ms-widget-front class=\"white-bg\"><div \nlayout=\"row\" layout-align=\"start start\" style=\"padding: 15px\"><md-input-container flex-gt-sm=\"15\" \nclass=\"md-block margin\" style=\"border: 1px solid rgb(169, 161, 161);margin-top: 0%;border-radius: 5px;height: 35px\">\n<label>Status</label><md-select ng-model=\"object.status\" multiple=\"multiple\"><md-option value=\"completed\">Completed\n</md-option><md-option value=\"failed\">Failed</md-option></md-select></md-input-container><md-input-container \nflex-gt-sm=\"15\" class=\"md-block margin\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 5px; height: 36px; margin-right: 3%;margin-left: 3%; margin-top: 0%\">\n<label>Date Range</label><input date-range-picker ng-readonly=\"true\" name=\"datefilter\" type=\"text\" \nng-model=\"object.date\"></md-input-container><div layout=\"row\" layout-align=\"space-between center\"><md-button \nclass=\"md-raised md-accent\" ng-click=\" documentSearch(object)\" style=\"margin-top:-1% !important;margin-left: -9%\">\n<md-icon md-menu-align-target md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon>Search</md-button><md-button \nclass=\"md-raised md-warn\" ng-click=\"DocCtrl.Reset()\" style=\"margin-top:-1% !important\"><md-icon \nmd-font-icon=\"icon-replay\"></md-icon>Reset</md-button></div><div></div></div><div layput=\"row\" \nlayout-align=\"space-between center\" style=\"padding: 10px\"><div><md-checkbox aria-label=\"Select All\" \nng-checked=\"checkuncheckAllWorkitems()\" md-indeterminate=\"isIndeterminate()\" ng-click=\"toggleAll()\" \nstyle=\"margin-bottom: -3%\"></md-checkbox></div><div style=\"margin-top: -2%\"><md-button class=\"md-raised md-accent\" \nng-click=\" documentSubmit()\" style=\"margin-left: 3%\">Migrate</md-button></div></div><table id=\"scrollToDivID\" \nclass=\"dataTable row-border hover tableHighllete\" ng-if=\"batchDetails.length != 0\" class=\"scrollable\" ms-scroll \nstyle=\"border: 1px solid #ccc\"><img src=\"assets/images/loading.gif\" alt=\"Smiley face\" ng-if=\"loadingbar==true\" \nheight=\"80\" width=\"80\" style=\"left: 50%;top: 20%;transform: translate(-50%, -50%);position: absolute\"><thead><tr \nstyle=\"background-color: #093676 !important; color: white\"><th></th><th>S.No</th><th>Archieve Doc ID</th><th>Archive ID\n</th><th>File Name</th><th>Created ON</th><th>Response Code</th><th>Status</th></tr></thead><tbody><tr \nng-repeat=\"document in DocumentationDetails\"><td><span ng-if=\"document.status != \'completed\'\"><md-checkbox \nng-checked=\"exists(document, selected)\" ng-click=\"checkuncheckWorkitems(document, selected)\"></md-checkbox></span></td>\n<td>{{$index+1}}</td><td>{{document.archiveDocId}}</td><td>{{document.sourceArchiveId}}</td><td>{{document.fileName}}\n</td><td><span>\n{{document.createdDate.substring(8,10)}}-{{document.createdDate.substring(5,7)}}-{{document.createdDate.substring(0,4)}}\n</span> <span style=\"color: #070707\"><b>\n{{document.createdDate.substring(11,13)}}:{{document.createdDate.substring(14,16)}}:{{document.createdDate.substring(17,19)}}\n</b></span></td><td>{{document.statusCode}}</td><td><span ng-if=\"document.status==\'failed\'\" style=\"color: red\">\n{{document.status}}</span> <span ng-if=\"document.status!=\'failed\'\" style=\"color:green\">{{document.status}}</span> \n<span><md-button class=\"md-icon-button\" ng-click=\"viewdocuments(document.archiveDocId)\"><md-tooltip md-direction=\"top\">\nView Document</md-tooltip><md-icon class=\"icon s-18 blue-fg\" md-font-icon=\"icon-eye\"></md-icon></md-button></span></td>\n</tr></tbody></table><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\" \nng-if=\"batchDetails.length != 0 && searchdetails!=true\"><div class=\"md-padding\"><h5><b>\nShowing {{(pageNumber*size)+1}} - {{(pageNumber + 1)*size}} of {{totalRecords}} Results</b></h5></div><div \nlayout=\"row\" layout-align=\"center center\">Page No<md-input-container class=\"md-block md-padding\" style=\"margin: 0px\">\n<md-select ng-model=\"pageNumber\"><md-option ng-repeat=\"Number in pageNumbers\" ng-value=\"Number\" \nng-click=\"sendPageNumber(Number)\" value=\"Number\" ng-selected=\"$first\">{{Number+1}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-align=\"center center\"><div><md-button type=\"button\" \nng-click=\"previous()\" ng-disabled=\"pageNumber <= 0\">Prev</md-button></div><p class=\"md-padding\"><b>\n{{pageNumber+1}}/ {{totalPages}} &nbsp;PAGES</b></p><div class=\"md-padding\"><md-button type=\"button\" \nng-click=\"next(obj)\" ng-disabled=\"pageNumber == totalPages -1 || batchDetails.length == 0\">Next</md-button></div></div>\n</div><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\" ng-if=\"searchdetails == true\"><div \nclass=\"md-padding\"><h5><b>\nShowing {{(pageNumber*searchdetailssize)+1}} - {{(pageNumber + 1)*searchdetailssize}} of {{totalRecords}} Results</b>\n</h5></div><div layout=\"row\" layout-align=\"center center\">Page No<md-input-container class=\"md-block md-padding\" \nstyle=\"margin: 0px\"><md-select ng-model=\"pageNumber\"><md-option ng-repeat=\"Number in pageNumbers\" ng-value=\"Number\" \nng-click=\"searchdetailssendPageNumber(Number)\" value=\"Number\" ng-selected=\"$first\">{{Number+1}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-align=\"center center\"><div><md-button type=\"button\" \nng-click=\"searchdetailsprevious()\" ng-disabled=\"searchdetailspageNumber <= 0\">Prev</md-button></div><p \nclass=\"md-padding\"><b>{{searchdetailspageNumber+1}}/ {{totalPages}} &nbsp;PAGES</b></p><div class=\"md-padding\">\n<md-button type=\"button\" ng-click=\"searchdetailsnext()\" \nng-disabled=\"pageNumber == totalPages -1 || DocumentationDetails.length == 0\">Next</md-button></div></div></div>\n</ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/migration/batchRecords/batchRecord.html","<style>.nav-bar {\r\n        background: #fff;\r\n        border-bottom: 1px solid rgb(190, 190, 190);\r\n    }</style><div \nclass=\"nav-bar\" layout=\"row\"><div class=\"p-5\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-primary\" \nstyle=\"text-transform:capitalize; font-weight: bold; margin: 1rem 2rem 0 0\" ng-click=\"goBack()\"><i \nclass=\"icon icon-arrow-left s20\" style=\"vertical-align: sub\"></i> Back To Batch Records</md-button></div></div><div \nclass=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget><ms-widget-front class=\"white-bg\"><table \nid=\"scrollToDivID\" class=\"dataTable row-border hover table-border table-header\" ng-if=\"batchDetails.length != 0\" \nclass=\"scrollable\" ms-scroll style=\"border: 1px solid #ccc\"><img src=\"assets/images/loading.gif\" alt=\"Smiley face\" \nng-if=\"loadingbar==true\" height=\"60\" width=\"60\" \nstyle=\"left: 50%;top: 50%;transform: translate(-50%, -50%);position: absolute\"><thead><tr \nstyle=\"background-color: #093676 !important; color: white\"><th>S.No</th><th>Batch ID</th><th>Document Count</th><th>\nSuccess Count</th><th>Start Date Time</th><th>End Date Time</th><th>Status</th><th>Time Difference</th><th>Action</th>\n</tr></thead><tbody><tr ng-repeat=\"batch in batchDetails \"><td>{{$index+1}}</td><td>{{batch.id}}</td><td>\n{{batch.batchSize}}</td><td>{{batch.successCount}}</td><td><span>\n{{batch.createdDate.substring(8,10)}}-{{batch.createdDate.substring(5,7)}}-{{batch.createdDate.substring(0,4)}}</span> \n<span style=\"color: #070707\"><b>\n{{batch.createdDate.substring(11,13)}}:{{batch.createdDate.substring(14,16)}}:{{batch.createdDate.substring(17,19)}}\n</b></span></td><td><span>\n{{batch.lastModifiedDate.substring(8,10)}}-{{batch.lastModifiedDate.substring(5,7)}}-{{batch.lastModifiedDate.substring(0,4)}}\n</span> <span style=\"color: #070707\"><b>\n{{batch.lastModifiedDate.substring(11,13)}}:{{batch.lastModifiedDate.substring(14,16)}}:{{batch.lastModifiedDate.substring(17,19)}}\n</b></span></td><td><span ng-if=\"batch.batchStatus!=\'Completed\'\" style=\"color: red\">{{batch.batchStatus}}</span> <span \nng-if=\"batch.batchStatus ==\'Completed\'\" style=\"color:green\">{{batch.batchStatus}}</span></td><td>\n{{batch.differencehours}}</td><td><md-button class=\"md-icon-button\" ng-click=\"goToBatchDetails(batch)\"><md-tooltip \nmd-direction=\"top\">View Batch Record</md-tooltip><md-icon class=\"icon s-18 blue-fg\" md-font-icon=\"icon-eye\"></md-icon>\n</md-button></td></tr></tbody></table><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\" \nng-if=\"batchDetails.length != 0\"><div class=\"md-padding\"><h5><b>\nShowing {{(pageNumber*size)+1}} - {{(pageNumber + 1)*size}} of {{totalRecords}} Results</b></h5></div><div \nlayout=\"row\" layout-align=\"center center\">Page No<md-input-container class=\"md-block md-padding\" style=\"margin: 0px\">\n<md-select ng-model=\"pageNumber\"><md-option ng-repeat=\"Number in pageNumbers\" ng-value=\"Number\" \nng-click=\"sendPageNumber(Number)\" value=\"Number\" ng-selected=\"$first\">{{Number+1}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-align=\"center center\"><div><md-button type=\"button\" \nng-click=\"previous()\" ng-disabled=\"pageNumber <= 0\">Prev</md-button></div><p class=\"md-padding\"><b>\n{{pageNumber+1}}/ {{totalPages}} &nbsp;PAGES</b></p><div class=\"md-padding\"><md-button type=\"button\" \nng-click=\"next(obj)\" ng-disabled=\"pageNumber == totalPages -1 || batchDetails.length == 0\">Next</md-button></div></div>\n</div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/migration/batchRecords/batchRecordDetail.html","<div class=\"nav-bar\" layout=\"row\"><div class=\"p-5\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-primary\" style=\"text-transform:capitalize; font-weight: bold; margin: 1rem 2rem 0 0\" \nng-click=\"goBackbatchrecords()\"><i class=\"icon icon-arrow-left s20\" style=\"vertical-align: sub\"></i>\n Back To Batch Records</md-button></div></div><div class=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap>\n<ms-widget><ms-widget-front class=\"white-bg\"><table id=\"scrollToDivID\" \nclass=\"dataTable row-border hover table-border table-header\" class=\"scrollable\" ms-scroll \nstyle=\"border: 1px solid #ccc\"><img src=\"assets/images/loading.gif\" alt=\"Smiley face\" ng-if=\"loadingbar==true\" \nheight=\"60\" width=\"60\" style=\"left: 50%;top: 50%;transform: translate(-50%, -50%);position: absolute\"><thead><tr \nstyle=\"background-color: #093676 !important; color: white\"><th>Batch ID</th><th>Archieve Id</th><th>Start Date Time\n</th><th>End Date Time</th><th>Status</th></tr></thead><tbody><tr ng-repeat=\"batch in batchDetailspageData\"><td>\n{{batch.batchId}}</td><td>{{batch.archiveDocId}}</td><td><span>\n{{batch.createdDate.substring(8,10)}}-{{batch.createdDate.substring(5,7)}}-{{batch.createdDate.substring(0,4)}}</span> \n<span style=\"color: #070707\"><b>\n{{batch.createdDate.substring(11,13)}}:{{batch.createdDate.substring(14,16)}}:{{batch.createdDate.substring(17,19)}}\n</b></span></td><td><span>\n{{batch.lastModifiedDate.substring(8,10)}}-{{batch.lastModifiedDate.substring(5,7)}}-{{batch.lastModifiedDate.substring(0,4)}}\n</span> <span style=\"color: #070707\"><b>\n{{batch.lastModifiedDate.substring(11,13)}}:{{batch.lastModifiedDate.substring(14,16)}}:{{batch.lastModifiedDate.substring(17,19)}}\n</b></span></td><td><span ng-if=\"batch.status==\'failed\'\" style=\"color: red\">{{batch.status}}</span> <span \nng-if=\"batch.status!=\'failed\'\" style=\"color:green\">{{batch.status}}</span></td></tr></tbody></table><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\" ng-if=\"batchDetails.length != 0\"><div class=\"md-padding\"><h5><b>\nShowing {{(pageNumber*size)+1}} - {{(pageNumber + 1)*size}} of {{totalRecords}} Results</b></h5></div><div \nlayout=\"row\" layout-align=\"center center\">Page No<md-input-container class=\"md-block md-padding\" style=\"margin: 0px\">\n<md-select ng-model=\"pageNumber\"><md-option ng-repeat=\"Number in pageNumbers\" ng-value=\"Number\" \nng-click=\"detailssendPageNumber(Number)\" value=\"Number\" ng-selected=\"$first\">{{Number+1}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-align=\"center center\"><div><md-button type=\"button\" \nng-click=\"detailsprevious()\" ng-disabled=\"pageNumber <= 0\">Prev</md-button></div><p class=\"md-padding\"><b>\n{{pageNumber+1}}/ {{totalPages}} &nbsp;PAGES</b></p><div class=\"md-padding\"><md-button type=\"button\" \nng-click=\"detailsnext(obj)\" ng-disabled=\"pageNumber == totalPages -1 || batchDetails.length == 0\">Next</md-button>\n</div></div></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/migration/migrationSmartstoreConfiguration/migrationSmartstoreConfiguration.html","<style>.nav-bar {\r\n        background: #fff;\r\n        border-bottom: 1px solid rgb(190, 190, 190);\r\n    }</style><div \nclass=\"nav-bar\" layout=\"row\"><div class=\"p-5\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-primary\" \nstyle=\"text-transform:capitalize; font-weight: bold; margin: 1rem 2rem 0 0\" ng-click=\"goBack()\"><i \nclass=\"icon icon-arrow-left s20\" style=\"vertical-align: sub\"></i> Back To Migration</md-button></div></div><div \nclass=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget><ms-widget-front class=\"white-bg\"><div \nclass=\"widget-group c-p\" layout=\"row\" flex=\"100\" layout-wrap><div layout=\"row\" layout-align=\"center center\" flex=\"100\">\n<div layout=\"column\" flex=\"30\" style=\"padding:10px\"><div layout=\"row\" layout-align=\"center center\"><h3><b \nstyle=\"color: #0000f3\">Source System</b></h3></div><div \nstyle=\"border: 1px solid #787171;padding: 15px;background: #bed8ef8c\"><div flex-gt-sm=\"100\" style=\"margin-top: 1.5%\">\n<label>Source URL</label><md-input-container class=\"md-block margin\" style=\"margin: 0px;padding: 0px\"><input \ntype=\"text\" name=\"name\" ng-readonly=\"readable==\'true\'\" ng-model=\"configure.sourceSystemURL\" autocomplete=\"off\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 3px;height: 35px;background-color: white\">\n</md-input-container></div><div flex-gt-sm=\"100\" style=\"margin-top: 1.5%\"><label>System ID</label><md-input-container \nclass=\"md-block margin\" style=\"margin: 0px;padding: 0px\"><input type=\"text\" name=\"name\" ng-readonly=\"readable==\'true\'\" \nng-model=\"configure.sourceSystemId\" autocomplete=\"off\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 3px;height: 35px;background-color: white\">\n</md-input-container></div><div flex-gt-sm=\"100\" style=\"margin-top: 1.5%\"><label>Repository ID</label>\n<md-input-container class=\"md-block margin\" style=\"margin: 0px;padding: 0px\"><input type=\"text\" name=\"name\" \nng-readonly=\"readable==\'true\'\" ng-model=\"configure.sourceSystemArchiveId\" autocomplete=\"off\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 3px;height: 35px;background-color: white\">\n</md-input-container></div></div></div><div layout=\"column\" flex=\"30\" style=\"padding:10px\"><div layout=\"row\" \nlayout-align=\"center center\"><h3><b style=\"color: #0000f3\">Target System</b></h3></div><div \nstyle=\"border: 1px solid #787171;padding: 15px;background: #bed8ef8c\"><div flex-gt-sm=\"100\" style=\"margin-top: 1.5%\">\n<label>Target URL</label><md-input-container class=\"md-block margin\" style=\"margin: 0px;padding: 0px\"><input \ntype=\"text\" name=\"name\" ng-readonly=\"readable==\'true\'\" ng-model=\"configure.destinationSystemURL\" autocomplete=\"off\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 3px;height: 35px;background-color: white\">\n</md-input-container></div><div flex-gt-sm=\"100\" style=\"margin-top: 1.5%\"><label>System ID</label><md-input-container \nclass=\"md-block margin\" style=\"margin: 0px;padding: 0px\"><input type=\"text\" name=\"name\" ng-readonly=\"readable==\'true\'\" \nng-model=\"configure.destinationSystemId\" autocomplete=\"off\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 3px;height: 35px;background-color: white\">\n</md-input-container></div><div flex-gt-sm=\"100\" style=\"margin-top: 1.5%\"><label>Repository ID</label>\n<md-input-container class=\"md-block margin\" style=\"margin: 0px;padding: 0px\"><input type=\"text\" name=\"name\" \nng-readonly=\"readable==\'true\'\" ng-model=\"configure.destinationSystemArchiveId\" autocomplete=\"off\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 3px;height: 35px;background-color: white\">\n</md-input-container></div></div></div></div></div><div></div><div layout=\"column\" layout-align=\"center center\"><div>\n<label>Batch Size</label><md-input-container class=\"md-block margin\" style=\"margin: 0px;padding: 0px\"><input \ntype=\"number\" name=\"name\" ng-readonly=\"readable==\'true\'\" ng-model=\"configure.batchSize\" autocomplete=\"off\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 3px;height: 35px;background-color: white\">\n</md-input-container></div><div style=\"margin-top: -1%\"><label>Re-Try Count</label><md-input-container \nclass=\"md-block margin\" style=\"margin: 0px;padding: 0px\"><input type=\"number\" name=\"name\" \nng-readonly=\"readable==\'true\'\" ng-model=\"configure.retryCount\" autocomplete=\"off\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 3px;height: 35px;background-color: white\">\n</md-input-container></div></div><div layout=\"row\" layout-align=\"center center\" style=\"padding: 10px\"><md-button \nclass=\"md-raised md-accent\" ng-click=\" migrateSubmit(configure)\" ng-hide=\"visible==\'true\'\" \nstyle=\"margin-top:-1% !important;margin-right: 2%\"><md-icon md-menu-align-target md-font-icon=\"icon-plus\" \nclass=\"icon s24\"></md-icon>Save</md-button><md-button class=\"md-raised md-accent\" ng-click=\"migrateUpdate()\" \nstyle=\"margin-top:-1% !important\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>Edit</md-button><md-button \nclass=\"md-raised md-warn\" ng-click=\"migratecancel()\" ng-hide=\"visible==\'true\'\" \nstyle=\"margin-top:-1% !important;margin-left: 2%\"><md-icon md-font-icon=\"icon-delete\"></md-icon>Cancel</md-button>\n</div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/mycontent/Inbox/inbox.html","<div class=\"page-layout simple tabbed mh-0\" layout=\"column\"><div class=\"content parent-tabs\"><md-tabs class=\"mh-0\">\n<md-tab label=\"Inbox\" ui-sref=\"app.mycontent_inbox\" md-active=\"true\"></md-tab><md-tab label=\"Outbox\" \nui-sref=\"app.mycontent_outbox\"></md-tab></md-tabs></div></div><div class=\"widget-group\" flex=\"100\" layout=\"column\" \nlayout-wrap><ms-widget><ms-widget-front class=\"white-bg\" data-ng-if=\"docTypes.length != 0\"><div layout=\"row\" \nlayout-align=\"start start\" class=\"md-padding\"><span flex=\"90\"></span><md-icon md-font-icon=\"icon-view-module\" \nclass=\"s30 faint-text c-p\" ng-click=\"changeView()\"><md-tooltip md-direction=\"down\">Changeview</md-tooltip></md-icon>\n</div><div layout=\"row\" flex ng-show=\"myView\"><ms-widget flex=\"15\" ng-repeat=\"docType in docTypes\"><ms-widget-front \nclass=\"h-170 p-16 c-p\" ng-click=\"goToWorkitems(docType.requestType,docType.displayName)\"><div \nclass=\"md-subhead font-weight-500\">{{docType.displayName}}</div><div layout=\"column\" layout-align=\"space-between\" flex>\n<div><div class=\"h6 secondary-text\">{{docType.description}}</div></div></div><div layout=\"row\" \nlayout-align=\"space-between center\"><div><md-icon md-font-icon=\"{{docType.icon}}\" class=\"s50 icon\"></md-icon></div>\n<div><div layout=\"column\" layout-align=\"end end\"><span class=\"md-display-1 secondary-text\">{{docType.total}}</span> \n<span class=\"h5 secondary-text\">Pending items</span></div></div></div></ms-widget-front></ms-widget></div><div \nlayout=\"column\" ng-hide=\"myView\"><ms-widget ng-repeat=\"docType in docTypes\"><ms-widget-front class=\"h-60 p-16 c-p\" \nng-click=\"goToWorkitems(docType.requestType)\"><div layout=\"row\" layout-align=\"space-between center\"><div><md-icon \nmd-font-icon=\"{{docType.icon}}\" class=\"s50 icon\"></md-icon></div><div class=\"h4 font-weight-500\">\n{{docType.requestType}}</div><div class=\"h6 secondary-text\">{{docType.description}}</div><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h5 secondary-text md-padding\">Pending items</div><div \nclass=\"md-display-1 secondary-text\">{{docType.total}}</div></div></div></ms-widget-front></ms-widget></div>\n</ms-widget-front><ms-widget-front class=\"white-bg h-150\" data-ng-if=\"docTypes.length == 0\"><div \nclass=\"content-container text-center\"><div class=\"alert alert-info mv-10 mh-10\"><p>No data available</p></div></div>\n</ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/mycontent/Inbox/inbox.workitems.html","<style>\n.color{\r\n    color:rgba(0,0,0,0.38);    \r\n    }\r\n    .c-p {\r\n    cursor: pointer;\r\n}\r\n.selected {\r\n    background-color: rgb(232, 233, 237) !important;\r\n}\n</style><div id=\"documnets\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"widget-group\" \nlayout=\"column\" flex=\"20\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\"><ms-widget-front class=\"white-bg\">\n<md-toolbar layout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><div><span class=\"icon-keyboard-backspace c-p\" data-ng-click=\"goToInbox();\"></span>\n</div><div layout=\"row\"><md-icon class=\"icon-refresh c-p\" ng-click=\"getAllWorkitems()\" \nstyle=\"margin-right:-10px !important\"></md-icon><ms-search-bar on-search=\"search(query)\" debounce=\"300\" \nstyle=\"margin-right:-25px !important\"></ms-search-bar></div></div></md-toolbar><md-divider></md-divider><div \nclass=\"scrollable\" ms-scroll><div class=\"c-p\" ng-repeat=\"workitem in allWorkitems \" \ndata-ng-click=\"selectWorkitem(workitem);changeTab()\" data-ng-init=\"$first && selectWorkitem(workitem);\" \ndata-ng-class=\"{\'selected\': selectedWorkitem == workitem.docId}\"><div class=\"md-padding\"><div class=\"h5\"><b>\nPlease Approve {{displayName}}</b></div><span><b>{{workitem.docId}}</b></span><div layout=\"row\" \nlayout-align=\"space-between center \"><span>{{workitem.system}}</span> <span>{{workitem.priority}}</span></div></div>\n<md-divider class=\"no-margin\"></md-divider></div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" \nlayout=\"column\" flex=\"80\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"90\"><ms-widget-front \nclass=\"white-bg\" class=\"scrollable\" ms-scroll><div flex=\"100\" style=\"overflow-y:scroll !important\"><md-content><md-tabs\n md-dynamic-height md-border-bottom><md-tab label=\"Main\" md-active=\"selectedTab\"><md-content \nclass=\"md-padding scrollable\" ms-scroll ng-show=\"formHeader\" flex=\"100\"><div layout=\"row\" layout-align=\"center center\" \nclass=\"md-padding\"><div flex=\"100\"><span>Please Approve GeneralPO Request-<b>{{workitemInfo.sapDocId}}</b></span><form \nname=\"headerForm\" class=\"md-inline-form\" novalidate><fieldset ng-disabled=\"workitemInfo.dataChange == \'D\'\"><div \nng-bind-html=\"currentFormHeader\" compile-template class=\"scrollable\" ms-scroll></div></fieldset></form></div></div><div\n layout=\"row\" layout-align=\"center center\" class=\"md-padding\"><md-button class=\"md-accent md-raised pull-right\" \nng-if=\"workitemInfo.dataChange == \'M\'\" ng-click=\"updateHeader();\">Update</md-button></div></md-content></md-tab><md-tab\n label=\"Details\" ng-if=\"(workitemInfo.lineItems | json) ! =\'{}\'\"><md-content class=\"md-padding scrollable\" ms-scroll \nng-show=\"formLineitem\"><div layout=\"row\" layout-align=\"center center\"><div flex=\"100\"><form name=\"headerForm\" \nclass=\"md-inline-form\" novalidate><fieldset ng-disabled=\"workitemInfo.dataChange == \'D\'\" \nstyle=\"border: 1px solid #cccccc\"><div id=\"inbox-details\" ng-bind-html=\"currentFormLineitem\" compile-template></div>\n</fieldset></form></div></div><div layout=\"row\" layout-align=\"center center\" class=\"md-padding\" \nng-if=\"workitemInfo.dataChange == \'M\'\"><md-button class=\"md-accent md-raised pull-right\" ng-click=\"updateLineItems();\">\nUpdate</md-button></div></md-content></md-tab><md-tab label=\"Logs\"><md-content class=\"md-padding scrollable\" ms-scroll \nng-show=\"formLineitem\"><div class=\"md-padding scrollable\" ms-scroll><timeline><timeline-event \nng-repeat=\"log in workitemInfo.logs track by $index\" side=\"\"><timeline-badge style=\"background-color: rgb(3,155,229)\">\n<md-icon md-font-icon=\"{{log.icon}}\" class=\"s25 icon white-fg\" style=\"color:white !important\"></md-icon>\n</timeline-badge><timeline-panel class=\"{{\'info\'}}\" style=\"background-color: #f1eded;    border-radius: 20px\">\n<timeline-heading><div layout=\"row\" layout-align=\"end end\"><p><b>\nDate : {{log.endDate.substr(6,2)}}-{{log.endDate.substr(4,2)}}-{{log.endDate.substr(0,4)}}</b></p></div><div \nlayout=\"row\" layout-align=\"start center\" style=\"color:black\"><img ng-src=\"assets\\images\\avatars/Nora.jpg\" \nclass=\"md-avatar\" style=\"border-radius:50% !important;width:13%; height:auto\"><div class=\"h2\" \nng-if=\"log.activityText == \'Initiate\' \">{{log.actualUser}} initiated</div><div class=\"h2\" \nng-if=\"log.activityText == \'Approve\' \">{{log.actualUser}} Approved</div><div class=\"h2\" \nng-if=\"log.activityText == \'Cancel\' \">{{log.actualUser}} Rejected</div><div class=\"h2\" \nng-if=\"log.activityText != \'Initiate\' && log.activityText != \'Approve\' && log.activityText != \'Cancel\'  \">\n{{log.actualUser}} {{log.activityText}}</div></div></timeline-heading><div layout=\"row\" layout-align=\"start start\" \nstyle=\"padding-left: 2%\"><p style=\"color:black\">{{log.comments}}</p></div></timeline-panel></timeline-event></timeline>\n</div><div layout=\"row\" layout-align=\"center center\" class=\"md-padding\" ng-if=\"workitemInfo.dataChange == \'M\'\">\n<md-button class=\"md-accent md-raised pull-right\" ng-click=\"updateLineItems();\">Update</md-button></div></md-content>\n</md-tab><md-tab label=\"Attachments\"><div class=\"md-padding scrollable\" ms-scroll><div class=\"md-padding\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"h2\">Attachments</span> <span class=\"h3\">\n{{workitemInfo.attachments.length}}</span></div><div><md-list><md-list-item class=\"md-3-line\" \nng-repeat=\"attachment in workitemInfo.attachments\"><div flex=\"100\" layout=\"row\"><div layout=\"row\" flex=\"70\" \nclass=\"c-p\" ng-click=\"preview($event,attachment,workitemInfo.requestId)\"><div flex=\"10\" layout=\"row\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"{{fileIcon(attachment.fileType)}}\" class=\"s42 icon md-accent\">\n</md-icon></div><div flex=\"60\"><div class=\"md-list-item-text\"><h3><b>{{attachment.fileName}}</b></h3><h3>\nCreated By : {{attachment.creator}}</h3></div></div><div flex=\"30\"><h3>Date : {{attachment.createDate }}</h3></div>\n</div><div><md-icon md-font-icon=\"icon-download\" class=\"s32 c-p icon md-accent\" \nng-click=\"downloadFile(attachment,workitemInfo.requestId )\"></md-icon></div></div></md-list-item></md-list></div></div>\n<form novalidate><div layout=\"column\" layout-align=\"center center\" flex=\"100\" class=\"md-padding\"><div><div><input \nclass=\"ng-hide\" id=\"attachmentUpload\" name=\"attachmentUpload\" type=\"file\" multiple=\"multiple\" \nonchange=\"angular.element(this).scope().setAttachmentFile(this)\"><label for=\"attachmentUpload\" \nclass=\"md-button md-raised\">Upload files</label></div></div><div flex=\"10\"></div><div \nng-repeat=\"file in attachmentfiles.slice(0)\" layout=\"row\" layout-align=\"center center\"><span class=\"md-warn\">\n{{file.webkitRelativePath || file.name}}</span> ( <span ng-switch=\"file.size > 1024*1024\"><span ng-switch-when=\"true\">\n{{file.size / 1024 / 1024 | number:2}} MB</span> <span ng-switch-default>{{file.size / 1024 | number:2}} kB</span> \n</span>)</div></div></form></md-tab></md-tabs></md-content></div></ms-widget-front><div class=\"pv-10 text-right\">\n<md-button class=\"md-raised\" \nng-class=\"{\'md-primary\':actvity.buttonText === \'Reject\', \'md-accent\':actvity.buttonText === \'Approve\'}\" \nng-repeat=\"actvity in workitemInfo.activities\" data-ng-click=\"processActvity(actvity, $event);\" \nstyle=\"margin-right: 5px\">{{actvity.buttonText}}</md-button></div></ms-widget></div></div>");
$templateCache.put("app/main/mycontent/Outbox/outbox.html","<div class=\"page-layout simple tabbed mh-0\" layout=\"column\"><div class=\"content parent-tabs\"><md-tabs class=\"mh-0\">\n<md-tab label=\"Inbox\" ui-sref=\"app.mycontent_inbox\"></md-tab><md-tab label=\"Outbox\" ui-sref=\"app.mycontent_outbox\" \nmd-active=\"true\"></md-tab></md-tabs></div></div><div class=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap>\n<ms-widget><ms-widget-front class=\"white-bg\" data-ng-if=\"docTypes.length != 0\"><div layout=\"row\" \nlayout-align=\"start start\" class=\"md-padding\"><span flex=\"90\"></span><md-icon md-font-icon=\"icon-view-module\" \nclass=\"s30 faint-text c-p\" ng-click=\"changeView()\"><md-tooltip md-direction=\"down\">Changeview</md-tooltip></md-icon>\n</div><div layout=\"row\" flex ng-show=\"myView\"><ms-widget flex=\"15\" ng-repeat=\"docType in docTypes\"><ms-widget-front \nclass=\"h-170 p-16 c-p\" ng-click=\"goToWorkitems(docType.requestType)\"><div class=\"md-subhead font-weight-500\">\n{{docType.requestType}}</div><div layout=\"column\" layout-align=\"space-between\" flex><div><div \nclass=\"h6 secondary-text\">{{docType.description}}</div></div></div><div layout=\"row\" \nlayout-align=\"space-between center\"><div><md-icon md-font-icon=\"{{docType.icon}}\" class=\"s50 icon\"></md-icon></div>\n<div><div layout=\"column\" layout-align=\"end end\"><span class=\"md-display-1 secondary-text\">{{docType.total}}</span> \n<span class=\"h5 secondary-text\">Pending items</span></div></div></div></ms-widget-front></ms-widget></div><div \nlayout=\"column\" ng-hide=\"myView\"><ms-widget ng-repeat=\"docType in docTypes\"><ms-widget-front class=\"h-60 p-16 c-p\" \nng-click=\"goToWorkitems(docType.requestType)\"><div layout=\"row\" layout-align=\"space-between center\"><div><md-icon \nmd-font-icon=\"{{docType.icon}}\" class=\"s50 icon\"></md-icon></div><div class=\"h4 font-weight-500\">\n{{docType.requestType}}</div><div class=\"h6 secondary-text\">{{docType.description}}</div><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h5 secondary-text md-padding\">Pending items</div><div \nclass=\"md-display-1 secondary-text\">{{docType.total}}</div></div></div></ms-widget-front></ms-widget></div>\n</ms-widget-front><ms-widget-front class=\"white-bg h-150\" data-ng-if=\"docTypes.length == 0\"><div \nclass=\"content-container text-center\"><div class=\"alert alert-info mv-10 mh-10\"><p>No data available</p></div></div>\n</ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/mycontent/Outbox/outbox.workitems.html","<style>.c-p {\r\n    cursor: pointer;\r\n}\r\n.selected {\r\n    background-color: rgb(232, 233, 237) !important;\r\n}</style>\n<div id=\"documnets\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"widget-group\" layout=\"column\" \nflex=\"20\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\"><ms-widget-front class=\"white-bg\"><md-toolbar \nlayout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div>\n<span class=\"icon-keyboard-backspace c-p\" data-ng-click=\"goToOutbox();\"></span></div><div layout=\"row\"><md-icon \nclass=\"icon-refresh c-p\" ng-click=\"getAllWorkitems()\" style=\"margin-right:-10px !important\"></md-icon><ms-search-bar \non-search=\"search(query)\" debounce=\"300\" style=\"margin-right:-25px !important\"></ms-search-bar></div></div>\n</md-toolbar><md-divider></md-divider><div class=\"scrollable\" ms-scroll><div class=\"c-p\" \ndata-ng-repeat=\"workitem in allWorkitems | filter:searchString\" data-ng-click=\"selectWorkitem(workitem);changeTab()\" \ndata-ng-init=\"$first && selectWorkitem(workitem);\" data-ng-class=\"{\'selected\': selectedWorkitem == workitem.docId}\">\n<div class=\"md-padding\"><div class=\"h5\"><b>{{workitem.labelText}}</b></div><span><b>{{workitem.docId}}</b></span><div \nlayout=\"row\" layout-align=\"space-between center \"><span>{{workitem.system}}</span> <span>{{workitem.priority}}</span>\n</div></div><md-divider class=\"no-margin\"></md-divider></div></div></ms-widget-front></ms-widget></div><div \nclass=\"widget-group\" layout=\"column\" flex=\"80\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\"><ms-widget-front\n class=\"white-bg\"><div flex=\"100\" style=\"overflow-y:scroll !important\"><md-content><md-tabs md-dynamic-height \nmd-border-bottom><md-tab label=\"Main\" md-active=\"selectedTab\"><md-content class=\"md-padding scrollable\" ms-scroll \nng-show=\"formHeader\"><div layout=\"row\" layout-align=\"center center\"><div flex=\"70\"><form name=\"headerForm\" \nclass=\"md-inline-form\" novalidate><fieldset ng-disabled=\"workitemInfo.dataChange == \'D\'\" \nstyle=\"border: 1px solid #cccccc\"><div ng-bind-html=\"currentFormHeader\" compile-template></div></fieldset></form></div>\n</div></md-content></md-tab><md-tab label=\"Details\" ng-if=\"(workitemInfo.lineItems | json) ! =\'{}\'\"><md-content \nclass=\"md-padding scrollable\" ms-scroll ng-show=\"formLineitem\"><div layout=\"row\" layout-align=\"center center\"><div \nflex=\"100\"><form name=\"headerForm\" class=\"md-inline-form\" novalidate><fieldset \nng-disabled=\"workitemInfo.dataChange == \'D\'\" style=\"border: 1px solid #cccccc\"><div id=\"inbox-details\" \nng-bind-html=\"currentFormLineitem\" compile-template></div></fieldset></form></div></div></md-content></md-tab><md-tab \nlabel=\"Logs\"><md-content class=\"md-padding scrollable\" ms-scroll ng-show=\"formLineitem\"><div \nclass=\"md-padding scrollable\" ms-scroll><timeline><timeline-event ng-repeat=\"log in workitemInfo.logs track by $index\" \nside=\"\"><timeline-badge style=\"background-color: rgb(3,155,229)\"><md-icon md-font-icon=\"{{log.icon}}\" \nclass=\"s25 icon white-fg\" style=\"color:white !important\"></md-icon></timeline-badge><timeline-panel class=\"{{\'info\'}}\" \nstyle=\"background-color: #f1eded;    border-radius: 20px\"><timeline-heading><div layout=\"row\" layout-align=\"end end\">\n<p><b>Date : {{log.endDate.substr(6,2)}}-{{log.endDate.substr(4,2)}}-{{log.endDate.substr(0,4)}}</b></p></div><div \nlayout=\"row\" layout-align=\"start center\" style=\"color:black\"><img ng-src=\"assets\\images\\avatars/Nora.jpg\" \nclass=\"md-avatar\" style=\"border-radius:50% !important;width:13%; height:auto\"><div class=\"h2\" \nng-if=\"log.activityText == \'Initiate\' \">{{log.actualUser}} initiated</div><div class=\"h2\" \nng-if=\"log.activityText == \'Approve\' \">{{log.actualUser}} Approved</div><div class=\"h2\" \nng-if=\"log.activityText == \'Reject\' \">{{log.actualUser}} Rejected</div><div class=\"h2\" \nng-if=\"log.activityText != \'Initiate\' && log.activityText != \'Approve\' && log.activityText != \'Reject\'  \">\n{{log.actualUser}} {{log.activityText}}</div></div></timeline-heading><div layout=\"row\" layout-align=\"start start\" \nstyle=\"padding-left: 2%\"><p style=\"color:black\">{{log.comments}}</p></div></timeline-panel></timeline-event></timeline>\n</div><div layout=\"row\" layout-align=\"center center\" class=\"md-padding\" ng-if=\"workitemInfo.dataChange == \'M\'\">\n<md-button class=\"md-accent md-raised pull-right\" ng-click=\"updateLineItems();\">Update</md-button></div></md-content>\n</md-tab><md-tab label=\"Attachments\"><div class=\"md-padding scrollable\" ms-scroll><div class=\"md-padding\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"h2\">Attachments</span> <span class=\"h3\">\n{{workitemInfo.attachments.length}}</span></div><div><md-list><md-list-item class=\"md-3-line\" \nng-repeat=\"attachment in workitemInfo.attachments\"><div flex=\"100\" layout=\"row\"><div layout=\"row\" flex=\"70\" \nclass=\"c-p\" ng-click=\"preview($event,attachment,workitemInfo.requestId)\"><div flex=\"10\" layout=\"row\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"{{fileIcon(attachment.fileType)}}\" class=\"s42 icon md-accent\">\n</md-icon></div><div flex=\"60\"><div class=\"md-list-item-text\"><h3><b>{{attachment.fileName}}</b></h3><h3>\nCreated By : {{attachment.creator}}</h3></div></div><div flex=\"30\"><h3>Date : {{attachment.createDate }}</h3></div>\n</div><div><md-icon md-font-icon=\"icon-download\" class=\"s32 c-p icon md-accent\" \nng-click=\"downloadFile(attachment,workitemInfo.requestId )\" style=\"padding-top: 50%\"></md-icon></div></div>\n</md-list-item></md-list></div></div></md-tab></md-tabs></md-content></div></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/profile/about/about.html","<div class=\"widget-group\" flex layout=\"column\" layout-wrap ng-init=\"UserDetails()\"><ms-widget flippable=\"true\">\n<ms-widget-front class=\"white-bg\"><div class=\"md-padding\" layout-align=\"start start\"><div class=\"h3\">\nPersonal Information</div><div layout=\"row\" flex><div class=\"md-padding\" flex=\"100\" style=\"margin-top: 0\"><ms-widget \nflippable=\"true\"><ms-widget-front class=\"white-bg\" flex><div class=\"md-padding\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"details\">Primary Details </span><span class=\"edit c-p\" \nng-click=\"abtCtrl.editprofile($event,currentLogedInUser)\">EDIT</span></div><md-divider></md-divider><div layout=\"row\" \nlayout-align=\"start start\"><div layout=\"column\" class=\"md-padding\" flex=\"40\"><span class=\"subtext\">First Name</span> \n<span>{{currentLogedInUser.firstName}}</span></div><span flex=\"20\"></span><div layout=\"column\" class=\"md-padding\" \nflex=\"40\"><span class=\"subtext\">Middle Name</span> <span>{{}}</span></div></div><div layout=\"row\" \nlayout-align=\"start start\"><div layout=\"column\" class=\"md-padding\" flex=\"40\"><span class=\"subtext\">Last Name</span> \n<span>{{currentLogedInUser.lastName}}</span></div><span flex=\"20\"></span><div layout=\"column\" class=\"md-padding\" \nflex=\"40\"><span class=\"subtext\">Display Name</span> <span>\n{{currentLogedInUser.firstName}} {{currentLogedInUser.lastName}}</span></div></div><div layout=\"row\" \nlayout-align=\"start start\"><div layout=\"column\" class=\"md-padding\" flex=\"40\"><span class=\"subtext\">Authority</span> \n<span ng-repeat=\"authority in currentLogedInUser.authorities \">\n{{authority.replace(\"ROLE_USER\",\"User\").replace(\"ROLE_ADMIN\",\"Admin\")}}</span></div><span flex=\"20\"></span><div \nlayout=\"column\" class=\"md-padding\" flex=\"40\"><span class=\"subtext\">Activate User</span> <span>\n{{currentLogedInUser.activated}}</span></div></div><div layout=\"row\" layout-align=\"start start\"><div layout=\"column\" \nclass=\"md-padding\" flex=\"40\"><span class=\"subtext\">Currency</span> <span>{{currentLogedInUser.currency}}</span></div>\n<span flex=\"20\"></span><div layout=\"column\" class=\"md-padding\" flex=\"40\"><span class=\"subtext\">Decimal Seperator</span>\n <span>{{currentLogedInUser.decimalSeparator}}</span></div></div><div layout=\"row\" layout-align=\"start start\"><div \nlayout=\"column\" class=\"md-padding\" flex=\"40\"><span class=\"subtext\">Language</span> <span>\n{{currentLogedInUser.language}}</span></div><span flex=\"20\"></span><div layout=\"column\" class=\"md-padding\" flex=\"40\">\n<span class=\"subtext\">Date Format</span> <span>{{currentLogedInUser.dateFormat}}</span></div></div><div layout=\"row\" \nlayout-align=\"start start\"><div layout=\"column\" class=\"md-padding\" flex=\"40\"><span class=\"subtext\">TimeZone</span> \n<span>{{currentLogedInUser.timeZone}}</span></div></div></ms-widget-front></ms-widget></div></div></div>\n</ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/profile/substitution/substitution.create.html","<md-dialog flex=\"40\" ng-init=\"getAllUsers();\"><form name=\"userForm\" novalidate \nng-submit=\"userForm.$valid && userCtrl.createUser(user)\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Create Substitution</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex=\"100\">\n<md-input-container class=\"md-block\" flex=\"40\"><label>Substitution To</label><md-select \nng-model=\"substitute.substituteuser\" placeholder=\"Select Substitutor\" ng-required=\"required\"><md-option \nng-value=\"user.login\" ng-repeat=\" user in usersList \">{{user.login}}</md-option></md-select></md-input-container><span \nflex=\"20\"></span><md-switch ng-model=\"substitute.status\" aria-label=\" Activate User\">Status</md-switch></div><div \nlayout=\"row\" flex=\"100\"><md-datepicker ng-model=\"substitute.fromDate\" md-placeholder=\"From Date\"></md-datepicker><span \nflex=\"25\"></span><md-datepicker ng-model=\"substitute.toDate\" md-placeholder=\"To Date\"></md-datepicker></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" \nng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"userForm.$valid && save(substitute)\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/profile/substitution/substitution.html","<div class=\"page-layout simple right-sidenav\" layout=\"row\" ng-init=\"substitutionCtrl.getAllSubstitutes()\"><div flex \nclass=\"scrollable\" ms-scroll><div layout=\"column\"><md-button flow-btn \nclass=\"md-fab grey-700-bg md-mini md-fab-bottom-right add_btn\" ng-click=\"createSubstitutor($event)\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Create substitution</md-tooltip></md-button><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nmd-dynamic-height><ms-widget-front class=\"white-bg\"><div class=\"h3 md-padding\">Manage Substitute Users</div><div \nlayout=\"row\" layout-align=\"center center\"><ms-widget flippable=\"true\" layout=\"column\" flex=\"95\" md-dynamic-height>\n<ms-widget-front class=\"white-bg\"><div flex=\"100\" class=\"md-padding scrollable\" ms-scroll><table \nclass=\"dataTable row-border hover table-border\" datatable=\"ng\" dt-options=\"userCtrl.dtOptions\"><thead><tr \nclass=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Substituted-By\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Substituted-To</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">From Date</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">To Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\" layout=\"row\" layout-align=\"center center\"><span class=\"column-title\">\nActions</span></div></th></tr></thead><tbody><tr ng-repeat=\"substitute in allSubstitutes\"><td>{{substitute.userId}}\n</td><td>{{substitute.substituteuser}}</td><td>{{substitute.fromDate.substr(0,10)}}</td><td>\n{{substitute.toDate.substr(0,10)}}</td><td><i class=\"icon-checkbox-marked-circle green-500-fg\" \nng-show=\"{{substitute.status}}\"></i> <i class=\"icon-cancel red-500-fg\" ng-show=\"{{! substitute.status}}\"></i></td><td \nlayout=\"row\" layout-align=\"center center\" style=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button \nclass=\"md-icon-button test-tooltip\" aria-label=\"Update\" ng-click=\"update($event,substitute)\"><md-tooltip \nmd-direction=\"top\">Update</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-pencil s18\"></i></md-icon></md-button><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Delete\" ng-click=\"delete($event, substitute) \"><md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon>\n<i layout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s18\"></i></md-icon></md-button></td></tr></tbody>\n</table></div></ms-widget-front></ms-widget></div></ms-widget-front></ms-widget></div></div></div></div>");
$templateCache.put("app/main/profile/substitution/substitution.update.html","<md-dialog aria-label=\"update\" flex=\"40\" ng-init=\"getAllUsers();\"><form name=\"userForm\" novalidate \nng-submit=\"userForm.$valid && userCtrl.createUser(user)\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Update Substitutor</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex=\"100\">\n<md-input-container class=\"md-block\" flex=\"40\"><label>Select Substitutor</label><md-select \nng-model=\"substitutionItem.substituteuser\" placeholder=\"Select Substitutor\" ng-required=\"required\"><md-option \nng-value=\"user.login\" ng-repeat=\" user in usersList \">{{user.login}}</md-option></md-select></md-input-container><span \nflex=\"20\"></span><md-switch ng-model=\"substitutionItem.status\" aria-label=\" Activate User\">Status</md-switch></div><div\n layout=\"row\" flex=\"100\"><md-datepicker ng-model=\"substitutionItem.fromDate\" md-placeholder=\"From Date\">\n</md-datepicker><span flex=\"25\"></span><md-datepicker ng-model=\"substitutionItem.toDate\" md-placeholder=\"To Date\">\n</md-datepicker></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button \ntype=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"userForm.$valid && update($event, substitutionItem)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/reset/view/reset.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><form name=\"passwordForm\" novalidate \nlayout=\"column\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Reset Password</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" layout-align=\"center center\"><md-input-container\n class=\"md-block\"><md-icon md-font-icon=\"icon-key-variant\" style=\"color: rgb(5, 167, 253) !important\"></md-icon><input \ntype=\"password\" name=\"password\" ng-model=\"password\" placeholder=\"Enter Password*\" required><div \nng-messages=\"passwordForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>Password field is required\n</span></div></div></md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-key-variant\" \nstyle=\"color: rgb(5, 167, 253) !important\"></md-icon><input type=\"password\" name=\"passwordConfirm\" \nng-model=\"passwordConfirm\" placeholder=\"Re-enter Password*\" required> <span \nstyle=\"color: red;font-family: \'Roboto\';font-size: 12px\" ng-show=\"password !== passwordConfirm\">Passwords do not match\n</span><div ng-messages=\"passwordForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nRe-enter Password field is required</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions\n layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"passwordForm.$valid && resetPasswordfinish($scope.finishPassword)\">Save</md-button>\n</md-dialog-actions></form></div></div></div>");
$templateCache.put("app/main/sites/site/create.site.dialog.html","<md-dialog aria-label=\"Add a new site\" flex=\"50\"><form name=\"siteForm\" novalidate \nng-submit=\"siteCtrl.createSite(site)\" layout=\"column\" flex=\"100\"><md-toolbar class=\"md-accent\" style=\"height: 50px\" \nflex=\"80\"><div class=\"md-toolbar-tools\"><h2>Create Site</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><div\n layout=\"row\"><div flex=\"45\"><md-input-container class=\"md-block\"><input type=\"text\" name=\"name\" ng-model=\"site.name\" \nplaceholder=\"Site name\" required><div ng-messages=\"siteForm.name.$error\" role=\"alert\"><div ng-message=\"required\">\nSite name is required</div></div></md-input-container></div><span flex=\"10\"></span><div flex=\"45\"><md-input-container \nclass=\"md-block\"><input type=\"text\" name=\"url\" ng-model=\"site.url\" placeholder=\"URL\" required><div \nng-messages=\"siteForm.url.$error\" role=\"alert\"><div ng-message=\"required\"><span>Site URL is required</span></div></div>\n</md-input-container></div></div><div layout=\"row\"><div flex=\"45\"><md-input-container class=\"md-block\"><input \ntype=\"text\" name=\"title\" ng-model=\"site.title\" placeholder=\"SiteTitle\"></md-input-container></div><span flex=\"10\">\n</span><div flex=\"45\"><md-input-container class=\"md-block\"><input type=\"text\" name=\"description\" \nng-model=\"site.description\" placeholder=\"Description\"></md-input-container></div></div><div layout=\"row\"><div \nflex=\"45\"><md-button ng-click=\"openIconList()\" class=\"md-accent md-raised\">select site logo</md-button></div>\n<md-divider direction=\"vertical\"></md-divider><div flex=\"45\" align=\"center\"><md-icon md-font-icon=\"icon-eye\" \nng-style=\"{color: \'black\', \'font-size\': \'36px\'}\"></md-icon><md-radio-group ng-model=\"site.visibility\" flex=\"\" \nlayout=\"row\" class=\"md-padding\"><md-radio-button value=\"Public\">Public</md-radio-button><md-radio-button \nvalue=\"Private\">Private</md-radio-button></md-radio-group></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"center center\"><md-button ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"siteForm.$valid && save(site)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sites/site/site.html","<style>\n.site{\r\n    position: absolute;\r\n    top: -14px;\r\n    left: 124px;\r\n    }\r\n    .buttons{  \r\n   position: absolute;\r\n    top: 5px;\r\n    right: 0px;\r\n }\n</style><div class=\"page-layout simple tabbed mh-0\" layout=\"column\"><div class=\"content parent-tabs\"><md-tabs \nclass=\"mh-0\"><md-tab label=\"Home\" md-active=\"true\"></md-tab></md-tabs></div><div class=\"buttons\"><md-button \nng-click=\"loadHome()\" style=\"min-width: 20px;border-radius:55px !important\"><md-icon md-font-icon=\"icon-home\" \nng-style=\"{\'font-size\': \'20px\'}\" style=\"color: #4cc3d9 !important\"></md-icon></md-button><md-button \nng-click=\"loadDoclibrary()\" style=\"min-width: 20px;border-radius:55px !important\"><md-icon md-font-icon=\"icon-folder\" \nng-style=\"{\'font-size\': \'20px\'}\" style=\"color: #4cc3d9 !important\"></md-icon></md-button><md-button \nng-click=\"loadMembers()\" style=\"min-width: 20px;border-radius:55px !important\"><md-icon \nmd-font-icon=\"icon-account-multiple\" ng-style=\"{\'font-size\': \'20px\'}\" style=\"color: #4cc3d9 !important\"></md-icon>\n</md-button><md-button aria-label=\"Settings\" ng-click=\"loadSiteSettings()\" \nstyle=\"min-width: 20px;border-radius:55px !important\"><md-icon md-font-icon=\"icon-cog\" \nng-style=\"{\'font-size\': \'20px\'}\" style=\"color: #4cc3d9 !important\"></md-icon></md-button></div></div><div id=\"sites\" \nclass=\"page-layout carded fullwidth scrollable\" layout=\"column\" flex ms-scroll md-dynamic-height><div \nclass=\"widget-group\" layout=\"column\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\">\n<ms-widget-front class=\"white-bg\"><div layout=\"column\" layout-align=\"start center\" layout-wrap class=\"scrollable\" \nms-scroll><div class=\"p-16\" layout=\"column\" flex=\"100\"><div ui-view=\"sitehome\" ng-show=\"loadPage==\'Home\'\"></div><div \nui-view=\"dashboard\" ng-show=\"loadPage==\'home\'\"></div><div ui-view=\"doclibrary\" ng-show=\"loadPage==\'Library\'\"></div><div\n ui-view=\"members\" ng-show=\"loadPage==\'members\'\"></div><div ui-view=\"todolist\" ng-show=\"loadPage==\'notes\'\"></div><div \nui-view=\"discussionforum\" ng-show=\"loadPage==\'discussionforum\'\"></div><div ui-view=\"sitesettings\" \nng-show=\"loadPage==\'sitesettings\'\"></div></div></div></ms-widget-front></ms-widget></div><md-button flow-btn \nclass=\"md-fab md-accent md-fab-bottom-right\" aria-label=\"Add Note\" ng-click=\"siteCtrl.showConfirm($event)\" \nng-show=\"loadPage==\'todolist\'\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Add Note\n</md-tooltip></md-button></div>");
$templateCache.put("app/main/smartstore-admin/Repositories/create.repository.html","<md-dialog aria-label=\"Add a new Repository\" flex=\"45\"><form name=\"repForm\" novalidate \nng-submit=\"repForm.$valid && save(repository)\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Create Repository</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll>\n<md-input-container class=\"md-block\"><input type=\"text\" name=\"id\" ng-model=\"repository.repositoryId\" \nplaceholder=\"Repository Id\" required><div ng-messages=\"repForm.id.$error\" role=\"alert\"><div ng-message=\"required\">\nRepository Id is required</div></div></md-input-container><md-input-container class=\"md-block\"><input \ntype=\"description\" name=\"name\" ng-model=\"repository.name\" placeholder=\"Repository Name\" required><div \nng-messages=\"repForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Repository Name is required</span>\n</div></div></md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"description\" \nng-model=\"repository.description\" placeholder=\"Repository Description\" required><div \nng-messages=\"repForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>Description is required</span>\n</div></div></md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"pVersion\" \nng-model=\"repository.pVersion\" placeholder=\"P Version\" required><div ng-messages=\"repForm.pVersion.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Version is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><md-select name=\"storageType\" ng-model=\"repository.storageType\" \nplaceholder=\"Storage Type\" required><md-option ng-value=\"storageType\" ng-repeat=\"storageType in storageTypes\">\n{{storageType}}</md-option></md-select><div ng-messages=\"repForm.storageType.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Type is required</span></div></div></md-input-container><div layout=\"column\" \nng-if=\"repository.storageType==\'GoogleDrive\'\"><div><b style=\"color:#0072ff\">Google Drive</b></div><div flex=\"100\">\n<md-input-container class=\"md-block\"><input type=\"text\" name=\"clientID\" ng-model=\"repository.clientId\" \nplaceholder=\"Client Id\" required><div ng-messages=\"repForm.clientID.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Client Id is required</span></div></div></md-input-container><md-input-container class=\"md-block\"><input \ntype=\"text\" name=\"clientSecret\" ng-model=\"repository.clientSecret\" placeholder=\"Client Secret\" required><div \nng-messages=\"repForm.clientSecret.$error\" role=\"alert\"><div ng-message=\"required\"><span>Client Secret is required\n</span></div></div></md-input-container></div></div><div layout=\"column\" ng-if=\"repository.storageType==\'OneDrive\'\">\n<div><b style=\"color:#0072ff\">One Drive</b></div><div flex=\"100\"><md-input-container class=\"md-block\"><input \ntype=\"text\" name=\"clientID\" ng-model=\"repository.clientId\" placeholder=\"Client Id\" required><div \nng-messages=\"repForm.clientID.$error\" role=\"alert\"><div ng-message=\"required\"><span>Client Id is required</span></div>\n</div></md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"clientSecret\" \nng-model=\"repository.clientSecret\" placeholder=\"Client Secret\" required><div ng-messages=\"repForm.clientSecret.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Client Secret is required</span></div></div></md-input-container></div>\n</div><div layout=\"column\" ng-if=\"repository.storageType==\'FileSystem\'\"><div><b style=\"color:#0072ff\">File System</b>\n</div><div flex=\"100\"><md-input-container class=\"md-block\"><input type=\"text\" name=\"rootPath\" \nng-model=\"repository.rootPath\" placeholder=\"Root Path\" required><div ng-messages=\"repForm.rootPath.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Root Path is required</span></div></div></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button>\n<md-button type=\"submit\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/smartstore-admin/Repositories/display.repository.html","<md-dialog flex=\"45\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Repository Details</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><md-input-container class=\"md-block\">\n<input type=\"text\" name=\"id\" ng-model=\"currentrepository.repositoryId\" placeholder=\"Repository Id\" readonly=\"true\">\n</md-input-container><md-input-container class=\"md-block\"><input type=\"description\" name=\"name\" \nng-model=\"currentrepository.name\" placeholder=\"Repository Name\" readonly=\"true\"></md-input-container>\n<md-input-container class=\"md-block\"><input type=\"text\" name=\"description\" ng-model=\"currentrepository.description\" \nplaceholder=\"Repository Description\" readonly=\"true\"></md-input-container><md-input-container class=\"md-block\"><input \ntype=\"text\" name=\"pVersion\" ng-model=\"currentrepository.pVersion\" placeholder=\"P Version\" readonly=\"true\">\n</md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"clientID\" \nng-model=\"currentrepository.storageType\" placeholder=\"storageType\" readonly=\"true\"></md-input-container><div \nlayout=\"column\" ng-if=\"currentrepository.storageType==\'GoogleDrive\'\"><div><b style=\"color:#0072ff\">Google Drive</b>\n</div><div flex=\"100\"><md-input-container class=\"md-block\"><input type=\"text\" name=\"clientID\" \nng-model=\"currentrepository.clientId\" placeholder=\"Client Id\" readonly=\"true\"></md-input-container><md-input-container \nclass=\"md-block\"><input type=\"text\" name=\"clientSecret\" ng-model=\"currentrepository.clientSecret\" \nplaceholder=\"Client Secret\" readonly=\"true\"></md-input-container></div></div><div layout=\"column\" \nng-if=\"currentrepository.storageType==\'OneDrive\'\"><div><b style=\"color:#0072ff\">One Drive</b></div><div flex=\"100\">\n<md-input-container class=\"md-block\"><input type=\"text\" name=\"clientID\" ng-model=\"currentrepository.clientId\" \nplaceholder=\"Client Id\" readonly=\"true\"></md-input-container><md-input-container class=\"md-block\"><input type=\"text\" \nname=\"clientSecret\" ng-model=\"currentrepository.clientSecret\" placeholder=\"Client Secret\" readonly=\"true\">\n</md-input-container></div></div><div layout=\"column\" ng-if=\"currentrepository.storageType==\'FileSystem\'\"><div><b \nstyle=\"color:#0072ff\">File System</b></div><div flex=\"100\"><md-input-container class=\"md-block\"><input type=\"text\" \nname=\"rootPath\" ng-model=\"currentrepository.rootPath\" placeholder=\"Root Path\" readonly=\"true\"></md-input-container>\n</div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Ok\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/smartstore-admin/Repositories/preview.repository.html","<style>\n.table-border {\r\n    border: 1px solid #d3d3d3 !important;\r\n}\r\n.table-header {\r\n    background-color: #dee7f4 !important;\r\n    text-transform: uppercase;\r\n    font-size: 11px!important;\r\n}\n</style><div class=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div \nclass=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"md-padding white-bg\"><div class=\"previous-state c-p blue-fg\" data-ng-click=\"repCtrl.goToMain()\"><span><span \nclass=\"icon-arrow-left-bold-circle-outline\"></span> Back </span></div><table \nclass=\"dataTable row-border hover table-border\" datatable=\"ng\" dt-options=\"repCtrl.dtOptions\"><thead><tr \nclass=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Repository Id\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Repository Name\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Description</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">pVersion</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Storage Type</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"repository in repositoriesList \"><td>{{repository.repositoryId}}</td><td>{{repository.name}}</td>\n<td>{{repository.description}}</td><td>{{repository.pVersion}}</td><td>{{repository.storageType}}</td><td layout=\"row\" \nlayout-align=\"center center\" style=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button \nclass=\"md-icon-button test-tooltip\" aria-label=\"Display\" ng-click=\"DisplayRepDialog($event,repository)\"><md-tooltip \nmd-direction=\"top\">Display</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-login s18\"></i></md-icon></md-button><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Update\" ng-click=\"updateRepDialog($event,repository)\"><md-tooltip md-direction=\"top\">Update</md-tooltip>\n<md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s18\"></i></md-icon></md-button><md-button\n class=\"md-icon-button test-tooltip\" aria-label=\"Delete\" ng-click=\"deleteRepository($event,repository)\"><md-tooltip \nmd-direction=\"top\">Delete</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-delete s18\"></i></md-icon></md-button></td></tr></tbody></table></div></ms-widget></div><md-button \nflow-btn class=\"md-fab grey-700-bg md-mini md-fab-bottom-right add_btn\" ng-click=\"createRepDialog(ev)\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Create Repository</md-tooltip></md-button></div>");
$templateCache.put("app/main/smartstore-admin/Repositories/update.repository.html","<md-dialog flex=\"45\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Update Repository</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><md-input-container class=\"md-block\">\n<input type=\"text\" name=\"id\" ng-model=\"currentrepository.repositoryId\" placeholder=\"Repository Id\" required><div \nng-messages=\"updateRepForm.id.$error\" role=\"alert\"><div ng-message=\"required\">Repository Id is required</div></div>\n</md-input-container><md-input-container class=\"md-block\"><input type=\"description\" name=\"name\" \nng-model=\"currentrepository.name\" placeholder=\"Repository Name\" required><div ng-messages=\"updateRepForm.name.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Repository Name is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><input type=\"text\" name=\"description\" ng-model=\"currentrepository.description\" \nplaceholder=\"Repository Description\" required><div ng-messages=\"updateRepForm.description.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Description is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><input type=\"text\" name=\"pVersion\" ng-model=\"currentrepository.pVersion\" placeholder=\"P Version\" \nrequired><div ng-messages=\"updateRepForm.pVersion.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nVersion is required</span></div></div></md-input-container><md-input-container class=\"md-block\"><md-select \nname=\"storageType\" ng-model=\"currentrepository.storageType\" placeholder=\"Storage Type\" required><md-option \nng-value=\"storageType\" ng-repeat=\"storageType in storageTypes\">{{storageType}}</md-option></md-select><div \nng-messages=\"updateRepForm.storageType.$error\" role=\"alert\"><div ng-message=\"required\"><span>Type is required</span>\n</div></div></md-input-container><div layout=\"column\" ng-if=\"currentrepository.storageType==\'GoogleDrive\'\"><div><b \nstyle=\"color:#0072ff\">Google Drive</b></div><div flex=\"100\"><md-input-container class=\"md-block\"><input type=\"text\" \nname=\"clientID\" ng-model=\"currentrepository.clientId\" placeholder=\"Client Id\" required><div \nng-messages=\"updateRepForm.clientID.$error\" role=\"alert\"><div ng-message=\"required\"><span>Client Id is required</span>\n</div></div></md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"clientSecret\" \nng-model=\"currentrepository.clientSecret\" placeholder=\"Client Secret\" required><div \nng-messages=\"updateRepForm.clientSecret.$error\" role=\"alert\"><div ng-message=\"required\"><span>Client Secret is required\n</span></div></div></md-input-container></div></div><div layout=\"column\" \nng-if=\"currentrepository.storageType==\'OneDrive\'\"><div><b style=\"color:#0072ff\">One Drive</b></div><div flex=\"100\">\n<md-input-container class=\"md-block\"><input type=\"text\" name=\"clientID\" ng-model=\"currentrepository.clientId\" \nplaceholder=\"Client Id\" required><div ng-messages=\"updateRepForm.clientID.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Client Id is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><input type=\"text\" name=\"clientSecret\" ng-model=\"currentrepository.clientSecret\" \nplaceholder=\"Client Secret\" required><div ng-messages=\"updateRepForm.clientSecret.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Client Secret is required</span></div></div></md-input-container></div></div><div \nlayout=\"column\" ng-if=\"currentrepository.storageType==\'FileSystem\'\"><div><b style=\"color:#0072ff\">File System</b></div>\n<div flex=\"100\"><md-input-container class=\"md-block\"><input type=\"text\" name=\"rootPath\" \nng-model=\"currentrepository.rootPath\" placeholder=\"Root Path\" required><div \nng-messages=\"updateRepForm.rootPath.$error\" role=\"alert\"><div ng-message=\"required\"><span>Root Path is required</span>\n</div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span>\n<md-button ng-click=\"cancel()\">Cancel</md-button><md-button ng-click=\"updateRepository(currentrepository)\">Update\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/smartstore-admin/companies/companies.html","<style>\n.table-border {\r\n    border: 1px solid #d3d3d3 !important;\r\n}\r\n.table-header {\r\n    background-color: #dee7f4 !important;\r\n    text-transform: uppercase;\r\n    font-size: 11px!important;\r\n}\n</style><div class=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div \nclass=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"md-padding white-bg\"><div class=\"previous-state c-p\" data-ng-click=\"companyCtrl.goToMain()\"><span><span \nclass=\"icon-arrow-left-bold-circle-outline\"></span> Back </span></div><table \nclass=\"dataTable row-border hover table-border\" datatable=\"ng\" dt-options=\"companyCtrl.dtOptions\"><thead><tr \nclass=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Company Id</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Company Name</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Address</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\" layout=\"row\" layout-align=\"center center\"><span class=\"column-title\">\nActions</span></div></th></tr></thead><tbody><tr ng-repeat=\"company in SmartstoreCompanies \"><td>{{company.companyId}}\n</td><td>{{company.name}}</td><td>{{company.address}}</td><td layout=\"row\" layout-align=\"center center\" \nstyle=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Display\" ng-click=\"DisplayCompanyDialog($event,company)\"><md-tooltip md-direction=\"top\">Display\n</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-login s18\"></i></md-icon>\n</md-button><md-button class=\"md-icon-button test-tooltip\" aria-label=\"Update\" \nng-click=\"updateCompanyDialog($event,company)\"><md-tooltip md-direction=\"top\">Update</md-tooltip><md-icon><i \nlayout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s18\"></i></md-icon></md-button><md-button \nclass=\"md-icon-button test-tooltip\" aria-label=\"Delete\" ng-click=\"CompanyDelete($event,company)\"><md-tooltip \nmd-direction=\"top\">Delete</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-delete s18\"></i></md-icon></md-button></td></tr></tbody></table></div></ms-widget></div><md-button \nflow-btn class=\"md-fab grey-700-bg md-mini md-fab-bottom-right add_btn\" ng-click=\"createCompanyDialog(ev)\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Create Company</md-tooltip></md-button></div>");
$templateCache.put("app/main/smartstore-admin/companies/create.companies.html","<md-dialog flex=\"45\"><form name=\"doctype\" novalidate><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nCreate Company</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><md-input-container class=\"md-block\">\n<label>Company Id</label><input type=\"text\" name=\"name\" ng-model=\"company.companyId\" required><div \nng-messages=\"doctype.name.$error\" role=\"alert\"><div ng-message=\"required\">Company Id is required</div></div>\n</md-input-container><md-input-container class=\"md-block\"><label>Company Name</label><input type=\"description\" \nname=\"description\" ng-model=\"company.name\" required><div ng-messages=\"doctype.description.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Company Name is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><label>Address</label><input type=\"text\" name=\"buttonText\" \nng-model=\"company.address\" required><div ng-messages=\"doctype.prefix.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Address is required</span></div></div></md-input-container></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button \nng-click=\"doctype.$valid && save(company)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/smartstore-admin/companies/display.company.html","<md-dialog flex=\"45\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Company Details</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><md-input-container class=\"md-block\">\n<input type=\"text\" name=\"name\" ng-model=\"currentCompany.companyId\" placeholder=\"Company Id\" readonly=\"true\">\n</md-input-container><md-input-container class=\"md-block\"><input type=\"description\" name=\"description\" \nng-model=\"currentCompany.name\" placeholder=\"Company Name\" readonly=\"true\"></md-input-container><md-input-container \nclass=\"md-block\"><input type=\"text\" name=\"buttonText\" ng-model=\"currentCompany.address\" placeholder=\"Address\" \nreadonly=\"true\"></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nng-click=\"cancel()\">Ok</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/smartstore-admin/companies/update.companies.html","<md-dialog flex=\"45\"><form name=\"companyForm\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nUpdate Company</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><md-input-container class=\"md-block\">\n<input type=\"text\" name=\"name\" ng-model=\"currentCompany.companyId\" placeholder=\"Company Id\" required><div \nng-messages=\"companyForm.name.$error\" role=\"alert\"><div ng-message=\"required\">Company Id is required</div></div>\n</md-input-container><md-input-container class=\"md-block\"><input type=\"description\" name=\"description\" \nng-model=\"currentCompany.name\" placeholder=\"Company Name\" required><div ng-messages=\"companyForm.description.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Company Name is required</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"buttonText\" \nng-model=\"currentCompany.address\" placeholder=\"Address\" required><div ng-messages=\"companyForm.prefix.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Address is required</span></div></div>\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nng-click=\"cancel()\">Cancel</md-button><md-button ng-click=\"update(currentCompany)\">Save</md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/smartstore-admin/mimetype/create.mimetype.html","<md-dialog flex=\"45\"><form name=\"mimeType\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nCreate MimeType</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><md-input-container class=\"md-block\">\n<label>MimeType</label><input type=\"text\" name=\"name\" ng-model=\"MimeType.mimeType\" required><div \nng-messages=\"mimeType.name.$error\" role=\"alert\"><div ng-message=\"required\">MimeType is required</div></div>\n</md-input-container><md-input-container class=\"md-block\"><label>File Extension</label><input type=\"description\" \nname=\"description\" ng-model=\"MimeType.fileExtension\" required><div ng-messages=\"mimeType.description.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>File Extension is required</span></div></div>\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nng-click=\"cancel()\">Cancel</md-button><md-button ng-click=\"save(MimeType)\">Save</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/smartstore-admin/mimetype/display.mimetype.html","<md-dialog flex=\"45\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>MimeType Details</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><md-input-container class=\"md-block\">\n<label>MimeType</label><input type=\"text\" name=\"name\" ng-model=\"currentMimetype.mimeType\" readonly=\"true\">\n</md-input-container><md-input-container class=\"md-block\"><label>File Extension</label><input type=\"description\" \nname=\"description\" ng-model=\"currentMimetype.fileExtension\" readonly=\"true\"></md-input-container></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Ok</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/smartstore-admin/mimetype/mimetype.html","<style>\n.table-border {\r\n    border: 1px solid #d3d3d3 !important;\r\n}\r\n.table-header {\r\n    background-color: #dee7f4 !important;\r\n    text-transform: uppercase;\r\n    font-size: 11px!important;\r\n}\n</style><div class=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div \nclass=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"md-padding white-bg\"><div class=\"previous-state c-p\" data-ng-click=\"mimetypeCtrl.goToMain()\"><span><span \nclass=\"icon-arrow-left-bold-circle-outline\"></span> Back </span></div><table \nclass=\"dataTable row-border hover table-border\" datatable=\"ng\" dt-options=\"mimetypeCtrl.dtOptions\"><thead><tr \nclass=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Mime Type</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">File Extension</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\" layout=\"row\" layout-align=\"center center\"><span \nclass=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr ng-repeat=\"mimetype in SmartstoreMimeTypes \"><td>\n{{mimetype.mimeType}}</td><td>{{mimetype.fileExtension}}</td><td layout=\"row\" layout-align=\"center center\" \nstyle=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Display\" ng-click=\"DisplayMimeTypeDialog($event,mimetype)\"><md-tooltip md-direction=\"top\">Display\n</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-login s18\"></i></md-icon>\n</md-button><md-button class=\"md-icon-button test-tooltip\" aria-label=\"Update\" \nng-click=\"updateMimeTypeDialog($event,mimetype)\"><md-tooltip md-direction=\"top\">Update</md-tooltip><md-icon><i \nlayout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s18\"></i></md-icon></md-button><md-button \nclass=\"md-icon-button test-tooltip\" aria-label=\"Delete\" ng-click=\"MimeTypeDelete($event,mimetype)\"><md-tooltip \nmd-direction=\"top\">Delete</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-delete s18\"></i></md-icon></md-button></td></tr></tbody></table></div></ms-widget></div><md-button \nflow-btn class=\"md-fab grey-700-bg md-mini md-fab-bottom-right add_btn\" ng-click=\"createMimeTypeDialog(ev)\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Create MimeType</md-tooltip></md-button></div>");
$templateCache.put("app/main/smartstore-admin/mimetype/update.mimetype.html","<md-dialog flex=\"45\"><form name=\"mimeType\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nUpdate MimeType</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><md-input-container class=\"md-block\">\n<label>MimeType</label><input type=\"text\" name=\"name\" ng-model=\"currentMimetype.mimeType\" required><div \nng-messages=\"doctype.name.$error\" role=\"alert\"><div ng-message=\"required\">MimeType is required</div></div>\n</md-input-container><md-input-container class=\"md-block\"><label>File Extension</label><input type=\"description\" \nname=\"description\" ng-model=\"currentMimetype.fileExtension\" required><div ng-messages=\"doctype.description.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>File Extension is required</span></div></div>\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nng-click=\"cancel()\">Cancel</md-button><md-button ng-click=\"update(currentMimetype)\">Save</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/smartstore-admin/systems/create.system.html","<md-dialog flex=\"45\"><form name=\"SystemForm\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nCreate System</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><md-input-container class=\"md-block\">\n<label>System Id</label><input type=\"text\" name=\"id\" ng-model=\"system.systemId\" required><div \nng-messages=\"SystemForm.id.$error\" role=\"alert\"><div ng-message=\"required\">System Id is required</div></div>\n</md-input-container><md-input-container class=\"md-block\"><label>System Name</label><input type=\"description\" \nname=\"name\" ng-model=\"system.systemName\" required><div ng-messages=\"SystemForm.name.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>System Name is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><label>System Description</label><input type=\"description\" name=\"description\" \nng-model=\"system.description\"><div ng-messages=\"SystemForm.description.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>System Description is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><label>System Type</label><md-select name=\"type\" ng-model=\"system.systemType\" required><md-option \nng-value=\"type\" ng-repeat=\"type in types\">{{type}}</md-option></md-select><div ng-messages=\"SystemForm.type.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>System Type is required</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><label>Auth Id</label><input type=\"text\" name=\"authId\" \nng-model=\"system.authId\" required><div ng-messages=\"SystemForm.authId.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Auth Id is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><label>Access Mode</label><input type=\"text\" name=\"Accessmode\" ng-model=\"system.accessMode\" required>\n<div ng-messages=\"SystemForm.Accessmode.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nAccess Mode is required</span></div></div></md-input-container><div layout-gt-xs=\"row\" layout-align=\"center center\">\n<span flex=\"5\"></span><label class=\"pt-10\" style=\"margin-top:2% !important\">Expiration</label><md-datepicker \nng-model=\"system.expiration\" style=\"margin-top: 2% !important\"></md-datepicker></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button \nng-click=\"save(system)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/smartstore-admin/systems/display.system.html","<md-dialog flex=\"45\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Update System</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><md-input-container class=\"md-block\">\n<label>System Id</label><input type=\"text\" name=\"id\" ng-model=\"currentSystem.systemId\" readonly=\"true\">\n</md-input-container><md-input-container class=\"md-block\"><label>System Name</label><input type=\"description\" \nname=\"name\" ng-model=\"currentSystem.systemName\" readonly=\"true\"></md-input-container><md-input-container \nclass=\"md-block\"><label>System Description</label><input type=\"description\" name=\"description\" \nng-model=\"currentSystem.description\" readonly=\"true\"></md-input-container><md-input-container class=\"md-block\"><label>\nSystem Type</label><input type=\"text\" name=\"systemtype\" ng-model=\"currentSystem.systemType\" readonly=\"true\">\n</md-input-container><md-input-container class=\"md-block\"><label>Auth Id</label><input type=\"text\" name=\"authId\" \nng-model=\"currentSystem.authId\" readonly=\"true\"></md-input-container><md-input-container class=\"md-block\"><label>\nAccess Mode</label><input type=\"text\" name=\"Accessmode\" ng-model=\"currentSystem.accessMode\" readonly=\"true\">\n</md-input-container><md-input-container class=\"md-block\"><label>Repository</label><input type=\"text\" \nname=\"repository\" ng-model=\"currentSystem.repository\" readonly=\"true\"></md-input-container><div layout-gt-xs=\"row\" \nlayout-align=\"center center\"><span flex=\"5\"></span><label class=\"pt-10\" style=\"margin-top:2% !important\">Expiration\n</label><md-datepicker ng-model=\"currentSystem.expiration\" style=\"margin-top: 2% !important\"></md-datepicker></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Ok</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/smartstore-admin/systems/systems.html","<style>\n.table-border {\r\n    border: 1px solid #d3d3d3 !important;\r\n}\r\n.table-header {\r\n    background-color: #dee7f4 !important;\r\n    text-transform: uppercase;\r\n    font-size: 11px!important;\r\n}\n</style><div class=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll \nng-hide=\"showRepos\"><div class=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" \nclass=\"no-padding\"><div class=\"md-padding white-bg\"><div class=\"previous-state c-p blue-fg\" \ndata-ng-click=\"systemCtrl.goToMain()\"><span><span class=\"icon-arrow-left-bold-circle-outline\"></span> Back </span>\n</div><ms-widget flippable=\"true\"><ms-widget-front class=\"white-bg md-padding\"><div layout=\"row\" layout-wrap><ms-widget\n flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"33\" flex-gt-md=\"20\" ng-repeat=\"system in SmartstoreSystems\">\n<ms-widget-front class=\"h-170 p-16 light-green-500-bg white-fg\" ng-click=\"selectSystem(system)\"><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"end start\" flex><div class=\"md-title pb-16\">{{system.systemName}}</div><span class=\"h4\">\n</span></div><div class=\"background-image-center\"><md-icon md-font-icon=\"icon-minus-network\" class=\"s128 faint-text\">\n</md-icon></div></ms-widget-front><div layout=\"row\" layout-align=\"space-between center\"><md-button \nclass=\"md-icon-button test-tooltip\" aria-label=\"Update\" ng-click=\"DisplaySystemDialog($event,system)\"><md-tooltip \nmd-direction=\"top\">Display</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-login s18\"></i></md-icon></md-button><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Update\" ng-click=\"updateSystemDialog($event,system)\"><md-tooltip md-direction=\"top\">Edit</md-tooltip>\n<md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s18\"></i></md-icon></md-button><md-button\n class=\"md-icon-button test-tooltip\" aria-label=\"Delete\" ng-click=\"SystemDelete($event,system)\"><md-tooltip \nmd-direction=\"top\">Delete</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-delete s18\"></i></md-icon></md-button><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Update\" ng-click=\"ValidateDialog($event,system)\"><md-tooltip md-direction=\"top\">Validate</md-tooltip>\n<md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon-checkbox-marked-outline s18\"></i></md-icon>\n</md-button></div></ms-widget></div></ms-widget-front></ms-widget></div></ms-widget></div><md-button flow-btn \nclass=\"md-fab grey-700-bg md-mini md-fab-bottom-right add_btn\" ng-click=\"createSystemDialog(ev)\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Create System</md-tooltip></md-button></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll ng-if=\"showRepos\"><div \nclass=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"md-padding white-bg\"><div class=\"previous-state c-p blue-fg\" data-ng-click=\"gotoSystems()\"><span><span \nclass=\"icon-arrow-left-bold-circle-outline\"></span> Back </span></div><table \nclass=\"dataTable row-border hover table-border\" datatable=\"ng\" dt-options=\"repCtrl.dtOptions\"><thead><tr \nclass=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Repository Id\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Repository Name\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">System Id</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">pVersion</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Storage Type</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"repository in repositoriesList \"><td>{{repository.repositoryId}}</td><td>{{repository.name}}</td>\n<td>{{repository.systemId}}</td><td>{{repository.pVersion}}</td><td>{{repository.storageType}}</td><td layout=\"row\" \nlayout-align=\"center center\" style=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button \nclass=\"md-icon-button test-tooltip\" aria-label=\"Display\" ng-click=\"DisplayRepDialog($event,repository)\"><md-tooltip \nmd-direction=\"top\">Display</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-login s18\"></i></md-icon></md-button><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Update\" ng-click=\"updateRepDialog($event,repository)\"><md-tooltip md-direction=\"top\">Update</md-tooltip>\n<md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s18\"></i></md-icon></md-button><md-button\n class=\"md-icon-button test-tooltip\" aria-label=\"Delete\" ng-click=\"deleteRepository($event,repository)\"><md-tooltip \nmd-direction=\"top\">Delete</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-delete s18\"></i></md-icon></md-button></td></tr></tbody></table></div></ms-widget></div><md-button \nflow-btn class=\"md-fab grey-700-bg md-mini md-fab-bottom-right add_btn\" ng-click=\"createRepDialog(ev)\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Create Repository</md-tooltip></md-button></div>");
$templateCache.put("app/main/smartstore-admin/systems/update.system.html","<md-dialog flex=\"45\"><form name=\"SystemForm\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nUpdate System</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><md-input-container class=\"md-block\">\n<label>System Id</label><input type=\"text\" name=\"id\" ng-model=\"currentSystem.systemId\" required><div \nng-messages=\"SystemForm.id.$error\" role=\"alert\"><div ng-message=\"required\">System Id is required</div></div>\n</md-input-container><md-input-container class=\"md-block\"><label>System Name</label><input type=\"description\" \nname=\"name\" ng-model=\"currentSystem.systemName\" required><div ng-messages=\"SystemForm.name.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>System Name is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><label>System Description</label><input type=\"description\" name=\"description\" \nng-model=\"currentSystem.description\"><div ng-messages=\"SystemForm.description.$error\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"required\"><span>System Description is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><label>System Type</label><md-select name=\"type\" \nng-model=\"currentSystem.systemType\" required><md-option ng-value=\"type\" ng-repeat=\"type in types\">{{type}}</md-option>\n</md-select><div ng-messages=\"SystemForm.type.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\n<span>System Type is required</span></div></div></md-input-container><md-input-container class=\"md-block\"><label>\nAuth Id</label><input type=\"text\" name=\"authId\" ng-model=\"currentSystem.authId\" required><div \nng-messages=\"SystemForm.authId.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nAuth Id is required</span></div></div></md-input-container><md-input-container class=\"md-block\"><label>Access Mode\n</label><input type=\"text\" name=\"Accessmode\" ng-model=\"currentSystem.accessMode\" required><div \nng-messages=\"SystemForm.Accessmode.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nAccess Mode is required</span></div></div></md-input-container><md-input-container class=\"md-block\"><label>Repository\n</label><md-select name=\"Repository\" ng-model=\"currentSystem.repository\" multiple=\"multiple\" required><md-option \nng-value=\"Repository.repositoryId\" ng-repeat=\"Repository in SystemRepositories\">{{Repository.name}}</md-option>\n</md-select><div ng-messages=\"SystemForm.Repository.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Repository is required</span></div></div></md-input-container><div layout-gt-xs=\"row\" \nlayout-align=\"center center\"><span flex=\"5\"></span><label class=\"pt-10\" style=\"margin-top:2% !important\">Expiration\n</label><md-datepicker ng-model=\"currentSystem.expiration\" style=\"margin-top: 2% !important\"></md-datepicker></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button>\n<md-button ng-click=\"update(currentSystem)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/smartstore-admin/systems/validate.system.html","<md-dialog flex=\"45\"><form name=\"SystemForm\"><md-dialog-content class=\"scrollable\" ms-scroll><div><span><p>\n{{certificate.certificate}}</p></span></div><div layout=\"row\" class=\"pl-0\" layout-align=\"center center\"><md-radio-group\n ng-model=\"currentSystem.certificateStatus\" style=\"display: -webkit-inline-box\"><md-radio-button class=\"pr-15\" \nvalue=\"Accept\">Accept</md-radio-button><md-radio-button class=\"pr-15\" value=\"Reject\">Reject</md-radio-button>\n</md-radio-group></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"save(currentSystem.certificateStatus)\" class=\"md-accent\">Save</md-button><md-button ng-click=\"cancel()\" \nclass=\"md-warn\">Cancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/user-management/groups/addGroupMemberDialog.html","<md-dialog ng-cloak><form name=\"groupsCtrl.memberForm\" role=\"form\" novalidate ng-submit=\" \"><md-toolbar layout=\"row\" \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Add Member</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"ok()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nlayout=\"column\" layout-align=\"center center\"><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"45\"><input \ntype=\"text\" name=\"name\" ng-model=\"member.name\" placeholder=\"Name\"></md-input-container><span flex=\"10\"></span>\n<md-input-container class=\"md-block\" flex=\"45\"><input type=\"text\" name=\"email\" ng-model=\"member.email\" \nplaceholder=\"Email\"></md-input-container></div><div layout=\"row\" \nng-style=\"{\'color\':\'red\',\'font-family\':\'Roboto\',\'font-size\':\'12px\'}\" ng-show=\"msgVisibility\">\nPlease enter either name or email</div><div><md-button type=\"button\" class=\"md-raised md-padding\" \nng-click=\"searchMember(member)\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>Search user</md-button></div><div \nng-show=\"tableVisibility\" class=\"scrollable md-padding\" ms-scroll><table><thead><tr><th \nclass=\"secondary-text md-padding\"><div class=\"table-header\"><span class=\"column-title\">NAME</span></div></th><th \nclass=\"secondary-text md-padding\"><div class=\"table-header\"><span class=\"column-title\">EMAIL</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"member in searchedMembers\"><td class=\"md-padding\">\n{{member.firstName}} {{member.lastName}}</td><td class=\"md-padding\">{{member.email}}</td><td layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-click=\"addGroupMember(member) \">ADD</md-button>\n</td></tr></tbody></table></div></md-dialog-content></form><md-dialog-actions layout=\"row\"><span flex></span><md-button\n ng-click=\"cancel(member)\">Cancel</md-button><md-button ng-click=\"ok()\" md-autofocus>Ok</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/user-management/groups/createGroupDialog.html","<md-dialog aria-label=\"Create a new Group\" flex=\"20\"><form name=\"groupForm\" novalidate ng-submit=\"\" layout=\"column\">\n<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create Group</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"close()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-input-container class=\"md-block\"><input type=\"text\" name=\"name\" \nng-model=\"group.name\" placeholder=\"Group name\" required><div ng-messages=\"groupForm.name.$error\" role=\"alert\"><div \nng-message=\"required\">Group name is required</div></div></md-input-container><md-input-container class=\"md-block\">\n<input type=\"text\" name=\"description\" ng-model=\"group.description\" placeholder=\"Description\"></md-input-container>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button ng-click=\"cancel()\">Cancel\n</md-button><md-button type=\"submit\" ng-click=\"groupForm.$valid && createGroup(group)\">Save</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/user-management/groups/groups.html","<div class=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\"><ms-widget-front \nclass=\"white-bg\"><div class=\"md-padding\" flex=\"35\"><ul class=\"breadcrumb\"><li ng-click=\"groupsCtrl.goToAdmin()\">\nAdministration</li><li ng-click=\"groupsCtrl.goToAdminuser()\">User Management</li><li>Groups</li></ul></div><div \nid=\"groups\" class=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll \nmd-dynamic-height><md-button flow-btn class=\"md-fab grey-700-bg md-mini md-fab-bottom-right\" \nng-click=\"groupsCtrl.createGroupDialog($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"top\">Create Group</md-tooltip></md-button><div class=\"widget-group\" layout=\"column\" flex=\"100\" \nlayout-wrap><ms-widget flippable=\"true\" layout=\"column\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">\n{{groupsCtrl.groupStatGraphData.title}}</div><div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" \nlayout-align-sm=\"end\" flex-sm=\"100\"><md-button class=\"ph-16\" \nng-repeat=\"(key, range) in groupsCtrl.groupStatGraph.ranges\" ng-click=\"groupsCtrl.groupStatGraph.changeRange(key)\" \nng-disabled=\"groupsCtrl.groupStatGraph.currentRange == key\">{{range}}</md-button></div></div><div layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div class=\"p-16\" layout=\"row\" flex=\"100\"><nvd3 class=\"h-320 remove-x-lines\" \nconfig=\"groupsCtrl.groupStatGraph.mainChart.config\" options=\"groupsCtrl.groupStatGraph.mainChart.options\" \ndata=\"groupsCtrl.groupStatGraph.mainChart.data\"></nvd3></div></div></ms-widget-front></ms-widget></div><div \nclass=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\"><ms-widget-front \nclass=\"white-bg\"><div class=\"search\" layout=\"row\" layout-align=\"center center\"><span flex=\"33\"></span> <span flex=\"33\" \nclass=\"h3\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><input \nng-model=\"searchGroup\" type=\"text\" placeholder=\"Search a group here\"></md-input-container></span><span flex=\"33\">\n</span></div><div layout=\"row\" layout-wrap><div ng-repeat=\"eachGroup in groupsCtrl.allGroups | filter : searchGroup\" \nclass=\"md-padding\" flex=\"25\"><md-toolbar layout=\"row\" class=\"{{groupsCtrl.getAnotherColor($index)}}\"><div \nclass=\"md-toolbar-tools\"><span>{{eachGroup.name}}</span><md-fab-speed-dial ng-hide=\"eachGroup.hidden\" \nmd-direction=\"down\" md-open=\"eachGroup.isOpen\" class=\"md-scale md-fab-top-right\" \nng-class=\"{ \'md-hover-full\': eachGroup.hover }\" ng-mouseenter=\"eachGroup.isOpen=true\" \nng-mouseleave=\"eachGroup.isOpen=false\"><md-fab-trigger><md-button aria-label=\"menu\" class=\"md-fab md-mini grey-700-bg\">\n<md-tooltip md-direction=\"top\" md-visible=\"tooltipVisible\">Menu</md-tooltip><md-icon md-font-icon=\"icon-menu\" \naria-label=\"menu\"></md-icon></md-button></md-fab-trigger><md-fab-actions><md-button class=\"md-fab md-raised md-mini\" \nng-click=\"groupsCtrl.addMemberDialog($event, eachGroup)\"><md-tooltip md-direction=\"right\">Add Group Member</md-tooltip>\n<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-button class=\"md-fab md-raised md-mini\"><md-tooltip \nmd-direction=\"right\">Edit Group</md-tooltip><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button><md-button \nclass=\"md-fab md-raised md-mini\" ng-click=\"groupsCtrl.deleteGroup(eachGroup)\"><md-tooltip md-direction=\"right\">\nDelete Group</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div></md-toolbar><md-content flex ng-style=\"{\'border\': \'1px solid #cccccc\'}\" class=\"scrollable\" \nms-scroll layout=\"row\" layout-wrap><div ng-switch=\"(eachGroup.members).length\"><div ng-switch-when=\"0\" layout=\"row\" \nlayout-align=\"center center\"><p class=\"md-padding md-subhead md-primary-fg\">{{\'No member yet...\' | uppercase}}</p>\n</div><div ng-switch-default ng-style=\"{\'height\':\'280px\'}\"><md-list><md-list-item class=\"md-2-line\" \nng-repeat=\"member in eachGroup.members \" ng-click=\"null\"><img ng-src=\"assets\\images\\avatars/Nora.jpg\" \nclass=\"md-avatar\"><div class=\"md-list-item-text\" layout=\"column\"><h3>{{ member.firstName }} {{ member.lastName }}</h3>\n<p>{{ member.email }}</p><md-button class=\"md-secondary md-icon-button\" \nng-click=\"groupsCtrl.deleteGroupMember(eachGroup, $index)\"><md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon>\n<i class=\"icon icon-delete s30\"></i></md-icon></md-button></div><md-divider></md-divider></md-list-item></md-list>\n</div></div></md-content></div></div></ms-widget-front></ms-widget></div></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/user-management/users/create.user.dialog.html","<md-dialog aria-label=\"Add a new user\"><form name=\"userForm\" novalidate \nng-submit=\"userForm.$valid && userCtrl.createUser(user)\" layout=\"column\" flex=\"66\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Create User</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-input-container class=\"md-block\"><input type=\"text\" name=\"login\" \nng-model=\"user.login\" placeholder=\"Login Id\" required><div ng-messages=\"userForm.login.$error\" role=\"alert\"><div \nng-message=\"required\">User ID is required</div></div></md-input-container><md-input-container class=\"md-block\"><input \ntype=\"email\" name=\"email\" ng-model=\"user.email\" placeholder=\"Email\" required><div ng-messages=\"userForm.email.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Email is required</span></div><div \nng-message=\"email\"><span>Email must be a valid e-mail address</span></div></div></md-input-container><div layout=\"row\">\n<md-input-container class=\"md-block\" flex=\"45\"><input type=\"text\" name=\"firstName\" ng-pattern=\"/^[a-zA-Z ]*$/\" \nng-model=\"user.firstName\" placeholder=\"First name\" required><div ng-messages=\"userForm.firstName.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>First Name is required</span></div><div ng-message=\"pattern\"><span>\nFirst Name has invalid characters</span></div></div></md-input-container><span flex=\"10\"></span><md-input-container \nclass=\"md-block\" flex=\"45\"><input type=\"text\" name=\"lastName\" ng-pattern=\"/^[a-zA-Z ]*$/\" ng-model=\"user.lastName\" \nplaceholder=\"Last name\"><div ng-messages=\"userForm.lastName.$error\" role=\"alert\"><div ng-message=\"pattern\"><span>\nLast Name has invalid characters</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"md-block\" flex=\"45\"><input type=\"password\" name=\"password\" ng-model=\"user.password\" placeholder=\"Password\" \nrequired><div ng-messages=\"userForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPassword field is required</span></div></div></md-input-container><span flex=\"10\"></span><md-input-container \nclass=\"md-block\" flex=\"45\"><input type=\"password\" name=\"passwordConfirm\" ng-model=\"user.passwordConfirm\" \nplaceholder=\"Re-enter Password\"> <span style=\"color: red;font-family: \'Roboto\';font-size: 12px\" \nng-show=\"user.password !== user.passwordConfirm\">Passwords do not match</span></md-input-container></div><div \nlayout=\"row\"><md-input-container class=\"md-block\" flex=\"45\"><label>Select Authority</label><md-select \nng-model=\"user.authorities\" multiple=\"multiple\"><md-option ng-value=\"authority\" ng-repeat=\"authority in roles\">\n{{ authority.replace(\"ROLE_USER\",\"User\").replace(\"ROLE_ADMIN\",\"Admin\") }}</md-option></md-select></md-input-container>\n<span flex=\"10\"></span><md-input-container class=\"md-block\" flex=\"45\"><label>Activate User</label><md-select \nng-model=\"user.activated\"><md-option ng-value=\"activate\" ng-repeat=\"activate in status\">{{ activate }}</md-option>\n</md-select></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"userForm.$valid && save(user)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/user-management/users/update.user.dialog.html","<md-dialog aria-label=\"Update a user\"><form name=\"userUpdateForm\" novalidate \nng-submit=\"userUpdateForm.$valid && update(currentUser)\" layout=\"column\" flex=\"66\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Update User</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content layout=\"column\"><md-input-container><input type=\"text\" \ndisabled=\"true\" name=\"login\" ng-model=\"currentUser.login\" placeholder=\"Login Id\" required></md-input-container>\n<md-input-container class=\"md-block\"><input type=\"email\" disabled=\"true\" name=\"email\" ng-model=\"currentUser.email\" \nplaceholder=\"Email\" required></md-input-container><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"45\">\n<input type=\"text\" name=\"firstName\" ng-pattern=\"/^[a-zA-Z ]*$/\" ng-model=\"currentUser.firstName\" \nplaceholder=\"First name\" required><div ng-messages=\"userUpdateForm.firstName.$error\" role=\"alert\"><div \nng-message=\"required\"><span>First Name is required</span></div><div ng-message=\"pattern\"><span>\nFirst Name has invalid characters</span></div></div></md-input-container><span flex=\"10\"></span><md-input-container \nclass=\"md-block\" flex=\"45\"><input type=\"text\" name=\"lastName\" ng-pattern=\"/^[a-zA-Z ]*$/\" \nng-model=\"currentUser.lastName\" placeholder=\"Last name\"><div ng-messages=\"userUpdateForm.lastName.$error\" role=\"alert\">\n<div ng-message=\"pattern\"><span>Last Name has invalid characters</span></div></div></md-input-container></div><div \nlayout=\"row\"><md-input-container class=\"md-block\" flex=\"45\"><label>Select Authority</label><md-select \nng-model=\"currentUser.authorities\" multiple=\"multiple\"><md-option ng-value=\"authority\" ng-repeat=\"authority in roles\">\n{{authority.replace(\"ROLE_USER\",\"User\").replace(\"ROLE_ADMIN\",\"Admin\")}}</md-option></md-select></md-input-container>\n<span flex=\"10\"></span><md-input-container class=\"md-block\" flex=\"45\"><label>Activate User</label><md-select \nng-model=\"currentUser.activated\"><md-option ng-value=\"activated\" ng-repeat=\"activated in status\">\n{{activated.replace(\"true\",\"True\").replace(\"false\",\"False\")}}</md-option></md-select></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button ng-click=\"cancel()\">Cancel\n</md-button><md-button type=\"submit\" ng-click=\"userUpdateForm.$valid && update(currentUser)\">Update</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/user-management/users/users.html","<div id=\"user\" class=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div \nclass=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\"><ms-widget-front \nclass=\"white-bg\"><div class=\"md-padding\" flex=\"35\"><ul class=\"breadcrumb\"><li ng-click=\"userCtrl.goToAdmin()\">\nAdministration</li><li ng-click=\"userCtrl.goToAdminuser()\">User Management</li><li>Users</li></ul></div><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"userCtrl.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Login</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">First Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Last Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Email</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Authorities</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Activated</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\" layout=\"row\" layout-align=\"center center\"><span class=\"column-title\">\nActions</span></div></th></tr></thead><tbody><tr ng-repeat=\"user in usersList | filter : searchUser\"><td>{{user.login}}\n</td><td>{{user.firstName}}</td><td>{{user.lastName}}</td><td>{{user.email}}</td><td><span \nclass=\"text-boxed green-bg white-fg\" ng-show=\"{{user.authorities.indexOf(\'ROLE_USER\') != -1}}\">User</span> <span \nclass=\"text-boxed orange-bg white-fg\" ng-show=\"{{user.authorities.indexOf(\'ROLE_ADMIN\') != -1}}\">Admin</span></td><td \nstyle=\"padding-top:0px !important;padding-bottom:0px !important\"><i class=\"icon-checkbox-marked-circle green-500-fg\" \nng-show=\"{{user.activated}}\"></i> <i class=\"icon-cancel red-500-fg\" ng-show=\"{{! user.activated}}\"></i></td><td \nlayout=\"row\" layout-align=\"center center\" style=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button \nclass=\"md-icon-button test-tooltip\" aria-label=\"Update\" ng-click=\"updateUserDialog($event,user)\"><md-tooltip \nmd-direction=\"top\">Update</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-pencil s20\"></i></md-icon></md-button><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Delete\" ng-click=\"userCtrl.deleteUser($event, user) \"><md-tooltip md-direction=\"top\">Delete</md-tooltip>\n<md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s20\"></i></md-icon></md-button></td></tr>\n</tbody></table></ms-widget-front></ms-widget></div><md-button flow-btn \nclass=\"md-fab grey-700-bg md-mini md-fab-bottom-right\" aria-label=\"Create User\" ng-click=\"createUserDialog($event)\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Create User</md-tooltip></md-button></div>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab md-mini\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></form>\n</div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\" layout=\"column\" layout-align=\"start start\"><div class=\"secondary-text\">\n<div>{{vm.date | date:\'EEEE\'}}</div><div layout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> \n<span class=\"md-subhead\">th</span> <span>{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list>\n<md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span>\n</md-subheader><md-list-item class=\"md-2-line\" ng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div \nclass=\"md-list-item-text\"><h3>{{event.title}}</h3><p>{{event.detail}}</p></div></md-list-item></md-list><md-divider>\n</md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader>\n<md-list-item class=\"md-2-line\" ng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\">\n<h3>{{note.title}}</h3><p>{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list>\n<md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader>\n<md-list-item><h3 translate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.notify\" aria-label=\"Notifications\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item><md-list-item><h3 \ntranslate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.cloud\" \naria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch class=\"md-secondary md-warn\" \nng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header\" id=\"navheader\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\"><img id=\"log1\"></span></div>\n</md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>\n<script>\nif(window.localStorage[\'branddata\'] !=\"null\"){\r\n	var logodata = JSON.parse(window.localStorage[\'branddata\']).applogo; \r\n	var backrounddata = JSON.parse(window.localStorage[\'branddata\']).appbackroundimage; \r\n	if((logodata ||backrounddata) !=null && (logodata ||backrounddata) !=\'undefined\'){\r\n		$(\"#navheader\").css(\'background-image\', \'url(\'+backrounddata+\')\');\r\n		$(\'#log1\').attr(\'src\', logodata);\r\n	}else{\r\n		$(\"#navheader\").css(\'background-image\', \'url(\'+\"assets/images/2.jpg\"+\')\');\r\n		$(\'#log1\').attr(\'src\', \"../assets/images/logos/logo3.jpg\");\r\n	}\r\n}\r\nelse{\r\n	$(\"#navheader\").css(\'background-image\', \'url(\'+\"assets/images/2.jpg\"+\')\');\r\n	$(\'#log1\').attr(\'src\', \"../assets/images/logos/logo3.jpg\");\r\n}\n</script>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon>\n<md-button ng-click=\"vm.editMyProfile($event)\">My Profile</md-button></md-menu-item><md-menu-item class=\"md-indent\" \nui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox</md-button>\n</md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-key\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.changePassword($event)\">Change Password</md-button></md-menu-item>\n<md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\">\n</md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar>\n<div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\" ng-init=\"vm.UserDetails()\"><div layout=\"row\" layout-align=\"start center\" \nflex><md-button id=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div layout=\"row\" flex=\"50\" layout-align=\"start start\">\n<span id=\"mySpan\" class=\"header-text\"></span></div><div layout=\"row\" layout-align=\"center\" show-gt-md hide-xs hide-sm \nhide-md><span id=\"mySpan\" class=\"h1 f-1\" style=\"color:white\">SmartDocs | Smartstore</span></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\"></md-progress-circular><toolbar-search-bar \non-search=\"search(query)\" on-result-click=\"searchResultClick(item)\" debounce=\"300\"></toolbar-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"username white-500-fg\" hide show-gt-sm>{{loggedInUserName }}</span><md-icon \nmd-font-icon=\"icon-chevron-down white-500-fg\" class=\"icon s16\" hide-xs></md-icon><div class=\"avatar-wrapper pl-15\"><img\n md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"></div></div></md-button><md-menu-content \nwidth=\"3\"><md-menu-item class=\"md-indent\" ng-click=\"vm.openProfileDialog($event)\"><md-icon md-font-icon=\"icon-account\" \nclass=\"icon toolbar-icon-color\"></md-icon><md-button ng-click=\"vm.editMyProfile()\">My Profile</md-button>\n</md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-account-key\" \nclass=\"icon toolbar-icon-color\"></md-icon><md-button ng-click=\"vm.changePassword($event)\">Change Password</md-button>\n</md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon toolbar-icon-color\">\n</md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar>\n</div></div><div layout=\"row\"><md-progress-linear class=\"md-accent\" md-mode=\"indeterminate\" \nng-show=\"$root.loadingProgress\"></md-progress-linear></div><script>\nif(window.localStorage[\'branddata\'] !=\"null\"){\r\n	var label = JSON.parse(window.localStorage[\'branddata\']).applabel;\r\n	if(label !=null && label != \'undefined\'){	\r\n		document.getElementById(\'mySpan\').innerHTML = label;\r\n	}else{\r\n		document.getElementById(\'mySpan\').innerHTML  = \"SmartDocs Inc.\";\r\n	}\r\n}else{\r\n	document.getElementById(\'mySpan\').innerHTML  = \"SmartDocs Inc.\";\r\n}\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\r\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\r\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<style>\n.sidebar-list-label {\r\n   color: #aab2bd;\r\n    font-size: 12px;\r\n    line-height: 0px;\r\n    font-weight: 500;\r\n    text-align: center;\r\n}\n</style><ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </div>\r\n         <div layout=\"column\">\r\n <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-black-bg\" style=\"padding: 15px 15px 10px 5px;\" ng-if=\"node.uisref && node.title\">\r\n          \r\n <i class=\"icon s16 {{node.icon}} pl-10\" ng-if=\"node.icon\" ></i> <br>\r\n         <span class=\"sidebar-list-label\">{{node.title}}</span>   \r\n</a>\r\n</div>\r\n  \r\n    </div>\r\n\r\n    <ul class=\"left-side-menu\" ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\r\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/main/createform/views/custom/custom.html","<div id=\"createForm\" ng-controller=\"CustomCreateformController as ctrl\" \nclass=\"customForm page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll md-dynamic-height>\n<div class=\"customCreateForm\"><md-content flex layout-padding><form name=\"customForm\" novalidate><div \nclass=\"textInput\" layout=\"column\" layout-align=\"center center\"><md-input-container class=\"md-block\" style=\"width:50%\">\n<label>Name (required)</label><input name=\"formName\" ng-model=\"ctrl.custom.formName\" required><div \nng-messages=\"customForm.formName.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container>\n<md-input-container class=\"md-block\" style=\"width:50%\"><label>Description</label><input name=\"formDesc\" \nng-model=\"ctrl.custom.formDesc\"></md-input-container></div><div layout=\"row\" align=\"center\"><div flex=\"50\" \nclass=\"htmlUpload\"><md-icon md-font-icon=\"icon-box-upload\" \nng-style=\"{color: \'green\', \'font-size\':\'48px\', height:\'48px\', \'padding-right\' :\'8%\'}\"></md-icon><h1 \nclass=\"md-display-1\"><span>Upload HTML file</span></h1><div class=\"md-list-item-text\">1. Maximum file upload size is \n<span style=\"color: red\">500kB</span><br>2. The file should have a valid <span style=\"color: red\">&lt;form&gt;</span>\n with multiple input elements, i.e.</div><p class=\"md-caption\">\n&lt;input type=\"text\" name=\"GmailAddress\" style=\"color:blue;text-align:center\"></p><md-subheader class=\"md-warn\" \nng-show=\"files.length\">Uploaded files</md-subheader><div ng-repeat=\"file in files.slice(0)\"><span class=\"md-warn\">\n{{file.webkitRelativePath || file.name}}</span> (<span ng-switch=\"file.size > 1024*1024\"> <span ng-switch-when=\"true\">\n{{file.size / 1024 / 1024 | number:2}} MB</span> <span ng-switch-default>{{file.size / 1024 | number:2}} kB</span> \n</span>)</div><md-card-actions layout=\"row\" layout-align=\"center\"><input class=\"ng-hide\" id=\"formUploadFile\" \nname=\"formUploadFile\" multiple=\"multiple\" type=\"file\" type=\"submit\" \nonchange=\"angular.element(this).scope().setFile(this)\"><label for=\"formUploadFile\" ng-hide=\"files.length\" \nclass=\"md-button md-raised md-accent\">Upload</label><md-button class=\"md-accent md-raised\" type=\"submit\" \nng-disabled=\"!files.length\" ng-click=\"ctrl.uploadFile($event)\">Submit</md-button><md-button \nclass=\"md-accent md-raised\" ng-show=\"files.length\" ng-click=\"reset()\">Reset</md-button></md-card-actions></div>\n<md-divider></md-divider><div flex=\"50\"><md-icon md-font-icon=\"icon-web\" \nng-style=\"{color: \'green\', \'font-size\':\'48px\', height:\'48px\', \'padding-right\' :\'8%\'}\"></md-icon><h1 \nclass=\"md-display-1\"><span>Specify page URL</span></h1><div align=\"left\"><md-input-container class=\"md-block\" \nstyle=\"margin-left: 40px\"><label>Enter the URL here</label><input type=\"url\" name=\"formUrl\" \nng-model=\"ctrl.custom.formUrl\" ng-required=\"!files.length\" http-prefix><div ng-messages=\"customForm.formUrl.$error\">\n<div ng-message=\"required\">Please enter the web address of your preferred form.</div><div ng-message=\"url\">\nPlease enter a valid URL to proceed.</div></div></md-input-container></div><md-card-actions layout=\"row\" \nlayout-align=\"center\"><md-button class=\"md-accent md-raised\" type=\"submit\" ng-disabled=\"files.length\" \nng-click=\"customForm.$valid && ctrl.submitUrl($event)\">Submit</md-button></md-card-actions></div></div></form>\n</md-content></div></div>");
$templateCache.put("app/main/createform/views/custom/preview.html","<md-dialog><form name=\"customEditForm\" novalidate><md-dialog-content><md-tabs md-dynamic-height md-border-bottom \nmd-stretch-tabs=\"always\" md-selected=\"selectedTab\"><md-tab label=\"Basic\"><md-content class=\"md-padding\" \nstyle=\"min-width:800px\"><h1 class=\"md-display-1\">Customize input fields</h1><div layout=\"row\" \nng-repeat=\"eachInput in inputElemAll track by $index\"><md-input-container class=\"md-block\" flex=\"5\"><md-button \nclass=\"md-icon-button md-warn\" aria-label=\"Settings\"><md-icon md-font-icon=\"icon-delete\" ng-click=\"removeElem($index)\" \nng-style=\"{\'font-size\':\'36px\', height:\'36px\', \'padding-right\' :\'8%\'}\"></md-icon></md-button></md-input-container><span \nflex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\"><label>Field Name</label><input name=\"elemName\" \nng-model=\"eachInput.name\" placeholder=\"{{eachInput.name}}\"> <span \nstyle=\"color: red;font-family: \'Roboto\';font-size: 12px\" ng-show=\"getElemId(eachInput.name) != eachInput.id\">\nThe element already exists. Please choose a different name.</span></md-input-container><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"20\"><label>Field Type</label><md-select ng-model=\"eachInput.type\" \nplaceholder=\"{{eachInput.type}}\"><md-option ng-value=\"type\" ng-repeat=\"type in fieldTypes\">{{type}}</md-option>\n</md-select></md-input-container><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\"><label>CSS Style\n</label><input name=\"elemStyle\" ng-model=\"eachInput.style\" placeholder=\"{{custom.style}}\"></md-input-container><span \nflex=\"5\"></span><md-input-container class=\"md-block\" flex=\"15\"><md-switch ng-model=\"eachInput.required\" \naria-label=\"Switch 1\">Required</md-switch></md-input-container></div><md-button \nclass=\"md-fab md-accent md-icon-button\" id=\"add-contact-button\" ng-click=\"addElem()\" aria-label=\"add contact\" \nstyle=\"position: fixed;bottom: 8px;right: 8px;padding: 0\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n</md-content></md-tab><md-tab label=\"Positioning\" md-on-select=\"setParent()\"><md-content class=\"md-padding\" \nstyle=\"min-width:800px\"><h1 class=\"md-display-1\">Define form structure</h1><div layout=\"row\" \nng-repeat=\"eachInput in inputElemAll\"><md-input-container class=\"md-block\" flex=\"20\"><label>{{eachInput.name}}</label>\n</md-input-container><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"25\"><label>Is a child of</label>\n<md-select ng-model=\"eachInput.position.parent\" placeholder=\"{{eachInput.position.parent}}\"><md-option ng-value=\"elem\" \nng-repeat=\"elem in parentAll\">{{elem}}</md-option></md-select><span \nstyle=\"color: red;font-family: \'Roboto\';font-size: 12px\" ng-show=\"checkParent(eachInput)\">{{parentError}}</span>\n</md-input-container><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\" \nng-show=\"eachInput.position.parent==\' \'\"><label>Row</label><input type=\"number\" step=\"any\" name=\"elemRow\" \nng-model=\"eachInput.position.row\"> <span ng-show=\"isNumeric(eachInput.position.row) && eachInput.position.row < 1\" \nstyle=\"color: red;font-family: \'Roboto\';font-size: 12px\">Rows start from 1</span></md-input-container><span flex=\"5\">\n</span><md-input-container class=\"md-block\" flex=\"20\" ng-show=\"eachInput.position.parent==\' \'\"><label>Column</label>\n<input type=\"number\" step=\"any\" name=\"elemColumn\" ng-model=\"eachInput.position.column\"> <span \nng-show=\"isNumeric(eachInput.position.column) && eachInput.position.column < 1\" \nstyle=\"color: red;font-family: \'Roboto\';font-size: 12px\">Columns start from 1</span></md-input-container></div>\n</md-content></md-tab><md-tab label=\"Preview\" md-on-select=\"preview()\"><md-content class=\"md-padding\"><h1 \nclass=\"md-display-1\">Preview your changes</h1><form name=\"customPreviewForm\" novalidate><div layout=\"row\" \nlayout-align=\"start start\" ng-repeat=\"row in rowColMap\"><div layout=\"column\" layout-align=\"start start\" \nng-repeat=\"column in row\" flex-offset=\"10\"><div ng-if=\"column.position.parent == \' \'\"><div ng-switch=\"column.type\"><div\n ng-switch-when=\"text\"><md-input-container class=\"md-block\"><label>{{dynamicElemLabel(column.name,column.required)}}\n</label><input name=\"{{column.name}}\" ng-model=\"ctrl.custom.dummy\" type=\"text\" ng-required=\"column.required\" \nstyle=\"{{column.style}}\"></md-input-container></div><div ng-switch-when=\"password\"><md-input-container \nclass=\"md-block\"><label>{{dynamicElemLabel(column.name,column.required)}}</label><input name=\"{{column.name}}\" \nng-model=\"ctrl.custom.dummy\" type=\"password\" ng-required=\"column.required\" style=\"{{column.style}}\">\n</md-input-container></div><div ng-switch-when=\"url\"><md-input-container class=\"md-block\"><label>\n{{dynamicElemLabel(column.name,column.required)}}</label><input name=\"{{column.name}}\" ng-model=\"ctrl.custom.dummy\" \ntype=\"url\" ng-required=\"column.required\" style=\"{{column.style}}\"></md-input-container></div><div \nng-switch-when=\"email\"><md-input-container class=\"md-block\"><label>{{dynamicElemLabel(column.name,column.required)}}\n</label><input name=\"{{column.name}}\" ng-model=\"ctrl.custom.dummy\" type=\"email\" ng-required=\"column.required\" \nstyle=\"{{column.style}}\"></md-input-container></div><div ng-switch-when=\"number\"><md-input-container class=\"md-block\">\n<label>{{dynamicElemLabel(column.name,column.required)}}</label><input name=\"{{column.name}}\" \nng-model=\"ctrl.custom.dummy\" type=\"number\" ng-required=\"column.required\" style=\"{{column.style}}\"></md-input-container>\n</div><div ng-switch-when=\"checkbox\"><md-input-container class=\"md-block\"><md-checkbox name=\"tos\" \nng-model=\"ctrl.custom.dummy\" ng-required=\"column.required\">{{dynamicElemLabel(column.name,column.required)}}\n</md-checkbox></md-input-container></div><div ng-switch-when=\"date\"><label>\n{{dynamicElemLabel(column.name,column.required)}}</label><md-datepicker ng-model=\"ctrl.custom.dummy\"></md-datepicker>\n</div><div ng-switch-when=\"range\"><label>{{dynamicElemLabel(column.name,column.required)}}</label><md-slider-container>\n<md-slider flex=\"50\" min=\"0\" max=\"50\" ng-model=\"color.red\" aria-label=\"red\" id=\"red-slider\"></md-slider>\n<md-input-container><input flex type=\"number\" ng-model=\"color.red\" aria-label=\"red\" aria-controls=\"red-slider\">\n</md-input-container></md-slider-container></div><div ng-switch-when=\"radio\"><label>\n{{dynamicElemLabel(column.name,column.required)}}</label><md-radio-group ng-model=\"data.group1\" layout=\"row\">\n<md-radio-button value=\"Apple\">Val 1</md-radio-button><md-radio-button value=\"Banana\">Val 2</md-radio-button>\n<md-radio-button value=\"Mango\">Val 3</md-radio-button></md-radio-group></div></div></div><div layout=\"row\" \nlayout-align=\"start start\" ng-repeat=\"childElem in getChildren(column.name)\" flex-offset=\"25\"><div \nng-switch=\"childElem.type\"><div ng-switch-when=\"text\"><md-input-container class=\"md-block\"><label>\n{{dynamicElemLabel(childElem.name,childElem.required)}}</label><input name=\"{{childElem.name}}\" \nng-model=\"ctrl.custom.dummy\" type=\"text\" ng-required=\"childElem.required\" style=\"{{childElem.style}}\">\n</md-input-container></div><div ng-switch-when=\"password\"><md-input-container class=\"md-block\"><label>\n{{dynamicElemLabel(childElem.name,childElem.required)}}</label><input name=\"{{childElem.name}}\" \nng-model=\"ctrl.custom.dummy\" type=\"password\" ng-required=\"childElem.required\" style=\"{{childElem.style}}\">\n</md-input-container></div><div ng-switch-when=\"url\"><md-input-container class=\"md-block\"><label>\n{{dynamicElemLabel(childElem.name,childElem.required)}}</label><input name=\"{{childElem.name}}\" \nng-model=\"ctrl.custom.dummy\" type=\"url\" ng-required=\"childElem.required\" style=\"{{childElem.style}}\">\n</md-input-container></div><div ng-switch-when=\"email\"><md-input-container class=\"md-block\"><label>\n{{dynamicElemLabel(childElem.name,childElem.required)}}</label><input name=\"{{childElem.name}}\" \nng-model=\"ctrl.custom.dummy\" type=\"email\" ng-required=\"childElem.required\" style=\"{{childElem.style}}\">\n</md-input-container></div><div ng-switch-when=\"number\"><md-input-container class=\"md-block\"><label>\n{{dynamicElemLabel(childElem.name,childElem.required)}}</label><input name=\"{{childElem.name}}\" \nng-model=\"ctrl.custom.dummy\" type=\"number\" ng-required=\"childElem.required\" style=\"{{childElem.style}}\">\n</md-input-container></div><div ng-switch-when=\"checkbox\"><md-input-container class=\"md-block\"><md-checkbox name=\"tos\" \nng-model=\"ctrl.custom.dummy\" ng-required=\"childElem.required\">{{dynamicElemLabel(childElem.name,childElem.required)}}\n</md-checkbox></md-input-container></div><div ng-switch-when=\"date\"><label>\n{{dynamicElemLabel(childElem.name,childElem.required)}}</label><md-datepicker ng-model=\"ctrl.custom.dummy\">\n</md-datepicker></div><div ng-switch-when=\"range\"><label>{{dynamicElemLabel(childElem.name,childElem.required)}}\n</label><md-slider-container><md-slider flex=\"50\" min=\"0\" max=\"50\" ng-model=\"color.red\" aria-label=\"red\" \nid=\"red-slider\"></md-slider><md-input-container><input flex type=\"number\" ng-model=\"color.red\" aria-label=\"red\" \naria-controls=\"red-slider\"></md-input-container></md-slider-container></div><div ng-switch-when=\"radio\"><label>\n{{dynamicElemLabel(childElem.name,childElem.required)}}</label><md-radio-group ng-model=\"data.group1\" layout=\"row\">\n<md-radio-button value=\"Apple\">Val 1</md-radio-button><md-radio-button value=\"Banana\">Val 2</md-radio-button>\n<md-radio-button value=\"Mango\">Val 3</md-radio-button></md-radio-group></div></div></div></div></div></form>\n</md-content></md-tab></md-tabs></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nng-click=\"hide()\">Cancel</md-button><md-button ng-click=\"answer(\'useful\')\">Save</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/administration/list-management/list-maintenance/createlist-maintenanace-dialog.html","<md-dialog aria-label=\"Add List\"><form name=\"listForm\" novalidate \nng-submit=\"listForm.$valid && doctypeCrtl.createDocumentType()\" layout=\"column\" flex=\"66\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create Detail</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container class=\"md-block\" flex=\"45\" \nng-repeat=\"list in attrdata track by $index\"><label>{{list.fieldname}}</label><input type=\"text\" name=\"arrval\" \nng-model=\"crlist[$index].list\" required><div ng-messages=\"listForm.list.fieldname.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{list.fieldname}} is required</span></div><div ng-message=\"pattern\"><span>\n{{list.fieldname}} has invalid characters</span></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel\n</md-button><md-button type=\"submit\" ng-click=\"listForm.$valid && save()\">Save</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/administration/list-management/list-maintenance/list-maintenance.html","<style>\n.mh-0 {\r\n    min-height: 0px !important;\r\n}\r\n.parent-tabs > md-tabs .md-tab.md-active:after{\r\n    content: \" \";\r\n    border-left: 7px solid transparent;\r\n    border-right: 7px solid transparent;\r\n    border-bottom: 7px solid #efefef;\r\n    position: absolute;\r\n    display: block;\r\n    top: 87%;\r\n    left: 50%;\r\n    \r\n}\r\n.parent-tabs > md-tabs md-ink-bar {\r\n    background: none; \r\n}\r\n.parent-tabs > md-tabs .md-tab:hover {\r\n    color: #389cec !important;\r\n}\r\n.md-tab {\r\n  \r\n  text-transform: none;\r\n  }\r\n  .table-border {\r\n    border: 1px solid #d3d3d3 !important;\r\n}\r\n.table-header {\r\n    background-color: #dee7f4 !important;\r\n    text-transform: uppercase;\r\n    font-size: 11px!important;\r\n}\n</style><div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div class=\"widget-group scrollable\" flex=\"100\" \nlayout=\"column\" layout-wrap ms-scroll ng-init=\"requestCtrl.getRequestForms()\"><ms-widget><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"List Definition\" \nui-sref=\"app.administration.lists\"></md-tab><md-tab label=\"List Maintenance\" md-active=\"true\" \nui-sref=\"app.administration.list-maintenance\"></md-tab></md-tabs><md-button ng-hide=\"showrowdata\" flow-btn \nclass=\"md-fab grey-700-bg md-mini md-fab-bottom-right add_btn\" ng-click=\"createlistmaintenanace(ev)\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Create Detail</md-tooltip></md-button></div><div \nclass=\"white-bg\" layout=\"row\" ng-show=\"showrowdata\" layout-wrap><div ng-repeat=\"list in listdata\" flex=\"100\" \nflex-gt-xs=\"15\" flex-gt-md=\"15\" class=\"md-padding\"><a ng-click=\"showdetail(list)\"><ms-widget flex=\"15\"><ms-widget-front\n class=\"h-170 p-16 c-p\"><div class=\"md-subhead font-weight-500 black-fg\">{{list.name}}</div><div layout=\"column\" \nlayout-align=\"space-between\" flex><div><div class=\"h6 secondary-text\">{{list.description}}</div></div></div><div \nlayout=\"row\" layout-align=\"space-between center\"><div><md-icon md-font-icon=\"icon-file-document\" class=\"s50 icon\">\n</md-icon></div></div></ms-widget-front></ms-widget></a></div></div><div ng-hide=\"showrowdata\" \nclass=\"md-padding white-bg\"><div class=\"previous-state c-p\"><md-button ng-click=\"goback()\">Back</md-button></div><table\n class=\"simple table-border\" ng-if=\"dynamicdata1 != undefined\" ms-responsive-table><thead><tr class=\"table-header\"><th \nclass=\"secondary-text\" ng-hide=\"value == \'_id\'\" ng-repeat=\"(key, value) in dynamicdata1\"><div class=\"table-header\">\n<span class=\"column-title\">{{value}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\" \nlayout=\"row\" layout-align=\"center center\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr \nng-repeat=\"(key, value) in tdata track by $index\"><td ng-hide=\"k == \'_id\'\" \nng-repeat=\"(k, v) in tdata[$index] track by $index\">{{v}}</td><td layout=\"row\" layout-align=\"center center\" \nstyle=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Update\" ng-click=\"updatedataDialog($event,tdata[$index])\"><md-tooltip md-direction=\"top\">Update\n</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s18\"></i></md-icon>\n</md-button><md-button class=\"md-icon-button test-tooltip\" aria-label=\"Delete\" \nng-click=\"deletedata($event,tdata[$index]) \"><md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon><i \nlayout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s18\"></i></md-icon></md-button></td></tr></tbody>\n</table><div ng-if=\"dynamicdata1 == undefined\" class=\"md-padding\"><span layout=\"row\" layout-align=\"center center\"><h2>\nNo Data Available</h2></span></div><md-divider></md-divider><div ng-if=\"dynamicdata1 != undefined\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"md-padding\"><h5>\nShowing {{(listmainCtrl.pageNumber*listmainCtrl.pageSize)+1}} - {{(listmainCtrl.pageNumber*listmainCtrl.pageSize)+listmainCtrl.pageSize}} of {{listmainCtrl.numberOfElements}} Results\n</h5></div><div layout=\"row\" layout-align=\"center center\">Page No<md-input-container class=\"md-block md-padding\" \nstyle=\"margin: 0px\"><md-select ng-model=\"pageNumber\"><md-option ng-repeat=\"pageNumber in pageNumbers\" \nng-value=\"pageNumber\" ng-click=\"sendPageNumber(pageNumber)\" value=\"listmainCtrl.pageNumber\">{{pageNumber+1}}\n</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"center center\"><div><md-button \nstyle=\"min-width: 0px; !important;padding:0px\" type=\"button\" ng-click=\"listmainCtrl.previous()\" \nng-disabled=\"listmainCtrl.pageNumber <= 0 \">Prev</md-button></div><p class=\"md-padding\">\n{{listmainCtrl.pageNumber+1}}/{{listmainCtrl.length}} &nbsp;PAGES</p><div class=\"md-padding\"><md-button \nstyle=\"min-width: 0px; !important;padding:0px\" type=\"button\" ng-click=\"listmainCtrl.next()\" \nng-disabled=\"listmainCtrl.pageNumber == pageNumbers.length-1 || listmainCtrl.numberOfElements == 0\">Next</md-button>\n</div></div></div></div></ms-widget></div></div>");
$templateCache.put("app/main/administration/list-management/list-maintenance/updatelistmaintenance-dialog.html","<md-dialog aria-label=\"Add List\"><form name=\"listForm\" novalidate ng-submit=\"listForm.$valid && updatedata()\" \nlayout=\"column\" flex=\"66\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Update Detail</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container class=\"md-block\" flex=\"45\" \nng-hide=\"key == \'_id\'\" ng-repeat=\"(key, value) in currentdata track by $index\"><label>{{key}}</label><input \ntype=\"text\" name=\"arrval\" ng-init=\"updateddata[$index] = value\" ng-model=\"updateddata[$index]\" required><div \nng-messages=\"listForm.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{key}} is required</span></div><div \nng-message=\"pattern\"><span>{{key}} has invalid characters</span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" \nng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"updatedata()\">update</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/user-management/groups/addGroupMemberDialog.html","<md-dialog ng-cloak flex=\"60\"><form name=\"groupsCtrl.memberForm\" role=\"form\" novalidate ng-submit=\" \"><md-toolbar \nlayout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Add Member</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"ok()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout=\"column\" layout-align=\"center center\"><div layout=\"row\" layout-align=\"space-between center\" \nstyle=\"width:100%\"><md-input-container class=\"md-block\"><input type=\"text\" name=\"name\" ng-model=\"member.name\" \nplaceholder=\"Name\"></md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"email\" \nng-model=\"member.email\" placeholder=\"Email\"></md-input-container><md-button type=\"button\" class=\"md-raised\" \nng-click=\"searchMember(member)\" style=\"margin-bottom: 20px\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>Search\n</md-button></div><div layout=\"row\" ng-style=\"{\'color\':\'red\',\'font-family\':\'Roboto\',\'font-size\':\'12px\'}\" \nng-show=\"msgVisibility\">Please enter either name or email</div><div ng-show=\"tableVisibility\" \nclass=\"scrollable md-padding\" ms-scroll><table><thead><tr><th class=\"secondary-text md-padding\"><div \nclass=\"table-header\"><span class=\"column-title\">NAME</span></div></th><th class=\"secondary-text md-padding\"><div \nclass=\"table-header\"><span class=\"column-title\">EMAIL</span></div></th></tr></thead><tbody \nng-repeat=\"member in searchedMembers\"><tr ng-repeat=\"user in member\"><td class=\"md-padding\">\n{{user.firstName}} {{user.lastName}}</td><td class=\"md-padding\">{{user.email}}</td><td layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-click=\"addGroupMember(user) \">ADD</md-button>\n</td></tr></tbody></table></div></md-dialog-content></form><md-dialog-actions layout=\"row\"><span flex></span><md-button\n ng-click=\"cancel(member)\">Cancel</md-button><md-button ng-click=\"ok()\" md-autofocus>Ok</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/administration/user-management/groups/createGroupDialog.html","<md-dialog aria-label=\"Create a new Group\" flex=\"20\"><form name=\"groupForm\" novalidate ng-submit=\"\" layout=\"column\">\n<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create Group</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"close()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-input-container class=\"md-block\"><label>Group name</label><input \ntype=\"text\" name=\"name\" ng-model=\"group.name\" required><div ng-messages=\"groupForm.name.$error\" role=\"alert\"><div \nng-message=\"required\">Group name is required</div></div></md-input-container><md-input-container class=\"md-block\">\n<input type=\"text\" name=\"description\" ng-model=\"group.description\" placeholder=\"Description\"></md-input-container>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button ng-click=\"cancel()\">Cancel\n</md-button><md-button type=\"submit\" ng-click=\"groupForm.$valid && createGroup(group)\">Save</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/user-management/groups/editGroupDialog.html","<md-dialog aria-label=\"Create a new Group\" flex=\"20\"><form name=\"groupForm\" novalidate ng-submit=\"\" layout=\"column\">\n<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Edit Group</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"close()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-input-container class=\"md-block\"><input type=\"text\" name=\"name\" \nng-model=\"currentGroup.name\" placeholder=\"Group name\" required><div ng-messages=\"groupForm.name.$error\" role=\"alert\">\n<div ng-message=\"required\">Group name is required</div></div></md-input-container><md-input-container class=\"md-block\">\n<input type=\"text\" name=\"description\" ng-model=\"currentGroup.description\" placeholder=\"Description\">\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" ng-click=\" EditGroup(currentGroup)\">Save</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/user-management/groups/groups.html","<style>\n.mh-0 {\r\n    min-height: 0px !important;\r\n}\r\n.parent-tabs > md-tabs .md-tab.md-active:after{\r\n    content: \" \";\r\n    border-left: 7px solid transparent;\r\n    border-right: 7px solid transparent;\r\n    border-bottom: 7px solid #efefef;\r\n    position: absolute;\r\n    display: block;\r\n    top: 87%;\r\n    left: 50%;\r\n   \r\n}\r\n.parent-tabs > md-tabs md-ink-bar {\r\n    background: none; \r\n}\r\n.parent-tabs > md-tabs .md-tab:hover {\r\n    color: #389cec !important;\r\n}\r\n.md-tab {\r\n  \r\n  text-transform: none;\r\n  }\r\n  .table-border {\r\n    border: 1px solid #d3d3d3 !important;\r\n}\r\n.table-header {\r\n    background-color: #dee7f4 !important;\r\n    text-transform: uppercase;\r\n    font-size: 11px!important;\r\n}\n</style><div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Users\" ui-sref=\"app.administration.users\">\n</md-tab><md-tab label=\"Groups\" ui-sref=\"app.administration.groups\" md-active=\"true\"></md-tab></md-tabs></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable white-bg\" layout=\"column\" flex ms-scroll md-dynamic-height \nng-if=\"!viewGroupMember\"><div class=\"search\" layout=\"row\" layout-align=\"center center\"><span flex=\"100\">\n<md-input-container class=\"no-margin pull-right\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><input \nng-model=\"searchGroup\" type=\"text\" placeholder=\"Search...\"></md-input-container></span></div><div layout=\"row\" \nlayout-wrap><div layout=\"row\" flex=\"100\" layout-align=\"center center\" ng-if=\"totalGroups<1\" \nstyle=\"border:2px solid rgb(97, 149, 232)\"><p><b>No Groups are available.</b></p></div><div \nng-repeat=\"eachGroup in groupsCtrl.allGroups | filter : searchGroup\" flex=\"100\" flex-gt-xs=\"25\" flex-gt-md=\"20\">\n<md-card style=\"height:190px\"><div layout=\"column\" layout-align=\"space-between\" flex class=\"c-p\" \nng-click=\"groupsCtrl.selectGroup(eachGroup)\" md-theme=\"{{getAnotherColor($index)}}\"><md-tooltip md-direction=\"top\">\n{{eachGroup.description}}</md-tooltip><div class=\"white-fg md-padding\" layout=\"row\" layout-align=\"center center\" \nng-style=\"{\'height\':\'150px\'}\" style=\"background-color: {{getAnotherColor($index)}}\"><md-icon \nmd-font-icon=\"icon-account-multiple\" class=\"s64 white-fg\"></md-icon></div></div><div><md-divider></md-divider><div \nclass=\"text\" style=\"text-align: center\"><md-button class=\"md-icon-button test-tooltip\" \nng-click=\"groupsCtrl.editGroup($event,eachGroup)\"><md-tooltip md-direction=\"top\">Edit Group</md-tooltip><md-icon><i \nlayout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s20\"></i></md-icon></md-button><a class=\"c-p\" \nng-click=\"groupsCtrl.selectGroup(eachGroup)\">{{eachGroup.name}}</a><md-button class=\"md-icon-button test-tooltip\" \nng-click=\"groupsCtrl.deleteGroup(eachGroup)\"><md-tooltip md-direction=\"top\">Delete Group</md-tooltip><md-icon><i \nlayout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s20\"></i></md-icon></md-button></div></div></md-card>\n</div></div></div><div class=\"page-layout carded fullwidth md-padding scrollable white-bg\" \ndata-ng-if=\"viewGroupMember\"><div class=\"md-padding\" layout=\"row\"><span class=\"md-active c-p\" \ndata-ng-click=\"goBackToGroup();\" style=\"display: inherit\"><md-icon md-font-icon=\"icon-arrow-left md-active s16\">\n</md-icon>Go back</span></div><table class=\"dataTable row-border hover table-border\" datatable=\"ng\" \ndt-options=\"dtOptions\"><thead><tr class=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">First Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Last Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Email</span></div></th><th class=\"secondary-text\"><div class=\"table-header\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr \nng-repeat=\"eachGroup in groupObj.members | filter : searchUser\"><td>{{eachGroup.firstName}}</td><td>\n{{eachGroup.lastName}}</td><td>{{eachGroup.email}}</td><td layout=\"row\" layout-align=\"center center\" \nstyle=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Delete\" ng-click=\"groupsCtrl.deleteGroupMember(groupObj, $index)\"><md-tooltip md-direction=\"top\">Delete\n</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s18\"></i></md-icon>\n</md-button></td></tr></tbody></table></div></ms-widget></div><md-button flow-btn \nclass=\"md-fab grey-700-bg md-mini md-fab-bottom-right\" ng-click=\"groupsCtrl.createGroupDialog($event)\" \nng-if=\"!viewGroupMember\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Create Group\n</md-tooltip></md-button><md-button flow-btn class=\"md-fab grey-700-bg md-mini md-fab-bottom-right\" \nng-click=\"groupsCtrl.addMemberDialog($event, groupObj)\" ng-if=\"viewGroupMember\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon><md-tooltip md-direction=\"top\">Add Group Member</md-tooltip></md-button></div></div>");
$templateCache.put("app/main/administration/user-management/user-upload/userupload.html","<style>\ntable, th , td  {\r\n  border: 1px solid grey;\r\n  border-collapse: collapse;\r\n  padding: 5px;\r\n  width:50px;\r\n  height:50px;\r\n  \r\n}\r\ntable tr:nth-child(odd) {\r\n  background-color: #f1f1f1;\r\n}\r\ntable tr:nth-child(even) {\r\n  background-color: #ffffff;\r\n}\r\n\r\n.mh-0 {\r\n    min-height: 0px !important;\r\n}\r\n.parent-tabs > md-tabs .md-tab.md-active:after{\r\n    content: \" \";\r\n    border-left: 7px solid transparent;\r\n    border-right: 7px solid transparent;\r\n    border-bottom: 7px solid #efefef;\r\n    position: absolute;\r\n    display: block;\r\n    top: 87%;\r\n    left: 50%;\r\n  \r\n}\r\n.parent-tabs > md-tabs md-ink-bar {\r\n    background: none; \r\n}\r\n.parent-tabs > md-tabs .md-tab:hover {\r\n    color: #389cec !important;\r\n}\r\n\r\n.md-tab {\r\n  \r\n  text-transform: none;\r\n  }\r\n\r\n#collapse1{\r\noverflow-y:scroll;\r\nheight:200px;\r\n}\r\n\r\n\r\n.md-button {\r\n  padding: 0 6px 0 6px;\r\n  margin: 6px 8px 6px 8px;\r\n  min-width: 88px;\r\n  border-radius: 3px;\r\n  font-size: 14px;\r\n  text-align: center;\r\n  text-transform: uppercase;\r\n  text-decoration:none;\r\n  border: none;\r\n  outline: none;\r\n}\n</style><div class=\"page-layout simple right-sidenav\" layout=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Users\" ui-sref=\"app.administration.users\">\n</md-tab><md-tab label=\"Groups\" ui-sref=\"app.administration.groups\"></md-tab><md-tab label=\"UserUpload\" \nui-sref=\"app.administration.userupload\" md-active=\"true\"></md-tab></md-tabs></div><div class=\"block center\">\n<ng-csv-import content=\"csv.content\" header=\"csv.header\" separator=\"csv.separator\" result=\"csv.result\"></ng-csv-import>\n</div><div style=\"width:100%; overflow-y:auto; height: 400px !important; max-height:350px !important\" \nclass=\"scrollable\" ms-scroll><table class=\"table\" style=\"width:98%\"><thead class=\"thead-inverse\"><tr \nstyle=\"background-color:lavender\"><th>Login</th><th>FirstName</th><th>LastName</th><th>Email</th><th \nng-show=\"IsVisible\">Errors</th></tr></thead><tbody><tr ng-repeat=\"user in finalUsersList track by $index \"><td>\n{{user.login}}</td><td>{{user.firstName}}</td><td>{{user.lastName}}</td><td>{{user.email}}</td><td \nstyle=\"color:red;font-size:120%\" ng-show=\"IsVisible\">{{user.error}}</td></tr></tbody></table></div><div layout=\"row\" \nlayout-align=\"end end\"><md-button class=\"md-raised md-cornered\" ng-click=\"cancel();\">Cancel</md-button><md-button \nclass=\"md-raised md-accent\" ng-click=\"save(csv.result)\" ng-disabled=\"savebuttonVisible\">Save</md-button></div>\n</ms-widget></div></div></div><div ng-include=\"\'/app/core/layouts/footer.html\'\"></div>");
$templateCache.put("app/main/administration/user-management/users/create.user.dialog.html","<md-dialog aria-label=\"Add a new user\"><form name=\"userForm\" novalidate \nng-submit=\"userForm.$valid && userCtrl.createUser(user)\" layout=\"column\" flex=\"66\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Create User</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-input-container class=\"md-block\"><label>Login Id</label><input \ntype=\"text\" name=\"login\" ng-model=\"user.login\" required><div ng-messages=\"userForm.login.$error\" role=\"alert\"><div \nng-message=\"required\">User ID is required</div></div></md-input-container><md-input-container class=\"md-block\"><label>\nEmail</label><input type=\"email\" name=\"email\" ng-model=\"user.email\" ng-pattern=\"re\" required><div \nng-messages=\"userForm.email.$error||userForm.email.$error.pattern \" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span class=\"error\">Email is required</span></div><div ng-message=\"email\"><span class=\"\">\nEmail must be a valid e-mail address</span></div><div ng-message=\"pattern\"><span class=\"\">Please enter correct domain\n</span></div></div></md-input-container><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"45\"><label>\nFirst name</label><input type=\"text\" name=\"firstName\" ng-pattern=\"/^[a-zA-Z ]*$/\" ng-model=\"user.firstName\" required>\n<div ng-messages=\"userForm.firstName.$error\" role=\"alert\"><div ng-message=\"required\"><span>First Name is required\n</span></div><div ng-message=\"pattern\"><span>First Name has invalid characters</span></div></div></md-input-container>\n<span flex=\"10\"></span><md-input-container class=\"md-block\" flex=\"45\"><input type=\"text\" name=\"lastName\" \nng-pattern=\"/^[a-zA-Z ]*$/\" ng-model=\"user.lastName\" placeholder=\"Last name\"><div \nng-messages=\"userForm.lastName.$error\" role=\"alert\"><div ng-message=\"pattern\"><span>Last Name has invalid characters\n</span></div></div></md-input-container></div><div layout=\"row\" layout-align=\"start center\"><md-input-container \nclass=\"md-block\" flex=\"45\"><label>Password</label><input type=\"{{inputType}}\" name=\"password\" ng-model=\"user.password\" \nrequired><div ng-messages=\"userForm.password.$error\" role=\"alert\"><div ng-message=\"required\">Password is required</div>\n</div></md-input-container><span flex=\"5\"></span><md-checkbox type=\"checkbox\" ng-model=\"mypassword\" \nng-click=\"hideShowPassword()\"><label for=\"checkbox\" ng-if=\"mypassword\">Hide</label><label for=\"checkbox\" \nng-if=\"!mypassword\">Show</label></md-checkbox></div><div layout=\"row\"><md-input-container flex=\"45\"><label>\nSelect Authority</label><md-select name=\"Authority\" ng-model=\"user.authorities\" multiple=\"multiple\" required><md-option\n ng-value=\"authority\" ng-repeat=\"authority in roles\" ng-selected=\"$first\">\n{{ authority.replace(\"ROLE_USER\",\"User\").replace(\"ROLE_ADMIN\",\"Admin\") }}</md-option></md-select><div \nng-messages=\"userForm.Authority.$error\" role=\"alert\"><div ng-message=\"required\"><span>Authority is required</span>\n</div></div></md-input-container><span flex=\"10\"></span><md-switch ng-model=\"user.activated\" \naria-label=\" Activate User\">Activate User</md-switch></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"userForm.$valid && save(user)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/user-management/users/resetpassword.html","<md-dialog flex=\"35\"><form name=\"passwordForm\" novalidate layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Reset Password</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" \nlayout-align=\"center center\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-key-variant\" \nstyle=\"color: rgb(5, 167, 253) !important\"></md-icon><input type=\"password\" name=\"password\" ng-model=\"user.password\" \nplaceholder=\"Enter Password*\" required><div ng-messages=\"passwordForm.password.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Password field is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><md-icon md-font-icon=\"icon-key-variant\" style=\"color: rgb(5, 167, 253) !important\"></md-icon><input \ntype=\"password\" name=\"passwordConfirm\" ng-model=\"user.passwordConfirm\" placeholder=\"Re-enter Password*\" required> <span\n style=\"color: red;font-family: \'Roboto\';font-size: 12px\" ng-show=\"user.password !== user.passwordConfirm\">\nPasswords do not match</span><div ng-messages=\"passwordForm.passwordConfirm.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Re-enter Password field is required</span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" \nng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"passwordForm.$valid && resetPasswordfinish(user.password,key)\">Save</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/administration/user-management/users/update.user.dialog.html","<md-dialog aria-label=\"Update a user\"><form name=\"userUpdateForm\" novalidate \nng-submit=\"userUpdateForm.$valid && update(currentUser)\" layout=\"column\" flex=\"66\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Update User:{{currentUser.login}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"column\">\n<md-input-container><input type=\"text\" disabled=\"true\" name=\"login\" ng-model=\"currentUser.login\" \nplaceholder=\"Login Id\" required></md-input-container><md-input-container class=\"md-block\"><input type=\"email\" \nname=\"email\" ng-model=\"currentUser.email\" placeholder=\"Email\" required></md-input-container><div layout=\"row\">\n<md-input-container class=\"md-block\" flex=\"45\"><input type=\"text\" name=\"firstName\" ng-pattern=\"/^[a-zA-Z ]*$/\" \nng-model=\"currentUser.firstName\" placeholder=\"First name\" required><div ng-messages=\"userUpdateForm.firstName.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>First Name is required</span></div><div ng-message=\"pattern\"><span>\nFirst Name has invalid characters</span></div></div></md-input-container><span flex=\"10\"></span><md-input-container \nclass=\"md-block\" flex=\"45\"><input type=\"text\" name=\"lastName\" ng-pattern=\"/^[a-zA-Z ]*$/\" \nng-model=\"currentUser.lastName\" placeholder=\"Last name\"><div ng-messages=\"userUpdateForm.lastName.$error\" role=\"alert\">\n<div ng-message=\"pattern\"><span>Last Name has invalid characters</span></div></div></md-input-container></div><div \nlayout=\"row\"><md-input-container flex=\"45\"><label>Select Authority</label><md-select name=\"Authority\" \nng-model=\"currentUser.authorities\" multiple=\"multiple\" required><md-option ng-value=\"authority\" \nng-repeat=\"authority in roles\">{{ authority.replace(\"ROLE_USER\",\"User\").replace(\"ROLE_ADMIN\",\"Admin\") }}</md-option>\n</md-select><div ng-messages=\"userUpdateForm.Authority.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nAuthority is required</span></div></div></md-input-container><span flex=\"10\"></span><md-switch \nng-model=\"currentUser.activated\" aria-label=\" Activate User\">Activate User</md-switch></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button ng-click=\"cancel()\">Cancel</md-button>\n<md-button type=\"submit\" ng-click=\"userUpdateForm.$valid && update(currentUser)\">Update</md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/administration/user-management/users/users.html","<style>\n.mh-0 {\r\n    min-height: 0px !important;\r\n}\r\n.parent-tabs > md-tabs .md-tab.md-active:after{\r\n    content: \" \";\r\n    border-left: 7px solid transparent;\r\n    border-right: 7px solid transparent;\r\n    border-bottom: 7px solid #efefef;\r\n    position: absolute;\r\n    display: block;\r\n    top: 87%;\r\n    left: 50%;\r\n   \r\n}\r\n.parent-tabs > md-tabs md-ink-bar {\r\n    background: none; \r\n}\r\n.parent-tabs > md-tabs .md-tab:hover {\r\n    color: #389cec !important;\r\n}\r\n.md-tab {\r\n  \r\n  text-transform: none;\r\n  }\r\n  .table-border {\r\n    border: 1px solid #d3d3d3 !important;\r\n}\r\n.table-header {\r\n    background-color: #dee7f4 !important;\r\n    text-transform: uppercase;\r\n    font-size: 11px!important;\r\n}\n</style><div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Users\" ui-sref=\"app.administration.users\" \nmd-active=\"true\"></md-tab><md-tab label=\"Groups\" ui-sref=\"app.administration.groups\"></md-tab></md-tabs></div><div \nclass=\"md-padding white-bg\"><table class=\"dataTable row-border hover table-border\" datatable=\"ng\" \ndt-options=\"userCtrl.dtOptions\"><thead><tr class=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">Login</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">First Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Last Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Email</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Authorities</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Activated</span></div></th><th class=\"secondary-text\"><div class=\"table-header\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr \nng-repeat=\"user in usersList | filter : searchUser\"><td>{{user.login}}</td><td>{{user.firstName}}</td><td>\n{{user.lastName}}</td><td>{{user.email}}</td><td><span class=\"text-boxed green-bg white-fg\" \nng-show=\"{{user.authorities.indexOf(\'ROLE_USER\') != -1}}\">User</span> <span class=\"text-boxed orange-bg white-fg\" \nng-show=\"{{user.authorities.indexOf(\'ROLE_ADMIN\') != -1}}\">Admin</span></td><td \nstyle=\"padding-top:0px !important;padding-bottom:0px !important\"><i class=\"icon-checkbox-marked-circle green-500-fg\" \nng-show=\"{{user.activated}}\"></i> <i class=\"icon-cancel red-500-fg\" ng-show=\"{{! user.activated}}\"></i></td><td \nlayout=\"row\" layout-align=\"center center\" style=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button \nclass=\"md-icon-button test-tooltip\" id=\"{{user.id}}\" aria-label=\"Update\" \nonclick=\"angular.element(this).scope().updateUserDialog(this)\"><md-tooltip md-direction=\"top\">Update</md-tooltip>\n<md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s18 deleteme\"></i></md-icon></md-button>\n<md-button class=\"md-icon-button test-tooltip\" id=\"{{user.id}}\" aria-label=\"Delete\" \nonclick=\"angular.element(this).scope().deleteUser(this)\"><md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon><i \nlayout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s18\"></i></md-icon></md-button><md-button \nclass=\"md-icon-button test-tooltip\" id=\"{{user.id}}\" aria-label=\"Reset Password\" \nonclick=\"angular.element(this).scope().resetPassword(this)\"><md-tooltip md-direction=\"top\">Reset Password</md-tooltip>\n<md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon-account-key s20\"></i></md-icon></md-button></td></tr>\n</tbody></table></div></ms-widget></div><md-button flow-btn class=\"md-fab grey-700-bg md-mini md-fab-bottom-right\" \naria-label=\"Create User\" ng-click=\"createUserDialog($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"top\">Create User</md-tooltip></md-button></div></div>");
$templateCache.put("app/main/pages/errors/404/error-404.html","<div id=\"error-404\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"md-display-3 md-padding\" translate=\"ERROR404.CODE\">coming soon</div><div \nclass=\"message md-padding\" translate=\"ERROR404.MESSAGE\">\nIt’s not quite ready yet, but we are working hard to make it available soon.</div><div \nclass=\"search md-whiteframe-1dp\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon s24\"></md-icon><input ng-model=\"vm.search\" type=\"text\" placeholder=\"Search for anything\" translate \ntranslate-attr-placeholder=\"ERROR404.SEARCH\" flex></div><md-button class=\"md-raised md-accent\" ng-click=\"goHome()\">\nGo back to home page</md-button></div></div>");
$templateCache.put("app/main/pages/errors/500/error-500.html","<div id=\"error-500\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"error-code\" translate=\"ERROR500.CODE\">500</div><div class=\"message\" \ntranslate=\"ERROR500.MESSAGE\">Well, you broke the internet!</div><div class=\"sub-message\" \ntranslate=\"ERROR500.SUBMESSAGE\">Just kidding, looks like we have an internal issue, please try again in couple minutes\n</div><a class=\"report-link md-accent-color\" href=\"/\" translate=\"ERROR500.REPORT\">Report this problem</a></div></div>");
$templateCache.put("app/main/sites/site/dashboard/site.dashboard.html","<div class=\"page-layout carded fullwidth\" layout=\"row\" data-ng-init=\"siteCtrl.getCurrentSitePage()\"><div flex=\"95\" \nclass=\"md-padding\"><md-toolbar layout=\"row\" \nstyle=\"background-color: rgb(193, 201, 199); height: 20px;border-top-right-radius: 8px;border-top-left-radius: 8px\">\n<div class=\"md-toolbar-tools\"><span>{{siteDashCtrl.title}}</span></div></md-toolbar><md-content class=\"md-padding\" \nflex ng-style=\"{\'border\': \'1px solid #cccccc\'}\" class=\"scrollable\" ms-scroll ng-bind-html=\"siteDashCtrl.siteHomeText\">\n</md-content></div></div>");
$templateCache.put("app/main/sites/site/dashboard/site.logo.html","<md-dialog aria-label=\"Add site icon\"><form name=\"siteForm\" novalidate ng-submit=\"siteCtrl.createSite(site)\" flex=\"66\">\n<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Select Site Logo</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content flex=\"66\" layout=\"column\" layout-align=\"center center\">\n<md-input-container class=\"md-block\" flex=\"33\"><label>Search an icon</label><input ng-model=\"searchText\">\n</md-input-container><md-radio-group ng-model=\"site.icon\" layout=\"row\" layout-align=\"center center\" layout-wrap \nflex=\"66\"><div ng-repeat=\"icon in icons | filter:{properties: {name:searchText}} | limitTo:noOfIconsForDisplay \">\n<md-radio-button value=\"icon-{{::icon.properties.name}}\" aria-label=\"icon-{{::icon.properties.name}}\"><i \nclass=\"icon icon-{{::icon.properties.name}} s40\"></i></md-radio-button></div></md-radio-group></md-dialog-content>\n<md-dialog-actions layout-align=\"center center\"><md-button ng-click=\"loadMoreIcons($event)\">Load more icons</md-button>\n<md-button ng-click=\" \">Upload</md-button><md-button ng-click=\"saveLogo(site.icon)\" class=\"md-accent md-raised\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sites/site/doclibraryForm/doclibraryForm.html","<div class=\"page-layout carded fullwidth scrollable\" layout=\"column\" flex ms-scroll md-dynamic-height><div \nclass=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" layout=\"row\"><ms-widget-front \nclass=\"white-bg\"><div layout=\"row\"><div ng-cloak flex=\"100\" class=\"scrollable\" ms-scroll><md-content><md-tabs \nmd-dynamic-height md-border-bottom><md-tab label=\"Main\"><md-content class=\"md-padding scrollable\" ms-scroll><div \nlayout=\"row\" layout-align=\"center center\"><div flex=\"70\"><form name=\"headerForm\" class=\"md-inline-form\" novalidate>\n<fieldset ng-disabled=\"true\" style=\"border: 1px solid #cccccc\"><div ng-bind-html=\"currentFormHeader\" compile-template>\n</div></fieldset></form></div></div></md-content></md-tab><md-tab label=\"Details\"><md-content class=\"md-padding\"><div \nlayout=\"row\" layout-align=\"center center\"><div flex=\"100\"><form name=\"lineitemForm\" novalidate><fieldset \nstyle=\"border: 1px solid #cccccc\" ng-disabled=\"true\"><div ng-bind-html=\"currentFormLineitem\" compile-template></div>\n</fieldset><div layout=\"row\" layout-align=\"center center\" class=\"md-padding\"><md-button class=\"md-raised\" \nng-click=\"docLibraryFormCtrl.gotoBack()\">Back</md-button></div></form></div></div></md-content></md-tab></md-tabs>\n</md-content></div></div></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/sites/site/discussionforum/create.thread.html","<div flex=\"30\"><md-dialog aria-label=\"Add a new user\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nAdd New Thread</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-input-container class=\"md-block\"><h3><label>Enter Threadname\n</label></h3><input class=\"md-title\" type=\"text\" ng-model=\"thread.Threadname\" required></md-input-container>\n<md-input-container class=\"md-block\"><h3><label>Enter Comment</label></h3><textarea rows=\"3\"></textarea>\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button \ntype=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"\">Save</md-button>\n</md-dialog-actions></md-dialog></div>");
$templateCache.put("app/main/sites/site/discussionforum/site.forum.html","<div layout=\"row\" flex=\"100\"><div flex=\"75\" layout=\"column\" ng-hide=\"commentsVisibility\"><md-content><md-list>\n<md-list-item class=\"md-3-line\" ng-repeat=\"thread in Threads | filter:searchCategory\"><img \nng-src=\"assets\\images\\avatars/Nora.jpg\" class=\"md-avatar\"><div class=\"md-list-item-text md-padding\" layout=\"column\" \nng-click=\"openthread(thread)\"><span class=\"md-body-2 md-primary-fg\">{{thread.Threadname}}</span><h3 \nclass=\"md-headline\"><span class=\"text-boxed orange-bg white-fg\" flex=\"5\">{{thread.Creator}} </span><span \nclass=\"text-boxed green-bg white-fg\" flex=\"5\">{{thread.Category}}</span></h3><p>Last Comment by {{thread.Creator}}</p>\n</div><span class=\"md-primary-fg md-hue-3 md-secondary md-subhead\"><md-icon md-font-icon=\"icon-comment-text-outline\" \nclass=\"md-accent-fg\" ng-style=\"{\'font-size\': \'32px\'}\"></md-icon><span>&nbsp;</span> {{thread.Comments.length}}\n<md-tooltip md-direction=\"top\">Comments</md-tooltip></span><md-divider md-inset ng-if=\"!$last\"></md-divider>\n</md-list-item></md-list></md-content></div><div flex=\"75\" ng-show=\"commentsVisibility\"><md-content><md-list>\n<md-list-item class=\"md-3-line\" ng-repeat=\" eachComment in selectedThread.Comments\"><img \nng-src=\"assets\\images\\avatars/Nora.jpg\" class=\"md-avatar\"><div class=\"md-list-item-text md-padding\" layout=\"column\">\n<span class=\"md-primary-fg md-body-2\">{{eachComment.Commenter}}</span><p>{{\'Commented On \' + eachComment.Commentedon}}\n</p><br><span>{{eachComment.Comment}}</span></div><md-divider md-inset ng-if=\"!$last\"></md-divider></md-list-item>\n</md-list></md-content><div align=\"center\"><div layout=\"row\" layout-align=\"center center\"><span class=\"md-title\">\nEnter comment </span><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"60\"><textarea rows=\"4\" \nng-model=\"userComment\" style=\"border: 1px solid; background-color: honeydew\" md-no-autogrow md-maxlength=\"200\">\n</textarea></md-input-container></div><md-button ng-click=\"null\" class=\"md-accent\">save</md-button><md-button \nng-click=\"commentsVisibility=false\" class=\"md-raised\">Go back</md-button></div></div><md-divider></md-divider><div \nflex=\"25\"><div layout=\"column\" layout-padding><md-input-container><label class=\"h3\">Search discussions here</label>\n<md-icon md-font-icon=\"icon-magnify\" class=\"s32\"></md-icon><input ng-model=\"user.name\" type=\"text\">\n</md-input-container><p class=\"md-headline text-bold border-bottom\">Categories</p><div align=\"center\" \nclass=\"md-border-bottom\" flex=\"10\"><span ng-repeat=\"thread in Threads\"><span \nclass=\"md-title {{siteForumCtrl.getAnotherColor($index)}}-fg md-padding\" ng-click=\"opencategory(thread.Category)\">\n#{{thread.Category}} </span><span>&nbsp;</span></span></div><span class=\"md-title md-primary\" \nng-click=\"opencategory(\'\')\" align=\"center\">#ALL</span></div></div><md-button flow-btn \nclass=\"md-fab md-accent md-fab-bottom-right\" ng-click=\"createThreadDialog($event)\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon><md-tooltip md-direction=\"top\">Add Thread</md-tooltip></md-button></div>");
$templateCache.put("app/main/sites/site/doclibrary/VersionFiledialog.html","<md-dialog><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Add new version : {{selectedFileName}}</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><form name=\"doclibrary\" novalidate layout=\"column\"><div layout=\"row\">\n<div flex=\"45\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>Upload File</b></span></div><span \nflex=\"10\"></span><div flex=\"45\" layout=\"column\" layout-align=\"center start\"><input class=\"ng-hide\" id=\"formUploadFile\" \nname=\"formUploadFile\" type=\"file\" onchange=\"angular.element(this).scope().setFile(this)\"><label for=\"formUploadFile\" \nclass=\"md-button md-raised md-accent\">Upload</label></div></div><div><div ng-repeat=\"file in files.slice(0)\" \nlayout=\"row\" layout-align=\"center center\"><span class=\"md-warn\">{{file.webkitRelativePath || file.name}}</span> (<span \nng-switch=\"file.size > 1024*1024\"> <span ng-switch-when=\"true\">{{file.size / 1024 / 1024 | number:2}} MB</span> <span \nng-switch-default>{{file.size / 1024 | number:2}} kB</span> </span>)</div></div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button \nng-click=\"NewVersionFile()\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sites/site/doclibrary/checkInFiledialog.html","<md-dialog><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nCheckIn {{checkInFile.type}} : {{checkInFile.name}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><form name=\"doclibrary\" \nnovalidate layout=\"column\"><div layout=\"row\"><div flex=\"45\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\">\n<b>Upload File</b></span></div><span flex=\"10\"></span><div flex=\"45\" layout=\"column\" layout-align=\"center start\"><input\n class=\"ng-hide\" id=\"formUploadFile\" name=\"formUploadFile\" type=\"file\" \nonchange=\"angular.element(this).scope().setFile(this)\"><label for=\"formUploadFile\" \nclass=\"md-button md-raised md-accent\">Upload</label></div></div><div><div ng-repeat=\"file in files.slice(0)\" \nlayout=\"row\" layout-align=\"center center\"><span class=\"md-warn\">{{file.webkitRelativePath || file.name}}</span> (<span \nng-switch=\"file.size > 1024*1024\"> <span ng-switch-when=\"true\">{{file.size / 1024 / 1024 | number:2}} MB</span> <span \nng-switch-default>{{file.size / 1024 | number:2}} kB</span> </span>)</div></div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button \nng-click=\"checkIn()\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sites/site/doclibrary/details-sidenav.html","<div flex=\"100\" layout=\"column\" ng-show=\"detailsVisibility\" class=\"scrollable\" ms-scroll><div layout=\"row\" \nlayout-align=\"center center\"><span class=\"md-title md-padding\">{{siteDocLibCtrl.selectedFileName}}</span></div><div \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button\" ng-click=\"UpdateFile($event)\" \nng-disabled=\"checkout\"><md-tooltip md-direction=\"top\">Edit</md-tooltip><md-icon md-font-icon=\"icon-pencil\" \nstyle=\"color:#ffc107 ! important\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-if=\"siteDocLibCtrl.receivedFile.type != \'folder\'\" ng-click=\"checkInFileDialog($event)\"><md-tooltip \nmd-direction=\"top\">Check in</md-tooltip><md-icon md-font-icon=\"icon-login\" style=\"color:#0e76e2 ! important\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-if=\"siteDocLibCtrl.receivedFile.type != \'folder\'\" \nng-click=\"fileCheckout()\"><md-tooltip md-direction=\"top\">Check out</md-tooltip><md-icon md-font-icon=\"icon-logout\" \nstyle=\"color:#ff8080 ! important\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-if=\"siteDocLibCtrl.receivedFile.type != \'folder\'\" ng-click=\"downloadFile()\" ng-disabled=\"checkout\"><md-tooltip \nmd-direction=\"top\">Download</md-tooltip><md-icon md-font-icon=\"icon-download\" style=\"color:#2ecc71 ! important\">\n</md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"siteDocLibCtrl.deleteFile(ev)\" \nng-disabled=\"checkout\"><md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon md-font-icon=\"icon-delete\" \nstyle=\"color:#ff6656 ! important\"></md-icon></md-button></div><div><md-content ng-cloak><md-tabs md-dynamic-height \nmd-center-tabs md-border-bottom><md-tab label=\"Details\"><div class=\"auto-height scrollable\" ms-scroll><md-content \nclass=\"md-padding scrollable\" ms-scroll><div align=\"right\"><md-button flow-btn class=\"md-icon-button\" \nng-click=\"enableEditor()\" ng-hide=\"editorEnabled\" ng-if=\"siteDocLibCtrl.receivedFile.type != \'folder\'\"><md-icon \nmd-font-icon=\"icon-pencil\" style=\"color:#ffc107! important\"></md-icon><md-tooltip md-direction=\"top\">Edit Attributes\n</md-tooltip></md-button><md-button flow-btn class=\"md-icon-button\" ng-click=\"saveAllAttributes()\" \nng-show=\"editorEnabled\" ng-if=\"siteDocLibCtrl.receivedFile.type != \'folder\'\"><md-icon md-font-icon=\"icon-content-save\" \nstyle=\"color:#FFD700 ! important\"></md-icon><md-tooltip md-direction=\"top\">Save Attributes</md-tooltip></md-button>\n<md-button flow-btn class=\"md-icon-button\" ng-click=\"siteDocLibCtrl.sharedUsersDialog($event)\" \nng-if=\"siteDocLibCtrl.receivedFile.type != \'folder\'\"><md-icon md-font-icon=\"icon-account-plus\" \nstyle=\"color:#7fba00 ! important\"></md-icon><md-tooltip md-direction=\"top\">Share {{siteDocLibCtrl.selectedFileName}}\n</md-tooltip></md-button><md-button flow-btn class=\"md-icon-button\" ng-click=\"\" \nng-if=\"siteDocLibCtrl.receivedFile.type != \'folder\'\"><md-icon md-font-icon=\"icon-star\" \nstyle=\"color:#FFD700 ! important\"></md-icon><md-tooltip md-direction=\"top\">Add To Favorites</md-tooltip></md-button>\n</div><table class=\"detailsTable1\"><tr ng-repeat=\"attribute in siteDocLibCtrl.fileAttributes\" ng-hide=\"editorEnabled\" \nng-click=\"enableEditor()\"><th align=\"left\">{{attribute.name.charAt(0).toUpperCase()+ attribute.name.slice(1)}}</th><td>\n{{attribute.value}}</td></tr><tr ng-repeat=\"attribute in siteDocLibCtrl.fileAttributes\" ng-show=\"editorEnabled\"><td>\n<md-input-container style=\"padding-top: 0px !important; padding-bottom: 0px !important;margin:-18px 0 !important\">\n<input type=\"text\" name=\"name\" ng-model=\"attribute.name\"></md-input-container></td><td><md-input-container \nstyle=\"padding-top: 0px !important; padding-bottom: 0px !important;margin:-18px 0 !important\"><input type=\"text\" \nname=\"name\" ng-model=\"attribute.value\"></md-input-container></td></tr></table><div layout=\"row\" \nlayout-align=\"center center\"><div ng-repeat=\"user in siteDocLibCtrl.allSharedUsers\" style=\"padding-left: 2%\"><md-button\n flow-btn class=\"md-icon-button md-fab md-mini grey-700-bg\" ng-click=\"\">{{user.firstName.slice(0,1).toUpperCase()}}\n<md-tooltip md-direction=\"top\">{{user.firstName +\" \"+ user.lastName}}</md-tooltip></md-button></div></div></md-content>\n</div><div class=\"md-padding\" layout=\"row\" layout-align=\"center center\" ng-show=\"buttonVisibility\"><md-button \nclass=\"md-raised\" ng-click=\"buildForm(file.id)\">DISPLAY</md-button></div><div class=\"md-padding\" layout=\"row\" \nlayout-align=\"center center\" ng-show=\"filebuttonVisibility\"><md-button class=\"md-raised\" \nng-click=\"previewFile($event)\">DISPLAY</md-button></div><md-divider ng-show=\"versionsVisibility\"></md-divider><div \nlayout=\"row\" layout-align=\"center center\" class=\"md-padding\" ng-show=\"versionsVisibility\"><span class=\"md-body-2\">\nVERSIONS</span></div><md-divider ng-show=\"versionsVisibility\"></md-divider><div class=\"auto-height scrollable\" \nms-scroll><md-content><md-list><md-list-item class=\"md-2-line\" ng-repeat=\"version in file.versions\" ng-click=\"null\">\n<div class=\"md-list-item-text\" layout=\"row\" layout-align=\"start start\"><div><h3><strong>Version {{version.versionNo}} \n</strong>created by<br><strong>{{version.createdBy}}</strong></h3><p>Date : {{version.createdDate.substr(0,10)}}</p>\n</div><div><md-button class=\"md-secondary md-icon-button\" ng-click=\"downloadVersionedFile(file.id,version.versionNo)\">\n<md-tooltip md-direction=\"top\">Download</md-tooltip><md-icon><i class=\"icon icon-download\"></i></md-icon></md-button>\n</div></div><md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list><div layout=\"row\" \nlayout-align=\"start center\" ng-show=\"versionsVisibility\" class=\"md-padding\"><md-button class=\"md-icon-button\" \nng-hide=\"file.type==\'folder\'\" ng-click=\"VersionFileDialog($event,file)\" ng-disabled=\"checkout\"><md-tooltip \nmd-direction=\"top\">Add new version</md-tooltip><md-icon md-font-icon=\"icon-library-plus\"></md-icon></md-button></div>\n</md-content></div></md-tab><md-tab label=\"ACTIVITY\"><div class=\"auto-height-activity scrollable\" ms-scroll>\n<md-content><md-list><md-list-item class=\"md-2-line\" ng-repeat=\"activity in file.activities | orderBy:\'-\' \" \nng-click=\"null\"><img ng-src=\"assets\\images\\avatars/Nora.jpg\" class=\"md-avatar\"><div class=\"md-list-item-text\" \nlayout=\"column\"><span><b><strong>{{activity.description}}</strong></b> by <strong>{{activity.userId}}</strong></span>\n<p>Date :{{activity.postedAt.substr(0,10)}}</p></div><md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list>\n</md-content></div></md-tab></md-tabs></md-content></div></div>");
$templateCache.put("app/main/sites/site/doclibrary/editFiledialog.html","<md-dialog><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nEdit {{currentFile.type}} : {{currentFile.name}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><form name=\"doclibrary\" \nnovalidate layout=\"column\"><div layout=\"row\"><div flex=\"45\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\">\n<b>Rename</b></span></div><span flex=\"10\"></span><div flex=\"45\" layout=\"column\" layout-align=\"center start\">\n<md-input-container flex=\"45\" class=\"md-block\" layout=\"column\" layout-align=\"space-around start\"><input type=\"text\" \nname=\"editname\" ng-model=\"currentFile.name\"></md-input-container></div></div><div layout=\"row\"><div flex=\"45\" \nlayout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>Move to folder</b></span></div><span flex=\"10\"></span>\n<md-input-container flex=\"45\" class=\"md-block\" layout=\"column\" layout-align=\"space-around start\"><input type=\"text\" \nname=\"name\" ng-model=\"currentFile.id\"></md-input-container></div></form></md-dialog-content><md-dialog-actions \nlayout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button \nng-click=\"updateFile(currentFile)\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sites/site/doclibrary/fileDetails.html","<style>\ntable {\r\n    border-collapse: collapse;\r\n    width: 100%;\r\n}\r\n\r\nth, td {\r\n    text-align: left;\r\n    padding: 8px;\r\n}\r\n\r\ntr:nth-child(even){background-color: #f2f2f2}\n</style><md-dialog flex=\"50\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>File Details</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><form name=\"doclibrary\" novalidate layout=\"column\"><md-tabs \nmd-border-bottom><md-tab label=\"Details\"><md-content class=\"md-padding\"><table><tr><th>Name</th><th>Details</th></tr>\n<tr ng-repeat=\"(key,value) in currentFile.attributes\"><td>{{key}}</td><td>{{value}}</td></tr></table></md-content>\n</md-tab><md-tab label=\"Activity Feed\"><md-content class=\"md-padding\"><md-list><md-list-item class=\"md-2-line\" \nng-repeat=\"activity in currentFile.activities | orderBy:\'-\' \" ng-click=\"null\"><img \nng-src=\"assets\\images\\avatars/Nora.jpg\" class=\"md-avatar\"><div class=\"md-list-item-text\" layout=\"column\"><span><b>\n<strong>{{activity.description}}</strong></b> by <strong>{{activity.userId}}</strong></span><p>\nDate :{{activity.postedAt.substr(0,10)}}</p></div><md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list>\n</md-content></md-tab><md-tab label=\"Versions\"><md-content class=\"md-padding\"><md-list><md-list-item class=\"md-2-line\" \nng-repeat=\"version in currentFile.versions\" ng-click=\"null\"><md-button flow-btn class=\"md-icon-button\"><md-icon \nmd-font-icon=\"{{selectedFileIcon}}\" class=\"icon\"></md-icon></md-button><span flex=\"5\"></span><div \nclass=\"md-list-item-text\" layout=\"row\" layout-align=\"start start\"><div><h3><strong>Version {{version.versionNo}} \n</strong>created by <strong>{{version.createdBy}}</strong></h3><p>Date : {{version.createdDate.substr(0,10)}}</p></div>\n<div></div></div><md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list></md-content></md-tab><md-tab \nlabel=\"permissions\"><md-content class=\"md-padding\"></md-content></md-tab></md-tabs></form></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/sites/site/doclibrary/fileDetailsDialog.html","<md-dialog><form name=\"fileDetailsForm\" novalidate ng-submit=\"fileDetailsForm.$valid && update(selectedFile)\" \nlayout=\"column\" flex=\"66\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nDetails : {{selectedFileName}}</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content layout=\"column\" class=\"scrollable\" ms-scroll><div layout=\"column\" \nflex=\"45\"><md-input-container class=\"md-block\" ng-repeat=\"fileAttribute in fileAttributes\"><input type=\"text\" \nname=\"fileName\" ng-model=\"fileAttribute.attributeValue\" placeholder=\"{{fileAttribute.attributeName}}\" required>\n</md-input-container><span flex=\"10\"></span></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"center center\"><md-button ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"updateFileAttributes()\">Update</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sites/site/doclibrary/folderSettingDialog.html","<md-dialog flex=\"30\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Folder Settings</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" layout-align=\"start center\"><md-checkbox \nng-model=\"folder.foldersOnly\" aria-label=\"folder\">Allow only Folders</md-checkbox></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button \nng-click=\"FolderUpdate(folder)\">Ok</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sites/site/doclibrary/managePermissionsDialog.html","<md-dialog aria-label=\"Add a new doctype\" flex=\"80\" ng-init=\"getPermission()\"><form name=\"docType\" layout=\"column\">\n<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Manage Permissions: {{selectedFileName}}</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><div ng-switch=\"(allUsers).length\" \nng-style=\"{\'border\': \'1px solid #cccccc\'}\"><div ng-switch-when=\"0\" layout=\"row\" layout-align=\"center center\"><p \nclass=\"md-padding md-subhead md-primary-fg\">{{\'No data yet...\' | uppercase}}</p></div><div ng-switch-default \nng-style=\"{\'height\':\'190px\', \'overflow\': \'auto\'}\"><table class=\"simple list-view\"><thead><tr><th>NAME</th><th>View</th>\n<th>Edit</th><th>Permission</th><th>Delete</th><th>Download</th><th></th></tr></thead><tbody><tr \nng-repeat=\"user in allUsersForPermission\"><td data-ng-if=\"user.type == \'Group\'\"><i class=\"fa fa-users\" \naria-hidden=\"true\"></i> {{user.firstName}}</td><td data-ng-if=\"user.type == \'User\'\"><i class=\"fa fa-user\" \naria-hidden=\"true\"></i> {{user.firstName}} {{user.lastName}}</td><td data-ng-if=\"user.type == \'SiteAdmin\'\"><i \nclass=\"fa fa-user-circle-o\" aria-hidden=\"true\"></i> {{sitedisplayname}}Admin</td><td data-ng-if=\"user.type == \'Owner\'\">\n<i class=\"fa fa-user-circle\" aria-hidden=\"true\"></i> Owner</td><td><i class=\"icon-checkbox-marked-circle green-500-fg\" \nng-show=\"{{user.permissions.indexOf(\'View\')!==-1}}\"></i> <i class=\"icon-cancel red-500-fg\" \nng-show=\"{{ user.permissions.indexOf(\'View\')==-1}}\"></i></td><td><i class=\"icon-checkbox-marked-circle green-500-fg\" \nng-show=\"{{user.permissions.indexOf(\'Edit\')!==-1}}\"></i> <i class=\"icon-cancel red-500-fg\" \nng-show=\"{{ user.permissions.indexOf(\'Edit\')==-1}}\"></i></td><td><i class=\"icon-checkbox-marked-circle green-500-fg\" \nng-show=\"{{user.permissions.indexOf(\'Permission\')!==-1}}\"></i> <i class=\"icon-cancel red-500-fg\" \nng-show=\"{{ user.permissions.indexOf(\'Permission\')==-1}}\"></i></td><td><i \nclass=\"icon-checkbox-marked-circle green-500-fg\" ng-show=\"{{user.permissions.indexOf(\'Delete\')!==-1}}\"></i> <i \nclass=\"icon-cancel red-500-fg\" ng-show=\"{{ user.permissions.indexOf(\'Delete\')==-1}}\"></i></td><td><i \nclass=\"icon-checkbox-marked-circle green-500-fg\" ng-show=\"{{user.permissions.indexOf(\'Download\')!==-1}}\"></i> <i \nclass=\"icon-cancel red-500-fg\" ng-show=\"{{ user.permissions.indexOf(\'Download\')==-1}}\"></i></td><td class=\"no-padding\">\n<md-button data-ng-hide=\"user.type == \'SiteAdmin\' || user.type == \'Owner\'\" class=\"md-secondary md-icon-button\" \nng-click=\"removePermission(user)\"><md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon><i \nclass=\"icon icon-delete s20\"></i></md-icon></md-button></td></tr></tbody></table></div></div><div layout=\"row\" \nlayout-align=\"start center\" class=\"md-padding\"><md-checkbox ng-model=\"filePermissionType\" aria-label=\"inherit\">\nSet Inherited</md-checkbox></div><div class=\"scrollable\" ms-scroll><div layout=\"row\" class=\"pl-0\"><md-radio-group \nng-model=\"searchElements.type\" style=\"display: -webkit-inline-box\" \nng-change=\"onChangePermissionType(searchElements.type)\" ng-disabled=\"\"><md-radio-button class=\"pr-15\" value=\"User\" \nng-disabled=\"filePermissionType\">User</md-radio-button><md-radio-button class=\"pr-15\" value=\"Group\" \nng-disabled=\"filePermissionType\">Group</md-radio-button><md-radio-button class=\"pr-15\" value=\"Owner\" \nng-disabled=\"filePermissionType\">Owner</md-radio-button><md-radio-button value=\"SiteAdmin\" \nng-disabled=\"filePermissionType\">{{sitedisplayname}}Admin</md-radio-button></md-radio-group></div><div layout=\"row\" \ndata-ng-if=\"searchElements.type ==\'User\' || searchElements.type ==\'Group\'\"><md-input-container \nclass=\"no-padding no-margin\" flex=\"40\"><input type=\"text\" name=\"name\" ng-model=\"searchElements.text\" \nplaceholder=\"Search Here\" ng-disabled=\"filePermissionType\"></md-input-container><md-button class=\"md-raised\" \nng-disabled=\"searchElements.text == undefined\" ng-click=\"searchUsersForManagePermission(searchElements)\" \nstyle=\"height: 35px;top: -11px\">Search</md-button></div></div><div><table class=\"simple\" \nng-show=\"searchElements.type ==\'Owner\'|| searchElements.type ==\'SiteAdmin\'\"><thead><tr><th \nclass=\"secondary-text md-padding\"><span class=\"column-title\">NAME</span></th><th class=\"secondary-text md-padding\">View\n</th><th class=\"secondary-text md-padding\">Edit</th><th class=\"secondary-text md-padding\">Permission</th><th \nclass=\"secondary-text md-padding\">Delete</th><th class=\"secondary-text md-padding\">Download</th><th></th></tr></thead>\n<tbody><tr><td class=\"no-padding\" data-ng-if=\"searchElements.type ==\'Owner\'\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important\">Owner</td><td class=\"no-padding\" \ndata-ng-if=\"searchElements.type ==\'SiteAdmin\'\" style=\"padding-left: 10px !important;padding-right: 10px !important\">\nSiteAdmin</td><td class=\"no-padding\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important;padding-top: 12px !important\"><md-checkbox \nvalue=\"view\" ng-model=\"ownerStatus.View\"></md-checkbox></td><td class=\"no-padding\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important;padding-top: 12px !important\"><md-checkbox \nvalue=\"edit\" ng-model=\"ownerStatus.Edit\"></md-checkbox></td><td class=\"no-padding\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important;padding-top: 12px !important\"><md-checkbox \nvalue=\"permission\" ng-model=\"ownerStatus.Permission\"></md-checkbox></td><td class=\"no-padding\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important;padding-top: 12px !important\"><md-checkbox \nvalue=\"delete\" ng-model=\"ownerStatus.Delete\"></md-checkbox></td><td class=\"no-padding\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important;padding-top: 12px !important\"><md-checkbox \nvalue=\"download\" ng-model=\"ownerStatus.Download\"></md-checkbox></td><td class=\"no-padding\"><md-button \nclass=\"md-accent md-raised md-mini\" ng-click=\"addUserForManagePermission(null, ownerStatus, searchElements.type)\">ADD\n</md-button></td></tr></tbody></table></div><div class=\"scrollable md-padding pt-0\" ms-scroll \ndata-ng-if=\"searchElements.type ==\'User\' || searchElements.type ==\'Group\'\"><table class=\"simple\" \nng-show=\"searchedUsers.data.length > 0\"><thead><tr><th class=\"secondary-text md-padding\"><span class=\"column-title\">\nNAME</span></th><th class=\"secondary-text md-padding\" data-ng-if=\"searchedUsers.type == \'User\'\"><span \nclass=\"column-title\">EMAIL</span></th><th class=\"secondary-text md-padding\">View</th><th \nclass=\"secondary-text md-padding\">Edit</th><th class=\"secondary-text md-padding\">Permission</th><th \nclass=\"secondary-text md-padding\">Delete</th><th class=\"secondary-text md-padding\">Download</th><th></th></tr></thead>\n<tbody><tr data-ng-repeat=\"(key,value) in searchedUsers.data track by $index\" ng-init=\"status = {}\"><td \nclass=\"no-padding\" data-ng-if=\"searchedUsers.type == \'User\'\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important\">{{value.firstName}} {{value.lastName}}</td><td \nclass=\"no-padding\" data-ng-if=\"searchedUsers.type == \'User\'\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important\">{{value.email}}</td><td class=\"no-padding\" \ndata-ng-if=\"searchedUsers.type == \'Group\'\" style=\"padding-left: 10px !important;padding-right: 10px !important\">\n{{value.name}}</td><td class=\"no-padding\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important;padding-top: 12px !important\"><md-checkbox \nvalue=\"view\" ng-model=\"status.View\"></md-checkbox></td><td class=\"no-padding\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important;padding-top: 12px !important\"><md-checkbox \nvalue=\"edit\" ng-model=\"status.Edit\"></md-checkbox></td><td class=\"no-padding\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important;padding-top: 12px !important\"><md-checkbox \nvalue=\"permission\" ng-model=\"status.Permission\"></md-checkbox></td><td class=\"no-padding\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important;padding-top: 12px !important\"><md-checkbox \nvalue=\"delete\" ng-model=\"status.Delete\"></md-checkbox></td><td class=\"no-padding\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important;padding-top: 12px !important\"><md-checkbox \nvalue=\"download\" ng-model=\"status.Download\"></md-checkbox></td><td class=\"no-padding\"><md-button \nclass=\"md-accent md-raised md-mini\" ng-click=\"addUserForManagePermission(value, status, searchedUsers.type) \">ADD\n</md-button></td></tr></tbody></table></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button type=\"button\" \nng-click=\"saveUserManagePermission()\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sites/site/doclibrary/previewFiles.html","<md-dialog style=\"height: 100%; width: 100%\"><md-dialog-content class=\"no-padding\"><iframe id=\"iframe\" \nsrc=\"{{fileURL}}\" name=\"contentframe\" frameborder=\"0\" \nstyle=\"width: 100%; height: 100%; position: absolute; z-index: 999\"></iframe></md-dialog-content></md-dialog>");
$templateCache.put("app/main/sites/site/doclibrary/sharedUsersDialog.html","<md-dialog ng-cloak flex=\"80\" ng-init=\"getPermission()\"><md-toolbar layout=\"row\" class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><span>Sharing : {{selectedFileName}}</span> <span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content layout=\"column\" layout-align=\"center center\"><div fill-width>\n<md-content flex ng-style=\"{\'border\': \'1px solid #cccccc\'}\" class=\"scrollable\" ms-scroll layout=\"row\" layout-wrap><div \nng-switch=\"(allSharedUsers).length\"><div ng-switch-when=\"0\" layout=\"row\" layout-align=\"center center\"><p \nclass=\"md-padding md-subhead md-primary-fg\">{{\'Not shared yet...\' | uppercase}}</p></div><div ng-switch-default \nng-style=\"{\'height\':\'190px\'}\"><table class=\"simple list-view\"><thead><tr><th>NAME</th><th>View</th><th>Edit</th><th>\nShare</th><th>Delete</th><th>Download</th><th>End Date</th><th></th></tr></thead><tbody><tr \nng-repeat=\"user in allSharedUsers\"><td data-ng-if=\"user.groupName != null\"><i class=\"fa fa-users\" aria-hidden=\"true\">\n</i> {{user.groupName}}</td><td data-ng-if=\"user.groupName == null\"><i class=\"fa fa-user\" aria-hidden=\"true\"></i>\n {{user.firstName}} {{user.lastName}}</td><td><i class=\"icon-checkbox-marked-circle green-500-fg\" \nng-show=\"{{user.permissions.indexOf(\'view\')!==-1}}\"></i> <i class=\"icon-cancel red-500-fg\" \nng-show=\"{{ user.permissions.indexOf(\'view\')==-1}}\"></i></td><td><i class=\"icon-checkbox-marked-circle green-500-fg\" \nng-show=\"{{user.permissions.indexOf(\'edit\')!==-1}}\"></i> <i class=\"icon-cancel red-500-fg\" \nng-show=\"{{ user.permissions.indexOf(\'edit\')==-1}}\"></i></td><td><i class=\"icon-checkbox-marked-circle green-500-fg\" \nng-show=\"{{user.permissions.indexOf(\'share\')!==-1}}\"></i> <i class=\"icon-cancel red-500-fg\" \nng-show=\"{{ user.permissions.indexOf(\'share\')==-1}}\"></i></td><td><i class=\"icon-checkbox-marked-circle green-500-fg\" \nng-show=\"{{user.permissions.indexOf(\'delete\')!==-1}}\"></i> <i class=\"icon-cancel red-500-fg\" \nng-show=\"{{ user.permissions.indexOf(\'delete\')==-1}}\"></i></td><td><i class=\"icon-checkbox-marked-circle green-500-fg\" \nng-show=\"{{user.permissions.indexOf(\'download\')!==-1}}\"></i> <i class=\"icon-cancel red-500-fg\" \nng-show=\"{{ user.permissions.indexOf(\'download\')==-1}}\"></i></td><td>{{user.expirydate.substr(0,10)}}</td><td \nclass=\"no-padding\"><md-button class=\"md-secondary md-icon-button\" ng-click=\"removeSharing(user.id)\"><md-tooltip \nmd-direction=\"top\">Delete</md-tooltip><md-icon><i class=\"icon icon-delete s20\"></i></md-icon></md-button></td></tr>\n</tbody></table></div></div></md-content><div class=\"scrollable md-padding\" ms-scroll><div layout=\"row\" \nclass=\"md-padding pl-0\"><md-radio-group ng-model=\"searchElements.type\" style=\"display: -webkit-inline-box\">\n<md-radio-button class=\"pr-15\" value=\"user\">User</md-radio-button><md-radio-button value=\"group\">Group\n</md-radio-button></md-radio-group></div><div layout=\"row\"><md-input-container class=\"no-padding no-margin\" flex=\"40\">\n<input type=\"text\" name=\"name\" ng-model=\"searchElements.text\" placeholder=\"Search User\" required></md-input-container>\n<md-button class=\"md-raised\" ng-disabled=\"searchElements.text == undefined\" ng-click=\"searchUsers(searchElements)\" \nstyle=\"height: 35px;top: -11px\">Search</md-button></div></div><div class=\"scrollable md-padding pt-0\" ms-scroll><table \nclass=\"simple\" ng-show=\"searchedUsers.data.length > 0\" flex=\"45\"><thead><tr><th class=\"secondary-text md-padding\"><span\n class=\"column-title\">NAME</span></th><th class=\"secondary-text md-padding\" data-ng-if=\"searchedUsers.type == \'user\'\">\n<span class=\"column-title\">EMAIL</span></th><th class=\"secondary-text md-padding\">View</th><th \nclass=\"secondary-text md-padding\">Edit</th><th class=\"secondary-text md-padding\">Share</th><th \nclass=\"secondary-text md-padding\">Delete</th><th class=\"secondary-text md-padding\">Download</th><th \nclass=\"secondary-text md-padding\">End Date</th><th></th></tr></thead><tbody><tr \ndata-ng-repeat=\"(key,value) in searchedUsers.data track by $index\"><td class=\"no-padding\" \ndata-ng-if=\"searchedUsers.type == \'user\'\" style=\"padding-left: 10px !important;padding-right: 10px !important\">\n{{value.firstName}} {{value.lastName}}</td><td class=\"no-padding\" data-ng-if=\"searchedUsers.type == \'user\'\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important\">{{value.email}}</td><td class=\"no-padding\" \ndata-ng-if=\"searchedUsers.type == \'group\'\" style=\"padding-left: 10px !important;padding-right: 10px !important\">\n{{value.name}}</td><td class=\"no-padding\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important;padding-top: 12px !important\"><md-checkbox \nvalue=\"view\" ng-model=\"status.view\"></md-checkbox></td><td class=\"no-padding\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important;padding-top: 12px !important\"><md-checkbox \nvalue=\"edit\" ng-model=\"status.edit\"></md-checkbox></td><td class=\"no-padding\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important;padding-top: 12px !important\"><md-checkbox \nvalue=\"share\" ng-model=\"status.share\"></md-checkbox></td><td class=\"no-padding\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important;padding-top: 12px !important\"><md-checkbox \nvalue=\"delete\" ng-model=\"status.delete\"></md-checkbox></td><td class=\"no-padding\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important;padding-top: 12px !important\"><md-checkbox \nvalue=\"download\" ng-model=\"status.download\"></md-checkbox></td><td class=\"no-padding\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important\"><md-datepicker ng-model=\"myDate\" \nmd-placeholder=\"Expiry Date\"></md-datepicker></td><td class=\"no-padding\"><md-button \nclass=\"md-accent md-raised md-mini\" ng-click=\"shareFile(value, status, myDate, searchedUsers.type) \">ADD</md-button>\n</td></tr></tbody></table></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nng-click=\"cancel(member)\">Cancel</md-button><md-button ng-click=\"updateFileSharing()\" md-autofocus>Ok</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sites/site/doclibrary/site.doclibrary.html","<style>\n.selected {\r\n        background-color: rgb(232, 233, 237) !important;\r\n          \r\n    }\r\n    .uf {\r\n    background-color: #fb8c00 !important;\r\n    }\n</style><div id=\"docLibrary\" class=\"page-layout simple right-sidenav\" layout=\"row\"><md-button flow-btn \nclass=\"md-fab md-mini grey-700-bg md-fab-bottom-right uf add_btn\" aria-label=\"Add Note\" ng-click=\"createFile($event)\" \nng-init=\"siteDocLibCtrl.getFiles()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">\nUpload File</md-tooltip></md-button><div flex=\"80\"><div layout=\"row\" ng-show=\"filePathVisibility\" class=\"c-p\"><span \nng-repeat=\"folder in filePath track by $index\" class=\"md-subhead\"><a ng-click=\"siteDocLibCtrl.gotoFolder(folder)\" \nstyle=\"border: none;color: black !important;padding:3px;font-size: 14px\">{{folder.name}}</a><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></span></div><table class=\"simple list-view\"><thead><tr><th></th><th><a \nhref=\"#\" ng-click=\"orderByField=\'name\'; reverseSort = !reverseSort\" style=\"color: #626262 !important\">Name<span \nng-show=\"orderByField == \'name\'\"><span ng-show=\"!reverseSort\"><md-icon md-font-icon=\"icon-keyboard-up\" class=\"icon\">\n</md-icon></span><span ng-show=\"reverseSort\"><md-icon md-font-icon=\"icon-keyboard-down\" class=\"icon\"></md-icon></span>\n</span></a></th><th hide-xs><a href=\"#\" ng-click=\"orderByField=\'createdBy\'; reverseSort = !reverseSort\" \nstyle=\"color: #626262 !important\">Owner<span ng-show=\"orderByField == \'createdBy\'\"><span ng-show=\"!reverseSort\">\n<md-icon md-font-icon=\"icon-keyboard-up\" class=\"icon\"></md-icon></span><span ng-show=\"reverseSort\"><md-icon \nmd-font-icon=\"icon-keyboard-down\" class=\"icon\"></md-icon></span></span></a></th><th hide-xs><a href=\"#\" \nng-click=\"orderByField=\'size\'; reverseSort = !reverseSort\" style=\"color: #626262 !important\">Size<span \nng-show=\"orderByField == \'size\'\"><span ng-show=\"!reverseSort\"><md-icon md-font-icon=\"icon-keyboard-up\" class=\"icon\">\n</md-icon></span><span ng-show=\"reverseSort\"><md-icon md-font-icon=\"icon-keyboard-down\" class=\"icon\"></md-icon></span>\n</span></a></th><th hide show-gt-md><a href=\"#\" ng-click=\"orderByField=\'lastModifiedDate\'; reverseSort = !reverseSort\" \nstyle=\"color: #626262 !important\">Last Modified<span ng-show=\"orderByField == \'lastModifiedDate\'\"><span \nng-show=\"!reverseSort\"><md-icon md-font-icon=\"icon-keyboard-up\" class=\"icon\"></md-icon></span><span \nng-show=\"reverseSort\"><md-icon md-font-icon=\"icon-keyboard-down\" class=\"icon\"></md-icon></span></span></a></th></tr>\n</thead><tbody><tr class=\"c-p\" \nng-repeat=\"file in siteDocLibCtrl.files | filter:global.search | orderBy:orderByField:reverseSort\" \nng-click=\"siteDocLibCtrl.selectFile(file, $index)\" ng-dblclick=\"siteDocLibCtrl.doubleClick(file)\" \nng-class=\"{\'selected\':$index == selectedRow}\"><td class=\"file-icon\"><md-icon \nmd-font-icon=\"{{siteDocLibCtrl.fileIcon(file)}}\" class=\"icon\"></md-icon></td><td class=\"name\">{{file.name}}</td><td \nclass=\"owner\" hide-xs>{{file.createdBy}}</td><td class=\"size\" hide-xs><span ng-show=\"file.size == \'\'\">-</span><span \nng-switch=\"file.size > 1024*1024\" ng-hide=\"file.type ==\'folder\'\"><span ng-switch-when=\"true\">\n{{file.size / 1024 / 1024 | number:2}} MB</span> <span ng-switch-default>{{file.size / 1024 | number:2}} kB</span>\n</span></td><td><span>{{file.lastModifiedDate.substr(0,10)}}</span></td></tr></tbody></table><div \nng-show=\"siteDocLibCtrl.numberOfElements == 0\" class=\"md-padding\"><span layout=\"row\" layout-align=\"center center\"><h2>\nNo files</h2></span></div><md-divider></md-divider><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"md-padding\"><h5>\nShowing {{(siteDocLibCtrl.pageNumber*siteDocLibCtrl.pageSize)+1}} - {{(siteDocLibCtrl.pageNumber*siteDocLibCtrl.pageSize)+siteDocLibCtrl.pageSize}} of {{siteDocLibCtrl.numberOfElements}} Results\n</h5></div><div layout=\"row\" layout-align=\"center center\">Page No<md-input-container class=\"md-block md-padding\" \nstyle=\"margin: 0px\"><md-select ng-model=\"pageNumber\"><md-option ng-repeat=\"pageNumber in pageNumbers\" \nng-value=\"pageNumber\" ng-click=\"sendPageNumber(pageNumber)\" value=\"siteDocLibCtrl.pageNumber\">{{pageNumber+1}}\n</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"center center\"><div><md-button \ntype=\"button\" ng-click=\"siteDocLibCtrl.previous()\" ng-disabled=\"siteDocLibCtrl.pageNumber <= 0 \">Prev</md-button></div>\n<p class=\"md-padding\">{{siteDocLibCtrl.pageNumber+1}}/{{fileResults.totalPages}} &nbsp;PAGES</p><div \nclass=\"md-padding\"><md-button type=\"button\" ng-click=\"siteDocLibCtrl.next()\" \nng-disabled=\"siteDocLibCtrl.pageNumber == pageNumbers.length-1 || siteDocLibCtrl.numberOfElements == 0\">Next\n</md-button></div></div></div></div><md-divider></md-divider><div flex=\"20\" ng-hide=\"detailsVisibility\" \nlayout=\"column\"><md-tabs md-dynamic-height md-center-tabs md-border-bottom md-active><md-tab label=\"Details\">\n<md-content class=\"md-padding\"><div layout=\"column\" layout-align=\"center center\"><svg width=\"107px\" height=\"82px\" \nviewBox=\"0 0 107 82\" focusable=\"false\"><path class=\"a-s-fa-Ha-pa drive\" fill=\"#B8B8B8\" \nd=\"M0,4a4,4,0,0,1,4,-4h89a4,4,0,0,1,4,4v18.5l-23.5,40.5h-69.5a4,4,0,0,1,-4,-4ZM74.5,65l23,-39.15l1,0l7,4.1l1,1l-23,39.15ZM74,65.8l9.5,5.5l-9,4ZM97,51v8a4,4,0,0,1,-4,4h-3ZM21,63v19l23,-19Z\">\n</path></svg><p class=\"md-primary md-hue-3\">Select a file or folder to view its details.</p></div></md-content>\n</md-tab><md-tab label=\"Activity\"><md-content class=\"md-padding\"><div layout=\"column\" layout-align=\"center center\"><svg\n width=\"107px\" height=\"82px\" viewBox=\"0 0 107 82\" focusable=\"false\"><path class=\"a-s-fa-Ha-pa drive\" fill=\"#B8B8B8\" \nd=\"M0,4a4,4,0,0,1,4,-4h89a4,4,0,0,1,4,4v18.5l-23.5,40.5h-69.5a4,4,0,0,1,-4,-4ZM74.5,65l23,-39.15l1,0l7,4.1l1,1l-23,39.15ZM74,65.8l9.5,5.5l-9,4ZM97,51v8a4,4,0,0,1,-4,4h-3ZM21,63v19l23,-19Z\">\n</path></svg><p class=\"md-primary md-hue-3\">Select a file or folder to view its details.</p></div></md-content>\n</md-tab></md-tabs></div><div flex=\"20\" layout=\"column\" ng-show=\"detailsVisibility\" class=\"scrollable\" ms-scroll><div \nlayout=\"row\" layout-align=\"center center\"><span class=\"md-title md-padding\">{{siteDocLibCtrl.selectedFileName}}</span>\n</div><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button\" ng-click=\"UpdateFile($event)\" \nng-disabled=\"checkout\"><md-tooltip md-direction=\"top\">Edit</md-tooltip><md-icon md-font-icon=\"icon-pencil\" \nstyle=\"color:#ffc107 ! important\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-if=\"siteDocLibCtrl.receivedFile.type != \'folder\'\" ng-click=\"checkInFileDialog($event)\"><md-tooltip \nmd-direction=\"top\">Check in</md-tooltip><md-icon md-font-icon=\"icon-login\" style=\"color:#0e76e2 ! important\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-if=\"siteDocLibCtrl.receivedFile.type != \'folder\'\" \nng-click=\"fileCheckout()\"><md-tooltip md-direction=\"top\">Check out</md-tooltip><md-icon md-font-icon=\"icon-logout\" \nstyle=\"color:#ff8080 ! important\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-if=\"siteDocLibCtrl.receivedFile.type != \'folder\'\" ng-click=\"downloadFile()\" ng-disabled=\"checkout\"><md-tooltip \nmd-direction=\"top\">Download</md-tooltip><md-icon md-font-icon=\"icon-download\" style=\"color:#2ecc71 ! important\">\n</md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"siteDocLibCtrl.deleteFile(ev)\" \nng-disabled=\"checkout\"><md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon md-font-icon=\"icon-delete\" \nstyle=\"color:#ff6656 ! important\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-if=\"siteDocLibCtrl.receivedFile.type != \'folder\'\" ng-click=\"FileDeatilsDialog($event,file)\"><md-tooltip \nmd-direction=\"top\">Details</md-tooltip><md-icon md-font-icon=\"icon-file\" style=\"color:#0e76e2 ! important\"></md-icon>\n</md-button></div><div><md-content ng-cloak><md-tabs md-dynamic-height md-center-tabs md-border-bottom><md-tab \nlabel=\"Details\"><div class=\"auto-height scrollable\" ms-scroll><md-content class=\"md-padding scrollable\" ms-scroll><div \nalign=\"right\"><md-button flow-btn class=\"md-icon-button\" ng-click=\" addNewAttribute() \" \nng-if=\"siteDocLibCtrl.receivedFile.type != \'folder\'\"><md-icon md-font-icon=\"icon-plus\" \nstyle=\"color: #f9a148 ! important\"></md-icon><md-tooltip md-direction=\"top\">Add New Attribute</md-tooltip></md-button>\n<md-button flow-btn class=\"md-icon-button\" ng-click=\"enableEditor()\" ng-hide=\"editorEnabled\" \nng-if=\"siteDocLibCtrl.receivedFile.type != \'folder\'\"><md-icon md-font-icon=\"icon-pencil\" \nstyle=\"color:#ffc107! important\"></md-icon><md-tooltip md-direction=\"top\">Edit Attributes</md-tooltip></md-button>\n<md-button flow-btn class=\"md-icon-button\" ng-click=\"saveAllAttributes()\" ng-show=\"editorEnabled\" \nng-if=\"siteDocLibCtrl.receivedFile.type != \'folder\'\"><md-icon md-font-icon=\"icon-content-save\" \nstyle=\"color:#FFD700 ! important\"></md-icon><md-tooltip md-direction=\"top\">Save Attributes</md-tooltip></md-button>\n<md-button flow-btn class=\"md-icon-button\" ng-click=\"siteDocLibCtrl.sharedUsersDialog($event)\" \nng-if=\"siteDocLibCtrl.receivedFile.type != \'folder\'\"><md-icon md-font-icon=\"icon-account-plus\" \nstyle=\"color:#7fba00 ! important\"></md-icon><md-tooltip md-direction=\"top\">Share {{siteDocLibCtrl.selectedFileName}}\n</md-tooltip></md-button><md-button flow-btn class=\"md-icon-button\" ng-click=\"\" \nng-if=\"siteDocLibCtrl.receivedFile.type != \'folder\'\"><md-icon md-font-icon=\"icon-star\" \nstyle=\"color:#FFD700 ! important\"></md-icon><md-tooltip md-direction=\"top\">Add To Favorites</md-tooltip></md-button>\n</div><table class=\"detailsTable1\"><tr ng-repeat=\"attribute in siteDocLibCtrl.fileAttributes\" ng-hide=\"editorEnabled\" \nng-click=\"enableEditor()\"><th align=\"left\">{{attribute.name.charAt(0).toUpperCase()+ attribute.name.slice(1)}}</th><td>\n{{attribute.value}}</td></tr><tr ng-repeat=\"attribute in siteDocLibCtrl.fileAttributes\" ng-show=\"editorEnabled\"><td>\n<md-input-container style=\"padding-top: 0px !important; padding-bottom: 0px !important;margin:-18px 0 !important\">\n<input type=\"text\" name=\"name\" ng-model=\"attribute.name\"></md-input-container></td><td><md-input-container \nstyle=\"padding-top: 0px !important; padding-bottom: 0px !important;margin:-18px 0 !important\"><input type=\"text\" \nname=\"name\" ng-model=\"attribute.value\"></md-input-container></td></tr></table><div layout=\"row\" \nlayout-align=\"center center\"><div ng-repeat=\"user in siteDocLibCtrl.allSharedUsers\" style=\"padding-left: 2%\"><md-button\n flow-btn class=\"md-icon-button md-fab md-mini grey-700-bg\" ng-click=\"\">{{user.firstName.slice(0,1).toUpperCase()}}\n<md-tooltip md-direction=\"top\">{{user.firstName +\" \"+ user.lastName}}</md-tooltip></md-button></div></div></md-content>\n</div><div class=\"md-padding\" layout=\"row\" layout-align=\"center center\" ng-show=\"buttonVisibility\"><md-button \nclass=\"md-raised\" ng-click=\"buildForm(file.id)\">DISPLAY</md-button></div><div class=\"md-padding\" layout=\"row\" \nlayout-align=\"center center\" ng-show=\"filebuttonVisibility\"><md-button class=\"md-raised\" \nng-click=\"previewFile($event)\">DISPLAY</md-button></div><md-divider ng-show=\"versionsVisibility\"></md-divider><div \nlayout=\"row\" layout-align=\"center center\" class=\"md-padding\" ng-show=\"versionsVisibility\"><span class=\"md-body-2\">\nVERSIONS</span></div><md-divider ng-show=\"versionsVisibility\"></md-divider><div class=\"auto-height scrollable\" \nms-scroll><md-content><md-list><md-list-item class=\"md-2-line\" ng-repeat=\"version in file.versions\" ng-click=\"null\">\n<div class=\"md-list-item-text\" layout=\"row\" layout-align=\"start start\"><div><h3><strong>Version {{version.versionNo}} \n</strong>created by<br><strong>{{version.createdBy}}</strong></h3><p>Date : {{version.createdDate.substr(0,10)}}</p>\n</div><div><md-button class=\"md-secondary md-icon-button\" ng-click=\"downloadVersionedFile(file.id,version.versionNo)\">\n<md-tooltip md-direction=\"top\">Download</md-tooltip><md-icon><i class=\"icon icon-download\"></i></md-icon></md-button>\n</div></div><md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list><div layout=\"row\" \nlayout-align=\"start center\" ng-show=\"versionsVisibility\" class=\"md-padding\"><md-button class=\"md-icon-button\" \nng-hide=\"file.type==\'folder\'\" ng-click=\"VersionFileDialog($event,file)\" ng-disabled=\"checkout\"><md-tooltip \nmd-direction=\"top\">Add new version</md-tooltip><md-icon md-font-icon=\"icon-library-plus\"></md-icon></md-button></div>\n</md-content></div></md-tab><md-tab label=\"ACTIVITY\"><div class=\"auto-height-activity scrollable\" ms-scroll>\n<md-content><md-list><md-list-item class=\"md-2-line\" ng-repeat=\"activity in file.activities | orderBy:\'-\' \" \nng-click=\"null\"><img ng-src=\"assets\\images\\avatars/Nora.jpg\" class=\"md-avatar\"><div class=\"md-list-item-text\" \nlayout=\"column\"><span><b><strong>{{activity.description}}</strong></b> by <strong>{{activity.userId}}</strong></span>\n<p>Date :{{activity.postedAt.substr(0,10)}}</p></div><md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list>\n</md-content></div></md-tab></md-tabs></md-content></div></div></div>");
$templateCache.put("app/main/sites/site/doclibrary/upload.doclibrary.dialog.html","<md-dialog flex=\"35\" ng-init=\"getDocumentTypes(); getDocumentTemplate();\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Create File</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content style=\"padding:0px !important\"><md-tabs md-dynamic-height \nmd-stretch-tabs=\"always\" md-center-tabs><md-tab label=\"Upload\"><form name=\"uploadfile\" \nng-submit=\"uploadfile.$valid && uploadFile($event,folderName, description,documentTypeName,documentTypeJson)\">\n<md-content class=\"md-padding scrollable\" ms-scroll><span class=\"md-body-2\" ng-style=\"{color:\'red\'}\" \nng-hide=\"files.length\">{{ErrorMsg}}</span><div layout=\"row\" ng-hide=\"folderName\"><div flex=\"35\" layout=\"column\" \nlayout-align=\"start center\"><span class=\"h3\"><b>Upload File</b></span></div><span flex=\"5\"></span><div flex=\"45\" \nlayout=\"column\" layout-align=\"center start\"><input class=\"ng-hide\" id=\"formUploadFile\" name=\"formUploadFile\" \ntype=\"file\" onchange=\"angular.element(this).scope().setFile(this)\"><label for=\"formUploadFile\" \nclass=\"md-button md-raised md-accent\">Upload</label></div></div><div><div ng-repeat=\"file in files.slice(0)\" \nlayout=\"row\" layout-align=\"center center\"><span class=\"md-warn\">{{file.webkitRelativePath || file.name}}</span> (<span \nng-switch=\"file.size > 1024*1024\"> <span ng-switch-when=\"true\">{{file.size / 1024 / 1024 | number:2}} MB</span> <span \nng-switch-default>{{file.size / 1024 | number:2}} kB</span> </span>)</div></div><div layout=\"row\" \nng-hide=\"files.length\"><div flex=\"35\" layout=\"column\" layout-align=\"start center\"><span class=\"h3\"><b>Create Folder \n</b></span></div><span flex=\"5\"></span><md-input-container flex=\"45\" class=\"md-block\" style=\"margin: 0px\"><input \ntype=\"text\" ng-model=\"folderName\" placeholder=\"Folder name\"></md-input-container></div><div layout=\"row\"><div \nflex=\"35\" layout=\"column\" layout-align=\"start center\"><span class=\"h3\"><b>Description </b></span></div><span flex=\"5\">\n</span><md-input-container flex=\"45\" class=\"md-block\" style=\"margin: 0px\"><input type=\"text\" name=\"description\" \nng-model=\"description\" required></md-input-container></div><div layout=\"row\" ng-if=\"files.length\"><div flex=\"35\" \nlayout=\"column\" layout-align=\"start center\"><span class=\"h3\"><b>Document Type </b></span></div><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"45\" style=\"margin: 0px\"><md-select name=\"documentTypeName\" \nng-model=\"documentTypeName\" ng-required=\"true\"><md-option ng-repeat=\"documentType in documentsList\" \nng-value=\"documentType.name\" ng-click=\"selectDocumentType(documentType)\">{{documentType.name}}</md-option></md-select>\n<div ng-messages=\"uploadfile.documentTypeName.$error\" \nng-show=\"uploadfile.$submitted || uploadfile.documentTypeName.$touched ||  uploadfile.documentTypeName.$dirty \"><div \nng-message-exp=\"[\'required\']\" ng-hide=\"uploadfile.documentTypeName.$valid\"><span translate>Please select DocumentType\n</span></div></div></md-input-container></div><span flex=\"5\"></span><md-divider></md-divider><div \nng-show=\"attributeObjects\"><div ng-repeat=\"attributeObject in attributeObjects\"><div layout=\"row\"><p flex=\"50\">\n{{attributeObject.name}}</p><div ng-if=\" attributeObject.required == true \">*</div><p></p><div \nng-if=\" attributeObject.required == true \" layout=\"row\" flex=\"100\"><div ng-if=\"attributeObject.type == \'String\' \" \nlayout=\"row\" flex=\"100\"><md-input-container class=\"md-block\" flex=\"40\" style=\"margin: 0px\"><input type=\"text\" \nname=\"string\" ng-model=\"attributeObject.Value\" required><div ng-messages=\"uploadfile.string.$error\" role=\"alert\"><div \nng-message=\"required\">This field is required</div></div></md-input-container></div><div \nng-if=\" attributeObject.type == \'Number\' \" layout=\"row\" flex=\"100\"><md-input-container class=\"md-block\" flex=\"40\" \nstyle=\"margin: 0px\"><input type=\"number\" name=\"number\" ng-model=\"attributeObject.Value\" required><div \nng-messages=\"uploadfile.number.$error\" role=\"alert\"><div ng-message=\"required\">This field is required</div></div>\n</md-input-container></div><div ng-if=\"attributeObject.type == \'Date\' \" layout=\"row\" flex=\"100\"><md-datepicker \nng-model=\"attributeObject.Value\" required style=\"margin: 0px\"></md-datepicker><div \nng-messages=\"uploadfile.attributeObject.Value.$error\"><div ng-message=\"required\">required</div></div></div></div><div \nng-if=\" attributeObject.required == false \" layout=\"row\" flex=\"100\"><div ng-if=\"attributeObject.type == \'String\' \" \nlayout=\"row\" flex=\"100\"><md-input-container class=\"md-block\" flex=\"40\" style=\"margin: 0px\"><input type=\"text\" \nng-model=\"attributeObject.Value\"></md-input-container></div><div ng-if=\" attributeObject.type == \'Number\' \" \nlayout=\"row\" flex=\"100\"><md-input-container class=\"md-block\" flex=\"40\" style=\"margin: 0px\"><input type=\"number\" \nng-model=\"attributeObject.Value\"></md-input-container></div><div ng-if=\"attributeObject.type == \'Date\' \" layout=\"row\" \nflex=\"100\"><md-datepicker ng-model=\"attributeObject.Value\" style=\"margin: 0px\"></md-datepicker></div></div></div></div>\n</div></md-content><div layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button \ntype=\"submit\">Save</md-button></div></form></md-tab><md-tab label=\"Create\"><form name=\"create\" \nng-submit=\"create.$valid && createTemplateFile($event,create.name,create.description,create.documentType,create.template,createFiledocTypeJson)\">\n<md-content class=\"md-padding scrollable\" ms-scroll><div layout=\"row\"><div flex=\"35\" layout=\"column\" \nlayout-align=\"center center\"><span class=\"h3\"><b>Name </b></span></div><span flex=\"5\"></span><md-input-container \nflex=\"45\" class=\"md-block\" style=\"margin:0px\"><input type=\"text\" name=\"createname\" ng-model=\"create.name\" required>\n</md-input-container></div><div layout=\"row\"><div flex=\"35\" layout=\"column\" layout-align=\"center center\"><span \nclass=\"h3\"><b>Description </b></span></div><span flex=\"5\"></span><md-input-container flex=\"45\" class=\"md-block\" \nstyle=\"margin:0px\"><input type=\"text\" name=\"des\" ng-model=\"create.description\" required></md-input-container></div><div\n layout=\"row\"><div flex=\"35\" layout=\"column\" layout-align=\"center center\"><span class=\"h3\"><b>Template Name</b></span>\n</div><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"45\" style=\"margin:0px\"><md-select \nname=\"template\" ng-model=\"create.template\" ng-required=\"true\"><md-option ng-repeat=\"template in templateList\" \nng-value=\"template.name\" ng-click=\"selectDocumentTemplate(template.name)\">{{template.name}}</md-option></md-select><div\n ng-messages=\"create.template.$error\" \nng-show=\"create.$submitted || create.template.$touched ||  create.template.$dirty \"><div ng-message-exp=\"[\'required\']\" \nng-hide=\"create.template.$valid\"><span translate>Please select Template</span></div></div></md-input-container></div>\n<div layout=\"row\"><div flex=\"35\" layout=\"column\" layout-align=\"center center\"><span class=\"h3\"><b>Document Type </b>\n</span></div><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"45\" style=\"margin:0px\"><input \ntype=\"text\" disabled=\"true\" ng-model=\"create.documentType \" placeholder=\"{{create.documentType }}\">\n</md-input-container></div><md-divider></md-divider><div ng-show=\"DocTypeattributeObjects\"><div \nng-repeat=\"attributeObject in DocTypeattributeObjects\"><div layout=\"row\"><p flex=\"40\">{{attributeObject.name}}</p><div \nng-if=\" attributeObject.required == true \">*</div><p></p><div ng-if=\" attributeObject.required == true \" layout=\"row\" \nflex=\"100\"><div ng-if=\"attributeObject.type == \'String\' \" layout=\"row\" flex=\"100\"><md-input-container class=\"md-block\" \nflex=\"40\" style=\"margin: 0px\"><input type=\"text\" name=\"string\" ng-model=\"attributeObject.Value\" required><div \nng-messages=\"create.string.$error\" role=\"alert\"><div ng-message=\"required\">This field is required</div></div>\n</md-input-container></div><div ng-if=\" attributeObject.type == \'Number\' \" layout=\"row\" flex=\"100\"><md-input-container \nclass=\"md-block\" flex=\"40\" style=\"margin: 0px\"><input type=\"number\" name=\"number\" ng-model=\"attributeObject.Value\" \nrequired><div ng-messages=\"create.number.$error\" role=\"alert\"><div ng-message=\"required\">This field is required</div>\n</div></md-input-container></div><div ng-if=\"attributeObject.type == \'Date\' \" layout=\"row\" flex=\"100\"><md-datepicker \nng-model=\"attributeObject.Value\" required></md-datepicker><div ng-messages=\"create.attributeObject.Value.$error\" \nrole=\"alert\"><div ng-message=\"required\">required</div></div></div></div><div \nng-if=\" attributeObject.required == false \" layout=\"row\" flex=\"100\"><div ng-if=\"attributeObject.type == \'String\' \" \nlayout=\"row\" flex=\"100\"><md-input-container class=\"md-block\" flex=\"40\" style=\"margin: 0px\"><input type=\"text\" \nng-model=\"attributeObject.Value\"></md-input-container></div><div ng-if=\" attributeObject.type == \'Number\' \" \nlayout=\"row\" flex=\"100\"><md-input-container class=\"md-block\" flex=\"40\" style=\"margin: 0px\"><input type=\"number\" \nng-model=\"attributeObject.Value\"></md-input-container></div><div ng-if=\"attributeObject.type == \'Date\' \" layout=\"row\" \nflex=\"100\"><md-datepicker ng-model=\"attributeObject.Value\"></md-datepicker></div></div></div></div></div></md-content>\n<div layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\">Save\n</md-button></div></form></md-tab></md-tabs></md-dialog-content></md-dialog>");
$templateCache.put("app/main/sites/site/home/addcontract.dialog.html","<md-dialog flex=\"55\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><span flex=\"35\"></span><h2>\nAdd Contract</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"p-0\"><md-content layout-padding><form name=\"contractForm\" \nnovalidate><div layout=\"row\" ng-hide=\"templateName\" ng-hide=\"templateName\"><div flex=\"35\" layout=\"column\" \nlayout-align=\"center end\"><span class=\"h3\"><b>Upload File</b></span></div><span flex=\"10\"></span><div flex=\"45\" \nlayout=\"column\" layout-align=\"center start\"><input class=\"ng-hide\" id=\"formUploadFile\" name=\"formUploadFile\" \ntype=\"file\" onchange=\"angular.element(this).scope().setFile(this)\"><label for=\"formUploadFile\" \nclass=\"md-button md-raised md-accent\">Browse</label></div></div><div><div ng-repeat=\"file in files.slice(0)\" \nlayout=\"row\" layout-align=\"center center\"><span class=\"md-warn\">{{file.webkitRelativePath || file.name}}</span> ( <span\n ng-switch=\"file.size > 1024*1024\"><span ng-switch-when=\"true\">{{file.size / 1024 / 1024 | number:2}} MB</span> <span \nng-switch-default>{{file.size / 1024 | number:2}} kB</span> </span>)</div></div><div layout-gt-sm=\"row\" \nng-hide=\"files.length\" flex=\"65\"><span flex=\"35\"></span><md-input-container class=\"md-block\" flex-gt-sm><label>Template\n</label><md-select ng-model=\"templateName\"><md-option ng-repeat=\"template in templateList\" value=\"{{template.name}}\">\n{{template.name}}</md-option></md-select></md-input-container></div><div layout-gt-xs=\"row\"><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex-gt-xs><label>Contract Name</label><input ng-model=\"contract.ContractName\" \nng-required=\"attributesList[7].isRequired\"></md-input-container><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex-gt-sm><label>Status</label><md-select ng-model=\"contract.Status\" \nng-required=\"attributesList[8].isRequired\"><md-option ng-repeat=\"status in statusValues\" ng-value=\"status\">{{status}}\n</md-option></md-select></md-input-container><span flex=\"5\"></span></div><div layout-gt-xs=\"row\"><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex-gt-sm><label>Contract Type</label><md-select name=\"contractType\" \nng-model=\"contract.ContractType\" ng-required=\"attributesList[2].isRequired\"><md-option \nng-repeat=\"type in contractTypeList\" ng-value=\"type.name\" ng-selected=\"isSelectedCType(type.name)\">{{type.name}}\n</md-option></md-select><div class=\"errors\" ng-messages=\"contractForm.contractType.$error\"><div ng-message=\"required\">\nRequired</div></div></md-input-container><span flex=\"5\"></span><md-input-container class=\"md-block\" flex-gt-sm><label>\nCategory</label><md-select name=\"category\" ng-model=\"contract.Category\" ng-required=\"attributesList[6].isRequired\">\n<md-option ng-repeat=\"cate in categoriesList\" ng-value=\"cate.name\">{{cate.name}}</md-option></md-select>\n</md-input-container><span flex=\"5\"></span></div><div layout-gt-xs=\"row\"><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex-gt-sm><label>Description</label><input ng-model=\"contract.Description\"></md-input-container><span\n flex=\"5\"></span></div><div layout-gt-xs=\"row\"><span flex=\"5\"></span><md-input-container class=\"md-block\" flex-gt-sm>\n<label>Business Partner Type</label><md-select ng-model=\"contract.BusinessPartnerType\" \nrequired=\"{{attributesList[3].isRequired}}\"><md-option ng-repeat=\"parnerType in businessPartnerTypes\" \nng-click=\"selectParnerTypeType(parnerType)\" ng-value=\"parnerType\">{{parnerType}}</md-option></md-select>\n</md-input-container><span flex=\"5\"></span><md-input-container class=\"md-block\" flex-gt-xs \nng-if=\"contract.BusinessPartnerType == \'Customer\'\"><label>Business Partner</label><input \nng-model=\"contract.BusinessPartner\" ng-required=\"attributesList[4].isRequired\" readonly=\"readonly\"><md-icon \nmd-font-icon=\"icon-magnify\" ng-click=\"searchCustomers($event)\" class=\"blue-fg s32 c-p\"></md-icon></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-xs ng-if=\"contract.BusinessPartnerType == \'Employee\'\"><label>\nBusiness Partner</label><input ng-model=\"contract.BusinessPartner\" ng-required=\"attributesList[4].isRequired\" \nreadonly=\"readonly\"><md-icon md-font-icon=\"icon-magnify\" ng-click=\"searchEmployee($event)\" class=\"blue-fg s32 c-p\">\n</md-icon></md-input-container><md-input-container class=\"md-block\" flex-gt-xs \nng-if=\"contract.BusinessPartnerType == \'Vendor\'\"><label>Business Partner</label><input \nng-model=\"contract.BusinessPartner\" ng-required=\"attributesList[4].isRequired\" readonly=\"readonly\"><md-icon \nmd-font-icon=\"icon-magnify\" ng-click=\"searchVendors($event);\" class=\"blue-fg s32 c-p\"></md-icon></md-input-container>\n<md-button class=\"md-raised\" ng-click=\"addnewVendor()\" style=\"height: 35px;top: 5px;min-width: 100px\" \nng-if=\"contract.BusinessPartnerType == \'Vendor\'\">Add Vendor</md-button><md-button class=\"md-raised\" \nng-click=\"addnewEmployee()\" style=\"height: 35px;top: 5px;min-width: 100px\" \nng-if=\"contract.BusinessPartnerType == \'Employee\'\">Add Employee</md-button><md-button class=\"md-raised\" \nng-click=\"addnewCustomer()\" style=\"height: 35px;top: 5px;min-width: 100px\" \nng-if=\"contract.BusinessPartnerType == \'Customer\'\">Add Customer</md-button><span flex=\"5\"></span></div><div></div><div \nlayout-gt-xs=\"row\"><span flex=\"5\"></span><md-input-container class=\"md-block\" flex-gt-sm><label>Organizational Unit\n</label><md-select name=\"companyCode\" ng-model=\"contract.OrganizationUnit\" ng-required=\"attributesList[1].isRequired\">\n<md-option ng-repeat=\"code in companyCodes\" ng-value=\"code.companyCode\" \nng-selected=\"isSelectedCCode(code.companyCode)\">{{code.name}}</md-option></md-select><div class=\"errors\" \nng-messages=\"contractForm.companyCode.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><span\n flex=\"5\"></span><label class=\"pt-10\">ValidTill</label><md-datepicker ng-model=\"contract.ValidTill\" \nstyle=\"margin: 0px\" md-min-date=\"minDate\" md-max-date=\"maxDate\" required=\"{{attributesList[0].isRequired}}\">\n</md-datepicker><span flex=\"5\"></span></div><div layout-gt-xs=\"row\"><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex-gt-xs><label>Amount</label><input name=\"amount\" type=\"number\" ng-model=\"contract.Amount\" \nng-required=\"attributesList[9].isRequired\"></md-input-container><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex-gt-sm><label>Currency</label><md-select ng-model=\"contract.Currency\" \nrequired=\"{{attributesList[10].isRequired}}\"><md-option ng-repeat=\"cur in currencys\" ng-value=\"cur\">{{cur}}</md-option>\n</md-select></md-input-container><span flex=\"5\"></span></div><div layout-gt-xs=\"row\"><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex-gt-xs><label>SAP Contract</label><input ng-model=\"contract.SAPcontract\" \nng-required=\"attributesList[11].isRequired\"></md-input-container><span flex=\"5\"></span></div><div layout-gt-xs=\"row\">\n<span flex=\"5\"></span><md-input-container class=\"md-block\" flex-gt-xs><label>Notes</label><input \nng-model=\"contract.Notes\"></md-input-container><span flex=\"5\"></span></div></form></md-content></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button \nng-disabled=\"contractForm.$invalid\" ng-click=\"uploadFile($event,contract,documentTypeJson)\">Add Contract</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sites/site/home/site.home.html","<style>\n.card-para {\r\n        margin: 0 0 10px;\r\n        padding: 15px !important;\r\n        font-size: 13px;\r\n        font-family: \"Helvetica Neue\", Helvetica, Arial, Roboto, sans-serif, sans-serif;\r\n        line-height: 1.53846154;\r\n    }\r\n    \r\n    .pt-b {\r\n        border: 1px solid #eeeeee;\r\n    }\r\n    \r\n    .panel-heading {\r\n        padding: 15px;\r\n    }\r\n    \r\n    .panel-body {\r\n        padding: 15px;\r\n    }\r\n    \r\n    .panel-controls {\r\n        float: right;\r\n    }\r\n    table.simple-row tbody tr td {\r\n    padding: 14px 8px;\r\n    border-bottom: 0px !important;\r\n   \r\n}\r\n	#circle{\r\n		width: 70%;\r\n		height: 50%;	\r\n		border-radius: 50%;\r\n	}\r\n	#iconStyles{\r\n		margin-bottom: -65%;\r\n		margin-left: 20%;\r\n	}\n</style><div layout=\"row\"><ms-widget flex=\"50\"><div class=\"white-bg\"><div class=\"panel-heading\" layout=\"row\" \nstyle=\"background-color: #4cc3d9 !important; display: block\"><div class=\"grey-A100-fg\" style=\"display: inline-block\">\nOverview</div></div><div class=\"panel-body card-para scrollable pt-b\" ms-scroll><div flex layout=\"row\"><div flex \nstyle=\"color:#757575\"><span ng-bind-html=\"Home.ganeralsettings.overview\"></span></div></div></div></div></ms-widget>\n<ms-widget flex=\"50\"><div class=\"white-bg\"><div class=\"panel-heading\" layout=\"row\" \nstyle=\"background-color: #4cc3d9  !important; display: block\"><div class=\"grey-A100-fg\" style=\"display: inline-block\">\nSupport</div></div><div flex><div class=\"panel-body card-para scrollable pt-b\" ms-scroll><div flex layout=\"row\"><div \nflex style=\"color:#757575\"><span ng-bind-html=\"Home.ganeralsettings.support\"></span></div></div></div></div></div>\n</ms-widget></div><div layout=\"row\"><ms-widget flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\"><div class=\"white-bg\"><div \nclass=\"panel-heading\" layout=\"row\" style=\"background-color: #4cc3d9  !important; display: block\"><div \nclass=\"grey-A100-fg\" style=\"display: inline-block\">Latest Activities</div></div><md-content flex \nclass=\"panel-body card-para scrollable pt-b\" ms-scroll><md-list><md-list-item class=\"md-2-line\" \nng-repeat=\"activity in Home.latestActivities\"><p ng-bind-html=\"activity.description\"></p><p \nng-if=\"activity.description == null\"><b>{{activity.userId}}</b>\n {{activity.activityType.charAt(26).toUpperCase()+activity.activityType.slice(27,46)}} On {{activity.postedAt | date:\"dd/MM/yyyy \' \' h:mma\"}}\n</p></md-list-item></md-list></md-content></div></ms-widget></div>");
$templateCache.put("app/main/sites/site/members/site.addMemberDialog.html","<md-dialog ng-cloak><form name=\"siteMembersCtrl.memberForm\" role=\"form\" novalidate ng-submit=\" \"><md-toolbar \nlayout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Add {{memberRole}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout=\"column\" layout-align=\"center center\"><div layout=\"row\" class=\"md-padding\">\n<md-input-container class=\"md-block\" flex=\"45\"><input type=\"text\" name=\"name\" ng-model=\"member.name\" \nplaceholder=\"Name\"></md-input-container><span flex=\"10\"></span><md-input-container class=\"md-block\" flex=\"45\"><input \ntype=\"text\" name=\"email\" ng-model=\"member.email\" placeholder=\"Email\"></md-input-container></div><div layout=\"row\" \nng-style=\"{\'color\':\'red\',\'font-family\':\'Roboto\',\'font-size\':\'12px\'}\" ng-show=\"msgVisibility\">\nPlease enter either name or email</div><div class=\"md-padding\"><md-button type=\"button\" class=\"md-raised\" \nng-click=\"searchMember(member)\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>Search user</md-button></div><div \nng-show=\"tableVisibility\" class=\"md-padding scrollable\" ms-scroll><table><thead><tr><th \nclass=\"secondary-text md-padding\"><div class=\"table-header\"><span class=\"column-title\">NAME</span></div></th><th \nclass=\"secondary-text md-padding\"><div class=\"table-header\"><span class=\"column-title\">EMAIL</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"member in searchedMembers\"><td class=\"md-padding\">\n{{member.firstName}} {{member.lastName}}</td><td class=\"md-padding\">{{member.email}}</td><td layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-click=\"addMember(member) \">ADD</md-button></td>\n</tr></tbody></table></div></md-dialog-content></form><md-dialog-actions layout=\"row\"><span flex></span><md-button \nng-click=\"cancel(member)\">Cancel</md-button><md-button ng-click=\"ok()\" md-autofocus>Ok</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/sites/site/members/site.members.html","<div class=\"page-layout carded fullwidth\" layout=\"row\"><div flex-gt-sm=\"30\" flex ng-repeat=\"role in roles\" \nclass=\"md-padding\"><md-toolbar layout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\"><span>{{role}}</span></div>\n<div><md-button flow-btn class=\"md-fab grey-700-bg md-mini md-fab-top-right\" \nng-click=\"siteMembersCtrl.addMemberDialog($event,role)\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"top\">Add Member</md-tooltip></md-button></div></md-toolbar><md-content flex \nng-style=\"{\'border\': \'1px solid #cccccc\'}\" class=\"scrollable\" ms-scroll><div \nng-switch=\"(siteMembersCtrl.members | filter:{roleId:role}).length\"><div ng-switch-when=\"0\" layout=\"row\" \nlayout-align=\"center center\"><p class=\"md-padding md-subhead md-primary-fg\">{{\'No member yet...\' | uppercase}}</p>\n</div><div ng-switch-default ng-style=\"{\'height\':\'280px\'}\" flex=\"100\"><md-list><md-list-item class=\"md-2-line\" \nng-repeat=\"eachMember in siteMembersCtrl.members | filter: role\" ng-click=\"null\"><img \nng-src=\"assets\\images\\avatars/Nora.jpg\" class=\"md-avatar\"><div class=\"md-list-item-text\" layout=\"column\"><h3>\n{{ eachMember.firstName }} {{ eachMember.lastName }}</h3><p>{{ eachMember.email }}</p><span flex=\"10\"></span><md-button\n class=\"md-secondary md-icon-button\" ng-click=\"siteMembersCtrl.deleteMember($event, role, eachMember)\"><md-tooltip \nmd-direction=\"top\">Delete</md-tooltip><md-icon><i class=\"icon icon-delete s30\"></i></md-icon></md-button></div>\n<md-divider></md-divider></md-list-item></md-list></div></div></md-content></div></div>");
$templateCache.put("app/main/sites/site/sitesettings/site.addDocumentDialog.html","<md-dialog ng-cloak flex=\"35\" ng-init=\"getDocumentTypes()\"><form name=\"siteMembersCtrl.memberForm\" role=\"form\" \nnovalidate><md-toolbar layout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Add Document Type</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"close()\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"row\"><div flex=\"45\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"h3\"><b>Document Type </b></span></div><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"35\" style=\"padding-top: 0px !important;padding-bottom: 0px !important\">\n<md-select ng-model=\"documentType\"><md-option ng-repeat=\"documentType in documentsList\" ng-value=\"documentType.name\" \nng-click=\"selectDocumentType(documentType)\">{{documentType.name}}</md-option></md-select></md-input-container></div>\n</md-dialog-content></form><md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel\n</md-button><md-button ng-click=\"\" md-autofocus>Ok</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sites/site/sitesettings/sitesettings.html","<div ng-init=\"getSite()\"><md-tabs md-dynamic-height md-border-bottom><md-tab label=\"General Settings\"><md-content \nclass=\"md-padding scrollable\" ms-scroll><div><form name=\"userForm\"><label>Portlet 1</label><text-angular \nng-model=\"home.overview\"></text-angular></form></div><div><form name=\"siteHome\"><label>Portlet 2</label><text-angular \nng-model=\"home.support\"></text-angular></form></div></md-content><md-dialog-actions layout=\"row\"><span flex></span>\n<md-button ng-click=\"clear()\" class=\"md-raised\">Cancel</md-button><md-button ng-click=\"save(siteId,siteSettingName)\" \nclass=\"md-raised\">Save</md-button></md-dialog-actions></md-tab><md-tab label=\"Site Settings\"><md-content \nclass=\"md-padding scrollable\" ms-scroll><form name=\"siteSetting\" novalidate><div layout=\"row\"><div flex=\"35\" \nlayout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>SiteName </b></span></div><span flex=\"10\"></span>\n<md-input-container flex=\"15\" class=\"md-block\" layout=\"column\" layout-align=\"space-around start\"><input type=\"text\" \nname=\"name\" ng-disabled=\"Edit\" ng-model=\"site.name\"></md-input-container></div><div layout=\"row\"><div flex=\"35\" \nlayout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>Site Url</b></span></div><span flex=\"10\"></span>\n<md-input-container flex=\"15\" class=\"md-block\" layout=\"column\" layout-align=\"space-around start\" \nstyle=\"padding-top: 0px !important;padding-bottom: 0px !important\"><input type=\"text\" name=\"name\" ng-disabled=\"Edit\" \nng-model=\"site.url\"></md-input-container></div><div layout=\"row\"><div flex=\"35\" layout=\"column\" \nlayout-align=\"center end\"><span class=\"h3\"><b>Site Description </b></span></div><span flex=\"10\"></span>\n<md-input-container flex=\"15\" class=\"md-block\" layout=\"column\" layout-align=\"space-around start\" \nstyle=\"padding-top: 0px !important;padding-bottom: 0px !important\"><input type=\"text\" name=\"name\" ng-disabled=\"Edit\" \nng-model=\"site.description\"></md-input-container></div><div layout=\"row\"><div flex=\"35\" layout=\"column\" \nlayout-align=\"center end\"><span class=\"h3\"><b>Site Title </b></span></div><span flex=\"10\"></span><md-input-container \nflex=\"15\" class=\"md-block\" layout=\"column\" layout-align=\"space-around start\" \nstyle=\"padding-top: 0px !important;padding-bottom: 0px !important\"><input type=\"text\" name=\"name\" ng-disabled=\"Edit\" \nng-model=\"site.title\"></md-input-container></div><div layout=\"row\"><span flex></span><md-button \nng-click=\"sitesettingCtrl.editMode()\" ng-hide=\"editButton\">Edit</md-button><md-button ng-click=\"Updatesite(site)\" \nng-show=\"editButton\">Save</md-button><md-button ng-click=\"sitesettingCtrl.Cancel()\" ng-show=\"editButton\">Cancel\n</md-button></div></form></md-content></md-tab></md-tabs></div>");
$templateCache.put("app/main/sites/site/todolist/site.todolist.html","<div ng-switch=\"notes.length\"><div id=\"notes\" layout=\"column\" ms-scroll flex><div ng-switch-when=\"0\" layout=\"row\" \nlayout-align=\"center center\"><div id=\"error-404\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"error-code\">&nbsp;</div><div class=\"message\">\nSorry but we couldn’t find any to-do list for the \"{{siteTodoCtrl.value}}\" site.</div><div><md-button \nclass=\"md-raised md-warn\" ng-click=\"siteTodoCtrl.showConfirm()\">Add new to-do</md-button></div></div></div></div>\n<md-content ms-scroll flex><ms-masonry class=\"notes\" options=\'{\"columnCount\":4}\'><ms-masonry-item ng-switch-default \nclass=\"note\" ng-repeat=\"note in notes | orderBy: \'time\':true \" ms-note-item=\"note\" \nng-click=\"siteTodoCtrl.editNote($event, note.todolistId)\"></ms-masonry-item></ms-masonry></md-content></div></div>");
$templateCache.put("app/main/sites/site/wiki/site.wiki.html","<div><h1 class=\"md-display-2\">Wiki -> Naveena</h1><h1>{{siteWikiCtrl.test}}</h1></div>");
$templateCache.put("app/main/smartstore-admin/systems/repos/create.repository.html","<md-dialog aria-label=\"Add a new Repository\" flex=\"45\"><form name=\"repForm\" novalidate \nng-submit=\"repForm.$valid && save(repository)\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Create Repository</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll>\n<md-input-container class=\"md-block\"><input type=\"text\" name=\"id\" ng-model=\"repository.repositoryId\" \nplaceholder=\"Repository Id\" required><div ng-messages=\"repForm.id.$error\" role=\"alert\"><div ng-message=\"required\">\nRepository Id is required</div></div></md-input-container><md-input-container class=\"md-block\"><input \ntype=\"description\" name=\"name\" ng-model=\"repository.name\" placeholder=\"Repository Name\" required><div \nng-messages=\"repForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Repository Name is required</span>\n</div></div></md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"description\" \nng-model=\"repository.description\" placeholder=\"Repository Description\" required><div \nng-messages=\"repForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>Description is required</span>\n</div></div></md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"pVersion\" \nng-model=\"repository.pVersion\" placeholder=\"P Version\" required><div ng-messages=\"repForm.pVersion.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Version is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><md-select name=\"storageType\" ng-model=\"repository.storageType\" \nplaceholder=\"Storage Type\" required><md-option ng-value=\"storageType\" ng-repeat=\"storageType in storageTypes\">\n{{storageType}}</md-option></md-select><div ng-messages=\"repForm.storageType.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Type is required</span></div></div></md-input-container><div layout=\"row\"><span>\nEncript Document</span> <span style=\"margin-left: 4%\"><md-checkbox type=\"checkbox\" ng-model=\"repository.encript\">\n</md-checkbox></span></div><div layout=\"column\" ng-if=\"repository.storageType==\'GoogleDrive\'\"><div><b \nstyle=\"color:#0072ff\">Google Drive</b></div><div flex=\"100\"><md-input-container class=\"md-block\"><input type=\"text\" \nname=\"clientID\" ng-model=\"repository.clientId\" placeholder=\"Client Id\" required><div \nng-messages=\"repForm.clientID.$error\" role=\"alert\"><div ng-message=\"required\"><span>Client Id is required</span></div>\n</div></md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"clientSecret\" \nng-model=\"repository.clientSecret\" placeholder=\"Client Secret\" required><div ng-messages=\"repForm.clientSecret.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Client Secret is required</span></div></div></md-input-container></div>\n</div><div layout=\"column\" ng-if=\"repository.storageType==\'OneDrive\'\"><div><b style=\"color:#0072ff\">One Drive</b></div>\n<div flex=\"100\"><md-input-container class=\"md-block\"><input type=\"text\" name=\"clientID\" ng-model=\"repository.clientId\" \nplaceholder=\"Client Id\" required><div ng-messages=\"repForm.clientID.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Client Id is required</span></div></div></md-input-container><md-input-container class=\"md-block\"><input \ntype=\"text\" name=\"clientSecret\" ng-model=\"repository.clientSecret\" placeholder=\"Client Secret\" required><div \nng-messages=\"repForm.clientSecret.$error\" role=\"alert\"><div ng-message=\"required\"><span>Client Secret is required\n</span></div></div></md-input-container></div></div><div layout=\"column\" ng-if=\"repository.storageType==\'amazonS3\'\">\n<div><b style=\"color:#0072ff\">Amazon S3</b></div><div flex=\"100\"><md-input-container class=\"md-block\"><input \ntype=\"text\" name=\"clientID\" ng-model=\"repository.clientId\" placeholder=\"Client Id\" required><div \nng-messages=\"repForm.clientID.$error\" role=\"alert\"><div ng-message=\"required\"><span>Client Id is required</span></div>\n</div></md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"clientSecret\" \nng-model=\"repository.clientSecret\" placeholder=\"Client Secret\" required><div ng-messages=\"repForm.clientSecret.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Client Secret is required</span></div></div></md-input-container></div>\n</div><div layout=\"column\" ng-if=\"repository.storageType==\'azurestorage\'\"><div><b style=\"color:#0072ff\">Azure storage\n</b></div><div flex=\"100\"><md-input-container class=\"md-block\"><input type=\"text\" name=\"clientID\" \nng-model=\"repository.clientId\" placeholder=\"Client Id\" required><div ng-messages=\"repForm.clientID.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Client Id is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><input type=\"text\" name=\"clientSecret\" ng-model=\"repository.clientSecret\" \nplaceholder=\"Client Secret\" required><div ng-messages=\"repForm.clientSecret.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Client Secret is required</span></div></div></md-input-container></div></div><div \nlayout=\"column\" ng-if=\"repository.storageType==\'FileSystem\'\"><div><b style=\"color:#0072ff\">File System</b></div><div \nflex=\"100\"><md-input-container class=\"md-block\"><input type=\"text\" name=\"rootPath\" ng-model=\"repository.rootPath\" \nplaceholder=\"Root Path\" required><div ng-messages=\"repForm.rootPath.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Root Path is required</span></div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/smartstore-admin/systems/repos/display.repository.html","<md-dialog flex=\"45\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Repository Details</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><md-input-container class=\"md-block\">\n<input type=\"text\" name=\"id\" ng-model=\"currentrepository.repositoryId\" placeholder=\"Repository Id\" readonly=\"true\">\n</md-input-container><md-input-container class=\"md-block\"><input type=\"description\" name=\"name\" \nng-model=\"currentrepository.name\" placeholder=\"Repository Name\" readonly=\"true\"></md-input-container>\n<md-input-container class=\"md-block\"><input type=\"text\" name=\"description\" ng-model=\"currentrepository.description\" \nplaceholder=\"Repository Description\" readonly=\"true\"></md-input-container><md-input-container class=\"md-block\"><input \ntype=\"text\" name=\"pVersion\" ng-model=\"currentrepository.pVersion\" placeholder=\"P Version\" readonly=\"true\">\n</md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"clientID\" \nng-model=\"currentrepository.storageType\" placeholder=\"storageType\" readonly=\"true\"></md-input-container><div \nlayout=\"column\" ng-if=\"currentrepository.storageType==\'GoogleDrive\'\"><div><b style=\"color:#0072ff\">Google Drive</b>\n</div><div flex=\"100\"><md-input-container class=\"md-block\"><input type=\"text\" name=\"clientID\" \nng-model=\"currentrepository.clientId\" placeholder=\"Client Id\" readonly=\"true\"></md-input-container><md-input-container \nclass=\"md-block\"><input type=\"text\" name=\"clientSecret\" ng-model=\"currentrepository.clientSecret\" \nplaceholder=\"Client Secret\" readonly=\"true\"></md-input-container></div></div><div layout=\"column\" \nng-if=\"currentrepository.storageType==\'OneDrive\'\"><div><b style=\"color:#0072ff\">One Drive</b></div><div flex=\"100\">\n<md-input-container class=\"md-block\"><input type=\"text\" name=\"clientID\" ng-model=\"currentrepository.clientId\" \nplaceholder=\"Client Id\" readonly=\"true\"></md-input-container><md-input-container class=\"md-block\"><input type=\"text\" \nname=\"clientSecret\" ng-model=\"currentrepository.clientSecret\" placeholder=\"Client Secret\" readonly=\"true\">\n</md-input-container></div></div><div layout=\"column\" ng-if=\"currentrepository.storageType==\'FileSystem\'\"><div><b \nstyle=\"color:#0072ff\">File System</b></div><div flex=\"100\"><md-input-container class=\"md-block\"><input type=\"text\" \nname=\"rootPath\" ng-model=\"currentrepository.rootPath\" placeholder=\"Root Path\" readonly=\"true\"></md-input-container>\n</div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Ok\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/smartstore-admin/systems/repos/update.repository.html","<md-dialog flex=\"45\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Update Repository</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><md-input-container class=\"md-block\">\n<input type=\"text\" name=\"id\" ng-model=\"currentrepository.repositoryId\" placeholder=\"Repository Id\" required><div \nng-messages=\"updateRepForm.id.$error\" role=\"alert\"><div ng-message=\"required\">Repository Id is required</div></div>\n</md-input-container><md-input-container class=\"md-block\"><input type=\"description\" name=\"name\" \nng-model=\"currentrepository.name\" placeholder=\"Repository Name\" required><div ng-messages=\"updateRepForm.name.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Repository Name is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><input type=\"text\" name=\"description\" ng-model=\"currentrepository.description\" \nplaceholder=\"Repository Description\" required><div ng-messages=\"updateRepForm.description.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Description is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><input type=\"text\" name=\"pVersion\" ng-model=\"currentrepository.pVersion\" placeholder=\"P Version\" \nrequired><div ng-messages=\"updateRepForm.pVersion.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nVersion is required</span></div></div></md-input-container><md-input-container class=\"md-block\"><md-select \nname=\"storageType\" ng-model=\"currentrepository.storageType\" placeholder=\"Storage Type\" required><md-option \nng-value=\"storageType\" ng-repeat=\"storageType in storageTypes\">{{storageType}}</md-option></md-select><div \nng-messages=\"updateRepForm.storageType.$error\" role=\"alert\"><div ng-message=\"required\"><span>Type is required</span>\n</div></div></md-input-container><div layout=\"row\"><span>Encript Document</span> <span style=\"margin-left: 4%\">\n<md-checkbox type=\"checkbox\" ng-model=\"repository.encript\"></md-checkbox></span></div><div layout=\"column\" \nng-if=\"currentrepository.storageType==\'GoogleDrive\'\"><div><b style=\"color:#0072ff\">Google Drive</b></div><div \nflex=\"100\"><md-input-container class=\"md-block\"><input type=\"text\" name=\"clientID\" \nng-model=\"currentrepository.clientId\" placeholder=\"Client Id\" required><div \nng-messages=\"updateRepForm.clientID.$error\" role=\"alert\"><div ng-message=\"required\"><span>Client Id is required</span>\n</div></div></md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"clientSecret\" \nng-model=\"currentrepository.clientSecret\" placeholder=\"Client Secret\" required><div \nng-messages=\"updateRepForm.clientSecret.$error\" role=\"alert\"><div ng-message=\"required\"><span>Client Secret is required\n</span></div></div></md-input-container></div></div><div layout=\"column\" \nng-if=\"currentrepository.storageType==\'OneDrive\'\"><div><b style=\"color:#0072ff\">One Drive</b></div><div flex=\"100\">\n<md-input-container class=\"md-block\"><input type=\"text\" name=\"clientID\" ng-model=\"currentrepository.clientId\" \nplaceholder=\"Client Id\" required><div ng-messages=\"updateRepForm.clientID.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Client Id is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><input type=\"text\" name=\"clientSecret\" ng-model=\"currentrepository.clientSecret\" \nplaceholder=\"Client Secret\" required><div ng-messages=\"updateRepForm.clientSecret.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Client Secret is required</span></div></div></md-input-container></div></div><div \nlayout=\"column\" ng-if=\"currentrepository.storageType==\'amazonS3\'\"><div><b style=\"color:#0072ff\">Amazon S3</b></div><div\n flex=\"100\"><md-input-container class=\"md-block\"><input type=\"text\" name=\"clientID\" \nng-model=\"currentrepository.clientId\" placeholder=\"Client Id\" required><div \nng-messages=\"updateRepForm.clientID.$error\" role=\"alert\"><div ng-message=\"required\"><span>Client Id is required</span>\n</div></div></md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"clientSecret\" \nng-model=\"currentrepository.clientSecret\" placeholder=\"Client Secret\" required><div \nng-messages=\"updateRepForm.clientSecret.$error\" role=\"alert\"><div ng-message=\"required\"><span>Client Secret is required\n</span></div></div></md-input-container></div></div><div layout=\"column\" \nng-if=\"currentrepository.storageType==\'azurestorage\'\"><div><b style=\"color:#0072ff\">Azure storage</b></div><div \nflex=\"100\"><md-input-container class=\"md-block\"><input type=\"text\" name=\"clientID\" \nng-model=\"currentrepository.clientId\" placeholder=\"Client Id\" required><div \nng-messages=\"updateRepForm.clientID.$error\" role=\"alert\"><div ng-message=\"required\"><span>Client Id is required</span>\n</div></div></md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"clientSecret\" \nng-model=\"currentrepository.clientSecret\" placeholder=\"Client Secret\" required><div \nng-messages=\"updateRepForm.clientSecret.$error\" role=\"alert\"><div ng-message=\"required\"><span>Client Secret is required\n</span></div></div></md-input-container></div></div><div layout=\"column\" \nng-if=\"currentrepository.storageType==\'FileSystem\'\"><div><b style=\"color:#0072ff\">File System</b></div><div flex=\"100\">\n<md-input-container class=\"md-block\"><input type=\"text\" name=\"rootPath\" ng-model=\"currentrepository.rootPath\" \nplaceholder=\"Root Path\" required><div ng-messages=\"updateRepForm.rootPath.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Root Path is required</span></div></div></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button>\n<md-button ng-click=\"updateRepository(currentrepository)\">Update</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\">\n{{step.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div>\n</md-button></div></div><div class=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" layout=\"row\" layout-align=\"start center\"><div class=\"step\" \nlayout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">\nOptional</div></div></md-button><div class=\"ms-stepper-step-content\" ng-transclude></div><div \nclass=\"ms-stepper-controls\" layout=\"row\" layout-align=\"start center\" \nng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button class=\"md-accent md-raised\" \nng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");
$templateCache.put("app/main/sites/site/todolist/directives/ms-new-note/ms-new-note.html","<ms-note-form note-type=\"\'new\'\"></ms-note-form>");
$templateCache.put("app/main/sites/site/todolist/directives/ms-note-form/ms-note-form.html","<div><form ng-submit=\"MsNoteForm.submit()\" ng-class=\"MsNoteForm.note.color\"><input type=\"text\" \nclass=\"note-title-input\" placeholder=\"Name\" ng-model=\"MsNoteForm.note.name\" ng-class=\"MsNoteForm.note.color\">\n<md-input-container md-no-float ng-class=\"MsNoteForm.note.color\"><textarea type=\"text\" \nclass=\"note-description-textarea\" placeholder=\"Description\" ng-model=\"MsNoteForm.note.description\">\r\n      </textarea>\n</md-input-container><md-list class=\"checklist\" ng-if=\"MsNoteForm.note.actions.length > 0\"><md-divider></md-divider>\n<md-list-item ng-repeat=\"item in MsNoteForm.note.actions\"><md-checkbox ng-model=\"item.completed\" \naria-label=\"toggle check\"></md-checkbox><p ng-class=\"{\'text-strike md-secondary-text\':item.completed}\">\n{{item.description}}</p><md-icon ng-click=\"MsNoteForm.deleteCheckItem(item)\" class=\"md-secondary\" \nmd-font-icon=\"icon-close-circle\" aria-label=\"remove\"></md-icon><md-divider></md-divider></md-list-item></md-list><div \nclass=\"checklist-form\" ng-if=\"MsNoteForm.note.actions.length > 0 || MsNoteForm.checkListForm\" layout=\"row\" \nlayout-align=\"space-between end\"><md-input-container class=\"\" md-no-float flex><input id=\"new-checklist-item-input\" \ntype=\"text\" placeholder=\"New Action\" ng-model=\"MsNoteForm.newCheckListItem\" \nng-keydown=\"$event.keyCode === 13 ? + MsNoteForm.addChecklistItem():\'\';\"></md-input-container><md-button \nclass=\"md-icon-button\" ng-click=\"MsNoteForm.addChecklistItem()\" aria-label=\"add\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button></div><div class=\"footer\" layout-gt-xs=\"row\" layout-align-gt-xs=\"space-between center\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"actions\" layout=\"row\" layout-align=\"center center\" \nlayout-wrap><md-button class=\"md-icon-button\" aria-label=\"checklist\" ng-click=\"MsNoteForm.checklistFormToggle()\">\n<md-icon md-font-icon=\"icon-checkbox-multiple-marked\" class=\"s20\"></md-icon></md-button></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button ng-if=\"MsNoteForm.type ===\'edit\'\" ng-click=\"MsNoteForm.deleteNote()\" \nclass=\"md-icon-button\" aria-label=\"delete note\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button><md-button \nng-if=\"MsNoteForm.type ===\'edit\'\" type=\"submit\" ng-disabled=\"MsNoteForm.isNotValid()\">Save</md-button><md-button \nng-if=\"MsNoteForm.type ===\'new\'\" type=\"submit\" ng-enabled=\"MsNoteForm.isNotValid()\">Add</md-button></div></div></form>\n</div>");
$templateCache.put("app/main/sites/site/todolist/directives/ms-note-item/ms-note-item.html","<md-card ng-class=\" siteTodoCtrl.getAnotherColor($index)\"><md-card-content><md-card-title ng-if=\"MsNoteItem.note.name\">\n<md-card-title-text>{{MsNoteItem.note.name}}</md-card-title-text></md-card-title><md-description \nng-if=\"MsNoteItem.note.description\"><span>{{MsNoteItem.note.description}}</span></md-description><div \nng-if=\"MsNoteItem.note.actions.length > 0\" class=\"checklist\"><div class=\"checklist-item\" \nng-repeat=\"checkItem in  MsNoteItem.note.actions\" layout=\"row\" layout-align=\"start center\"><md-checkbox \nng-model=\"checkItem.completed\" ng-click=\"$event.preventDefault();$event.stopPropagation()\" \naria-label=\"{{checkItem.description}}\"></md-checkbox><span class=\"text-truncate\" \nng-class=\"{\'text-strike md-secondary-text\':checkItem.completed}\" flex>{{checkItem.description}}</span></div></div>\n</md-card-content></md-card>");}]);